// ==== SHARED: mcp-server/shared/table-rules.mjs ====
var TableRules = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // mcp-server/shared/table-rules.mjs
  var table_rules_exports = {};
  __export(table_rules_exports, {
    GROUP_BLANK_LABEL: () => GROUP_BLANK_LABEL,
    IMPORT_MAX_BYTES: () => IMPORT_MAX_BYTES,
    IMPORT_MAX_ROWS: () => IMPORT_MAX_ROWS,
    NEW_TAB_COLS: () => NEW_TAB_COLS,
    RESERVED_VIEW_KEYS: () => RESERVED_VIEW_KEYS,
    addTable: () => addTable,
    applyImport: () => applyImport,
    cloneDoc: () => cloneDoc,
    defaultTableCols: () => defaultTableCols,
    deleteTable: () => deleteTable,
    effectiveCell: () => effectiveCell,
    effectiveTopic: () => effectiveTopic,
    ensureUnionColumn: () => ensureUnionColumn,
    gcUnionColumn: () => gcUnionColumn,
    groupByChain: () => groupByChain,
    groupByIndices: () => groupByIndices,
    groupPathOf: () => groupPathOf,
    groupRows: () => groupRows,
    groupTotals: () => groupTotals,
    groupableColumns: () => groupableColumns,
    impliedTableCols: () => impliedTableCols,
    importColumnNames: () => importColumnNames,
    importMessages: () => importMessages,
    importProbe: () => importProbe,
    importTooLarge: () => importTooLarge,
    insertUnionColumnAt: () => insertUnionColumnAt,
    materializeTableCols: () => materializeTableCols,
    notesKey: () => notesKey,
    orderAppend: () => orderAppend,
    orderRemove: () => orderRemove,
    orderRename: () => orderRename,
    orderedKeys: () => orderedKeys,
    removeUnionColumnAt: () => removeUnionColumnAt,
    renameGroupByColumn: () => renameGroupByColumn,
    renameTable: () => renameTable,
    rowsOfTable: () => rowsOfTable,
    seedTableCols: () => seedTableCols,
    setGroupByChain: () => setGroupByChain,
    shapeImportGrid: () => shapeImportGrid,
    shiftColumnLabels: () => shiftColumnLabels,
    tableAddColumn: () => tableAddColumn,
    tableColsOf: () => tableColsOf,
    tableDropSet: () => tableDropSet,
    tableKey: () => tableKey,
    tableNames: () => tableNames,
    tableRemoveColumn: () => tableRemoveColumn,
    tableRenameSet: () => tableRenameSet,
    topicColumnIndex: () => topicColumnIndex,
    ungroupedToGrouped: () => ungroupedToGrouped,
    uniqueColumnName: () => uniqueColumnName,
    uniqueTableName: () => uniqueTableName,
    validTableName: () => validTableName
  });

  // mcp-server/shared/table-rules/topic.mjs
  var NEW_TAB_COLS = Object.freeze(["#", "Topic", "Parent Task", "Task", "Sub Task", "Resources", "Status", "Notes", "Date"]);
  var RESERVED_VIEW_KEYS = Object.freeze(["All", "Roadmap"]);
  function topicColumnIndex(doc) {
    if (doc.flat) return -1;
    if (doc.epicCol) {
      const idx = doc.columns.findIndex((c) => (c || "").trim().toLowerCase() === doc.epicCol.toLowerCase());
      if (idx >= 0) return idx;
    }
    return doc.columns.length > 1 ? 1 : -1;
  }
  function effectiveTopic(rows, idx, topicCi) {
    for (let i = idx; i >= 0; i--) {
      const v = (rows[i][topicCi] || "").trim();
      if (v) return v;
    }
    return "";
  }
  function tableNames(doc) {
    const ci = topicColumnIndex(doc);
    if (ci < 0) return [];
    const seen = /* @__PURE__ */ new Set(), out = [];
    doc.rows.forEach((r) => {
      const v = (r[ci] || "").trim();
      if (v && !seen.has(v)) {
        seen.add(v);
        out.push(v);
      }
    });
    return out;
  }
  function rowsOfTable(doc, table) {
    const ci = topicColumnIndex(doc);
    if (ci < 0) return [];
    return doc.rows.map((_, i) => i).filter((i) => effectiveTopic(doc.rows, i, ci) === table);
  }
  function uniqueTableName(doc, base) {
    const taken = new Set(tableNames(doc).concat(RESERVED_VIEW_KEYS));
    base = String(base).trim();
    let name = base, n = 1;
    while (taken.has(name)) {
      n++;
      name = base + " " + n;
    }
    return name;
  }
  function ungroupedToGrouped(doc, topicName, columnName) {
    doc.columns.splice(1, 0, columnName || NEW_TAB_COLS[1]);
    doc.rows.forEach((r) => r.splice(1, 0, topicName));
    if (doc.defaultCols) doc.defaultCols = doc.columns.slice();
    delete doc.flat;
  }
  function cloneDoc(doc) {
    const j = (v) => v ? JSON.parse(JSON.stringify(v)) : v;
    return { ...doc, columns: doc.columns.slice(), rows: doc.rows.map((r) => r.slice()), tableCols: j(doc.tableCols), groupBy: j(doc.groupBy), columnLabels: j(doc.columnLabels) };
  }

  // mcp-server/shared/table-rules/columns.mjs
  function tableColsOf(doc, table) {
    const stored = doc.tableCols && doc.tableCols[table];
    if (Array.isArray(stored)) return stored.filter((n) => doc.columns.includes(n));
    return impliedTableCols(doc);
  }
  function impliedTableCols(doc) {
    const topicCi = topicColumnIndex(doc);
    return doc.columns.filter((c, i) => i > 0 && i !== topicCi);
  }
  function hasOwnCols(doc, table) {
    return !!(doc.tableCols && Array.isArray(doc.tableCols[table]));
  }
  function materializeTableCols(doc) {
    doc.tableCols = doc.tableCols || {};
    const implied = impliedTableCols(doc);
    for (const t of tableNames(doc)) if (!hasOwnCols(doc, t)) doc.tableCols[t] = implied.slice();
  }
  function uniqueColumnName(doc, base) {
    let name = base, n = 1;
    while (doc.columns.includes(name)) {
      n++;
      name = base + " " + n;
    }
    return name;
  }
  function ensureUnionColumn(doc, name) {
    let ci = doc.columns.indexOf(name);
    if (ci >= 0) return ci;
    materializeTableCols(doc);
    ci = doc.columns.length;
    doc.columns.push(name);
    doc.rows.forEach((r) => r.push(""));
    return ci;
  }
  function tableAddColumn(doc, table, name, pos) {
    materializeTableCols(doc);
    ensureUnionColumn(doc, name);
    const set = doc.tableCols[table] = tableColsOf(doc, table);
    if (set.includes(name)) return;
    set.splice(pos == null ? set.length : Math.max(0, Math.min(set.length, pos)), 0, name);
  }
  function tableRemoveColumn(doc, table, name) {
    materializeTableCols(doc);
    const ci = doc.columns.indexOf(name);
    const topicCi = topicColumnIndex(doc);
    if (ci <= 0 || ci === topicCi) return { ci: -1, labelsTouched: false };
    doc.rows.forEach((r, ri) => {
      if (effectiveTopic(doc.rows, ri, topicCi) === table) r[ci] = "";
    });
    doc.tableCols[table] = tableColsOf(doc, table).filter((n) => n !== name);
    return gcUnionColumn(doc, name);
  }
  function gcUnionColumn(doc, name) {
    const used = tableNames(doc).some((t) => tableColsOf(doc, t).includes(name));
    if (used) return { ci: -1, labelsTouched: false };
    const ci = doc.columns.indexOf(name);
    if (ci <= 0 || ci === topicColumnIndex(doc)) return { ci: -1, labelsTouched: false };
    return { ci, labelsTouched: removeUnionColumnAt(doc, ci) };
  }
  function insertUnionColumnAt(doc, ci, name) {
    doc.columns.splice(ci, 0, name);
    doc.rows.forEach((r) => r.splice(ci, 0, ""));
    return shiftColumnLabels(doc, ci, 1);
  }
  function removeUnionColumnAt(doc, ci) {
    doc.columns.splice(ci, 1);
    doc.rows.forEach((r) => r.splice(ci, 1));
    return shiftColumnLabels(doc, ci, -1);
  }
  function shiftColumnLabels(doc, atCi, delta) {
    if (!doc.columnLabels) return false;
    let touched = false;
    for (const table of Object.keys(doc.columnLabels)) {
      const m = doc.columnLabels[table];
      const next = {};
      for (const k of Object.keys(m)) {
        const idx = +k;
        if (delta < 0 && idx === atCi) {
          touched = true;
          continue;
        }
        const ni = idx >= atCi ? idx + delta : idx;
        if (ni !== idx) touched = true;
        next[ni] = m[k];
      }
      doc.columnLabels[table] = next;
    }
    return touched;
  }
  function seedTableCols(doc, table, names) {
    materializeTableCols(doc);
    names.forEach((n) => ensureUnionColumn(doc, n));
    doc.tableCols[table] = names.slice();
  }
  function defaultTableCols(newTabCols) {
    return newTabCols.filter((c, i) => i > 0 && i !== 1);
  }
  function tableRenameSet(doc, oldName, newName) {
    if (!hasOwnCols(doc, oldName)) return;
    doc.tableCols[newName] = doc.tableCols[oldName];
    delete doc.tableCols[oldName];
  }
  function tableDropSet(doc, table) {
    const own = tableColsOf(doc, table);
    if (doc.tableCols) delete doc.tableCols[table];
    const removed = [];
    let labelsTouched = false;
    own.forEach((n) => {
      const r = gcUnionColumn(doc, n);
      if (r.ci >= 0) removed.push(r.ci);
      labelsTouched = labelsTouched || r.labelsTouched;
    });
    return { removed, labelsTouched };
  }

  // mcp-server/shared/table-rules/group-by.mjs
  var GROUP_BLANK_LABEL = "(blank)";
  function groupableColumns(doc, viewKey) {
    if (viewKey == null || RESERVED_VIEW_KEYS.includes(viewKey)) return doc.columns.filter((c, i) => i > 0 && (c || "").trim());
    return tableColsOf(doc, viewKey).filter((c) => (c || "").trim());
  }
  function groupByChain(doc, viewKey) {
    const stored = doc.groupBy && doc.groupBy[viewKey];
    if (!Array.isArray(stored)) return [];
    const can = groupableColumns(doc, viewKey);
    return stored.filter((n) => can.includes(n));
  }
  function groupByIndices(doc, viewKey) {
    return groupByChain(doc, viewKey).map((n) => doc.columns.indexOf(n)).filter((i) => i > 0);
  }
  function setGroupByChain(doc, viewKey, chain) {
    if (!Array.isArray(chain)) throw new Error("group by: the chain must be an array of column names");
    const can = groupableColumns(doc, viewKey);
    const out = [];
    for (const n of chain) {
      if (typeof n !== "string" || !n.trim()) throw new Error("group by: a level must be a column name");
      if (!can.includes(n)) throw new Error('group by: "' + viewKey + '" has no column named "' + n + '" (its columns: ' + can.join(", ") + ")");
      if (out.includes(n)) throw new Error('group by: "' + n + '" is listed twice');
      out.push(n);
    }
    doc.groupBy = doc.groupBy || {};
    doc.groupBy[viewKey] = out;
    return out.slice();
  }
  function renameGroupByColumn(doc, oldName, newName) {
    if (!doc.groupBy || oldName === newName) return false;
    let changed = false;
    for (const k of Object.keys(doc.groupBy)) {
      const chain = doc.groupBy[k];
      if (!Array.isArray(chain)) continue;
      const i = chain.indexOf(oldName);
      if (i >= 0) {
        chain[i] = newName;
        changed = true;
      }
    }
    return changed;
  }
  function effectiveCell(rows, idx, ci, topicCi) {
    if (ci === topicCi) return effectiveTopic(rows, idx, topicCi);
    const topicHere = topicCi >= 0 ? effectiveTopic(rows, idx, topicCi) : null;
    for (let i = idx; i >= 0; i--) {
      if (topicCi >= 0 && effectiveTopic(rows, i, topicCi) !== topicHere) break;
      const v = (rows[i][ci] || "").trim();
      if (v) return v;
    }
    return "";
  }
  function groupPathOf(doc, ri, idxs, topicCi) {
    return idxs.map((ci) => effectiveCell(doc.rows, ri, ci, topicCi) || GROUP_BLANK_LABEL);
  }
  function groupRows(doc, shown, idxs, topicCi) {
    const root = { key: "", path: [], rows: shown.slice(), children: [] };
    if (!idxs.length) return root;
    for (const x of shown) {
      const path = groupPathOf(doc, x.ri, idxs, topicCi);
      let node = root;
      for (let d = 0; d < path.length; d++) {
        let child = node.children.find((c) => c.key === path[d]);
        if (!child) {
          child = { key: path[d], path: path.slice(0, d + 1), rows: [], children: [] };
          node.children.push(child);
        }
        child.rows.push(x);
        node = child;
      }
    }
    return root;
  }
  function groupTotals(doc, rows, hiddenCols) {
    const out = [];
    const topicCi = topicColumnIndex(doc);
    doc.columns.forEach((name, ci) => {
      if (ci === 0 || ci === topicCi || hiddenCols && hiddenCols.has(ci)) return;
      let sum = 0, n = 0, ok = true;
      for (const { row } of rows) {
        const raw = String(row[ci] == null ? "" : row[ci]).trim();
        if (!raw) continue;
        const v = Number(raw.replace(/[,\s]/g, ""));
        if (!isFinite(v)) {
          ok = false;
          break;
        }
        sum += v;
        n++;
      }
      if (ok && n) out.push({ name, sum });
    });
    return out;
  }

  // mcp-server/shared/table-rules/import.mjs
  var IMPORT_MAX_ROWS = 1e3;
  var IMPORT_MAX_BYTES = 900 * 1024;
  function shapeImportGrid(grid) {
    const blank = (r) => !r || r.every((c) => String(c).trim() === "");
    let start = 0;
    while (start < grid.length && blank(grid[start])) start++;
    if (start >= grid.length) return { headers: [], rows: [], total: 0 };
    const body = grid.slice(start + 1).filter((r) => !blank(r));
    const lastCol = (r) => {
      let n = r.length;
      while (n > 0 && String(r[n - 1]).trim() === "") n--;
      return n;
    };
    let width = lastCol(grid[start]);
    for (const r of body) {
      const n = lastCol(r);
      if (n > width) width = n;
    }
    const fit = (r) => {
      const out = r.slice(0, width).map((v) => String(v));
      while (out.length < width) out.push("");
      return out;
    };
    return { headers: fit(grid[start]), rows: body.slice(0, IMPORT_MAX_ROWS).map(fit), total: body.length };
  }
  function importColumnNames(headers, reserved) {
    const taken = new Set(reserved || []);
    const unique = (base) => {
      let name = base, n = 1;
      while (taken.has(name)) {
        n++;
        name = base + " " + n;
      }
      taken.add(name);
      return name;
    };
    const out = new Array(headers.length);
    headers.forEach((h, i) => {
      if ((h || "").trim()) out[i] = unique(h);
    });
    headers.forEach((h, i) => {
      if (out[i] == null) out[i] = unique("Column " + (i + 1));
    });
    return out;
  }
  function applyImport(doc, name, headers, rows, topicColumnName) {
    if (doc.flat || topicColumnIndex(doc) < 0) {
      if (!doc.title) throw new Error("import: a flat domain needs a title - its own rows are filed under it");
      ungroupedToGrouped(doc, doc.title, topicColumnName);
    }
    const topicCi = topicColumnIndex(doc);
    const names = importColumnNames(headers, [doc.columns[0], doc.columns[topicCi]]);
    seedTableCols(doc, name, names);
    const idx = names.map((h) => doc.columns.indexOf(h));
    const fresh = rows.map((r) => {
      const out = doc.columns.map(() => "");
      out[topicCi] = name;
      r.forEach((v, i) => {
        out[idx[i]] = v;
      });
      return out;
    });
    doc.rows.push(...fresh);
    return fresh.length;
  }
  function importProbe(doc, name, headers, rows, topicColumnName) {
    const probe = cloneDoc(doc);
    applyImport(probe, name, headers, rows, topicColumnName);
    return probe;
  }
  function importTooLarge(bytes) {
    return bytes > IMPORT_MAX_BYTES;
  }
  var importMessages = {
    noHeader: (file) => ({ text: file + " has no header row" }),
    tooLarge: (file, bytes, domainNoun) => ({
      text: file + " is too large for this " + domainNoun,
      sub: Math.round(bytes / 1024) + " KB of text with it; a " + domainNoun + " holds " + Math.round(IMPORT_MAX_BYTES / 1024) + " KB"
    }),
    cut: (name, kept, total) => ({
      text: "Imported " + kept.toLocaleString() + " of " + total.toLocaleString() + ' rows into "' + name + '"',
      sub: "A table holds " + IMPORT_MAX_ROWS.toLocaleString() + " rows - the other " + (total - kept).toLocaleString() + " were left out"
    }),
    ok: (name, rowCount, colCount) => ({
      text: 'Imported "' + name + '"',
      sub: rowCount.toLocaleString() + " row" + (rowCount === 1 ? "" : "s") + ", " + colCount + " column" + (colCount === 1 ? "" : "s")
    })
  };

  // mcp-server/shared/table-rules/tables.mjs
  function validTableName(doc, name, { current, alsoTaken } = {}) {
    const n = String(name == null ? "" : name).trim();
    if (!n) throw new Error("a table needs a name");
    if (RESERVED_VIEW_KEYS.includes(n)) throw new Error('"' + n + '" is reserved and cannot be a table name');
    if (n !== current && tableNames(doc).concat(alsoTaken || []).includes(n)) throw new Error('a table named "' + n + '" already exists');
    return n;
  }
  function addTable(doc, name, { columns, topicColumnName } = {}) {
    const bare = doc.flat || topicColumnIndex(doc) < 0;
    if (bare && !doc.title) throw new Error("add table: a flat domain needs a title - its own rows are filed under it");
    const n = validTableName(doc, name, { alsoTaken: bare ? [doc.title] : [] });
    if (bare) ungroupedToGrouped(doc, doc.title, topicColumnName);
    seedTableCols(doc, n, Array.isArray(columns) && columns.length ? columns.map(String) : defaultTableCols(NEW_TAB_COLS));
    const topicCi = topicColumnIndex(doc);
    const row = doc.columns.map(() => "");
    row[0] = String(doc.rows.length + 1);
    row[topicCi] = n;
    doc.rows.push(row);
    return n;
  }
  function renameTable(doc, oldName, newName) {
    if (!tableNames(doc).includes(oldName)) throw new Error('no table named "' + oldName + '" (have: ' + tableNames(doc).join(", ") + ")");
    const n = validTableName(doc, newName, { current: oldName });
    if (n === oldName) return { name: n, labelsTouched: false };
    const topicCi = topicColumnIndex(doc);
    doc.rows.forEach((r) => {
      if ((r[topicCi] || "").trim() === oldName) r[topicCi] = n;
    });
    tableRenameSet(doc, oldName, n);
    if (doc.groupBy && Array.isArray(doc.groupBy[oldName])) {
      doc.groupBy[n] = doc.groupBy[oldName];
      delete doc.groupBy[oldName];
    }
    let labelsTouched = false;
    if (doc.columnLabels && doc.columnLabels[oldName]) {
      doc.columnLabels[n] = doc.columnLabels[oldName];
      delete doc.columnLabels[oldName];
      labelsTouched = true;
    }
    return { name: n, labelsTouched };
  }
  function deleteTable(doc, name) {
    if (!tableNames(doc).includes(name)) throw new Error('no table named "' + name + '" (have: ' + tableNames(doc).join(", ") + ")");
    const topicCi = topicColumnIndex(doc);
    const before = doc.rows;
    doc.rows = before.filter((_, i) => effectiveTopic(before, i, topicCi) !== name);
    const dropped = tableDropSet(doc, name);
    if (doc.groupBy) delete doc.groupBy[name];
    let labelsTouched = dropped.labelsTouched;
    if (doc.columnLabels && doc.columnLabels[name]) {
      delete doc.columnLabels[name];
      labelsTouched = true;
    }
    return { rowsRemoved: before.length - doc.rows.length, columnsRemoved: dropped.removed.length, labelsTouched };
  }

  // mcp-server/shared/table-rules/order.mjs
  var tableKey = (name) => name;
  var notesKey = (id) => "id:" + id;
  function orderedKeys(order, present) {
    const idx = new Map((order || []).map((k, i) => [k, i]));
    return present.slice().sort((a, b) => {
      const ai = idx.has(a) ? idx.get(a) : Infinity, bi = idx.has(b) ? idx.get(b) : Infinity;
      if (ai !== bi) return ai - bi;
      return present.indexOf(a) - present.indexOf(b);
    });
  }
  function orderAppend(order, present, key) {
    if ((order || []).includes(key)) return (order || []).slice();
    return orderedKeys(order, present.filter((k) => k !== key)).concat([key]);
  }
  function orderRename(order, oldKey, newKey) {
    return (order || []).map((k) => k === oldKey ? newKey : k);
  }
  function orderRemove(order, key) {
    return (order || []).filter((k) => k !== key);
  }
  return __toCommonJS(table_rules_exports);
})();

;
// ==== SHARED: mcp-server/shared/profile-schema.mjs ====
var ProfileSchema = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // mcp-server/shared/profile-schema.mjs
  var profile_schema_exports = {};
  __export(profile_schema_exports, {
    CLASS_YEARS: () => CLASS_YEARS,
    CONSENT_BOXES: () => CONSENT_BOXES,
    CONSENT_KEYS: () => CONSENT_KEYS,
    CONSENT_NOTE: () => CONSENT_NOTE,
    PROFILE_FIELD_KEYS: () => PROFILE_FIELD_KEYS,
    PROFILE_TYPES: () => PROFILE_TYPES,
    PROGRAMS: () => PROGRAMS,
    fieldsFor: () => fieldsFor,
    isProfileType: () => isProfileType,
    normalizeConsent: () => normalizeConsent,
    normalizeList: () => normalizeList,
    normalizeWhatsapp: () => normalizeWhatsapp,
    profileComplete: () => profileComplete,
    validateProfile: () => validateProfile
  });

  // mcp-server/shared/edu-lists.mjs
  var CLASS_YEARS = Object.freeze([
    "General",
    "Nursery",
    "LKG",
    "UKG",
    "Class 1",
    "Class 2",
    "Class 3",
    "Class 4",
    "Class 5",
    "Class 6",
    "Class 7",
    "Class 8",
    "Class 9",
    "Class 10",
    "Class 11",
    "Class 12",
    "Class 11 (Science)",
    "Class 11 (Commerce)",
    "Class 11 (Arts)",
    "Class 12 (Science)",
    "Class 12 (Commerce)",
    "Class 12 (Arts)",
    "Year 1",
    "Year 2",
    "Year 3",
    "Year 4",
    "Year 5"
  ]);
  var PROGRAMS = Object.freeze(["General", "School", "Diploma", "ITI", "BTech", "BE", "BSc", "BCom", "BA", "BBA", "BCA", "MBA", "MTech", "MSc", "MCom", "MA", "PhD"]);

  // mcp-server/shared/profile-schema.mjs
  var PROFILE_TYPES = Object.freeze([
    { key: "general", label: "General user" },
    { key: "teacher", label: "Teacher" },
    { key: "student", label: "Student" }
  ]);
  var isProfileType = (v) => PROFILE_TYPES.some((t) => t.key === v);
  var CONSENT_KEYS = Object.freeze([
    { key: "feedback", label: "Contact me for feedback" },
    { key: "updates", label: "Send me product updates" },
    { key: "offers", label: "Contact me for offers and discounts" }
  ]);
  var CONSENT_BOXES = Object.freeze([
    { keys: ["feedback"], label: "Contact me for feedback" },
    { keys: ["updates", "offers"], label: "Send me product updates, offers and discounts" }
  ]);
  var CONSENT_NOTE = "Let us contact you for feedback and we will surprise you with special features and discounts.";
  var NAME = { key: "displayName", label: "Name", kind: "text", required: true, max: 80 };
  var WHATSAPP = { key: "whatsapp", label: "WhatsApp number", kind: "tel", required: true, hint: "With country code, e.g. +91 98765 43210" };
  var PROGRAM = { key: "program", label: "Education program", kind: "multipick", required: true, options: PROGRAMS, max: 60 };
  var FIELDS_BY_TYPE = Object.freeze({
    // Teacher order (Rishabh 2026-10-01): Institution, Education program, Classes taught, Subjects - the last three all several values.
    teacher: [NAME, { key: "institution", label: "Institution", kind: "text", required: true, max: 120 }, PROGRAM, { key: "classes", label: "Classes taught", kind: "multipick", required: true, options: CLASS_YEARS, max: 40 }, { key: "subjects", label: "Subjects", kind: "multipick", required: true, options: [], max: 60 }, WHATSAPP],
    student: [NAME, { key: "institution", label: "Institution", kind: "text", required: true, max: 120 }, PROGRAM, { key: "classes", label: "Class / Year", kind: "pick", required: true, options: CLASS_YEARS, max: 40 }, WHATSAPP],
    general: [NAME, { key: "institution", label: "Organisation", kind: "text", required: true, max: 120 }, WHATSAPP]
  });
  function fieldsFor(type) {
    return FIELDS_BY_TYPE[type] || [];
  }
  var PROFILE_FIELD_KEYS = Object.freeze(["displayName", "institution", "classes", "program", "subjects", "whatsapp"]);
  function normalizeWhatsapp(raw) {
    let s = String(raw == null ? "" : raw).trim();
    if (!s) return null;
    s = s.replace(/^00/, "+").replace(/[\s().-]/g, "");
    if (/^\d{10}$/.test(s)) s = "+91" + s;
    if (!/^\+\d{8,15}$/.test(s)) return null;
    return s;
  }
  function normalizeConsent(c) {
    const out = {};
    for (const { key } of CONSENT_KEYS) out[key] = !!(c && c[key] === true);
    return out;
  }
  function normalizeList(v) {
    const arr = Array.isArray(v) ? v : String(v == null ? "" : v).split(",");
    return [...new Set(arr.map((x) => String(x == null ? "" : x).trim()).filter(Boolean))];
  }
  function validateProfile(body) {
    const b = body || {};
    const errors = {};
    const role = String(b.role || "");
    if (!isProfileType(role)) errors.role = "Choose a profile.";
    const value = { role, consent: normalizeConsent(b.consent) };
    for (const f of fieldsFor(role)) {
      if (f.key === "whatsapp") {
        const raw2 = String(b.whatsapp == null ? "" : b.whatsapp).trim();
        const w = normalizeWhatsapp(raw2);
        if (!w) errors.whatsapp = raw2 ? "Enter the WhatsApp number with its country code." : "WhatsApp number is required.";
        else value.whatsapp = w;
        continue;
      }
      if (f.kind === "multipick" || f.kind === "pick") {
        const list = normalizeList(b[f.key]);
        if (f.kind === "pick" && list.length > 1) {
          errors[f.key] = "Choose one " + f.label + ".";
          continue;
        }
        if (f.required && !list.length) {
          errors[f.key] = f.label + " is required.";
          continue;
        }
        const long = list.find((x) => x.length > f.max);
        if (long) {
          errors[f.key] = f.label + ': "' + long.slice(0, 20) + '\u2026" is too long (max ' + f.max + " characters).";
          continue;
        }
        value[f.key] = list;
        continue;
      }
      const raw = String(b[f.key] == null ? "" : b[f.key]).trim();
      if (f.required && !raw) {
        errors[f.key] = f.label + " is required.";
        continue;
      }
      if (raw.length > f.max) {
        errors[f.key] = f.label + " is too long (max " + f.max + " characters).";
        continue;
      }
      value[f.key] = raw || null;
    }
    for (const k of PROFILE_FIELD_KEYS) if (!(k in value)) value[k] = null;
    const ok = Object.keys(errors).length === 0;
    return ok ? { ok, errors, value } : { ok, errors };
  }
  function profileComplete(profile) {
    return validateProfile(profile).ok;
  }
  return __toCommonJS(profile_schema_exports);
})();

;
// ==== SHARED: mcp-server/shared/default-chapter.mjs ====
var DefaultChapter = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // mcp-server/shared/default-chapter.mjs
  var default_chapter_exports = {};
  __export(default_chapter_exports, {
    CHAPTER_LAYOUT: () => CHAPTER_LAYOUT,
    chapterName: () => chapterName,
    defaultChapter: () => defaultChapter,
    defaultNotesMeta: () => defaultNotesMeta,
    mintChapterIds: () => mintChapterIds,
    notesBoxName: () => notesBoxName,
    notesMetaName: () => notesMetaName,
    notesNounOf: () => notesNounOf,
    notesPrefixOfFile: () => notesPrefixOfFile,
    rand36: () => rand36
  });
  var CHAPTER_LAYOUT = "stack";
  function notesNounOf(modeOrKind) {
    if (modeOrKind === "tracker" || modeOrKind === "document") return "Notes";
    if (modeOrKind === "book") return "Chapter";
    return null;
  }
  function chapterName(notesNoun, takenNames = []) {
    const taken = new Set(takenNames);
    const base = "New " + notesNoun;
    let name = base, n = 1;
    while (taken.has(name)) {
      n++;
      name = base + " " + n;
    }
    return name;
  }
  var rand36 = (n) => Math.random().toString(36).slice(2, 2 + n);
  function mintChapterIds(rand = rand36) {
    return { epicId: String(Date.now()) + "_" + rand(4), boxId: "box_" + rand(5) };
  }
  var notesPrefixOfFile = (file) => file ? String(file).replace(/\.csv$/i, "") : null;
  function defaultChapter({ notesNoun, rand }) {
    if (!notesNoun) throw new Error("defaultChapter: no notes noun - the domain's kind must be a document or a book.");
    const { epicId, boxId } = mintChapterIds(rand);
    return { id: epicId, name: chapterName(notesNoun), layout: CHAPTER_LAYOUT, boxes: [{ id: boxId }] };
  }
  var defaultNotesMeta = (chapter) => ({ epics: [chapter] });
  var notesMetaName = (prefix) => `${prefix}__notes_meta.json`;
  var notesBoxName = (prefix, epicId, boxId) => `${prefix}__notes__${epicId}__${boxId}.md`;
  return __toCommonJS(default_chapter_exports);
})();

;
// ==== SHARED: mcp-server/shared/box-title.mjs ====
var BoxTitle = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // mcp-server/shared/box-title.mjs
  var box_title_exports = {};
  __export(box_title_exports, {
    firstH1: () => firstH1
  });
  function firstH1(text) {
    const lines = String(text || "").split("\n");
    let fence = false;
    for (const line of lines) {
      if (line.trim().startsWith("```")) {
        fence = !fence;
        continue;
      }
      if (fence) continue;
      const m = line.match(/^#\s+(.+?)\s*$/);
      if (m) return m[1];
    }
    return "";
  }
  return __toCommonJS(box_title_exports);
})();

;
// ==== FILE: categories.js ====
// ───────────────────────────────────────────────────────────────────────────
// Categories — opt-in 4th-level navigation under Parent Task.
//
// A section "opts in" by declaring a `categories` array in its SECTIONS entry:
//
//   personal: {
//     title: "7. Personal",
//     categories: [
//       { name: "Details", file: "7__Personal__Details.csv" },
//       { name: "Pricing", file: "7__Personal__Pricing.csv", defaultCols: [...] }
//     ]
//   }
//
// Each Category is backed by its own CSV file with its own column structure.
// Sections WITHOUT a `categories` field behave exactly as before — none of
// the code below runs for them. This keeps existing tabs untouched.
//
// Integration points in index.html (small hooks):
//   - loadCSV()    → delegates to loadCategorySection() when categories present
//   - save()       → uses activeCategoryFile() to pick the right file
//   - switchTab()  → calls renderCategoryTabs() after loading
//   - init()       → same
//   - restoreFrom()→ same
// ───────────────────────────────────────────────────────────────────────────

function hasCategories(sec) {
  return Array.isArray(sec && sec.categories) && sec.categories.length > 0;
}

function activeCategoryMeta(sec) {
  if (!hasCategories(sec)) return null;
  return sec.categories.find(c => c.name === sec.activeCategory) || sec.categories[0];
}

function activeCategoryFile(sec) {
  if (!hasCategories(sec)) return sec.file;
  const cat = activeCategoryMeta(sec);
  return cat ? cat.file : sec.file;
}

// Load every category's CSV into sec.dataByCategory, then point sec.columns
// and sec.rows at the active category's data so all existing edit functions
// (addRow, addColumn, onEdit, …) operate on the active category transparently.
async function loadCategorySection(sec) {
  sec.dataByCategory = sec.dataByCategory || {};
  for (const cat of sec.categories) {
    const fallback = cat.defaultCols || sec.defaultCols || DEFAULT_COLS;
    try {
      const res = await fetch('/load?file=' + cat.file);
      if (!res.ok) throw new Error('not found');
      _csvVersions[cat.file] = res.headers.get('X-Note-Version') || null;   // data.js: the token the next save sends back
      const text = await res.text();
      const parsed = parseCSV(text);
      if (parsed.length > 0) {
        sec.dataByCategory[cat.name] = { columns: parsed[0], rows: parsed.slice(1) };
      } else {
        sec.dataByCategory[cat.name] = { columns: [...fallback], rows: [] };
      }
    } catch (e) {
      console.warn(`No CSV for ${cat.file}, starting empty`);
      delete _csvVersions[cat.file];
      sec.dataByCategory[cat.name] = { columns: [...fallback], rows: [] };
    }
  }
  if (!sec.activeCategory || !sec.dataByCategory[sec.activeCategory]) {
    sec.activeCategory = sec.categories[0].name;
  }
  syncSectionToCategory(sec);
}

// Make sec.columns and sec.rows point to the active category's data. Keeps
// object references stable so existing in-place mutations (splice, push, pop)
// from the rest of the app continue to work without changes.
function syncSectionToCategory(sec) {
  if (!hasCategories(sec)) return;
  const data = sec.dataByCategory[sec.activeCategory];
  if (data) {
    sec.columns = data.columns;
    sec.rows = data.rows;
  }
}

function renderCategoryTabs() {
  const wrap = document.getElementById('categoryTabs');
  if (!wrap) return;
  const sec = SECTIONS[activeSection];
  if (!hasCategories(sec)) { wrap.innerHTML = ''; return; }

  const active = sec.activeCategory || sec.categories[0].name;
  let html = '';
  for (const cat of sec.categories) {
    const isActive = active === cat.name;
    const nameAttr = cat.name.replace(/'/g, "\\'");
    html += `<div class="category-tab ${isActive ? 'active' : ''}" role="button" onclick="switchCategory('${esc(nameAttr)}')">${esc(cat.name)}</div>`;
  }
  wrap.innerHTML = html;
}

function switchCategory(name) {
  const sec = SECTIONS[activeSection];
  if (!hasCategories(sec)) return;
  if (sec.activeCategory === name) return;

  sec.activeCategory = name;
  syncSectionToCategory(sec);
  // Recompute formulas for the new category — the formula set may differ
  // (e.g. Details has Stamp Duty = 7% of Price; Pricing has none).
  if (typeof computeAllFormulas === 'function') {
    if (computeAllFormulas(sec)) save();
  }

  // Preserve Epic / Parent Task selection across category switches. The new
  // category may not have any rows for those values yet — that's fine. The
  // table will be empty, but the user's context is kept, and "+ Add Row"
  // will pre-fill the new row with the active Epic + Parent Task so it
  // appears in this category immediately.
  //
  // Only reset to "All" if the new category's structure doesn't even *have*
  // the relevant column (then the filter is meaningless here).
  if (epicColumnIndex(sec) < 0) sec.activeSubtab = 'All';
  if (parentTaskColumnIndex(sec) < 0) sec.activeParentTask = 'All';
  selectedRows.clear();
  // Categories can have different column layouts — the index-keyed grid view
  // from the previous category would misapply, so drop it.
  if (typeof _clearGridView === 'function') _clearGridView();

  renderCategoryTabs();
  renderSubtabs();
  renderGroupOutline();
  renderTable();
}

;
// ==== FILE: js/labels.js ====
// ── Label / vocabulary table ────────────────────────────────────────────────
// SINGLE SOURCE OF TRUTH for every mode-specific, user-facing string.
//
// To reword the app you edit VALUES in this table only — no other code changes.
// Every UI string that differs between modes reads through LBL('key'); adding a
// new mode-specific word = add one key here + swap a literal for LBL('key') at
// its one render site.
//
// Two modes:
//   tracker — the professional Task Tracker (default).
//   book    — a class / book content portal (Subject → Chapter → Section → Content).
//
// Which mode is live is chosen at DEPLOY time by APP_MODE in .env.<env>
// (baked into firebase-config.generated.js, read by cloud-store.js into
// window.__APP_MODE_BUILD), then overridden per-book at runtime (see _ttMode).
//
// Fallback: a missing key, or a missing/unknown mode, falls back to the tracker
// value, so a partial `book` table is always safe and prod never breaks.

const LABELS = {
  tracker: {
    // The app's name: the browser tab on the dashboard, and the tail of the tab while a document / book is open
    // ("<its title> - Interactive Books", applyTabTitle). The <h1> carries the OPEN document's title (books-store
    // _applyBookTitleToHeader) and nothing when no document is open - there is no default document name any more
    // (Rishabh 2026-09-29: the Journal is an ordinary document).
    docTitle:    'Interactive Books',
    // The ONE book-level read-only marker beside the title. MODE-NEUTRAL, so it is defined here
    // only and the `book` pack reaches it through LBL's tracker fallback.
    appReadOnlyBadge: 'Read only',   // Rishabh 2026-09-30: "for read only text is enough, we can remove the lock"
    appReadOnlyTip:   'Read only - nothing in here can be edited',

    // Sub-tab / tab creation (subtabs.js, data.js)
    addTab:      '+ Add Domain',
    addEpic:     '+ Add Table',
    addNotes:    '+ Add Notes',
    notesNoun:   DefaultChapter.notesNounOf('tracker'),   // "Notes": what "+ Add Notes" creates ("New Notes" - Rishabh 2026-10-05: the name follows the button's word) and what a new domain is born with (mcp-server/shared/default-chapter.mjs, the one source of the word)

    // Notes view (notes.js)
    addBox:      '+ Add Box',
    boxNoun:     'Box',            // the ONE word for a notes box in this mode; consumers derive case (.toLowerCase()) + plural themselves - UI-A-2 (Rishabh 2026-09-18)

    // Roadmap (notes.js + notes-roadmap.js)
    roadmap:            'Roadmap',
    roadmapShowTip:     'Show the roadmap above the boxes',
    roadmapHideTip:     'Hide the roadmap',
    roadmapAddedToast:  '✓ Roadmap added',
    roadmapHiddenToast: '✓ Roadmap hidden',

    // Laser pointer (laser.js) - the toolbar button left of Roadmap; mode-neutral, the book pack falls back here
    laser:              'Laser',
    laserTip:           'Laser pointer - point at things while you present. Hold Ctrl (Cmd on Mac) to click what is underneath; Esc turns it off',

    // Roadmap row-axis terms (group-by / scope / column headers, notes-roadmap.js)
    chapter:      'Topic',         // the mid-level grouping (a notes-epic) - Rishabh 2026-09-11: Area -> Topic -> Section for EVERY personal doc (journal, tracker, notes); "initiative" fit only a tracker
    subject:      'Domain',        // the top-level grouping (a tab) - Rishabh 2026-09-11: his own level-1 names read as domains (Real Estate, Health Care, Legal Compliance)
    scopeChapter: 'This topic',
    scopeSubject: 'This domain',
    addChapter:   '+ Topic',
    // CRUD nouns (tab/epic wizards, toasts, dialogs). Rishabh 2026-09-11: the SAME words as the roadmap / share / Readers
    // (Domain -> Topic), so a doc speaks one language inside its editor and outside it. (EV26 Part B had kept "Tab"/"Epic".)
    tabNoun:      'Domain',
    epicNoun:     'Topic',
    spaceNoun:    'journal',   // personal-container noun; the book portal shows "space" (EV: person's "personal space")
  },

  book: {
    // Header
    docTitle:    'Interactive Books',

    // Sub-tab / tab creation
    addTab:      '+ Add Subject',
    addEpic:     '+ Add Table',
    addNotes:    '+ Add Chapter',
    notesNoun:   DefaultChapter.notesNounOf('book'),      // "Chapter": "+ Add Chapter" creates "New Chapter" (was the literal "New Notes" - Rishabh 2026-10-05); the same shared source

    // Notes view
    addBox:      '+ Add Section',
    boxNoun:     'Section',

    // Roadmap (same term in both modes - it is one shared timeline)
    roadmap:            'Roadmap',
    roadmapShowTip:     'Show the roadmap above the sections',
    roadmapHideTip:     'Hide the roadmap',
    roadmapAddedToast:  '✓ Roadmap added',
    roadmapHiddenToast: '✓ Roadmap hidden',

    // Roadmap row-axis terms
    chapter:      'Chapter',
    subject:      'Subject',
    scopeChapter: 'This chapter',
    scopeSubject: 'This subject',
    addChapter:   '+ Chapter',
    tabNoun:      'Subject',
    epicNoun:     'Chapter',
    spaceNoun:    'space',   // personal-container noun in the book portal (the person's "personal space")
  },
};

// Active mode (EV26). A PER-BOOK mode wins whenever a book is OPEN (cloud-store
// sets window.__ttActiveBookMode on book open, clears it on the dashboard);
// otherwise the deploy-baked APP_MODE (from .env.<env> via build-config.mjs). The
// old localhost Tracker/Book dev-toggle was removed - per-book mode makes it
// obsolete (to preview a mode, open a book of that kind). Falls back to 'tracker'.
function _ttMode() {
  const bm = (typeof window !== 'undefined') ? window.__ttActiveBookMode : null;
  if (bm === 'book' || bm === 'tracker') return bm;
  const b = window.__APP_MODE_BUILD;
  return (b === 'book' || b === 'tracker') ? b : 'tracker';
}

// LBL(key, mode): the word for `key` in `mode` (default = the ACTIVE mode), falling back to the
// tracker word, then to the key itself (so a typo shows the key, never "undefined"). The optional
// `mode` lets a caller ask for a SPECIFIC container's vocabulary (e.g. the dashboard share wizard
// naming the terms of the book being shared, not the currently-open one).
function LBL(key, mode) {
  const pack = LABELS[mode || _ttMode()] || LABELS.tracker;
  if (pack[key] != null) return pack[key];
  if (LABELS.tracker[key] != null) return LABELS.tracker[key];
  return key;
}

// "a"/"an" for a word whose first letter varies by mode (e.g. epicNoun "Epic"=vowel
// vs "Chapter"=consonant). A first-letter test is enough for our vocabulary. Returns
// the article + the word: aan(LBL('epicNoun')) -> "an Epic" | "a Chapter".
function aan(w) { return (/^[aeiou]/i.test(String(w)) ? 'an ' : 'a ') + w; }

function _lblEsc(s) {
  return String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}

// The browser TAB follows the open document / book: "<its title> - Interactive Books" while one is open, the plain
// app name on the dashboard (Rishabh 2026-10-28: five tabs open, every one read "Interactive Books"). ONE writer: the
// seam that puts the title in the <h1> (books-store _applyBookTitleToHeader) calls this with the title; the no-document
// states (boot, dashboard) call applyModeLabels, which calls it with nothing.
function applyTabTitle(openTitle) {
  document.title = openTitle ? openTitle + ' - ' + LBL('docTitle') : LBL('docTitle');
}

// Stamp the header chrome once the mode is known. With no document open (dashboard, boot) the <h1> is empty and the
// tab is the plain app name; with one open, both carry its title, set by books-store _applyBookTitleToHeader right
// after this (the tab is left alone here, so it never flashes the plain name between the two). Toolbars call LBL() on
// every render, so they need no explicit re-stamp.
function applyModeLabels() {
  const noDoc = (typeof window === 'undefined' || window.__ttActiveBookMode == null);
  if (noDoc) applyTabTitle('');
  const h1 = document.getElementById('appTitle');
  if (h1 && noDoc) h1.textContent = '';   // no document open (dashboard, boot) -> nothing in the header
  // Anti-flash: keep the header text hidden until the active container's mode is RESOLVED
  // (_initActiveBook / books.setActive / the dashboard set window.__ttModeReady). Otherwise the
  // baked-APP_MODE paint (this fn on DOMContentLoaded) showed for a beat before the per-book
  // re-stamp corrected it -> a visible "book -> tracker" flash on load. Deployed has no per-book
  // re-stamp, so it never flashed; this makes the branch match that clean load.
  const vis = ((typeof window !== 'undefined') && window.__ttModeReady === true) ? '' : 'hidden';
  if (h1) h1.style.visibility = vis;
}

document.addEventListener('DOMContentLoaded', applyModeLabels);

// Classic (non-module) script: expose on window for the module cloud-store and
// for inline onclick handlers.
window.LBL = LBL;
window.aan = aan;
window.applyModeLabels = applyModeLabels;

;
// ==== FILE: js/state.js ====
// Section definitions — CSV filenames map to tabs.
// `defaultCols` is used when the CSV file is missing or empty. Sections without
// their own defaultCols fall back to DEFAULT_COLS (task-style structure).
//
// ── Default starter tab ──
// A brand-new personal doc (a new user's first sign-in) starts with one empty
// "Notes" domain (Rishabh 2026-09-12: Journal › Notes › New Notes). Existing trackers load their own saved tabs from the cloud and
// are unaffected by this template. The table starts empty (header row only);
// an empty notes-Epic is created on first edit.
//
// To add more tabs, copy the `tasks` entry below, give it a new key, title, and
// `file` (e.g. "2__Project.csv"). All features (Epics, Parent Tasks, Notes,
// Mermaid/Excalidraw diagrams, formulas, categories, undo/redo) work on any
// section automatically.
const SECTIONS = {
  tasks: {
    title: "Notes",
    file: "1__Notes.csv",
    columns: [],
    rows: [],
    // The same columns every new domain gets (sections.js NEW_TAB_COLS; Rishabh 2026-09-29). Column 2 "Topic" is
    // the table-name column: it drives the table pills, is auto-filled, and stays hidden inside a table.
    defaultCols: TableRules.NEW_TAB_COLS.slice()
  }
};


const COL_CLASSES = ['c-num','c-theme','c-epic','c-parent','c-task','c-sub','c-owner','c-status','c-notes','c-act'];

const TD_CLASSES  = ['col-num','col-theme','col-epic','col-parent','col-task','col-sub','col-owner','col-status','col-notes',''];

const DEFAULT_COLS = ["#","Theme","Epic","Parent Task","Task / Summary","Sub Task","Resources","Status","Notes"];

const MAX_HISTORY = 50;


let activeSection = 'tasks';

let selectedRows = new Set();
let selectedCols = new Set();   // column indices (table-select.js)


// ── Undo/redo history (per section) ──
// Each mutating action snapshots the section's columns+rows BEFORE the change
// and pushes onto `undo`. Any new mutation clears `redo`.
function snapshotSection(sec) {
  return {
    columns: sec.columns.slice(),
    rows: sec.rows.map(r => r.slice()),
    flat: !!sec.flat,   // a flat table (no grouping column) is part of the shape: Undo after "+ Add Table" must bring it back (J, 2026-09-29)
    // The whole table VIEW moves with the data (J, 2026-09-30: rename a grouped table, undo -> it came back ungrouped):
    // each table's own columns, its Group by chain, its display labels - all keyed by table name, all in the snapshot.
    tableCols: JSON.parse(JSON.stringify(sec.tableCols || {})),
    groupBy: JSON.parse(JSON.stringify(sec.groupBy || {})),
    columnLabels: JSON.parse(JSON.stringify(sec.columnLabels || {}))
  };
}


function pushUndo() {
  const sec = SECTIONS[activeSection];
  if (!sec.undo) sec.undo = [];
  if (!sec.redo) sec.redo = [];
  sec.undo.push(snapshotSection(sec));
  if (sec.undo.length > MAX_HISTORY) sec.undo.shift();
  sec.redo.length = 0;
}


function restoreFrom(snap) {
  const sec = SECTIONS[activeSection];
  sec.columns = snap.columns;
  sec.rows = snap.rows;
  // `flat` is persisted with the tab list, not the CSV, so a change of it re-saves the list (sections.js);
  // otherwise a reload would read the grouped shape back over the restored flat columns.
  const wasFlat = !!sec.flat;
  if (snap.flat) sec.flat = true; else delete sec.flat;
  if (snap.tableCols) {
    sec.tableCols = JSON.parse(JSON.stringify(snap.tableCols));
    sec.groupBy = JSON.parse(JSON.stringify(snap.groupBy || {}));
    if (typeof saveTableViews === 'function') saveTableViews(sec);   // ONE file holds both (table-groupby.js)
  }
  if (snap.columnLabels && JSON.stringify(snap.columnLabels) !== JSON.stringify(sec.columnLabels || {})) {
    sec.columnLabels = JSON.parse(JSON.stringify(snap.columnLabels));
    if (typeof saveColumnLabels === 'function') saveColumnLabels(sec);
  }
  if (sec.defaultCols) sec.defaultCols = sec.columns.slice();
  if (wasFlat !== !!sec.flat && typeof saveSectionsConfig === 'function') saveSectionsConfig();
  // If using categories, keep dataByCategory in sync with the restored data
  if (typeof hasCategories === 'function' && hasCategories(sec)) {
    sec.dataByCategory[sec.activeCategory] = { columns: sec.columns, rows: sec.rows };
  }
  // An undo/redo can change which Epics exist (e.g. undoing Add-Epic removes its
  // seed row). If the active table Epic no longer has any rows, fall back to
  // 'All' — otherwise renderSubtabs re-injects it as a phantom active pill for
  // an Epic that's gone.
  if (!sec.activeNotesEpic && sec.activeSubtab && sec.activeSubtab !== 'All' && sec.activeSubtab !== 'Roadmap'
      && typeof uniqueEpics === 'function' && !uniqueEpics(sec).includes(sec.activeSubtab)) {
    sec.activeSubtab = defaultTableSubtab(sec);
  }
  selectedRows.clear(); selectedCols.clear();
  // The grid sort/filter view is keyed by column INDEX; a restored snapshot may
  // have a different column layout, so drop it rather than misapply to the wrong
  // column.
  if (typeof _clearGridView === 'function') _clearGridView();
  save();
  if (typeof renderCategoryTabs === 'function') renderCategoryTabs();
  renderSubtabs();
  renderGroupOutline();
  renderTable();
}


function undo() {
  const sec = SECTIONS[activeSection];
  if (!sec.undo || !sec.undo.length) return;
  sec.redo.push(snapshotSection(sec));
  restoreFrom(sec.undo.pop());
  showToast('↶ Undone');
}


function redo() {
  const sec = SECTIONS[activeSection];
  if (!sec.redo || !sec.redo.length) return;
  sec.undo.push(snapshotSection(sec));
  restoreFrom(sec.redo.pop());
  showToast('↷ Redone');
}

;
// ==== FILE: js/sections.js ====
// ───────────────────────────────────────────────────────────────────────────
// Section tabs (the top-level "theme" tabs) — user-managed, like Epics.
//
// The hardcoded SECTIONS object in state.js is only the DEFAULT seed. The live
// list of tabs (which sections exist, their order, titles, and CSV files) is
// persisted in a sidecar:
//
//   data/sections.json  →  { "sections": [ { "key", "title", "file", "flat"? }, ... ] }
//   (`flat: true` = a table with no grouping column - an imported file; see table-import.js)
//
// On boot loadSectionsConfig() reconciles SECTIONS to match sections.json:
//   • a key that matches a state.js default keeps its rich config (defaultCols,
//     formulas, categories, parentTaskCol, …) — only title/file are refreshed;
//   • a brand-new key becomes a plain single-CSV section using NEW_TAB_COLS;
//   • a default key absent from sections.json stays deleted (deletes persist).
// First run (no sections.json) seeds the file from the current defaults so the
// existing behaviour is preserved and the list becomes user-editable.
// ───────────────────────────────────────────────────────────────────────────

// Column template for a freshly-created tab — the same lean starter as a new
// tracker (clean, fits without scroll; add more columns via + Add Column).
const NEW_TAB_COLS = TableRules.NEW_TAB_COLS.slice();   // the shared module's list (Rishabh 2026-09-29); "Topic" = the table-name column (column 2, auto-filled, hidden inside a table)

const SECTIONS_CONFIG_FILE = 'sections.json';

// The chapter list is written WHOLE, so the store MERGES it (cloud-store/fetch-shim: a sections.json save
// unions in chapters another writer added and drops the ones another writer deleted - decided by the file
// name, not by a flag). This tab tells the store which keys it ADDED and which it DELETED this session, so
// its own adds are never mistaken for "deleted elsewhere" and its own deletes are never resurrected. The
// merged list comes back and is adopted (_adoptMergedSections), so a chapter an MCP tool or the same
// person's other tab added shows up here on this tab's next save.
let _knownSectionKeys = new Set();          // keys as last loaded from / settled by the store
const _deletedSectionKeys = new Set();      // keys this tab deleted, not yet settled by the store
const _renamedSectionKeys = new Set();      // keys this tab renamed, not yet settled (the store's title stands for the rest)
let _reorderedSections = false;             // this tab reordered, not yet settled (the store's order stands otherwise)

// Snapshot of the state.js defaults (captured once, before any rebuild) so a
// default tab keeps its advanced config across a reconcile.
let _sectionDefaults = null;
function _snapshotSectionDefaults() {
  if (_sectionDefaults) return;
  _sectionDefaults = {};
  for (const k of Object.keys(SECTIONS)) _sectionDefaults[k] = SECTIONS[k];
}

// Rebuild SECTIONS (in place — it's a const) to match the persisted list,
// preserving insertion order so the tab strip renders in the saved order.
function _applySectionsList(list) {
  _snapshotSectionDefaults();
  for (const k of Object.keys(SECTIONS)) delete SECTIONS[k];
  for (const entry of list) {
    if (!entry || !entry.key) continue;
    const key = entry.key;
    if (_sectionDefaults[key]) {
      const s = _sectionDefaults[key];
      if (entry.title) s.title = entry.title;
      if (entry.file) s.file = entry.file;
      s.columns = []; s.rows = []; // reloaded from disk by loadCSV
      SECTIONS[key] = s;
    } else {
      SECTIONS[key] = _plainSection(entry);
    }
  }
}

// A plain single-CSV section from its persisted entry. A FLAT table (an imported file) keeps its flag and
// falls back to the bare "#" gutter when its CSV is missing; every other new tab starts on NEW_TAB_COLS.
function _plainSection(entry) {
  return Object.assign({
    title: entry.title || entry.key,
    file: entry.file,
    columns: [], rows: [],
    defaultCols: entry.flat ? ['#'] : NEW_TAB_COLS.slice()
  }, entry.flat ? { flat: true } : {});
}

async function loadSectionsConfig() {
  _snapshotSectionDefaults();
  let list = null;
  try {
    const res = await fetch('/load?file=' + SECTIONS_CONFIG_FILE);
    if (res.ok) {
      const text = await res.text();
      if (text.trim()) {
        const json = JSON.parse(text);
        if (json && Array.isArray(json.sections) && json.sections.length) list = json.sections;
      }
    }
  } catch (_) { /* missing/invalid → fall back to defaults */ }

  if (list) _applySectionsList(list);
  else if (/^(srread|srview)~/.test(String((typeof window !== 'undefined' && window.__ttActiveBookPrefix) || ''))) {
    // A synthetic RECEIVED READ-ONLY book (as-a-book read, Rishabh 2026-08-11) OR the author's own
    // per-version VIEWER ('srview~') has no stored sections.json; start EMPTY so shared-read.js is its
    // ONLY source of subjects - never seed the defaults, never carry the previous book's tabs across.
    for (const k of Object.keys(SECTIONS)) delete SECTIONS[k];
  }
  else {
    // First run: a brand-new user has no sections.json. Seed from the captured state.js
    // DEFAULTS, never from whatever tabs are still in memory. A same-tab account switch
    // (signInWithPopup does not reload the page) leaves SECTIONS holding the PREVIOUS
    // account's tabs, and saveSectionsConfig() persists Object.keys(SECTIONS) — so seeding
    // from live SECTIONS would write the prior account's tab list into the new user's store.
    // _sectionDefaults was snapshotted at the top of this fn (clean, pre-mutation). P1 fix.
    _applySectionsList(Object.keys(_sectionDefaults).map((k) => ({ key: k, title: _sectionDefaults[k].title, file: _sectionDefaults[k].file })));
    saveSectionsConfig(); // seed sections.json from the defaults
  }

  // Make sure the active tab still exists after a reconcile.
  if (!SECTIONS[activeSection]) {
    const first = Object.keys(SECTIONS)[0];
    if (first) activeSection = first;
  }
  _knownSectionKeys = new Set(Object.keys(SECTIONS).filter(k => !SECTIONS[k]._sharedVirtual));
}

let _sectionsSaving = null;                 // the in-flight subject-list save, so a tab-return re-read waits for its merged response
function saveSectionsConfig() {
  // Never persist VIRTUAL shared subjects (read-access shares resolved live from
  // the sender's snapshot). They exist only in-memory for the current render.
  const sections = Object.keys(SECTIONS).filter(k => !SECTIONS[k]._sharedVirtual).map(k => Object.assign({
    key: k, title: SECTIONS[k].title, file: SECTIONS[k].file
  }, SECTIONS[k].flat ? { flat: true } : {}));
  const addedSectionKeys = sections.map(s => s.key).filter(k => !_knownSectionKeys.has(k));
  const p = fetch('/save', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename: SECTIONS_CONFIG_FILE, csv: JSON.stringify({ sections }, null, 2), addedSectionKeys, deletedSectionKeys: [..._deletedSectionKeys], renamedSectionKeys: [..._renamedSectionKeys], reorderedSections: _reorderedSections })
  }).then(async (res) => {
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res.json().catch(() => null);
  }).then((j) => {
    // Past this point the save HAS LANDED. A throw here is this tab's own adopt failing, never the network, so it
    // gets its own sentence (J: a code error in the adopt used to read as "check your connection" on a save that
    // had succeeded). The store is right either way; a reload shows it.
    if (!(j && Array.isArray(j.sections))) return;
    _deletedSectionKeys.clear(); _renamedSectionKeys.clear(); _reorderedSections = false;   // settled by the store
    try { _adoptMergedSections(j.sections); }
    catch (e) {
      console.error('[sections] adopt after save failed', e);
      if (typeof showToast === 'function') showToast('⚠ Saved, but this tab could not refresh its ' + LBL('tabNoun') + ' list (' + ((e && e.message) || e) + ') - reload to see it');
    }
  }, () => {
    if (typeof showToast === 'function') showToast('⚠ Could not save the ' + LBL('tabNoun') + ' list - check your connection and try again');
  });
  _sectionsSaving = p; p.finally(() => { if (_sectionsSaving === p) _sectionsSaving = null; });
  return p;
}

// COMING BACK TO THE TAB (notes-refresh.js revalidateOnReturn, Rishabh 2026-09-18 "round 34 jaisa: tab pe wapas aate
// hi subject + chapter list bhi re-read"): re-read the subject list and adopt what another writer - an MCP
// add_section, the same person's other tab, a co-author - did to it, through the same _adoptMergedSections a save's
// merged response goes through (add / remove / retitle / reorder + the one toast). Nothing is saved here; the store is
// read as truth. Only for an editable document on screen: a read-only view, a shared read (srread~ / srview~) and
// the dashboard overlay are left alone, and a subject-list save still in flight settles first so its merged
// response is never raced by this read.
async function revalidateSectionsList() {
  if (typeof SECTIONS === 'undefined' || !Object.keys(SECTIONS).length) return { skipped: 'no-document' };
  if (document.body.classList.contains('tt-evlib-open') || document.body.classList.contains('tt-readonly')) return { skipped: 'off-screen' };
  if (/^(srread|srview)~/.test(String((typeof window !== 'undefined' && window.__ttActiveBookPrefix) || ''))) return { skipped: 'shared-read' };
  if (_sectionsSaving) await _sectionsSaving;
  let list = null;
  try {
    const res = await fetch('/load?file=' + SECTIONS_CONFIG_FILE);
    if (!res.ok) return { skipped: 'no-file' };
    const json = JSON.parse((await res.text()) || '{}');
    if (Array.isArray(json.sections) && json.sections.length) list = json.sections.filter(e => e && e.key);
  } catch (_) { return { skipped: 'unreadable' }; }
  if (!list || !list.length) return { skipped: 'no-file' };
  const sig = (l) => l.map(e => e.key + '|' + (e.title || '')).join('\u0000');
  const mine = Object.keys(SECTIONS).filter(k => !SECTIONS[k]._sharedVirtual).map(k => ({ key: k, title: SECTIONS[k].title }));
  if (sig(list) === sig(mine)) return { changed: false };
  _adoptMergedSections(list);
  return { changed: true };
}

// Bring SECTIONS in line with the list the store settled on: a chapter another writer added appears (a
// plain section; a default key gets its rich config back, as _applySectionsList does), a chapter another
// writer deleted goes, a title another writer changed is taken, the order is the merged one. Nothing
// changed = nothing rendered, no toast.
function _adoptMergedSections(list) {
  const keys = list.map(e => e && e.key).filter(Boolean);
  _knownSectionKeys = new Set(keys);
  let changed = false;
  const before = Object.keys(SECTIONS).filter(k => !SECTIONS[k]._sharedVirtual).join('\u0000');
  for (const entry of list) {
    if (!entry || !entry.key) continue;
    if (SECTIONS[entry.key]) { if (entry.title && SECTIONS[entry.key].title !== entry.title) { SECTIONS[entry.key].title = entry.title; changed = true; } continue; }
    _snapshotSectionDefaults();
    const d = _sectionDefaults[entry.key];
    SECTIONS[entry.key] = d
      ? Object.assign(d, { title: entry.title || d.title, file: entry.file || d.file, columns: [], rows: [] })
      : _plainSection(entry);
    changed = true;
  }
  for (const k of Object.keys(SECTIONS)) {
    if (SECTIONS[k]._sharedVirtual || _knownSectionKeys.has(k)) continue;
    delete SECTIONS[k]; changed = true;
  }
  if (!changed && keys.join('\u0000') === before) return;
  reorderSectionsTo(keys);
  if (!SECTIONS[activeSection]) { activeSection = Object.keys(SECTIONS)[0]; switchTab(activeSection); }
  else renderTabs();
  if (typeof showToast === 'function') showToast('The ' + LBL('tabNoun') + ' list changed elsewhere and was updated');
}

// Click router for a tab pill: clicking the ACTIVE tab renames it (mirrors the
// Epic pills); clicking another switches to it.
function onTabClick(key) {
  if (activeSection === key) renameSection(key);
  else switchTab(key);
}

// ── Drag-to-reorder tabs ─────────────────────────────────────────────────────
// Mirrors the notes-box drag pattern. Dragging persists the new order to
// sections.json (saveSectionsConfig writes Object.keys(SECTIONS) order). A plain
// click (no movement) still fires onTabClick, so switch/rename are unaffected.
let draggedTabKey = null;
function onTabDragStart(e, key) {
  // Reordering edits the (possibly-viewed) tracker's sections.json; block it in
  // read-only admin view (the save would be swallowed anyway, leaving the UI out
  // of sync until reload).
  if (document.body && document.body.classList.contains('tt-readonly')) { e.preventDefault(); return; }
  draggedTabKey = key;
  if (e.dataTransfer) {
    e.dataTransfer.effectAllowed = 'move';
    try { e.dataTransfer.setData('text/plain', key); } catch (_) {}
  }
  if (e.currentTarget && e.currentTarget.classList) e.currentTarget.classList.add('is-dragging');
}
function onTabDragOver(e) {
  if (!draggedTabKey) return;
  e.preventDefault();                 // required to allow a drop
  if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
  if (e.currentTarget && e.currentTarget.classList) e.currentTarget.classList.add('drag-over');
}
function onTabDragLeave(e) {
  if (e.currentTarget && e.currentTarget.classList) e.currentTarget.classList.remove('drag-over');
}
function onTabDragEnd() {
  draggedTabKey = null;
  document.querySelectorAll('.tab.drag-over').forEach(el => el.classList.remove('drag-over'));
  document.querySelectorAll('.tab.is-dragging').forEach(el => el.classList.remove('is-dragging'));
}
function onTabDrop(e, targetKey) {
  e.preventDefault();
  if (e.currentTarget && e.currentTarget.classList) e.currentTarget.classList.remove('drag-over');
  const dragged = draggedTabKey;
  draggedTabKey = null;
  if (!dragged || dragged === targetKey) return;
  const keys = Object.keys(SECTIONS);
  const fromIdx = keys.indexOf(dragged);
  const toIdx = keys.indexOf(targetKey);
  if (fromIdx < 0 || toIdx < 0) return;
  // Forward drag (left→right) lands AFTER the target, backward lands BEFORE —
  // the target's index shifts left by one after removing an earlier source, so
  // splicing back in at toIdx gives both behaviours (same as the box reorder).
  const [moved] = keys.splice(fromIdx, 1);
  keys.splice(toIdx, 0, moved);
  reorderSectionsTo(keys);
  _reorderedSections = true;
  saveSectionsConfig();               // persist the new order to sections.json
  renderTabs();
  if (typeof showToast === 'function') showToast('✓ ' + LBL('tabNoun') + 's reordered');
}
// Rebuild SECTIONS (a const) in the given key order, PRESERVING each live
// section object (loaded rows/columns, undo history, categories, notesEpics) —
// only the order changes. Unlike _applySectionsList it does NOT reset data, so
// no reload is needed.
function reorderSectionsTo(newKeys) {
  const saved = {};
  for (const k of Object.keys(SECTIONS)) saved[k] = SECTIONS[k];
  for (const k of Object.keys(SECTIONS)) delete SECTIONS[k];
  for (const k of newKeys) if (saved[k]) SECTIONS[k] = saved[k];
  for (const k of Object.keys(saved)) if (!(k in SECTIONS)) SECTIONS[k] = saved[k]; // safety net
}

// Create a new empty tab: prompt for a name, then the one create path below with the default columns.
async function addSection() {
  const input = await showPromptModal({ title: 'New ' + LBL('tabNoun'), label: 'Name this ' + LBL('tabNoun'), okLabel: 'Create' });
  if (input === null) return; // cancelled
  const title = (input || '').trim() || 'New Tab';
  // Header-only CSV so the new tab loads as an empty table.
  const header = (typeof csvQuote === 'function' ? NEW_TAB_COLS.map(csvQuote) : NEW_TAB_COLS).join(',') + '\n';
  const made = await _createSection({ title, columns: NEW_TAB_COLS.slice(), csv: header });
  // "✓ Added" only when the domain came with its chapter. When the server refused the chapter, the last word on screen
  // stays the warning bornChapter raised (showToast keeps ONE toast - a ✓ here replaced the ⚠ before it could be read:
  // J's row 135 RUN, 2026-10-28), and the domain is still there, bare, with its "+ Add Notes".
  if (made && made.born && typeof showToast === 'function') showToast('✓ Added ' + LBL('tabNoun') + ' "' + title + '"');
}

// The ONE path that makes a new tab exist: a unique key + CSV file derived from the title, the in-memory
// section, the CSV write, the tab-list save, the switch ("+ Add Domain": an empty table on NEW_TAB_COLS).
// Resolves the new key, or null when the store refused the write - the in-memory tab is rolled back and a
// toast says so. (`flat` on a section = a table with no grouping column, an older file import; it is read
// from sections.json by _plainSection and never made here any more.)
async function _createSection({ title, columns, csv }) {
  // Unique in-memory key (alphanumeric, derived from the title).
  const base = title.toLowerCase().replace(/[^a-z0-9]+/g, '') || 'tab';
  let key = base, n = 1;
  while (SECTIONS[key]) { n++; key = base + n; }

  // Unique CSV filename with a numeric prefix (cosmetic ordering, like 1__…).
  const safeName = (title.replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '')) || 'Tab';
  const existingFiles = new Set(Object.keys(SECTIONS).map(k => SECTIONS[k].file).filter(Boolean));
  let prefix = Object.keys(SECTIONS).length + 1;
  let file = prefix + '__' + safeName + '.csv';
  while (existingFiles.has(file)) { prefix++; file = prefix + '__' + safeName + '.csv'; }

  SECTIONS[key] = { title, file, columns: [], rows: [], defaultCols: columns.slice() };
  // The CSV write's two failures are two sentences (SAVE-ERR-1): the fetch REJECTED = nothing reached the server, the
  // only path that may say "server"; the server ANSWERED no = a refusal (a permission, a read-only wallet), named as
  // such - not as a server that is down (J's row 135, 2026-10-28).
  let res = null;
  try {
    res = await fetch('/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: file, csv })
    });
  } catch (_) {
    delete SECTIONS[key];   // roll back the in-memory tab: nothing landed
    if (typeof showToast === 'function') showToast('⚠ Server not running - ' + LBL('tabNoun') + ' not created');
    return null;
  }
  if (!res.ok) {
    delete SECTIONS[key];   // roll back the in-memory tab: the server refused it
    if (typeof showToast === 'function') showToast('⚠ The server did not take the new ' + LBL('tabNoun').toLowerCase() + ' (HTTP ' + res.status + ') - not created');
    return null;
  }
  // BORN WITH CONTENT (the shared rule, mcp-server/shared/default-chapter.mjs; Rishabh 2026-10-27): one chapter, one
  // empty box, so switchTab lands on it (landOnFirstChapter) and a fresh domain never shows an empty state. The domain
  // is listed (saveSectionsConfig) only after its chapter is written, the way add_section / createBook commit both at
  // once. `born` is false when the server refused the chapter: the domain exists, bare, and bornChapter said so.
  const born = await bornChapter(SECTIONS[key]);
  saveSectionsConfig();
  await switchTab(key);
  return { key, born };
}

// The birth itself: the chapter the shared rule names, saved BEFORE it shows - the two writes addNotesEpic makes,
// together. A refused write leaves the domain without it and SAYS so; nothing half-shown. Returns true when it landed.
async function bornChapter(sec) {
  const chapter = DefaultChapter.defaultChapter({ notesNoun: LBL('notesNoun') });
  const epicId = chapter.id, boxId = chapter.boxes[0].id;
  sec.notesEpics = [chapter];
  const [meta, box] = await Promise.all([saveNotesMeta(sec), saveNotesContent(sec, epicId, boxId, '', true)]);
  if (meta && meta.failedFile) {
    sec.notesEpics = [];
    if (!(box && box.failedFile)) deleteNotesContent(sec, epicId, boxId).catch(() => {});
    if (typeof showToast === 'function') showToast('⚠ The ' + LBL('tabNoun').toLowerCase() + ' has no ' + LBL('notesNoun').toLowerCase() + ' yet - the server did not take the first one. Use "' + LBL('addNotes') + '".');
    return false;
  }
  return true;
}

// A domain never shows an empty state. One with NO chapter and NO table - a domain made before the birth rule, or one
// whose last chapter was deleted - is given its born chapter the moment it is OPENED (boot landing + switchTab, data.js),
// once, one save (Rishabh's option 1, 2026-10-28: an old and a new domain behave the same). Not for a shared view-only
// subject, a read-only view (admin view / wallet / a read share), or a domain that cannot hold notes. The strip's
// "+ Add Notes" / "+ Add Table" stay as they are; this only fills the one state nothing should land on.
async function bornChapterIfBare(sec) {
  if (!sec || sec._sharedVirtual || !notesPrefix(sec)) return false;
  if (sectionHasTable(sec) || (sec.notesEpics || []).length) return false;
  if (document.body.classList.contains('tt-readonly') || document.body.classList.contains('tt-view-ro')) return false;
  return bornChapter(sec);
}

// Rename a tab (display title only — the key and CSV file stay the same, so no
// data moves). Clicking the active tab triggers this via onTabClick.
async function renameSection(key) {
  const sec = SECTIONS[key];
  if (!sec) return;
  if (sec._sharedVirtual) return;   // a shared (view-only) subject isn't the recipient's to rename
  if (document.body && document.body.classList.contains('tt-readonly')) return;  // read-only admin view
  const input = await showPromptModal({ title: 'Rename ' + LBL('tabNoun'), value: sec.title, okLabel: 'Rename' });
  if (input === null) return;
  const title = (input || '').trim();
  if (!title || title === sec.title) return;
  sec.title = title;
  _renamedSectionKeys.add(key);
  saveSectionsConfig();
  renderTabs();
  if (sec.flat && typeof renderSubtabs === 'function') renderSubtabs();   // a flat domain's table pill carries the domain's name
  if (typeof showToast === 'function') showToast('✓ Renamed ' + LBL('tabNoun') + ' to "' + title + '"');
}

// Delete a tab and ALL its data files (CSV + every notes/diagram sidecar that
// shares its file prefix). Guarded by a confirm; the last remaining tab can't
// be deleted (the app needs at least one section).
async function deleteSection(key) {
  const sec = SECTIONS[key];
  if (!sec) return;
  if (sec._sharedVirtual) {   // a shared (view-only) subject: ask the sender to revoke, not a local delete
    if (typeof showToast === 'function') showToast('This is a shared ' + LBL('tabNoun') + ' - ask the sender to remove your access.');
    return;
  }
  if (document.body && document.body.classList.contains('tt-readonly')) return;  // read-only admin view
  if (Object.keys(SECTIONS).length <= 1) {
    if (typeof showToast === 'function') showToast('⚠ Can’t delete the last ' + LBL('tabNoun'));
    return;
  }
  if (!(await showConfirmModal({
    title: 'Delete ' + LBL('tabNoun') + '?',
    message: 'The "' + sec.title + '" ' + LBL('tabNoun') + ' and ALL its data (table, notes, diagrams) will be permanently deleted. This cannot be undone.',
    okLabel: 'Delete', danger: true
  }))) return;

  // Every file for a section shares this prefix: <prefix>.csv and <prefix>__*.
  const prefix = sec.file
    ? sec.file.replace(/\.csv$/, '')
    : (sec.categories && sec.categories[0] && sec.categories[0].file
        ? sec.categories[0].file.replace(/__[^_]+\.csv$/, '')
        : null);

  const finish = () => {
    delete SECTIONS[key];
    _deletedSectionKeys.add(key);
    if (activeSection === key) activeSection = Object.keys(SECTIONS)[0];
    saveSectionsConfig();
    switchTab(activeSection);
    if (typeof showToast === 'function') showToast('✓ Deleted ' + LBL('tabNoun') + ' "' + sec.title + '"');
  };

  if (prefix) {
    fetch('/deletePrefix', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prefix })
    }).then(finish).catch(finish);
  } else {
    finish();
  }
}

;
// ==== FILE: js/csv.js ====

// ── CSV Parser ──
// Char-by-char so it correctly handles:
//   - quoted fields with embedded commas
//   - quoted fields with embedded newlines (multi-line cells)
//   - escaped quotes ("")
//   - \n, \r\n AND a lone \r as line endings - all three break a row (see the branch below)
// Does NOT trim fields — preserves leading/trailing spaces as written.
function parseCSV(text) {
  const rows = [];
  let row = [];
  let field = '';
  let inQuotes = false;
  let i = 0;

  while (i < text.length) {
    const ch = text[i];

    if (inQuotes) {
      if (ch === '"' && text[i + 1] === '"') { field += '"'; i += 2; }
      else if (ch === '"') { inQuotes = false; i++; }
      else { field += ch; i++; }
    } else {
      if (ch === '"') { inQuotes = true; i++; }
      else if (ch === ',') { row.push(field); field = ''; i++; }
      else if (ch === '\n' || ch === '\r') {
        row.push(field);
        rows.push(row);
        row = []; field = '';
        // Treat \r\n as a single line ending
        if (ch === '\r' && text[i + 1] === '\n') i += 2;
        else i++;
      } else { field += ch; i++; }
    }
  }

  // Flush trailing field/row (file with no terminating newline)
  if (field !== '' || row.length > 0) {
    row.push(field);
    rows.push(row);
  }

  return rows;
}


// ── CSV Builder ──
// The quote test must name EVERY character parseCSV treats as a delimiter, and `\r` is one of them
// (see the row-break branch above, which breaks on `\n` OR `\r`). It was missing here, so a cell
// holding a LONE `\r` was written raw and read back as two rows - the cell truncated at the `\r` and
// the remainder became a phantom row. `\r\n` was never affected: it contains a `\n`, so the newline
// test already caught it, which is why the gap survived - the common Windows case looked fine.
function csvQuote(v) {
  const s = String(v);
  return (s.includes(',') || s.includes('"') || s.includes('\n') || s.includes('\r')) ? '"' + s.replace(/"/g, '""') + '"' : s;
}


function buildCSV(sec) {
  let csv = sec.columns.map(csvQuote).join(',') + '\n';
  sec.rows.forEach((r, i) => {
    // Always renumber the # column on save so the CSV stays in sync after row deletes.
    const row = r.slice();
    row[0] = String(i + 1);
    csv += row.map(csvQuote).join(',') + '\n';
  });
  return csv;
}

;
// ==== FILE: js/storage.js ====

// localStorage key + helpers for per-section grouping-column-name overrides.
// Lets sections rename "Parent Task" to anything (e.g. "Builder" for a real
// estate inventory) while keeping the vertical sub-sub-tab sidebar working.
const PT_COL_KEY = 'taskTrackerParentTaskCols';


function getStoredPtColName(secKey) {
  try {
    const all = JSON.parse(localStorage.getItem(PT_COL_KEY) || '{}');
    return all[secKey];
  } catch (_) { return null; }
}


function setStoredPtColName(secKey, name) {
  try {
    const all = JSON.parse(localStorage.getItem(PT_COL_KEY) || '{}');
    if (name) all[secKey] = name;
    else delete all[secKey];
    localStorage.setItem(PT_COL_KEY, JSON.stringify(all));
  } catch (_) {}
}


// ── Column resize (drag the right edge of a header) ──
// Widths persist in localStorage as { [sectionKey]: { [colName]: width } }.
// Namespacing by section means resizing "Parent Task" in Personal doesn't
// affect "Parent Task" in Brand Management — each tab is fully independent.
const COL_WIDTH_KEY = 'taskTrackerColWidths';


function getStoredColWidth(secKey, name) {
  try {
    const all = JSON.parse(localStorage.getItem(COL_WIDTH_KEY) || '{}');
    return (all[secKey] || {})[name];
  } catch (_) { return null; }
}


function setStoredColWidth(secKey, name, width) {
  try {
    const all = JSON.parse(localStorage.getItem(COL_WIDTH_KEY) || '{}');
    if (!all[secKey] || typeof all[secKey] !== 'object') all[secKey] = {};
    all[secKey][name] = width;
    localStorage.setItem(COL_WIDTH_KEY, JSON.stringify(all));
  } catch (_) {}
}

;
// ==== FILE: js/formulas.js ====

// ── Formula columns ──
// A column with an entry in a section's (or category's) `formulas` map is
// derived: its value is computed from the row's other cells, the cell is
// read-only in the UI, and the stored CSV value gets refreshed automatically
// whenever any cell in the same row is edited.
function parseFormulaNumber(s) {
  if (s == null || s === '') return 0;
  const cleaned = String(s).replace(/[^0-9.\-]/g, '');
  return parseFloat(cleaned) || 0;
}


// Get the formula map that applies to the currently-active view. For a
// Categorized section, formulas live on the active category; for a regular
// section, on the section itself.
function getActiveFormulas(sec) {
  if (typeof hasCategories === 'function' && hasCategories(sec)) {
    const cat = (typeof activeCategoryMeta === 'function') ? activeCategoryMeta(sec) : null;
    return cat && cat.formulas;
  }
  return sec.formulas;
}


function isFormulaColumn(sec, ci) {
  const formulas = getActiveFormulas(sec);
  if (!formulas) return false;
  const colName = sec.columns[ci];
  return colName != null && Object.prototype.hasOwnProperty.call(formulas, colName);
}


// Recompute formula cells for one row. Returns true if any cell changed.
function computeRowFormulas(sec, ri) {
  const formulas = getActiveFormulas(sec);
  if (!formulas) return false;
  const row = sec.rows[ri];
  if (!row) return false;
  const rowObj = {};
  sec.columns.forEach((col, i) => { rowObj[col] = row[i]; });
  let changed = false;
  for (const colName in formulas) {
    const ci = sec.columns.indexOf(colName);
    if (ci < 0) continue;
    try {
      const out = formulas[colName](rowObj);
      const newStr = (out == null) ? '' : String(out);
      if (row[ci] !== newStr) { row[ci] = newStr; changed = true; }
    } catch (e) { console.warn(`Formula error for ${colName}:`, e); }
  }
  return changed;
}


function computeAllFormulas(sec) {
  if (!getActiveFormulas(sec) || !sec.rows) return false;
  let any = false;
  for (let i = 0; i < sec.rows.length; i++) {
    if (computeRowFormulas(sec, i)) any = true;
  }
  return any;
}

;
// ==== FILE: js/epics.js ====

// ── Sub-tab helpers (Epic-based filtering) ──
// The Epic column is **positional by convention**: column at index 1, i.e.
// the first column after the #. This is robust against renames (the same
// position drives the horizontal sub-tabs regardless of what you call it).
// A section can override via sec.epicCol = "..." in SECTIONS metadata if
// it needs Epic at a different position.
// The rule lives in the SHARED module (mcp-server/shared/table-rules.mjs topicColumnIndex - the MCP server runs the
// same code): -1 for a flat table (an imported file, no grouping column), else sec.epicCol by name, else column 1.
function epicColumnIndex(sec) { return TableRules.topicColumnIndex(sec); }


// Does the section have a table to open? A grouped section: at least one table-Epic (the "All Tables" overview
// merges them). A FLAT section (an imported file, no grouping column): its one table, whenever it has columns.
function sectionHasTable(sec) {
  if (sec.flat) return sec.columns.length > 1;
  return uniqueEpics(sec).length >= 1;
}


function uniqueEpics(sec) { return TableRules.tableNames(sec); }   // shared rule: the tables, in first-appearance order


// Effective Epic for a row: its own value, OR the most recent non-empty Epic
// above it. This lets the existing "Epic on first row of a group, blank on
// continuation rows" pattern keep working without rewriting the data.
function effectiveEpic(rows, idx, epicCi) { return TableRules.effectiveTopic(rows, idx, epicCi); }   // shared rule: fill-down


// Parent Task column index. Resolution order: localStorage override (auto-
// tracked from rename) > section-declared sec.parentTaskCol > default name
// "parent task". Any candidate that collides with the Epic column (col 1)
// is rejected — Epic and Parent Task must be different columns or the UI
// would show the same values in both nav strips.
function parentTaskColumnIndex(sec) {
  if (sec.flat) return -1;   // a flat table: a column named "Parent Task" is just a column
  const epicCi = epicColumnIndex(sec);
  const candidates = [];
  const overridden = getStoredPtColName(activeSection);
  if (overridden) candidates.push(overridden);
  if (sec.parentTaskCol) candidates.push(sec.parentTaskCol);
  candidates.push('parent task');
  for (const name of candidates) {
    const idx = sec.columns.findIndex(c => (c || '').trim().toLowerCase() === name.toLowerCase());
    if (idx >= 0 && idx !== epicCi) return idx;
  }
  return -1;
}


// Effective Parent Task — same inheritance pattern as Epic, but bounded by
// Epic. We stop walking up when we cross an Epic boundary so a row at the
// start of Epic B doesn't accidentally inherit a Parent Task from Epic A.
function effectiveParentTask(rows, idx, ptCi, epicCi) {
  if (ptCi < 0) return '';
  const epicAtIdx = epicCi >= 0 ? effectiveEpic(rows, idx, epicCi) : null;
  for (let i = idx; i >= 0; i--) {
    if (epicCi >= 0) {
      const epicAtI = effectiveEpic(rows, i, epicCi);
      if (epicAtI !== epicAtIdx) break;
    }
    const v = (rows[i][ptCi] || '').trim();
    if (v) return v;
  }
  return '';
}


// Unique explicit Parent Task values within a given Epic.
function uniqueParentTasksInEpic(sec, epicName) {
  const ptCi = parentTaskColumnIndex(sec);
  const epicCi = epicColumnIndex(sec);
  if (ptCi < 0) return [];
  const seen = new Set();
  const out = [];
  sec.rows.forEach((r, i) => {
    if (epicName !== 'All' && epicCi >= 0) {
      if (effectiveEpic(sec.rows, i, epicCi) !== epicName) return;
    }
    const v = (r[ptCi] || '').trim();
    if (v && !seen.has(v)) { seen.add(v); out.push(v); }
  });
  return out;
}

;
// ==== FILE: js/notes/notes-persistence.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-persistence.js
// ==========================================================================


// ───────────────────────────────────────────────────────────────────────────
// Notes-type Epics — plain markdown notes alongside the tabular Epics.
//
// A notes-Epic is a *collection of boxes*. Each box is an independent
// contenteditable region backed by its own .md file. Layouts (stack / 2col /
// 3col / 2x2) just rearrange the grid; box data is identical.
//
// Storage (in /data alongside the section's CSV):
//   <prefix>__notes_meta.json                         → meta for ALL epics
//   <prefix>__notes__<epicId>__<boxId>.md             → one box's content
//   <prefix>__notes__<epicId>.md   (LEGACY pre-multi-box format, still read
//                                    as a single "main" box if the new path
//                                    doesn't exist yet — see loadNotesContent)
//
// Meta schema:
//   { epics: [ { id, name, layout, boxes: [ { id, lastEditedBy, lastEditedAt }, ... ] }, ... ] }
//   lastEditedBy / lastEditedAt = MU-1 L8, see stampBoxLastEdited below.
//
// `epic.id` and `box.id` never change once created — so rename/move are pure
// meta updates with no file rename. Deleting an epic deletes every box file.
// ───────────────────────────────────────────────────────────────────────────

// File-prefix used for this section's notes sidecars. For a normal single-CSV
// section, strip ".csv" from sec.file. For a categorized section (Personal),
// strip the "__<CategoryName>.csv" suffix so all categories share one notes
// namespace at the section level.
function notesPrefix(sec) {
  if (sec.file) return sec.file.replace(/\.csv$/, '');
  if (sec.categories && sec.categories[0] && sec.categories[0].file) {
    return sec.categories[0].file.replace(/__[^_]+\.csv$/, '');
  }
  return null;
}

// The sidecar names are the shared rule's (mcp-server/shared/default-chapter.mjs): one source for the web, the MCP and
// the server that births a book's first subject with its chapter.
function notesMetaFilename(sec) {
  const p = notesPrefix(sec);
  return p ? DefaultChapter.notesMetaName(p) : null;
}

// New multi-box content filename.
function notesContentFilename(sec, epicId, boxId) {
  const p = notesPrefix(sec);
  return p ? DefaultChapter.notesBoxName(p, epicId, boxId) : null;
}

// Legacy pre-multi-box filename. Read-only fallback when migrating older
// epics that were saved as a single .md before this refactor.
function notesContentFilenameLegacy(sec, epicId) {
  const p = notesPrefix(sec);
  return p ? p + '__notes__' + epicId + '.md' : null;
}


// ── Concurrency guards (cloud mode) ──────────────────────────────────────────
// _boxVersions[file] = the "{seconds}.{nanos}" change token last loaded/saved for
//   a box doc; the next autosave sends it so the fetch shim can 409 a stale
//   overwrite (an MCP or other-session write that landed under us).
// _boxHeld[file] = true once a conflict was detected for that box; its autosave
//   is suspended until the user reloads the box (a fresh load clears the flag).
// _boxLoaded[file] = the box's server CONTENT as we last loaded/saved it. A 409 means
//   the version TOKEN moved, but a token move is NOT proof the content diverged (a
//   structural op - reorder/rename/new tab - or a re-render can move it while the box
//   content is unchanged). We compare the server's current content to this to tell a
//   real content conflict from a token-only move, so the conflict banner never false-
//   alarms on a structural-only change.
// _deletedEpicIds = tab ids the user deleted this session, so saveNotesMeta's
//   merge-unknown-tabs does not resurrect them from Firestore.
// _deletedBoxIds = composite "<epicId> <boxId>" keys of boxes the user deleted this
//   session, so the box-level merge (fetch-shim mergeEpicLists) does not resurrect a
//   just-deleted box from the DB's stale copy. Mirror of _deletedEpicIds one level down.
// All are inert in local dev mode (no X-Note-Version header => no token =>
// nothing ever holds; there is no concurrency there).
const _boxVersions = {};
const _boxHeld = {};
const _boxLoaded = {};
// Files this tab CREATED (first write, no token yet) and has not loaded since. The one load that follows a
// creation - the re-render that puts the new box on screen - would fetch back the content this tab wrote a
// moment ago; it reads _boxLoaded instead and clears the mark, so every later load fetches as before.
const _boxFresh = new Set();
// Meta saves of ONE file leave one after another (B4, Rishabh 2026-10-06). Two in flight on the same doc
// are two Firestore transactions on one document: the second commit fails its precondition, the SDK
// re-runs it (a billed read + a failed write + a console warn per retry) and only then lands. The box
// saves already queue per file (_boxSaveChain); this is the same rule for the chapter list. What a save
// SENDS and DECLARES is read at its departure (see saveNotesMeta), so a queued save carries the latest model.
const _metaSaveChain = {};
const _deletedEpicIds = new Set();
const _deletedBoxIds = new Set();
// WHAT THIS TAB CHANGED, per meta file (Rishabh 2026-10-05, the rule behind F's merge: "a tab's copy stands only for
// what it changed since its last successful meta save; every other box / chapter field keeps the store's"). Before,
// ITEM 5 had the call sites mark a changed chapter id by hand (rename, layout, fit, chapter order) and the merge kept
// THIS tab's whole chapter / box for anything it did not know better - so a stale tab's height write carried an old
// roadmap card's tasks and another chapter's grain back over what a second tab had just saved (his BVP card, prod
// 21:26 IST). Now nothing is marked at the sites - saveNotesMeta has ~15 callers (heights, renames, layout, the
// roadmap's prefs and its undo) and one forgotten site would reopen the loss. The declaration is DIFFED here, once,
// against a snapshot of the chapter list as last LOADED or last successfully SENT, so every caller, present and
// future, is covered by construction. On success the baseline becomes what was SENT (what the store took from us;
// for keys we did not declare it kept its own, which we never claimed, so the next diff stays silent about them until
// the tab-return adopts the store's copy - notes-refresh); on failure it stays, so the same diff goes again. A chapter
// or box the baseline lacks needs no entry: the merge lands it whole.
const _metaBaseline = {};   // meta file -> [epics] snapshot: persisted keys only, virtual chapters out
function _metaSnapshot(epics) {
  return JSON.parse(JSON.stringify((epics || []).filter(e => e && !e._sharedVirtual), (k, v) => (k && k[0] === '_') ? undefined : v));
}
// One comparable string for any meta value: keys sorted, `_`-keys out, so two copies of the same data compare equal
// whatever order their keys were built in. The save diff below and the tab-return compare (notes-refresh) both use it.
function notesStableJson(v) {
  if (Array.isArray(v)) return '[' + v.map(notesStableJson).join(',') + ']';
  if (v && typeof v === 'object') return '{' + Object.keys(v).filter(k => k[0] !== '_').sort().map(k => JSON.stringify(k) + ':' + notesStableJson(v[k])).join(',') + '}';
  return v === undefined ? 'null' : JSON.stringify(v);
}
const _idOrder = (list) => (list || []).map(x => String(x.id));
// Did this tab change the ORDER of a list (boxes of a chapter / chapters of a subject) since the baseline? Two shapes
// are an order fact: the ids both sides have in a different sequence (a move), and a NEW id placed BEFORE an id the
// baseline has (a mid-list insert - "+ Add Box" after the box the person is on, the roadmap's undo putting a station
// back at its slot). The merge (fetch-shim mergeEpicLists) appends an undeclared new id at the END, so an insert
// that is not declared lands last in the store and the tab-return reload moves it there on screen (Rishabh
// 2026-10-15: "added a box in second position, clicked outside, the box went to last"). A new id AFTER every known
// one is exactly what the merge does on its own, so it stays undeclared - the store's order (another writer's
// reorder) still stands for that save.
function _orderChanged(curIds, baseIds) {
  const cur = new Set(curIds), base = new Set(baseIds);
  if (curIds.filter(id => base.has(id)).join('\u0000') !== baseIds.filter(id => cur.has(id)).join('\u0000')) return true;
  let afterNew = false;
  for (const id of curIds) { if (!base.has(id)) afterNew = true; else if (afterNew) return true; }
  return false;
}
const _keysDiffering = (a, b, skip) => [...new Set([...Object.keys(a), ...Object.keys(b)])].filter(k => !skip.includes(k) && k[0] !== '_' && notesStableJson(a[k]) !== notesStableJson(b[k]));
// The declaration the merge reads (fetch-shim mergeEpicLists, F): { epics: { <id>: { fields: [keys], boxes: { <boxId>: [keys] },
// boxOrder } }, epicOrder } - per chapter key (all but id / boxes), per box key, the order of the ids both sides have.
function metaChangesSince(base, epics) {
  const cur = _metaSnapshot(epics);
  const baseById = new Map((base || []).map(e => [String(e.id), e]));
  const out = { epics: {}, epicOrder: false };
  for (const e of cur) {
    const b = baseById.get(String(e.id));
    if (!b) continue;   // new to the store: lands whole
    const fields = _keysDiffering(e, b, ['id', 'boxes']);
    const boxes = {};
    const bBoxes = new Map((b.boxes || []).map(x => [String(x.id), x]));
    for (const x of (e.boxes || [])) {
      const y = bBoxes.get(String(x.id));
      if (!y) continue;   // new box: lands whole
      const keys = _keysDiffering(x, y, ['id']);
      if (keys.length) boxes[x.id] = keys;
    }
    const boxOrder = _orderChanged(_idOrder(e.boxes), _idOrder(b.boxes));
    if (fields.length || Object.keys(boxes).length || boxOrder) out.epics[e.id] = { fields, boxes, boxOrder };
  }
  out.epicOrder = _orderChanged(_idOrder(cur), _idOrder(base || []));
  return out;
}
// _boxSaveChain = per-file tail promise. A single browser's saves to ONE box run
//   one-at-a-time: each waits for the previous to fully SETTLE (its success callback
//   advances _boxVersions/_boxLoaded) before starting, so the next save carries the
//   FRESH token and can never self-409 -> the "two of my own overlapping saves look
//   like a foreign conflict" false banner is gone at the source. Keyed by FILE, so
//   different boxes never wait on each other; MCP / other-writer paths do NOT pass
//   through here, so they are never serialized (any/many boxes stay fully parallel).
// _boxSentContents = per-file recent contents THIS browser sent (bounded). The 409
//   reconcile treats "the server holds something WE ourselves sent" as benign, so any
//   stray overlap (e.g. a reconcile re-save) can never be misread as a foreign write.
const _boxSaveChain = {};
const _boxSentContents = {};


// ── MU-1 L8: who last edited a box ─────────────────────────────────────────
// ONE field per box on its notes-meta entry, overwritten at every content-changing
// save - not the creator: Priya editing Aman's box makes the box read Priya. The
// names are exact (`lastEditedBy` / `lastEditedAt`): Manage > Contributions reads
// them. L9: the box NEVER shows it, in the reader or the editor - nothing in
// notes-render.js reads these two fields.
//
// The email is the signed-in user's, read live from the cloud bridge. In local dev
// there is no bridge and no signed-in user, so there is nobody to stamp.
function _signedInEmail() {
  const c = (typeof window !== 'undefined') ? window.__ttCloud : null;
  return (c && typeof c.email === 'function') ? (c.email() || '') : '';
}

// Stamp one box's meta entry. Returns whether it was stamped, so the caller knows
// whether a meta write is owed - this never writes, saveNotesMeta stays the ONE writer.
function stampBoxLastEdited(sec, epicId, boxId) {
  const email = _signedInEmail();
  if (!email) return false;
  const epic = (sec.notesEpics || []).find(e => String(e.id) === String(epicId));
  const box = epic && (epic.boxes || []).find(b => String(b.id) === String(boxId));
  if (!box) return false;
  box.lastEditedBy = email;
  box.lastEditedAt = Date.now();
  return true;
}

// ── The meta has ONE writer, and never two of it in flight ─────────────────
// Structural edits (add / delete / rename a box or chapter, layout, height, title)
// call saveNotesMeta directly: each is one user action and has to land at once. The
// L8 stamp is different - it rides on EVERY content save, so a direct call there would
// put a second write of the SAME doc in flight beside flushPendingNotesSaves's own
// awaited one (blur + debounce + a multi-box flush all land together). So the stamp
// only MARKS the section, and this timer is the single writer that flushes it. Any
// direct saveNotesMeta for that section cancels the pending flush, because the write
// it is about to make already carries the stamp (the stamp is in memory the moment it
// is taken) - so the two can never race.
//
// The window is short on purpose: it exists to collapse writes that land together, not
// to delay the stamp. Steady typing saves ~900 ms apart, so each still writes its own
// meta - which is what L8 asks for - and an interrupted session can lose at most this
// much of the LAST stamp (never content: the box's own save is separate and already done).
const NOTES_META_COALESCE_MS = 300;
let _metaDirtySec = null;        // the section whose meta is owed a write (else null)
let _metaDirtyTimer = null;

function markNotesMetaDirty(sec) {
  // A different section still owed a write is flushed now, never dropped: one pending
  // slot, and the stamp it carries must not be lost when the user moves on.
  if (_metaDirtySec && _metaDirtySec !== sec) saveNotesMeta(_metaDirtySec);
  _metaDirtySec = sec;
  if (_metaDirtyTimer) return;   // a flush is already scheduled for this section
  _metaDirtyTimer = setTimeout(() => {
    _metaDirtyTimer = null;
    const owed = _metaDirtySec;
    if (owed) saveNotesMeta(owed);
  }, NOTES_META_COALESCE_MS);
}
// Called by saveNotesMeta itself: the write about to happen IS the owed write.
function _clearNotesMetaDirty(sec) {
  if (_metaDirtySec !== sec) return;          // another section's pending flush is not ours to cancel
  if (_metaDirtyTimer) { clearTimeout(_metaDirtyTimer); _metaDirtyTimer = null; }
  _metaDirtySec = null;
}


async function loadNotesMeta(sec) {
  sec.notesEpics = sec.notesEpics || [];
  const file = notesMetaFilename(sec);
  if (!file) return;
  try {
    const res = await fetch('/load?file=' + file);
    if (!res.ok) { sec.notesEpics = []; return; }
    const text = await res.text();
    if (!text.trim()) { sec.notesEpics = []; return; }
    const json = JSON.parse(text);
    sec.notesEpics = Array.isArray(json.epics) ? json.epics : [];
  } catch (e) {
    sec.notesEpics = [];
  }
  normalizeNotesEpics(sec.notesEpics);
  _metaBaseline[file] = _metaSnapshot(sec.notesEpics);   // the store and this tab agree on exactly this
}
// The model and its baseline travel TOGETHER. A tab-return that reloads the meta and then has to stand down (a
// keystroke landed during the reload - typing wins) puts memory back to the old copy; the baseline must go back with
// it, or the next save diffs OLD memory against the store's NEW copy, reads the other tab's card as "this tab changed
// it back" and declares it - the same loss through the typing-wins door (J RUN, row 51).
function notesMetaHold(sec) { return { epics: sec.notesEpics, baseline: _metaBaseline[notesMetaFilename(sec)] }; }
function notesMetaRestore(sec, hold) { sec.notesEpics = hold.epics; _metaBaseline[notesMetaFilename(sec)] = hold.baseline; }

// A chapter list as the store holds it -> as memory holds it. Backwards-compat: epics created before multi-box
// have no `boxes` array (a single 'main' box points at the legacy single-file content) and no layout. The ONE
// place this happens: loadNotesMeta and the tab-return compare (notes-refresh) both run it, so a store copy and
// a memory copy of the same data compare equal.
function normalizeNotesEpics(epics) {
  (epics || []).forEach(epic => {
    if (!epic || epic.type === 'timeline') return;   // timeline epics have no boxes/layout
    if (!Array.isArray(epic.boxes) || epic.boxes.length === 0) epic.boxes = [{ id: 'main' }];
    if (!epic.layout) epic.layout = 'stack';
  });
  return epics;
}


function saveNotesMeta(sec) {
  const file = notesMetaFilename(sec);
  if (!file) return Promise.resolve();
  _clearNotesMetaDirty(sec);   // this write settles whatever the L8 stamp had marked owed
  // Never persist VIRTUAL shared (read-access) chapters — they are resolved live from
  // the sender's snapshot and must never enter the recipient's own meta (the whole
  // revocable-no-copy guarantee).
  // What this save SENDS and what it DECLARES is read at DEPARTURE - after the previous save of this file has
  // settled - not when it is called. The declaration is a diff against the baseline, and the baseline moves only
  // when a save LANDS: read at call time inside a burst, a field toggled back to the baseline's value (Stack ->
  // 2 cols -> Stack, four quick clicks) compares equal to the stale baseline, goes undeclared, and the store keeps
  // the first click's value while the screen shows the last (RUN 2026-10-06, B4). Read at departure, the diff is
  // against the baseline the previous save just set, and the model is the latest - every edit made while a save
  // was in flight rides the next one, declared. An edit that lands AFTER departure differs from `sent`, so the
  // save after it declares it; this one's success never sweeps it.
  let sent;
  const send = () => {
    const payload = JSON.stringify({ epics: (sec.notesEpics || []).filter(e => !e._sharedVirtual) }, null, 2);
    sent = _metaSnapshot(sec.notesEpics);
    const changes = metaChangesSince(_metaBaseline[file], sec.notesEpics);
    return fetch('/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // mergeEpics: the shim merges per FIELD - this tab's copy stands only for what `changes` declares (see
      // metaChangesSince); the store keeps its own for everything else, unions in any tab / box a concurrent writer
      // (an MCP tool, another session) added that we never saw, minus the tabs / boxes we deleted this session.
      body: JSON.stringify({ filename: file, csv: payload, mergeEpics: true, deletedEpicIds: [..._deletedEpicIds], deletedBoxIds: [..._deletedBoxIds], changes })
    });
  };
  const chained = (_metaSaveChain[file] || Promise.resolve()).then(send, send);
  // The chain advances on the WHOLE save - response read, baseline moved, adopted - not on the fetch alone: the
  // next save's departure diff runs against the baseline THIS save sets, and that happens in the success handler
  // below, after the fetch settled (J RUN 2026-10-06: chained on the fetch, a save queued behind a slow one
  // departed before the baseline moved, diffed against the old one, and left its toggle-back undeclared).
  const done = chained.then(async res => ({ ok: res.ok, r: await res.json().catch(() => null) })).then(({ ok, r }) => {
    // The store took what we declared: from here the baseline is what we sent. A refused or failed save leaves
    // the baseline as it was, so the same diff goes with the next one.
    if (ok) _metaBaseline[file] = sent;
    else return { failedFile: file };   // refused (not landed): say so to the caller, like the box save does
    // Adopt what the merge KEPT that we lack, so an AI's concurrent write appears
    // without a reload. Skipped in read-only mode (the shim returns no `epics`).
    if (!r || !Array.isArray(r.epics)) return;
    // (1) new TABS: adopt like a locally-added chapter (subtab order + re-render).
    const have = new Set((sec.notesEpics || []).map(e => String(e.id)));
    const added = r.epics.filter(e => !have.has(String(e.id)));
    for (const e of added) {
      if (!Array.isArray(e.boxes) || !e.boxes.length) e.boxes = [{ id: 'main' }];
      if (!e.layout) e.layout = 'stack';
      sec.notesEpics.push(e);
      _metaBaseline[file].push(_metaSnapshot([e])[0]);   // adopted from the store = agreed, not ours to declare
      if (typeof subtabOrderInsertAtEnd === 'function') subtabOrderInsertAtEnd(sec, subtabKeyOfNotes(e.id));
    }
    if (added.length && typeof renderSubtabs === 'function') renderSubtabs();
    // (2) new BOXES in a tab we ALREADY have (the box-level analogue of the above):
    // adopt them into our in-memory list so an MCP box added to an OPEN chapter shows
    // up. Only fires when a concurrent box was actually merged in (rare) - the common
    // no-concurrency save adopts nothing and re-renders nothing (keeps the caret).
    const localById = new Map((sec.notesEpics || []).map(e => [String(e.id), e]));
    let activeGainedBox = false;
    for (const re of r.epics) {
      const localE = localById.get(String(re.id));
      if (!localE || !Array.isArray(re.boxes)) continue;
      const localBoxIds = new Set((localE.boxes || []).map(b => String(b.id)));
      // The same rule the store merge applies (fetch-shim mergeEpicLists): a box this tab DELETED
      // is not "a box we never saw". Without it, a save that left before the delete (the editor's
      // blur-commit as the confirm dialog takes focus) answers AFTER the splice with the box still
      // in the store, and this adopt puts the deleted box straight back into memory.
      const newBoxes = re.boxes.filter(b => !localBoxIds.has(String(b.id)) && !_deletedBoxIds.has(String(re.id) + ' ' + String(b.id)));
      if (!newBoxes.length) continue;
      if (!Array.isArray(localE.boxes)) localE.boxes = [];
      localE.boxes.push(...newBoxes);
      const baseE = _metaBaseline[file].find(x => String(x.id) === String(re.id));
      if (baseE) { if (!Array.isArray(baseE.boxes)) baseE.boxes = []; baseE.boxes.push(..._metaSnapshot([{ boxes: newBoxes }])[0].boxes); }   // adopted = agreed
      if (String(re.id) === String(sec.activeNotesEpic)) activeGainedBox = true;
    }
    if (activeGainedBox && typeof renderNotesBoxes === 'function') renderNotesBoxes();
    // Resolves with the file that did not land, for the same reason the box save does:
    // flushPendingNotesSaves has to be able to name what failed before someone leaves.
  }).catch(() => ({ failedFile: file }));
  _metaSaveChain[file] = done.then(() => {}, () => {});   // the tail never rejects, so the next queued save always runs
  return done;
}


// Load a single box's content. Tries the new multi-box path first; for the
// legacy 'main' box, falls back to the pre-multi-box single-file path so old
// notes keep showing up. After the user edits + autosaves, the new path takes
// over and the legacy file becomes orphaned (harmless — safe to delete by hand).
async function loadNotesContent(sec, epicId, boxId) {
  const file = notesContentFilename(sec, epicId, boxId);
  if (!file) return '';
  if (_boxFresh.delete(file)) return _boxLoaded[file] ?? '';   // created by this tab a moment ago: the store holds exactly what we wrote
  try {
    const res = await fetch('/load?file=' + file);
    if (res.ok) {
      // Stash this box's version token (cloud mode sends X-Note-Version) so the
      // next autosave can detect a concurrent write. A fresh load is also the
      // "reload" that releases any conflict hold on this box.
      _boxVersions[file] = res.headers.get('X-Note-Version') || null;
      delete _boxHeld[file];
      const text = await res.text();
      _boxLoaded[file] = text;   // remember the server content, to tell a real content conflict from a token-only move
      return text;
    }
  } catch (_) {}
  // Legacy fallback: only for the single 'main' box created during migration
  if (boxId === 'main') {
    const legacy = notesContentFilenameLegacy(sec, epicId);
    if (legacy) {
      try {
        const r2 = await fetch('/load?file=' + legacy);
        if (r2.ok) { const t = await r2.text(); _boxLoaded[file] = t; return t; }
      } catch (_) {}
    }
  }
  _boxLoaded[file] = '';   // absent / never-loaded -> empty baseline
  return '';
}


// L7: the box lock is enforced HERE, at the write, because this is the one door every
// change to a box's content goes through - the keyboard, an image or video upload
// (notes-media-video.js:132 calls this directly, never through the editor's flushSave),
// a table insert, a file drop, a roadmap move, a conflict reconcile. A per-button guard
// would have to be re-added to every future button; this cannot be walked around, and it
// is the same door the L8 stamp hangs on. The editor's flushSave keeps its own early
// return as the fast path (no wasted serialize), and the toolbar of a locked box is
// hidden by CSS - this is the guarantee under both.
// (boxLockHolder lives in notes-render.js's lock block - the same shared global scope at
// runtime. Checked by typeof because the classic test harnesses load a SUBSET of these
// files, and a bare reference would throw there instead of just finding no lock.)
function _refuseIfBoxLocked(sec, epicId, boxId) {
  const holder = (typeof boxLockHolder === 'function') ? boxLockHolder(sec, epicId, boxId) : null;
  if (!holder) return false;
  if (typeof showToast === 'function') showToast('⚠ ' + holder + ' is editing this ' + LBL('boxNoun').toLowerCase());
  return true;
}

function saveNotesContent(sec, epicId, boxId, content, silent, reconcileAttempt) {
  const file = notesContentFilename(sec, epicId, boxId);
  if (!file) return Promise.resolve();
  if (_refuseIfBoxLocked(sec, epicId, boxId)) return Promise.resolve();
  // A reconcile RE-save (attempt>0) is invoked from INSIDE the current chain link
  // (reconcileOrConflict, after a 409); re-chaining it would make it wait for its own
  // link to settle = deadlock. Run it directly - it already carries the fresh token.
  if (reconcileAttempt) return _doSaveNotesContent(sec, epicId, boxId, file, content, silent, reconcileAttempt);
  // Serialize THIS browser's saves to THIS ONE box (see _boxSaveChain note): each waits
  // for the previous to fully settle, so the next carries the fresh token and can't self-409.
  const run = () => _doSaveNotesContent(sec, epicId, boxId, file, content, silent, 0);
  const chained = (_boxSaveChain[file] || Promise.resolve()).then(run, run);
  _boxSaveChain[file] = chained.catch(() => {});   // the tail never rejects, so the next queued save always runs
  return chained;
}

// Remember the last few contents THIS browser sent for a box, so a 409 reconcile can tell
// its OWN just-sent content from a genuine foreign write (reconcileOrConflict's benign check).
function _rememberSent(file, content) {
  const arr = _boxSentContents[file] || (_boxSentContents[file] = []);
  arr.push(content);
  if (arr.length > 4) arr.shift();   // bounded - only a near-simultaneous own-send matters
}

function _doSaveNotesContent(sec, epicId, boxId, file, content, silent, reconcileAttempt) {
  // NOTHING CHANGED = NOTHING TO WRITE (Rishabh's lead, 2026-10-11, RUN finding). The blur save fires on every blur -
  // clicking the menu, a cell, another box - and used to send the box even when its text equalled what the server
  // holds: one Firestore write + the version read per blur, and under a read-only wallet a false "Not saved". The
  // test runs HERE, inside the per-box chain, so the baseline is the one the previous save left behind (an
  // edit-then-undo while a save is in flight still compares against the landed text, never a stale one). A first
  // create (no token yet) and a 409 re-save always write.
  if (!reconcileAttempt && (_boxVersions[file] ?? null) !== null && content === (_boxLoaded[file] ?? '')) return Promise.resolve();
  _rememberSent(file, content);
  // L8: a save that changes NOTHING must not re-stamp the box's last editor (opening a
  // box and clicking away still fires a blur save). _boxLoaded[file] is the content the
  // server holds as we last loaded/saved it, so this comparison IS the dirty test - no
  // second flag to keep in step. An ABSENT baseline means this browser never loaded the
  // box, i.e. addNotesBox just created it and is writing the empty first file; that is a
  // creation, not an edit, and addNotesBox does its own creation stamp.
  const contentChanged = content !== (_boxLoaded[file] ?? '');
  const firstCreate = (_boxVersions[file] ?? null) === null;   // no token yet = this write creates the file
  return fetch('/save', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // versionCheck: the shim refuses (409) if the box's TOKEN moved since we last
    // loaded/saved it. expectedUpdatedAt is our last-known token (null for a
    // brand-new box => a first create, which always writes).
    body: JSON.stringify({ filename: file, csv: content, versionCheck: true, expectedUpdatedAt: _boxVersions[file] ?? null })
  }).then(res => {
    if (res.status === 409) {
      // A moved token is NOT proof the CONTENT diverged: a structural op
      // (reorder/rename/new tab) or a re-render can move a box's token while its
      // server content is unchanged. Verify the actual content before alarming -
      // reconcile silently on a token-only move, banner only on real divergence.
      return reconcileOrConflict(sec, epicId, boxId, file, content, silent, reconcileAttempt || 0);
    }
    // A refused write is a FAILED save, not a saved one. The shim answers a refusal (permission-denied - an editor whose
    // access was just removed; a rule change; a lock) with a JSON error body and a non-OK status, and this path used to
    // fall straight through to "✓ Notes saved" (RUN 2026-09-15, MU-1 cell 13). Say what the server said, and resolve
    // with the file so a batch (flushPendingNotesSaves) can name it too.
    if (!res.ok) {
      return res.json().catch(() => ({})).then((j) => {
        // WALLET: the shim refused the write because the wallet is read-only (402, reason 'wallet') - the one notice
        // says "Not saved - wallet is read-only", the text stays in the box (no reload), the save is a failed save.
        if (res.status === 402 && j && j.reason === 'wallet') {
          showToast('⚠ Not saved - wallet is read-only');   // NOT gated on `silent` (the blur save is silent): a refusal is never routine, and the "✓ Saved" pill from the last good save must not sit beside the notice (F's joint RUN)
          window.__ttCloud.wallet.notice({ status: 402, data: j }, 'Save');
          return { failedFile: file };
        }
        const msg = (j && (j.error || j.message)) || ('the server answered ' + res.status);
        if (!silent) showToast('⚠ Could not save this ' + LBL('boxNoun').toLowerCase() + ': ' + msg);
        return { failedFile: file };
      });
    }
    const v = res.headers.get('X-Note-Version');
    if (v) _boxVersions[file] = v;   // advance our token to what we just wrote
    _boxLoaded[file] = content;      // server now holds exactly this
    if (firstCreate) _boxFresh.add(file);   // the one load that follows a creation needs no fetch
    // PAST THIS POINT THE WRITE HAS LANDED. A throw below is this tab's own follow-up failing (a stamp, the
    // conflict bookkeeping, a toast) - never the network and never the save - so it gets its own sentence
    // (SAVE-ERR-1, Rishabh 2026-09-21; J: the broad catch used to read a ReferenceError here as "Server not
    // running", a server problem reported for a client code error). The store is right either way.
    try {
      // L8: the write landed and it changed the box → this person is now its last editor.
      // Marked, not written: markNotesMetaDirty's single timer is the one writer, so this
      // can never put a second saveNotesMeta in flight beside flushPendingNotesSaves's.
      if (contentChanged && stampBoxLastEdited(sec, epicId, boxId)) markNotesMetaDirty(sec);
      if (_boxHeld[file]) return;      // an out-of-order in-flight success during a LIVE conflict: don't toast (would bury the warn), don't clear the banner
      // A clean save (no active hold): if a stash lingered from a conflict the user
      // reloaded + re-saved, it's now resolved - clear the banner + stash.
      resolveNoteConflict(file, boxId);
      // `silent` suppresses the toast — used by the blur save, which runs on EVERY
      // blur (incl. clicking into a table cell): the 900ms typing debounce already
      // surfaces "✓ Notes saved", so a second toast on every blur was just noise.
      if (!silent) showToast('✓ Notes saved');
    } catch (e) {
      console.error('[notes] save landed, but the follow-up failed', e);
      // Not gated on `silent`: a code error is never routine, and the routine toast it replaces is the one `silent` mutes.
      showToast('⚠ Notes saved, but this ' + LBL('boxNoun').toLowerCase() + ' could not refresh (' + ((e && e.message) || e) + ') - reload to see it');
    }
    // A save that failed must be able to SAY so. It still resolves (every caller here is
    // fire-and-forget and an unhandled rejection would be worse than silence), but it
    // resolves with the file that did not land, so flushPendingNotesSaves - the one
    // caller that awaits a whole batch before someone leaves or copies - can name it.
  }, () => {
    // The fetch itself rejected: no response, nothing landed. This is the ONLY path that may say "server".
    if (!silent) showToast('⚠ Server not running');
    return { failedFile: file };
  }).catch((e) => {
    // The server answered but this tab threw while handling a 409 / a refusal: not landed, not the network.
    console.error('[notes] save: error after the server answered', e);
    showToast('⚠ Could not finish saving this ' + LBL('boxNoun').toLowerCase() + ' (' + ((e && e.message) || e) + ') - reload and check it');
    return { failedFile: file };
  });
}

// Record a save's outcome. Every save here resolves (never rejects) and resolves with
// { failedFile } when it did not land, so a batch can be collected instead of guessed at.
function _noteFailure(failed, result) {
  if (result && result.failedFile) failed.push(result.failedFile);
}

// Flush any pending in-memory notes edits for the ACTIVE section to the cloud, so a
// copy (which reads PERSISTED state) can't miss an edit made moments earlier - a
// roadmap card just dragged (lives in the meta), or typing still inside the 900ms
// content debounce. Only the active section can hold unsaved edits: leaving a chapter
// blur-saves its content, and a non-active section has nothing mounted. Awaited by the
// copy handlers before they read the cloud, closing the edit->copy stale-read race, and
// by _endEditorSession (books-api.js:118) before the store switches back off the owner.
//
// THROWS, naming every file that did not save, so "your last edits did not reach the
// book" can actually be said. Each save still runs past the one before it - one dead box
// must not stop the rest from landing - so the throw comes once, at the end, with the
// whole list. Callers already expect it: _endEditorSession toasts e.message, and the
// copy handlers show it as "⚠ <message>".
async function flushPendingNotesSaves(sectionKey) {
  const failed = [];
  // Only the ACTIVE section can hold unsaved in-memory edits. If a DIFFERENT section
  // is named (e.g. copying a non-active subject tab), there is nothing to flush - and
  // we must NOT write it: that would push this browser's possibly-stale in-memory meta
  // over a concurrent writer's change to a section we only have an old copy of.
  const sec = (sectionKey != null && sectionKey !== activeSection) ? null : SECTIONS[activeSection];
  // 0) The L8 stamp's owed meta write belongs to the section the stamp was taken in,
  //    which is not always the one being flushed. Its 300 ms timer would otherwise
  //    survive this leave and fire AFTER the store has switched back - writing the
  //    OWNER's meta into the editor's own store. Flush it here, whatever section it is
  //    for; saveNotesMeta cancels the timer as it goes. (When it IS this section, step 2
  //    below is that write - no need to make it twice.)
  if (_metaDirtySec && _metaDirtySec !== sec) _noteFailure(failed, await saveNotesMeta(_metaDirtySec));
  if (sec) {
    const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
    // 1) CONTENT: force each mounted editor's pending debounce to save now; keep the
    //    box.title cache in step (the 250ms outline timer may not have run yet) so the
    //    meta write below is consistent.
    for (const b of ((epic && epic.boxes) || [])) {
      if (_boxSaveTimers[b.id]) { clearTimeout(_boxSaveTimers[b.id]); delete _boxSaveTimers[b.id]; }
      const editor = document.querySelector(`.notes-editor[data-box-id="${b.id}"]`);
      if (editor && typeof getEditorContent === 'function' && typeof _firstH1 === 'function') {
        const t = _firstH1(getEditorContent(editor));
        if (t) b.title = t; else delete b.title;
      }
      const flush = _boxFlush[b.id];
      if (typeof flush === 'function') {
        try { _noteFailure(failed, await flush(true)); }
        catch (e) { failed.push(notesContentFilename(sec, epic.id, b.id) || b.id); }
      }
    }
    if (_notesOutlineTimer) { clearTimeout(_notesOutlineTimer); _notesOutlineTimer = null; }
    // 2) META: roadmap placements, box add/remove, layout, fit, titles - and every L8
    //    stamp the content saves above just took (each only MARKED the section, so this
    //    one awaited write flushes them all; it cancels the pending timer, so there is
    //    never a second write of this doc in flight beside it).
    _noteFailure(failed, await saveNotesMeta(sec));
  }
  if (failed.length) throw new Error('These did not save: ' + failed.join(', '));
}


function deleteNotesContent(sec, epicId, boxId) {
  const file = notesContentFilename(sec, epicId, boxId);
  if (!file) return Promise.resolve();
  // L7: deleting a box someone is typing in is the loudest write of all. Refused at the
  // same door as the save, so the roadmap's box moves (roadmap/card-ops.js:95/:143/:249)
  // are covered without each of them carrying its own check.
  if (_refuseIfBoxLocked(sec, epicId, boxId)) return Promise.resolve();
  return fetch('/delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename: file })
  }).catch(() => {});
}

;
// ==== FILE: js/notes/notes-conflict.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-conflict.js
// ==========================================================================

// A 409 fired. Fetch the box's CURRENT server content: if it equals what we last
// loaded/saved, the token moved but the content never diverged (structural op /
// token-only) -> adopt the fresh token and re-save silently (the edit is safe), no
// alarm. If the content actually differs, it's a real conflict -> the banner. The
// re-save is bounded (reconcileAttempt) so a repeatedly-moving token can't loop.
async function reconcileOrConflict(sec, epicId, boxId, file, content, silent, attempt) {
  // Snapshot our known baseline BEFORE the await: a re-render (loadNotesContent)
  // interleaving during the fetch could otherwise overwrite _boxLoaded to the very
  // divergent content we are trying to detect, misreading a real conflict as
  // token-only (a silent clobber of the other writer). Compare against this snapshot.
  const base = _boxLoaded[file] == null ? '' : _boxLoaded[file];
  let serverContent = null, serverTok = null, verified = false;
  try {
    const res = await fetch('/load?file=' + file);
    if (res.ok) { serverContent = await res.text(); serverTok = res.headers.get('X-Note-Version') || null; verified = true; }
  } catch (_) {}
  // The user's on-screen text right now (the box may be off-screen -> null).
  const editor = document.querySelector(`.notes-editor[data-box-id="${boxId}"]`);
  const live = editor ? getEditorContent(editor) : null;
  // A moved token is BENIGN whenever the server ALREADY holds content we ourselves
  // hold or intend: the baseline we loaded (a structural / token-only move), the exact
  // text THIS save is writing, or the live editor text. The stale-baseline case is
  // real and box-size makes it common: two overlapping autosaves (debounce + blur, or
  // two debounces on a slow save - externalizeScenes writes each scene doc before the
  // box commit, widening the in-flight window) - the FIRST lands our edit + bumps the
  // token, the SECOND 409s, and if the first's success callback (which refreshes
  // _boxLoaded) hasn't run yet, `base` is stale. The server still holds OUR data, so
  // this must NOT read as a conflict. Comparing to `content`/`live` too closes it: a
  // banner fires only when the server holds content we did NOT write (a real conflict).
  const benign = verified && (serverContent === base || serverContent === content || (live != null && serverContent === live)
    || (Array.isArray(_boxSentContents[file]) && _boxSentContents[file].includes(serverContent)));   // the server holds content WE ourselves sent (a just-sent / still-in-flight own save) -> our own write, never a foreign conflict
  if (benign) {
    // Adopt the fresh token + baseline. Re-save only if the live editor has moved past
    // what the server holds (the user kept typing) - bounded so a repeatedly-moving
    // token can't loop; else the server already has the latest, so just clear any
    // lingering conflict state. Re-save the LIVE editor, never the older captured
    // `content`, so an out-of-order overlapping save can't revert newer keystrokes.
    _boxVersions[file] = serverTok;
    _boxLoaded[file] = serverContent;
    const latest = live != null ? live : content;
    if (latest !== serverContent && attempt < 2) return saveNotesContent(sec, epicId, boxId, latest, silent, attempt + 1);
    if (latest !== serverContent) stashHeldEdit(file, latest);   // extreme token thrash: preserve the still-unsaved edit (recoverable; restoreConflictBanner self-clears when it matches)
    else resolveNoteConflict(file, boxId);                       // server already has our latest -> a prior conflict (if any) is resolved
    return;
  }
  // Genuine content divergence (someone changed the box's CONTENT to something we did NOT write), or we could not
  // read it back: surface the conflict + preserve the edit. The banner says WHICH: a read-back that failed is not
  // evidence that an AI or another tab wrote, so that case names what is known (the latest could not be confirmed).
  handleNoteConflict(sec, epicId, boxId, file, content, verified ? 'diverged' : 'unverified');
}


// ── Autosave conflict UX (a 409 from the version-check shim) ──────────────────
// A stale browser save was refused because the box changed under it (an MCP tool
// or another session wrote). The critical write already survives (the shim didn't
// overwrite it); this is the LOSING (browser) writer's side: surface it durably and
// PRESERVE the rejected edit so "reload + re-apply" is real. The rejected edit is
// stashed in localStorage (survives a full page refresh, which reloads MCP content
// and would otherwise drop the in-DOM edit) and offered back via "Copy my version".
function _heldEditKey(file) { return 'ttHeldEdit:' + file; }
function stashHeldEdit(file, content) {
  try { localStorage.setItem(_heldEditKey(file), String(content == null ? '' : content)); } catch (_) {}
}
function getHeldEdit(file) {
  try { return localStorage.getItem(_heldEditKey(file)); } catch (_) { return null; }
}
function clearHeldEdit(file) {
  try { localStorage.removeItem(_heldEditKey(file)); } catch (_) {}
}

let _ncbStylesDone = false;
function ensureConflictBannerStyles() {
  if (_ncbStylesDone) return; _ncbStylesDone = true;
  const css =
    '.notes-conflict-banner{display:flex;flex-wrap:wrap;align-items:center;gap:.45rem .7rem;margin:.4rem 0;padding:.5rem .7rem;border:1px solid #f0c36d;border-left:3px solid #d98324;border-radius:8px;background:#fdf6e3;color:#7a4e10;font-size:.85rem;line-height:1.35}' +
    '.notes-conflict-banner .ncb-msg{flex:1 1 240px}' +
    '.notes-conflict-banner .ncb-actions{display:flex;gap:.4rem;flex-wrap:wrap}' +
    '.ncb-btn{font:inherit;font-size:.8rem;padding:.2rem .55rem;border:1px solid #d98324;border-radius:6px;background:#fff;color:#7a4e10;cursor:pointer;white-space:nowrap}' +
    '.ncb-btn:hover{background:#fbe6c4}';
  const st = document.createElement('style'); st.id = 'ncb-styles'; st.textContent = css;
  document.head.appendChild(st);
}

function removeConflictBanner(boxId) {
  const wrap = document.querySelector(`.notes-box[data-box-id="${boxId}"]`);
  const b = wrap && wrap.querySelector('.notes-conflict-banner');
  if (b) b.remove();
}

// Build (or replace) the conflict banner at the top of the box. Two states, static
// Rishabh-approved copy. Held: makes it unambiguous the edit is NOT saved, and walks the
// user through recovery (copy -> reload -> paste); buttons Copy my text, then Reload
// latest. Reloaded: says the latest is on screen and only Copy is left (below). The
// message is set via textContent (no interpolation) and the
// banner is a SIBLING of .notes-editor (outside the contenteditable) - no new XSS
// surface, and getEditorContent/setEditorContent never touch it.
const CONFLICT_BANNER_MSG = "Not saved - this note changed while you were typing. An AI or another tab updated it. Your text is still on screen but hasn't been saved. Copy it, reload to get the latest, then paste it back in.";
// The 409 arrived but the server's current content could not be read back (connection): the note MAY have changed; the
// one thing known is that this text is not saved. Same recovery, honest reason.
const CONFLICT_BANNER_MSG_UNVERIFIED = "Not saved - this note may have changed while you were typing, and the latest version could not be read back (connection). Your text is still on screen but hasn't been saved. Copy it, reload to get the latest, then paste it back in.";
// The second state, after "Reload latest" succeeded: the box now shows the latest version and saves normally again;
// the unsaved text is still held for Copy. The banner used to keep its first sentence here, so a reload that left the
// screen looking the same read as a dead button (Rishabh 2026-10-27: "reload latest button not working, kabhi kabhar").
const CONFLICT_BANNER_MSG_RELOADED = "Latest version loaded - this note saves normally again. Your unsaved text is kept: Copy my text, then paste it back where it belongs. This notice goes away with your next save.";
function showConflictBanner(boxId, file, sec, epicId, msg = CONFLICT_BANNER_MSG) {
  ensureConflictBannerStyles();
  const wrap = document.querySelector(`.notes-box[data-box-id="${boxId}"]`);
  if (!wrap) return;
  const existing = wrap.querySelector('.notes-conflict-banner');
  if (existing) existing.remove();
  // Held = the rejected edit is on screen and nothing saves until it is reloaded (both buttons). Hold released = the
  // person reloaded: the latest is on screen, saving works, only the held text is left to copy (Copy alone).
  const held = !!_boxHeld[file];
  const banner = document.createElement('div');
  banner.className = 'notes-conflict-banner';
  banner.setAttribute('role', 'alert');
  banner.setAttribute('contenteditable', 'false');
  banner.innerHTML = '<span class="ncb-msg"></span>'
    + '<span class="ncb-actions">'
    + '<button class="ncb-btn ncb-copy" type="button">Copy my text</button>'
    + (held ? '<button class="ncb-btn ncb-reload" type="button">Reload latest</button>' : '')
    + '</span>';
  banner.querySelector('.ncb-msg').textContent = held ? msg : CONFLICT_BANNER_MSG_RELOADED;   // one of the static sentences above, no interpolation
  wrap.insertBefore(banner, wrap.firstChild);
  banner.querySelector('.ncb-copy').addEventListener('click', () => {
    // Prefer the stash (the captured "my text" - correct even after a reload shows
    // the server content). If it's unavailable (e.g. localStorage failed at conflict
    // time), fall back to the live editor so a live-conflict edit is still copyable.
    const stash = getHeldEdit(file);
    const editor = document.querySelector(`.notes-editor[data-box-id="${boxId}"]`);
    const text = (stash != null && stash !== '') ? stash : (editor ? getEditorContent(editor) : '');
    if (!text) { showToast('⚠ Nothing to copy'); return; }   // never claim success on empty
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(() => showToast('✓ Copied your text'), () => showToast('⚠ Copy failed'));
    else showToast('⚠ Clipboard unavailable');
  });
  if (held) banner.querySelector('.ncb-reload').addEventListener('click', () => { reloadHeldBox(sec, epicId, boxId, file); });
}

// A 409 fired: hold + stash the rejected edit + show the persistent banner (if the
// box is on screen; else it appears on the next render via restoreConflictBanner).
function handleNoteConflict(sec, epicId, boxId, file, content, reason = 'diverged') {
  _boxHeld[file] = true;
  stashHeldEdit(file, content);
  showConflictBanner(boxId, file, sec, epicId, reason === 'unverified' ? CONFLICT_BANNER_MSG_UNVERIFIED : CONFLICT_BANNER_MSG);
}

// User chose "Reload latest": capture whatever is in the editor NOW (so edits made
// after the conflict are preserved too), load the MCP content, and keep the banner
// (stash retained, so "Copy my text" still works if they reloaded before copying).
// loadNotesContent clears the hold + refreshes the token.
async function reloadHeldBox(sec, epicId, boxId, file) {
  const editor = document.querySelector(`.notes-editor[data-box-id="${boxId}"]`);
  if (!editor) return;
  stashHeldEdit(file, getEditorContent(editor));   // capture the current unsaved edit first
  // Load fresh, but only replace the editor on a genuine success: a transient error
  // must NOT blank the box + drop the hold (the edit is only in the DOM/stash). We do
  // the fetch here (not via loadNotesContent) so we can tell a load FAILURE from a
  // legitimately-empty box - both of which loadNotesContent returns as ''.
  let res = null;
  try { res = await fetch('/load?file=' + file); } catch (_) {}
  if (!res || !res.ok) { showToast('⚠ Reload failed - your text is unchanged'); return; }
  const content = await res.text();
  _boxVersions[file] = res.headers.get('X-Note-Version') || null;
  _boxLoaded[file] = content;
  delete _boxHeld[file];
  setEditorContent(editor, content);
  _boxImages[boxId] = extractImageRefs(content);
  _boxTitleCache[boxId] = _firstH1(content);
  initBoxUndo(boxId, editor, content);
  restoreConflictBanner(sec, epicId, boxId);   // keep the banner only if the preserved edit still differs from what's now shown
}

// A clean (non-conflicting) save resolved a prior conflict: drop the stash + banner.
function resolveNoteConflict(file, boxId) {
  if (getHeldEdit(file) == null) return;   // nothing lingering - normal save, no-op
  clearHeldEdit(file);
  removeConflictBanner(boxId);
}

// On (re)render, re-surface the banner ONLY if a preserved edit still genuinely
// diverges from what the box now SHOWS. Compare the stash against the live editor's
// getEditorContent (NOT the raw loaded bytes): both are the same serialization form,
// so a structural-only change (token moved, content unchanged) and a re-render with
// the box's own content never false-alarm, and there is no whitespace/title-migration
// mismatch between the render and reload call sites. If they match, the divergence is
// gone -> clear the stash silently, no "not saved".
function restoreConflictBanner(sec, epicId, boxId) {
  const file = notesContentFilename(sec, epicId, boxId);
  if (!file) return;
  const stash = getHeldEdit(file);
  if (stash == null) return;                                       // no preserved edit
  const editor = document.querySelector(`.notes-editor[data-box-id="${boxId}"]`);
  const shown = editor ? getEditorContent(editor) : '';
  if (stash === shown) { clearHeldEdit(file); return; }            // divergence gone -> no alarm
  showConflictBanner(boxId, file, sec, epicId);                    // a real unsaved divergence remains
}

;
// ==== FILE: js/notes/notes-media-image.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-media-image.js
// ==========================================================================


// ── Image paste / inline rendering ───────────────────────────────────────
//
// Pasted images are saved as sidecar files next to the box's .md content:
//   <prefix>__notes__<eid>__<bid>__img_<timestamp>_<rand>.png
// The .md itself references them as standard markdown:  ![](filename.png)
// On render, those refs are swapped with <img src="/load?file=…"> so they
// appear inline in the editor.

// MU-1: a media name minted while EDITING SOMEONE ELSE'S BOOK carries that book - `<bookId>~` - so the server can keep
// an editor's writes inside the book they were given (cloud-store/media.js mediaNamePrefix owns the rule; this is the
// hook it installs). For the owner of the store it is '' and every name below is exactly what it always was.
function mediaNamePrefixHook() {
  return (typeof window.__ttMediaNamePrefix === 'function') ? window.__ttMediaNamePrefix() : '';
}

function imageFilename(sec, epicId, boxId, ext) {
  const p = notesPrefix(sec);
  if (!p) return null;
  const stamp = Date.now();
  const rand = Math.random().toString(36).slice(2, 6);
  return `${mediaNamePrefixHook()}${p}__notes__${epicId}__${boxId}__img_${stamp}_${rand}.${ext}`;
}

async function uploadImageBlob(filename, blob) {
  return fetch('/saveBinary', {
    method: 'POST',
    headers: { 'X-Filename': filename },
    body: blob
  }).then(r => r.json());
}

// Delete a sidecar image file from the server.
function deleteImageFile(filename) {
  if (!filename) return Promise.resolve();
  return fetch('/delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename })
  }).catch(() => {});
}

// Extract all sidecar media filenames referenced by a box: markdown ![](file)
// syntax, HTML <img src="file" …> syntax, AND the ```pdf fence (the storage file
// on its first body line). Returns a Set of bare filenames so the orphan-cleanup
// diff can compare across saves regardless of which form was used. (Named for its
// original image-only role; it now also covers PDF media.)
function extractImageRefs(text) {
  const out = new Set();
  if (!text) return out;
  // Markdown form
  const reMd = /!\[[^\]]*\]\(([^)]+)\)/g;
  let m;
  while ((m = reMd.exec(text)) !== null) {
    const file = m[1].trim();
    if (file && !/^[a-z]+:\/\//i.test(file)) out.add(file);
  }
  // HTML form (resized images)
  const reHtml = /<img[^>]+src=["']([^"']+)["']/g;
  while ((m = reHtml.exec(text)) !== null) {
    let file = m[1].replace(/^\/load\?file=/, '').replace(/^.*\//, '');
    try { file = decodeURIComponent(file); } catch (_) {}
    if (file && !/^[a-z]+:\/\//i.test(file)) out.add(file);
  }
  // Fenced ```pdf blocks: the FIRST body line is the storage filename (line 2 is
  // the cosmetic display name). Capture it so a removed PDF enters the same
  // orphan-cleanup diff as images and its bytes get /deleted.
  const rePdf = /```pdf[^\n]*\n([^\n]+)/g;
  while ((m = rePdf.exec(text)) !== null) {
    const file = m[1].trim();
    if (file && !/^[a-z]+:\/\//i.test(file)) out.add(file);
  }
  // Fenced ```videofile blocks: FIRST body line is the storage filename (line 2 is
  // the display name) - same orphan-cleanup + share-copy treatment as images/PDFs.
  const reVideo = /```videofile[^\n]*\n([^\n]+)/g;
  while ((m = reVideo.exec(text)) !== null) {
    const file = m[1].trim();
    if (file && !/^[a-z]+:\/\//i.test(file)) out.add(file);
  }
  return out;
}

// Map: boxId → Set of image filenames known to be referenced by that box.
// Populated on load, refreshed on every save. Used to diff and clean orphans.
const _boxImages = {};

// Shared insertion helper used by both paste and drop. Uploads the blob and
// then inserts a resize-wrapped <img> at the current cursor position. The
// wrapper gets an explicit initial width/height (capped at 600px wide) so the
// browser's native resize handle works from the first interaction.
async function insertImageAtCursor(editor, sec, epicId, boxId, blob, mimeType, originLabel) {
  const ext = ((mimeType || 'image/png').split('/')[1] || 'png').toLowerCase().replace('jpeg', 'jpg');
  const filename = imageFilename(sec, epicId, boxId, ext);
  if (!filename) return;
  try {
    await uploadImageBlob(filename, blob);
  } catch (_) {
    showToast('⚠ Image upload failed');
    return;
  }
  // Probe the blob for natural dimensions so the initial wrapper size has a
  // sensible aspect ratio. If probing fails (rare), fall back to 500x350.
  const dims = await probeImageDimensions(blob);
  // The awaits above suspend for seconds (× N for a multi-file upload). If the user
  // switched epics / deleted this box / moved a roadmap card meanwhile,
  // renderNotesBoxes() has detached `editor`. Never insert into a dead node or lie
  // about success: drop the just-uploaded orphan and surface it (no false "✓").
  // (Shared path — this hardens paste/drop too.)
  if (!editor || !editor.isConnected) {
    deleteImageFile(filename);
    showToast('⚠ ' + LBL('boxNoun') + ' closed - image not inserted');
    return;
  }
  // Make sure the insert lands in THIS editor, not wherever focus drifted during
  // the upload (execCommand targets the live document selection).
  const sel = window.getSelection();
  const caretInEditor = sel && sel.rangeCount && editor.contains(sel.getRangeAt(0).startContainer);
  if (!caretInEditor) {
    editor.focus();
    const s = window.getSelection();
    if (s) { const r = document.createRange(); r.selectNodeContents(editor); r.collapse(false); s.removeAllRanges(); s.addRange(r); }
  }
  // Inside a table cell the image starts no wider than the cell (its saved width / height then fit the column); in
  // free text the 600 px cap as before.
  const anchorNode = sel && sel.rangeCount ? sel.getRangeAt(0).startContainer : null;
  const anchorEl = anchorNode && (anchorNode.nodeType === 3 ? anchorNode.parentElement : anchorNode);
  const cell = anchorEl && anchorEl.closest && anchorEl.closest('.md-table-block th, .md-table-block td');
  const cap = cell ? Math.max(80, Math.min(600, cell.clientWidth - 24)) : 600;
  const w = Math.min(dims.w, cap);
  const h = Math.round((dims.h / dims.w) * w);
  // Instant local preview — avoids the post-upload window where /load?file=
  // can 404 before getBytes sees the just-written object. The URL lives for the
  // session (cleaned on navigation); a reload re-renders via /load?file=.
  const previewUrl = URL.createObjectURL(blob);
  document.execCommand('insertHTML', false, renderImageWrap(filename, w, h, previewUrl));
  editor.dispatchEvent(new Event('input'));
  showToast('✓ Image ' + originLabel);
}

// Read a Blob's natural width/height by loading it into a temporary Image.
function probeImageDimensions(blob) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(blob);
    const im = new Image();
    im.onload = () => { URL.revokeObjectURL(url); resolve({ w: im.naturalWidth || 400, h: im.naturalHeight || 300 }); };
    im.onerror = () => { URL.revokeObjectURL(url); resolve({ w: 400, h: 300 }); };
    im.src = url;
  });
}

// Upload one or more images via a native file-picker and insert them at the cursor
// - the SAME path as paste/drop (insertImageAtCursor -> uploadImageBlob -> Cloud
// Storage -> renderImageWrap). Ungated like paste, but inert in read-only (onclick
// + this guard, mirroring the ▶ video button; NOT the onmousedown table pattern
// which leaks in read-only). Multiple files insert in their chosen order.
function uploadNotesImage(boxId) {
  if (document.body && document.body.classList.contains('tt-readonly')) return;   // read-only: inert
  const selId = (typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(boxId) : boxId;
  const editor = boxId
    ? document.querySelector(`.notes-editor[data-box-id="${selId}"]`)
    : ((_lastFocusedNotesEditor && document.body.contains(_lastFocusedNotesEditor)) ? _lastFocusedNotesEditor : document.querySelector('.notes-editor'));
  const sec = SECTIONS[activeSection];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!editor || !epic) { showToast('⚠ Open a notes ' + LBL('boxNoun').toLowerCase() + ' first'); return; }

  // Capture the caret NOW - the picker dialog blurs the editor. Images land where
  // the user was typing; if the caret isn't in THIS box, we append at the end.
  let savedRange = null;
  const ws = window.getSelection();
  if (ws && ws.rangeCount) {
    const rg = ws.getRangeAt(0);
    if (editor.contains(rg.startContainer)) savedRange = rg.cloneRange();
  }

  const input = document.createElement('input');
  input.type = 'file'; input.accept = 'image/*'; input.multiple = true; input.style.display = 'none';
  const cleanup = () => { if (input.parentNode) input.remove(); };
  input.addEventListener('cancel', cleanup);   // dialog dismissed with no selection (modern browsers)
  // Fallback reaper for browsers without the file-input 'cancel' event (Safari
  // <16.4): when focus returns to the window after the dialog closes, reap the
  // hidden input if 'change' didn't already remove it. Idempotent (cleanup checks
  // parentNode), so a successful pick that already cleaned up is unaffected.
  window.addEventListener('focus', () => setTimeout(cleanup, 300), { once: true });
  input.addEventListener('change', async () => {
    const files = Array.from(input.files || []).filter(f => f.type && f.type.startsWith('image/'));
    cleanup();
    if (!files.length) return;
    // Restore focus + caret so the execCommand('insertHTML') inside insertImageAtCursor lands in the box.
    editor.focus();
    const sel = window.getSelection(); sel.removeAllRanges();
    if (savedRange && editor.contains(savedRange.startContainer)) {
      sel.addRange(savedRange);
    } else {
      const r = document.createRange(); r.selectNodeContents(editor); r.collapse(false); sel.addRange(r);
    }
    // Sequential (await) so multiple selections insert in the chosen order.
    for (const f of files) {
      await insertImageAtCursor(editor, sec, epic.id, boxId, f, f.type, 'uploaded');
    }
  });
  document.body.appendChild(input);
  input.click();
}

// Walk the live DOM of every CURRENTLY-RENDERED box in the active epic
// (optionally skipping one — used when a box is about to be deleted) and
// return the union of image filenames they reference.
function collectLiveImageRefs(excludeBoxId) {
  const refs = new Set();
  const sec = SECTIONS[activeSection];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return refs;
  for (const box of (epic.boxes || [])) {
    if (excludeBoxId && box.id === excludeBoxId) continue;
    const editor = document.querySelector(`.notes-editor[data-box-id="${box.id}"]`);
    if (!editor) continue;
    extractImageRefs(getEditorContent(editor)).forEach(r => refs.add(r));
  }
  return refs;
}

// Render a single image reference as the wrapped, resizable form.
// `displaySrc` (optional) overrides the visible src — used right after a paste
// so the just-uploaded image shows INSTANTLY from a local blob: URL instead of
// waiting on the /load?file= → service-worker → getBytes round-trip (which can
// briefly race the upload that just completed). `data-file` always stays the
// bare filename, so getEditorContent serializes the same regardless of src, and
// a later reload renders via /load?file= as usual.
function renderImageWrap(file, width, height, displaySrc) {
  const src = displaySrc || ('/load?file=' + encodeURIComponent(file));
  const dataFile = escapeHtmlForEditor(file);
  const style = (width && height) ? ` style="width:${width}px;height:${height}px"` : '';
  // The Copy button (Rishabh 2026-09-30: "ek copy image hona chahiye") is part of the wrap, so every rendered image
  // has it; the serializer reads only the <img> of a wrap, so it never reaches the saved markdown.
  return `<span class="img-wrap" contenteditable="false"${style} ondblclick="viewNotesImage(this)"><img src="${src}" alt="" data-file="${dataFile}"><button type="button" class="img-copy" onmousedown="event.preventDefault()" onclick="copyNotesImage(this)" title="Copy image" aria-label="Copy image" tabindex="-1"><svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><rect x="5.5" y="5.5" width="8" height="8" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M10.5 5.5V3.5a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2" fill="none" stroke="currentColor" stroke-width="1.4"/></svg></button><button type="button" class="img-cut" onmousedown="event.preventDefault()" onclick="cutNotesImage(this)" title="Cut image" aria-label="Cut image" tabindex="-1"><svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><circle cx="4.5" cy="11.5" r="2" fill="none" stroke="currentColor" stroke-width="1.4"/><circle cx="11.5" cy="11.5" r="2" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M6 10.2 12.5 2.5M10 10.2 3.5 2.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button><button type="button" class="img-view" onmousedown="event.preventDefault()" onclick="viewNotesImage(this)" title="View full screen" aria-label="View full screen" tabindex="-1"><svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M2.5 6V2.5H6M10 2.5h3.5V6M13.5 10v3.5H10M6 13.5H2.5V10" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button></span>`;
}

// VIEW an image full screen (Rishabh 2026-10-16: "for image we need full screen as well, not just cut copy"): the
// third control on every wrap (after Copy and Cut, the order the test relies on) and a double-click on the wrap. View
// only, like openExcalidrawFullscreen: the SHOWN pixels (currentSrc, else src) are put in a body-level overlay that
// reuses the diagram's fullscreen chrome (styles.css .excalidraw-fs-*: backdrop z 9500 above a fullscreened box, below
// the editor modal); Esc (capture, so the box-level Esc does not also fire), the ✕ or a click on the backdrop closes
// it, a click on the picture stays. Nothing is written and the wrap is untouched, so it works in read-only and in a
// table cell (a cell image is the same wrap). Fails loudly on a wrap with no picture.
function viewNotesImage(el) {
  const wrap = el && el.closest ? el.closest('.img-wrap') : null;
  const img = wrap ? wrap.querySelector('img') : null;
  if (!img) { showToast('⚠ Nothing to view'); return; }
  return openNotesImageFullscreen(img);
}
function openNotesImageFullscreen(img) {
  if (document.querySelector('.excalidraw-fs-backdrop')) return;   // one overlay at a time (the diagram's or this)
  const backdrop = document.createElement('div');
  backdrop.className = 'excalidraw-fs-backdrop img-fs-backdrop';
  backdrop.innerHTML =
    '<button class="excalidraw-fs-close" type="button" title="Exit fullscreen (Esc)">✕</button>' +
    '<div class="excalidraw-fs-stage"></div>';
  const full = document.createElement('img');
  full.src = img.currentSrc || img.src;
  full.alt = img.alt || '';
  full.className = 'img-fs-picture';
  backdrop.querySelector('.excalidraw-fs-stage').appendChild(full);
  const close = () => {
    document.removeEventListener('keydown', onKey, true);
    backdrop.remove();
  };
  const onKey = (e) => {
    if (e.key !== 'Escape') return;
    e.stopImmediatePropagation();
    e.preventDefault();
    close();
  };
  backdrop.addEventListener('click', (e) => {
    if (e.target && e.target.closest && e.target.closest('.img-fs-picture')) return;   // a click on the picture itself stays
    close();
  });
  document.addEventListener('keydown', onKey, true);
  document.body.appendChild(backdrop);
  return backdrop;
}

// Put the image on the clipboard as a PNG (the one image type every browser's clipboard takes): the shown pixels
// are read from the <img> (a blob: URL or /load?file= - whatever it displays), drawn to a canvas, written with
// the async clipboard API. Works in read-only too - copying is reading. Fails loudly, never silently.
// Cut = the same copy, then the image leaves the note (the wrap is removed, the box saves; Ctrl+Z brings it back and
// the file stays while the undo history references it). Read-only has no Cut button (styles.css) and refuses here too.
async function cutNotesImage(btn) {
  if (document.body && document.body.classList.contains('tt-readonly')) { showToast('Read-only - copy instead'); return; }
  const wrap = btn && btn.closest ? btn.closest('.img-wrap') : null;
  const editor = wrap && wrap.closest ? wrap.closest('.notes-editor') : null;
  if (!wrap || !editor) return;
  const ok = await copyNotesImage(btn, true);
  if (!ok) return;   // the copy said why; nothing is removed that is not on the clipboard
  wrap.remove();
  editor.dispatchEvent(new Event('input'));
  showToast('\u2713 Image cut');
}
async function copyNotesImage(btn, quiet) {
  const img = btn.parentElement && btn.parentElement.querySelector('img');
  if (!img) return;
  try {
    if (!(navigator.clipboard && navigator.clipboard.write && typeof ClipboardItem !== 'undefined')) throw new Error('this browser cannot copy images');
    const bmp = await createImageBitmap(await (await fetch(img.currentSrc || img.src)).blob());
    const canvas = document.createElement('canvas');
    canvas.width = bmp.width; canvas.height = bmp.height;
    canvas.getContext('2d').drawImage(bmp, 0, 0);
    const png = await new Promise((res, rej) => canvas.toBlob(b => (b ? res(b) : rej(new Error('could not encode the image'))), 'image/png'));
    await navigator.clipboard.write([new ClipboardItem({ 'image/png': png })]);
    if (!quiet) showToast('\u2713 Image copied');
    return true;
  } catch (e) {
    showToast('\u26a0 Copy failed - ' + ((e && e.message) || e));
    return false;
  }
}

// Reliable image loading — independent of the service worker.
//
// Saved notes reference images as <img src="/load?file=NAME">. On Firebase
// Hosting there is no real /load endpoint, so that <img> element load only
// resolves if sw.js happens to be controlling the page at that instant — which
// it ISN'T on a first/incognito load or just after an SW update, leaving a
// permanently-broken image (the recurring issue). The window.fetch shim in
// cloud-store.js, by contrast, ALWAYS resolves /load?file= (it calls getBytes
// directly), so here we fetch each image's bytes and swap in a local object URL.
// This makes cloud images load as reliably as the local task_viewer's direct
// file-serve. Results are cached per session so the focus/blur re-renders that
// rebuild the editor don't re-fetch (and don't flash).
const _imgObjectUrls = new Map();   // bare filename → RESOLVED object URL (alive for the session; ONLY resolved urls live here)
const _imgInFlight = new Map();     // bare filename → Promise<objectURL|null> (in-flight fetch; deduped so concurrent callers share ONE fetch)

// A MODULE-LEVEL bounded fetch pool, shared across EVERY concurrent hydrateImages
// call. It replaces the old `await`-inside-the-`for` (which cost the SUM of N round
// trips for a chapter's images instead of overlapping them). Module-level, not a
// pool-per-call, because the export paths do `Promise.all(editors.map(hydrateImages))`
// - a per-call pool would put editors×POOL /load fetches in flight at once and hammer
// Storage; a shared pool caps the WHOLE app at _HYDRATE_POOL in flight, export and
// cold-open alike.
//
// TWELVE, measured on THIS path, not copied from the shared-read precedent's 6.
// 8 images cold via /load->getBytes (localhost, real backend, 2026-09-07):
//   serial 4894ms · pool6 ~1060ms · pool12 ~715ms · pool24 665ms · unbounded ~740ms.
// The getBytes knee is ~12 (12≈24≈unbounded); 6 leaves ~35% on the table AND ran
// ~30% slower than the unbounded fetch the OLD per-box render already did - i.e. 6
// would REGRESS the many-single-image-box case. 12 matches unbounded there (no
// regression) while still bounding a pathological 100-image chapter. The precedent's
// 6 was the /ev/media relay's knee (a different per-request cost), so it does not
// transfer - "read it, don't copy it".
const _HYDRATE_POOL = 12;
let _hydrateActive = 0;
const _hydrateWaiters = [];          // FIFO resolvers parked waiting for a slot
function _acquireHydrateSlot() {
  if (_hydrateActive < _HYDRATE_POOL) { _hydrateActive++; return Promise.resolve(); }
  return new Promise((resolve) => _hydrateWaiters.push(resolve));
}
function _releaseHydrateSlot() {
  const next = _hydrateWaiters.shift();
  if (next) next();                  // hand the slot straight to the next waiter (count stays occupied)
  else _hydrateActive--;
}

// Fetch ONE image's bytes as a session-cached object URL. Deduped by `_imgInFlight`
// so two <img>s referencing the SAME file (in one call or across concurrent calls)
// share a single fetch and a single object URL - the pre-fix code checked the cache
// at the top and wrote it at the bottom with an `await` between, so N-in-flight both
// missed and both fetched, orphaning one url. Returns the url, or null when the file
// is genuinely missing (res not ok). Rejects only on a transient network throw - the
// caller then keeps the /load?file= src as a last-resort fallback (the SW may serve it).
function _fetchImageObjectUrl(file) {
  if (_imgObjectUrls.has(file)) return Promise.resolve(_imgObjectUrls.get(file));
  if (_imgInFlight.has(file)) return _imgInFlight.get(file);
  const p = (async () => {
    await _acquireHydrateSlot();
    try {
      const res = await fetch('/load?file=' + encodeURIComponent(file));
      if (!res.ok) return null;                          // genuinely missing → caller leaves the <img> as-is
      const url = URL.createObjectURL(await res.blob());
      _imgObjectUrls.set(file, url);                     // only a RESOLVED url is ever cached
      return url;
    } finally {
      _releaseHydrateSlot();
      _imgInFlight.delete(file);                         // settled (ok/missing/threw) → allow a later retry of a transient miss
    }
  })();
  _imgInFlight.set(file, p);
  return p;
}

// Resolve every <img> in `root` to a local object URL, in parallel through the shared
// pool, and RESOLVE ONLY once all of them have settled - the export paths await this
// before a canvas/print capture, so an early return would silently capture blank images.
async function hydrateImages(root) {
  if (!root || !root.querySelectorAll) return;
  const jobs = [];
  for (const img of root.querySelectorAll('img')) {
    const cur = img.getAttribute('src') || '';
    if (/^(blob:|data:)/i.test(cur)) continue;           // fresh paste or already hydrated
    if (img.closest && img.closest('[data-ev-product]')) continue;   // F-10: shared view -> hydrateSharedMedia serves via gated /ev/media; skip the own-store /load (no wasted 404-first)
    let file = (img.dataset && img.dataset.file) || '';
    if (!file) {
      const m = cur.match(/\/load\?file=([^"'&\s]+)/);
      if (m) { try { file = decodeURIComponent(m[1]); } catch (_) { file = m[1]; } }
    }
    if (!file) continue;
    if (_imgObjectUrls.has(file)) { img.src = _imgObjectUrls.get(file); continue; }   // warm cache: sync, no flash, no job
    jobs.push((async () => {
      try {
        const url = await _fetchImageObjectUrl(file);
        if (url) img.src = url;                           // else genuinely missing → leave as-is
      } catch (_) { /* transient — keep the /load?file= src as a last-resort fallback */ }
    })());
  }
  await Promise.all(jobs);                               // every image settled before we resolve (export capture depends on it)
}

// ── ⬆ Upload menu (anchored popup on each box's Upload button) ──
// Mirrors the color-pop lifecycle: a singleton popover anchored under the button,
// opened on mousedown+preventDefault so the editor keeps its caret through the pick
// (every item is mousedown+preventDefault too), closed on outside-mousedown. In
// read-only the handler early-returns so the menu never opens - the viewer's button
// is inert, not merely its downstream actions. The items delegate to the existing
// uploadNotesImage / uploadNotesPdf flows.
function _closeUploadMenu() {
  const p = document.getElementById('notesUploadMenu');
  if (p) p.classList.remove('open');
  document.removeEventListener('mousedown', _uploadMenuOutside, true);
}
function _uploadMenuOutside(ev) {
  const p = document.getElementById('notesUploadMenu');
  if (p && !p.contains(ev.target)) _closeUploadMenu();
}
function _pickUpload(e, kind, boxId) {
  if (e) e.preventDefault();
  _closeUploadMenu();
  if (kind === 'pdf') uploadNotesPdf(boxId);
  else if (kind === 'video') uploadNotesVideo(boxId);
  else uploadNotesImage(boxId);
}
function openUploadMenu(e, boxId) {
  if (e) e.preventDefault();
  if (document.body && document.body.classList.contains('tt-readonly')) return;   // read-only: inert (menu never opens)
  ensureVideoEmbedStyles();
  let pop = document.getElementById('notesUploadMenu');
  if (!pop) { pop = document.createElement('div'); pop.id = 'notesUploadMenu'; pop.className = 'notes-upload-menu'; document.body.appendChild(pop); }
  // Two-level escape: JS-string-escape (\ and ') so bid is a valid single-quoted JS
  // literal, then HTML-escape (") so it can't break out of the double-quoted attr.
  // Defense in depth - boxId is app-generated base36, never user-controlled.
  const bid = escapeHtmlForEditor(String(boxId).replace(/\\/g, '\\\\').replace(/'/g, "\\'"));
  // The Video option only appears when the viewer is allowed to upload video
  // (VIDEO_UPLOAD_MODE + per-user flag, via cloud-store.js canUploadVideo). The
  // uploadNotesVideo path re-checks, so a hidden option can never be forced.
  const canVid = !!(window.__ttCloud && window.__ttCloud.canUploadVideo && window.__ttCloud.canUploadVideo());
  pop.innerHTML =
    `<button type="button" class="nu-item" onmousedown="_pickUpload(event,'image','${bid}')" title="Upload image(s) from your device" tabindex="-1">&#128444; Image</button>`
    + `<button type="button" class="nu-item" onmousedown="_pickUpload(event,'pdf','${bid}')" title="Upload PDF(s) from your device" tabindex="-1">&#128196; PDF</button>`
    + (canVid ? `<button type="button" class="nu-item" onmousedown="_pickUpload(event,'video','${bid}')" title="Upload a video (MP4 or WebM) from your device" tabindex="-1">&#127909; Video</button>` : '');
  const btn = e.currentTarget || e.target;
  const r = btn.getBoundingClientRect();
  pop.style.left = Math.round(r.left) + 'px';
  pop.style.top = Math.round(r.bottom + 4) + 'px';
  pop.classList.add('open');
  setTimeout(() => document.addEventListener('mousedown', _uploadMenuOutside, true), 0);
}

;
// ==== FILE: js/notes/notes-media-pdf.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-media-pdf.js
// ==========================================================================

// Sidecar filename for an uploaded PDF. Mirrors imageFilename but with an __pdf_
// marker + a fixed .pdf extension (the backend MEDIA_RE routes by the .pdf suffix;
// the bytes still land in the same users/{uid}/images/ bucket path). Bails the same
// way (null when there is no notes prefix) so callers skip the upload cleanly.
function pdfFilename(sec, epicId, boxId) {
  const p = notesPrefix(sec);
  if (!p) return null;
  const stamp = Date.now();
  const rand = Math.random().toString(36).slice(2, 6);
  return `${mediaNamePrefixHook()}${p}__notes__${epicId}__${boxId}__pdf_${stamp}_${rand}.pdf`;   // MU-1: named for the book when editing another's
}

// Normalize a PDF's display name to a single safe line. The name is the user's own
// filename and it lands both in the ```pdf fence (line 2) and in extractImageRefs'
// whole-text scan, so it must lose:
//   - CR/LF + backticks: a newline could inject a bare ``` and break the fence.
//   - [ ] ( ) < >: without them a crafted name like "![x](STORAGE_NAME).pdf" or
//     '<img src="STORAGE_NAME">' can't forge a live image ref that extractImageRefs
//     would then pin forever (the referenced file would never get GC'd).
// Whitespace runs collapse; an empty result falls back so the chip is never blank.
// Idempotent, so re-serializing an already-clean name stays byte-stable.
function _pdfDisplayName(raw) {
  const s = String(raw == null ? '' : raw)
    .replace(/[`\r\n]+/g, ' ')       // fence / close-marker breakers -> space (keep word boundaries)
    .replace(/[[\]()<>]/g, '')       // md-link / html-tag chars -> strip (defeats phantom-ref injection)
    .replace(/\s+/g, ' ').trim();
  return s || 'document.pdf';
}

// Upload one PDF blob and insert it at the caret as an atomic LINK block (the same
// upload path as images: uploadImageBlob -> /saveBinary -> Cloud Storage). Reuses
// the detached-editor hardening verbatim: if the box was closed / navigated away
// during the (multi-second) upload, drop the just-uploaded orphan and warn instead
// of inserting into a dead node or lying about success; otherwise re-anchor the
// caret to THIS editor so the insert never lands wherever focus drifted. No size
// check here - the caller (uploadNotesPdf) gates on maxUploadBytes before this runs.
async function insertPdfAtCursor(editor, sec, epicId, boxId, file) {
  const filename = pdfFilename(sec, epicId, boxId);
  if (!filename) return;
  const displayName = _pdfDisplayName(file && file.name);
  try {
    await uploadImageBlob(filename, file);
  } catch (_) {
    showToast('⚠ PDF upload failed');
    return;
  }
  if (!editor || !editor.isConnected) {
    deleteImageFile(filename);
    showToast('⚠ ' + LBL('boxNoun') + ' closed - PDF not inserted');
    return;
  }
  const sel = window.getSelection();
  const caretInEditor = sel && sel.rangeCount && editor.contains(sel.getRangeAt(0).startContainer);
  if (!caretInEditor) {
    editor.focus();
    const s = window.getSelection();
    if (s) { const r = document.createRange(); r.selectNodeContents(editor); r.collapse(false); s.removeAllRanges(); s.addRange(r); }
  }
  document.execCommand('insertHTML', false, renderPdfLinkBlock(filename, displayName));
  _wirePdfControls(editor);   // wire the just-inserted block's Preview/Link/remove now; setEditorContent only runs on load/re-render, so without this a fresh chip's buttons are dead until reload. Idempotent (_pebWired) so existing blocks are never double-wired.
  editor.dispatchEvent(new Event('input'));
  showToast('✓ PDF uploaded');
}

// Upload one or more PDFs via a native file-picker and insert each at the cursor as
// an atomic link block (Preview toggle shows an inline viewer). Same shape as
// uploadNotesImage: read-only inert, caret captured before the picker blurs the
// editor, sequential inserts keep the chosen order. Each file is size-checked
// against window.__ttCloud.maxUploadBytes('pdf') (server-side storage.rules is the
// real cap; this is the fast client-side reject). No fallback if the bridge fn is
// absent - it exists post-merge (the backend routing lands in the same batch).
function uploadNotesPdf(boxId) {
  if (document.body && document.body.classList.contains('tt-readonly')) return;   // read-only: inert
  const selId = (typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(boxId) : boxId;
  const editor = boxId
    ? document.querySelector(`.notes-editor[data-box-id="${selId}"]`)
    : ((_lastFocusedNotesEditor && document.body.contains(_lastFocusedNotesEditor)) ? _lastFocusedNotesEditor : document.querySelector('.notes-editor'));
  const sec = SECTIONS[activeSection];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!editor || !epic) { showToast('⚠ Open a notes ' + LBL('boxNoun').toLowerCase() + ' first'); return; }

  // Capture the caret NOW - the picker dialog blurs the editor.
  let savedRange = null;
  const ws = window.getSelection();
  if (ws && ws.rangeCount) {
    const rg = ws.getRangeAt(0);
    if (editor.contains(rg.startContainer)) savedRange = rg.cloneRange();
  }

  const input = document.createElement('input');
  input.type = 'file'; input.accept = 'application/pdf'; input.multiple = true; input.style.display = 'none';
  const cleanup = () => { if (input.parentNode) input.remove(); };
  input.addEventListener('cancel', cleanup);
  window.addEventListener('focus', () => setTimeout(cleanup, 300), { once: true });
  input.addEventListener('change', async () => {
    const files = Array.from(input.files || []).filter(f => f.type === 'application/pdf' || /\.pdf$/i.test(f.name || ''));
    cleanup();
    if (!files.length) return;
    const cap = window.__ttCloud.maxUploadBytes('pdf');   // bytes; server also enforces via storage.rules
    editor.focus();
    const sel = window.getSelection(); sel.removeAllRanges();
    if (savedRange && editor.contains(savedRange.startContainer)) {
      sel.addRange(savedRange);
    } else {
      const r = document.createRange(); r.selectNodeContents(editor); r.collapse(false); sel.addRange(r);
    }
    // Sequential (await) so multiple selections insert in the chosen order.
    for (const f of files) {
      if (f.size > cap) { showToast('PDF too large (max ' + Math.round(cap / (1024 * 1024)) + ' MB)'); continue; }
      await insertPdfAtCursor(editor, sec, epic.id, boxId, f);
    }
  });
  document.body.appendChild(input);
  input.click();
}
// ── Inline PDF blocks (real bytes uploaded via /saveBinary; loaded back via the
// window.fetch shim -> a blob: URL, see hydratePdfFrame). Link-first, like video: the
// default form is a compact chip; a Preview toggle opens an inline viewer. The two
// forms round-trip to a ```pdf fence whose info-string records the state (```pdf open
// for the preview form) so a preview left open is RESTORED on reload. `file` is the
// storage filename (safe, app-generated); `name` is the user's filename, ESCAPED
// wherever it reaches HTML (chip text + data-name) so a hostile filename can't inject
// markup, and sanitized (via _pdfDisplayName) before it enters the fence.
function renderPdfLinkBlock(file, name) {
  const safeFile = escapeHtmlForEditor(file);
  const safeName = escapeHtmlForEditor(_pdfDisplayName(name || file));
  const safeHref = escapeHtmlForEditor('/load?file=' + encodeURIComponent(file));
  return `<div class="pdf-link-block" contenteditable="false" data-file="${safeFile}" data-name="${safeName}">`
    + `<a class="veb-link" href="${safeHref}" target="_blank" rel="noopener noreferrer">&#128196; ${safeName}</a>`
    + `<button class="veb-btn peb-topreview" type="button" title="Show an inline PDF viewer" tabindex="-1">&#9654; Preview</button>`
    + `</div>`;
}
// The expanded PREVIEW form: the PDF's pages drawn inline by pdf.js (hydratePdfFrame fills
// .peb-pages). Controls: open the full file in the browser's own viewer, collapse back to
// the link, or remove (edit-only; hidden + inert in read-only).
function renderPdfEmbedBlock(file, name) {
  const safeFile = escapeHtmlForEditor(file);
  const safeName = escapeHtmlForEditor(_pdfDisplayName(name || file));
  // Empty on purpose: the bytes are fetched by hydratePdfFrame through the window.fetch shim
  // (which ALWAYS resolves /load via getBytes, SW-independent - the same reason hydrateImages
  // exists) and the pages are drawn into .peb-pages.
  return `<div class="pdf-embed-block" contenteditable="false" data-file="${safeFile}" data-name="${safeName}">`
    + `<div class="peb-frame"><div class="peb-pages" role="document" aria-label="PDF preview"></div></div>`
    + `<div class="peb-ctrls" contenteditable="false">`
    +   `<button class="veb-btn peb-open" type="button" title="Open the full PDF (download / print / zoom) in a new tab" tabindex="-1">&#8599; Open</button>`
    +   `<button class="veb-btn peb-tolink" type="button" title="Show as a link instead" tabindex="-1">&#128279; Link</button>`
    +   `<button class="veb-btn peb-remove" type="button" title="Remove PDF" tabindex="-1">&times;</button>`
    + `</div></div>`;
}
// The PDF's bytes: fetched through the window.fetch shim (always resolves /load through
// getBytes - never a raw /load URL, which 404s / falls through to index.html when the
// service worker is not controlling the page) into a session-cached blob: URL. Shared by
// the inline pages, the Preview toggle and the open-in-a-tab link.
const _pdfObjectUrls = new Map();   // storage filename -> object URL (alive for the session)

// ── Inline pages, drawn by pdf.js (vendored at /vendor/pdfjs-<ver>/, Apache-2.0; no CDN at
// runtime, cached by the SW like every same-origin file). The preview used to be an <iframe>
// on the blob URL, i.e. the browser's OWN PDF viewer - which iOS WebKit does not have: an iPad
// (Safari and Chrome alike) drew a "PDF / Open" card and never a page (Rishabh 2026-10-17).
// ONE path for every platform: each page is a canvas fitted to the frame's width, rendered
// only while it is near the viewport and released when it scrolls far away, so a long PDF
// costs a few pages of memory, not all of them. The Open button still hands the full file to
// the browser's viewer (toolbar, download, print, zoom) in a new tab.
const PDFJS_DIR = '/vendor/pdfjs-6.4.299/';
const PEB_PAD = 10;                 // px around the page stack inside .peb-pages (matches its CSS padding)
const PEB_MAX_DPR = 2;              // a 3x phone screen renders at 2x: crisp enough, half the pixels
let _pdfjsLoad = null;              // the library module, imported once per session on the first preview
function _pdfjs() {
  if (!_pdfjsLoad) _pdfjsLoad = import(PDFJS_DIR + 'pdf.min.mjs').then((lib) => { lib.GlobalWorkerOptions.workerSrc = PDFJS_DIR + 'pdf.worker.min.mjs'; return lib; });
  return _pdfjsLoad;
}
const _pdfDocs = new Map();         // blob url -> Promise<PDFDocumentProxy>: one parse per file per session
function _pdfDoc(url) {
  if (!_pdfDocs.has(url)) _pdfDocs.set(url, _pdfjs().then((lib) => lib.getDocument({ url }).promise));
  return _pdfDocs.get(url);
}
// Lay the document's pages into `pages` (the scrolling .peb-pages) and keep them drawn while visible.
function _pdfLayoutPages(pages, doc) {
  let base = null;                                  // page 1 at scale 1: the placeholder size until a page has been read
  const visible = new Set();
  const frameWidth = () => Math.max(120, pages.clientWidth - 2 * PEB_PAD);
  const sizeHolder = (holder, vp) => { const w = frameWidth(), s = w / vp.width; holder.style.width = w + 'px'; holder.style.height = Math.round(vp.height * s) + 'px'; return s; };
  const release = (holder) => {                     // far from the viewport: drop the pixels, keep the box
    if (holder._pebTask) { holder._pebTask.cancel(); holder._pebTask = null; }
    const c = holder.firstChild; if (c) { c.width = 0; c.height = 0; }
    holder.dataset.rendered = '';
  };
  const render = async (holder) => {
    const page = holder._pebPage || (holder._pebPage = await doc.getPage(Number(holder.dataset.page)));
    const s = sizeHolder(holder, page.getViewport({ scale: 1 }));
    const vp = page.getViewport({ scale: s * Math.min(window.devicePixelRatio || 1, PEB_MAX_DPR) });
    const canvas = holder.firstChild;
    if (holder._pebTask) holder._pebTask.cancel();
    canvas.width = Math.round(vp.width); canvas.height = Math.round(vp.height);
    const task = page.render({ canvasContext: canvas.getContext('2d'), viewport: vp });
    holder._pebTask = task;
    try { await task.promise; holder.dataset.rendered = '1'; }
    catch (e) { if (!(e && e.name === 'RenderingCancelledException')) throw e; }
    finally { if (holder._pebTask === task) holder._pebTask = null; }
  };
  const draw = (holder) => render(holder).catch((e) => console.error('[pdf] page ' + holder.dataset.page + ' did not render', e));
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => { const h = en.target; if (en.isIntersecting) { visible.add(h); if (!h.dataset.rendered) draw(h); } else { visible.delete(h); release(h); } });
  }, { root: pages, rootMargin: '150% 0px' });
  doc.getPage(1).then((p) => {
    base = p.getViewport({ scale: 1 });
    for (let i = 1; i <= doc.numPages; i++) {
      const holder = document.createElement('div'); holder.className = 'peb-page'; holder.dataset.page = String(i);
      holder.appendChild(document.createElement('canvas'));
      sizeHolder(holder, base);
      pages.appendChild(holder); io.observe(holder);
    }
  }).catch((e) => { pages.innerHTML = `<div class="peb-status">PDF could not be read</div>`; console.error('[pdf] first page failed', e); });
  // A frame width change (window resize, the editor's layout) re-fits the pages on screen; the rest re-fit as they scroll in.
  let lastW = frameWidth();
  new ResizeObserver(() => {
    const w = frameWidth(); if (!base || Math.abs(w - lastW) < 2) return; lastW = w;
    pages.querySelectorAll('.peb-page').forEach((h) => { if (visible.has(h)) draw(h); else { h.dataset.rendered = ''; sizeHolder(h, h._pebPage ? h._pebPage.getViewport({ scale: 1 }) : base); } });
  }).observe(pages);
}
// The gated shared-product id for a media block: shared-read.js stamps data-ev-product on
// the shared editor, so any PDF block inside it resolves its bytes through the entitlement-
// gated relay. null in the author's OWN edit view -> the fetch falls back to the /load shim.
function _evProductOf(el) {
  const host = el && el.closest && el.closest('[data-ev-product]');
  return (host && host.dataset && host.dataset.evProduct) || null;
}
// Fetch a PDF's bytes and return a session-cached blob: object URL, or null if the file is
// genuinely missing. In the author's own store the bytes come via the /load shim (SW-
// independent - always resolves through getBytes). In a SHARED view (productId set) the
// bytes live in the CREATOR's store, reachable only through the entitlement-gated /ev/media
// relay with the viewer's Bearer token (own-store /load 404s for a recipient). Shared by the
// inline preview, the Preview toggle, and the open-in-a-tab link.
async function _pdfBlobUrl(file, productId) {
  if (!file) return null;
  const key = (productId ? productId + ' ' : '') + file;   // never collide own-store vs gated for the same name
  if (_pdfObjectUrls.has(key)) return _pdfObjectUrls.get(key);
  try {
    let res;
    if (productId) {
      const cloud = (typeof window !== 'undefined') && window.__ttCloud;
      if (!cloud) return null;
      const token = await cloud.idToken();
      res = await fetch((cloud.mcpBase || '') + '/ev/media?productId=' + encodeURIComponent(productId) + '&file=' + encodeURIComponent(file),
        { headers: { authorization: 'Bearer ' + token } });
    } else {
      res = await fetch('/load?file=' + encodeURIComponent(file));
    }
    if (!res.ok) return null;
    // Force application/pdf so it previews inline: the gated relay may report octet-stream
    // (emulator); /load already returns application/pdf, so re-typing is a no-op there.
    const url = URL.createObjectURL(new Blob([await res.blob()], { type: 'application/pdf' }));
    _pdfObjectUrls.set(key, url);
    return url;
  } catch (_) { return null; }
}
// Fill a preview block's .peb-pages with the document's pages. Idempotent: a block that is
// loading or drawn is left alone (the parser calls this for every open block on load and the
// toggle calls it for the block it just swapped in).
async function hydratePdfFrame(block) {
  if (!block || !block.querySelector) return;
  const pages = block.querySelector('.peb-pages');
  if (!pages || pages.dataset.pebState) return;
  pages.dataset.pebState = 'loading';
  const status = (msg) => { pages.innerHTML = `<div class="peb-status">${escapeHtmlForEditor(msg)}</div>`; };
  status('Loading PDF...');
  const file = (block.dataset && block.dataset.file) || '';
  const url = await _pdfBlobUrl(file, _evProductOf(block));
  if (!url) { pages.dataset.pebState = 'error'; status('PDF not found'); return; }
  let doc;
  try { doc = await _pdfDoc(url); }
  catch (e) { pages.dataset.pebState = 'error'; status('PDF could not be read'); console.error('[pdf] ' + file + ' did not load', e); return; }
  pages.innerHTML = '';
  pages.dataset.pebState = 'ready';
  _pdfLayoutPages(pages, doc);
}
// Open the FULL PDF (the browser's own viewer: toolbar, download, print, zoom) in a
// new tab. The inline preview deliberately hides that chrome, so this is where those
// controls live. Open a blank tab SYNCHRONOUSLY (keeps the click's user gesture so it
// is not popup-blocked), then point it at the SW-independent blob: URL - no view hash,
// so the tab shows the full viewer. Fixes the old raw <a href="/load"> that 404s when
// the SW is not controlling the page.
function _openPdfInTab(file, productId) {
  if (!file) return;
  const w = window.open('', '_blank');
  _pdfBlobUrl(file, productId).then(url => {
    if (url && w) w.location = url;
    else { if (w) w.close(); showToast('⚠ Could not open PDF'); }
  });
}
// Wire a PDF block's link<->preview toggle + remove. Factored (not inlined like the
// video wiring) because the toggle swaps the block IN PLACE instead of re-rendering
// the whole editor via setEditorContent - a full re-render would rebuild every block
// and disrupt the caret. (A UX/perf choice, not a correctness requirement: an opened
// preview now persists as a ```pdf open fence and is restored on reload regardless.)
// Each toggle swaps the block and re-wires only the swapped-in node. In read-only the
// toggle is transient (no input dispatched) and remove is inert.
function _wirePdfControls(editor, root) {
  (root || editor).querySelectorAll('.peb-topreview, .peb-tolink, .peb-remove, .peb-open').forEach(btn => {
    if (btn._pebWired) return; btn._pebWired = true;
    btn.addEventListener('mousedown', (e) => {
      e.preventDefault(); e.stopPropagation();
      const ro = !!(document.body && document.body.classList.contains('tt-readonly'));
      if (btn.classList.contains('peb-open')) {                        // open full PDF in a new tab (allowed in read-only too)
        const block = btn.closest('.pdf-embed-block');
        _openPdfInTab(block && block.dataset.file, _evProductOf(block));
        return;
      }
      if (btn.classList.contains('peb-remove')) {                      // remove (edit only)
        if (ro) return;
        const block = btn.closest('.pdf-embed-block');
        if (block) { block.remove(); editor.dispatchEvent(new Event('input')); }
        return;
      }
      const toLink = btn.classList.contains('peb-tolink');             // preview -> link, else link -> preview
      const block = btn.closest(toLink ? '.pdf-embed-block' : '.pdf-link-block');
      if (!block || !block.dataset.file) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = toLink
        ? renderPdfLinkBlock(block.dataset.file, block.dataset.name)
        : renderPdfEmbedBlock(block.dataset.file, block.dataset.name);
      const fresh = tmp.firstChild;
      block.replaceWith(fresh);
      _wirePdfControls(editor, fresh);                                 // rebind the swapped-in block
      if (!toLink) hydratePdfFrame(fresh);                             // draw the pages (bytes via the fetch shim, SW-independent)
      if (!ro) editor.dispatchEvent(new Event('input'));
    });
  });
  // The link-form filename opens the FULL PDF (with the viewer's toolbar / download)
  // in a new tab. A raw <a href="/load"> navigation 404s when the SW isn't
  // controlling the page (same root cause as the iframe), so intercept: open a blank
  // tab synchronously (preserves the user gesture so it isn't popup-blocked), then
  // point it at the SW-independent blob: URL once the bytes arrive.
  (root || editor).querySelectorAll('.pdf-link-block .veb-link').forEach(a => {
    if (a._pebWired) return; a._pebWired = true;
    const openInTab = (e) => {
      // 'click' covers left-click + ctrl/cmd-click; 'auxclick' covers middle-click
      // (which fires auxclick, NOT click - its native "open in new tab" would hit
      // /load and 404 when the SW isn't controlling the page). Only act on the
      // middle button for auxclick so right-click / the context menu stay intact.
      if (e.type === 'auxclick' && e.button !== 1) return;
      e.preventDefault();
      const block = a.closest('.pdf-link-block');
      _openPdfInTab(block && block.dataset.file, _evProductOf(block));
    };
    a.addEventListener('click', openInTab);
    a.addEventListener('auxclick', openInTab);
  });
}

;
// ==== FILE: js/notes/notes-media-video.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-media-video.js
// ==========================================================================

// Sidecar filename for an uploaded video. Mirrors pdfFilename with a __vid_ marker
// and the source container's extension (mp4/webm) so the backend VIDEO_RE routes it
// to the authed-Range stream (sw.js serveVideo) and mediaContentType picks the right
// video/* type. Bails (null) when there is no notes prefix, like the others.
function videoFilename(sec, epicId, boxId, ext) {
  const p = notesPrefix(sec);
  if (!p) return null;
  const stamp = Date.now();
  const rand = Math.random().toString(36).slice(2, 6);
  const safeExt = /^(mp4|webm)$/i.test(ext) ? String(ext).toLowerCase() : 'mp4';
  return `${mediaNamePrefixHook()}${p}__notes__${epicId}__${boxId}__vid_${stamp}_${rand}.${safeExt}`;   // MU-1: named for the book when editing another's
}

// Normalize an uploaded video's display name (same rules + rationale as
// _pdfDisplayName: kill fence/close-marker breakers + md-link/html-tag chars so a
// crafted name can't forge a phantom media ref). Idempotent -> byte-stable.
function _videoDisplayName(raw) {
  const s = String(raw == null ? '' : raw)
    .replace(/[`\r\n]+/g, ' ')
    .replace(/[[\]()<>]/g, '')
    .replace(/\s+/g, ' ').trim();
  return s || 'video.mp4';
}

// Active video uploads, keyed by the placeholder's upId -> WHERE the video is going.
// The in-box "Uploading..." placeholder vanishes when the user switches chapter/tab
// (its editor is torn down). Instead of a separate corner badge (inconsistent - the
// feedback appeared to "jump" from the box to a corner), renderNotesBoxes RE-INSERTS
// the same placeholder when the user returns to the box mid-upload, so the feedback
// stays consistently in the box. Cleared when the upload settles.
const _activeVideoUploads = new Map();                     // upId -> { name, epicId, boxId }
function _startVideoUpload(upId, name, epicId, boxId) { _activeVideoUploads.set(upId, { name, epicId, boxId }); }
function _endVideoUpload(upId) { _activeVideoUploads.delete(upId); }
// Re-insert any in-flight upload placeholders for a freshly-rendered box, so the
// "Uploading..." feedback reappears in-box when the user returns mid-upload.
function restoreUploadPlaceholders(editor, epicId, boxId) {
  if (!editor) return;
  _activeVideoUploads.forEach((u, upId) => {
    if (u.epicId !== epicId || u.boxId !== boxId) return;
    if (editor.querySelector('.vfb-uploading[data-uploading="' + upId + '"]')) return;   // already present
    const tmp = document.createElement('div');
    tmp.innerHTML = renderVideoUploadingBlock(u.name, upId);
    editor.appendChild(tmp.firstChild);
    ensureEditableEdges(editor);
  });
}

// Upload one video file and insert its player block at the caret. Mirrors
// insertPdfAtCursor: upload via /saveBinary, harden against a box closed mid-upload
// (delete the orphan + toast), insert the block, wire + hydrate it. The block renders
// with NO src; hydrateVideoFile points <video> at /load?file= so the SW streams it
// with Range (sw.js serveVideo) once it is controlling the page.
async function insertVideoFileAtCursor(editor, sec, epicId, boxId, file, ext) {
  const filename = videoFilename(sec, epicId, boxId, ext);
  if (!filename) return;
  const displayName = _videoDisplayName(file && file.name);
  // Re-anchor the caret into THIS editor, then drop an "uploading" placeholder at it
  // BEFORE the (slow, up to 150 MB) upload so the box shows progress immediately
  // instead of looking frozen. The placeholder has no data-file -> never serializes.
  const sel = window.getSelection();
  const caretInEditor = sel && sel.rangeCount && editor.contains(sel.getRangeAt(0).startContainer);
  if (!caretInEditor) {
    editor.focus();
    const s = window.getSelection();
    if (s) { const r = document.createRange(); r.selectNodeContents(editor); r.collapse(false); s.removeAllRanges(); s.addRange(r); }
  }
  const upId = 'up_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  document.execCommand('insertHTML', false, renderVideoUploadingBlock(displayName, upId));

  // Track the upload so its placeholder can be RESTORED in-box if the user leaves and
  // returns mid-upload (renderNotesBoxes -> restoreUploadPlaceholders). Consistent feedback.
  _startVideoUpload(upId, displayName, epicId, boxId);
  let ok = false;
  try { await uploadImageBlob(filename, file); ok = true; } catch (_) { /* handled below */ }
  _endVideoUpload(upId);

  // Find the placeholder ANYWHERE on screen by its upId - it may be in the original
  // editor (still on the box) OR one re-inserted into a freshly-rendered editor after a
  // tab switch. document-wide so both cases resolve to the same swap.
  const ph = document.querySelector('.vfb-uploading[data-uploading="' + upId + '"]');

  if (!ok) {                                   // upload failed: drop the placeholder (nothing stored, no orphan)
    if (ph) ph.remove();
    showToast('⚠ Video upload failed');
    return;
  }

  // Upload SUCCEEDED. OQ1 (background upload): the video LANDS wherever the user is - it
  // is never silently discarded. If the placeholder is on screen, swap it in place.
  if (ph && ph.isConnected) {
    const host = ph.closest('.notes-editor') || editor;
    const tmp = document.createElement('div');
    tmp.innerHTML = renderVideoFileBlock(filename, displayName);
    const block = tmp.firstChild;
    ph.replaceWith(block);                        // swap the placeholder for the real player
    _wireVideoFileControls(host, block);
    hydrateVideoFile(block);                       // points the <video> at /load (SW streams it)
    ensureEditableEdges(host);                     // a caret spot after the (atomic) video, so typing still works
    // Park the caret in the editable line right after the block: keeps sequential
    // multi-file inserts in order AND lets the user type right after the video.
    try {
      const after = block.nextElementSibling;
      const s2 = window.getSelection(); const r2 = document.createRange();
      if (after) r2.setStart(after, 0); else r2.setStartAfter(block);
      r2.collapse(true); s2.removeAllRanges(); s2.addRange(r2);
    } catch (_) {}
    host.dispatchEvent(new Event('input'));
    showToast('✓ Video uploaded');
    return;
  }

  // No placeholder on screen (user is on a different chapter/section). Persist the ref
  // into the box's saved content so it renders on the box's next load. Reclaim the
  // orphan only if the box was deleted while away.
  const epicNow = (sec.notesEpics || []).find(n => n.id === epicId);
  const boxStillExists = epicNow && (epicNow.boxes || []).some(b => b.id === boxId);
  if (!boxStillExists) {
    deleteImageFile(filename);
    showToast('⚠ ' + LBL('boxNoun') + ' deleted - video discarded');
    return;
  }
  const saved = await loadNotesContent(sec, epicId, boxId);
  const fence = '```videofile\n' + filename + '\n' + displayName + '\n```\n';
  const merged = (saved && saved.trim()) ? (saved.replace(/\n+$/, '') + '\n\n' + fence) : fence;
  await saveNotesContent(sec, epicId, boxId, merged, true);
  showToast('✓ Video uploaded (added to the ' + LBL('boxNoun').toLowerCase() + ')');
}

// uploadNotesPdf's video sibling. GATED (window.__ttCloud.canUploadVideo, config-
// driven) AND read-only inert. Accepts mp4/webm containers (client format-guard;
// codec can't be verified pre-upload, so an unsupported-codec file uploads but may
// not play - we make no false promise). Size-checked against maxUploadBytes('video');
// storage.rules is the real cap. Sequential inserts keep the chosen order.
function uploadNotesVideo(boxId) {
  if (document.body && document.body.classList.contains('tt-readonly')) return;   // read-only: inert
  if (!(window.__ttCloud && window.__ttCloud.canUploadVideo && window.__ttCloud.canUploadVideo())) {
    showToast('⚠ Video upload is not enabled for your account');
    return;
  }
  const selId = (typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(boxId) : boxId;
  const editor = boxId
    ? document.querySelector(`.notes-editor[data-box-id="${selId}"]`)
    : ((_lastFocusedNotesEditor && document.body.contains(_lastFocusedNotesEditor)) ? _lastFocusedNotesEditor : document.querySelector('.notes-editor'));
  const sec = SECTIONS[activeSection];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!editor || !epic) { showToast('⚠ Open a notes ' + LBL('boxNoun').toLowerCase() + ' first'); return; }

  // Capture the caret NOW - the picker dialog blurs the editor.
  let savedRange = null;
  const ws = window.getSelection();
  if (ws && ws.rangeCount) {
    const rg = ws.getRangeAt(0);
    if (editor.contains(rg.startContainer)) savedRange = rg.cloneRange();
  }

  const input = document.createElement('input');
  input.type = 'file'; input.accept = 'video/mp4,video/webm'; input.multiple = true; input.style.display = 'none';
  const cleanup = () => { if (input.parentNode) input.remove(); };
  input.addEventListener('cancel', cleanup);
  window.addEventListener('focus', () => setTimeout(cleanup, 300), { once: true });
  input.addEventListener('change', async () => {
    const picked = Array.from(input.files || []);
    cleanup();
    if (!picked.length) return;
    const cap = window.__ttCloud.maxUploadBytes('video');   // bytes; server also enforces via storage.rules
    editor.focus();
    const sel = window.getSelection(); sel.removeAllRanges();
    if (savedRange && editor.contains(savedRange.startContainer)) sel.addRange(savedRange);
    else { const r = document.createRange(); r.selectNodeContents(editor); r.collapse(false); sel.addRange(r); }
    // Sequential (await) so multiple selections insert in the chosen order.
    for (const f of picked) {
      const ext = (/\.webm$/i.test(f.name || '') || f.type === 'video/webm') ? 'webm'
                : (/\.mp4$/i.test(f.name || '') || f.type === 'video/mp4') ? 'mp4' : null;
      if (!ext) { showToast('Only MP4 or WebM video is supported'); continue; }
      if (f.size > cap) { showToast('Video too large (max ' + Math.round(cap / (1024 * 1024)) + ' MB)'); continue; }
      await insertVideoFileAtCursor(editor, sec, epic.id, boxId, f, ext);
    }
  });
  document.body.appendChild(input);
  input.click();
}

// ── Inline video embeds (link-only; the app stores the URL, never any bytes) ──
// A line whose ENTIRE text is a public video URL renders as an atomic, playable
// embed. Persistence is the bare URL on its own line (like ![](file) for images):
// getEditorContent serializes a .video-embed-block back to that URL and
// setEditorContent re-detects it. parseVideoEmbed is STRICT and re-run at render
// time (notes reload from raw .md, so validation cannot live only in the toolbar):
// https-only, EXACT host match (never substring, so "youtube.com.evil.com" is
// rejected), and the embed src is REBUILT from the regex-extracted id - a raw or
// hostile user URL is never placed into an iframe/video src.
function parseVideoEmbed(raw) {
  let u;
  try { u = new URL(String(raw).trim()); } catch (_) { return null; }
  if (u.protocol !== 'https:') return null;                       // https-only
  const host = u.hostname.replace(/^www\./, '').replace(/^m\./, '');
  const ytStart = () => {
    const t = u.searchParams.get('t') || u.searchParams.get('start');
    const s = t ? (parseInt(t, 10) || 0) : 0;
    return s > 0 ? ('?start=' + s) : '';
  };
  if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    let id = u.searchParams.get('v');
    if (!id) { const m = u.pathname.match(/^\/(?:embed|shorts|v)\/([A-Za-z0-9_-]{11})(?:[/?]|$)/); if (m) id = m[1]; }
    if (!id || !/^[A-Za-z0-9_-]{11}$/.test(id)) return null;
    return { type: 'iframe', embedSrc: 'https://www.youtube-nocookie.com/embed/' + id + ytStart() };
  }
  if (host === 'youtu.be') {
    const id = u.pathname.slice(1).split('/')[0];
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return null;
    return { type: 'iframe', embedSrc: 'https://www.youtube-nocookie.com/embed/' + id + ytStart() };
  }
  if (host === 'drive.google.com') {
    let id = null;
    const m = u.pathname.match(/^\/file\/d\/([A-Za-z0-9_-]+)/); if (m) id = m[1];
    if (!id) id = u.searchParams.get('id');
    if (!id || !/^[A-Za-z0-9_-]+$/.test(id)) return null;
    return { type: 'iframe', embedSrc: 'https://drive.google.com/file/d/' + id + '/preview' };
  }
  if (host === 'instagram.com') {
    // Public post / reel / IGTV -> Instagram's official self-contained embed iframe.
    // Portrait (not 16:9), so the block gets a taller frame. Only public posts embed.
    const m = u.pathname.match(/^\/(p|reel|reels|tv)\/([A-Za-z0-9_-]+)/);
    if (!m) return null;
    const kind = (m[1] === 'reels') ? 'reel' : m[1];
    return { type: 'iframe', portrait: true, embedSrc: 'https://www.instagram.com/' + kind + '/' + m[2] + '/embed' };
  }
  if (/\.(mp4|webm|ogg)$/i.test(u.pathname)) {              // direct media file (played locally)
    return { type: 'video', embedSrc: u.href };
  }
  return null;
}
// Build the atomic player block for an already-validated video URL. `url` is the
// canonical bare URL kept in data-url (this is what round-trips to the .md line);
// `parsed` is the strict parse result (embed src rebuilt from the id). The iframe
// is sandboxed (defense in depth, since there is no CSP backstop). Both attribute
// values are escaped so `&`/`"` in a URL cannot truncate the attribute.
function renderVideoEmbedBlock(url, parsed, size) {
  const safeUrl = escapeHtmlForEditor(url);
  const safeSrc = escapeHtmlForEditor(parsed.embedSrc);
  const sz = (size === 's' || size === 'l') ? size : 'm';   // M is the default width
  const cls = 'video-embed-block'
    + (parsed.portrait ? ' veb-portrait' : '')              // Instagram etc. -> taller frame
    + (sz === 's' ? ' veb-s' : (sz === 'l' ? ' veb-l' : ''));
  // allow-popups-to-escape-sandbox: a link opened from INSIDE the embed (YouTube
  // title / "Watch on YouTube", IG "Watch on Instagram") opens a popup that would
  // otherwise INHERIT this sandbox — a sandboxed cross-origin top-level nav that
  // Chrome blocks (ERR_BLOCKED_BY_RESPONSE / chrome-error page). The flag lets ONLY
  // the popup run unsandboxed so it lands on the real youtube.com/instagram.com; the
  // embed itself stays sandboxed. (Not allow-top-navigation* — unneeded + less safe.)
  // scrolling="no" on IG only (OQ9): the frame is sized to IG's exact MEASURE height, but
  // a sub-pixel rounding still leaves IG's embed page 1px scrollable -> a stray inner
  // scrollbar ("poora fit but scrollbar still visible"). Suppress it. IG-only so a
  // scrollable Drive/doc preview keeps its scrollbar.
  const noScroll = parsed.portrait ? ' scrolling="no"' : '';
  const media = (parsed.type === 'iframe')
    ? `<iframe src="${safeSrc}" loading="lazy" referrerpolicy="strict-origin-when-cross-origin" allow="fullscreen" allowfullscreen${noScroll} sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"></iframe>`
    : `<video src="${safeSrc}" controls preload="none" playsinline></video>`;
  const szb = (v, label) => `<button class="veb-szb${v === sz ? ' veb-sz-on' : ''}" type="button" data-sz="${v}" title="${label} size" tabindex="-1">${v.toUpperCase()}</button>`;
  return `<div class="${cls}" contenteditable="false" data-url="${safeUrl}">`
    + `<div class="veb-frame">${media}</div>`
    + `<div class="veb-ctrls" contenteditable="false">`
    +   `<span class="veb-size">${szb('s', 'Small')}${szb('m', 'Medium')}${szb('l', 'Large')}</span>`
    +   `<button class="veb-btn veb-tolink" type="button" title="Show as a link instead" tabindex="-1">&#128279; Link</button>`
    +   `<button class="veb-btn veb-remove" type="button" title="Remove video" tabindex="-1">&times;</button>`
    + `</div></div>`;
}
// The compact LINK form of a video - the default when a bare video URL is present.
// A clickable link plus a "Preview" button that swaps it to the inline player.
// Atomic (contenteditable=false) so its button never serializes; getEditorContent
// emits just the bare URL on its own line, so the link form round-trips as a plain
// URL (and a plain video URL renders back as this link form).
function renderVideoLinkBlock(url) {
  const safeUrl = escapeHtmlForEditor(url);
  return `<div class="video-link-block" contenteditable="false" data-url="${safeUrl}">`
    + `<a class="veb-link" href="${safeUrl}" target="_blank" rel="noopener noreferrer">&#127909; ${safeUrl}</a>`
    + `<button class="veb-btn veb-topreview" type="button" title="Show an inline player" tabindex="-1">&#9654; Preview</button>`
    + `</div>`;
}
// Uploaded-video block: a native <video controls> streamed by the SW (sw.js
// serveVideo). Rendered with NO src (like the PDF iframe) - a raw src="/load"
// depends on the SW controlling the page; hydrateVideoFile sets it once the SW is
// ready. preload="metadata" so only headers load until the user hits play. Storage
// file + display name live in data-* and round-trip to a ```videofile fence.
function renderVideoFileBlock(file, name) {
  const safeFile = escapeHtmlForEditor(file);
  const safeName = escapeHtmlForEditor(_videoDisplayName(name || file));
  return `<div class="video-file-block" contenteditable="false" data-file="${safeFile}" data-name="${safeName}" title="${safeName}">`
    + `<div class="vfb-frame"><video class="vfb-video" controls preload="metadata" playsinline></video>`
    +   `<div class="vfb-ctrls" contenteditable="false"><button class="veb-btn vfb-remove" type="button" title="Remove video" tabindex="-1">&times;</button></div>`
    + `</div></div>`;
}
// Transient "uploading" placeholder shown while a (potentially large) video uploads,
// so the box does not look frozen. It is a .video-file-block (so the atomic-block
// guards apply) but carries NO data-file, which means getEditorContent emits NOTHING
// for it - it never serializes to the note. data-uploading is a unique handle so the
// upload can find + swap exactly this node for the real player on success.
function renderVideoUploadingBlock(name, upId) {
  const safeName = escapeHtmlForEditor(_videoDisplayName(name));
  return `<div class="video-file-block vfb-uploading" contenteditable="false" data-uploading="${escapeHtmlForEditor(upId)}">`
    + `<div class="vfb-loading"><span class="vfb-spinner" aria-hidden="true"></span><span>Uploading ${safeName}...</span></div>`
    + `</div>`;
}
// Point a video-file block's <video> at the SW-served /load URL (the SW streams it
// with Range - that is the whole point of Option D, so unlike images/PDFs this is
// SW-dependent by design). Wait for the SW to be ready so a first load / SW update
// does not race the element load. Idempotent (skips an already-src'd video).
function hydrateVideoFile(block) {
  if (!block || !block.querySelector) return;
  const video = block.querySelector('video.vfb-video');
  if (!video) return;
  if (video.getAttribute('src')) return;   // already hydrated
  const file = (block.dataset && block.dataset.file) || '';
  if (!file) return;
  if (block.closest && block.closest('[data-ev-product]')) return;   // F-10: in a shared view hydrateSharedVideo serves this via the gated /ev-load; skip the own-store /load (no wasted 404-first)
  video.addEventListener('loadedmetadata', () => { try { if (video.paused && !video.currentTime) video.currentTime = 0.05; } catch (_) {} }, { once: true });   // poster: nudge to the first frame so the video shows a frame at rest, not a black box
  const set = () => { video.src = '/load?file=' + encodeURIComponent(file); };
  // Diagnostic (once per element): surface WHY a video won't play. The usual cause is
  // the page not being SW-controlled, so /load misses the SW and the element errors.
  if (!video._ttErrLogged) {
    video._ttErrLogged = true;
    video.addEventListener('error', () => {
      const c = video.error && video.error.code;
      const ctl = !!(typeof navigator !== 'undefined' && navigator.serviceWorker && navigator.serviceWorker.controller);
      console.warn('[tt-video] <video> error code=' + c + ' file=' + file + ' controller=' + ctl);
    });
  }
  const sw = (typeof navigator !== 'undefined') && navigator.serviceWorker;
  // The <video> is streamed by the SW. Point it at /load ONLY once the SW CONTROLS
  // this page - otherwise the request hits the network, falls through to index.html,
  // and the element errors (MEDIA_ERR_SRC_NOT_SUPPORTED). If it isn't controlling yet
  // (first load, before clients.claim), the 'controllerchange' handler below sets the
  // src when control arrives. (No SW at all -> set directly, e.g. in tests.)
  if (!sw) { set(); return; }
  if (sw.controller) set();
  else console.warn('[tt-video] hydrate ' + file + ': no SW controller yet -> deferring to controllerchange');
}
// A fresh / incognito load can point a video at /load BEFORE the SW is controlling
// the page (that fetch then misses the SW -> blank player). When the SW takes
// control, re-point any still-blank / errored video block so playback goes through
// it. Videos that already loaded (readyState > 0, no error) are left undisturbed.
if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    const vids = document.querySelectorAll('.video-file-block[data-file] video.vfb-video');
    vids.forEach((v) => {
      if (v.readyState > 0 && !v.error) return;
      const block = v.closest('.video-file-block');
      const file = block && block.dataset && block.dataset.file;
      if (file) { v.src = '/load?file=' + encodeURIComponent(file); v.load(); }
    });
  });
}
// OQ9 — fit Instagram embeds so there is NO inner vertical scrollbar. IG's official
// /embed page posts its exact rendered height to the parent ({type:'MEASURE',
// details:{height}}) on load AND whenever its width changes. A fixed CSS aspect-ratio
// can't fit it: IG caps the media at 4:5 but adds a FIXED 189px of chrome (header +
// action bar + likes), so the natural aspect drifts with width (S/M/L presets, narrow
// 2-column boxes). We size the frame to IG's reported height instead — exact at any
// width, and self-correcting on an S/M/L resize (IG re-measures). Origin-locked to
// instagram.com; height sanity-bounded. Explicit height overrides the CSS aspect-ratio.
if (typeof window !== 'undefined' && !window.__vebIgMeasureWired) {
  window.__vebIgMeasureWired = true;
  window.addEventListener('message', (e) => {
    if (e.origin !== 'https://www.instagram.com') return;
    let d = e.data;
    if (typeof d === 'string') { try { d = JSON.parse(d); } catch (_) { return; } }
    if (!d || d.type !== 'MEASURE' || !d.details || typeof d.details.height !== 'number') return;
    const h = d.details.height;
    if (!(h > 0) || h > 4000) return;                     // sane bound (IG reels ~560-900px)
    document.querySelectorAll('.video-embed-block iframe').forEach((ifr) => {
      if (ifr.contentWindow !== e.source) return;         // match the exact embed that measured
      const frame = ifr.closest('.veb-frame');
      if (frame) frame.style.height = h + 'px';
    });
  });
}
// Wire a video-file block's remove button (edit-only; hidden + inert in read-only).
// mousedown (keeps the editor selection) + read-only guard, idempotent via _vfbWired.
function _wireVideoFileControls(editor, root) {
  (root || editor).querySelectorAll('.vfb-remove').forEach(btn => {
    if (btn._vfbWired) return; btn._vfbWired = true;
    btn.addEventListener('mousedown', (e) => {
      e.preventDefault(); e.stopPropagation();
      if (document.body && document.body.classList.contains('tt-readonly')) return;
      const block = btn.closest('.video-file-block');
      if (block) { block.remove(); editor.dispatchEvent(new Event('input')); }
    });
  });
}
let _vebStylesDone = false;
function ensureVideoEmbedStyles() {
  if (_vebStylesDone) return; _vebStylesDone = true;
  const css =
    '.video-embed-block{position:relative;margin:.5rem 0;max-width:640px}' +
    // border + soft shadow (OQ9): an Instagram embed's page is WHITE, so on the light
    // tracker background its edges vanished ("blend ho raha hai"). A 1px line + subtle
    // shadow delineate the player. Harmless on YouTube/Drive (dark video) too.
    '.veb-frame{position:relative;width:100%;aspect-ratio:16/9;background:#000;border-radius:8px;overflow:hidden;border:1px solid var(--c-line-200,#e3ddd2);box-shadow:0 1px 4px rgba(0,0,0,.08)}' +
    '.veb-frame iframe,.veb-frame video{position:absolute;inset:0;width:100%;height:100%;border:0;display:block}' +
    '.video-embed-block.veb-s{max-width:400px}' +      // size presets (landscape / 16:9)
    '.video-embed-block.veb-l{max-width:880px}' +
    '.veb-portrait{max-width:400px}' +                 // Instagram etc.: taller, narrower
    '.veb-portrait.veb-s{max-width:300px}' +
    '.veb-portrait.veb-l{max-width:540px}' +
    // Initial portrait aspect ≈ Instagram's natural embed shape at 400px wide
    // (height = 1.25·w + 189px of fixed chrome → 40/69 ≈ 0.58). This is only the
    // pre-measure default; the IG 'MEASURE' message listener (below) sizes the frame
    // to IG's exact reported height on load so the embed FITS with no inner scroll (OQ9).
    '.veb-portrait .veb-frame{aspect-ratio:40/69}' +
    '.veb-ctrls{position:absolute;top:5px;right:5px;display:flex;gap:5px;opacity:0;transition:opacity .12s}' +
    '.video-embed-block:hover .veb-ctrls{opacity:1}' +
    '.veb-btn{font:inherit;font-size:.78rem;padding:.14rem .5rem;border:1px solid var(--c-line-200,#e3ddd2);border-radius:6px;background:var(--c-fill-50,#faf8f4);color:var(--c-ink-700,#3b3630);cursor:pointer;white-space:nowrap}' +
    '.veb-btn:hover{background:var(--c-fill-100,#f1ece3)}' +
    '.veb-ctrls .veb-btn{background:rgba(18,16,12,.62);color:#fff;border:none}' +
    '.veb-ctrls .veb-btn:hover{background:rgba(18,16,12,.82)}' +
    '.veb-size{display:inline-flex;border-radius:6px;overflow:hidden}' +   // segmented S M L
    '.veb-szb{font:inherit;font-size:.72rem;line-height:1;padding:.18rem .44rem;border:none;background:rgba(18,16,12,.62);color:#fff;cursor:pointer}' +
    '.veb-szb:hover{background:rgba(18,16,12,.82)}' +
    '.veb-szb.veb-sz-on{background:#fff;color:#18100c}' +   // current size highlighted
    '.video-link-block{display:flex;align-items:center;gap:.5rem;margin:.35rem 0;font-size:.9rem}' +
    '.veb-link{color:var(--c-ink-700,#3b3630);text-decoration:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:72%}' +
    '.veb-link:hover{text-decoration:underline}' +
    // ── inline PDF blocks (share the .veb-btn / .veb-link chrome above) ──
    '.pdf-link-block{display:flex;align-items:center;gap:.5rem;margin:.35rem 0;font-size:.9rem}' +
    '.pdf-embed-block{position:relative;margin:.5rem 0;max-width:820px}' +
    '.peb-frame{position:relative;width:100%;height:70vh;min-height:360px;max-height:820px;background:#f1ece3;border:1px solid var(--c-line-200,#e3ddd2);border-radius:8px;overflow:hidden}' +
    '.peb-pages{position:absolute;inset:0;overflow:auto;padding:10px;box-sizing:border-box;-webkit-overflow-scrolling:touch}' +   /* pdf.js pages (notes-media-pdf.js); padding = PEB_PAD */
    '.peb-page{position:relative;margin:0 auto 10px;background:#fff;box-shadow:0 1px 3px rgba(18,16,12,.18)}' +
    '.peb-page canvas{display:block;width:100%;height:100%}' +
    '.peb-status{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#6b655c;font-size:.9rem}' +
    '.peb-ctrls{position:absolute;top:5px;right:5px;display:flex;gap:5px;opacity:0;transition:opacity .12s}' +
    '.pdf-embed-block:hover .peb-ctrls{opacity:1}' +
    '.peb-ctrls .veb-btn{background:rgba(18,16,12,.62);color:#fff;border:none}' +
    '.peb-ctrls .veb-btn:hover{background:rgba(18,16,12,.82)}' +
    // ── inline uploaded-video block (native <video>, SW-streamed with Range) ──
    '.video-file-block{position:relative;margin:.5rem 0;max-width:640px}' +
    '.vfb-frame{position:relative;width:100%;border-radius:8px;overflow:hidden;background:#000}' +
    '.vfb-video{display:block;width:100%;max-height:70vh;background:#000;border-radius:8px}' +
    '.vfb-ctrls{position:absolute;top:5px;right:5px;display:flex;gap:5px;opacity:0;transition:opacity .12s}' +
    '.video-file-block:hover .vfb-ctrls{opacity:1}' +
    '.vfb-ctrls .veb-btn{background:rgba(18,16,12,.62);color:#fff;border:none}' +
    '.vfb-ctrls .veb-btn:hover{background:rgba(18,16,12,.82)}' +
    '.vfb-loading{display:flex;align-items:center;justify-content:center;gap:.5rem;min-height:120px;padding:1rem;border-radius:8px;background:var(--c-fill-100,#f1ece3);border:1px dashed var(--c-line-200,#e3ddd2);color:var(--c-ink-600,#4b453d);font-size:.9rem}' +
    '.vfb-spinner{width:15px;height:15px;border:2px solid var(--c-line-300,#cbc3b5);border-top-color:var(--c-ink-600,#4b453d);border-radius:50%;display:inline-block;animation:vfbspin .8s linear infinite}' +
    '@keyframes vfbspin{to{transform:rotate(360deg)}}' +
    // ── the ⬆ Upload anchored menu (mirrors the .notes-color-pop pattern) ──
    '.notes-upload-menu{position:fixed;z-index:9600;display:none;flex-direction:column;gap:3px;padding:5px;background:var(--c-fill-50,#faf8f4);border:1px solid var(--c-line-200,#e3ddd2);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.14)}' +
    '.notes-upload-menu.open{display:flex}' +
    '.notes-upload-menu .nu-item{font:inherit;font-size:.82rem;text-align:left;white-space:nowrap;padding:.34rem .6rem;border:none;border-radius:6px;background:transparent;color:var(--c-ink-700,#3b3630);cursor:pointer}' +
    '.notes-upload-menu .nu-item:hover{background:var(--c-fill-150,#efe9df)}' +
    'body.tt-readonly .veb-remove,body.tt-readonly .peb-remove,body.tt-readonly .vfb-remove{display:none}' +   // read-only viewers can Preview + collapse (view-only), but not remove
    '.veb-input{width:100%;box-sizing:border-box;font:inherit;font-size:.9rem;line-height:1.4;padding:.55rem .65rem;border:1px solid var(--c-line-200,#e3ddd2);border-radius:8px;resize:vertical;margin:.2rem 0 .1rem}' +
    '.veb-hint{color:#b45309;font-size:.8rem;min-height:1.1em;margin:.1rem 0 .2rem}';
  const st = document.createElement('style'); st.id = 'veb-styles'; st.textContent = css;
  document.head.appendChild(st);
}

// "Attach a video" - link-only inline embeds. Opens a small modal where the user
// pastes one or more public video URLs (one per line); each valid URL is inserted
// at the caret (or appended) as its OWN bare-URL line, then the box re-renders so
// setEditorContent turns each into an inline player. The app stores only the link.
// Uses onclick (not onmousedown) + a read-only guard so it never fires / leaks in
// a read-only view (unlike the older insertNotesTable mousedown path).
function insertNotesVideo(boxId) {
  if (document.body && document.body.classList.contains('tt-readonly')) return;
  let editor;
  if (boxId) {
    const sel = (typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(boxId) : boxId;
    editor = document.querySelector(`.notes-editor[data-box-id="${sel}"]`);
  } else {
    const live = _lastFocusedNotesEditor && document.body.contains(_lastFocusedNotesEditor);
    editor = live ? _lastFocusedNotesEditor : document.querySelector('.notes-editor');
  }
  if (!editor) { showToast('⚠ Open a notes ' + LBL('boxNoun').toLowerCase() + ' first'); return; }

  // Capture the caret's line NOW, before the modal steals focus. If the caret is
  // not in THIS box (or sits in an atomic block), we append at the end instead.
  let anchorLine = null;
  const winSel = window.getSelection();
  if (winSel && winSel.rangeCount) {
    const a = winSel.anchorNode; const ael = a && (a.nodeType === 1 ? a : a.parentElement);
    const inThis = ael && ael.closest && ael.closest('.notes-editor') === editor;
    const inAtomic = ael && ael.closest && ael.closest('.md-table-block, .mermaid-block, .excalidraw-block, .video-embed-block, .video-link-block, .pdf-embed-block, .pdf-link-block, .video-file-block');
    if (inThis && !inAtomic) anchorLine = notesEditorLineDiv(editor);
  }

  ensureShareStyles();            // reuse the shared modal chrome (.tts-overlay/.tts-panel/.tts-btn)
  ensureVideoEmbedStyles();
  const ov = document.createElement('div'); ov.className = 'tts-overlay';
  const panel = document.createElement('div'); panel.className = 'tts-panel';
  panel.innerHTML =
    `<div class="tts-hd"><div><h3>Attach a video</h3><div class="sub">Paste a YouTube, Google Drive, or direct video link (one per line)</div></div>` +
      `<button id="vebClose" class="tts-icon" title="Close">&times;</button></div>` +
    `<textarea id="vebInput" class="veb-input" rows="4" spellcheck="false" placeholder="https://youtu.be/...\nhttps://drive.google.com/file/d/.../view"></textarea>` +
    `<div id="vebHint" class="veb-hint"></div>` +
    `<div class="tts-foot"><span class="tts-foot-r"><button id="vebCancel" class="tts-btn">Cancel</button><button id="vebInsert" class="tts-btn tts-btn-primary">Insert</button></span></div>`;
  ov.appendChild(panel); document.body.appendChild(ov);
  const ta = panel.querySelector('#vebInput'); ta.focus();
  const close = () => ov.remove();
  ov.addEventListener('mousedown', e => { if (e.target === ov) close(); });
  panel.querySelector('#vebClose').addEventListener('click', close);
  panel.querySelector('#vebCancel').addEventListener('click', close);

  panel.querySelector('#vebInsert').addEventListener('click', () => {
    const urls = (ta.value || '').split('\n').map(s => s.trim()).filter(Boolean);
    if (!urls.length) { close(); return; }
    const good = [], badCount = urls.filter(u => !parseVideoEmbed(u)).length;
    urls.forEach(u => { if (parseVideoEmbed(u)) good.push(u); });
    if (!good.length) {
      panel.querySelector('#vebHint').textContent = "Couldn't recognize a YouTube, Google Drive, or direct video link.";
      return;
    }
    // Splice each good URL as its own bare-URL line (blank-separated so each is its
    // own block region), then re-render in place - setEditorContent turns each into
    // a player. Same splice-then-rerender path insertNotesTable uses.
    const frag = document.createDocumentFragment();
    const blank = () => { const d = document.createElement('div'); d.appendChild(document.createElement('br')); return d; };
    const lineDiv = (t) => { const d = document.createElement('div'); d.textContent = t; return d; };
    // Attach = explicit "preview" intent, so insert each as a ```video fence (player).
    good.forEach(url => {
      frag.appendChild(blank());
      frag.appendChild(lineDiv('```video'));
      frag.appendChild(lineDiv(url));
      frag.appendChild(lineDiv('```'));
    });
    frag.appendChild(blank());
    if (anchorLine && anchorLine.parentNode === editor) editor.insertBefore(frag, anchorLine.nextSibling);
    else editor.appendChild(frag);
    setEditorContent(editor, getEditorContent(editor));
    editor.dispatchEvent(new Event('input'));
    close();
    showToast(badCount ? `✓ ${good.length} video(s) added, ${badCount} link(s) skipped` : `✓ ${good.length} video(s) added`);
  });
}

;
// ==== FILE: js/notes/notes-editor-serialize.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-editor-serialize.js
// ==========================================================================

// Walk the editor's DOM and emit a markdown-ish text string:
//   <span class="img-wrap" style="width:Wpx;height:Hpx">…<img>…</span>  →  <img src="file" width="W" height="H">
//   <span class="img-wrap">…<img>…</span>  (no explicit size)            →  ![](file)
//   <br>           →  \n
//   block end (<div>, <p>) → \n
//   text nodes     →  their text content
//   <span style="color:#hex"> / <font color> → <span style="color:#rrggbb">

// Normalize any CSS color the browser hands us (foreColor emits rgb(), paste may
// bring #rgb/#rrggbb or a <font color>) to a canonical lowercase #rrggbb, or null
// if it isn't a plain color we recognize. Keeping the saved form to exactly
// #rrggbb is what makes the color round-trip byte-for-byte and the render-side
// un-escape regex tight (hex-only → no attribute/XSS injection).
function normalizeColorHex(c) {
  if (!c) return null;
  const s = String(c).trim().toLowerCase();
  let m = s.match(/^#([0-9a-f]{6})$/);
  if (m) return '#' + m[1];
  m = s.match(/^#([0-9a-f]{3})$/);
  if (m) return '#' + m[1].split('').map((x) => x + x).join('');
  m = s.match(/^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/);
  if (m) {
    const h = (n) => Math.max(0, Math.min(255, Number(n))).toString(16).padStart(2, '0');
    return '#' + h(m[1]) + h(m[2]) + h(m[3]);
  }
  return null;
}

// The markdown of ONE image node, or null for anything else. A resize-wrapped image (.img-wrap with an inline
// width / height) is `<img src="file" width="W" height="H">`; an unsized wrap or a bare <img> is `![](file)`. Either
// form is valid markdown and the parser renders both (renderImageToken). Used by the free-text serializer here and by
// the table-cell serializer (notes-tables-view.js cellToMarkdown), so an image lives in a cell exactly as in a line
// (Rishabh 2026-10-16: an image pasted into a cell vanished on the next save - the cell walker did not know images).
function imageNodeToMarkdown(node) {
  if (!node || node.nodeType !== 1) return null;
  const tag = node.tagName.toLowerCase();
  const fileOf = (img) => img.dataset.file || decodeURIComponent((img.getAttribute('src') || '').replace(/^\/load\?file=/, '').replace(/^.*\//, ''));
  if (tag === 'span' && node.classList && node.classList.contains('img-wrap')) {
    const img = node.querySelector('img');
    if (!img) return '';
    const w = parseInt(node.style.width, 10) || null;
    const h = parseInt(node.style.height, 10) || null;
    return (w && h) ? `<img src="${fileOf(img)}" width="${w}" height="${h}">` : `![](${fileOf(img)})`;
  }
  if (tag === 'img') return `![${node.getAttribute('alt') || ''}](${fileOf(node)})`;
  return null;
}

// The lesson marker lines a diagram block carries, in file order (round 5). Pure over the block's dataset.
function lessonMarkersOf(node) {
  const ds = node.dataset || {};
  if (ds.lessons) return JSON.parse(ds.lessons);
  const lh = ds.lessonHash, lu = ds.lessonUrl;
  return (lh && lu) ? [{ v: ds.lessonV || '1', hash: lh, url: lu, config: null, label: null }] : [];
}
// ONE marker line from its parsed form - the exact text notes-editor-parse.js parseLessonMarkers accepts (the MCP's
// diagram-text.js writes the same grammar). Byte-identical re-emit is the contract: the marker survives every save.
function lessonMarkerLine(m) {
  if (m.v === '3') return '<!-- tt-lesson v=3 nhash=' + m.hash + ' config="' + m.config + '" label="' + m.label + '" url="' + m.url + '" -->';
  return '<!-- tt-lesson v=' + m.v + ' ' + (m.v === '2' ? 'nhash' : 'hash') + '=' + m.hash + ' url="' + m.url + '" -->';
}

function getEditorContent(editor) {
  let out = '';
  // The box's own text colour, as a hex: a colour span carrying exactly this colour says nothing (Chrome inserts
  // computed-style spans of its own on a merge / an Enter inside styled text - Rishabh 2026-10-14: literal
  // `<span style="color:#14211b">` lines under a heading; #14211b IS the body ink), so it is not persisted.
  const defaultHex = (editor && typeof getComputedStyle === 'function') ? normalizeColorHex(getComputedStyle(editor).color) : null;
  // An inline wrapper (bold / italic / underline / code / colour) is persisted PER LINE: the DOM run may hold a
  // <br> (Enter inside a coloured run leaves `<span style="color"><br></span>` on the new line - Chrome carries the
  // style over), but the saved form is read back one line at a time, so a wrapper straddling a newline came back
  // as two literal tag fragments the person could see and never remove (his 2026-10-14 screenshots). Each line
  // segment gets its own open/close; an empty segment gets none (nothing to style). `wrapSeg` may rewrite a segment
  // (bold keeps a heading marker outside the markers).
  function emitWrapped(node, wrapSeg) {
    const before = out.length;
    for (const child of node.childNodes) walk(child);
    const inner = out.slice(before);
    out = out.slice(0, before);
    out += inner.split('\n').map((seg) => (seg === '' ? '' : wrapSeg(seg))).join('\n');
  }
  function walk(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      out += node.nodeValue;
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    // Synthetic caret-slot line setEditorContent inserts (the leader above a
    // top-of-box atomic block): drop it WHILE STILL EMPTY so it never reaches
    // the saved markdown. But the moment the user types/pastes into it — the
    // whole point of the slot — it holds real content, so fall through and
    // serialize it normally (it stops being synthetic).
    if (node.dataset && node.dataset.synthetic === '1') {
      const hasText = !!(node.textContent || '').trim();
      const hasNonBr = Array.prototype.some.call(node.children, el => el.tagName !== 'BR');
      if (!hasText && !hasNonBr) return;
    }
    const tag = node.tagName.toLowerCase();

    // An image (a resize-wrapped .img-wrap or a bare <img>): its markdown, the same in a free-text line and in a
    // table cell (cellToMarkdown, notes-tables-view.js).
    const imageMd = imageNodeToMarkdown(node);
    if (imageMd != null) { out += imageMd; return; }   // never recurse into the wrapper
    // URL pill <a class="url-pill" data-url="…">label</a> — emit the underlying
    // URL, NOT the displayed label. Without this, saving while pills are
    // collapsed would lose the URL and replace it with "webshare.io" text.
    if (tag === 'a' && node.classList && node.classList.contains('url-pill')) {
      const url = node.dataset.url || node.getAttribute('href') || node.textContent;
      out += url;
      return;
    }
    // Mermaid block <div class="mermaid-block" data-source="…">SVG</div> —
    // emit back the ```mermaid``` fenced code block from data-source so the
    // saved .md keeps the editable source, not the rendered SVG.
    if (tag === 'div' && node.classList && node.classList.contains('mermaid-block')) {
      const src = node.dataset.source || '';
      if (!out.endsWith('\n') && out.length > 0) out += '\n';
      out += '```mermaid\n' + src + '\n```\n';
      return; // don't recurse into the SVG
    }
    // Excalidraw block <div class="excalidraw-block" data-source="…">SVG</div> —
    // emit back the ```excalidraw``` fenced block holding the scene JSON, so the
    // saved .md keeps the editable scene, not the rendered SVG preview. The
    // source is single-line minified JSON (see excalidraw.js), so no newline
    // pitfalls inside the fence. `return` is critical — never recurse into the
    // rendered preview/SVG (would emit garbage into the .md).
    if (tag === 'div' && node.classList && node.classList.contains('excalidraw-block')) {
      const src = node.dataset.source || '';
      if (!out.endsWith('\n') && out.length > 0) out += '\n';
      out += '```excalidraw\n' + src + '\n```\n';
      // PER-COPY lesson marker (SPEC §10): re-emit it BYTE-IDENTICAL on the line
      // right after the fence so the diagram's video reference survives this save
      // (setEditorContent stashed it into data-lesson-*). Without this, editing
      // anything in the box would drop the marker and the "▶ Video" toggle.
      // ROUND 5 (video-editor, 2026-10-29): the block may carry SEVERAL videos (one marker line per variant). The run is
      // stashed as data-lessons (a JSON array in file order); a block that carries only the single-marker attributes
      // (data-lesson-v/hash/url = the first line, still written by the parser and by the classic renderer's fixtures)
      // is a one-variant run. Each line is re-emitted by its version: v=1 hash, v=2 nhash, v=3 nhash + config + label.
      for (const m of lessonMarkersOf(node)) out += lessonMarkerLine(m) + '\n';
      return;
    }
    // Markdown table block — emit the raw `| col | col |` source lines back
    // so the saved .md keeps the editable pipe-table, not the rendered HTML.
    if (tag === 'div' && node.classList && node.classList.contains('md-table-block')) {
      const src = node.dataset.source || '';
      if (!out.endsWith('\n') && out.length > 0) out += '\n';
      out += src + '\n';
      return; // don't recurse into the rendered <table>
    }
    // Inline video PLAYER <div class="video-embed-block" data-url="URL"> - serialize
    // to a fenced ```video block holding the bare URL (canonical data-url, NEVER a
    // live iframe src, which carries a rebuilt embed path / cache-buster). The fence
    // is what persists the "preview" choice - a bare URL (no fence) is the LINK form.
    // Newline-guarded like mermaid; an empty data-url emits nothing (no silent loss).
    if (tag === 'div' && node.classList && node.classList.contains('video-embed-block')) {
      const url = node.dataset.url || '';
      if (!url) return;
      if (!out.endsWith('\n') && out.length > 0) out += '\n';
      // Persist the chosen size in the fence info-string; M (default) stays bare
      // so existing content round-trips byte-identical (portrait is re-derived from
      // the URL, not stored).
      const sz = node.classList.contains('veb-s') ? ' s' : (node.classList.contains('veb-l') ? ' l' : '');
      out += '```video' + sz + '\n' + url + '\n```\n';
      return; // don't recurse into the player
    }
    // Inline video LINK <div class="video-link-block" data-url="URL"> - serialize to
    // the bare URL on its own line (the default form; buttons never serialize). A
    // bare video URL renders back as this link block.
    if (tag === 'div' && node.classList && node.classList.contains('video-link-block')) {
      const url = node.dataset.url || '';
      if (!url) return;
      if (!out.endsWith('\n') && out.length > 0) out += '\n';
      out += url + '\n';
      return;
    }
    // Inline PDF block -> a fenced ```pdf block: storage filename (line 1) + the
    // sanitized display name (line 2). The info-string carries the open/collapsed
    // state so a preview left open is restored on reload: ```pdf open for the preview
    // form, bare ```pdf for the link form. The display name is re-run through
    // _pdfDisplayName so a name can never break the fence. Newline-guarded like the
    // video/mermaid branches; an empty data-file emits nothing.
    if (tag === 'div' && node.classList && (node.classList.contains('pdf-link-block') || node.classList.contains('pdf-embed-block'))) {
      const file = node.dataset.file || '';
      if (!file) return;
      const name = _pdfDisplayName(node.dataset.name || '');
      const openTok = node.classList.contains('pdf-embed-block') ? ' open' : '';
      if (!out.endsWith('\n') && out.length > 0) out += '\n';
      out += '```pdf' + openTok + '\n' + file + '\n' + name + '\n```\n';
      return;
    }
    // Inline uploaded-video block -> a fenced ```videofile block: storage filename
    // (line 1) + sanitized display name (line 2). No open/collapsed state (always the
    // player). Same fence discipline as ```pdf; an empty data-file emits nothing.
    if (tag === 'div' && node.classList && node.classList.contains('video-file-block')) {
      const file = node.dataset.file || '';
      if (!file) return;
      const name = _videoDisplayName(node.dataset.name || '');
      if (!out.endsWith('\n') && out.length > 0) out += '\n';
      out += '```videofile\n' + file + '\n' + name + '\n```\n';
      return;
    }
    if (tag === 'br') { out += '\n'; return; }
    // Inline emphasis — **bold** / `code` rendered by renderFreeInline (and any
    // <b>/<strong>/<code> from Ctrl+B or pasted rich text) serialize back to the
    // markdown markers so the saved .md round-trips. Mirrors cellToMarkdown.
    // (Italic <em>/<i> is intentionally not emitted — see applyInlineMd.)
    if (tag === 'strong' || tag === 'b') {
      // A heading marker is never INSIDE the bold run: Ctrl+B over a whole heading line wraps <b> around the
      // `.md-hash` span too, and `**## Title**` is no heading to the renderer (Rishabh 2026-10-02: "## Mobility - 7
      // Day" rendered as text). The marker + its space come first, the bold wraps the rest: `## **Title**`.
      emitWrapped(node, (seg) => {
        const m = seg.match(/^(#{1,6}\s+)([\s\S]*)$/);
        return m ? m[1] + (m[2] ? '**' + m[2] + '**' : '') : '**' + seg + '**';
      });
      return;
    }
    if (tag === 'code') { emitWrapped(node, (seg) => '`' + seg + '`'); return; }
    // Italic / underline (the I/U buttons) have no clean markdown — a bare * for
    // italic misfires, and underline has no markdown at all — so they persist as
    // literal <em>/<u> HTML (applyInlineMd un-escapes them back on render).
    if (tag === 'em' || tag === 'i') { emitWrapped(node, (seg) => '<em>' + seg + '</em>'); return; }
    if (tag === 'u') { emitWrapped(node, (seg) => '<u>' + seg + '</u>'); return; }
    // Colored text — the A/color button (and any pasted colored span) persists as
    // a normalized <span style="color:#rrggbb">…</span> that applyInlineMd
    // un-escapes back on render. Only a clean hex is emitted; an unrecognized color
    // yields null and the wrapper falls through (text kept, color dropped), so
    // junk colors never reach the saved markdown. The box's own default colour is
    // no colour at all (see defaultHex above) - the wrapper falls through the same way.
    if (tag === 'span' || tag === 'font') {
      const hex = normalizeColorHex((node.style && node.style.color) || node.getAttribute('color'));
      if (hex && hex !== defaultHex) { emitWrapped(node, (seg) => `<span style="color:${hex}">` + seg + '</span>'); return; }
    }
    // Aligned line (center/right) — persist as <div align="X">…</div> since
    // markdown has no alignment syntax. Capture the children's markdown (the
    // line keeps its heading # markers etc.) and wrap it.
    if (tag === 'div' && node.style && (node.style.textAlign === 'center' || node.style.textAlign === 'right')) {
      const ta = node.style.textAlign;
      const before = out.length;
      for (const child of node.childNodes) walk(child);
      const inner = out.slice(before).replace(/\n+$/, '');
      out = out.slice(0, before);
      if (out.length > 0 && !out.endsWith('\n')) out += '\n';
      out += `<div align="${ta}">${inner}</div>\n`;
      return;
    }
    const isBlock = (tag === 'div' || tag === 'p');
    // A block starts its own line. The first text typed into an EMPTY box sits bare at the editor's root; the first
    // Enter puts the next line in a <div> after it, and without this the two read back as one line
    // (RUN 2026-10-27: "# Box One<div>intro line</div>" saved as "# Box Oneintro line", the title glued to the body).
    if (isBlock && out.length > 0 && !out.endsWith('\n')) out += '\n';
    for (const child of node.childNodes) walk(child);
    if (isBlock && !out.endsWith('\n')) out += '\n';
  }
  for (const child of editor.childNodes) walk(child);
  return out.replace(/\n+$/, '');
}

function escapeHtmlForEditor(s) {
  // Must escape `"` too — this string ends up inside HTML attribute values
  // (e.g. data-source="..." on mermaid blocks). Without &quot; escaping, a
  // literal " in the source truncates the attribute at the first quote.
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}


// ── Rendering ────────────────────────────────────────────────────────────

// Tracks the notes editor the user last focused, so the toolbar "⊞ Table"
// button knows which box to insert into (clicking the button blurs the editor,
// so document.activeElement is the button at click time, not the editor).
let _lastFocusedNotesEditor = null;

// Set text alignment (left/center/right) on the line(s) the selection touches in
// the focused notes box. Persisted as <div align="…">…</div> in the saved
// markdown (see setEditorContent / getEditorContent). Uses mousedown+preventDefault
// at the call site so clicking the button doesn't drop the editor's caret.
function alignNotes(e, align) {
  if (e) e.preventDefault();
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) { showToast('⚠ Click inside a notes ' + LBL('boxNoun').toLowerCase() + ' first'); return; }
  const anchor = sel.anchorNode;
  const el = anchor && (anchor.nodeType === 1 ? anchor : anchor.parentElement);
  const editor = el && el.closest && el.closest('.notes-editor');
  if (!editor) { showToast('⚠ Click inside a notes ' + LBL('boxNoun').toLowerCase() + ' first'); return; }
  const range = sel.getRangeAt(0);
  const lineDivs = [];
  editor.childNodes.forEach(child => {
    if (child.nodeType === 1 && child.tagName === 'DIV' && range.intersectsNode(child)) lineDivs.push(child);
  });
  if (!lineDivs.length) {
    let p = el;
    while (p && p.parentElement !== editor) p = p.parentElement;
    if (p && p.tagName === 'DIV') lineDivs.push(p);
  }
  if (!lineDivs.length) { showToast('⚠ Put the cursor on a line first'); return; }
  lineDivs.forEach(d => { d.style.textAlign = (align === 'left') ? '' : align; });
  editor.dispatchEvent(new Event('input'));   // debounced save; blur re-render keeps it
}

// Bold / Italic / Underline the SELECTED text (mirrors alignNotes' selection
// handling; uses mousedown+preventDefault so clicking the button doesn't collapse
// the selection). execCommand wraps the selection in <b>/<i>/<u> (styleWithCSS off
// → real tags, not styled spans); getEditorContent serializes them to **…** for
// bold and literal <em>/<u> for italic/underline, which round-trip back on render.
function formatNotes(e, cmd) {
  if (e) e.preventDefault();
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0 || sel.isCollapsed) { showToast('⚠ Select some text first'); return; }
  const anchor = sel.anchorNode;
  const el = anchor && (anchor.nodeType === 1 ? anchor : anchor.parentElement);
  const editor = el && el.closest && el.closest('.notes-editor');
  if (!editor) { showToast('⚠ Select text inside a notes ' + LBL('boxNoun').toLowerCase() + ' first'); return; }
  if (document.body && document.body.classList.contains('tt-readonly')) return;   // read-only view
  try { document.execCommand('styleWithCSS', false, false); } catch (_) {}
  try { document.execCommand(cmd, false, null); } catch (_) {}
  editor.dispatchEvent(new Event('input'));   // debounced save; blur re-render normalizes the markup
}

// Heading level on the LINE(S) the selection touches - the H button's popover and Ctrl+Alt+1..4 (Rishabh
// 2026-09-24). A heading IS a line beginning `#{n} ` - the same markdown the renderer reads - so the file format,
// the MCP, export and share are untouched. level 1..4 SETS that level (H2 on an H2 line stays H2 - his word: "set");
// level 0 = "Text" strips it. The line's DOM is edited to exactly what setEditorContent renders (.md-head.md-h<n> +
// the dimmed .md-hash span), so the look is immediate and the next blur rebuild changes nothing. A table cell is
// not a line; an atomic block (table / diagram / video) is skipped.
function headNotes(level) {
  if (document.body && document.body.classList.contains('tt-readonly')) return;
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) { showToast('⚠ Click inside a notes ' + LBL('boxNoun').toLowerCase() + ' first'); return; }
  const anchor = sel.anchorNode;
  const el = anchor && (anchor.nodeType === 1 ? anchor : anchor.parentElement);
  const editor = el && el.closest && el.closest('.notes-editor');
  if (!editor) { showToast('⚠ Click inside a notes ' + LBL('boxNoun').toLowerCase() + ' first'); return; }
  if (el.closest('th, td')) { showToast('⚠ A heading is a line, not a table cell'); return; }
  const range = sel.getRangeAt(0);
  const lineDivs = [];
  editor.childNodes.forEach(child => {
    if (child.nodeType === 1 && child.tagName === 'DIV' && range.intersectsNode(child)) lineDivs.push(child);
  });
  if (!lineDivs.length) {
    let p = el;
    while (p && p.parentElement !== editor) p = p.parentElement;
    if (p && p.tagName === 'DIV') lineDivs.push(p);
  }
  const lines = lineDivs.filter(d => !d.getAttribute('contenteditable'));
  if (!lines.length) { showToast('⚠ Put the cursor on a line first'); return; }
  lines.forEach(d => setNotesLineHeading(d, level));
  editor.dispatchEvent(new Event('input'));   // debounced save + outline / title refresh (a # on line 1 IS the box title)
}
function setNotesLineHeading(div, level) {
  const hash = div.querySelector(':scope > .md-hash');
  if (hash) {
    const next = hash.nextSibling;                                   // the marker's trailing whitespace text
    if (next && next.nodeType === 3) next.nodeValue = next.nodeValue.replace(/^\s+/, '');
    hash.remove();
  } else if (div.firstChild && div.firstChild.nodeType === 3) {
    div.firstChild.nodeValue = div.firstChild.nodeValue.replace(/^#{1,6}\s+/, '');   // typed `## ` not yet rebuilt
  }
  div.classList.remove('md-head', 'md-h1', 'md-h2', 'md-h3', 'md-h4', 'md-h5', 'md-h6');
  if (!level) { if (!div.firstChild) div.appendChild(document.createElement('br')); return; }
  const span = document.createElement('span');
  span.className = 'md-hash';
  span.textContent = '#'.repeat(level);
  div.insertBefore(document.createTextNode(' '), div.firstChild);   // an empty line is <div><br></div>: marker before the <br>
  div.insertBefore(span, div.firstChild);
  div.classList.add('md-head', 'md-h' + level);
}
// A line's heading classes from its OWN text - the rule the renderer applies (`#{1,6}` + whitespace at the start
// is a heading of that level; anything else is plain text) - so a line the browser or a key handler re-arranged
// looks the way the next rebuild will draw it. Used after a split (notes-keys.js handleNotesHeadingEnterKey).
function setNotesLineClassFromText(div) {
  const m = /^(#{1,6})\s/.exec(div.textContent);
  div.classList.remove('md-head', 'md-h1', 'md-h2', 'md-h3', 'md-h4', 'md-h5', 'md-h6');
  if (m) div.classList.add('md-head', 'md-h' + m[1].length);
}
function _closeNotesHeadPop() {
  const p = document.getElementById('notesHeadPop');
  if (p) p.classList.remove('open');
  document.removeEventListener('mousedown', _notesHeadPopOutside, true);
}
function _notesHeadPopOutside(ev) {
  const p = document.getElementById('notesHeadPop');
  if (p && !p.contains(ev.target)) _closeNotesHeadPop();
}
// The H button's popover: H1 H2 H3 H4 Text. mousedown + preventDefault (button + items) keeps the caret / selection.
function openNotesHeadPop(e) {
  if (e) e.preventDefault();
  if (document.body && document.body.classList.contains('tt-readonly')) return;
  let pop = document.getElementById('notesHeadPop');
  if (!pop) { pop = document.createElement('div'); pop.id = 'notesHeadPop'; pop.className = 'notes-pop-menu'; document.body.appendChild(pop); }
  pop.innerHTML = [1, 2, 3, 4].map(n =>
    `<button type="button" class="npm-item npm-h${n}" onmousedown="event.preventDefault(); _closeNotesHeadPop(); headNotes(${n})" title="Heading ${n} (Ctrl+Alt+${n})" tabindex="-1">H${n}</button>`
  ).join('') + `<button type="button" class="npm-item" onmousedown="event.preventDefault(); _closeNotesHeadPop(); headNotes(0)" title="Back to normal text" tabindex="-1">Text</button>`;
  const btn = e.currentTarget || e.target;
  const r = btn.getBoundingClientRect();
  pop.style.left = Math.round(r.left) + 'px';
  pop.style.top = Math.round(r.bottom + 4) + 'px';
  pop.classList.add('open');
  setTimeout(() => document.addEventListener('mousedown', _notesHeadPopOutside, true), 0);
}

// Curated text colors for the notes color popover. 'CLEAR' is the "back to
// default" chip (removes the inline color rather than setting one, so headings /
// table cells fall back to THEIR own CSS color, not a hardcoded body hex).
const NOTES_COLORS = [
  { name: 'Default', val: 'CLEAR' },
  { name: 'Black', val: '#000000' },   // true black, distinct from the body's ink (Rishabh 2026-10-16: "black color is not there")
  { name: 'Red', val: '#dc2626' },
  { name: 'Orange', val: '#ea580c' },
  { name: 'Amber', val: '#b45309' },
  { name: 'Green', val: '#16a34a' },
  { name: 'Blue', val: '#2563eb' },
  { name: 'Purple', val: '#9333ea' },
  { name: 'Gray', val: '#6b7280' },
];

function _closeNotesColorPop() {
  const p = document.getElementById('notesColorPop');
  if (p) p.classList.remove('open');
  document.removeEventListener('mousedown', _notesColorPopOutside, true);
}
function _notesColorPopOutside(ev) {
  const p = document.getElementById('notesColorPop');
  if (p && !p.contains(ev.target)) _closeNotesColorPop();
}

// Open the swatch popover anchored under the clicked color button. mousedown +
// preventDefault (here and on every swatch) keeps the editor's text selection
// alive through the whole pick, so execCommand has something to color.
function openNotesColorPop(e) {
  if (e) e.preventDefault();
  if (document.body && document.body.classList.contains('tt-readonly')) return;
  let pop = document.getElementById('notesColorPop');
  if (!pop) { pop = document.createElement('div'); pop.id = 'notesColorPop'; pop.className = 'notes-color-pop'; document.body.appendChild(pop); }
  pop.innerHTML = NOTES_COLORS.map((c) => c.val === 'CLEAR'
    ? `<button type="button" class="ncp-clear" onmousedown="colorNotes(event,'CLEAR')" title="Remove color (back to default)" tabindex="-1">✕ Default</button>`
    : `<button type="button" class="ncp-sw" style="background:${c.val}" onmousedown="colorNotes(event,'${c.val}')" title="${c.name}" tabindex="-1"></button>`
  ).join('');
  const btn = e.currentTarget || e.target;
  const r = btn.getBoundingClientRect();
  pop.style.left = Math.round(r.left) + 'px';
  pop.style.top = Math.round(r.bottom + 4) + 'px';
  pop.classList.add('open');
  setTimeout(() => document.addEventListener('mousedown', _notesColorPopOutside, true), 0);
}

// Color the selected text (or clear color). Mirrors formatNotes' selection
// handling. For a set: styleWithCSS=TRUE so foreColor emits a <span style="color">
// (the serializer normalizes it to canonical #rrggbb). For CLEAR: strip the inline
// color off any colored span the selection touches so each context falls back to
// its own CSS baseline (never a hardcoded hex). Ends with an input event so the
// debounced save + blur re-render run.
function colorNotes(e, color) {
  if (e) e.preventDefault();
  if (document.body && document.body.classList.contains('tt-readonly')) { _closeNotesColorPop(); return; }
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0 || sel.isCollapsed) { showToast('⚠ Select some text first'); _closeNotesColorPop(); return; }
  const anchor = sel.anchorNode;
  const el = anchor && (anchor.nodeType === 1 ? anchor : anchor.parentElement);
  const editor = el && el.closest && el.closest('.notes-editor');
  if (!editor) { showToast('⚠ Select text inside a notes ' + LBL('boxNoun').toLowerCase() + ' first'); _closeNotesColorPop(); return; }
  if (color === 'CLEAR') {
    clearNotesColor(editor, sel.getRangeAt(0));
  } else {
    try { document.execCommand('styleWithCSS', false, true); } catch (_) {}
    try { document.execCommand('foreColor', false, color); } catch (_) {}
  }
  editor.dispatchEvent(new Event('input'));
  _closeNotesColorPop();
}

// Remove inline text color from any colored <span>/<font> the selection touches,
// unwrapping the element if it carried nothing but the color. Whole-element
// granularity (select the colored run, hit Default) — partial clears just clear
// the whole run, which is fine for this control.
function clearNotesColor(editor, range) {
  if (!range) return;
  editor.querySelectorAll('span[style*="color"], font[color], font').forEach((node) => {
    if (!range.intersectsNode(node)) return;
    if (node.tagName === 'FONT') { node.replaceWith(...node.childNodes); return; }
    node.style.removeProperty('color');
    if (!node.getAttribute('style')) node.replaceWith(...node.childNodes);   // bare span left → unwrap
  });
}

// Convert pasted HTML into the editor's markdown TEXT. The notes editor is a
// markdown model end-to-end (getEditorContent serializes DOM->markdown,
// setEditorContent parses markdown->DOM) and has NO concept of <ul>/<ol>/<li>/
// <h1-6> tags — injecting raw list/heading HTML collapses to a run-on line on the
// next re-render (the serializer emits a newline only for <div>/<p>). Converting
// to markdown up front — one "- "/"N. " line per list item (indented per nesting
// level), "# " headings, **bold**, <em>/<u>, `code`, bare URLs, pipe tables —
// makes pasted structure survive the round-trip. Inline color/style is dropped
// (only markdown is emitted), which also replaces the old paste color-stripping.
function htmlToMarkdown(html) {
  const tpl = document.createElement('template');
  tpl.innerHTML = String(html);
  tpl.content.querySelectorAll('style, script').forEach((n) => n.remove());

  const IND = '   ';   // one list-nesting level = 3 spaces (matches NOTES_LIST_INDENT)
  const lines = [];
  const blankSep = () => { if (lines.length && lines[lines.length - 1] !== '') lines.push(''); };

  // Markdown for a SINGLE node, including its own tag's wrapping. A <br> is a LINE BREAK wherever it sits - the
  // clipboard HTML Chrome hands over for copied page text is `<span style=…>one<br>two</span>`, so a <br> inside an
  // inline wrapper is the normal case, not an edge (Rishabh 2026-10-14: a cell / paragraph pasted from another cell
  // lost every line break - the <br> had become a space). The break travels as '\n' and the wrappers apply per line.
  function inlineNode(n) {
    if (n.nodeType === 3) return n.nodeValue.replace(/[ \t\r\f\v]+/g, ' ').replace(/\n/g, ' ');
    if (n.nodeType !== 1) return '';
    const t = n.tagName.toLowerCase();
    if (t === 'br') return '\n';
    if (t === 'strong' || t === 'b') return wrapLines(inlineMd(n), '**', '**');
    if (t === 'em' || t === 'i') return wrapLines(inlineMd(n), '<em>', '</em>');
    if (t === 'u') return wrapLines(inlineMd(n), '<u>', '</u>');
    if (t === 'code') return wrapLines(inlineMd(n), '`', '`');
    if (t === 'a') { const href = n.getAttribute('href') || ''; return /^https?:\/\//i.test(href) ? href : inlineMd(n); }
    return inlineMd(n);   // span/font/other inline wrappers → just their content
  }
  // A wrapper around text that may hold line breaks: each line gets its own open/close, an empty line none.
  function wrapLines(inner, open, close) { return inner.split('\n').map((seg) => { const x = seg.trim(); return x ? open + x + close : ''; }).join('\n'); }
  // Inline content of a node as one markdown string ('\n' = a line break inside it).
  function inlineMd(node) { let s = ''; node.childNodes.forEach((n) => { s += inlineNode(n); }); return s; }
  // One line of it: breaks become spaces (a list item / heading / blockquote is one line).
  const oneLine = (node) => inlineMd(node).replace(/\n/g, ' ').replace(/\s+/g, ' ').trim();
  // A pipe-table cell keeps its breaks as the literal <br> the notes table model uses.
  const cellLine = (node) => inlineMd(node).split('\n').map((x) => x.replace(/\s+/g, ' ').trim()).filter((x, i, a) => x || (i > 0 && i < a.length - 1)).join('<br>');
  // A clone of an <li> with nested lists removed, so its own text excludes the
  // nested items (those are emitted separately, one indent deeper).
  function liInlineOnly(li) { const c = li.cloneNode(true); c.querySelectorAll('ul, ol').forEach((x) => x.remove()); return c; }

  function emitList(listNode, depth) {
    const ordered = listNode.tagName.toLowerCase() === 'ol';
    let i = 0;
    [...listNode.children].forEach((li) => {
      if (li.tagName.toLowerCase() !== 'li') return;
      i++;
      const marker = ordered ? (i + '. ') : '- ';
      const txt = oneLine(liInlineOnly(li));
      lines.push(IND.repeat(depth) + marker + txt);
      [...li.children].forEach((c) => { const ct = c.tagName.toLowerCase(); if (ct === 'ul' || ct === 'ol') emitList(c, depth + 1); });
    });
  }
  function emitTable(table) {
    const rows = [...table.querySelectorAll('tr')]
      .map((tr) => [...tr.querySelectorAll('th, td')].map((cell) => (cellLine(cell).replace(/\|/g, '\\|')) || ' '))
      .filter((r) => r.length);
    if (!rows.length) return;
    const ncol = Math.max(...rows.map((r) => r.length));
    blankSep();
    rows.forEach((r, ri) => { while (r.length < ncol) r.push(' '); lines.push('| ' + r.join(' | ') + ' |'); if (ri === 0) lines.push('| ' + Array(ncol).fill('---').join(' | ') + ' |'); });
    blankSep();
  }
  const HAS_BLOCK = 'ul,ol,table,p,div,section,article,h1,h2,h3,h4,h5,h6,blockquote,pre';
  const INLINE_TAGS = ['strong', 'b', 'em', 'i', 'u', 'code', 'a', 'span', 'font', 'sub', 'sup', 'mark', 'small'];

  // Block walker: accumulates consecutive inline siblings into one line, flushing
  // at every block boundary so a sentence stays one line but blocks/items split.
  function block(node, depth) {
    let buf = '';
    // The run flushes as one line per break: a trailing / leading break adds nothing, a break between two
    // texts keeps the blank line it stands for (a pasted paragraph gap).
    const flush = () => {
      const segs = buf.split('\n').map((x) => x.replace(/\s+/g, ' ').trim());
      while (segs.length && !segs[0]) segs.shift();
      while (segs.length && !segs[segs.length - 1]) segs.pop();
      segs.forEach((x) => lines.push(x ? IND.repeat(depth) + x : ''));
      buf = '';
    };
    node.childNodes.forEach((n) => {
      if (n.nodeType === 3) { buf += n.nodeValue.replace(/[ \t\r\f\v]+/g, ' ').replace(/\n/g, ' '); return; }
      if (n.nodeType !== 1) return;
      const t = n.tagName.toLowerCase();
      if (t === 'br') { buf += '\n'; return; }
      if (INLINE_TAGS.includes(t)) { buf += inlineNode(n); return; }
      flush();
      const hm = t.match(/^h([1-6])$/);
      if (hm) { blankSep(); lines.push('#'.repeat(+hm[1]) + ' ' + oneLine(n)); blankSep(); return; }
      if (t === 'ul' || t === 'ol') { emitList(n, depth); return; }
      if (t === 'table') { emitTable(n); return; }
      if (t === 'pre') { blankSep(); lines.push('```'); (n.textContent || '').replace(/\s+$/, '').split('\n').forEach((l) => lines.push(l)); lines.push('```'); blankSep(); return; }
      if (t === 'blockquote') { const inl = oneLine(n); if (inl) lines.push(IND.repeat(depth) + '> ' + inl); return; }
      // Recurse real containers through block() so <br> becomes a line break and
      // inline runs still coalesce into one line (inlineMd alone would space-join <br>).
      if (t === 'p' || t === 'div' || t === 'section' || t === 'article' || (n.querySelector && n.querySelector(HAS_BLOCK))) { block(n, depth); return; }
      buf += inlineMd(n); flush();   // any other element: its inline content, breaks and all
    });
    flush();
  }

  block(tpl.content, 0);
  return lines.join('\n').replace(/\n{3,}/g, '\n\n').replace(/^\n+|\n+$/g, '');
}

;
// ==== FILE: js/notes/notes-editor-parse.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-editor-parse.js
// ==========================================================================

// Initialize Mermaid (loaded as a separate <script> in index.html). The
// global `mermaid` may not be defined if the CDN failed; render functions
// guard against that and fall back to plain-text display.
//   - suppressErrorRendering: stop Mermaid from injecting the giant bomb
//     "Syntax error in text" graphic into <body> on parse failures. We
//     show our own compact in-block error instead.
//   - logLevel: 'error' suppresses verbose console output.
//   - flowchart.htmlLabels:false renders labels as native SVG <text>/<tspan>
//     instead of <foreignObject> HTML. Multi-line labels (with <br/>) size
//     correctly this way; foreignObject mode clips lines past the first.
// Boot-perf (Fix-2 Slice 1): mermaid (the ~1MB CDN lib) is NO LONGER loaded at boot.
// It is used ONLY here (renderMermaidBlock), so we LAZY-LOAD it on the first mermaid
// block render via ensureMermaid(): inject the CDN <script> once, initialize with the
// same config, memoize the promise. A CDN failure leaves `mermaid` undefined and
// renderMermaidBlock shows its existing "library not loaded" fallback (no silent swallow).
let _mermaidLoad = null;
function ensureMermaid() {
  if (typeof mermaid !== 'undefined') return Promise.resolve(mermaid);
  if (_mermaidLoad) return _mermaidLoad;
  _mermaidLoad = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/mermaid@10/dist/mermaid.min.js';
    s.onload = () => {
      try {
        mermaid.initialize({
          startOnLoad: false,
          securityLevel: 'loose',
          theme: 'default',
          suppressErrorRendering: true,
          logLevel: 'error',
          flowchart: { htmlLabels: false, useMaxWidth: true }
        });
      } catch (_) {}
      resolve(typeof mermaid !== 'undefined' ? mermaid : null);
    };
    s.onerror = () => { _mermaidLoad = null; reject(new Error('mermaid CDN load failed')); };
    document.head.appendChild(s);
  });
  return _mermaidLoad;
}

// Ensure the contenteditable has a caret position ABOVE a leading atomic block and
// BELOW a trailing one - otherwise you can't click/arrow to type next to a table /
// diagram / VIDEO that sits at the very top or bottom of the box (the "can't type in
// the box after a video" bug). The trailing blank line is stripped by getEditorContent
// (never pollutes the saved md); the leading one is data-synthetic so it's skipped on
// serialize too. Idempotent: an atomic check on the first/last element means a second
// call finds an editable edge line already there and adds nothing. Used by
// setEditorContent AND after programmatic block inserts (swap / append).
function ensureEditableEdges(editor) {
  if (!editor) return;
  const atomic = (el) => !!(el && (el.getAttribute('contenteditable') === 'false'
    || el.classList.contains('md-table-block')
    || el.classList.contains('mermaid-block')
    || el.classList.contains('excalidraw-block')));
  if (atomic(editor.lastElementChild)) {
    const trailer = document.createElement('div');
    trailer.appendChild(document.createElement('br'));
    editor.appendChild(trailer);
  }
  if (atomic(editor.firstElementChild)) {
    const leader = document.createElement('div');
    leader.dataset.synthetic = '1';
    leader.appendChild(document.createElement('br'));
    editor.insertBefore(leader, editor.firstChild);
  }
}

// Returns synchronously after setting innerHTML; mermaid blocks render
// async in the background and replace their "Rendering…" placeholders.
// What each editor last RENDERED, as its own serialization (getEditorContent right after the render). The
// blur handler compares the live serialization to this and skips its whole-box rebuild when nothing
// changed - a plain click-in / click-out no longer tears down and re-renders every diagram, table and
// video block (Rishabh 2026-09-18: "click D5, click D6 -> D5's diagram disappears and re-renders").
// Serialization vs serialization, never vs the raw text: the parser normalises. WeakMap: the entry dies
// with the element, so a re-rendered chapter starts clean with no per-box bookkeeping.
const _editorRendered = new WeakMap();
// The lesson MARKER lines after a diagram fence (round 5): parse the run starting at lines[at] - consecutive lines only;
// the first line that is not a marker ends it. Pure. v=1 / v=2 = the legacy single-marker grammar (hash | nhash);
// v=3 = nhash + config + label + url in that order. Returns [{ v, hash, url, config, label }] in file order.
const LESSON_MARKER_LEGACY = /^<!-- tt-lesson v=([12]) (?:hash|nhash)=([0-9a-f]{8}) url="([^"]*)" -->$/;
const LESSON_MARKER_V3 = /^<!-- tt-lesson v=3 nhash=([0-9a-f]{8}) config="([^"]*)" label="([^"]*)" url="([^"]*)" -->$/;
function parseLessonMarkers(lines, at) {
  const run = [];
  for (let k = at; k < lines.length; k++) {
    const l = lines[k];
    const v3 = l.match(LESSON_MARKER_V3);
    if (v3) { run.push({ v: '3', hash: v3[1], url: v3[4], config: v3[2], label: v3[3] }); continue; }
    const lg = l.match(LESSON_MARKER_LEGACY);
    if (lg) { run.push({ v: lg[1], hash: lg[2], url: lg[3], config: null, label: null }); continue; }
    break;
  }
  return run;
}

function setEditorContent(editor, text) {
  if (!text) { editor.innerHTML = ''; _editorRendered.set(editor, getEditorContent(editor)); return; }
  // The rebuild replaces every table's inner scroller (.md-table-scroll) with a fresh element whose scrollTop is 0,
  // so a FROZEN table the user had scrolled to row 20 snapped back to its header row (measured 2026-09-24: row 20
  // moved from y=679 to y=1109, out of the window; the editor / box / page scrollers were NOT reset - the browser
  // keeps those through an innerHTML swap). Captured by table index here, written back once the frozen class is on.
  const tableScroll = Array.from(editor.querySelectorAll('.md-table-scroll'), s => ({ top: s.scrollTop, left: s.scrollLeft }));
  const lines = text.split('\n');
  const htmlParts = [];
  ensureVideoEmbedStyles();   // inject player CSS once (self-contained, no styles.css dependency)

  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    // ── Fenced mermaid block: ```mermaid … ``` ──
    // Fenced video block ```video[ s|l] <url> ``` -> inline PLAYER (the "preview"
    // form). Mirrors the mermaid branch. A bare video URL (no fence) is the LINK
    // form instead; the Preview/Link toggles rewrite this fence <-> the bare URL.
    // An optional size token on the info-string (s / l; M is bare) sizes the player.
    const vfence = line.trim();
    if (vfence === '```video' || vfence.startsWith('```video ')) {
      const szTok = vfence.slice(8).trim().toLowerCase();          // after "```video"
      const vsize = (szTok === 's' || szTok === 'l') ? szTok : 'm';
      let j = i + 1; const vsrc = [];
      while (j < lines.length && lines[j].trim() !== '```') { vsrc.push(lines[j]); j++; }
      if (j >= lines.length) { htmlParts.push(`<div>${escapeHtmlForEditor(line)}</div>`); i++; continue; }
      const vurl = vsrc.join('\n').trim();
      const vp = parseVideoEmbed(vurl);
      htmlParts.push(vp ? renderVideoEmbedBlock(vurl, vp, vsize) : `<div>${renderFreeInline(vurl)}</div>`);
      i = j + 1;
      continue;
    }
    // Fenced PDF block: ```pdf (link form, 📄 name + Preview) or ```pdf open (the
    // preview form, restored when a viewer was left open). Body line 1 = the storage
    // filename, remaining lines = the display name. An open preview is hydrated after
    // render (see below). Mirrors mermaid's unterminated-fence guard (render as plain
    // text if there is no closing ```).
    if (vfence === '```pdf' || vfence === '```pdf open') {
      const isOpen = vfence === '```pdf open';
      let j = i + 1; const pbody = [];
      while (j < lines.length && lines[j].trim() !== '```') { pbody.push(lines[j]); j++; }
      if (j >= lines.length) { htmlParts.push(`<div>${escapeHtmlForEditor(line)}</div>`); i++; continue; }
      const pfile = (pbody[0] || '').trim();
      const pname = _pdfDisplayName(pbody.slice(1).join(' '));
      htmlParts.push(pfile ? (isOpen ? renderPdfEmbedBlock(pfile, pname) : renderPdfLinkBlock(pfile, pname)) : `<div>${renderFreeInline(pbody.join('\n'))}</div>`);
      i = j + 1;
      continue;
    }
    // Fenced uploaded-video block: ```videofile. Body line 1 = storage filename, the
    // rest = display name. Rendered as a <video> hydrated after render (the SW streams
    // it). Unterminated-fence guard like ```pdf (render as plain text if no closing ```).
    if (vfence === '```videofile') {
      let j = i + 1; const vbody = [];
      while (j < lines.length && lines[j].trim() !== '```') { vbody.push(lines[j]); j++; }
      if (j >= lines.length) { htmlParts.push(`<div>${escapeHtmlForEditor(line)}</div>`); i++; continue; }
      const vfile = (vbody[0] || '').trim();
      const vname = _videoDisplayName(vbody.slice(1).join(' '));
      htmlParts.push(vfile ? renderVideoFileBlock(vfile, vname) : `<div>${renderFreeInline(vbody.join('\n'))}</div>`);
      i = j + 1;
      continue;
    }
    if (line.trim() === '```mermaid') {
      let j = i + 1;
      const srcLines = [];
      while (j < lines.length && lines[j].trim() !== '```') {
        srcLines.push(lines[j]);
        j++;
      }
      // No closing ``` found → user is mid-typing. Render the lines as
      // plain text instead of trying to render an unclosed block (which
      // would fail and leave the user with a confusing error).
      if (j >= lines.length) {
        htmlParts.push(`<div>${escapeHtmlForEditor(line)}</div>`);
        i++;
        continue;
      }
      const src = srcLines.join('\n');
      const escSrc = escapeHtmlForEditor(src);
      // contenteditable=false makes the block atomic — cursor sits before/
      // after, Backspace deletes the whole block. focusin (in ui.js)
      // expands it back to source lines when the editor is being edited.
      htmlParts.push(`<div class="mermaid-block" contenteditable="false" data-source="${escSrc}"><div class="mermaid-loading">⏳ Rendering diagram…</div></div>`);
      i = j + 1; // skip past the closing ```
      continue;
    }

    // ── Fenced Excalidraw block: ```excalidraw … ``` ──
    // Body is single-line minified scene JSON. Mirrors the mermaid branch:
    // atomic contenteditable=false block carrying the verbatim JSON in
    // data-source; renderExcalidrawBlock (excalidraw.js) async-renders a
    // static SVG preview + the ✎ edit / ⋮ source buttons.
    if (line.trim() === '```excalidraw') {
      let j = i + 1;
      const srcLines = [];
      while (j < lines.length && lines[j].trim() !== '```') {
        srcLines.push(lines[j]);
        j++;
      }
      // No closing ``` → user mid-typing; render the opening line as plain text.
      if (j >= lines.length) {
        htmlParts.push(`<div>${escapeHtmlForEditor(line)}</div>`);
        i++;
        continue;
      }
      const src = srcLines.join('\n');
      const escSrc = escapeHtmlForEditor(src);
      // PER-COPY lesson MARKER (SPEC §10): a `<!-- tt-lesson v=1 hash=<8hex>
      // url="…" -->` on the line immediately after the closing fence links THIS
      // copy's diagram to its generated video (E writes it; C's share carries it).
      // Parse + stash it on the block (data-lesson-*) so excalidraw-video.js can
      // decide the toggle, and CONSUME the line so it never renders as literal
      // text. getEditorContent re-emits it byte-identical, so it survives edits.
      let next = j + 1;
      let lessonAttrs = '';
      // ROUND 5 (video-editor, 2026-10-29): a diagram can carry SEVERAL videos - one marker line per VARIANT (its config:
      // language · voice · mode · opening), CONSECUTIVE lines right after the fence; a blank line or prose ends the run.
      //   v=1 hash=<content-hash> (legacy) | v=2 nhash=<narration-hash> (legacy) | v=3 nhash=<narration-hash>
      //   config="<key>" label="<words>" url="..." (written on every generate since round 5; the MCP's diagram-text.js
      //   is the writer, this regex is its mirror - attribute order fixed; key and label never hold a double quote).
      // ALL lines are stashed on the block as data-lessons (a JSON array in file order: { v, hash, url, config, label },
      // config / label null on a legacy line) - excalidraw-video.js lists the variants from it; data-lesson-v/hash/url
      // stay = the FIRST line, so every reader of the single-marker days keeps working. getEditorContent re-emits every
      // line byte-identical, in order (parseLessonMarkers / lessonMarkerLine below are the one pair).
      const run = parseLessonMarkers(lines, next);
      if (run.length) {
        const first = run[0];
        lessonAttrs = ` data-lesson-v="${escapeHtmlForEditor(first.v)}" data-lesson-hash="${escapeHtmlForEditor(first.hash)}" data-lesson-url="${escapeHtmlForEditor(first.url)}" data-lessons="${escapeHtmlForEditor(JSON.stringify(run))}"`;
        next = j + 1 + run.length;   // consume every marker line of the run
      }
      htmlParts.push(`<div class="excalidraw-block" contenteditable="false" data-source="${escSrc}"${lessonAttrs}><div class="excalidraw-loading">⏳ Rendering diagram…</div></div>`);
      i = next; // skip past the closing ``` (and the marker if present)
      continue;
    }

    // ── Markdown table: header row `| a | b |` followed by separator
    //    row `| --- | --- |` (with optional `:` alignment markers). Body
    //    rows are any subsequent lines that look like table rows; we stop
    //    at the first non-table line. Empty lines terminate the table. ──
    // The table may be preceded by a `<!--cols:w,w,…-->` width comment (markdown
    // has no width syntax, so drag-set widths persist as this comment). It's
    // stored LEADING so a row typed at the bottom in ⋮-source mode stays
    // contiguous with the body and re-parses into the table rather than being
    // orphaned below the comment.
    // Consume any run of leading HTML comments before the header:
    //   <!--cols:w,w,…-->  drag-set column widths
    //   <!--tv:BASE64-->   sort + per-column filters (display-only view state)
    let cmScan = i, colsRaw = null, tvRaw = null;
    while (cmScan < lines.length) {
      const cm = lines[cmScan].match(/^\s*<!--\s*(cols|tv):\s*(.*?)\s*-->\s*$/);
      if (!cm) break;
      if (cm[1] === 'cols') colsRaw = cm[2];
      else tvRaw = lines[cmScan].trim();   // keep the whole comment for re-emit
      cmScan++;
    }
    const hdrIdx = cmScan;
    if (isMdTableRow(lines[hdrIdx]) && hdrIdx + 1 < lines.length && isMdTableSeparator(lines[hdrIdx + 1])) {
      const headerCells = parseMdTableRow(lines[hdrIdx]);
      const aligns = parseMdTableAlignment(lines[hdrIdx + 1]);
      const bodyRows = [];
      let j = hdrIdx + 2;
      while (j < lines.length && isMdTableRow(lines[j]) && !isMdTableSeparator(lines[j])) {
        bodyRows.push(parseMdTableRow(lines[j]));
        j++;
      }
      // True column count spans header AND body — a hand-written ragged row
      // (fewer/more cells than the header) must not mis-map under fixed layout.
      const colCount = Math.max(headerCells.length, ...bodyRows.map(r => r.length));
      // Resolve widths from the cols comment; drop if its count no longer matches
      // the table (stale, e.g. after a raw-source column edit).
      let colWidths = null;
      if (colsRaw) {
        const ws = colsRaw.split(',').map(s => parseFloat(s.trim()));
        if (ws.length === colCount && ws.every(n => n > 0)) colWidths = ws;
      }
      const view = tvDecode(tvRaw);                 // sort + filters (display-only)
      const showTv = bodyRows.length >= 2;          // sort/filter only matters with ≥2 rows
      // Rebuild canonical leading comments (valid cols, then tv) + the table rows
      // as the stored source so both round-trip through save/re-render; a stale
      // cols comment is dropped by not being re-added.
      const keep = [];
      if (colWidths) keep.push('<!--cols:' + colWidths.map(w => Math.round(w)).join(',') + '-->');
      if (tvRaw) keep.push(tvRaw);
      const srcLines = keep.concat(lines.slice(hdrIdx, j));
      const escSrc = escapeHtmlForEditor(srcLines.join('\n'));
      const colgroup = colWidths
        ? '<colgroup>' + colWidths.map(w => `<col style="width:${Math.round(w)}px">`).join('') + '</colgroup>'
        : '';
      const tblOpen = colWidths
        ? `<table class="md-table md-table-fixed" style="width:${Math.round(colWidths.reduce((a, b) => a + b, 0))}px">`
        : '<table class="md-table">';
      let tbl = tblOpen + colgroup + '<thead><tr>';
      // Render every row padded to colCount so the colgroup, header and body
      // all share one column count and fixed-layout cells line up correctly.
      for (let idx = 0; idx < colCount; idx++) {
        const c = headerCells[idx] != null ? headerCells[idx] : '';
        const style = aligns[idx] ? ` style="text-align:${aligns[idx]}"` : '';
        // Sort/filter affordances (≥2 rows only). They're contenteditable=false
        // so they don't become editable header text, and cellToMarkdown skips
        // the .tv-th-ctrls wrapper so the header markdown stays clean.
        let ctrls = '';
        if (showTv) {
          const sdir = (view.sort && view.sort.ci === idx) ? view.sort.dir : '';
          const filtered = !!(view.filters && view.filters['' + idx]);
          const glyph = sdir === 'asc' ? '▲' : (sdir === 'desc' ? '▼' : '↕');
          ctrls = '<span class="tv-th-ctrls" contenteditable="false">'
            + `<span class="tv-sort${sdir ? ' tv-on' : ''}" data-ci="${idx}" title="Sort (click to cycle)">${glyph}</span>`
            + `<span class="tv-filter${filtered ? ' tv-on' : ''}" data-ci="${idx}" title="Filter values">▾</span>`
            + '</span>';
        }
        // Cell is contenteditable=true even though the wrapping block is
        // contenteditable=false — user clicks the cell to edit just that cell's
        // content. The trailing .md-col-resize handle (no text) sits on the
        // right border for drag-to-resize.
        tbl += `<th${style} data-ci="${idx}" contenteditable="true">${renderMdTableCellHtml(c.replace(/^(?:\s*<br>)+|(?:<br>\s*)+$/gi, ''))}${ctrls}<span class="col-resize md-col-resize" contenteditable="false" data-ci="${idx}" title="Drag to resize column"></span></th>`;
      }
      tbl += '</tr></thead>';
      if (bodyRows.length) {
        // Display order: filters hide non-matching rows; sort reorders them. Each
        // row carries data-ri (its ORIGINAL index) so cell edits + serialization
        // stay canonical; filtered-out rows stay in the DOM (display:none) and so
        // are never lost on save.
        // Only apply the view when its controls are actually shown (≥2 rows);
        // otherwise a stale filter could hide the last row(s) with no ▾ to clear
        // it. The tv comment is kept, so the view re-applies once rows grow back.
        const visible = showTv ? bodyRows.map(cells => tvRowMatches(cells, view.filters, colCount)) : bodyRows.map(() => true);
        let order = bodyRows.map((_, ri) => ri);
        if (showTv && view.sort && view.sort.ci < colCount) {
          const sci = view.sort.ci, sdir = view.sort.dir;
          order = order.slice().sort((a, b) =>
            tvCompare(tvCellText(bodyRows[a][sci] || ''), tvCellText(bodyRows[b][sci] || ''), sdir));
        }
        tbl += '<tbody>';
        order.forEach(ri => {
          const row = bodyRows[ri];
          const hid = visible[ri] ? '' : ' class="tv-row-hidden"';
          tbl += `<tr data-ri="${ri}"${hid}>`;
          for (let idx = 0; idx < colCount; idx++) {
            const cell = row[idx] != null ? row[idx] : '';
            const style = aligns[idx] ? ` style="text-align:${aligns[idx]}"` : '';
            tbl += `<td${style} contenteditable="true">${renderMdInline(cell)}</td>`;
          }
          tbl += '</tr>';
        });
        tbl += '</tbody>';
      }
      tbl += '</table>';
      // ☰ menu (top-right): Copy / Delete (Rishabh 2026-09-24 - one icon instead of the
      // standalone ⋮ source + ✕ Table buttons; notes-tables-menu.js). Also shown in read-only, where it offers Copy.
      const menuBtn = '<button class="md-table-menu" type="button" title="Table menu - copy, edit source, delete" tabindex="-1" contenteditable="false">☰</button>';
      // ❄ Freeze header — caps the table height and pins the header while
      // scrolling (toggled per table; state in localStorage, applied on render
      // below). Outside .md-table-ctrls so it's reachable in read-only too.
      const freezeBtn = '<button class="md-table-freeze" type="button" title="Freeze header row (scroll the table inside a window)" tabindex="-1" contenteditable="false">❄</button>';
      // Clear-all-sort/filter — shown ONLY when a view is active. Lives in the
      // block top area (NOT in .md-table-ctrls, which is hidden in read-only) so
      // it's reachable in read-only too, where sort/filter now work.
      const viewActive = !!(showTv && (view.sort || (view.filters && Object.keys(view.filters).length)));
      const clearViewBtn = viewActive
        ? '<button class="md-table-clear-view" type="button" title="Clear all sort + filters" tabindex="-1" contenteditable="false">⤬ Clear sort/filter</button>'
        : '';
      const tblCtrls = '<div class="md-table-ctrls" contenteditable="false">'
        + '<button class="md-tbl-btn" type="button" data-act="addrowup" title="Add a row above the one your cursor is in (else at the top)" tabindex="-1">+ Row ↑</button>'
        + '<button class="md-tbl-btn" type="button" data-act="addrow" title="Add a row below the one your cursor is in (else at the end)" tabindex="-1">+ Row ↓</button>'
        + '<button class="md-tbl-btn" type="button" data-act="delrow" title="Remove the row your cursor is in (else the last)" tabindex="-1">− Row</button>'
        + '<button class="md-tbl-btn" type="button" data-act="addcolleft" title="Add a column to the left of the one your cursor is in (else at the start)" tabindex="-1">+ Col ←</button>'
        + '<button class="md-tbl-btn" type="button" data-act="addcol" title="Add a column to the right of the one your cursor is in (else at the end)" tabindex="-1">+ Col →</button>'
        + '<button class="md-tbl-btn" type="button" data-act="delcol" title="Remove the column your cursor is in (else the last)" tabindex="-1">− Col</button>'
        + '<button class="md-tbl-btn" type="button" data-act="fitcols" title="Auto-fit each column width to its content" tabindex="-1">↔ Fit</button>'
        + '<button class="md-tbl-btn" type="button" data-act="clearcells" title="Clear all cell text (keeps the columns + headers)" tabindex="-1">⌫ Clear</button>'
        + '</div>';
      const topTools = `<div class="md-table-tools" contenteditable="false">${freezeBtn}${menuBtn}</div>`;
      htmlParts.push(`<div class="md-table-block" contenteditable="false" data-source="${escSrc}">${clearViewBtn}${topTools}${tblCtrls}<div class="md-table-scroll">${tbl}</div></div>`);
      i = j;
      continue;
    }

    if (line === '') { htmlParts.push('<div><br></div>'); i++; continue; }

    // Aligned line — stored as <div align="center|right">…</div> (markdown has no
    // alignment syntax, so alignment is persisted as this HTML wrapper). Inner
    // text still gets heading/inline treatment; getEditorContent round-trips it.
    const alignM = line.match(/^<div align="(center|right)">([\s\S]*)<\/div>$/);
    if (alignM) {
      const al = alignM[1];
      const inner = alignM[2];
      const ah = inner.match(/^(#{1,6})(\s+)(.*)$/);
      if (ah) {
        htmlParts.push(`<div class="md-head md-h${ah[1].length}" style="text-align:${al}"><span class="md-hash">${ah[1]}</span>${ah[2]}${renderFreeInline(ah[3])}</div>`);
      } else {
        htmlParts.push(`<div style="text-align:${al}">${renderFreeInline(inner) || '<br>'}</div>`);
      }
      i++;
      continue;
    }

    // Heading line (# / ## / ### …) — render bigger/bolder so the box reads like
    // a clean document. The `#` markers are KEPT (in a dimmed span), so
    // getEditorContent reads back identical textContent — the markdown round-trips
    // byte-for-byte and saving is unaffected. Display-only styling.
    const hMatch = line.match(/^(#{1,6})(\s+)(.*)$/);
    if (hMatch) {
      const level = hMatch[1].length;
      const rest = renderFreeInline(hMatch[3]);
      htmlParts.push(`<div class="md-head md-h${level}"><span class="md-hash">${hMatch[1]}</span>${hMatch[2]}${rest}</div>`);
      i++;
      continue;
    }

    // Whole-line video URL -> compact LINK form (the default), checked before the
    // inline/pill path so it renders as the video link block (with a Preview toggle)
    // rather than a plain url-pill. Only a line that is ENTIRELY a single video URL
    // qualifies (parseVideoEmbed uses new URL(), which fails on prose); a URL inside
    // text stays a normal pill. The PLAYER form lives in a ```video fence (above);
    // the Preview/Link toggles swap between the two.
    // Only an UNINDENTED whole-line URL becomes a link block. An indented URL is
    // nested content (e.g. under a list item), so leave it to the normal pill path
    // and keep its leading indent - converting would store it trimmed and drift the
    // indent away on the next serialize.
    const vtrim = line.trim();
    if (vtrim && !/^\s/.test(line) && parseVideoEmbed(vtrim)) { htmlParts.push(renderVideoLinkBlock(vtrim)); i++; continue; }

    let out = '';
    let last = 0;
    const combined = new RegExp(NOTES_IMG_TOKEN_RE.source, 'g');
    let m;
    while ((m = combined.exec(line)) !== null) {
      out += renderFreeInline(line.slice(last, m.index));
      out += renderImageToken(m);
      last = m.index + m[0].length;
    }
    out += renderFreeInline(line.slice(last));
    htmlParts.push(`<div>${out || '<br>'}</div>`);
    i++;
  }

  editor.innerHTML = htmlParts.join('');

  // Guarantee a caret spot above a leading atomic block and below a trailing one.
  ensureEditableEdges(editor);

  // Resolve images to local object URLs via the reliable fetch shim (no service
  // worker needed). Fire-and-forget; cached so re-renders are instant + flash-free.
  hydrateImages(editor);

  // Wire the video controls (mousedown+preventDefault so they never drop the caret
  // or blur the editor). Bound to freshly-rendered buttons, discarded on the next
  // innerHTML render (no listener leak). Each swap replaces the node with the other
  // form and re-renders in place so the button handlers rebind. In EDIT mode the
  // input event also persists the choice (player -> ```video fence, link -> bare
  // URL line). In READ-ONLY the swap is transient (view-only): Preview + collapse
  // let a viewer watch inline, but no input is dispatched (nothing to persist, and
  // the /save shim swallows writes anyway) and Remove is inert. The S/M/L size
  // buttons resize the player IN PLACE (class swap only, no re-render) so the iframe
  // never reloads; the new size persists via getEditorContent's fence info-string.
  editor.querySelectorAll('.veb-remove, .veb-tolink, .veb-topreview, .veb-szb').forEach(btn => {
    btn.addEventListener('mousedown', (e) => {
      e.preventDefault(); e.stopPropagation();
      const ro = !!(document.body && document.body.classList.contains('tt-readonly'));
      if (btn.classList.contains('veb-szb')) {                               // resize (in place)
        const block = btn.closest('.video-embed-block'); const sz = btn.dataset.sz;
        if (!block || !sz) return;
        block.classList.remove('veb-s', 'veb-l');
        if (sz === 's') block.classList.add('veb-s'); else if (sz === 'l') block.classList.add('veb-l');
        block.querySelectorAll('.veb-szb').forEach(b => b.classList.toggle('veb-sz-on', b.dataset.sz === sz));
        if (!ro) editor.dispatchEvent(new Event('input'));
        return;
      }
      if (btn.classList.contains('veb-remove')) {                            // remove (edit only)
        if (ro) return;
        const block = btn.closest('.video-embed-block');
        if (block) { block.remove(); editor.dispatchEvent(new Event('input')); }
      } else if (btn.classList.contains('veb-tolink')) {                     // player -> link
        const block = btn.closest('.video-embed-block'); const url = block && block.dataset.url;
        if (!block || !url) return;
        const d = document.createElement('div'); d.textContent = url;
        block.replaceWith(d);
        setEditorContent(editor, getEditorContent(editor));
        if (!ro) editor.dispatchEvent(new Event('input'));
      } else if (btn.classList.contains('veb-topreview')) {                  // link -> player
        const block = btn.closest('.video-link-block'); const url = block && block.dataset.url;
        const parsed = url && parseVideoEmbed(url);
        if (!block || !parsed) return;
        const tmp = document.createElement('div'); tmp.innerHTML = renderVideoEmbedBlock(url, parsed);
        block.replaceWith(tmp.firstChild);
        setEditorContent(editor, getEditorContent(editor));
        if (!ro) editor.dispatchEvent(new Event('input'));
      }
    });
  });

  // Wire the PDF link<->preview toggle + remove (see _wirePdfControls: swaps in
  // place, not a full re-render, to avoid rebuilding the editor + disrupting the
  // caret - a UX choice, since an opened preview persists as a ```pdf open fence).
  _wirePdfControls(editor);
  // Load any preview that was left open (persisted as ```pdf open) - SW-independent.
  editor.querySelectorAll('.pdf-embed-block').forEach(hydratePdfFrame);
  // Wire + hydrate uploaded-video blocks (points each <video> at /load; the SW
  // streams it with Range - see sw.js serveVideo).
  _wireVideoFileControls(editor);
  editor.querySelectorAll('.video-file-block').forEach(hydrateVideoFile);

  // Async-render all mermaid blocks in the background. setEditorContent
  // doesn't await — placeholders show "Rendering…" until each SVG arrives.
  editor.querySelectorAll('.mermaid-block').forEach(b => {
    renderMermaidBlock(b).catch(() => {});
  });

  // Async-render Excalidraw blocks (excalidraw.js, lazy-loaded). Guarded so a
  // failure to load excalidraw.js never breaks the rest of the editor render.
  if (typeof renderExcalidrawBlock === 'function') {
    editor.querySelectorAll('.excalidraw-block').forEach(b => {
      renderExcalidrawBlock(b).catch(() => {});
    });
  }

  // Wire markdown tables: each cell is contenteditable, and every keystroke
  // rebuilds the block's data-source so the save round-trip captures edits.
  // The ⋮ button expands THAT block to raw pipe-syntax for adding rows etc.
  editor.querySelectorAll('.md-table-block').forEach((block, blockIdx) => {
    // Apply the persisted "freeze header" state for this table (box id + index).
    const fzBtn = block.querySelector('.md-table-freeze');
    if (isTableFrozen(editor.dataset.boxId, blockIdx)) {
      block.classList.add('md-table-frozen');
      if (fzBtn) fzBtn.classList.add('active');
    }
    if (fzBtn) {
      // mousedown+preventDefault like the other block controls so the click never
      // drops a caret into the block or blurs the editor. Display-only (localStorage
      // + a class toggle, no save), so it also works in read-only.
      fzBtn.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const ed = block.closest('.notes-editor');
        const ix = ed ? Array.prototype.indexOf.call(ed.querySelectorAll('.md-table-block'), block) : -1;
        const on = !block.classList.contains('md-table-frozen');
        setTableFrozen(ed ? ed.dataset.boxId : '', ix, on);
        block.classList.toggle('md-table-frozen', on);
        fzBtn.classList.toggle('active', on);
        fitFrozenTableWindow(block);   // the window's height follows where it sits (notes-tables.js)
      });
    }
    block.querySelectorAll('th[contenteditable="true"], td[contenteditable="true"]').forEach(cell => {
      cell.addEventListener('input', () => updateMdTableDataSource(block));
    });
    // Drag-to-resize: each header's right-edge handle widens/narrows its column.
    block.querySelectorAll('.md-col-resize').forEach(h => {
      h.addEventListener('mousedown', (e) => startNotesColResize(e, block, h));
    });
    // Sort / filter header controls (display-only). mousedown+preventDefault so
    // clicking them never drops a caret into the header or blurs the editor.
    block.querySelectorAll('.tv-sort').forEach(el => {
      el.addEventListener('mousedown', (e) => {
        e.preventDefault(); e.stopPropagation();
        tvCycleSort(block, parseInt(el.dataset.ci, 10));
      });
    });
    block.querySelectorAll('.tv-filter').forEach(el => {
      el.addEventListener('mousedown', (e) => {
        e.preventDefault(); e.stopPropagation();
        tvOpenFilter(block, parseInt(el.dataset.ci, 10), el);
      });
    });
    const menu = block.querySelector('.md-table-menu');
    if (menu) menu.addEventListener('mousedown', (e) => openNotesTableMenu(e, block));   // mousedown: the caret + selection stay where they are
    // Clear all sort + filters in one click (mousedown like the sort/filter
    // glyphs, so read-only's click/beforeinput guards never touch it).
    const cv = block.querySelector('.md-table-clear-view');
    if (cv) {
      cv.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        tvWriteView(block, { sort: null, filters: {} });   // empty view ⇒ tv comment dropped on re-render
      });
    }
    // +/− Row/Col controls. mousedown+preventDefault so the click doesn't move
    // focus into the (contenteditable=false) block before we re-render it — the
    // caret stays in whatever cell the user last clicked, which is how − Row/Col
    // know WHICH row/column to delete (captured before the re-render).
    block.querySelectorAll('.md-tbl-btn').forEach(b => {
      b.addEventListener('mousedown', (e) => {
        const target = activeTableCell(block);   // caret's cell, before preventDefault
        e.preventDefault();
        e.stopPropagation();
        // `target` is also the caret to put back after the rebuild (Rishabh 2026-09-24: "user ka context lose ho jaata hai").
        const act = b.dataset.act;
        if (act === 'addrow') mdTableAddRow(block, target ? target.bodyRowIndex : null, false, target);
        else if (act === 'addrowup') mdTableAddRow(block, target ? target.bodyRowIndex : null, true, target);
        else if (act === 'delrow') mdTableRemoveRow(block, target ? target.bodyRowIndex : null, target);
        else if (act === 'addcolleft') mdTableAddCol(block, target ? target.colIndex : null, true, target);
        else if (act === 'addcol') mdTableAddCol(block, target ? target.colIndex : null, false, target);
        else if (act === 'delcol') mdTableRemoveCol(block, target ? target.colIndex : null, target);
        else if (act === 'fitcols') autoFitNotesTableColumns(block);
        else if (act === 'clearcells') mdTableClearAll(block, target);
      });
    });
  });
  editor.querySelectorAll('.md-table-scroll').forEach((s, i) => {
    const k = tableScroll[i];                 // a table that did not exist before the rebuild has nothing to restore
    if (k) { s.scrollTop = k.top; s.scrollLeft = k.left; }
  });
  // A frozen table's window is no taller than what is visible below it (notes-tables.js fitFrozenTableWindow): its
  // bottom edge - the horizontal scrollbar - and a row added at its end stay on screen. Scroll / resize re-fit it.
  fitFrozenTableWindows(editor);
  wireFrozenTableWindowFit(editor);
  _editorRendered.set(editor, getEditorContent(editor));   // the baseline the blur handler compares against
}

// Render one mermaid block: validate the source via mermaid.parse() FIRST
// (with suppressErrors so it never throws or injects DOM nodes), and only
// call mermaid.render() if the syntax is valid. Falls back gracefully to a
// preformatted source + error message on any failure. After rendering, a
// "⋮ source" button is attached on top so the user can switch the block
// to raw-source editing on demand (same pattern as md-table-block).
async function renderMermaidBlock(block) {
  const src = block.dataset.source || '';
  let renderedHtml = '';
  // Fix-2 Slice 1: mermaid is lazy-loaded here (not at boot). Load it on the first
  // block render; a CDN failure leaves `mermaid` undefined -> the existing fallback below.
  try { await ensureMermaid(); } catch (_) {}
  if (typeof mermaid === 'undefined') {
    renderedHtml = `<pre class="mermaid-fallback">${escapeHtmlForEditor(src)}</pre>` +
      `<div class="mermaid-error">⚠ Mermaid library not loaded (check internet / CDN)</div>`;
  } else if (!src.trim()) {
    renderedHtml = `<div class="mermaid-error">⚠ Empty mermaid block</div>`;
  } else {
    // Validate without rendering — catches "Donation -->|" type incomplete
    // syntax before mermaid's render path can leak DOM artifacts.
    let parseError = null;
    try {
      const ok = await mermaid.parse(src, { suppressErrors: true });
      if (ok === false || ok === null) parseError = new Error('Invalid mermaid syntax');
    } catch (e) {
      parseError = e;
    }
    if (parseError) {
      renderedHtml = `<pre class="mermaid-fallback">${escapeHtmlForEditor(src)}</pre>` +
        `<div class="mermaid-error">⚠ ${escapeHtmlForEditor(String(parseError.message || parseError))}</div>`;
      cleanupOrphanMermaidNodes();
    } else {
      const id = 'mermaid_' + Math.random().toString(36).slice(2, 9);
      try {
        const out = await mermaid.render(id, src);
        renderedHtml = out.svg;
      } catch (e) {
        renderedHtml = `<pre class="mermaid-fallback">${escapeHtmlForEditor(src)}</pre>` +
          `<div class="mermaid-error">⚠ ${escapeHtmlForEditor(String(e && e.message || e))}</div>`;
      } finally {
        cleanupOrphanMermaidNodes();
      }
    }
  }
  // Always also include the ⋮ source button so the user can explicitly drop
  // into raw-mermaid editing. The block stays as a rendered diagram on
  // focus/scroll — no more auto-expansion the moment the editor is touched.
  block.innerHTML = renderedHtml +
    `<button class="mermaid-edit-src" type="button" title="Edit raw mermaid source" tabindex="-1">⋮ source</button>`;
  const btn = block.querySelector('.mermaid-edit-src');
  if (btn) {
    // mousedown (not click) so the editor doesn't focus into the block
    // before we replace it — that focus would land on a now-orphan node.
    btn.addEventListener('mousedown', (e) => {
      e.preventDefault();
      e.stopPropagation();
      expandMermaidBlock(block);
    });
  }
}

// Remove any temporary nodes Mermaid leaves behind on the <body> when a
// render fails — typically a hidden <div id="dmermaid_…"> wrapper or a
// stray error SVG. Safe to call after every render attempt.
function cleanupOrphanMermaidNodes() {
  document.querySelectorAll('body > [id^="dmermaid_"], body > [id^="dmermaid-"]').forEach(el => {
    if (!el.closest('.mermaid-block')) el.remove();
  });
}

// Replace ONE .mermaid-block with its raw ```mermaid``` source code as
// editable lines — invoked by the per-block ⋮ source button so the user
// can explicitly drop into mermaid-source editing. On editor blur, the
// re-render via setEditorContent turns the lines back into an SVG block.
function expandMermaidBlock(block) {
  const src = block.dataset.source || '';
  const text = '```mermaid\n' + src + '\n```';
  const lines = text.split('\n');
  const frag = document.createDocumentFragment();
  lines.forEach(line => {
    const d = document.createElement('div');
    if (line === '') d.appendChild(document.createElement('br'));
    else d.textContent = line;
    frag.appendChild(d);
  });
  block.replaceWith(frag);
}
// Bulk version — kept for symmetry with the markdown-table API but no
// longer fires on focusin. Touching the editor (scroll, click padding, tab)
// won't collapse a rendered diagram anymore; the ⋮ source button is the
// only thing that flips a block into raw-source mode.
function expandMermaidBlocks(container) {
  if (!container) return;
  container.querySelectorAll('.mermaid-block').forEach(expandMermaidBlock);
}
// Inline markdown applied to table cell text: escape HTML, then bold
// `**text**` → <strong>, then linkify URLs into pills, then restore intra-cell
// line breaks. Italic intentionally left out — single `*` shows up too often in
// plain text and would misfire.
// Apply inline markdown — **bold** → <strong> and `code` → <code> — to an
// ALREADY-HTML-ESCAPED string, returning HTML. Italic is deliberately NOT
// handled: a lone * — and _ inside snake_case identifiers like GCP_PROJECT_ID —
// misfires far too often in technical prose. Because getEditorContent and
// cellToMarkdown invert <strong>/<code> back to ** and `, this is a display-only
// transform that round-trips the saved markdown byte-for-byte.
//
// `code` spans are extracted FIRST into opaque placeholders, then ** is applied,
// then the code spans are restored. Two reasons:
//   (1) markdown code is literal — no **bold** rendered inside a code span;
//   (2) ROUND-TRIP SAFETY (critical): running the ** and ` regexes as two naive
//       independent passes emits IMPROPERLY-NESTED tags whenever a bold and a
//       code span overlap (e.g. **`**`**  →  <strong><code></strong></code>).
//       The browser's innerHTML parser silently re-balances such markup, and
//       getEditorContent would then serialize a DIFFERENT markdown string —
//       corrupting the saved note. Extracting code first makes each code span an
//       atomic token (no * or ` inside), so the ** pass can never interleave with
//       it and every restored <code> lands wholly inside or wholly outside a
//       <strong> — always valid nesting, so the tree (and the saved markdown) is
//       exactly what the user typed.
function applyInlineMd(escaped) {
  // Bold content may contain a LONE * (e.g. **note *Product Usage* here**) — common
  // in prose — but never **; the alternation matches a non-* OR a * not followed by
  // another *, so a single * is allowed inside while ** always closes the span. (A
  // char is either * or not, and *(?!*) is exclusive, so no ambiguous backtracking.)
  // On NON-code text: apply **bold**, then un-escape the inline tags the
  // Italic/Underline buttons persist as literal HTML — <em> and <u>. Two guards:
  //  (1) scoped to non-code segments, so a literal <em> inside a `code span`
  //      stays literal text and a tag can't straddle a code boundary;
  //  (2) only BALANCED pairs (<em>…</em>) are un-escaped — the buttons always
  //      produce balanced tags, so a LONE or unbalanced <em>/</em> a user TYPES
  //      (e.g. notes documenting HTML) stays literal text and is never hijacked
  //      into live formatting or corrupted on save. [/] is a literal slash.
  // Colored span: the serializer wrote a CANONICAL <span style="color:#rrggbb">,
  // escapeHtmlForEditor then turned < > " into entities, so we match the escaped
  // form and un-escape ONLY when the captured value is a strict #hex — never
  // reflect arbitrary attribute text back as live HTML (XSS / attr-injection).
  const fmt = (t) => t.replace(/[*][*]((?:[*](?![*])|[^*])+?)[*][*]/g, '<strong>$1</strong>')
                      .replace(/&lt;em&gt;(.*?)&lt;[/]em&gt;/g, '<em>$1</em>')
                      .replace(/&lt;u&gt;(.*?)&lt;[/]u&gt;/g, '<u>$1</u>')
                      .replace(/&lt;span style=&quot;color:(#[0-9a-f]{6})&quot;&gt;(.*?)&lt;[/]span&gt;/gi, '<span style="color:$1">$2</span>');
  const re = /`([^`]+?)`/g;
  let out = '', last = 0, m;
  while ((m = re.exec(escaped)) !== null) {
    out += fmt(escaped.slice(last, m.index));       // text BEFORE this code span
    out += '<code>' + m[1] + '</code>';             // the code span itself -> literal, untouched
    last = m.index + m[0].length;
  }
  out += fmt(escaped.slice(last));                  // trailing text after the last code span
  return out;
}

// Inline render for FREE-TEXT lines (outside tables): escape → bold/code →
// linkify. No <br>-restore step (free text keeps each line in its own <div>, so
// there are no literal <br> markers within a line the way table cells have).
function renderFreeInline(raw) {
  return linkifyUrls(applyInlineMd(escapeHtmlForEditor(raw)));
}

// A table CELL's inline html. An EMPTY header cell must still hold a caret slot: its only other children are the
// sort / filter controls and the resize handle (contenteditable=false), so a click on the empty cell had no editable
// position to land on - the selection fell outside the block and typing went nowhere (Rishabh 2026-09-28, prod:
// "+ Col, can't type in the column header"). A <br> is that slot; cellToMarkdown reads it back as '' (br -> space,
// trimmed), so the saved markdown stays empty until the user types.
// The two markdown forms of an image (notes-editor-serialize.js imageNodeToMarkdown): `<img src=… width=… height=…>`
// (sized) and `![alt](file)`. ONE renderer for both, used by the free-text line and by the table cell.
const NOTES_IMG_TOKEN_RE = /(<img[^>]+>)|(!\[([^\]]*)\]\(([^)]+)\))/;
function renderImageToken(m) {
  if (m[1]) {
    const tag = m[1];
    const srcM = tag.match(/src=["']([^"']+)["']/);
    const wM = tag.match(/width=["']?(\d+)/);
    const hM = tag.match(/height=["']?(\d+)/);
    let file = srcM ? srcM[1] : '';
    file = file.replace(/^\/load\?file=/, '').replace(/^.*\//, '');
    try { file = decodeURIComponent(file); } catch (_) {}
    return renderImageWrap(file, wM ? parseInt(wM[1], 10) : null, hM ? parseInt(hM[1], 10) : null);
  }
  return renderImageWrap(m[4].trim(), null, null);
}
function renderMdTableCellHtml(text) {
  return renderMdInline(text) || '<br>';
}
function renderMdInline(text) {
  // Images in a cell: lifted out before the text pipeline (escaping would turn `<img …>` into literal text), held as
  // \u0000N\u0000 markers that every step below leaves alone, put back rendered at the end - so a cell shows its image
  // exactly as a free-text line does (Rishabh 2026-10-16).
  const images = [];
  text = String(text == null ? '' : text).replace(new RegExp(NOTES_IMG_TOKEN_RE.source, 'g'), (...m) => { images.push(renderImageToken(m)); return '\u0000' + (images.length - 1) + '\u0000'; });
  let s = escapeHtmlForEditor(text);
  s = applyInlineMd(s);   // **bold** + `code`
  // A cell stores a Shift+Enter line break as a literal <br> in its pipe-markdown
  // (pipe tables can't hold real newlines). escapeHtmlForEditor turned it into
  // &lt;br&gt; above — turn it back into an actual break so multi-line cells
  // render as the user typed them. cellToMarkdown does the inverse.
  //
  // This MUST run before linkifyUrls: the escaped &lt;br&gt; contains no literal
  // '<'/'>' chars, so the URL regex (which only excludes '<'/'>') would otherwise
  // swallow a <br> that directly follows a URL (e.g. "https://x.com<br>note") into
  // the pill and then corrupt it. Restoring the real <br> first makes the '<'
  // terminate the URL match cleanly.
  s = s.replace(/&lt;br\s*\/?&gt;/gi, '<br>');
  s = linkifyUrls(s);
  // Display-only list indentation inside table cells (Bug fix): a <br>-separated
  // segment the user typed as a list item gets indented so cells read like the
  // free-text list formatting outside tables. A cell is physically one pipe-row
  // and cellToMarkdown collapses leading whitespace, so the nesting level CANNOT
  // come from indent spaces — we derive it from the MARKER TYPE instead: a decimal
  // marker ("1." "2.") is the top level (no indent); a letter marker ("a." "b.",
  // also roman "i.") is treated as one nested level and indented via margin. We
  // only WRAP the segment (the "1."/"a." text is already literal) — never inject
  // text — so cellToMarkdown round-trips the cell byte-for-byte and is idempotent
  // across the blur re-render (collapseNotesTablePills). margin-left (not literal
  // spaces) is required because table cells render with white-space:normal.
  // A bullet ("- " / "* " / "+ ", NOTES_LIST_RE group 4) is a top-level line too: no indent, as typed. NOTES_LIST_RE
  // gained bullets with the lists rewrite (2026-10-15) and a bullet has no decimal marker, so for one release every
  // "- " line in a cell took the nested indent while a "-text" line beside it stayed flush (Rishabh, prod v183).
  s = s.split(/<br>/i).map(seg => {
    const m = seg.match(NOTES_LIST_RE);
    if (!m) return seg;
    if (m[4] != null || /^[0-9]+$/.test(m[2])) return seg;     // bullet or decimal = top level → no indent, leave as typed
    return `<span class="md-li" style="margin-left:1.4em">${seg}</span>`;   // letter / roman = nested → indent
  }).join('<br>');
  if (images.length) s = s.replace(/\u0000(\d+)\u0000/g, (_, i) => images[Number(i)] || '');
  return s;
}

;
// ==== FILE: js/notes/notes-lists.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-lists.js
// ==========================================================================

// ── Lists in notes free-text: numbered AND bullet, up to 3 levels ─────────────
// Notes lines are plain markdown text. A list line is "1. x" / "   a. y" / "      i. z" (ordered: the indent, 3
// spaces per level, decides the level and its marker style - L0 decimal, L1 lower-alpha, L2 lower-roman) or
// "- x" / "   - y" (bullet: '-', '*' or '+', the char the person typed is kept at every level). Only the MARKER
// is ever rewritten - the item's text keeps its bold / italic / colour / image nodes (Rishabh 2026-10-15: "fix
// bullet list number list totally professionally"; before, every list op rebuilt the line from textContent and
// a **bold** word or a pasted image in the item was gone after Enter / Tab).
//   Enter         non-empty item: split at the caret into this item + a new sibling (same level, same kind);
//                 empty item: outdent one level, at the top level leave the list (a plain line)
//   Tab / S+Tab   nest / unnest one level (caret stays where it was in the text)
//   Backspace     with the caret right after the marker: nested -> outdent, top level -> drop the marker (the
//                 text stays, as a plain line); the items that follow start a list of their own, from 1
//   any edit      the contiguous block around the caret is renumbered on input, so a deleted / pasted / moved
//                 item never leaves "1. 3. 4." behind
// Ordered runs are managed only when their first top-level marker is "1" (prose like "2026. Happy new year" or
// "404. errors" is never hijacked); a bullet line and an indented line are always managed.
const NOTES_LIST_RE = /^([ \t]*)(?:([0-9]+|[a-z]+)([.)])|([-*+]))([ \t]+)(.*)$/;
const NOTES_LIST_INDENT = '   '; // 3 spaces == one level
const NOTES_LIST_BLOCKS = '.md-table-block, .mermaid-block, .excalidraw-block, .video-embed-block, .video-link-block, .pdf-embed-block, .pdf-link-block, .video-file-block';

function notesListLevel(indent) {
  const spaces = (indent || '').replace(/\t/g, NOTES_LIST_INDENT);
  return Math.min(2, Math.floor(spaces.length / NOTES_LIST_INDENT.length));
}
function notesListMarker(level, n) {
  if (level <= 0) return String(n);
  if (level === 1) { // lower-alpha: 1->a, 27->aa
    let s = '', x = n;
    while (x > 0) { x--; s = String.fromCharCode(97 + (x % 26)) + s; x = Math.floor(x / 26); }
    return s || 'a';
  }
  const map = [[1000,'m'],[900,'cm'],[500,'d'],[400,'cd'],[100,'c'],[90,'xc'],
               [50,'l'],[40,'xl'],[10,'x'],[9,'ix'],[5,'v'],[4,'iv'],[1,'i']];
  let r = '', x = n; for (const [v, sym] of map) { while (x >= v) { r += sym; x -= v; } }
  return r || 'i';
}
// The SHAPE of a line: does it LOOK like a list item (no list context), and how. Null for a block (table,
// diagram, media) and for prose. At the TOP level only DECIMAL ordered markers count, so "e.g. …", "i.e. …" or
// "I. Introduction" is never a marker - alpha / roman appear once the person has Tab-indented (level >= 1).
function notesListShape(div) {
  if (!div || div.nodeType !== 1) return null;
  if (div.getAttribute && div.getAttribute('contenteditable') === 'false') return null;
  if (div.matches && div.matches(NOTES_LIST_BLOCKS)) return null;
  const m = (div.textContent || '').match(NOTES_LIST_RE);
  if (!m) return null;
  const ordered = m[4] == null;
  const level = notesListLevel(m[1]);
  if (ordered && level === 0 && !/^[0-9]+$/.test(m[2])) return null;
  const marker = ordered ? m[2] : m[4], sep = ordered ? m[3] : '';
  return { indent: m[1], level, ordered, marker, sep, ws: m[5], content: m[6], prefix: m[1] + marker + sep + m[5], prefixLen: (m[1] + marker + sep + m[5]).length };
}
// A MANAGED item (renumbered, continued, nested): every bullet, every indented line, and a top-level decimal
// whose contiguous shaped run starts with "1." (or with a bullet). A top-level decimal run starting elsewhere is
// numeric prose ("2026. …", "90. degrees") and stays untouched.
function notesListMatch(div) {
  const s = notesListShape(div);
  if (!s) return null;
  if (!s.ordered || s.level > 0 || s.marker === '1') return s;
  let p = div, first = null;
  while (p) {
    const ps = notesListShape(p);
    if (!ps) break;
    if (ps.level === 0) first = ps;
    p = p.previousElementSibling;
  }
  return (first && (!first.ordered || first.marker === '1')) ? s : null;
}
// The direct child of `editor` that contains the collapsed caret (one "line").
function notesEditorLineDiv(editor) {
  const sel = window.getSelection();
  if (!sel || !sel.rangeCount) return null;
  let n = sel.anchorNode;
  if (n === editor) {
    const c = editor.childNodes[sel.anchorOffset] || editor.lastChild;
    return (c && c.nodeType === 1) ? c : null;
  }
  while (n && n.parentNode !== editor) n = n.parentNode;
  return (n && n.nodeType === 1) ? n : null;
}
function setNotesCaret(div, charOffset) {
  let node = div.firstChild;
  if (!node || node.nodeType !== 3) { node = document.createTextNode(''); div.insertBefore(node, div.firstChild); }
  const len = (node.textContent || '').length;
  const r = document.createRange();
  r.setStart(node, Math.max(0, Math.min(charOffset, len)));
  r.collapse(true);
  const sel = window.getSelection();
  sel.removeAllRanges(); sel.addRange(r);
}
// The caret's character offset inside `div` (text only), or -1 when the caret is elsewhere.
function notesCaretOffsetIn(div) {
  const sel = window.getSelection();
  if (!sel || !sel.rangeCount || !div.contains(sel.anchorNode)) return -1;
  const probe = document.createRange();
  probe.selectNodeContents(div);
  try { probe.setEnd(sel.anchorNode, sel.anchorOffset); } catch (_) { return -1; }
  return probe.toString().length;
}
// The text node that holds the item's prefix (indent + marker + space): the line's first text node when the
// prefix sits whole inside it - the shape every parsed and every typed list line has. A marker the person
// wrapped in bold along with its text lives inside <strong>; that rare line is rebuilt as text instead.
function notesListPrefixNode(div, s) {
  const t = div.firstChild;
  return (t && t.nodeType === 3 && t.nodeValue.length >= s.prefixLen) ? t : null;
}
// Rewrite ONLY the prefix of a list line. The item's content nodes are untouched; a caret inside the prefix
// node keeps its place in the text (it moves with the prefix's new length).
function setNotesListPrefix(div, s, prefix) {
  const t = notesListPrefixNode(div, s);
  if (!t) { div.textContent = prefix + s.content; if (!div.textContent) div.appendChild(document.createElement('br')); return; }
  const sel = window.getSelection();
  const r = (sel && sel.rangeCount) ? sel.getRangeAt(0) : null;
  const inT = !!(r && r.collapsed && r.startContainer === t);
  const off = inT ? r.startOffset : -1;
  t.nodeValue = prefix + t.nodeValue.slice(s.prefixLen);
  if (!div.textContent && !div.querySelector('*')) div.appendChild(document.createElement('br'));   // an emptied line keeps its height
  if (inT) {
    const n = off >= s.prefixLen ? off - s.prefixLen + prefix.length : Math.min(off, prefix.length);
    const nr = document.createRange(); nr.setStart(t, Math.min(n, t.nodeValue.length)); nr.collapse(true);
    sel.removeAllRanges(); sel.addRange(nr);
  }
}
function notesListPrefixFor(s, level, ordered, marker, sep) {
  return NOTES_LIST_INDENT.repeat(level) + (ordered ? marker + sep : marker) + ' ';
}
// Re-derive the markers of the whole contiguous list block that `startDiv` is in. Managed lines only, unless
// `force`: an op that just split a run (an item left the list) renumbers the items after it as their own list,
// from 1, even though their first marker is not "1" any more.
function renumberNotesListBlock(startDiv, force) {
  const ok = (d) => (force ? notesListShape(d) : notesListMatch(d));
  let first = startDiv;
  while (first.previousElementSibling && ok(first.previousElementSibling)) first = first.previousElementSibling;
  const counters = [0, 0, 0];
  for (let cur = first, s; cur && (s = ok(cur)); cur = cur.nextElementSibling) {
    for (let L = s.level + 1; L < 3; L++) counters[L] = 0;
    let prefix;
    if (s.ordered) { counters[s.level]++; prefix = notesListPrefixFor(s, s.level, true, notesListMarker(s.level, counters[s.level]), s.sep); }
    else prefix = notesListPrefixFor(s, s.level, false, s.marker, '');
    if (prefix !== s.prefix) setNotesListPrefix(cur, s, prefix);
  }
}
// After ANY edit (typing, delete, paste, a line removed): the block around the caret is renumbered, so the
// markers always read 1, 2, 3 whatever was added or removed. Called from the editor's input handler
// (notes-render.js); a prefix that is already right is not touched, so plain typing changes nothing.
function renumberNotesListsAtCaret(editor) {
  const line = notesEditorLineDiv(editor);
  if (line && notesListMatch(line)) renumberNotesListBlock(line);
}
// An item with nothing after its marker: no text, no image, no pill.
function notesListItemEmpty(div, s) {
  return !s.content.trim() && !div.querySelector('img, .img-wrap, .url-pill');
}
// Split a list line at the caret into this item and a NEW sibling that starts with `prefix`: the content after
// the caret MOVES (Range.extractContents - a bold / coloured run split by the caret is closed on this line and
// reopened on the new one, an image travels whole). A caret inside the prefix splits at the prefix's end.
function splitNotesListLine(editor, div, s, prefix) {
  const sel = window.getSelection();
  const r0 = sel.getRangeAt(0);
  const t = notesListPrefixNode(div, s);
  const tail = document.createRange();
  tail.selectNodeContents(div);
  if (notesCaretOffsetIn(div) < s.prefixLen && t) tail.setStart(t, s.prefixLen);
  else tail.setStart(r0.startContainer, r0.startOffset);
  const frag = tail.extractContents();
  const nd = document.createElement('div');
  nd.appendChild(document.createTextNode(prefix));
  nd.appendChild(frag);
  nd.normalize();
  // a leading space the split left on the moved text ("one| two") is the separator, not content
  if (nd.firstChild.nodeType === 3) nd.firstChild.nodeValue = prefix + nd.firstChild.nodeValue.slice(prefix.length).replace(/^[ \t]+/, '');
  if (!div.textContent && !div.querySelector('*')) div.appendChild(document.createElement('br'));
  if (div.nextSibling) editor.insertBefore(nd, div.nextSibling); else editor.appendChild(nd);
  setNotesCaret(nd, prefix.length);
  return nd;
}
// The item leaves its level: nested -> one level out (same kind), top level -> a plain line (marker dropped,
// the text stays). The items after it become a list of their own, numbered from 1.
function outdentNotesListLine(div, s) {
  if (s.level > 0) {
    setNotesListPrefix(div, s, notesListPrefixFor(s, s.level - 1, s.ordered, s.ordered ? '1' : s.marker, s.sep));
    renumberNotesListBlock(div);
    return;
  }
  setNotesListPrefix(div, s, '');
  if (div.nextElementSibling && notesListShape(div.nextElementSibling)) renumberNotesListBlock(div.nextElementSibling, true);
}
// Handle Enter / Tab / Shift+Tab / Backspace on a list line. Returns true if it consumed the key (so the editor
// keydown handler stops). Free-text URL pills are already expanded to raw text while the editor is focused, so
// no URL is lost.
function handleNotesListKey(e, editor) {
  if (e.ctrlKey || e.metaKey || e.altKey) return false;
  if (e.key !== 'Enter' && e.key !== 'Tab' && e.key !== 'Backspace') return false;
  if (editor.getAttribute && editor.getAttribute('contenteditable') === 'false') return false;
  if (document.body && document.body.classList.contains('tt-readonly')) return false;  // read-only view
  const sel = window.getSelection();
  if (!sel || !sel.rangeCount || !sel.isCollapsed) return false;
  const a = sel.anchorNode; const ael = a && (a.nodeType === 1 ? a : a.parentElement);
  if (ael && ael.closest && ael.closest(NOTES_LIST_BLOCKS)) return false;
  const line = notesEditorLineDiv(editor);
  const s = notesListShape(line);
  if (!s) return false;
  const managed = !!notesListMatch(line);

  if (e.key === 'Tab') {
    if (!managed) return false;   // numeric prose: the free-text Tab (notes-keys.js) indents it like any line
    e.preventDefault(); e.stopPropagation();
    const newLevel = e.shiftKey ? Math.max(0, s.level - 1) : Math.min(2, s.level + 1);
    if (newLevel !== s.level) {
      setNotesListPrefix(line, s, notesListPrefixFor(s, newLevel, s.ordered, s.ordered ? '1' : s.marker, s.sep));   // marker fixed by renumber
      renumberNotesListBlock(line);
      editor.dispatchEvent(new Event('input'));
    }
    return true;
  }

  if (e.key === 'Backspace') {
    if (notesCaretOffsetIn(line) !== s.prefixLen) return false;   // only right after the marker
    e.preventDefault(); e.stopPropagation();
    if (managed) outdentNotesListLine(line, s);
    else setNotesListPrefix(line, s, '');
    editor.dispatchEvent(new Event('input'));
    return true;
  }

  // Enter
  e.preventDefault(); e.stopPropagation();
  if (notesListItemEmpty(line, s)) {
    if (managed) outdentNotesListLine(line, s);
    else setNotesListPrefix(line, s, '');
    editor.dispatchEvent(new Event('input'));
    return true;
  }
  let prefix;
  if (managed) prefix = notesListPrefixFor(s, s.level, s.ordered, s.ordered ? '1' : s.marker, s.sep);   // marker fixed by renumber
  else {
    // A top-level decimal that is not "1."-rooted ("2. …" typed after a pasted image, "2026. …"): Enter appends the
    // NEXT number locally - this line's number is kept and nothing is bulk-renumbered.
    const n = parseInt(s.marker, 10);
    if (!Number.isSafeInteger(n)) return true;   // an absurd marker (> 2^53) would stringify as "1e+21." - do nothing
    prefix = notesListPrefixFor(s, s.level, true, String(n + 1), s.sep);
  }
  splitNotesListLine(editor, line, s, prefix);
  if (managed) renumberNotesListBlock(line);
  editor.dispatchEvent(new Event('input'));
  return true;
}

;
// ==== FILE: js/notes/notes-tables.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-tables.js
// ==========================================================================

// Inverse of getEditorContent — convert stored markdown text back to HTML
// the contenteditable can display. Handles:
//   - Fenced ```mermaid``` code blocks → async-rendered SVG via Mermaid
//   - Inline images (both <img> and ![]() forms) via renderImageWrap
//   - URLs → pill linkification via linkifyUrls
// ── Freeze-header state for notes tables (per-table, display-only) ───────────
// "Freeze header" caps a table's height and scrolls it inside a window with the
// header row pinned (Excel-style). It's a pure view preference (it never touches
// the markdown), so it lives in localStorage — keyed by box id + the table's
// index within that box — instead of being threaded through the table source
// serializers. Re-applied on every render from the key, so it survives
// re-renders and reloads, and works in read-only (no save involved).
const FROZEN_TABLES_KEY = 'taskTrackerFrozenTables';
function _frozenTables() {
  try { return JSON.parse(localStorage.getItem(FROZEN_TABLES_KEY) || '{}'); } catch (_) { return {}; }
}
function isTableFrozen(boxId, idx) { return !!_frozenTables()[boxId + '#' + idx]; }
function setTableFrozen(boxId, idx, on) {
  const all = _frozenTables();
  const k = boxId + '#' + idx;
  if (on) all[k] = 1; else delete all[k];
  try { localStorage.setItem(FROZEN_TABLES_KEY, JSON.stringify(all)); } catch (_) {}
}

// ── Markdown table helpers ──────────────────────────────────────────────
// A table row is any line that starts AND ends with `|`. The separator
// row distinguishes a real table from a row of random pipes — its cells
// must be only hyphens with optional `:` for alignment.
function isMdTableRow(line) {
  const t = line.trim();
  return t.length >= 2 && t.startsWith('|') && t.endsWith('|');
}
function isMdTableSeparator(line) {
  if (!isMdTableRow(line)) return false;
  const cells = line.trim().slice(1, -1).split('|');
  if (cells.length === 0) return false;
  return cells.every(c => /^[\s:]*-+[\s:]*$/.test(c));
}
function parseMdTableRow(line) {
  return line.trim().slice(1, -1).split('|').map(c => c.trim());
}
// `:---` left, `---:` right, `:---:` center, plain `---` no alignment.
function parseMdTableAlignment(separatorLine) {
  return parseMdTableRow(separatorLine).map(c => {
    const left = c.startsWith(':');
    const right = c.endsWith(':');
    if (left && right) return 'center';
    if (right) return 'right';
    if (left) return 'left';
    return null;
  });
}

// Re-collapse a notes table's URL pills back to their compact preview form.
// Called (from the ui.js focusout router) when focus leaves the table block, so
// the pill returns the moment you click OUT of the table — instead of waiting
// for a full notes-box blur. The block's data-source is the source of truth
// (rebuilt on every cell input + read by getEditorContent), so this is purely
// cosmetic and never affects what's saved. Each header's drag-to-resize handle
// is a live node carrying its own mousedown listener, so it's detached before
// the cell is rebuilt and re-attached after, rather than recreated.
function collapseNotesTablePills(block) {
  if (!block) return;
  block.querySelectorAll('th[contenteditable="true"], td[contenteditable="true"]').forEach(cell => {
    // Never rebuild the cell the user is actively in (defensive — focusout has
    // normally already left it). Rebuilding would drop the caret.
    if (cell.contains(document.activeElement)) return;
    // Detach the live affordance nodes (each carries its own listeners) before
    // rebuilding the cell text, then re-append in render order: text, then the
    // sort/filter controls, then the resize handle. Without this the header's
    // .tv-th-ctrls would be wiped on focusout and the controls would vanish until
    // a full re-render.
    const tvCtrls = cell.querySelector('.tv-th-ctrls');
    const resize = cell.querySelector('.md-col-resize');
    cell.innerHTML = renderMdTableCellHtml(cellToMarkdown(cell));   // an empty cell keeps its caret slot
    if (tvCtrls) cell.appendChild(tvCtrls);
    if (resize) cell.appendChild(resize);
  });
}

// ── Add/remove rows & columns on a rendered markdown-table block ───────────
// Each edits the block's data-source (the pipe markdown), then re-renders the
// editor so the grid + the saved file reflect the change. Reuses parseMdTableRow.
// `land` = where the caret goes in the FRESH block, in post-mutation source coordinates { ri, ci } (ri -1 = header
// row, else data-ri) - or null when the caret was not in this table. The rebuild kills the old cell and with it the
// caret and the toolbar (:focus-within), which is what lost the user's place (Rishabh 2026-09-24).
function rerenderMdTable(block, land) {
  const editor = block.closest && block.closest('.notes-editor');
  if (!editor) return;
  const blockIdx = Array.prototype.indexOf.call(editor.querySelectorAll('.md-table-block'), block);
  setEditorContent(editor, getEditorContent(editor));   // re-renders + re-wires the block (table scroll kept by index)
  // Every op lands the caret inside the table (a caller without a better cell gets the first one): the box's own
  // undo is reachable only from inside it.
  const fresh = editor.querySelectorAll('.md-table-block')[blockIdx];
  if (fresh) placeNotesTableCaret(fresh, land || (fresh.querySelector('tbody tr') ? { ri: 0, ci: 0 } : { ri: -1, ci: 0 }));
  editor.dispatchEvent(new Event('input'));             // debounced save + outline rebuild
}
// Collapsed caret at the END of the cell's text (before the header's sort / resize affordances, which are
// contenteditable=false and must stay last so typing never lands behind them).
function placeNotesTableCaret(block, land) {
  const tr = land.ri === -1 ? block.querySelector('thead tr') : block.querySelector('tbody tr[data-ri="' + land.ri + '"]');
  const cell = tr && tr.cells[land.ci];
  if (!cell) return;
  // A FROZEN table scrolls its rows inside its own window: a row added below the LAST row sits past the window's
  // bottom edge and scrollIntoView left it there (RUN 2026-10-06: caret in the new row at y=785-820, window bottom
  // 793, window scrollTop unchanged - Rishabh: "+ Row doesn't take the cursor to the next row"). Scroll the window
  // itself by the exact overflow, keeping the pinned header clear - and do it BEFORE focusing the cell: the
  // focusin handler that expands URL pills in a table cell pins the window's scroll position for five frames to
  // what it was at focus time (so a focus never jumps a wide table), which would otherwise undo this scroll.
  const win = block.querySelector('.md-table-scroll');
  if (win && block.classList.contains('md-table-frozen')) {
    const cr = cell.getBoundingClientRect(), wr = win.getBoundingClientRect();
    const head = block.querySelector('thead'); const headH = head ? head.getBoundingClientRect().height : 0;
    if (cr.bottom > wr.bottom) win.scrollTop += Math.ceil(cr.bottom - wr.bottom);
    else if (cr.top < wr.top + headH) win.scrollTop -= Math.ceil(wr.top + headH - cr.top);
  }
  cell.focus({ preventScroll: true });   // the scrollers were just restored (and the window placed above); no nudge
  let n = cell.lastChild;
  while (n && n.nodeType === 1 && n.getAttribute('contenteditable') === 'false') n = n.previousSibling;
  const r = document.createRange();
  if (n) r.setStartAfter(n); else r.setStart(cell, 0);
  r.collapse(true);
  const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
  cell.scrollIntoView({ block: 'nearest', inline: 'nearest' });   // a no-op while the cell is in view; the least scroll when a reflow (a new column wrapping the rows above) pushed it out
}

// ── Frozen table window: fit it to the editor's VISIBLE area ──────────────────
// styles.css caps a frozen table's window at 65vh. In resize mode the EDITOR is the scroller with a fixed height
// (Fit mode: the box), so a window that starts partway down runs PAST that scroller's bottom edge - and because a
// frozen table scrolls its ROWS inside the window, the user never scrolls the editor, so the window's bottom edge
// (its horizontal scrollbar = the only way to the last columns) is never on screen (Rishabh 2026-10-06, his
// 'Team Planning' table: window bottom y=891, editor bottom y=784, bar 106px below the fold; "scroller gayab").
// The window's height is therefore DERIVED from where it sits: no taller than what is visible below its top edge
// inside the editor / box / viewport. Recomputed on every render, freeze toggle, box resize, scroll and window
// resize; an unfrozen table gets no cap. Below 160px the CSS cap stays (the window's top is itself out of view -
// the user scrolls the editor, and the scroll handler recomputes).
const FROZEN_WINDOW_MIN_PX = 160;
function fitFrozenTableWindow(block) {
  const win = block.querySelector('.md-table-scroll');
  const editor = block.closest('.notes-editor');
  if (!win || !editor) return;
  if (!block.classList.contains('md-table-frozen')) { win.style.maxHeight = ''; return; }
  // Never clear the cap to measure: a window that momentarily holds every row has nothing to scroll and the browser
  // clamps its scrollTop to 0 - the user's place in the rows (and the caret row a + Row just scrolled to) is lost.
  const box = editor.closest('.notes-box');
  const e = editor.getBoundingClientRect(), b = box ? box.getBoundingClientRect() : e, w = win.getBoundingClientRect();
  const cap = Math.round(window.innerHeight * 0.65);           // the CSS cap (styles.css .md-table-frozen .md-table-scroll)
  const visibleBottom = Math.min(e.bottom, b.bottom, window.innerHeight) - 10;   // the editor's bottom padding stays clear
  const avail = Math.floor(visibleBottom - w.top);
  const desired = avail >= FROZEN_WINDOW_MIN_PX ? Math.min(cap, avail) : cap;
  const next = desired + 'px';
  if (win.style.maxHeight === next) return;
  const keep = win.scrollTop;
  win.style.maxHeight = next;
  win.scrollTop = keep;
}
function fitFrozenTableWindows(editor) {
  if (!editor || !editor.querySelectorAll) return;
  editor.querySelectorAll('.md-table-block').forEach(fitFrozenTableWindow);
}
// The scrollers a frozen window sits in: the editor (resize mode) and the box (Fit mode). Wired once per element.
function wireFrozenTableWindowFit(editor) {
  const box = editor.closest('.notes-box');
  [editor, box].forEach(el => {
    if (!el || el.dataset.frozenFitWired) return;
    el.dataset.frozenFitWired = '1';
    el.addEventListener('scroll', () => fitFrozenTableWindows(editor), { passive: true });
  });
}
if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
  window.addEventListener('resize', () => { document.querySelectorAll('.notes-editor').forEach(fitFrozenTableWindows); });
}
// Split a table block's source into its pipe-rows and the optional trailing
// `<!--cols:…-->` width comment. mdTable* mutations operate on `rows` and
// recompose — dropping widths when the column count changes, since stale
// widths would mis-size the grid.
function mdTableSplit(block) {
  const all = (block.dataset.source || '').split('\n');
  let widthsLine = '', viewLine = '';
  const rows = [];
  for (const l of all) {
    if (/^\s*<!--\s*cols:/.test(l)) { widthsLine = l.trim(); continue; }
    if (/^\s*<!--\s*tv:/.test(l)) { viewLine = l.trim(); continue; }   // sort/filter view state
    if (l.trim() !== '') rows.push(l);
  }
  return { rows, widthsLine, viewLine };
}
function mdTableCompose(block, rows, widthsLine) {
  // Width + view-state (sort/filter) comments are written LEADING (before the
  // header) so a row appended at the bottom in ⋮-source mode stays contiguous
  // with the body on re-parse. The view comment is read from the CURRENT source
  // so it's preserved across row add/remove/clear (column changes strip it
  // explicitly via tvStripView, since filters are keyed by column index).
  const { viewLine } = mdTableSplit(block);
  const lead = [widthsLine, viewLine].filter(Boolean).join('\n');
  block.dataset.source = (lead ? lead + '\n' : '') + rows.join('\n');
}
// Drop the sort/filter view comment — used by column add/remove, whose index
// shift would otherwise leave filters pointing at the wrong columns.
function tvStripView(block) {
  block.dataset.source = (block.dataset.source || '').split('\n')
    .filter(l => !/^\s*<!--\s*tv:/.test(l)).join('\n');
}
function mdTableLines(block) {                          // just the pipe-rows (no width comment / blanks)
  return mdTableSplit(block).rows;
}
function mdTableAddRow(block, bodyRowIndex, above, caret) {
  tvClearFilters(block);                                // a value filter would hide the new blank row
  const { rows, widthsLine } = mdTableSplit(block);
  if (rows.length < 2) return;                          // need header + separator
  const cols = parseMdTableRow(rows[0]).length;
  const newRow = '| ' + Array(cols).fill('').join(' | ') + ' |';
  // rows = [header, separator, body0, body1, …]: body N lives at rows[2+N]. Two buttons (UI-A-3, Rishabh
  // 2026-09-18: "+ Row" always added below the current row - he wants above too):
  //   caret in body N            -> "↓" inserts at 2+N+1 (below, as before), "↑" at 2+N (above)
  //   caret in the HEADER (N=-1) -> both insert as the FIRST body row (nothing can go above the header)
  //   caret not in this table    -> "↓" appends at the END (as before), "↑" inserts at the TOP
  // bodyRowIndex is the SOURCE index (data-ri), so with a sort/filter view active the row still lands
  // beside the row the caret is in, not beside its screen neighbour.
  const bodyCount = rows.length - 2;
  const inBody = bodyRowIndex != null && bodyRowIndex >= 0 && bodyRowIndex < bodyCount;
  let at;
  if (inBody) at = 2 + bodyRowIndex + (above ? 0 : 1);
  else if (bodyRowIndex === -1) at = 2;
  else at = above ? 2 : rows.length;
  rows.splice(at, 0, newRow);
  mdTableCompose(block, rows, widthsLine);              // row count doesn't change widths
  // Caret lands in the NEW row, same column (Rishabh 2026-09-28: "add row ke baad type next row mein jaana chahiye" -
  // replaces his 2026-09-24 "stay in the cell"). rows[at] is body row at-2; no caret in this table -> nothing to place.
  // No caret in this table (the button was clicked cold): land in the new row's first cell all the same - the
  // caret must be back INSIDE the box after every op, or the next Ctrl+Z reaches the page's table-view undo and
  // the rows just added stay (Rishabh 2026-10-15: "added rows, undo se hat nahi rahi").
  rerenderMdTable(block, { ri: at - 2, ci: caret ? caret.colIndex : 0 });
}
// Which cell holds the caret inside this table block right now. Returns
// { colIndex, bodyRowIndex } (bodyRowIndex is 0-based among <tbody> rows, or -1
// when the caret is in the header row), or null if the caret isn't in a cell.
// Used so − Row / − Col delete the row/column the user is in, not always the last.
function activeTableCell(block) {
  const sel = window.getSelection && window.getSelection();
  if (!sel || sel.rangeCount === 0) return null;
  let node = sel.anchorNode;
  if (node && node.nodeType === 3) node = node.parentElement;   // text node → element
  const cell = node && node.closest && node.closest('th, td');
  if (!cell || !block.contains(cell)) return null;
  const tr = cell.closest('tr');
  let bodyRowIndex = -1;
  if (tr && tr.parentElement && tr.parentElement.tagName === 'TBODY') {
    // Prefer data-ri (the row's ORIGINAL source index): with a sort/filter view
    // active the DOM order differs from the source order, so the DOM position
    // would point + Row / − Row at the wrong row.
    bodyRowIndex = tr.dataset && tr.dataset.ri != null
      ? parseInt(tr.dataset.ri, 10)
      : Array.prototype.indexOf.call(tr.parentElement.children, tr);
  }
  return { colIndex: cell.cellIndex, bodyRowIndex };
}
function mdTableRemoveRow(block, bodyRowIndex, caret) {
  const { rows, widthsLine } = mdTableSplit(block);
  if (rows.length <= 3) { showToast('⚠ Table needs at least one row'); return; }  // header+sep+1 body
  // rows = [header, separator, body0, body1, …]; body N lives at rows[2+N].
  const bodyCount = rows.length - 2;
  const bi = (bodyRowIndex == null || bodyRowIndex < 0 || bodyRowIndex >= bodyCount)
    ? bodyCount - 1            // no caret in a body row → fall back to the last
    : bodyRowIndex;
  rows.splice(2 + bi, 1);
  mdTableCompose(block, rows, widthsLine);   // row count doesn't change widths
  // Caret: same column, the row that took the deleted row's place (the last row deleted -> the new last row).
  rerenderMdTable(block, caret ? { ri: caret.bodyRowIndex === -1 ? -1 : Math.min(bi, bodyCount - 2), ci: caret.colIndex } : { ri: Math.min(bi, bodyCount - 2), ci: 0 });
}
// `left` (Rishabh 2026-09-24, mirrors + Row ↑/↓): caret in column N -> "←" inserts at N (N shifts right), "→" at N+1;
// no caret in this table -> "←" at the START, "→" at the END. Existing widths are kept, the new column gets the default.
function mdTableAddCol(block, colIndex, left, caret) {
  tvStripView(block);                                   // column shift invalidates sort/filter
  const { rows } = mdTableSplit(block);
  if (rows.length < 2) return;
  const ncols = parseMdTableRow(rows[0]).length;
  const inCol = colIndex != null && colIndex >= 0 && colIndex < ncols;
  const at = inCol ? colIndex + (left ? 0 : 1) : (left ? 0 : ncols);

  // Capture the CURRENT rendered column widths BEFORE mutating, so existing
  // columns keep their size and ONLY the new column gets a default. Previously
  // add-column dropped all widths, so CSS squeezed every column into equal
  // slivers and the user had to click "Fit" each time. Prefer the explicit
  // colgroup; else measure the header cells (the block is still live here).
  const NEW_COL_W = 160;
  const table = block.querySelector('table.md-table');
  let widths = null;
  if (table) {
    const colEls = table.querySelectorAll('colgroup col');
    if (colEls.length === ncols) {
      widths = Array.from(colEls).map(c => Math.round(parseFloat(c.style.width) || 0));
    } else {
      const ths = table.querySelectorAll('thead th');
      if (ths.length === ncols) widths = Array.from(ths).map(th => Math.round(th.getBoundingClientRect().width));
    }
    if (widths && widths.some(w => !w || w <= 0)) widths = null;   // unreadable → don't trust it
  }

  const out = rows.map((l, i) => {
    const cells = parseMdTableRow(l);
    cells.splice(at, 0, i === 1 ? '---' : '');          // line index 1 is the |---|---| separator
    return '| ' + cells.join(' | ') + ' |';
  });

  let widthsLine = '';
  if (widths) {
    widths.splice(at, 0, NEW_COL_W);                    // sensible default for the inserted column
    widthsLine = '<!--cols:' + widths.join(',') + '-->';
  }
  // Remember which table block this is so we can re-find it after the full
  // re-render (rerenderMdTable rebuilds editor.innerHTML, detaching `block`).
  const editor = block.closest && block.closest('.notes-editor');
  const blockIdx = editor
    ? Array.prototype.indexOf.call(editor.querySelectorAll('.md-table-block'), block) : -1;
  mdTableCompose(block, out, widthsLine);
  // Caret lands in the NEW column, same row (Rishabh 2026-09-28, same word as for rows).
  rerenderMdTable(block, { ri: caret ? caret.bodyRowIndex : -1, ci: at });   // no caret: the new column's header
  // If widths couldn't be captured (a table never sized/fitted), auto-fit the
  // fresh block so it still doesn't congest. Re-resolve the LIVE block first.
  if (!widthsLine && editor && blockIdx >= 0) {
    const fresh = editor.querySelectorAll('.md-table-block')[blockIdx];
    if (fresh) autoFitNotesTableColumns(fresh, true);   // quiet: no "auto-fit" toast on add
  }
}
function mdTableRemoveCol(block, colIndex, caret) {
  tvStripView(block);                                   // column shift invalidates sort/filter
  const { rows } = mdTableSplit(block);
  if (rows.length < 2) return;
  const ncols = parseMdTableRow(rows[0]).length;
  if (ncols <= 1) { showToast('⚠ Table needs at least one column'); return; }
  const ci = (colIndex == null || colIndex < 0 || colIndex >= ncols)
    ? ncols - 1                 // no caret in a column → fall back to the last
    : colIndex;
  // Preserve the surviving columns' widths (drop only the removed column's) so
  // removing a column doesn't reset every width and re-congest the table — the
  // same fix as + Col, mirrored. Read widths from the live table before mutating.
  const table = block.querySelector('table.md-table');
  let widths = null;
  if (table) {
    const colEls = table.querySelectorAll('colgroup col');
    if (colEls.length === ncols) {
      widths = Array.from(colEls).map(c => Math.round(parseFloat(c.style.width) || 0));
    } else {
      const ths = table.querySelectorAll('thead th');
      if (ths.length === ncols) widths = Array.from(ths).map(th => Math.round(th.getBoundingClientRect().width));
    }
    if (widths && widths.some(w => !w || w <= 0)) widths = null;
  }
  const out = rows.map(l => { const c = parseMdTableRow(l); c.splice(ci, 1); return '| ' + c.join(' | ') + ' |'; });
  let widthsLine = '';
  if (widths) { widths.splice(ci, 1); widthsLine = '<!--cols:' + widths.join(',') + '-->'; }
  mdTableCompose(block, out, widthsLine);
  // Caret: the column to the LEFT of the deleted one (the first column deleted -> the new first column).
  rerenderMdTable(block, { ri: caret ? caret.bodyRowIndex : -1, ci: ci > 0 ? ci - 1 : 0 });   // no caret: the neighbour's header
}
// Empty every BODY cell (same row + column count, just blanked) while keeping the
// header row, the separator, and any column widths — so the table stays reusable.
// (✕ Table removes the whole thing; this only wipes the data you typed in.)
async function mdTableClearAll(block, caret) {
  if (!(await showConfirmModal({ title: 'Clear table?', message: 'All cell text in this table will be cleared. The column headers are kept.', okLabel: 'Clear', danger: true }))) return;
  tvClearFilters(block);                                // blanked cells would all be hidden by a value filter
  const { rows, widthsLine } = mdTableSplit(block);
  if (rows.length < 3) return;                          // header + separator + ≥1 body row
  const cols = parseMdTableRow(rows[0]).length;
  const blank = '| ' + Array(cols).fill('').join(' | ') + ' |';
  for (let i = 2; i < rows.length; i++) rows[i] = blank; // blank every body row, keep the count
  mdTableCompose(block, rows, widthsLine);              // cell text only → widths unchanged
  rerenderMdTable(block, caret ? { ri: caret.bodyRowIndex, ci: caret.colIndex } : { ri: 0, ci: 0 });
}

async function mdTableDelete(block) {
  if (!(await showConfirmModal({ title: 'Delete table?', message: 'This table will be removed from the note.', okLabel: 'Delete', danger: true }))) return;
  const editor = block.closest && block.closest('.notes-editor');
  block.remove();
  if (editor) editor.dispatchEvent(new Event('input'));   // debounced save (table now gone)
}

// ── Drag-to-resize columns on a notes table ───────────────────────────────
// Widths persist as the trailing `<!--cols:w1,w2,…-->` comment (written only
// once the user has actually dragged), so they survive save/reload without
// polluting untouched tables. Mirrors the main data-table's startColResize.
function mdTableSetWidths(block, widths) {
  const { rows } = mdTableSplit(block);
  const line = (widths && widths.length)
    ? '<!--cols:' + widths.map(w => Math.round(w)).join(',') + '-->'
    : '';
  mdTableCompose(block, rows, line);
}
// With table-layout:fixed, the table must carry its own total width so the
// <col> widths are honored exactly and the block (overflow-x:auto) scrolls
// when they exceed the editor.
function syncNotesTableWidth(table) {
  const cols = Array.from(table.querySelectorAll('colgroup col'));
  const total = cols.reduce((a, c) => a + (parseFloat(c.style.width) || 0), 0);
  if (total > 0) table.style.width = total + 'px';
}

// ── Paste tabular data as a real table ──────────────────────────────────────
// Detect a table on the clipboard and return it as a 2D array of cell strings
// (first row = header), else null. Tries, in order: an HTML <table>, a markdown
// pipe-table (header + `---` separator), then TSV (Excel/Sheets, tab-separated).
function parseClipboardTable(e) {
  const cd = e.clipboardData;
  if (!cd) return null;
  const html = cd.getData && cd.getData('text/html');
  if (html && /<table[\s>]/i.test(html)) {
    const rows = parseHtmlTable(html);
    if (rows && rows.length) return rows;
  }
  const text = (cd.getData && cd.getData('text/plain')) || '';
  if (!text.trim()) return null;
  const lines = text.replace(/\r/g, '').split('\n').filter(l => l.trim() !== '');
  // Markdown pipe-table: row 0 is `| … |`, row 1 is the `| --- | --- |` rule.
  if (lines.length >= 2 && isMdTableRow(lines[0]) && isMdTableSeparator(lines[1])) {
    const rows = [parseMdTableRow(lines[0])];
    for (let i = 2; i < lines.length; i++) {
      if (isMdTableRow(lines[i]) && !isMdTableSeparator(lines[i])) rows.push(parseMdTableRow(lines[i]));
    }
    return rows;
  }
  // TSV: real Excel/Sheets data is RECTANGULAR — ≥2 lines that every split into
  // the SAME number of tab-fields (≥2). This rejects tab-indented code / stack
  // traces / ragged prose (which would otherwise become a phantom grid), and
  // rejects pure indentation where the first field is empty on every line.
  if (text.indexOf('\t') >= 0) {
    const rows = lines.map(l => l.split('\t').map(c => c.trim()));
    const width = rows[0].length;
    const rectangular = width >= 2 && rows.length >= 2 && rows.every(r => r.length === width);
    const allFirstColEmpty = rows.every(r => r[0] === '');
    if (rectangular && !allFirstColEmpty) return rows;
  }
  return null;
}
// Parse a <table> out of an HTML clipboard fragment into a 2D array.
function parseHtmlTable(html) {
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const tables = Array.from(doc.querySelectorAll('table'));
    if (!tables.length) return null;
    // Prefer a "leaf" data table (no nested <table>) — outer tables are usually
    // layout/email wrappers (Gmail/Outlook/web). Among candidates pick the one
    // with the most cells so we grab the real data, not the wrapper.
    const leaves = tables.filter(t => !t.querySelector('table'));
    const candidates = leaves.length ? leaves : tables;
    let table = candidates[0], best = -1;
    for (const t of candidates) {
      const n = t.querySelectorAll('th, td').length;
      if (n > best) { best = n; table = t; }
    }
    // Expand colspan/rowspan into a grid so each cell keeps its TRUE column
    // index (otherwise a merged cell shifts every following column left).
    const grid = [];
    Array.from(table.querySelectorAll('tr')).forEach((tr, r) => {
      if (!grid[r]) grid[r] = [];
      let cellEls = Array.from(tr.querySelectorAll(':scope > th, :scope > td'));
      if (!cellEls.length) cellEls = Array.from(tr.querySelectorAll('th, td'));
      let c = 0;
      cellEls.forEach(td => {
        while (grid[r][c] !== undefined) c++;            // skip slots a rowspan above already filled
        const txt = (td.textContent || '').replace(/\s+/g, ' ').trim();
        const cs = Math.max(1, parseInt(td.getAttribute('colspan'), 10) || 1);
        const rs = Math.max(1, parseInt(td.getAttribute('rowspan'), 10) || 1);
        for (let dr = 0; dr < rs; dr++) {
          const rr = r + dr;
          if (!grid[rr]) grid[rr] = [];
          for (let dc = 0; dc < cs; dc++) grid[rr][c + dc] = (dr === 0 && dc === 0) ? txt : '';
        }
        c += cs;
      });
    });
    const rows = grid
      .map(row => Array.from(row, x => (x == null ? '' : x)))   // fill any holes
      .filter(row => row.length);
    return rows.length ? rows : null;
  } catch (_) { return null; }
}
// Build markdown pipe-table source from a 2D array. First row is the header;
// rows are padded to the widest row; `|` in any cell is escaped so it can't
// break the row.
function tableArrayToMarkdown(rows) {
  const ncols = Math.max(...rows.map(r => r.length));
  const cell = (s) => String(s == null ? '' : s).replace(/\|/g, '\\|').replace(/\s+/g, ' ').trim();
  const pad = (r) => { const c = r.map(cell); while (c.length < ncols) c.push(''); return c; };
  const out = ['| ' + pad(rows[0]).join(' | ') + ' |', '| ' + Array(ncols).fill('---').join(' | ') + ' |'];
  rows.slice(1).forEach(r => out.push('| ' + pad(r).join(' | ') + ' |'));
  return out.join('\n');
}

// Insert a starter markdown table AT THE CARET. When called from a box's ⊞
// action it targets that box by id (like insertExcalidrawBlock); with no id it
// falls back to the last-focused box. The button fires on mousedown +
// preventDefault (below) so the editor keeps its caret — we splice the table's
// pipe-source lines right after the caret's line, then re-render in place so the
// md-table-block renderer turns them into an editable grid exactly where the
// cursor was. If there's no usable in-box caret we fall back to appending at the
// end (the original behavior).
function insertNotesTable(e, boxId) {
  if (e && e.preventDefault) e.preventDefault();   // mousedown: don't blur the editor / drop its caret
  let editor;
  if (boxId) {
    const sel = (typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(boxId) : boxId;
    editor = document.querySelector(`.notes-editor[data-box-id="${sel}"]`);
  } else {
    const live = _lastFocusedNotesEditor && document.body.contains(_lastFocusedNotesEditor);
    editor = live ? _lastFocusedNotesEditor : document.querySelector('.notes-editor');
  }
  if (!editor) { showToast('⚠ Open a notes ' + LBL('boxNoun').toLowerCase() + ' first'); return; }
  // Default task-tracker table: Sr.No / Task / Sub-Task / Notes, four starter rows numbered 1-4 (Rishabh 2026-10-27
  // 21:0x: "Date column hata do, first column Sr.No"; the Date column went with it).
  const starter = '| Sr.No | Task | Sub-Task | Notes |\n| --- | --- | --- | --- |\n'
    + '| 1 |  |  |  |\n| 2 |  |  |  |\n| 3 |  |  |  |\n| 4 |  |  |  |';

  // Resolve the caret's top-level line div — but ONLY if the caret is actually
  // inside THIS editor and not inside an atomic block (a table/mermaid/excalidraw
  // block is contenteditable=false; splicing raw divs in there would corrupt it).
  const winSel = window.getSelection();
  let lineDiv = null;
  if (winSel && winSel.rangeCount) {
    const a = winSel.anchorNode;
    const ael = a && (a.nodeType === 1 ? a : a.parentElement);
    const inThis = ael && ael.closest && ael.closest('.notes-editor') === editor;
    const inAtomic = ael && ael.closest && ael.closest('.md-table-block, .mermaid-block, .excalidraw-block, .video-embed-block, .video-link-block, .pdf-embed-block, .pdf-link-block, .video-file-block');
    if (inThis && !inAtomic) lineDiv = notesEditorLineDiv(editor);
  }

  if (lineDiv) {
    // Splice the starter as plain pipe-line <div>s right after the caret's line,
    // a blank line on each side so the parser treats it as its own table region.
    // Then re-render in place: getEditorContent serializes the spliced lines and
    // setEditorContent collapses the header+separator into a real editable grid
    // at this position (same path that renders a table you typed by hand).
    const frag = document.createDocumentFragment();
    const blank = () => { const d = document.createElement('div'); d.appendChild(document.createElement('br')); return d; };
    frag.appendChild(blank());
    starter.split('\n').forEach(l => { const d = document.createElement('div'); d.textContent = l; frag.appendChild(d); });
    frag.appendChild(blank());
    editor.insertBefore(frag, lineDiv.nextSibling);   // appends if nextSibling is null
    setEditorContent(editor, getEditorContent(editor));
  } else {
    // No usable in-box caret → preserve the original end-append behavior exactly.
    const cur = getEditorContent(editor).replace(/\s+$/, '');
    const next = cur ? cur + '\n\n' + starter + '\n' : starter + '\n';
    setEditorContent(editor, next);
  }
  editor.dispatchEvent(new Event('input'));   // debounced save + outline rebuild
  showToast('✓ Table inserted');
}

;
// ==== FILE: js/notes/notes-tables-view.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-tables-view.js
// ==========================================================================
let notesColResize = null;  // { block, table, colEl, startX, startWidth }
function startNotesColResize(e, block, handle) {
  e.preventDefault();
  e.stopPropagation();
  const table = block.querySelector('table.md-table');
  if (!table) return;
  const ci = parseInt(handle.dataset.ci, 10);
  // Untouched tables are auto-layout with no <colgroup>; capture the current
  // rendered widths into an explicit fixed-layout colgroup so the drag has a
  // concrete per-column width to mutate.
  let colgroup = table.querySelector('colgroup');
  if (!colgroup) {
    colgroup = document.createElement('colgroup');
    table.querySelectorAll('thead th').forEach(th => {
      const col = document.createElement('col');
      col.style.width = Math.round(th.getBoundingClientRect().width) + 'px';
      colgroup.appendChild(col);
    });
    table.insertBefore(colgroup, table.firstChild);
    table.classList.add('md-table-fixed');
    syncNotesTableWidth(table);
  }
  const colEl = colgroup.children[ci];
  if (!colEl) return;
  notesColResize = { block, table, colEl, startX: e.clientX, startWidth: colEl.getBoundingClientRect().width };
  document.body.classList.add('col-resizing');
  document.addEventListener('mousemove', onNotesColResizeMove);
  document.addEventListener('mouseup', onNotesColResizeEnd);
}
function onNotesColResizeMove(e) {
  if (!notesColResize) return;
  const w = Math.max(40, notesColResize.startWidth + (e.clientX - notesColResize.startX));
  notesColResize.colEl.style.width = Math.round(w) + 'px';
  syncNotesTableWidth(notesColResize.table);
}
function onNotesColResizeEnd() {
  if (!notesColResize) return;
  const { block, table } = notesColResize;
  const widths = Array.from(table.querySelectorAll('colgroup col'))
    .map(c => Math.round(parseFloat(c.style.width) || c.getBoundingClientRect().width));
  mdTableSetWidths(block, widths);                        // persist into data-source
  notesColResize = null;
  document.body.classList.remove('col-resizing');
  document.removeEventListener('mousemove', onNotesColResizeMove);
  document.removeEventListener('mouseup', onNotesColResizeEnd);
  const editor = block.closest && block.closest('.notes-editor');
  if (editor) editor.dispatchEvent(new Event('input'));   // debounced save
}

// ── Auto-fit column widths ────────────────────────────────────────────────
// "↔ Fit" sizes every column to its own content instead of leaving the table
// crammed into equal slivers. For each column we measure the natural width of
// its widest cell — using an off-screen probe that copies that cell's font and
// horizontal padding, with white-space:normal and no width limit, so the probe
// lays each <br>-separated line on one line and its width is the widest line
// ("fit the text up to its line breaks"). The result is clamped:
//   • MIN so a short column ("India", "N/A") isn't an unreadable sliver;
//   • MAX so a long paragraph wraps to a few comfortable lines on screen
//     rather than stretching into one enormous line that scrolls off the edge.
// Widths are applied straight to the live table's <colgroup> (created if the
// table is still auto-layout) — no full-editor re-render, so OTHER tables in
// the box keep their scroll position — and persisted as the `<!--cols:…-->`
// comment via the normal debounced save (mirrors a drag-resize).
function autoFitNotesTableColumns(block, quiet) {
  const table = block && block.querySelector('table.md-table');
  if (!table) return;
  const ncols = table.querySelectorAll('thead th').length;
  if (!ncols) return;
  const editor = block.closest && block.closest('.notes-editor');

  const MIN = 64, MAX = 360, BUF = 6;   // px

  // Group cells by column index (header + body share one column count).
  const colCells = Array.from({ length: ncols }, () => []);
  table.querySelectorAll('tr').forEach(tr => {
    Array.prototype.forEach.call(tr.children, (cell, ci) => {
      if (ci < ncols) colCells[ci].push(cell);
    });
  });

  // One reusable off-screen probe. Border-box so the measured width includes
  // the padding we copy from each cell (matches how <col width> is honored
  // under table-layout:fixed). It MUST live INSIDE a .notes-editor: the URL-pill
  // glyph (🔗 ::before), padding and white-space:nowrap are scoped to
  // `.notes-editor a.url-pill`, so a body-level probe would under-measure any
  // column containing a URL and the pill would then clip. Absolute + off-screen
  // means it sizes to content regardless of the editor's own width.
  const probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;left:-99999px;top:0;visibility:hidden;'
    + 'display:inline-block;white-space:normal;box-sizing:border-box;';
  (editor || document.body).appendChild(probe);

  const widths = colCells.map(cells => {
    let w = MIN;
    cells.forEach(cell => {
      const cs = getComputedStyle(cell);
      probe.style.fontFamily = cs.fontFamily;
      probe.style.fontSize = cs.fontSize;
      probe.style.fontWeight = cs.fontWeight;     // headers are bold → measured per-cell
      probe.style.fontStyle = cs.fontStyle;
      probe.style.letterSpacing = cs.letterSpacing;
      probe.style.paddingLeft = cs.paddingLeft;
      probe.style.paddingRight = cs.paddingRight;
      // Canonical display HTML (collapsed URL pills) — independent of whether
      // the cell happens to be focused/expanded right now.
      probe.innerHTML = renderMdInline(cellToMarkdown(cell));
      const cw = Math.ceil(probe.getBoundingClientRect().width) + BUF;
      if (cw > w) w = cw;
    });
    return Math.min(MAX, Math.max(MIN, w));
  });
  probe.remove();

  // Apply to a fixed-layout colgroup on the LIVE table (no re-render).
  let colgroup = table.querySelector('colgroup');
  if (!colgroup) {
    colgroup = document.createElement('colgroup');
    for (let i = 0; i < ncols; i++) colgroup.appendChild(document.createElement('col'));
    table.insertBefore(colgroup, table.firstChild);
  }
  while (colgroup.children.length < ncols) colgroup.appendChild(document.createElement('col'));
  while (colgroup.children.length > ncols) colgroup.removeChild(colgroup.lastChild);  // drop any stale extras
  table.classList.add('md-table-fixed');
  widths.forEach((wpx, i) => { if (colgroup.children[i]) colgroup.children[i].style.width = wpx + 'px'; });
  syncNotesTableWidth(table);

  // Persist as the cols comment + autosave (no-op write in read-only, where the
  // fetch shim swallows the save — the fit then stays visual-only for the session).
  mdTableSetWidths(block, widths);
  if (editor) editor.dispatchEvent(new Event('input'));   // debounced save
  if (!quiet && typeof showToast === 'function') showToast('✓ Columns auto-fit');
}

// Walk a cell's DOM to recover the markdown text of its contents.
//   <strong>/<b> → **bold**
//   <em>/<i>     → *italic*
//   url-pill <a> → underlying URL (so saving keeps the URL, not "domain.com")
//   <br>         → space (markdown pipe-tables are single-line per cell)
//   literal `|`  → escaped to `\|` so it can't break the surrounding row
function cellToMarkdown(cell) {
  let out = '';
  function walk(node) {
    if (node.nodeType === Node.TEXT_NODE) { out += node.nodeValue; return; }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    // Skip non-content header affordances (sort/filter controls, resize handle)
    // so their glyphs never end up in the serialized header markdown.
    if (node.classList && (node.classList.contains('tv-th-ctrls') || node.classList.contains('col-resize'))) return;
    const tag = node.tagName.toLowerCase();
    // An image in a cell is content like any text: its markdown (notes-editor-serialize.js imageNodeToMarkdown), never
    // recursed into (the wrap's Copy button is chrome). Before, the walker fell through the wrap and the image was gone
    // on the next save (Rishabh 2026-10-16).
    const imageMd = imageNodeToMarkdown(node);
    if (imageMd != null) { out += imageMd; return; }
    if (tag === 'strong' || tag === 'b') {
      out += '**'; node.childNodes.forEach(walk); out += '**'; return;
    }
    if (tag === 'em' || tag === 'i') {
      out += '<em>'; node.childNodes.forEach(walk); out += '</em>'; return;
    }
    if (tag === 'u') {
      out += '<u>'; node.childNodes.forEach(walk); out += '</u>'; return;
    }
    if (tag === 'span' || tag === 'font') {
      const hex = normalizeColorHex((node.style && node.style.color) || node.getAttribute('color'));
      if (hex) { out += `<span style="color:${hex}">`; node.childNodes.forEach(walk); out += '</span>'; return; }
    }
    if (tag === 'code') {
      out += '`'; node.childNodes.forEach(walk); out += '`'; return;
    }
    if (tag === 'a' && node.classList && node.classList.contains('url-pill')) {
      out += node.dataset.url || node.getAttribute('href') || node.textContent;
      return;
    }
    // Shift+Enter inside a cell → a real line break, persisted as a literal <br>
    // in the pipe-markdown (renderMdInline turns it back into a <br> element).
    if (tag === 'br') { out += '<br>'; return; }
    // A plain Enter inside a cell yields a block element (div/p); treat its
    // boundary as a line break too so multi-line cells survive serialization
    // instead of having their words run together.
    if (tag === 'div' || tag === 'p') {
      if (out && !/<br>\s*$/.test(out)) out += '<br>';
      node.childNodes.forEach(walk);
      return;
    }
    node.childNodes.forEach(walk);
  }
  cell.childNodes.forEach(walk);
  // Collapse whitespace (keeps <br> markers — they hold none), tidy spaces around
  // breaks, drop a trailing break, escape pipes, trim. A HEADER is one line: its
  // leading breaks go too (the stored `<br>Status` of a header heals on its next save).
  out = out
    .replace(/\s+/g, ' ')
    .replace(/ *<br> */g, '<br>')
    .replace(/(?:<br>)+$/g, '');
  if (cell.tagName === 'TH') out = out.replace(/^(?:<br>)+/g, '');
  return out
    .replace(/\|/g, '\\|')
    .trim();
}

// Insert a line break at the caret inside a table cell — used to make
// Enter / Shift+Enter deterministic. The browser's own default for a
// contenteditable=true cell nested in a contenteditable=false block is
// unreliable (it sometimes inserts no <br> at all), so we do it ourselves.
// When the break lands at the very end of the cell, Chrome won't render the
// fresh empty line without a trailing "bogus" <br>; we add one and park the
// caret just before it. cellToMarkdown strips trailing <br>s, so the bogus
// node never reaches the saved pipe-source.
function insertCellLineBreak(cell) {
  const sel = window.getSelection();
  if (!sel || !sel.rangeCount) return;
  const range = sel.getRangeAt(0);
  range.deleteContents();
  const br = document.createElement('br');
  range.insertNode(br);
  // A single trailing <br> is no line to the browser: the caret "after" it renders on the SAME line and the next
  // keystroke lands before it, so Enter at the end of a cell's text showed nothing and typing stayed on the line
  // (sweep 2026-10-15: b1 + Enter + x -> b1x<br>). The break at the end therefore gets a placeholder <br> after it
  // (the one the browser needs to show the empty new line); a save keeps only the real break (cellToMarkdown drops
  // trailing breaks), so nothing extra persists. Whitespace-only text after the break counts as nothing.
  let after = br.nextSibling;
  while (after && after.nodeType === 3 && !after.nodeValue) after = after.nextSibling;
  if (!after || (after.nodeType === 1 && after.getAttribute('contenteditable') === 'false')) {
    br.parentNode.insertBefore(document.createElement('br'), br.nextSibling);
  }
  range.setStartAfter(br);
  range.collapse(true);
  sel.removeAllRanges();
  sel.addRange(range);
}

// ── Notes-table sort & filter (display-only) ─────────────────────────────────
// A per-column sort + value filter, persisted as a leading `<!--tv:BASE64-->`
// comment in the table source (base64 of {s:{c,d}, f:{ci:[values]}}). It only
// changes how rows are DISPLAYED — the saved row order never changes (rows carry
// data-ri; updateMdTableDataSource serializes by it). Works in read-only too
// (the comment update is in-memory; the disk save is a harmless no-op there).

function tvDecode(viewLine) {
  if (!viewLine) return { sort: null, filters: {} };
  const m = String(viewLine).match(/<!--\s*tv:\s*(.*?)\s*-->/);
  const payload = m ? m[1] : String(viewLine);
  try {
    const o = JSON.parse(decodeURIComponent(escape(atob(payload))));
    return { sort: o.s ? { ci: o.s.c, dir: o.s.d } : null, filters: o.f || {} };
  } catch (_) { return { sort: null, filters: {} }; }
}
function tvEncode(view) {
  const o = {};
  if (view.sort) o.s = { c: view.sort.ci, d: view.sort.dir };
  if (view.filters && Object.keys(view.filters).length) o.f = view.filters;
  if (!o.s && !o.f) return '';                          // empty view → no comment
  return '<!--tv:' + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + '-->';
}
function tvReadView(block) { return tvDecode(mdTableSplit(block).viewLine); }
function tvWriteView(block, view) {
  const caret = activeTableCell(block);                 // a sort / filter keeps data-ri, so the same cell exists after
  const { rows, widthsLine } = mdTableSplit(block);
  const lead = [widthsLine, tvEncode(view)].filter(Boolean).join('\n');
  block.dataset.source = (lead ? lead + '\n' : '') + rows.join('\n');
  rerenderMdTable(block, caret ? { ri: caret.bodyRowIndex, ci: caret.colIndex } : null);   // re-render applies the view
}
// Drop value FILTERS (keeping any sort) directly in the source, no re-render —
// used before adding/clearing rows so a freshly-blank row isn't instantly hidden
// by an active filter that doesn't include the empty value.
function tvClearFilters(block) {
  const view = tvReadView(block);
  if (!view.filters || !Object.keys(view.filters).length) return;
  view.filters = {};
  const { rows, widthsLine } = mdTableSplit(block);
  const lead = [widthsLine, tvEncode(view)].filter(Boolean).join('\n');
  block.dataset.source = (lead ? lead + '\n' : '') + rows.join('\n');
}
// Plain comparison/display text for a cell's markdown (strip bold, breaks→space).
function tvCellText(md) {
  return String(md == null ? '' : md)
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();
}
function tvNumIfNumeric(s) {
  const m = String(s).replace(/[,$₹€£\s]/g, '').match(/^-?\d+(?:\.\d+)?$/);
  return m ? parseFloat(m[0]) : null;
}
function tvCompare(a, b, dir) {
  const an = tvNumIfNumeric(a), bn = tvNumIfNumeric(b);
  let c;
  if (an !== null && bn !== null) c = an - bn;
  else c = String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
  return dir === 'desc' ? -c : c;
}
function tvRowMatches(cells, filters, colCount) {
  for (const k in filters) {
    const ci = +k;
    if (colCount != null && (ci < 0 || ci >= colCount)) continue;  // stale (column removed) → ignore
    if (!Array.isArray(filters[k])) continue;
    const v = tvCellText(cells[ci] != null ? cells[ci] : '');
    if (filters[k].indexOf(v) === -1) return false;     // AND across columns, OR within a column
  }
  return true;
}
// Distinct displayed values of column ci (sorted), read from the source body rows.
function tvColumnValues(block, ci) {
  const { rows } = mdTableSplit(block);
  const seen = new Set(), vals = [];
  for (let r = 2; r < rows.length; r++) {               // [header, separator, body…]
    const cells = parseMdTableRow(rows[r]);
    const v = tvCellText(cells[ci] != null ? cells[ci] : '');
    if (!seen.has(v)) { seen.add(v); vals.push(v); }
  }
  vals.sort((a, b) => tvCompare(a, b, 'asc'));
  return vals;
}
// Cycle a column's sort: none → asc → desc → none.
function tvCycleSort(block, ci) {
  const view = tvReadView(block);
  const cur = (view.sort && view.sort.ci === ci) ? view.sort.dir : null;
  const next = cur === null ? 'asc' : (cur === 'asc' ? 'desc' : null);
  view.sort = next ? { ci, dir: next } : null;
  tvWriteView(block, view);
}

// ── Filter dropdown (value checkboxes + search, like a data-grid column menu) ──
let _tvPop = null;
let _tvSearchMode = 'prefix';   // filter-dropdown search: 'prefix' (begins-with) | 'contains'; remembered across opens
function tvCloseFilterPop() {
  if (_tvPop) { _tvPop.remove(); _tvPop = null; }
  document.removeEventListener('mousedown', _tvPopOutside, true);
  document.removeEventListener('keydown', _tvPopKey, true);
}
function _tvPopOutside(e) { if (_tvPop && !_tvPop.contains(e.target)) tvCloseFilterPop(); }
function _tvPopKey(e) { if (e.key === 'Escape') tvCloseFilterPop(); }
// Build + show the floating filter dropdown (search + Starts-with/Contains mode
// toggle + value checkboxes + Select all/Clear + Apply/Cancel). Shared by the
// notes-table filter (tvOpenFilter) and the epic data-grid filter
// (gridOpenFilter in table.js): pass the column's distinct `values`, the
// initially-`selected` set, the anchor element to position under, and an
// `onApply(chosenValues)` callback that persists/applies the chosen values.
function tvBuildFilterPop(values, selectedInit, anchorEl, onApply) {
  tvCloseFilterPop();
  const selected = new Set(selectedInit);   // local working copy, mutated by the checkboxes

  const pop = document.createElement('div');
  pop.className = 'tv-filter-pop';
  const search = document.createElement('input');
  search.type = 'text'; search.className = 'tv-filter-search'; search.placeholder = 'Search…';
  // Two search modes: "Starts with" (prefix) and "Contains" (substring).
  const modeRow = document.createElement('div');
  modeRow.className = 'tv-filter-mode';
  const mPrefix = document.createElement('button'); mPrefix.type = 'button'; mPrefix.textContent = 'Starts with';
  const mContains = document.createElement('button'); mContains.type = 'button'; mContains.textContent = 'Contains';
  modeRow.appendChild(mPrefix); modeRow.appendChild(mContains);
  const tools = document.createElement('div');
  tools.className = 'tv-filter-tools';
  const selAll = document.createElement('button'); selAll.type = 'button'; selAll.textContent = 'Select all';
  const clr = document.createElement('button'); clr.type = 'button'; clr.textContent = 'Clear';
  tools.appendChild(selAll); tools.appendChild(clr);
  const list = document.createElement('div'); list.className = 'tv-filter-list';
  const foot = document.createElement('div'); foot.className = 'tv-filter-foot';
  const cancel = document.createElement('button'); cancel.type = 'button'; cancel.className = 'tv-btn'; cancel.textContent = 'Cancel';
  const apply = document.createElement('button'); apply.type = 'button'; apply.className = 'tv-btn tv-btn-primary'; apply.textContent = 'Apply';
  foot.appendChild(cancel); foot.appendChild(apply);
  pop.appendChild(search); pop.appendChild(modeRow); pop.appendChild(tools); pop.appendChild(list); pop.appendChild(foot);

  const rowEls = [];
  values.forEach(v => {
    const lab = document.createElement('label'); lab.className = 'tv-filter-item';
    lab.title = v === '' ? '(empty)' : v;   // full value on hover (the row text is truncated)
    const cb = document.createElement('input'); cb.type = 'checkbox'; cb.checked = selected.has(v);
    cb.addEventListener('change', () => { if (cb.checked) selected.add(v); else selected.delete(v); });
    const span = document.createElement('span');
    span.textContent = v === '' ? '(empty)' : v;
    if (v === '') span.className = 'tv-empty';
    lab.appendChild(cb); lab.appendChild(span);
    list.appendChild(lab);
    rowEls.push({ v, lab, cb });
  });
  const applySearch = () => {
    const q = search.value.toLowerCase().trim();
    rowEls.forEach(r => {
      const t = r.v.toLowerCase();
      const match = !q || (_tvSearchMode === 'prefix' ? t.startsWith(q) : t.includes(q));
      r.lab.style.display = match ? '' : 'none';
    });
  };
  const setMode = (m) => {
    _tvSearchMode = m;
    mPrefix.classList.toggle('active', m === 'prefix');
    mContains.classList.toggle('active', m === 'contains');
    applySearch();
  };
  // mousedown+preventDefault so clicking a mode keeps focus + the typed query in
  // the search box (no blur). Re-focus defensively.
  mPrefix.addEventListener('mousedown', (e) => { e.preventDefault(); setMode('prefix'); search.focus(); });
  mContains.addEventListener('mousedown', (e) => { e.preventDefault(); setMode('contains'); search.focus(); });
  search.addEventListener('input', applySearch);
  setMode(_tvSearchMode);   // init the active toggle from the remembered preference
  // Select all / Clear act on the currently-VISIBLE (search-filtered) items.
  selAll.addEventListener('click', () => rowEls.forEach(r => { if (r.lab.style.display !== 'none') { r.cb.checked = true; selected.add(r.v); } }));
  clr.addEventListener('click', () => rowEls.forEach(r => { if (r.lab.style.display !== 'none') { r.cb.checked = false; selected.delete(r.v); } }));
  cancel.addEventListener('click', tvCloseFilterPop);
  apply.addEventListener('click', () => {
    const chosen = values.filter(v => selected.has(v));
    tvCloseFilterPop();
    onApply(chosen);
  });

  document.body.appendChild(pop);
  const r = anchorEl.getBoundingClientRect();
  const W = 240;
  // Position under the anchor, clamped into the viewport on both axes. If the
  // dropdown would run off the bottom, flip it above the anchor (or clamp) so
  // the Apply/Cancel buttons are never below the fold — matters most for a
  // notes-table header low on a long page.
  const ph = pop.offsetHeight;
  let top = r.bottom + 4;
  if (top + ph > window.innerHeight - 8) {
    const above = r.top - ph - 4;
    top = above >= 8 ? above : Math.max(8, window.innerHeight - ph - 8);
  }
  pop.style.top = (window.scrollY + top) + 'px';
  pop.style.left = (window.scrollX + Math.max(8, Math.min(r.left, window.innerWidth - W - 8))) + 'px';
  _tvPop = pop;
  search.focus();
  setTimeout(() => {
    document.addEventListener('mousedown', _tvPopOutside, true);
    document.addEventListener('keydown', _tvPopKey, true);
  }, 0);
}

function tvOpenFilter(block, ci, anchorEl) {
  const view = tvReadView(block);
  const values = tvColumnValues(block, ci);
  // Interacting with the dropdown (on <body>) blurs the editor cell, which
  // triggers the box's blur re-render and detaches `block`. Re-resolve the live
  // block by its position at Apply time so the write/re-render still lands.
  const editor = block.closest && block.closest('.notes-editor');
  const blockIdx = editor ? Array.prototype.indexOf.call(editor.querySelectorAll('.md-table-block'), block) : -1;
  const liveBlock = () => (editor && blockIdx >= 0 && editor.querySelectorAll('.md-table-block')[blockIdx]) || block;
  const active = view.filters && view.filters['' + ci];
  const selected = new Set(active ? active : values);   // no filter ⇒ all selected
  tvBuildFilterPop(values, selected, anchorEl, (chosen) => {
    if (!view.filters) view.filters = {};
    if (chosen.length === values.length) delete view.filters['' + ci];   // all ⇒ no filter
    else view.filters['' + ci] = chosen;
    tvWriteView(liveBlock(), view);
  });
}

// Rebuild a .md-table-block's data-source from its live cells. Called on
// every cell `input` so subsequent saves/re-renders capture the edits.
// Alignment is preserved by reading the existing separator row from the
// previous data-source — the live DOM doesn't store it explicitly.
function updateMdTableDataSource(block) {
  const table = block.querySelector('table.md-table');
  if (!table) return;
  const headerRow = table.querySelector('thead tr');
  if (!headerRow) return;
  const oldLines = (block.dataset.source || '').split('\n');
  // Find the separator by content, not a fixed index — a leading width comment
  // shifts the rows down, so oldLines[1] is no longer guaranteed to be it
  // (using the index would silently reset column alignment on every keystroke).
  const sepLine = oldLines.find(isMdTableSeparator) || '';
  const aligns = isMdTableSeparator(sepLine) ? parseMdTableAlignment(sepLine) : [];
  const headerCells = Array.from(headerRow.querySelectorAll('th')).map(cellToMarkdown);
  const sepCells = headerCells.map((_, i) => {
    const a = aligns[i];
    if (a === 'center') return ':---:';
    if (a === 'right') return '---:';
    if (a === 'left') return ':---';
    return '---';
  });
  // Serialize body rows in their ORIGINAL order (data-ri), not the displayed
  // order. With a sort/filter view active the rendered <tr>s are reordered/
  // hidden, so saving by DOM order would persist the sort and lose the canonical
  // order. data-ri (assigned at render) maps each row back to its source slot,
  // so editing a cell while sorted/filtered still writes the right row and the
  // saved markdown keeps its author order. Filtered-out rows stay in the DOM
  // (display:none), so they're never dropped.
  const bodyTrs = Array.from(table.querySelectorAll('tbody tr'));
  bodyTrs.sort((a, b) => (parseInt(a.dataset.ri, 10) || 0) - (parseInt(b.dataset.ri, 10) || 0));
  const bodyRowsMd = bodyTrs.map(row =>
    Array.from(row.querySelectorAll('td')).map(cellToMarkdown)
  );
  const lines = [
    '| ' + headerCells.join(' | ') + ' |',
    '| ' + sepCells.join(' | ') + ' |',
    ...bodyRowsMd.map(row => '| ' + row.join(' | ') + ' |')
  ];
  // Typing in a cell never changes the column count, so carry the drag-set width
  // comment AND the sort/filter view comment through verbatim. Kept LEADING —
  // matches mdTableCompose so re-parse stays consistent.
  const vLine = oldLines.find(l => /^\s*<!--\s*tv:/.test(l));
  if (vLine) lines.unshift(vLine.trim());
  const wLine = oldLines.find(l => /^\s*<!--\s*cols:/.test(l));
  if (wLine) lines.unshift(wLine.trim());
  block.dataset.source = lines.join('\n');
}

;
// ==== FILE: js/notes/notes-tables-menu.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files).
// Module: notes-tables-menu.js - the ☰ menu on a notes table block (Copy / Delete -
// one word each; "Edit source" dropped as not needed, Rishabh 2026-09-24) and the copy itself. Rishabh 2026-09-24: the
// standalone "✕ Table" button left the hover row and "⋮ source" became this one
// icon. The menu is a body-level popover (the .notes-color-pop pattern), so the
// editor's own stacking context / overflow never clips it. Read-only shows Copy
// only - Delete is an edit.
// ==========================================================================
function _closeNotesTableMenu() {
  const p = document.getElementById('notesTableMenu');
  if (p) p.classList.remove('open');
  document.removeEventListener('mousedown', _notesTableMenuOutside, true);
}
function _notesTableMenuOutside(ev) {
  const p = document.getElementById('notesTableMenu');
  if (p && !p.contains(ev.target)) _closeNotesTableMenu();
}
// mousedown + preventDefault on the icon and on every item, so opening the menu and picking an entry never move the
// caret out of the cell the user is in (mdTableDelete reads nothing from the caret, but the user's
// place is theirs to keep).
// ONE block-menu popover for every notes block that carries a ☰ (the table, the whiteboard): the caller hands the
// items, this opens the body-level popover under the icon. items = [{ label, fn }].
function openNotesPopMenu(e, items) {
  e.preventDefault();
  e.stopPropagation();
  let pop = document.getElementById('notesTableMenu');
  if (!pop) { pop = document.createElement('div'); pop.id = 'notesTableMenu'; pop.className = 'notes-pop-menu'; document.body.appendChild(pop); }
  pop.innerHTML = '';
  for (const { label, fn } of items) {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'npm-item'; b.tabIndex = -1; b.textContent = label;
    b.addEventListener('mousedown', (ev) => { ev.preventDefault(); ev.stopPropagation(); _closeNotesTableMenu(); fn(); });
    pop.appendChild(b);
  }
  const r = (e.currentTarget || e.target).getBoundingClientRect();
  pop.style.top = Math.round(r.bottom + 4) + 'px';
  pop.style.right = Math.round(window.innerWidth - r.right) + 'px';   // right-aligned under the icon, like the icon itself
  pop.classList.add('open');
  setTimeout(() => document.addEventListener('mousedown', _notesTableMenuOutside, true), 0);
}
function openNotesTableMenu(e, block) {
  const readOnly = !!(document.body && document.body.classList.contains('tt-readonly'));
  const items = [{ label: 'Copy', fn: () => copyNotesTable(block) }];
  if (!readOnly) {
    // Cut = Copy + remove, no confirm: the clipboard holds the table and the box's Ctrl+Z brings it back
    // (Rishabh 2026-10-16: "table mein copy, delete ke saath cut bhi hona chahiye").
    items.push({ label: 'Cut', fn: () => { copyNotesTable(block); const editor = block.closest && block.closest('.notes-editor'); block.remove(); if (editor) editor.dispatchEvent(new Event('input')); showToast('✓ Table cut'); } });
    items.push({ label: 'Delete', fn: () => mdTableDelete(block) });
  }
  openNotesPopMenu(e, items);
}

// The table AS SHOWN (Rishabh 2026-09-24: "as per filter and sorting") - the header + the visible body rows in
// display order, each cell as its markdown (cellToMarkdown skips the sort / resize affordances).
function notesTableShownRows(block) {
  const table = block.querySelector('table.md-table');
  const header = Array.from(table.querySelectorAll('thead th'), cellToMarkdown);
  const body = Array.from(table.querySelectorAll('tbody tr'))
    .filter(tr => !tr.classList.contains('tv-row-hidden'))
    .map(tr => Array.from(tr.cells, cellToMarkdown));
  return { header, body };
}
// Two clipboard flavours: text/html = a plain <table> (Excel / Sheets / Docs paste a grid; this editor's paste
// handler turns it into a table block) and text/plain = the pipe markdown (readable anywhere, parsed by this editor
// too). Column widths and the sort / filter comment are not copied - the copy is the data you see.
function copyNotesTable(block) {
  const { header, body } = notesTableShownRows(block);
  const pipe = (cells) => '| ' + cells.join(' | ') + ' |';
  const md = [pipe(header), '|' + header.map(() => '---').join('|') + '|'].concat(body.map(pipe)).join('\n');
  const cellHtml = (c) => applyInlineMd(escapeHtmlForEditor(c)).replace(/&lt;br&gt;/g, '<br>');   // **bold** / `code` / <br> kept
  const tr = (cells, tag) => '<tr>' + cells.map(c => '<' + tag + '>' + cellHtml(c) + '</' + tag + '>').join('') + '</tr>';
  const html = '<table><thead>' + tr(header, 'th') + '</thead><tbody>' + body.map(c => tr(c, 'td')).join('') + '</tbody></table>';
  navigator.clipboard.write([new ClipboardItem({
    'text/html': new Blob([html], { type: 'text/html' }),
    'text/plain': new Blob([md], { type: 'text/plain' }),
  })]).then(
    () => showToast('✓ Table copied (' + body.length + ' rows)'),
    (err) => showToast('⚠ Could not copy the table (' + ((err && err.message) || err) + ')'));
}

;
// ==== FILE: js/notes/notes-structure.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-structure.js
// ==========================================================================


// ── Epic-level CRUD ──────────────────────────────────────────────────────

async function addNotesEpic() {
  const sec = SECTIONS[activeSection];
  // A SHARED (view-only) virtual subject is the teacher's projection - not the
  // recipient's to add real chapters into (its file is synthetic). Guard the action
  // even though the button is suppressed for it (renderSubtabs).
  if (sec && sec._sharedVirtual) {
    showToast('This is a shared ' + LBL('tabNoun').toLowerCase() + ' (view-only). Add your own ' + LBL('epicNoun').toLowerCase() + 's in one of your own ' + LBL('tabNoun').toLowerCase() + 's.');
    return;
  }
  if (!notesPrefix(sec)) {
    showToast('⚠ ' + LBL('epicNoun') + 's not supported in this ' + LBL('tabNoun').toLowerCase());
    return;
  }
  sec.notesEpics = sec.notesEpics || [];
  // Named by the shared rule (mcp-server/shared/default-chapter.mjs chapterName): the button's word - "New Notes" in a
  // document, "New Chapter" in a book (Rishabh 2026-10-05) - numbered when taken. The same name a new domain's BORN
  // chapter gets (sections.js _createSection), so the two cannot be told apart.
  const { epicId: id, boxId } = DefaultChapter.mintChapterIds();   // the one id shape (shared with the MCP + the server)
  const epic = { id, name: DefaultChapter.chapterName(LBL('notesNoun'), sec.notesEpics.map(n => n.name)), layout: DefaultChapter.CHAPTER_LAYOUT, boxes: [{ id: boxId }] };
  sec.notesEpics.push(epic);
  // Save BEFORE show (Rishabh 2026-10-05, "pehle save, lekin calls ek saath"): the tab appears only once the store
  // holds the chapter, so a refused or lost write can never leave a tab on screen that does not exist on the server.
  // The two writes go to two different documents (the chapter list, the first box's empty file) and cannot race each
  // other, so they leave TOGETHER - one round trip instead of two (F measured 1.9 s click-to-tab on the old chain of
  // awaits). The read-back of the box we just wrote is skipped too (notes-persistence _boxFresh).
  // The box save is silent: the tab appearing is the success, and a failure gets ONE sentence (below), not the box's own as well.
  const [meta, box] = await Promise.all([saveNotesMeta(sec), saveNotesContent(sec, id, boxId, '', true)]);
  if (meta && meta.failedFile) {
    // The chapter list did not take it: nothing of it stays. The box file, if that write landed, would be an orphan
    // for a chapter that does not exist - remove it as well.
    sec.notesEpics.splice(sec.notesEpics.indexOf(epic), 1);
    if (!(box && box.failedFile)) deleteNotesContent(sec, id, boxId).catch(() => {});
    showToast('⚠ Could not add the ' + LBL('notesNoun').toLowerCase() + ' - the server did not take it. Try again.');
    return;
  }
  sec.activeSubtab = 'All';
  sec.activeNotesEpic = id;
  // Append the new pill to the unified subtab order so it lands at the end
  // of the strip (alongside table-Epics in display order).
  if (typeof subtabOrderInsertAtEnd === 'function') {
    subtabOrderInsertAtEnd(sec, subtabKeyOfNotes(id));
  }
  await openNotesEpic(id);
  renderSubtabs();
}


async function delNotesEpic(id) {
  const sec = SECTIONS[activeSection];
  const idx = (sec.notesEpics || []).findIndex(n => n.id === id);
  if (idx < 0) return;
  const epic = sec.notesEpics[idx];
  if (epic._sharedVirtual) {   // a shared (view-only) chapter isn't the recipient's to delete
    showToast('This is a shared ' + LBL('epicNoun') + ' - ask the sender to remove your access.');
    return;
  }
  if (!(await showConfirmModal({
    title: 'Delete ' + LBL('epicNoun') + '?',
    message: `"${epic.name}" and all its boxes (and any pasted images) will be permanently removed.`,
    okLabel: 'Delete', danger: true
  }))) return;

  // Collect every image referenced by every box. We have to read each box's
  // .md off disk (the epic might not even be the active one — its editors
  // wouldn't be in the DOM).
  const imageFilesToDelete = new Set();
  for (const b of (epic.boxes || [])) {
    try {
      const content = await loadNotesContent(sec, id, b.id);
      extractImageRefs(content).forEach(f => imageFilesToDelete.add(f));
    } catch (_) {}
  }

  // Delete: every box's .md, the legacy single-file (if any), and every image
  const ops = [];
  for (const b of (epic.boxes || [])) ops.push(deleteNotesContent(sec, id, b.id));
  ops.push(fetch('/delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename: notesContentFilenameLegacy(sec, id) })
  }).catch(() => {}));
  for (const f of imageFilesToDelete) ops.push(deleteImageFile(f));
  await Promise.all(ops);

  // Clean in-memory tracking for these boxes
  for (const b of (epic.boxes || [])) delete _boxImages[b.id];

  sec.notesEpics.splice(idx, 1);
  _deletedEpicIds.add(String(id));   // so saveNotesMeta's merge-unknown-tabs doesn't resurrect it from Firestore
  await saveNotesMeta(sec);
  // Remove this pill from the unified subtab order
  if (typeof subtabOrderRemove === 'function') {
    subtabOrderRemove(sec, subtabKeyOfNotes(id));
  }
  if (sec.activeNotesEpic === id) {
    // Deleted the OPEN chapter → the same landing rule as opening the subject (data.js landOnFirstChapter): its
    // first remaining chapter; with none left, its table view (a table, or the empty-subject card). The roadmap
    // aggregate is never where a subject lands (Rishabh 2026-10-27).
    sec.activeNotesEpic = null;
    landOnFirstChapter(sec, null);
    if (sec.activeNotesEpic) { await openEpic(sec.activeNotesEpic); renderSubtabs(); return; }
    sec.activeSubtab = resolveLandingSubtab(sec, null);
    if (typeof rememberSubtab === 'function') rememberSubtab(activeSection, sec.activeSubtab);
    renderSubtabs();
    showTableView();
    renderTable();
  } else {
    // Deleted a NON-active chapter → repaint the pills, and refresh the roadmap so
    // the removed chapter's lane + cards leave any aggregate (the always-on Roadmap
    // tab, or an aggregate-scope chapter view). renderNotesRoadmap no-ops if hidden.
    renderSubtabs();
    if (typeof renderNotesRoadmap === 'function') renderNotesRoadmap();
  }
  showToast('✓ Notes deleted' + (imageFilesToDelete.size ? ` (+ ${imageFilesToDelete.size} image${imageFilesToDelete.size === 1 ? '' : 's'})` : ''));
}


function renameNotesEpic(id, newName) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === id);
  if (!epic) return;
  if (epic._sharedVirtual) { renderSubtabs(); return; }   // shared (view-only): not renameable
  const trimmed = (newName || '').trim();
  if (!trimmed || trimmed === epic.name) { renderSubtabs(); return; }
  if (trimmed === 'All' || trimmed === 'Roadmap') { showToast('⚠ Cannot use "' + trimmed + '" as a name'); renderSubtabs(); return; }
  if ((sec.notesEpics).some(n => n.id !== id && n.name === trimmed)) {
    showToast('⚠ "' + trimmed + '" already exists'); renderSubtabs(); return;
  }
  epic.name = trimmed;
  saveNotesMeta(sec);
  renderSubtabs();
  showToast('✓ Renamed to "' + trimmed + '"');
}


// ── Box-level CRUD ───────────────────────────────────────────────────────

async function addNotesBox() {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return;
  // A shared (view-only) chapter's content is not the recipient's to edit - no box adds.
  // (The toolbar button is also suppressed for a locked epic in renderNotesToolbar.)
  if (epic.locked) { showToast('This ' + LBL('epicNoun') + ' is shared to you (view-only).'); return; }
  const boxId = 'box_' + Math.random().toString(36).slice(2, 7);
  // A leftover (removed-feature) epic can have no boxes array; adding a box is how
  // it becomes an ordinary notes epic, so seed the array before pushing.
  if (!epic.boxes) epic.boxes = [];
  // UI-A-1 (Rishabh 2026-09-18: "selected value from outline ke basis pe"): insert right AFTER the box the
  // person is on. The LAST action wins: the outline's live click pin first (it is where they are looking),
  // else the editor they last focused - only if it is still on screen and belongs to THIS chapter - else
  // the end as before. A stale focus (another chapter's editor, a deleted box) falls through to the end.
  const ids = new Set(epic.boxes.map(x => x.id));
  const pinned = outlineSelectedBoxId();
  const focused = (_lastFocusedNotesEditor && document.body.contains(_lastFocusedNotesEditor)) ? _lastFocusedNotesEditor.dataset.boxId : null;
  const anchorId = (pinned && ids.has(pinned)) ? pinned : ((focused && ids.has(focused)) ? focused : null);
  const at = anchorId ? epic.boxes.findIndex(x => x.id === anchorId) + 1 : epic.boxes.length;
  epic.boxes.splice(at, 0, { id: boxId });
  stampBoxLastEdited(sec, epic.id, boxId);   // MU-1 L8: creating the box is the creator's first edit
  await saveNotesMeta(sec);                  // ...persisted by this existing write, not a second one
  await saveNotesContent(sec, epic.id, boxId, '');
  await renderNotesBoxes(); // re-render full grid
  renderNotesToolbar();      // refresh box count + show layout switcher
  renderNotesRoadmap();      // new box appears as a Later station
  renderNotesOutline();
  // Land where it went in (Q2, Rishabh yes): a mid-list insert the person has to hunt for is "where did it
  // go" in another shape. Scroll the new box into view and put the caret in it - the focus handler then
  // makes it the last-focused box, so the next "+ Add Box" chains right after it.
  scrollNotesToBox(boxId);
  const newEditor = document.querySelector(`.notes-editor[data-box-id="${boxId}"]`);
  if (newEditor) newEditor.focus();
  showToast('✓ ' + LBL('boxNoun') + ' added');
}


// Rename a box — edits its first # heading (the box's single title). Blank input
// removes the heading (box reverts to "Box N"). Everything else (body, roadmap
// card, outline) follows because they all read that one heading.
async function renameNotesBox(boxId) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return;
  const box = (epic.boxes || []).find(b => b.id === boxId);
  if (!box) return;
  const editor = document.querySelector(`.notes-editor[data-box-id="${boxId}"]`);
  const cur = (editor && typeof getEditorContent === 'function') ? _firstH1(getEditorContent(editor)) : (box.title || '');
  const next = await showPromptModal({ title: LBL('boxNoun') + ' title', label: 'Leave blank to remove the title', value: cur, okLabel: 'Save' });
  if (next === null) return; // cancelled
  renameBoxHeading(boxId, next.trim());
}

// Toggle "full width" for a box — it spans the whole row (grid-column:1/-1 in the
// column layouts, flex-basis:100% in Flow). Lets you mix a full-width box with a
// multi-column row, e.g. one wide box on top and two columns beneath it. Live
// class toggle (no re-render) so the editor keeps its content + caret. Persisted
// per box in the notes meta.
function toggleNotesBoxFull(boxId) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return;
  const box = (epic.boxes || []).find(b => b.id === boxId);
  if (!box) return;
  const now = !box.full;
  if (now) box.full = true; else delete box.full;
  const node = document.querySelector(`.notes-box[data-box-id="${boxId}"]`);
  if (node) {
    // The grid item is the box's SLOT (notes-render.js wraps each box; the Fit window's room on the page), so the row
    // span lives on the slot (.notes-slot--full, styles.css) exactly as the render path sets it - the box's own class
    // only marks its state. Toggling the box alone left the layout unchanged until the next render (Rishabh
    // 2026-11-02: "unable to set to full width a box?", the toast said done and nothing moved).
    const slot = node.closest('.notes-slot');
    if (!slot) throw new Error('notes: box ' + boxId + ' has no .notes-slot around it (notes-render.js renders one per box)');
    slot.classList.toggle('notes-slot--full', now);
    node.classList.toggle('notes-box--full', now);
    const btn = node.querySelector('.box-fw');
    if (btn) btn.classList.toggle('active', now);
  }
  saveNotesMeta(sec);
  if (typeof showToast === 'function') showToast(now ? '✓ ' + LBL('boxNoun') + ' set to full width' : '✓ ' + LBL('boxNoun') + ' back to column width');
}

// Toggle a per-box exemption from the epic-level Fit toggle. When Fit is on, every
// box auto-sizes to its content — but a box marked "fixed height" (nofit) keeps
// its own resizable height and scrolls instead, so e.g. a big diagram box doesn't
// blow the page height while the surrounding text boxes still auto-fit. Live class
// toggle (no re-render). Persisted per box in the notes meta.
function toggleNotesBoxFit(boxId) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return;
  const box = (epic.boxes || []).find(b => b.id === boxId);
  if (!box) return;
  const now = !box.nofit;
  if (now) box.nofit = true; else delete box.nofit;
  const node = document.querySelector(`.notes-box[data-box-id="${boxId}"]`);
  if (node) {
    node.classList.toggle('notes-box--nofit', now);
    const btn = node.querySelector('.box-nofit');
    if (btn) btn.classList.toggle('active', now);
  }
  saveNotesMeta(sec);
  if (typeof showToast === 'function') showToast(now
    ? (notesFitMode(epic) ? '✓ Fixed height - this ' + LBL('boxNoun').toLowerCase() + ' is excluded from Fit' : '✓ This ' + LBL('boxNoun').toLowerCase() + ' will keep a fixed height when Fit is on')
    : '✓ ' + LBL('boxNoun') + ' follows Fit again');
}

async function delNotesBox(boxId) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return;
  if (epic.boxes.length <= 1) {
    showToast('⚠ Cannot delete the only ' + LBL('boxNoun').toLowerCase() + ' - delete the ' + LBL('epicNoun') + ' instead');
    return;
  }
  const idx = epic.boxes.findIndex(b => b.id === boxId);
  if (idx < 0) return;
  // L7: refused BEFORE the confirm, not only at the file write. deleteNotesContent would
  // refuse the .md, but the box would already be spliced out of the meta - the box would
  // vanish from everyone's screen while its content stayed on disk.
  if (_refuseIfBoxLocked(sec, epic.id, boxId)) return;
  if (!(await showConfirmModal({ title: 'Delete ' + LBL('boxNoun').toLowerCase() + '?', message: 'This ' + LBL('boxNoun').toLowerCase() + "'s content and any images used only by it will be removed.", okLabel: 'Delete', danger: true }))) return;

  // Snapshot the box's image refs BEFORE we remove the box from epic.boxes,
  // so we can diff against sibling boxes to figure out which images are
  // unique to this one (safe to delete) vs. shared (must keep).
  const editor = document.querySelector(`.notes-editor[data-box-id="${boxId}"]`);
  const myRefs = editor ? extractImageRefs(getEditorContent(editor)) : new Set();
  const siblingRefs = collectLiveImageRefs(boxId);
  const orphanImages = [...myRefs].filter(f => !siblingRefs.has(f));

  epic.boxes.splice(idx, 1);
  _deletedBoxIds.add(String(epic.id) + ' ' + String(boxId));   // so the box-level merge doesn't resurrect it from the DB's stale copy
  delete _boxImages[boxId];
  await saveNotesMeta(sec);
  await Promise.all([
    deleteNotesContent(sec, epic.id, boxId),
    ...orphanImages.map(f => deleteImageFile(f))
  ]);
  await renderNotesBoxes();
  renderNotesToolbar();
  renderNotesRoadmap();      // its station goes away with the box
  renderNotesOutline();
  showToast('✓ ' + LBL('boxNoun') + ' deleted' + (orphanImages.length ? ` (+ ${orphanImages.length} image${orphanImages.length === 1 ? '' : 's'})` : ''));
}


async function setNotesLayout(layout) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic || epic.layout === layout) return;
  epic.layout = layout;
  await saveNotesMeta(sec);
  // A read-only SHARED chapter can't persist to its (virtual, stripped-on-save) meta - remember the
  // viewer's OWN layout choice locally so a refresh keeps it (Rishabh 2026-08-11; read by _srSavedView).
  if (epic._sharedVirtual && epic._sharedProductId) { try { localStorage.setItem('evReadView:' + epic._sharedProductId + ':' + (epic._sharedCi || 0) + ':layout', layout); } catch (_) {} }
  // Only the wrapper's data-layout needs to change; box contents/IDs unchanged.
  const wrap = document.getElementById('notesBoxes');
  if (wrap) wrap.dataset.layout = layout;
  renderNotesToolbar(); // refresh which button shows active
}

// Toggle "fit to content": each box auto-sizes to its text (no inner scrollbar)
// instead of a fixed/resizable height. Orthogonal to the column layout — works
// with any of them. Full re-render so the post-toggle resize fire is skipped
// (the ResizeObserver's first fire per box) and no content-height gets saved as
// a manual height.
// Fit is ONE mode, on or off (Rishabh 2026-10-27 18:2x: "purana 3rd mode wapas - content height + row max"): ON = a
// box is as tall as its content, the boxes of a row as tall as the row's tallest, the page scrolls; it is never
// capped to the screen and never scrolls inside itself (the screen-capped box of the same day read as "height
// chhoti hai"). epic.fit holds 'content' | false; a stored 'screen' (the old 3-state cycle's first state) and a
// legacy true both read as on. DEFAULT = on (Rishabh 2026-10-12: a chapter that holds NO stored value opens on Fit);
// only an explicit off (false, written by the toggle) reads as off. Every reader (the editable render, the shared read
// view, the toolbar, the height guard) goes through here, so the default lives in one place; 'content' is the
// internal key (CSS [data-fit="content"], the viewer's saved choice).
function notesFitMode(epic) {
  if (!epic) return '';
  return epic.fit === false ? '' : 'content';
}
async function setNotesFit() {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return;
  epic.fit = notesFitMode(epic) ? false : 'content';
  await saveNotesMeta(sec);
  // Persist the viewer's OWN fit choice for a read-only shared chapter (same reason as layout above): the mode string, '0' = off.
  if (epic._sharedVirtual && epic._sharedProductId) { try { localStorage.setItem('evReadView:' + epic._sharedProductId + ':' + (epic._sharedCi || 0) + ':fit', notesFitMode(epic) || '0'); } catch (_) {} }
  await renderNotesBoxes();
  if (typeof renderNotesRoadmap === 'function') renderNotesRoadmap();   // roadmap follows Fit too: on = full, off = compact-scroll
  renderNotesToolbar(); // refresh the toggle's active state
  // Fit ON lands the first box at the page top - the same landing an outline box click gives (Rishabh 2026-09-15:
  // "achieve this position when we first click fit").
  if (notesFitMode(epic)) {
    const first = document.querySelector('#notesBoxes .notes-box[data-box-id]');
    if (first) scrollNotesToBox(first.dataset.boxId);
  }
}


// ── Box drag-reorder ─────────────────────────────────────────────────────
// Drag handle (the ⋮⋮ in the top-right of each box) starts the drag. The
// entire box accepts drops. On drop, the array order updates, the DOM nodes
// are physically reordered (which preserves cursor + unsaved edits inside
// each editor), meta is saved, and the sidebar outline re-renders.

let draggedBoxId = null;

function onBoxDragStart(e, boxId) {
  draggedBoxId = boxId;
  e.dataTransfer.effectAllowed = 'move';
  try { e.dataTransfer.setData('text/plain', boxId); } catch (_) {}
  // Visually dim the source box while it's being dragged
  const src = document.querySelector(`.notes-box[data-box-id="${boxId}"]`);
  if (src) src.classList.add('is-dragging');
}

function onBoxDragOver(e) {
  if (!draggedBoxId) return;
  e.preventDefault(); // required to allow drop
  e.dataTransfer.dropEffect = 'move';
  e.currentTarget.classList.add('drag-over');
}

function onBoxDragLeave(e) {
  e.currentTarget.classList.remove('drag-over');
}

function onBoxDragEnd() {
  draggedBoxId = null;
  document.querySelectorAll('.notes-box.drag-over').forEach(el => el.classList.remove('drag-over'));
  document.querySelectorAll('.notes-box.is-dragging').forEach(el => el.classList.remove('is-dragging'));
}

function onBoxDrop(e, targetBoxId) {
  e.preventDefault();
  e.currentTarget.classList.remove('drag-over');
  applyBoxReorder(draggedBoxId, targetBoxId);
  draggedBoxId = null;
}

// Shared box-reorder core used by BOTH the main-grid box drop and the sidebar
// outline drop: moves `draggedId` into `targetBoxId`'s slot in epic.boxes,
// mirrors the move in the #notesBoxes DOM (preserving each editor's cursor +
// unsaved text instead of re-rendering), saves meta, and re-renders the outline.
function applyBoxReorder(draggedId, targetBoxId) {
  if (!draggedId || draggedId === targetBoxId) return;
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return;

  const fromIdx = epic.boxes.findIndex(b => b.id === draggedId);
  const toIdx = epic.boxes.findIndex(b => b.id === targetBoxId);
  if (fromIdx < 0 || toIdx < 0) return;

  // Forward drag (top→bottom) inserts AFTER the target; backward inserts BEFORE.
  // Drop on the LAST box to move to the end, the FIRST to move to the start.
  const before = epic.boxes.map(b => b.id);
  const [moved] = epic.boxes.splice(fromIdx, 1);
  epic.boxes.splice(toIdx, 0, moved);   // after the splice, toIdx lands after the target on a forward move
  _afterBoxOrderChange(sec, epic, moved.id, 'reordered', before);
}

// ONE finish for both box moves (↑ / ↓ and drag). epic.boxes is the single source of truth: the roadmap hook (B's row 17,
// Rishabh's option A) places the card next to its new neighbour and may RE-SORT epic.boxes to the board's reading order
// (an order the board cannot express - two cards side by side - comes back the way it was); THEN the boxes on screen are
// drawn from epic.boxes, never by a second positional DOM step (J, 2026-10-05: the old insertBefore after the hook moved
// the box a second time, so the screen disagreed with the data until a reload). The toast says only what stuck.
// `before` (the id order the move left) makes the move a step Ctrl+Z takes back (notes-undo.js notesOrderStep, loaded
// with the notes view like every notes module); a step taken back or forward (restoreNotesBoxOrder) passes null - it is
// not a new step.
function _afterBoxOrderChange(sec, epic, boxId, verb, before) {
  if (before) notesOrderStep(epic.id, before);
  if (typeof nrOnBoxOrderChanged === 'function') nrOnBoxOrderChanged(epic, boxId);
  syncNotesBoxesDom(epic);
  saveNotesMeta(sec);
  renderNotesOutline(); // box order changed → outline order changes too
  renderNotesRoadmap(); // one board row = one box: the row order IS epic.boxes order (Rishabh 2026-10-05), so every move sticks
  showToast('✓ ' + LBL('boxNoun') + ' ' + verb);
}
// The notes view's box elements in epic.boxes order - open editors keep their state (nodes move, nothing re-renders).
// The roadmap module's own DOM sync does the same append-in-order; this is the notes view's one copy of that rule.
function syncNotesBoxesDom(epic) {
  const wrap = document.getElementById('notesBoxes');
  if (!wrap) return;
  // The grid's children are the boxes' SLOTS (notes-render.js: <div class="notes-slot"> around each box - the room a
  // Fit box keeps on the page while its card is a sticky window, notes-fit-window.js), so a slot moves, box inside.
  (epic.boxes || []).forEach(b => {
    const el = wrap.querySelector(`.notes-box[data-box-id="${b.id}"]`);
    if (!el) return;
    const slot = el.closest('.notes-slot');
    if (!slot) throw new Error('notes: box ' + b.id + ' has no .notes-slot around it (notes-render.js renders one per box)');
    wrap.appendChild(slot);
  });
}

// ── Sidebar-outline drag-reorder ─────────────────────────────────────────
// The left outline's part-headers (one per box) are draggable so boxes can be
// reordered from the compact list, not just by dragging the big boxes. Reuses
// the same box-reorder core (applyBoxReorder) + the shared draggedBoxId. Only
// wired in edit mode (renderNotesOutline omits draggable in read-only).
function onOutlineDragStart(e, boxId) {
  draggedBoxId = boxId;
  e.dataTransfer.effectAllowed = 'move';
  try { e.dataTransfer.setData('text/plain', boxId); } catch (_) {}
  if (e.currentTarget && e.currentTarget.classList) e.currentTarget.classList.add('outline-dragging');
}
function onOutlineDragOver(e) {
  if (!draggedBoxId) return;
  e.preventDefault(); // required to allow drop
  e.dataTransfer.dropEffect = 'move';
  if (e.currentTarget && e.currentTarget.classList) e.currentTarget.classList.add('drag-over');
}
function onOutlineDragLeave(e) {
  if (e.currentTarget && e.currentTarget.classList) e.currentTarget.classList.remove('drag-over');
}
function onOutlineDragEnd() {
  draggedBoxId = null;
  document.querySelectorAll('.outline-part-header.drag-over, .outline-part-header.outline-dragging')
    .forEach(el => el.classList.remove('drag-over', 'outline-dragging'));
}
function onOutlineDrop(e, targetBoxId) {
  e.preventDefault();
  if (e.currentTarget && e.currentTarget.classList) e.currentTarget.classList.remove('drag-over');
  applyBoxReorder(draggedBoxId, targetBoxId);
  draggedBoxId = null;
}

// Reliable reorder via the ↑ / ↓ box buttons — sidesteps native drag-and-drop's
// lack of auto-scroll across a long box list. Swaps the box with its neighbour
// in BOTH the meta array and the DOM (the DOM swap preserves each editor's
// unsaved state instead of re-rendering from scratch).
function moveNotesBoxBy(boxId, delta) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return;
  const i = epic.boxes.findIndex(b => b.id === boxId);
  const j = i + delta;
  if (i < 0 || j < 0 || j >= epic.boxes.length) return; // already at an edge
  const before = epic.boxes.map(b => b.id);
  const t = epic.boxes[i]; epic.boxes[i] = epic.boxes[j]; epic.boxes[j] = t;
  _afterBoxOrderChange(sec, epic, boxId, 'moved', before);
}

// An order step taken back or forward (notes-undo.js timeline, Ctrl+Z / Ctrl+Y after a move): epic.boxes goes to `ids`
// (a box added since keeps its place after them; one deleted since is simply not there) and finishes like any move -
// the screen, the outline, the board, the save. Returns the order it left, which is the step in the other direction.
function restoreNotesBoxOrder(epicId, ids, verb) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === epicId);
  if (!epic) return null;
  const left = epic.boxes.map(b => b.id);
  const byId = new Map(epic.boxes.map(b => [b.id, b]));
  epic.boxes = ids.filter(id => byId.has(id)).map(id => byId.get(id)).concat(epic.boxes.filter(b => !ids.includes(b.id)));
  _afterBoxOrderChange(sec, epic, null, verb, null);
  return left;
}


// ── View switching: table-mode vs notes-mode ─────────────────────────────

function showTableView() {
  // Leaving the notes view drops any fullscreen box — clear the page scroll-lock
  // so switching to a table-view tab while fullscreen can't freeze scrolling.
  document.body.classList.remove('tt-box-fs-active');
  // Leaving the section "Roadmap" tab — drop its chrome-hide class (showRoadmapView adds it).
  document.body.classList.remove('tt-roadmap-tab');
  const tv = document.getElementById('tableView');
  const nv = document.getElementById('notesView');
  const tl = document.getElementById('timelineView');
  if (tv) tv.style.display = '';
  if (nv) nv.style.display = 'none';
  if (tl) tl.style.display = 'none';
  const pt = document.getElementById('parentTaskTabs');
  if (pt) pt.style.display = '';
  // The left sidebar (#parentTaskTabs) is shared: Parent-Task tabs in table mode,
  // the notes outline in notes mode. Entering table view must rebuild it for the
  // active table-Epic — otherwise a previously-open notes-Epic's outline lingers
  // beside the table (e.g. after "+ Add Epic" or deleting the active notes-Epic,
  // which switch to the table but don't re-render the sidebar themselves).
  // renderGroupOutline (table-groupby.js) clears it when the view has no grouping.
  if (typeof renderGroupOutline === 'function') renderGroupOutline();
  // Left the notes view → a locked (view-only) tab no longer applies; re-sync
  // read-only so the table isn't stuck read-only.
  if (typeof window !== 'undefined' && window.__ttCloud && window.__ttCloud.refreshReadOnlyClass) window.__ttCloud.refreshReadOnlyClass();
}

function showNotesView() {
  // Opening a chapter leaves the section "Roadmap" tab — drop its chrome-hide class
  // so this chapter's toolbar + boxes paint (renderNotesRoadmap re-syncs it too).
  document.body.classList.remove('tt-roadmap-tab');
  const tv = document.getElementById('tableView');
  const nv = document.getElementById('notesView');
  const tl = document.getElementById('timelineView');
  if (tv) tv.style.display = 'none';
  if (nv) nv.style.display = '';
  if (tl) tl.style.display = 'none';
  const pt = document.getElementById('parentTaskTabs');
  if (pt) pt.style.display = '';
  // Entered the notes view → re-sync read-only in case this tab is view-only.
  if (typeof window !== 'undefined' && window.__ttCloud && window.__ttCloud.refreshReadOnlyClass) window.__ttCloud.refreshReadOnlyClass();
}

// Tells cloud-store.js whether editing must be OFF right now because the visible
// notes tab is a "view only" (locked) shared chapter. Computed live (no stored
// state): true only when the notes view is showing AND its active epic is locked.
//
// SCOPE (Rishabh, 2026-08-08): a within-journal READ share is a VIRTUAL chapter
// (`_sharedVirtual`) rendered by renderSharedEpicBoxes - contenteditable=false, NO
// autosave wired, and its nav is stripped on every save (saveNotesMeta /
// saveSectionsConfig). So its content is ALREADY un-writable WITHOUT forcing the whole
// app read-only. Forcing global RO for it wrongly FROZE the recipient's OWN personal
// journal (couldn't add their own subject/chapter) - the journal is theirs; the teacher
// just placed a view-only item in it. So a `_sharedVirtual` chapter no longer reports
// locked here. A MATERIALIZED locked copy (real epic with `locked:true` from
// copyEpicToJournal, rendered via the EDITABLE path) is NOT `_sharedVirtual` and STILL
// depends on this global RO to stay read-only - so it keeps reporting locked.
if (typeof window !== 'undefined') {
  window.__ttEpicLocked = function () {
    const nv = document.getElementById('notesView');
    if (!nv || nv.style.display === 'none') return false;
    const sec = (typeof SECTIONS !== 'undefined') ? SECTIONS[activeSection] : null;
    if (!sec) return false;
    const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
    return !!(epic && epic.locked && !epic._sharedVirtual);
  };
}

// Toolbar: align + ↓ Export (one zip) + + Add Box buttons + layout switcher.
// (Table insert moved to a per-box ⊞ action, alongside the ▦ diagram action.)
function renderNotesToolbar() {
  // Sync read-only state to the now-active tab: a "view only" (locked) shared tab
  // turns editing off; any other tab turns it back on. Runs on every notes render.
  if (typeof window !== 'undefined' && window.__ttCloud && window.__ttCloud.refreshReadOnlyClass) window.__ttCloud.refreshReadOnlyClass();
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  const tb = document.getElementById('notesToolbar');
  if (!tb || !epic) return;
  const n = (epic.boxes || []).length;
  const layout = epic.layout || 'stack';
  // Hidden mode: the toggle sits at the far RIGHT of this toolbar (after + Add
  // Box). In visible mode it moves into the roadmap band's control strip instead
  // (rightmost, next to + Initiative), so we omit it here.
  // Adding a roadmap WRITES the chapter (epic.roadmap, persisted by saveNotesMeta), so it
  // follows the same rule as "+ Add Box" below. Without this it was offered inside a
  // read-only book view, answered "✓ Roadmap added", and the write was dropped on the floor -
  // saveNotesMeta filters `_sharedVirtual` chapters out - so the reader was told a thing had
  // happened that had not.
  const roadmapToggle = (epic.roadmap || _nrReadOnly(epic)) ? '' : `<button class="layout-btn" onclick="toggleNotesRoadmap()" title="${LBL('roadmapShowTip')}">${LBL('roadmap')}</button>`;
  // Layouts we expose, dependent on box count to avoid silly options
  //  (e.g. 2x2 with 1 box would look weird).
  const layouts = [];
  layouts.push({ key: 'stack', label: 'Stack',   tip: 'One column, ' + (LBL('boxNoun') + (/x$/i.test(LBL('boxNoun')) ? 'es' : 's')).toLowerCase() + ' stacked vertically' });
  if (n >= 2) layouts.push({ key: '2col', label: '2 cols',  tip: 'Two columns side by side' });
  if (n >= 3) layouts.push({ key: '3col', label: '3 cols',  tip: 'Three columns side by side' });
  if (n >= 3) layouts.push({ key: '2x2',  label: '2 × 2',   tip: '2 × 2 grid (rows of 2)' });
  if (n >= 3) layouts.push({ key: 'flow', label: 'Flow',    tip: (LBL('boxNoun') + (/x$/i.test(LBL('boxNoun')) ? 'es' : 's')) + ' wrap to fit; the last row stretches to fill (e.g. 5 → 3 then 2)' });
  // Spacer-first so all actions push to the right edge — matches the table
  // toolbar's pattern (Add Row / Add Column / Delete / Undo / Redo on right).
  // (The outline collapse toggle lives on the outline panel's own header.)
  let html = '';
  // "View only" badge for a LOCKED-but-own tab (admin view mode). A SHARED (virtual)
  // chapter already shows the ONE parent 🔒 on its subject tab + a tooltip, so the badge
  // here is redundant clutter for it - suppress it (Rishabh: one lock, no repeated popups).
  if (epic.locked && !epic._sharedVirtual) html += '<span class="tts-viewonly-badge" title="This ' + LBL('epicNoun') + ' was shared to you as view-only" style="display:inline-flex;align-items:center;gap:.3rem;font-size:.8rem;font-weight:600;color:#92400e;background:#fef3c7;border:1px solid #fde68a;border-radius:6px;padding:.2rem .55rem;margin-right:.4rem">🔒 View only</span>';
  html += '<div class="toolbar-spacer"></div>';
  // Align (L/C/R) lives per-box in each box's action row now (it's a text-level
  // action on that box's content), not in this global toolbar.
  if (n >= 2) {
    html += '<span class="toolbar-label">Layout:</span><div class="layout-group">';
    layouts.forEach(l => {
      const active = l.key === layout ? ' active' : '';
      html += `<button class="layout-btn${active}" title="${l.tip}" onclick="setNotesLayout('${l.key}')">${l.label}</button>`;
    });
    html += '</div>';
  }
  // Fit toggle — independent of the column layout; on / off (see notesFitMode).
  const fitMode = notesFitMode(epic);
  const fitActive = fitMode ? ' active' : '';
  // The label stays "Fit" (Rishabh 2026-09-15: "keep Fit only") - the state reads from the tooltip + the active style.
  const fitTitle = fitMode ? 'Fit to height is on - each box is as tall as its content; boxes in a row match the tallest. Click to turn Fit off' : 'Fit to height - each box as tall as its content; boxes in a row match the tallest';
  html += `<button class="layout-btn${fitActive}" onclick="setNotesFit()" title="${fitTitle}">↕ Fit</button>`;
  // (📤 Share lives in the top header now — a global hub, not per-chapter.)
  // (↓ Export and ↓ PDF left the toolbar - Rishabh 2026-09-28: Export PDF is a grid-menu tile like the other exports.)
  // "+ Add Box" edits the chapter's CONTENT - suppress it for a LOCKED (view-only shared)
  // chapter. Previously hidden by body.tt-readonly, but a `_sharedVirtual` chapter no longer
  // sets that (so it can't freeze the recipient's own journal), so suppress it explicitly here.
  if (!epic.locked) html += `<button class="btn-small btn-add" onclick="addNotesBox()">${LBL('addBox')}</button>`;
  html += roadmapToggle;   // Roadmap toggle to the right of + Add Box (both shown + hidden)
  tb.innerHTML = html;
}

// Cache of each box's current first-# heading. Box titles (that heading) drive
// the roadmap card + station labels, so we refresh the roadmap when a box's
// heading changes — but only then, so typing body text doesn't churn it.
const _boxTitleCache = {};
function _firstH1(text) { return BoxTitle.firstH1(text); }   // the ONE rule: mcp-server/shared/box-title.mjs (window.BoxTitle from the bundle) - the MCP's read + title mirror run the same function (NB-2)

// Return `md` with its first top-level (#) heading set to `title`. Empty title
// removes the heading. No heading present + a title → prepends one. (Fence-aware.)
function _setFirstH1(md, title) {
  const t = (title || '').trim();
  const lines = (md || '').split('\n');
  let fence = false, idx = -1;
  for (let i = 0; i < lines.length; i++) {
    const s = lines[i].trim();
    if (s.startsWith('```')) { fence = !fence; continue; }
    if (fence) continue;
    if (/^#\s+.+/.test(lines[i])) { idx = i; break; }
  }
  if (idx >= 0) {
    if (t) { lines[idx] = '# ' + t; return lines.join('\n'); }
    lines.splice(idx, 1);
    if (lines[idx] !== undefined && lines[idx].trim() === '') lines.splice(idx, 1);
    return lines.join('\n');
  }
  if (!t) return md || '';
  const body = md || '';
  return body ? ('# ' + t + '\n\n' + body) : ('# ' + t + '\n');
}

// THE single title editor. A box's title is its first # heading (the one source
// of truth). This edits that heading in the live editor (which persists it and
// refreshes the outline + roadmap + title cache via the editor's own input
// handler). Falls back to the persisted cache (box.title) when the box isn't on
// screen. Used by the ✏ rename and the roadmap card's title field.
function renameBoxHeading(boxId, title) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => (n.boxes || []).some(b => b.id === boxId));
  if (!epic) return;
  const box = epic.boxes.find(b => b.id === boxId);
  if (!box) return;
  const t = (title || '').trim();
  const editor = document.querySelector(`.notes-editor[data-box-id="${boxId}"]`);
  if (editor && typeof getEditorContent === 'function' && typeof setEditorContent === 'function') {
    setEditorContent(editor, _setFirstH1(getEditorContent(editor), t));
    editor.dispatchEvent(new Event('input', { bubbles: true }));   // persist + refresh outline/roadmap/cache
  } else {
    if (t) box.title = t; else delete box.title;                   // DOM-less: cache only
    saveNotesMeta(sec);
    if (typeof renderNotesRoadmap === 'function') renderNotesRoadmap();
    if (typeof renderNotesOutline === 'function') renderNotesOutline();
  }
}


// Router used by every "reopen an epic by id" call site (pill click, boot
// restore, section switch). Every Epic is now a notes Epic — the standalone
// timeline Epic type was removed — so this is a thin wrapper kept so the many
// existing openEpic() callers keep working unchanged.
async function openEpic(id) {
  return openNotesEpic(id);
}

async function openNotesEpic(id) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === id);
  if (!epic) return;
  sec.activeNotesEpic = id;   // the outline's folds are per chapter and remembered (notes-outline.js _outlineState) - nothing to clear here
  sec.activeSubtab = 'All';
  showNotesView();
  renderNotesToolbar();
  await renderNotesBoxes();   // renderNotesBoxes branches to the read-only shared render for a virtual epic
  // A virtual shared (read-access) chapter carries no `.roadmap` - renderNotesRoadmap
  // HIDES the panel for it (early return on !epic.roadmap). MUST still be called (not
  // skipped) so a roadmap left visible by a prior view doesn't linger over the shared
  // chapter (the "roadmap opens by default on a shared chapter" bug).
  renderNotesRoadmap();
  renderNotesOutline();
}


;
// ==== FILE: js/notes/notes-outline.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-outline.js
// ==========================================================================

// Collapse / expand the left outline panel. Collapsed, the panel shrinks to a
// thin rail (the "Outline" header itself is the toggle). Notes-only: the table
// renderer clears the class so it never affects the Parent-Task nav.
let _notesOutlineCollapsed = false;
function toggleNotesOutline() {
  _notesOutlineCollapsed = !_notesOutlineCollapsed;
  renderNotesOutline();
}


// ── Outline: # / ## / ### headings → vertical sidebar (notes mode) ───────
//
// In multi-box mode, each Box is one Part in the sidebar. Within a box,
// headings are nested under that part. Click a part-header to scroll the
// page to that box; click a heading to scroll to the heading line within it.
//
// `---` lines within a single box are kept literal (no special meaning) —
// box boundaries already provide the segmentation.

function parseNotesOutlineForEpic() {
  // Returns { parts: [{ title, boxId, headings: [{level,text,lineIndex}, ...] }] }
  // One Part per Box. Always returns at least one Part if an Epic is active.
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return { parts: [] };
  const parts = [];
  (epic.boxes || []).forEach((box, boxIdx) => {
    const editor = document.querySelector(`.notes-editor[data-box-id="${box.id}"]`);
    // Use the same serializer as save() so headings remain detectable even
    // when images are mixed in (we want the markdown text, not the raw DOM).
    // A shared (read-only) box carries its markdown on the box itself (box.md,
    // the single source of truth from ev_content); its contenteditable=false
    // editor has no data-box-id, so read box.md directly instead of the DOM.
    const text = (typeof box.md === 'string') ? box.md : (editor ? getEditorContent(editor) : '');
    const lines = text.split('\n');
    const part = { title: null, titleLineIndex: -1, boxId: box.id, headings: [] };
    // Track whether we're inside a ```fenced``` code block. Anything inside
    // (mermaid source, code snippets) shouldn't be parsed as headings.
    let inFence = false, firstH1Line = -1, firstH1Text = null;
    lines.forEach((line, i) => {
      const trimmed = line.trim();
      if (trimmed.startsWith('```')) { inFence = !inFence; return; }
      if (inFence) return;
      const m = line.match(/^(#{1,3})\s+(.+?)\s*$/);
      if (m) {
        const level = m[1].length;
        part.headings.push({ level, text: m[2], lineIndex: i });
        if (level === 1 && firstH1Line < 0) { firstH1Line = i; firstH1Text = m[2]; }
      }
    });
    // The box's FIRST `# ` heading IS the box title (single-source): the heading as it reads NOW, from the editor, is
    // the part-header, shown ONCE (titleLineIndex marks its line so it is not repeated as an item). box.title is only
    // the persisted CACHE of that heading (notes-render.js mirrors it on load and 250 ms after a heading edit) or a
    // legacy explicit title of a box with no heading - so it is read ONLY when the box has no `# ` line. Reading it
    // first left the outline a step behind the text: the input timer rendered the outline BEFORE refreshing the cache,
    // so an edited heading showed the OLD title as the header and the new text as an extra row until a reload
    // (Rishabh 2026-11-02: "1.1 Uses of Networks" -> "Uses of Networks").
    if (firstH1Line >= 0) { part.title = firstH1Text; part.titleLineIndex = firstH1Line; }
    else if (box.title) part.title = box.title;
    if (!part.title) part.title = LBL('boxNoun') + ' ' + (boxIdx + 1);
    parts.push(part);
  });
  return { parts };
}

function renderNotesOutline() {
  const sec = SECTIONS[activeSection];
  const wrap = document.getElementById('parentTaskTabs');
  if (!wrap || !sec || !sec.activeNotesEpic) return;
  // Collapsed: a rail that still DOES something (the team member's, extracted at Rishabh's word 2026-09-14) - one
  // numbered pip per box, in document order, each jumping to its box, with the one you are reading filled in.
  if (_notesOutlineCollapsed) {
    wrap.classList.add('outline-collapsed');
    const { parts: railParts } = parseNotesOutlineForEpic();
    const pips = railParts.map((p, i) => {
      const tip = esc(p.title).replace(/"/g, '&quot;');
      return `<button type="button" class="outline-pip" data-box-id="${esc(p.boxId)}" onclick="outlineJumpToBox('${p.boxId}')" title="${tip}"><span>${i + 1}</span></button>`;
    }).join('');
    wrap.innerHTML =
      `<button type="button" class="outline-rail-toggle" onclick="toggleNotesOutline()" title="Show the outline" aria-label="Show the outline">&raquo;</button>`
      + (pips ? `<div class="outline-rail-list">${pips}</div>` : '');
    updateNotesOutlineActive();
    _outlineSpyOn();
    return;
  }
  wrap.classList.remove('outline-collapsed');
  const { parts } = parseNotesOutlineForEpic();
  const totalHeadings = parts.reduce((acc, p) => acc + p.headings.length, 0);
  const multiPart = parts.length > 1;
  // Read-only viewers can't reorder boxes (mutations are no-op writes), so the
  // sidebar part-headers are only made draggable when editing.
  const ro = !!(document.body && document.body.classList.contains('tt-readonly'));
  // Which LEVELS reserve the chevron column. A level reserves it only when some row AT THAT LEVEL
  // can expand - then its leaves take the invisible spacer and the labels line up (v88, Rishabh
  // 2026-09-15: "aligned nahi hai"). A level where nothing can expand has nothing to align under,
  // so it drops the slot entirely and sits at its own indent (Rishabh 2026-09-15: "3.1" was pushed
  // off the left edge by a spacer for a chevron no sibling had). Derived from the rows, never a
  // per-case exception - and computed over ALL parts, because rows of one level share one indent
  // across the whole panel, and because a value that changed as the user folded a box would make
  // the surviving rows shift sideways on every toggle.
  // Key 0 = the box part-headers, which are one level of their own above the headings.
  const levelHasToggle = { 0: multiPart && parts.some((p) => p.headings.length > (p.titleLineIndex >= 0 ? 1 : 0)) };
  parts.forEach((p) => p.headings.forEach((h, i) => {
    if (i + 1 < p.headings.length && p.headings[i + 1].level > h.level) levelHasToggle[h.level] = true;
  }));

  let html = `<div class="parent-task-tab outline-all" role="button" onclick="toggleNotesOutline()" title="Hide the outline"><span class="outline-all-label">Outline</span><span class="outline-collapse-chev">&laquo;</span></div>`;

  if (totalHeadings === 0 && !multiPart) {
    html += `<div class="outline-empty">No headings yet.<br>Use <code>#</code> <code>##</code> <code>###</code> to outline.<br>Use <b>${LBL('addBox')}</b> to split.</div>`;
    wrap.innerHTML = html;
    return;
  }

  const _st = _outlineState();   // this chapter's folds (per document, per chapter)
  parts.forEach((part, partIdx) => {
    const hs = part.headings;
    // Stable per-heading key (boxId + level + text + duplicate-occurrence) and a
    // "has deeper children" flag (the very next heading is deeper). Both derived
    // from the flat headings[] array — the DOM carries no parent/child links.
    // lineIndex is NOT used in the key (it shifts as the user types above a heading).
    const seen = {};
    hs.forEach((h, idx) => {
      const sig = h.level + '\u0001' + h.text;
      const occ = (seen[sig] = (seen[sig] || 0) + 1) - 1;
      h._key = part.boxId + '\u0001' + sig + '\u0001' + occ;
      h._kids = (idx + 1 < hs.length && hs[idx + 1].level > h.level);
    });

    // Chevron for a collapsible heading, or an invisible spacer for a leaf — so
    // same-level rows stay left-aligned. data-key is URI-encoded (heading text
    // can't break the attribute); the click is wired after innerHTML below.
    const chevron = (key, expanded, hasKids, level) => hasKids
      ? `<span class="outline-chevron${expanded ? ' open' : ''}" role="button" data-key="${encodeURIComponent(key)}" title="Expand / collapse">▸</span>`
      : levelHasToggle[level]
        ? `<span class="outline-chevron outline-chevron-spacer"></span>`
        : '';

    // Multi-box: a box's first `# ` heading shows as the uppercase part-header, so
    // ITS sub-headings hang off the part-header's own toggle (sentinel PART key)
    // instead of a heading row. titleLineIndex < 0 ⇒ the title is an explicit box
    // rename (not a heading) ⇒ the part-header is a plain label with no toggle.
    const titleH = (multiPart && part.titleLineIndex >= 0)
      ? hs.find(h => h.lineIndex === part.titleLineIndex) : null;
    const partKey = part.boxId + '\u0001PART';
    const partExpanded = !_st.parts.has(partKey);   // boxes open by default; the Set holds the folded ones
    if (multiPart) {
      const partTip = outlinePlainText(part.title).replace(/"/g, '&quot;');
      const titleIdx = titleH ? hs.indexOf(titleH) : -1;   // the scroll-spy joins this row to the editor's heading by index (data-h-idx)
      // Any heading in the box besides its title folds under the part header (Rishabh 2026-09-14: "no clicking for
      // collapse and expansion" - it used to need a `##` right under the title, so a box of `#` headings never folded).
      const hasKids = hs.length > (titleH ? 1 : 0);
      const cls = 'outline-part-header' + (hasKids ? ' has-toggle' : '');
      const chev = chevron(partKey, partExpanded, hasKids, 0);   // a leaf takes the invisible same-width spacer so every box label starts at the same x - but only while SOME box on screen can expand
      // Drag-to-reorder the underlying box straight from the sidebar (edit mode
      // only). Clicking still scrolls; dragging reorders.
      const drag = ro ? '' :
        ` draggable="true" ondragstart="onOutlineDragStart(event,'${part.boxId}')"`
        + ` ondragover="onOutlineDragOver(event)" ondragleave="onOutlineDragLeave(event)"`
        + ` ondrop="onOutlineDrop(event,'${part.boxId}')" ondragend="onOutlineDragEnd(event)"`;
      const tip = (ro ? 'Jump to: ' : 'Drag to reorder, or click to jump to: ') + partTip;
      // The box's number, the same one its pip shows on the collapsed rail (1 = the first box in document order), so the
      // rail and the list name a box the same way and two boxes with one title ("Features", "Features") stay apart
      // (Rishabh 2026-10-27: "collapse mein numbering hai, expanded mein nahi - context lose ho jaata hai").
      html += `<div class="${cls}" tabindex="0" role="button" data-box-id="${esc(part.boxId)}"${titleIdx >= 0 ? ` data-h-idx="${titleIdx}"` : ''}${drag} onclick="outlineJumpToBox('${part.boxId}')" title="${tip}">${chev}<span class="outline-part-num">${partIdx + 1}</span><span class="outline-part-label">${esc(part.title)}</span></div>`;
    }

    // Visibility walk. A heading is hidden only when a KNOWN ancestor is collapsed;
    // an orphan (## with no preceding #, ### with no ##) stays visible so nothing
    // is ever unreachable. Level-1 (#) always shows — the default "headings only".
    let l1Key = null, l1Exp = false, l2Key = null, l2Exp = false;
    hs.forEach((h, hIdx) => {
      if (multiPart && !partExpanded) return;   // a folded box hides every heading it holds
      if (multiPart && h.lineIndex === part.titleLineIndex) {
        // The skipped title-#: not emitted, but it parents its ## children, which
        // expand/collapse via the part-header toggle.
        l1Key = partKey; l1Exp = partExpanded; l2Key = null; l2Exp = false;
        return;
      }
      if (h.level === 1) {
        l1Key = h._key; l1Exp = _st.exp.has(h._key); l2Key = null; l2Exp = false;
      } else if (h.level === 2) {
        const parentExp = (l1Key === null) ? true : l1Exp;
        l2Key = h._key; l2Exp = parentExp && _st.exp.has(h._key);
        if (!parentExp) return;
      } else { // level 3
        // Prefer the ## parent; if there's no ## (a ### directly under a #), fall
        // back to the # ancestor so a collapsed # still hides it — only a true
        // orphan (no # and no ##) stays visible.
        const parentExp = (l2Key === null) ? ((l1Key === null) ? true : l1Exp) : l2Exp;
        if (!parentExp) return;
      }
      const indentRem = (h.level - 1) * 0.85;
      const weight = h.level === 1 ? '600' : '500';
      const tip = outlinePlainText(h.text).replace(/"/g, '&quot;');
      const chev = chevron(h._key, _st.exp.has(h._key), h._kids, h.level);
      html += `<div class="parent-task-tab outline-item outline-l${h.level}" role="button" tabindex="0" data-box-id="${esc(part.boxId)}" data-h-idx="${hIdx}" style="padding-left:calc(0.7rem + ${indentRem}rem); font-weight:${weight}" onclick="scrollNotesToHeading('${part.boxId}',${hIdx})" title="Jump to: ${tip}">${chev}<span class="outline-item-label">${outlineLabelHtml(h.text)}</span></div>`;
    });
  });

  wrap.innerHTML = html;
  // Wire expand/collapse. Two affordances per collapsible row:
  //  • the chevron — toggles ONLY (stopPropagation, so it never also fires the
  //    row's scroll-to navigation), preserving its original behaviour;
  //  • the row itself (the box / heading title) — toggles IN ADDITION to its
  //    existing scroll-to (inline onclick), so clicking the name expands or
  //    collapses just like the icon does. The chevron's stopPropagation prevents
  //    a double-toggle when the click lands on the chevron.
  // A clicked row keeps the keyboard focus (after its own jump-to has run), so Ctrl/Cmd + C / X / V then copy / cut /
  // paste the box the row names (ui.js, the row's right-click menu by keyboard - Rishabh 2026-10-16 "with shortcuts").
  // Typing into the box is one click into the box away, as before.
  // A HEADING row is text navigation: the caret stays in the box at that heading (Rishabh 2026-10-27: "andar cursor
  // nahi hai"), so the row itself takes no focus; the shortcuts above stay with the box header rows.
  wrap.querySelectorAll('.outline-part-header[data-box-id]').forEach(row => {
    row.addEventListener('click', () => { setTimeout(() => { if (row.isConnected) row.focus({ preventScroll: true }); }, 0); });
  });
  wrap.querySelectorAll('.outline-chevron[data-key]').forEach(el => {
    const key = decodeURIComponent(el.dataset.key);
    el.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      toggleOutlineHeading(key);
    });
    const row = el.closest('.outline-part-header, .outline-item');
    if (row) row.addEventListener('click', () => toggleOutlineHeading(key));
  });
  updateNotesOutlineActive();
  _outlineSpyOn();
}

// ── Which heading is in view (the team member's scroll-spy, extracted at Rishabh's word 2026-09-14) ──
// There is no stable DOM node per heading to key off - scrollNotesToLine navigates by window.find() over the
// serialized markdown - but the EDITOR emits one .md-head div per heading, in the same order the parser walked, so the
// heading's index within its box is a reliable join key. Rows and rail pips carry it as data-h-idx / data-box-id.
// "Current" = the last heading whose top has passed under the chrome. In the multi-column layouts the boxes sit side
// by side, so comparing tops across boxes is a heuristic there; in the stack layout it is exact.
const OUTLINE_SPY_LINE = 170;   // px below the viewport top: just under the sticky chrome
const NOTES_SCROLL_GAP = 12;    // an outline click lands the target this far below the viewport top (12 < the 16px row gap, so the previous row ends above the viewport, not on its edge) - nothing is pinned above the boxes any more (the 140px of the old sticky header let the previous row show cropped; Rishabh 2026-09-15)
let _outlineSpyPin = null;      // the box the user last clicked in the outline: it stays current until the user scrolls by hand
// The HEADING the user last clicked in the outline (its index among the box's h1-h3), with the box pin. The page often
// cannot scroll a late heading up to the spy line (a short tail under a long box), so by position alone the heading
// ABOVE it stayed lit after the click (Rishabh 2026-10-15: "Explain your decision" clicked, "What is your company"
// highlighted). The clicked heading answers "where am I" while it is on screen; a scroll by hand releases it with the pin.
let _outlineSpyPinIdx = null;
function outlineJumpToBox(boxId) {
  _outlineSpyPin = boxId; _outlineSpyPinIdx = null;
  updateNotesOutlineActive();    // the page may already be scrolled where the box is (no scroll event will come) - light it now
  scrollNotesToBox(boxId);
}
// The box the outline currently SELECTS for a structural op - "+ Add Box" inserts right after it (UI-A-1,
// Rishabh 2026-09-18: "selected value from outline ke basis pe"). It is the click pin while that pin is
// live; null once the person scrolled away by hand or focused an editor in another box.
function outlineSelectedBoxId() { return _outlineSpyPin || null; }
// An editor focus in ANOTHER box means the person moved on: release the pin so "where am I" and
// "+ Add Box" both follow the box they are actually in. Focusing the PINNED box keeps it - an outline
// heading click focuses its editor (scrollNotesToLine) just before it pins, and a same-box focus must
// never undo the click it belongs to. Robust to that call order either way.
function outlineReleasePin(boxId) {
  if (_outlineSpyPin && _outlineSpyPin !== boxId) { _outlineSpyPin = null; _outlineSpyPinIdx = null; updateNotesOutlineActive(); }
}

function updateNotesOutlineActive() {
  const wrap = document.getElementById('parentTaskTabs');
  if (!wrap) return;
  let best = null, first = null, pinned = null;
  // Iterate .notes-box (not .notes-editor): a shared read-only box has no editor data-box-id, and the box carries it.
  // Count h1-h3 only: data-h-idx indexes part.headings, which the parser fills from levels 1-3; an h4 in the DOM would
  // push the count one ahead and every later lookup would land on the wrong row.
  // Every box has an anchor: its last heading that has passed under the chrome, else (a table / diagram box with no
  // heading) its own top - so a box without headings can still be "where I am" (idx -1 lights its part header).
  document.querySelectorAll('.notes-box[data-box-id]').forEach((bx) => {
    const boxId = bx.dataset.boxId;
    const br = bx.getBoundingClientRect();
    let inBox = null;
    bx.querySelectorAll('.md-h1, .md-h2, .md-h3').forEach((h, i) => {
      const top = h.getBoundingClientRect().top;
      if (!first) first = { boxId, idx: i };
      if (top <= OUTLINE_SPY_LINE) inBox = { boxId, idx: i, top };
    });
    if (!first) first = { boxId, idx: -1 };
    const cand = inBox || (br.top <= OUTLINE_SPY_LINE ? { boxId, idx: -1, top: br.top } : null);
    // Later anchor wins; boxes side by side (2col / 3col / 2x2) tie on top - the clicked one wins the tie.
    if (cand && (!best || cand.top > best.top + 1 || (Math.abs(cand.top - best.top) <= 1 && boxId === _outlineSpyPin))) best = cand;
    // The clicked box stays current while any of it is on screen, even when the page is too short to scroll it under
    // the chrome (Rishabh 2026-09-14: "1 click kiya, 2 hi rehta hai").
    if (boxId === _outlineSpyPin && br.bottom > OUTLINE_SPY_LINE && br.top < window.innerHeight) {
      pinned = inBox || { boxId, idx: -1 };
      // The clicked heading itself, while it is on screen: it beats the position rule inside its box.
      if (_outlineSpyPinIdx != null) {
        const h = bx.querySelectorAll('.md-h1, .md-h2, .md-h3')[_outlineSpyPinIdx];
        const hr = h && h.getBoundingClientRect();
        if (hr && hr.bottom > 0 && hr.top < window.innerHeight) pinned = { boxId, idx: _outlineSpyPinIdx };
      }
    }
  });
  // Above the first anchor (page parked at the very top) -> light the first row rather than nothing.
  const cur = pinned || best || first;
  wrap.querySelectorAll('.is-current, .is-current-part').forEach((el) => { el.classList.remove('is-current', 'is-current-part'); });
  if (!cur) return;
  const q = (sel) => wrap.querySelector(sel);
  const idSel = '[data-box-id="' + String(cur.boxId).replace(/"/g, '\\"') + '"]';
  const row = q('.outline-item' + idSel + '[data-h-idx="' + cur.idx + '"]')
           || q('.outline-part-header' + idSel + '[data-h-idx="' + cur.idx + '"]');
  const part = q('.outline-part-header' + idSel);
  if (row) {
    row.classList.add('is-current');
    if (part && part !== row) part.classList.add('is-current-part');
  } else if (part) {
    part.classList.add('is-current');   // the heading's own row is folded away - the box still answers "where am I"
  }
  const pip = q('.outline-pip' + idSel);
  if (pip) pip.classList.add('is-current');
}

let _outlineSpyWired = false;
let _outlineSpyRAF = 0;
function _outlineSpyOn() {
  if (_outlineSpyWired) return;
  _outlineSpyWired = true;
  const queue = () => { if (_outlineSpyRAF) return; _outlineSpyRAF = requestAnimationFrame(() => { _outlineSpyRAF = 0; updateNotesOutlineActive(); }); };
  // CAPTURE: in the 2col/3col/2x2 layouts each .notes-editor scrolls INSIDE itself, so a window-only listener would
  // never fire for the content that actually moved. Capture on document catches both.
  document.addEventListener('scroll', queue, true);
  window.addEventListener('resize', queue);
  // A scroll the USER makes releases the click pin; the click's own smooth scroll fires no wheel / touch / key event.
  const unpin = () => { if (_outlineSpyPin) { _outlineSpyPin = null; _outlineSpyPinIdx = null; queue(); } };
  window.addEventListener('wheel', unpin, { passive: true, capture: true });
  window.addEventListener('touchstart', unpin, { passive: true, capture: true });
  window.addEventListener('keydown', (e) => { if (/^(Arrow|Page|Home|End| )/.test(e.key) || e.key === ' ') unpin(); }, true);
}

function scrollNotesToTop() {
  const wrap = document.getElementById('notesView');
  if (!wrap) return;
  const top = wrap.getBoundingClientRect().top + window.scrollY - NOTES_SCROLL_GAP;
  window.scrollTo({ top, behavior: 'smooth' });
}

// The element between `el` and its box (inclusive) that actually scrolls vertically, else null. With Fit to screen the
// BOX is capped and scrolls; with Fit off the EDITOR is; with Fit to height nothing inside scrolls. Found by measuring,
// never by reading the Fit mode, so a future mode gets this for free.
function _notesInnerScroller(el, box) {
  for (let n = el; n && n !== box.parentElement; n = n.parentElement) {
    if (n.scrollHeight > n.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(n).overflowY)) return n;
    if (n === box) break;
  }
  return null;
}

function scrollNotesToBox(boxId) {
  const box = document.querySelector(`.notes-box[data-box-id="${boxId}"]`);
  if (!box) return;
  // A box click means "the start of this box": rewind whatever scrolls inside it (Fit to screen: the box; Fit off: the editor).
  const editor = box.querySelector('.notes-editor');
  const inner = editor && _notesInnerScroller(editor, box);
  const top = box.getBoundingClientRect().top + window.scrollY - NOTES_SCROLL_GAP;
  // The page and the text inside the card move through the Fit window module (notes-fit-window.js), never as two
  // scrolls racing its sync - that race left a stuck card where it was (2026-10-28).
  if (inner) notesFitWindowJump(inner, 0, top);
  else window.scrollTo({ top, behavior: 'smooth' });
}

// Scrolls so the clicked heading of the given box is at the top, and puts the caret at its end.
// The editor emits one .md-head div per `#` / `##` / `###` line, in the order the outline parser walked the
// markdown, so the heading's INDEX within its box joins an outline row to its element - the same key the
// scroll-spy uses (data-h-idx). The old way searched the page for the heading's raw markdown TEXT (window.find),
// which fails on any inline markup: the outline holds `**Mobility - 7 Day**`, the screen shows it bold with no
// asterisks, a `code` span loses its backticks, a URL collapses into a pill (Rishabh 2026-10-27: "Mobility 7 Day pe
// click karta hoon, nahi jaata").
const NOTES_OUTLINE_HEADING_SEL = '.md-h1, .md-h2, .md-h3';
function scrollNotesToHeading(boxId, hIdx) {
  const editor = document.querySelector(`.notes-editor[data-box-id="${boxId}"]`);
  if (!editor) return;
  const boxEl = editor.closest('.notes-box');
  const hd = (boxEl || editor).querySelectorAll(NOTES_OUTLINE_HEADING_SEL)[hIdx];
  if (!hd) throw new Error(`outline: box ${boxId} has no heading #${hIdx} on screen - the parser and the renderer disagree`);
  // preventScroll: a plain focus() scrolls the focused contenteditable "into view" inside its scroll container, and an
  // editor taller than the Fit card is aligned to the card's TOP - the card's scrollTop rewinds to 0 - and only then does
  // the smooth scroll below run, so every click read as "the scroll starts again from the top" (Rishabh 2026-11-02 on the
  // merged 42-diagram box; invisible while boxes were short). The rows already focus this way (preventScroll, below).
  editor.focus({ preventScroll: true });
  const sel = window.getSelection();
  const r = document.createRange();
  r.selectNodeContents(hd);
  r.collapse(false);   // the caret lands at the end of the heading line: jump, then keep writing under it
  sel.removeAllRanges();
  sel.addRange(r);
  {
    const rect = hd.getBoundingClientRect();
    // Pin the clicked heading (its index among the box's h1-h3, the outline's own row numbering) with the box.
    _outlineSpyPin = boxId; _outlineSpyPinIdx = hIdx;
    const inner = boxEl && _notesInnerScroller(editor, boxEl);
    if (inner) {
      // The heading's box scrolls inside itself (Fit to screen, or Fit off): put the heading at the top of that
      // scroller - one editor padding below its edge, the same breathing room the box's first line has - and frame the
      // BOX at the page top like a box click, so the frame is never cropped (Rishabh 2026-09-15: "navigate to the
      // position jab header ko click karte hai"). rect is measured where the scroller stands now; this is the landing.
      _outlineSpyPin = boxId;   // the clicked box answers "where am I" while it is on screen (side-by-side layouts tie on top)
      // The landing gap under the scroller's edge: the box's sticky toolbar's bottom edge plus a line of air (the editor
      // has focus here, so the bar is fading in - its opacity reads 0 at this instant, so it is measured by layout, not
      // by opacity), else the editor's own padding (a read-only page lays the bar out at display:none). Measured, so a
      // taller toolbar lands right without a number here.
      const innerRect = inner.getBoundingClientRect();
      const bar = boxEl.querySelector('.notes-box-actions');
      const barRect = bar && bar.getBoundingClientRect();
      const barBottom = barRect && barRect.height > 0 ? barRect.bottom - innerRect.top + 8 : 0;
      const gap = Math.max(parseFloat(getComputedStyle(editor).paddingTop) || 0, barBottom);
      const innerTop = inner.scrollTop + (rect.top - innerRect.top) - gap;
      // Both moves through the Fit window module (notes-fit-window.js notesFitWindowJump): a stuck card's text is
      // written by its sync on every page-scroll delta, and that write cancelled this scroll mid-way - the click
      // "did nothing" (Rishabh 2026-10-28 prod, RUN: page 20px, text 54 -> 32, the heading 2767px below).
      notesFitWindowJump(inner, innerTop, boxEl.getBoundingClientRect().top + window.scrollY - NOTES_SCROLL_GAP);
      return;
    }
    const top = window.scrollY + rect.top - NOTES_SCROLL_GAP;
    window.scrollTo({ top, behavior: 'smooth' });
    updateNotesOutlineActive();   // a page that cannot scroll that far fires no scroll event - light the pin now
  }
}
let _notesOutlineTimer = null;   // shared timer for outline rebuild

// ── Outline fold state: per chapter, remembered per document (Rishabh 2026-10-16: "reload ke baad bhi yaad rakho") ──
// Two sets per chapter: the EXPANDED heading keys (boxId + level + text + duplicate-occurrence, never lineIndex - that
// shifts as you type; default = none, so a chapter opens headings-only) and the FOLDED box part-keys
// (boxId+'\u0001PART'; default = every box open). Kept PER CHAPTER (section key + chapter id - two chapters both hold a
// box called 'main') and persisted PER DOCUMENT for the signed-in person in this browser under
// localStorage 'tt-outline:<email>:<document id>' - so a chapter switch, a Refresh and a reload all find the folds
// again (before: cleared on every chapter open, "saare expand ho gaye"). State lives OUTSIDE the DOM so the debounced
// full re-render keeps it. No usable storage (blocked, private window, full) = the defaults and nothing thrown; the
// folds still live for the session. Toggled by the per-heading chevron via toggleOutlineHeading().
const _outlineStore = { doc: null, chapters: {} };
function _outlineDocKey() {
  const c = window.__ttCloud;
  const doc = (c && c.books && typeof c.books.activeId === 'function') ? (c.books.activeId() || 'default') : 'default';
  const who = (c && typeof c.email === 'function') ? (c.email() || '') : '';
  return 'tt-outline:' + who + ':' + doc;
}
function _outlineChapterKey() {
  const sec = SECTIONS[activeSection];
  return String(activeSection) + '\u0001' + String((sec && sec.activeNotesEpic) || '');
}
function _outlineState() {
  const dk = _outlineDocKey();
  if (_outlineStore.doc !== dk) {   // another document (or the first use): read what this browser kept for it
    _outlineStore.doc = dk; _outlineStore.chapters = {};
    let raw = null;
    try { raw = localStorage.getItem(dk); } catch (_) { raw = null; }   // storage blocked = nothing kept
    if (raw) {
      try { const o = JSON.parse(raw); for (const k in o) _outlineStore.chapters[k] = { exp: new Set(o[k].exp || []), parts: new Set(o[k].parts || []) }; }
      catch (_) { _outlineStore.chapters = {}; }   // an unreadable entry = defaults
    }
  }
  const ck = _outlineChapterKey();
  return _outlineStore.chapters[ck] || (_outlineStore.chapters[ck] = { exp: new Set(), parts: new Set() });
}
function _outlinePersist() {
  const o = {};
  for (const k in _outlineStore.chapters) { const st = _outlineStore.chapters[k]; if (st.exp.size || st.parts.size) o[k] = { exp: [...st.exp], parts: [...st.parts] }; }
  try { localStorage.setItem(_outlineStore.doc, JSON.stringify(o)); } catch (_) { /* storage blocked: the session keeps the folds */ }
}
function toggleOutlineHeading(key) {
  const st = _outlineState();
  const set = key.endsWith('\u0001PART') ? st.parts : st.exp;
  if (set.has(key)) set.delete(key);
  else set.add(key);
  _outlinePersist();
  renderNotesOutline();
}

// ── Outline row labels: the heading as the page shows it, not its markdown ────────────────────────────────────
// `## **Mobility - 7 Day**` reads "Mobility - 7 Day" in bold on the page; the row showed the asterisks (Rishabh
// 2026-10-27: "outline mein star ke saath kyon?"). The row runs the editor's own inline renderer (escape, then
// **bold** / `code` / the <em> <u> colour tags - notes-editor-parse.js applyInlineMd), so the row and the page agree
// by construction; URLs stay as text (a pill in a row would be a second control). The tooltip takes the plain words.
function outlineLabelHtml(text) {
  return applyInlineMd(escapeHtmlForEditor(text));
}
function outlinePlainText(text) {
  const d = document.createElement('div');
  d.innerHTML = outlineLabelHtml(text);
  return esc(d.textContent);
}

;
// ==== FILE: js/notes/notes-export.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-export.js
// ==========================================================================

// What is left after the exports went: the toolbar zip export, the .md / image exports and
// their helpers were deleted on Rishabh's word (2026-09-29, 0 callers); stripDiagramFences stays - copy-paste + media-copy
// (cloud-store) read it through window.

// Drop ```excalidraw/```mermaid fences so phantom ![](…) inside diagram JSON
// isn't collected as a real image (avoids a wasted /load fetch + bundling a
// non-existent file).
function stripDiagramFences(text) {
  return (text || '').replace(/```(?:excalidraw|mermaid)[\s\S]*?```/g, '');
}

;
// ==== FILE: js/notes/notes-export-pdf.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files).
// Module: notes-export-pdf.js - "Export PDF": pick the chapters, the SERVER renders
// the PDF (PDF_SERVER_CONTRACT.md: one path for the web and the MCP, a per-email
// chapter quota for readers) and the browser downloads the file. Two halves:
// (1) the web: the picker modal (with its quota line), the job (start / poll /
// Stop / Download) painted on the dashboard's busy toast; (2) the headless seam
// (window.__ttBuildPdf, ?pdf=1) the render service drives inside the real app -
// buildNotesPdf + notesPdfStage are what it runs, so the file is what the app
// shows. No browser print dialog anywhere (Rishabh 2026-09-29: "ek path").
// ==========================================================================
// The watermark text the modal offers (Rishabh 2026-09-28: "one variable, hum value change kar denge"). null = the
// title shown in the header (the subject name, e.g. "Law"); a string = that text, whatever the header says. He can
// Not editable in the UI (his word 2026-09-28 23:5x); a \n breaks the mark into lines.
var NOTES_PDF_WATERMARK_DEFAULT = 'Built using Interactive Books\nby R EduVista';
// The mark's angle in degrees: 0 = horizontal, -30 = the classic diagonal (rising to the right). Applies to the page
// mark and to every whiteboard mark alike.
var NOTES_PDF_WATERMARK_ANGLE = 0;   // his word 2026-09-28 21:2x: horizontal
// The footer note under the credit line (his word 2026-09-28 22:1x); empty = the credit alone.
var NOTES_PDF_FOOTER_NOTE = 'Complete interactive experience available at reduvista.com - content as sections, graphs and videos, with AI interaction';   // one line (his word; 2026-10-12: AI interaction is not a content format, it belongs to the whole experience); \n would break it
// HEADLESS SEAM (server render, PDF_SERVER_CONTRACT.md section 3): the render service opens the app with ?pdf=1 in
// headless Chrome and drives ONE function, window.__ttBuildPdf - the same buildNotesPdf the web runs, so the server's
// file and the browser's print are one code path. In this mode no toast is painted: progress goes to
// window.__ttPdfProgress (a string the service reads into the job label), and the print DOM is staged (print classes,
// @page rule, title) without a print dialog - the service's printToPDF takes it from there.
var NOTES_PDF_HEADLESS = /[?&]pdf=1(?:&|$)/.test(location.search);
if (NOTES_PDF_HEADLESS) { window.__ttPdfProgress = 'Preparing\u2026'; window.__ttBuildPdf = notesPdfHeadless; }
// { customToken, bookId, picks:[{ sec:<section key>, epic:<epic id>, boxes?:[<box id>] }], header?, pageBreaks? } -> { ok, title, chapters }. Throws with a
// plain message (bad token, book not opened, unknown chapter, nothing to print) - the service reports it verbatim.
async function notesPdfHeadless(job) {
  const { auth } = await import('/js/cloud-store/firebase.js');
  const { signInWithCustomToken } = await import('https://www.gstatic.com/firebasejs/10.12.5/firebase-auth.js');
  await signInWithCustomToken(auth, job.customToken);
  const wantId = job.bookId || 'default';
  await notesPdfWaitFor(() => window.__ttModeReady === true && window.__ttCloud && window.__ttCloud.books, 60000, 'The app did not finish signing in');
  // The dashboard's own open (openJournal / openBook call the same seam): loads the book, rebuilds SECTIONS and awaits
  // init(), which loads every section's chapter list - so when it returns the picks can be resolved.
  await window.__ttCloud.books.setActive(wantId);
  if (window.__ttCloud.books.activeId() !== wantId) throw new Error('The book did not open (' + wantId + ')');
  const picks = (job.picks || []).map(p => {
    const sec = SECTIONS[p.sec]; const epic = sec && (sec.notesEpics || []).find(e => e.id === p.epic);
    if (!epic) throw new Error('Unknown ' + LBL('epicNoun').toLowerCase() + ': ' + p.sec + ' / ' + p.epic);
    return { sec, epic, boxes: Array.isArray(p.boxes) ? p.boxes.map(String) : null };   // boxes = a box-level pick (those boxes only)
  });
  if (!picks.length) throw new Error('Nothing to export - no ' + LBL('epicNoun').toLowerCase() + ' picked');
  const watermark = NOTES_PDF_WATERMARK_DEFAULT != null ? NOTES_PDF_WATERMARK_DEFAULT : notesPdfBookTitle();
  // The page header: the caller's text as given ('' = none), else the default line (Rishabh 2026-10-02: "i should be
  // able to write anything ... i should be able to skip"). The file is named after the header, or the book when blank.
  const header = typeof job.header === 'string' ? job.header : notesPdfHeader(await notesPdfAuthorDefault());
  const host = await buildNotesPdf(picks, watermark, null, notesPdfBreaksOf(job.pageBreaks));
  notesPdfStage(host, header, notesPdfFooter(watermark));
  await document.fonts.ready;
  window.__ttPdfProgress = 'Rendering the PDF\u2026';
  return { ok: true, title: header || notesPdfBookTitle(), chapters: picks.length };
}
function notesPdfWaitFor(cond, ms, what) {
  const t0 = Date.now();
  return new Promise((resolve, reject) => {
    const tick = () => { if (cond()) return resolve(); if (Date.now() - t0 > ms) return reject(new Error(what + ' within ' + Math.round(ms / 1000) + ' s')); setTimeout(tick, 200); };
    tick();
  });
}
// Export PDF is for the OWNER's own books only (Rishabh 2026-09-29 11:3x: "recipient ko koi feature nahi, sirf owner
// ko"): the tile shows only on an own book (not received, not a read card, not a co-authored book). The server refuses
// the same way. The rule is per BOOK - someone else's chapter inside an own Journal is not a thing any more (his word).
var NOTES_PDF_NOT_OWN = 'Export PDF is for your own books only.';
async function notesPdfOwnBook() {
  const books = await window.__ttCloud.books.list();
  const b = books.find(x => x.active) || books.find(x => x.id === window.__ttCloud.books.activeId());
  return !!b && !b.received && !b.editorOf;
}
async function notesPdfTileRefresh() {
  const tile = document.getElementById('exportPdfBtnTop'); if (!tile) return;
  // Nobody signed in (the sign-in card, any hash change there): there is no store to read the books from - nothing to
  // show and nothing to ask. Without this the hashchange listener below ran books.list() signed out and left an
  // unhandled rejection (F's RUN 2026-10-11).
  if (!window.__ttCloud || !window.__ttCloud.storeUid()) return;
  const own = await notesPdfOwnBook();
  tile.style.display = own ? '' : 'none';
  if (!own) return;
  // Quota 0 (Rishabh 2026-10-03): the tile stays, greyed - a click asks for access. The look is the client's; the
  // refusal is the server's (every /ev/pdf verb checks the quota), so a console-enabled tile changes nothing.
  // A failed read leaves the tile as it is (the server is the gate; the next refresh asks again) - never an unhandled rejection.
  const q = await notesPdfQuotaFor(window.__ttCloud.books.activeId()).catch(() => null);
  if (!q) return;
  tile.classList.toggle('tt-pdf-off', !!q.blocked);
  tile.title = q && q.blocked ? 'Export PDF is not enabled for this account - click to request access' : 'Save chosen chapters as one PDF, with a watermark';
}
// The caller's allowance for one document, read once a minute per document (the modal re-reads for its picks).
var _notesPdfQuotaCache = { bookId: null, at: 0, q: null };
async function notesPdfQuotaFor(bookId) {
  if (!bookId) return null;
  const now = Date.now();
  if (_notesPdfQuotaCache.bookId === bookId && now - _notesPdfQuotaCache.at < 60000) return _notesPdfQuotaCache.q;
  const q = await notesPdfApi('POST', '/ev/pdf/quota', { bookId });
  _notesPdfQuotaCache = { bookId, at: now, q };
  return q;
}
// Page breaks as the seam applies them: the caller's three booleans, else the default - every unit starts a new page
// (Rishabh 2026-10-04: "default mein section bhi checked ho").
var NOTES_PDF_BREAKS_DEFAULT = Object.freeze({ box: true, chapter: true, subject: true });
function notesPdfBreaksOf(pb) {
  return pb && typeof pb === 'object' ? { box: pb.box === true, chapter: pb.chapter === true, subject: pb.subject === true } : NOTES_PDF_BREAKS_DEFAULT;
}
// Quota 0: the small "Request access" form (the landing page's invite popup, in the app's words). One optional field,
// WhatsApp; the ask lands in inviteRequests with source pdf-export (server, pdf-access.js). A second visit says so.
function showNotesPdfRequestAccess(q) {
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  const ov = el('div', 'evlib-modal-ov'); ov.id = 'notesPdfAccess';
  const card = el('div', 'evlib-modal'); ov.appendChild(card);
  const head = el('div', 'mh'); const title = el('strong', null, 'Export PDF'); title.style.fontSize = '1.05rem'; head.appendChild(title);
  const x = el('button', 'btn', '\u2715'); x.type = 'button'; head.appendChild(x); card.appendChild(head);
  const body = el('div', 'mb'); card.appendChild(body);
  const note = el('div'); note.style.cssText = 'color:var(--ev-muted);font-size:.95rem;margin-bottom:.8rem';
  body.appendChild(note);
  const fld = el('div'); fld.appendChild(el('label', 'fld', 'WhatsApp number (optional)'));
  const wa = el('input'); wa.type = 'text'; wa.placeholder = '+91 98765 43210'; wa.maxLength = 20; fld.appendChild(wa); body.appendChild(fld);
  const foot = el('div'); foot.style.cssText = 'display:flex;gap:.5rem;justify-content:flex-end;align-items:center;margin-top:1rem;border-top:1px solid var(--ev-hair);padding-top:.8rem';
  const cancel = el('button', 'btn', 'Close'); cancel.type = 'button';
  const ask = el('button', 'btn primary', 'Request access'); ask.type = 'button';
  foot.appendChild(cancel); foot.appendChild(ask); body.appendChild(foot);
  const requested = (when) => { note.textContent = 'Export PDF is not enabled for this account yet. You asked for access' + (when ? ' on ' + new Date(when).toLocaleDateString(undefined, { day: 'numeric', month: 'short' }) : '') + ' - we will enable it and let you know.'; fld.style.display = 'none'; ask.style.display = 'none'; };
  if (q && q.requested) requested(null); else note.textContent = 'Export PDF is not enabled for this account yet. Ask for access and we will enable it for you.';
  const close = () => { document.removeEventListener('keydown', onKey, true); ov.remove(); };
  const onKey = (e) => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); } };
  ask.onclick = async () => {
    ask.disabled = true;
    try { const r = await notesPdfApi('POST', '/ev/pdf/request-access', { whatsapp: wa.value.trim() }); _notesPdfQuotaCache = { bookId: null, at: 0, q: null }; requested(r.requestedAt); showToast('\u2713 Access requested'); }
    catch (e) { ask.disabled = false; showToast('\u26A0 ' + ((e && e.message) || 'Could not send the request')); }
  };
  x.onclick = close; cancel.onclick = close;
  ov.addEventListener('mousedown', (e) => { if (e.target === ov) close(); });
  document.addEventListener('keydown', onKey, true);
  document.body.appendChild(ov);
  setTimeout(() => (fld.style.display === 'none' ? cancel : wa).focus(), 0);
}
if (!NOTES_PDF_HEADLESS) {
  window.addEventListener('hashchange', () => { notesPdfTileRefresh(); });
  document.addEventListener('click', (e) => { if (e.target && e.target.closest && e.target.closest('#hdrMenuBtn')) notesPdfTileRefresh(); }, true);
}
async function openNotesPdfExport() {
  if (!(await notesPdfOwnBook())) { showToast('\u26A0 ' + NOTES_PDF_NOT_OWN); return; }
  const active = SECTIONS[activeSection];
  // every section (tab order) with at least one chapter that has a box; the picker's scope decides which are offered
  const sections = Object.keys(SECTIONS).map(k => ({ key: k, sec: SECTIONS[k], chapters: ((SECTIONS[k].notesEpics || []).filter(e => (e.boxes || []).length)) }))
    .filter(s => s.chapters.length);
  if (!sections.length) { showToast('\u26A0 Nothing to export - no ' + LBL('epicNoun').toLowerCase() + ' has ' + aan(LBL('boxNoun').toLowerCase()) + ' yet'); return; }
  const bookId = window.__ttCloud.books.activeId();
  // A failed read (J 2026-10-04: a 503 left the button dead) opens the picker as before: its quota line shows the server's
  // sentence and the server still refuses a blocked start. Only a READ that says blocked shows the request form.
  const q = await notesPdfQuotaFor(bookId).catch(() => null);
  if (q && q.blocked) { showNotesPdfRequestAccess(q); return; }   // quota 0: ask for access instead of the picker (the server refuses anyway)
  const headerDefault = notesPdfHeader(await notesPdfAuthorDefault());
  showNotesPdfModal(sections, active, bookId, headerDefault).then(pick => { if (pick) return runNotesPdfJob(bookId, pick.picks, pick.preview, pick.header, pick.pageBreaks); });
}
// The server job (PDF_SERVER_CONTRACT.md section 1): start → poll status → Download. Painted on the dashboard's busy
// toast (the Share / Duplicate pattern: "Preparing 8 of 15 topics… - Journal / Don't close the browser" + Stop); the
// label is the server's, which is the headless app's own progress line - the same words the browser build showed.
// A refusal at start (quota, entitlement) is the server's sentence, shown as it came. Stop cancels the job on the
// server; Stop after done changes nothing (the server keeps a done job).
// preview = true runs the PREVIEW job (contract section 7): no quota, no file - stamped low-res page images shown in a
// panel, from which "Save as PDF" starts the real export with the same picks.
async function runNotesPdfJob(bookId, picks, preview, header, pageBreaks) {
  _pdfToast = await import('/js/dashboard/core.js');
  const wire = picks.map(p => ({ sec: p.key, epic: p.epic.id, ...(p.boxes ? { boxes: p.boxes } : {}) }));   // boxes = a box-level pick
  _pdfJob = { cancelled: false, jobId: null };
  const job = _pdfJob;
  notesPdfBusy(preview ? 'Preparing preview…' : ('Preparing ' + picks.length + ' ' + LBL('epicNoun').toLowerCase() + (picks.length === 1 ? '' : 's') + '…'));
  try {
    const started = await notesPdfApi('POST', preview ? '/ev/pdf/preview' : '/ev/pdf/start', { bookId, picks: wire, header, pageBreaks });
    job.jobId = started.jobId;
    if (job.cancelled) { await notesPdfApi('POST', '/ev/pdf/cancel', { jobId: job.jobId }); throw new Error('cancelled'); }
    for (;;) {
      await new Promise(r => setTimeout(r, 1500));
      const st = await notesPdfApi('GET', '/ev/pdf/status?jobId=' + encodeURIComponent(job.jobId));
      if (job.cancelled) throw new Error('cancelled');   // his Stop wins over a done that raced it (the server signs no url after a cancel)
      if (st.status === 'done' && preview) {
        _pdfToast.libToastHide('pdf');
        showNotesPdfPreview(st.previewPages || [], () => runNotesPdfJob(bookId, picks, false, header, pageBreaks));
        return;
      }
      if (st.status === 'done') {
        _pdfToast.libToast('PDF ready', 'ok', { owner: 'pdf', stay: 60000, action: { label: 'Open', onClick: () => { window.open(st.url, '_blank', 'noopener'); } } });
        window.open(st.url, '_blank', 'noopener');   // opens in the browser's PDF viewer (the link is inline) - preview first, download from there; the toast's Open is the second chance
        return;
      }
      if (st.status === 'cancelled') throw new Error('cancelled');
      if (st.status === 'error') throw new Error(st.error || 'the server reported an error');
      if (job.cancelled) { await notesPdfApi('POST', '/ev/pdf/cancel', { jobId: job.jobId }); throw new Error('cancelled'); }
      notesPdfBusy(st.label || 'Preparing…');
    }
  } catch (e) {
    if (e && e.message === 'cancelled') { _pdfToast.libToast('Export stopped', 'warn'); return; }
    _pdfToast.libToastHide('pdf');
    if (await window.__ttCloud.wallet.notice(e, preview ? 'PDF preview' : 'Export PDF')) { _notesPdfQuotaCache = { bookId: null, at: 0, q: null }; return; }   // WALLET 402: the notice + the switch, not the raw sentence
    _pdfToast.libToast((e && e.message) || 'PDF failed', 'err', { stay: 9000 });   // the server's sentence, verbatim - the toast IS the handling; no rethrow (J's RUN: it left an unhandled rejection beside the toast)
    _notesPdfQuotaCache = { bookId: null, at: 0, q: null };   // a refusal may mean the allowance moved: re-read next time
  }
}
// One authenticated call to the MCP (/ev/*), the way cloud-store's _evPost does it: the server's own sentence is the
// error the user reads. auth + the base URL come from the ES module through a runtime import (St is out of reach).
async function notesPdfApi(method, path, body) {
  const { auth, EV_MCP_BASE } = await import('/js/cloud-store/firebase.js');
  const token = auth.currentUser ? await auth.currentUser.getIdToken() : null;
  const res = await fetch(EV_MCP_BASE + path, { method, headers: Object.assign({ authorization: 'Bearer ' + token }, body ? { 'content-type': 'application/json' } : {}), body: body ? JSON.stringify(body) : undefined });
  const j = await res.json().catch(() => ({}));
  // A quota refusal carries its fields (need / left / limit / resetsAt) beside the server's sentence; the line the
  // reader sees is built here so its date is in the reader's own day, not the server's (J's RUN 2026-09-29: a print at
  // 01:30 IST reset "3 Nov" in UTC and "4 Nov" on screen). Any other refusal is the server's sentence, verbatim.
  if (!res.ok) {
    const e = new Error((j && j.code === 'quota' && notesPdfQuotaLine(j).text) || (j && (j.error || j.message)) || ('Could not reach ' + path + ' (' + res.status + ').'));
    e.status = res.status; e.data = j;   // a wallet 402 carries { state, balanceInr, needInr } - the one handler (wallet-state.js walletNotice) reads these
    throw e;
  }
  return j;
}
// The progress toast (Rishabh 2026-09-29: "sharing ka toast dekho - counter ki tarah chalta hai"): the dashboard's
// libToast in its busy form, painted by owner 'pdf' so only this flow takes it down. core.js is an ES module (pure
// helpers, no side effects on import), reached through a runtime import() like the auth module above.
let _pdfToast = null, _pdfJob = null;
function notesPdfBusy(msg) {
  if (NOTES_PDF_HEADLESS) { window.__ttPdfProgress = msg; return; }   // headless: the service reads the label, no toast
  const job = _pdfJob;
  _pdfToast.libToast(msg, 'busy', { sub: "Don't close the browser", owner: 'pdf', action: { label: 'Stop', onClick: () => { job.cancelled = true; if (job.jobId) notesPdfApi('POST', '/ev/pdf/cancel', { jobId: job.jobId }).catch(() => {}); } } });
}
// The Author field's default: the signed-in name, read from the auth module the way cloud-store reads it
// (displayName, else the email). St lives in an ES module, out of the classic bundle's reach; a runtime import()
// of the module is how excalidraw.js reaches its library too.
async function notesPdfAuthorDefault() {
  const { auth } = await import('/js/cloud-store/firebase.js');
  const u = auth.currentUser;
  return u ? (u.displayName || u.email || '') : '';
}
// The footer line: the watermark text as ONE line (Rishabh 2026-09-28).
function notesPdfFooter(watermark) {
  return (watermark || '').split('\n').map(l => l.trim()).filter(Boolean).join(' ');
}
// The page header + footer are CSS page margin boxes (Chrome 131+): top-centre the header,
// bottom-centre the footer line with NOTES_PDF_FOOTER_NOTE under it, bottom-right "Page n of N" (no date, his word). When a page defines margin boxes the browser drops its
// own date / title / URL / page-number row (measured 2026-09-28), so the header sits at the true centre - his ask.
// document.title carries the same header for any renderer without margin boxes (notesPdfStage sets it).
function notesPdfPageRule(header, footer) {
  const q = s => '"' + String(s || '').replace(/[\\"]/g, c => '\\' + c).replace(/\n/g, '\\A ') + '"';   // \A = a line break inside content()
  return '@page { margin: 15mm; ' +
    '@top-center { content: ' + q(header) + '; font: 10px system-ui, sans-serif; color: #111827; } ' +
    '@bottom-center { content: ' + q([footer, NOTES_PDF_FOOTER_NOTE].filter(Boolean).join('\n')) + '; font: 8px/1.35 system-ui, sans-serif; color: #6b7280; white-space: pre; text-align: center; } ' +
    '@bottom-right { content: "Page " counter(page) " of " counter(pages); font: 9px system-ui, sans-serif; color: #6b7280; } }';
}
// The DEFAULT page header, printed top-centre of every page: "<book title> by <author>" (Rishabh 2026-09-28); no
// author = the title alone. Since 2026-10-02 only the prefill of the modal's Header field - the caller's text wins.
function notesPdfBookTitle() {
  const titleEl = document.getElementById('appTitle');
  return titleEl ? titleEl.textContent.trim() : '';
}
function notesPdfHeader(author) {
  const title = notesPdfBookTitle();
  return author ? title + ' by ' + author : title;
}
// The picker, in the Share dialog's look and words (Rishabh 2026-09-28 23:3x: "share tab ko dekho, kitna clear hai"):
// the dashboard modal shell (.evlib-modal), the Scope segment (Document / Domain / Topic, or Book / Subject / Chapter)
// and the same two "Which domains? / Which topics?" pickers over the table filter popup (tvBuildFilterPop). Document =
// everything; Domain = every chapter of the chosen domains; Topic = the chosen chapters within the chosen domains.
// The open domain (all its chapters) starts chosen. Under the summary the quota line (contract section 5b): the server
// says how many of the picked chapters count against this reader's quota ("need") and how many prints are left; Save
// is disabled when need > left. Own content never counts, so the owner of a book sees no line at all.
// Header (Rishabh 2026-10-02): one text field prefilled with the default line ("<book> by <author>"); any text is
// printed top-centre of every page as given, blank = no page header; nothing else changes.
// Box scope (Rishabh 2026-10-03): a fourth scope, the box - "Which boxes?" under the chapters; a pick then carries the
// box ids and the export counts boxes, not a chapter. Page breaks: three checkboxes (box / chapter / subject), the
// defaults = today's print (chapter + subject on). Both ride the job to the seam, so Preview and Save agree.
// Resolves { picks: [{ key, sec, epic, boxes? }], preview, header, pageBreaks } or null.
function showNotesPdfModal(sections, active, bookId, headerDefault) {
  return new Promise(resolve => {
    const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
    const cap = w => w.charAt(0).toUpperCase() + w.slice(1);
    const wholeWord = _ttMode() === 'book' ? 'Book' : 'Document';
    const unit = LBL('tabNoun').toLowerCase(), chap = LBL('epicNoun').toLowerCase(), boxWord = LBL('boxNoun').toLowerCase();
    const plural = (n, w) => n + ' ' + w + (n === 1 ? '' : (w.endsWith('x') ? 'es' : 's'));   // box -> boxes
    // ── state ──
    let scope = 'subject';
    const chosenSecs = new Set(); const chosenChaps = new Set(); const chosenBoxes = new Set();   // section keys; section key + '|' + epic id; + '|' + box id
    const chapKey = (s, e) => s.key + '|' + e.id;
    const boxKey = (s, e, b) => chapKey(s, e) + '|' + b.id;
    const addChapterBoxes = (s, e) => (e.boxes || []).forEach(b => chosenBoxes.add(boxKey(s, e, b)));
    const dropChapterBoxes = (s, e) => (e.boxes || []).forEach(b => chosenBoxes.delete(boxKey(s, e, b)));
    const activeEntry = sections.find(s => s.sec === active) || sections[0];
    chosenSecs.add(activeEntry.key); activeEntry.chapters.forEach(e => { chosenChaps.add(chapKey(activeEntry, e)); addChapterBoxes(activeEntry, e); });
    // Box labels (the first heading, else the box title, else "Box n") come from the content - loaded when the box picker opens.
    const boxLabels = new Map();
    const loadBoxLabels = async () => {
      for (const s of sections.filter(s => chosenSecs.has(s.key))) for (const e of s.chapters.filter(e => chosenChaps.has(chapKey(s, e)))) {
        for (let i = 0; i < (e.boxes || []).length; i++) {
          const b = e.boxes[i]; const k = boxKey(s, e, b);
          if (boxLabels.has(k)) continue;
          const live = document.querySelector('.notes-editor[data-box-id="' + b.id + '"]');
          const md = live ? getEditorContent(live) : await loadNotesContent(s.sec, e.id, b.id);
          const h = (typeof _firstH1 === 'function' ? _firstH1(md || '') : '') || b.title || '';
          boxLabels.set(k, (h || (cap(boxWord) + ' ' + (i + 1))).slice(0, 60));   // a heading is a line, a picker row is not a paragraph
        }
      }
    };
    const totalChaps = sections.reduce((n, s) => n + s.chapters.length, 0);
    // ── shell ──
    const ov = el('div', 'evlib-modal-ov'); ov.id = 'notesPdfModal';
    const card = el('div', 'evlib-modal'); ov.appendChild(card);
    const head = el('div', 'mh'); const title = el('strong', null, 'Export PDF'); title.style.fontSize = '1.05rem'; head.appendChild(title);
    const x = el('button', 'btn', '\u2715'); x.type = 'button'; head.appendChild(x); card.appendChild(head);
    const body = el('div', 'mb'); card.appendChild(body);
    // ── scope ──
    const scopeWrap = el('div'); scopeWrap.appendChild(el('label', 'fld', 'Scope'));
    const seg = el('div', 'evlib-seg segwide');
    const segBtns = [['whole', wholeWord], ['subject', cap(unit)], ['chapter', cap(chap)], ['box', cap(boxWord)]].map(([k, w]) => { const b = el('button', k === scope ? 'on' : '', w); b.type = 'button'; b.dataset.scope = k; seg.appendChild(b); return b; });
    scopeWrap.appendChild(seg); body.appendChild(scopeWrap);
    // ── the page header ──
    const headWrap = el('div'); headWrap.style.marginTop = '.6rem';
    headWrap.appendChild(el('label', 'fld', 'Header'));
    const headInput = el('input'); headInput.type = 'text'; headInput.value = headerDefault || ''; headInput.placeholder = 'Leave blank for no header'; headInput.maxLength = 200;
    headInput.setAttribute('aria-label', 'Header printed on every page'); headInput.className = 'tt-pdf-header';
    headWrap.appendChild(headInput); body.appendChild(headWrap);
    // ── page breaks ──
    const brWrap = el('div'); brWrap.style.marginTop = '.6rem';
    brWrap.appendChild(el('label', 'fld', 'New page after every'));
    const brRow = el('div'); brRow.style.cssText = 'display:flex;gap:1rem;flex-wrap:wrap;font-size:.92rem';
    const brBoxes = {};
    [['subject', unit], ['chapter', chap], ['box', boxWord]].forEach(([k, w]) => {   // biggest unit first (Rishabh 2026-10-04)
      const lab = el('label'); lab.style.cssText = 'display:inline-flex;align-items:center;gap:.35rem;cursor:pointer';
      const cb = el('input'); cb.type = 'checkbox'; cb.checked = NOTES_PDF_BREAKS_DEFAULT[k]; cb.className = 'tt-pdf-break'; cb.dataset.unit = k;
      lab.appendChild(cb); lab.appendChild(document.createTextNode(w)); brRow.appendChild(lab); brBoxes[k] = cb;
    });
    brWrap.appendChild(brRow); body.appendChild(brWrap);
    const pageBreaks = () => ({ box: brBoxes.box.checked, chapter: brBoxes.chapter.checked, subject: brBoxes.subject.checked });
    // ── the three pickers ──
    const pickerField = (what) => {
      const wrap = el('div'); wrap.style.marginTop = '.4rem';
      const whats = plural(2, what).replace(/^2 /, '');   // the plural word alone, from the one helper (box -> boxes)
      wrap.appendChild(el('label', 'fld', 'Which ' + whats + '?'));
      const row = el('div'); row.style.cssText = 'display:flex;align-items:center;gap:.6rem;flex-wrap:wrap';
      const btn = el('button', 'btn', 'Choose ' + whats + ' \u25be'); btn.type = 'button';
      const status = el('span'); status.style.cssText = 'color:var(--ev-muted);font-size:.9rem';
      row.appendChild(btn); row.appendChild(status); wrap.appendChild(row);
      return { wrap, btn, status };
    };
    const wholeLine = el('div'); wholeLine.style.cssText = 'color:var(--ev-muted);font-size:.9rem;margin-top:.4rem';
    const subj = pickerField(unit), chp = pickerField(chap), bx = pickerField(boxWord);
    body.appendChild(wholeLine); body.appendChild(subj.wrap); body.appendChild(chp.wrap); body.appendChild(bx.wrap);
    const uniqueLabels = rows => { const seen = new Map(); return rows.map(r => { const n = (seen.get(r.label) || 0) + 1; seen.set(r.label, n); return Object.assign({}, r, { label: n === 1 ? r.label : r.label + ' (' + n + ')' }); }); };
    const secTitle = s => s.sec.title || s.sec.name || s.key;
    const secRows = () => uniqueLabels(sections.map(s => ({ id: s.key, label: secTitle(s) })));
    const chapRows = () => uniqueLabels(sections.filter(s => chosenSecs.has(s.key)).flatMap(s => s.chapters.map(e => ({ id: chapKey(s, e), label: secTitle(s) + ' \u203a ' + e.name }))));
    const boxRows = () => uniqueLabels(sections.filter(s => chosenSecs.has(s.key)).flatMap(s => s.chapters.filter(e => chosenChaps.has(chapKey(s, e))).flatMap(e => (e.boxes || []).map((b, i) => ({ id: boxKey(s, e, b), label: e.name + ' \u203a ' + (boxLabels.get(boxKey(s, e, b)) || (cap(boxWord) + ' ' + (i + 1))) })))));
    const openPicker = (rows, chosen, anchor, onApply) => {
      const byLabel = new Map(rows.map(r => [r.label, r.id]));
      tvBuildFilterPop(rows.map(r => r.label), rows.filter(r => chosen.has(r.id)).map(r => r.label), anchor, labels => onApply(labels.map(l => byLabel.get(l))));
    };
    const describe = (field, rows, chosen, what) => {
      const picked = rows.filter(r => chosen.has(r.id));
      const names = picked.slice(0, 3).map(r => r.label).join(', ') + (picked.length > 3 ? ' +' + (picked.length - 3) + ' more' : '');
      field.status.textContent = picked.length ? (picked.length + ' of ' + plural(rows.length, what) + ' selected \u00b7 ' + names) : ('None selected - choose at least one ' + what);
    };
    const picks = () => {   // the chapters this scope prints, in section order; box scope = chapters with chosen boxes, each pick carrying its box ids
      if (scope === 'whole') return sections.flatMap(s => s.chapters.map(e => ({ key: s.key, sec: s.sec, epic: e })));
      if (scope === 'box') return sections.filter(s => chosenSecs.has(s.key)).flatMap(s => s.chapters.filter(e => chosenChaps.has(chapKey(s, e))).map(e => ({ key: s.key, sec: s.sec, epic: e, boxes: (e.boxes || []).filter(b => chosenBoxes.has(boxKey(s, e, b))).map(b => b.id) })).filter(p => p.boxes.length));
      return sections.filter(s => chosenSecs.has(s.key)).flatMap(s => s.chapters.filter(e => scope === 'subject' || chosenChaps.has(chapKey(s, e))).map(e => ({ key: s.key, sec: s.sec, epic: e })));
    };
    // The quota line follows the picks (debounced: a picker click changes them several times a second). The reply for
    // the LATEST picks wins; an older reply is dropped. A failed read shows the server's sentence, Save stays on (the
    // server re-checks at start).
    let quotaSeq = 0, quotaTimer = null, quotaBlocks = false;
    const askQuota = () => {
      const seq = ++quotaSeq; const wire = picks().map(p => ({ sec: p.key, epic: p.epic.id, ...(p.boxes ? { boxes: p.boxes } : {}) }));
      if (!wire.length) { quotaLine.textContent = ''; quotaBlocks = false; return; }
      // While the server answers for the NEW picks the old line must not stand (Rishabh's RUN 2026-09-29 12:4x: "Needs 6"
      // beside "PDF · 108 topics"): say so, and hold Save until the answer for these picks is in.
      quotaLine.textContent = 'Checking your allowance…'; quotaLine.classList.remove('over'); quotaBlocks = true; okBtn.disabled = true;
      notesPdfApi('POST', '/ev/pdf/quota', { bookId, picks: wire }).then(q => {
        if (seq !== quotaSeq) return;
        const line = notesPdfQuotaLine(q); quotaLine.textContent = line.text; quotaBlocks = line.blocks; quotaLine.classList.toggle('over', line.blocks);
        okBtn.disabled = !picks().length || quotaBlocks;
      }).catch(e => { if (seq !== quotaSeq) return; quotaLine.textContent = (e && e.message) || 'Could not read the quota.'; quotaBlocks = false; quotaLine.classList.remove('over'); okBtn.disabled = !picks().length; });   // Save comes back: the server re-checks at start
    };
    const refresh = () => {
      segBtns.forEach(b => { b.className = b.dataset.scope === scope ? 'on' : ''; });
      wholeLine.style.display = scope === 'whole' ? '' : 'none';
      subj.wrap.style.display = scope === 'whole' ? 'none' : '';
      chp.wrap.style.display = scope === 'chapter' || scope === 'box' ? '' : 'none';
      bx.wrap.style.display = scope === 'box' ? '' : 'none';
      wholeLine.textContent = 'Whole ' + wholeWord.toLowerCase() + ': ' + plural(sections.length, unit) + ', ' + plural(totalChaps, chap);
      describe(subj, secRows(), chosenSecs, unit); describe(chp, chapRows(), chosenChaps, chap); describe(bx, boxRows(), chosenBoxes, boxWord);
      const ps = picks(); const n = ps.length;
      summary.textContent = 'PDF \u00b7 ' + (scope === 'box' ? plural(ps.reduce((k, p) => k + p.boxes.length, 0), boxWord) + ' in ' + plural(n, chap) : plural(n, chap));
      okBtn.disabled = !n || quotaBlocks;
      if (quotaTimer) clearTimeout(quotaTimer); quotaTimer = setTimeout(askQuota, 250);
    };
    const applySecs = ids => {
      const next = new Set(ids);
      for (const s of sections) {
        if (next.has(s.key) && !chosenSecs.has(s.key)) s.chapters.forEach(e => { chosenChaps.add(chapKey(s, e)); addChapterBoxes(s, e); });
        if (!next.has(s.key)) s.chapters.forEach(e => { chosenChaps.delete(chapKey(s, e)); dropChapterBoxes(s, e); });
      }
      chosenSecs.clear(); next.forEach(id => chosenSecs.add(id)); refresh();
    };
    const applyChaps = ids => {
      const next = new Set(ids);
      for (const s of sections) for (const e of s.chapters) {   // a newly chosen chapter starts with every box; a dropped one loses them
        const k = chapKey(s, e);
        if (next.has(k) && !chosenChaps.has(k)) addChapterBoxes(s, e);
        if (!next.has(k) && chosenChaps.has(k)) dropChapterBoxes(s, e);
      }
      chosenChaps.clear(); next.forEach(id => chosenChaps.add(id)); refresh();
    };
    const applyBoxes = ids => { chosenBoxes.clear(); ids.forEach(id => chosenBoxes.add(id)); refresh(); };
    bx.btn.addEventListener('click', async () => {
      if (!chosenChaps.size) { if (!chosenSecs.size) { openPicker(secRows(), chosenSecs, subj.btn, applySecs); return; } openPicker(chapRows(), chosenChaps, chp.btn, applyChaps); return; }
      bx.btn.disabled = true; try { await loadBoxLabels(); } finally { bx.btn.disabled = false; }
      refresh(); openPicker(boxRows(), chosenBoxes, bx.btn, applyBoxes);
    });
    subj.btn.addEventListener('click', () => openPicker(secRows(), chosenSecs, subj.btn, applySecs));
    chp.btn.addEventListener('click', () => { if (!chosenSecs.size) { openPicker(secRows(), chosenSecs, subj.btn, applySecs); return; } openPicker(chapRows(), chosenChaps, chp.btn, applyChaps); });
    segBtns.forEach(b => b.addEventListener('click', () => { scope = b.dataset.scope; refresh(); }));
    // No author / watermark fields (his word 2026-09-28 23:5x): the server renders with the watermark constant; the
    // Header field above is the one text the caller sets (his word 2026-10-02).
    // ── footer: summary + quota line + Cancel + Save ──
    // a 2-row grid: summary | Cancel | Save, then the quota note across the full width right under (Rishabh 2026-09-29:
    // one row for the three, the note close beneath, not a gap)
    const footer = el('div'); footer.style.cssText = 'display:grid;grid-template-columns:1fr auto auto;column-gap:.5rem;row-gap:.2rem;align-items:center;margin-top:1rem;border-top:1px solid var(--ev-hair);padding-top:.8rem';
    const summary = el('div'); summary.style.cssText = 'font-size:.82rem;color:var(--ev-muted)';
    const quotaLine = el('div', 'tt-pdf-quota'); quotaLine.style.gridColumn = '1 / -1';
    const cancelBtn = el('button', 'btn', 'Cancel'); cancelBtn.type = 'button';
    const prevBtn = el('button', 'btn', 'Preview'); prevBtn.type = 'button'; prevBtn.title = 'See every page as a stamped low-resolution image before you spend chapter prints';
    const okBtn = el('button', 'btn primary', 'Save as PDF'); okBtn.type = 'button';
    footer.style.gridTemplateColumns = '1fr auto auto auto';
    footer.appendChild(summary); footer.appendChild(cancelBtn); footer.appendChild(prevBtn); footer.appendChild(okBtn); footer.appendChild(quotaLine); body.appendChild(footer);
    document.body.appendChild(ov);
    let done = false;
    const close = (val) => { if (done) return; done = true; document.removeEventListener('keydown', onKey, true); if (typeof tvCloseFilterPop === 'function') tvCloseFilterPop(); ov.remove(); resolve(val); };
    const ok = () => {
      const picked = picks();
      if (!picked.length) { showToast('\u26A0 Pick at least one ' + chap); return; }
      if (quotaBlocks) { showToast('\u26A0 ' + quotaLine.textContent); return; }
      close({ picks: picked, preview: false, header: headInput.value.trim(), pageBreaks: pageBreaks() });
    };
    // Preview needs picks, not quota: a blocked or over-the-limit owner may still look
    prevBtn.onclick = () => { const picked = picks(); if (!picked.length) { showToast('\u26A0 Pick at least one ' + chap); return; } close({ picks: picked, preview: true, header: headInput.value.trim(), pageBreaks: pageBreaks() }); };
    const onKey = (e) => {
      if (document.querySelector('.tv-filter-pop')) return;   // the picker popup owns its own keys
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); ok(); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); close(null); }
    };
    okBtn.onclick = ok; cancelBtn.onclick = () => close(null); x.onclick = () => close(null);
    ov.addEventListener('mousedown', (e) => { if (e.target === ov) close(null); });
    document.addEventListener('keydown', onKey, true);
    refresh();
    setTimeout(() => okBtn.focus(), 0);
  });
}
// The preview panel (contract section 7): every page as a stamped low-res image, stacked; nothing to save from here -
// right-click, drag and selection are off, there is no link; Close, or Save as PDF (the real export, quota applies).
function showNotesPdfPreview(pages, onSave) {
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  const ov = el('div', 'evlib-modal-ov'); ov.id = 'notesPdfPreview';
  const card = el('div', 'evlib-modal tt-pdf-preview-card'); ov.appendChild(card);
  const head = el('div', 'mh'); const title = el('strong', null, 'Preview \u00b7 ' + pages.length + ' page' + (pages.length === 1 ? '' : 's')); title.style.fontSize = '1.05rem'; head.appendChild(title);
  const x = el('button', 'btn', '\u2715'); x.type = 'button'; head.appendChild(x); card.appendChild(head);
  const body = el('div', 'mb'); card.appendChild(body);
  const strip = el('div', 'tt-pdf-preview'); body.appendChild(strip);
  strip.addEventListener('contextmenu', e => e.preventDefault());
  strip.addEventListener('dragstart', e => e.preventDefault());
  // a whole-book preview is hundreds of pages - the images load as they scroll in (G's note)
  pages.forEach((url, i) => { const im = el('img', 'tt-pdf-preview-page'); im.loading = 'lazy'; im.src = url; im.alt = 'Page ' + (i + 1); im.draggable = false; strip.appendChild(im); });
  if (!pages.length) strip.appendChild(el('div', 'empty', 'The preview came back without pages.'));
  const foot = el('div'); foot.style.cssText = 'display:flex;gap:.5rem;justify-content:flex-end;align-items:center;margin-top:.8rem;border-top:1px solid var(--ev-hair);padding-top:.8rem';
  const note = el('div'); note.style.marginRight = 'auto';   // no caption (Rishabh 2026-09-29 13:4x)
  const closeBtn = el('button', 'btn', 'Close'); closeBtn.type = 'button';
  const saveBtn = el('button', 'btn primary', 'Save as PDF'); saveBtn.type = 'button';
  foot.appendChild(note); foot.appendChild(closeBtn); foot.appendChild(saveBtn); body.appendChild(foot);
  const close = () => { document.removeEventListener('keydown', onKey, true); ov.remove(); };
  const onKey = (e) => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); } };
  x.onclick = close; closeBtn.onclick = close; ov.addEventListener('mousedown', (e) => { if (e.target === ov) close(); });
  saveBtn.onclick = () => { close(); onSave(); };
  document.addEventListener('keydown', onKey, true);
  document.body.appendChild(ov);
}
// The Exports list (Rishabh 2026-09-29 12:1x: "what if I miss the download button in the toast"): every PDF job of the
// last 7 days from GET /ev/pdf/jobs - title, when, what it holds, and Download while the link lives; a cancelled /
// failed / expired job says so. Same modal shell as the picker.
async function openNotesPdfExports() {
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  const ov = el('div', 'evlib-modal-ov'); ov.id = 'notesPdfExports';
  const card = el('div', 'evlib-modal'); ov.appendChild(card);
  const head = el('div', 'mh'); const title = el('strong', null, 'Exports'); title.style.fontSize = '1.05rem'; head.appendChild(title);
  const x = el('button', 'btn', '\u2715'); x.type = 'button'; head.appendChild(x); card.appendChild(head);
  const body = el('div', 'mb'); card.appendChild(body);
  const list = el('div', 'tt-pdf-exports'); list.appendChild(el('div', 'empty', 'Loading\u2026')); body.appendChild(list);
  const close = () => { document.removeEventListener('keydown', onKey, true); ov.remove(); };
  const onKey = (e) => { if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); } };
  x.onclick = close; ov.addEventListener('mousedown', (e) => { if (e.target === ov) close(); });
  document.addEventListener('keydown', onKey, true);
  document.body.appendChild(ov);
  let jobs;
  try { jobs = (await notesPdfApi('GET', '/ev/pdf/jobs')).jobs || []; }
  catch (e) { list.textContent = ''; list.appendChild(el('div', 'empty', (e && e.message) || 'Could not load your exports.')); return; }
  list.textContent = '';
  if (!jobs.length) { list.appendChild(el('div', 'empty', 'No exports in the last 7 days.')); return; }
  const chap = LBL('epicNoun').toLowerCase();
  const when = iso => new Date(iso).toLocaleString(undefined, { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
  const daysLeft = iso => Math.max(0, Math.ceil((new Date(iso) - Date.now()) / 86400000));
  for (const j of jobs) {
    const row = el('div', 'row');
    const left = el('div'); left.appendChild(el('div', 't', j.title || 'PDF'));
    const n = j.chapters || 0;
    let meta = when(j.createdAt) + ' \u00b7 ' + n + ' ' + chap + (n === 1 ? '' : 's'), gone = false;
    if (j.status === 'done' && j.url) meta += ' \u00b7 link expires in ' + daysLeft(j.expiresAt) + ' day' + (daysLeft(j.expiresAt) === 1 ? '' : 's');
    else if (j.status === 'done') { meta += ' \u00b7 link expired'; gone = true; }
    else if (j.status === 'cancelled') { meta += ' \u00b7 stopped'; gone = true; }
    else if (j.status === 'error') { meta += ' \u00b7 failed'; gone = true; }
    else meta += ' \u00b7 ' + j.status;
    left.appendChild(el('div', 'm' + (gone ? ' gone' : ''), meta)); row.appendChild(left);
    if (j.status === 'done' && j.url) { const b = el('button', 'btn primary', 'Open'); b.type = 'button'; b.onclick = () => { window.open(j.url, '_blank', 'noopener'); }; row.appendChild(b); }
    list.appendChild(row);
  }
}
// The quota line (contract section 5b), two counters since 2026-10-03. q = { limit:{chapters,boxes,days}, used, left:{chapters,boxes},
// resetsAt, blocked, need:{chapters,boxes} } - need = what the picks cost (a chapter = 1 chapter + its boxes; a box pick = its boxes).
function notesPdfQuotaLine(q) {
  const when = q.resetsAt ? new Date(q.resetsAt).toLocaleDateString(undefined, { day: 'numeric', month: 'short' }) : '';
  // The app's own words (Rishabh 2026-10-04: "boxes nahi bhai, sections"): chapter = the epic noun, box = the box noun.
  const chapW = LBL('epicNoun').toLowerCase(), boxW = LBL('boxNoun').toLowerCase();
  const pl = (n, w) => n + ' ' + w + (n === 1 ? '' : (w.endsWith('x') ? 'es' : 's'));
  const words = (w) => pl(2, w).replace(/^2 /, '');   // the plural word alone: "sections"
  const limit = q.limit || { chapters: 0, boxes: 0 }, left = q.left || { chapters: 0, boxes: 0 }, need = q.need || { chapters: 0, boxes: 0 };
  // The line is ALWAYS there (Rishabh 2026-09-29: "how will the user know about this?"). A counter blocks only the
  // exports that need it (Rishabh 2026-10-04: 0 chapters left still allows a box pick). His pattern (2026-10-04): "Available: 7 chapters, 25 sections (resets Oct 29) · Selected: 2 chapters,
  // 27 sections - too many sections" - one shape for both states, the block names only the counter that fell short.
  if (q.blocked) return { text: 'PDF export is not enabled for this account.', blocks: true };
  if (limit.chapters === -1 && limit.boxes === -1) return { text: 'Available: no limit', blocks: false };
  const avail = (limit.chapters === -1 ? 'unlimited ' + words(chapW) : pl(left.chapters, chapW)) + ', ' + (limit.boxes === -1 ? 'unlimited ' + words(boxW) : pl(left.boxes, boxW));
  const selected = pl(need.chapters, chapW) + ', ' + pl(need.boxes, boxW);
  const tooMany = [];
  if (left.chapters !== -1 && need.chapters > left.chapters) tooMany.push(words(chapW));
  if (left.boxes !== -1 && need.boxes > left.boxes) tooMany.push(words(boxW));
  // Two lines on purpose (the one-line form clipped at the modal's edge, his screenshot 2026-10-04 00:53): Available… / Selected…
  const text = 'Available: ' + avail + (when ? ' (resets ' + when + ')' : '') + '\nSelected: ' + selected + (tooMany.length ? ' - too many ' + tooMany.join(' and ') : '');
  return { text, blocks: tooMany.length > 0 };
}
async function buildNotesPdf(picks, watermark, job, breaks) {
  const old = document.getElementById('notesPdfPrint'); if (old) old.remove();
  const host = document.createElement('div'); host.id = 'notesPdfPrint';
  // Page breaks (Rishabh 2026-10-03) as classes on the host; the print CSS gates its break-before rules on them.
  const br = notesPdfBreaksOf(breaks);
  ['box', 'chapter', 'subject'].forEach(k => host.classList.toggle('tt-pdf-break-' + k, !!br[k]));
  if (watermark) {
    const longest = Math.max(...watermark.split('\n').map(l => l.length));
    host.style.setProperty('--tt-wm-chars', String(longest));   // the print CSS sizes every mark to fit its width from the longest line
    host.style.setProperty('--tt-wm-angle', NOTES_PDF_WATERMARK_ANGLE + 'deg');
  }
  document.body.appendChild(host);
  const chapterWord = LBL('epicNoun').toLowerCase();
  let done = 0, subject = null, subjectSec = null;
  for (const { sec, epic, boxes } of picks) {   // boxes = a box-level pick: only those boxes of the chapter print
    notesPdfBusy('Preparing ' + (done + 1) + ' of ' + picks.length + ' ' + chapterWord + (picks.length === 1 ? '' : 's') + '\u2026 - ' + epic.name);
    await new Promise(r => setTimeout(r, 0));   // let the toast repaint between chapters (setEditorContent is synchronous)
    if (job && job.cancelled) throw new Error('cancelled');
    // Every subject opens on its own page with its name as the top heading, its chapters under it (Rishabh 2026-09-29
    // 12:1x: "subject level title kaise visible hoga?"); the chapter title is the second-level heading.
    if (sec !== subjectSec) {
      subjectSec = sec;
      subject = document.createElement('section'); subject.className = 'tt-pdf-subject';
      const sh = document.createElement('h1'); sh.className = 'tt-pdf-subject-title'; sh.textContent = sec.title || sec.name || ''; subject.appendChild(sh);
      host.appendChild(subject);
    }
    const ch = document.createElement('section'); ch.className = 'tt-pdf-chapter';
    const h = document.createElement('h2'); h.className = 'tt-pdf-chapter-title'; h.textContent = epic.name; ch.appendChild(h);
    subject.appendChild(ch);
    for (const b of (epic.boxes || []).filter(b => !boxes || boxes.includes(String(b.id)))) {
      const live = document.querySelector('.notes-editor[data-box-id="' + b.id + '"]');
      const md = live ? getEditorContent(live) : await loadNotesContent(sec, epic.id, b.id);   // the open chapter's unsaved edits count
      if (!(md || '').trim()) continue;
      const box = document.createElement('div'); box.className = 'notes-box';
      const ed = document.createElement('div'); ed.className = 'notes-editor'; ed.dataset.boxId = b.id;   // a print copy: not contenteditable
      box.appendChild(ed); ch.appendChild(box);
      setEditorContent(ed, md);
    }
    done++;
  }
  await notesPdfSettled(host, job);
  if (job && job.cancelled) throw new Error('cancelled');
  // Every visual carries its own mark, centred on it: whiteboards, mermaid diagrams, images (Rishabh 2026-09-28
  // 22:3x: no page-centre mark, "sirf visuals par"). Which page a visual lands on is the print engine's decision,
  // so the mark lives inside the block and travels with it. The footer line carries the credit on every page.
  if (watermark) host.querySelectorAll('.excalidraw-block, .mermaid-block, .img-wrap').forEach(blk => {
    const wm = document.createElement('div'); wm.className = 'tt-pdf-watermark tt-pdf-watermark--diagram';
    const main = document.createElement('span'); main.className = 'tt-pdf-watermark-main'; main.textContent = watermark; wm.appendChild(main);
    if (NOTES_PDF_FOOTER_NOTE) { const note = document.createElement('span'); note.className = 'tt-pdf-watermark-note'; note.textContent = NOTES_PDF_FOOTER_NOTE; wm.appendChild(note); }   // the note as a small third line (Rishabh 2026-09-29 12:2x, sample)
    blk.appendChild(wm);
  });
  // A diagram scales to the paper only through its viewBox (max-width alone would clip it): an exported SVG that
  // carries width/height but no viewBox gets one from those.
  host.querySelectorAll('svg[width][height]:not([viewBox])').forEach(svg => {
    const w = parseFloat(svg.getAttribute('width')), h = parseFloat(svg.getAttribute('height'));
    if (w > 0 && h > 0) svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
  });
  // The print copy of a diagram carries the SAME SVG ids as the live copy in the open chapter (an arrow's label gap
  // is a <mask id="mask-<element>">, referenced by url(#...)). A url(#id) resolves to the FIRST element with that id in
  // the document - in print that is the live copy, which is display:none, so the mask is empty and the arrow runs
  // straight through its label (Rishabh 2026-09-28, his DPDP diagrams: "edge ka text edge ke peeche hai"). Every id
  // in a print-copy SVG gets a suffix, and every reference inside that SVG follows it.
  host.querySelectorAll('svg').forEach((svg, k) => {
    const map = new Map();
    svg.querySelectorAll('[id]').forEach(el => { const fresh = el.id + '-pdf' + k; map.set(el.id, fresh); el.id = fresh; });
    if (!map.size) return;
    const ref = /#([A-Za-z0-9_:.-]+)/g;
    svg.querySelectorAll('*').forEach(el => {
      for (const attr of Array.from(el.attributes)) {
        if (attr.value.indexOf('#') === -1) continue;
        const v = attr.value.replace(ref, (m, id) => map.has(id) ? '#' + map.get(id) : m);
        if (v !== attr.value) el.setAttribute(attr.name, v);
      }
    });
  });
  return host;
}
// Diagrams render async (excalidraw / mermaid replace their "Rendering…" placeholder) and images hydrate to
// blob: URLs; poll until both are done, at most 20 s (a broken diagram keeps its error text and counts as done).
// A whole book can carry hundreds of diagrams and images (Rishabh 2026-09-29: "book badi ho toh"), so the wait is
// bounded by PROGRESS, not by a fixed clock: it goes on while the pending count keeps falling and gives up only
// after 20 s with no change (a broken diagram keeps its error text and counts as done; an image that never loads is
// what the 20 s idle cap is for). The toast shows what is still rendering.
function notesPdfSettled(host, job) {
  let last = -1, lastChange = Date.now(), total = 0;
  return new Promise(resolve => {
    const tick = () => {
      const diagrams = host.querySelectorAll('.excalidraw-loading, .mermaid-loading').length;
      const images = Array.from(host.querySelectorAll('img')).filter(im => !im.complete).length;
      const pending = diagrams + images;
      if (pending > total) total = pending;
      if (pending !== last) { last = pending; lastChange = Date.now(); if (pending) notesPdfBusy('Rendering ' + (total - pending + 1) + ' of ' + total + ' diagram' + (total === 1 ? '' : 's') + ' / image' + (total === 1 ? '' : 's') + '\u2026'); }
      if (!pending || (job && job.cancelled) || Date.now() - lastChange > 20000) resolve(pending);
      else setTimeout(tick, 250);
    };
    tick();
  });
}
// Stage the page for the render service's printToPDF: body.tt-printing applies the shared print rules (chrome hidden,
// boxes expanded, table borders), body.tt-pdf-print makes #notesPdfPrint the only thing on the page, an @page rule
// carries the header / footer / page number as margin boxes, document.title is the header. Returns the undo (the
// headless page is closed by the service, so nothing calls it there; a test does).
function notesPdfStage(host, header, footer) {
  const tabTitle = document.title;
  const pageStyle = document.createElement('style'); pageStyle.id = 'notesPdfPage'; pageStyle.textContent = notesPdfPageRule(header, footer);
  document.head.appendChild(pageStyle);
  document.body.classList.add('tt-printing', 'tt-pdf-print');
  if (header) document.title = header;
  return () => { document.body.classList.remove('tt-printing', 'tt-pdf-print'); document.title = tabTitle; pageStyle.remove(); };
}

;
// ==== FILE: js/notes/notes-export-links.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-export-links.js
// ==========================================================================

// ── Export links ─────────────────────────────────────────────────────────────
// A read-only tool: gather every web link across a chosen scope of notes boxes
// (This initiative / Whole area / Everything) into a table the user can copy or
// download, so they can feed those URLs to external tools (downloaders etc.).
// The product itself never fetches the links - it only LISTS URLs the user has
// already pasted. 100% read-only: no save, no mutation of loaded state; works for
// read-only viewers, when viewing another tracker, and in local mode.

let _elStylesDone = false;
function ensureExportLinksStyles() {
  if (_elStylesDone) return; _elStylesDone = true;
  const css =
    '.tts-panel.el-wide{max-width:820px}' +
    '.el-tblwrap{max-height:52vh;overflow:auto;margin:.5rem 0;border:1px solid var(--c-line-200,#e3ddd2);border-radius:8px}' +
    '.el-tblwrap .tts-tbl{width:100%;margin:0}' +
    '.el-tblwrap .tts-tbl td a{word-break:break-all;color:var(--c-accent,#2563eb);text-decoration:none}' +
    '.el-tblwrap .tts-tbl td a:hover{text-decoration:underline}' +
    '.el-tblwrap .tts-tbl thead th{position:sticky;top:0;background:var(--c-fill-100,#f1ece3);z-index:1;white-space:nowrap}' +
    '.el-tblwrap .tts-tbl th .tv-sort,.el-tblwrap .tts-tbl th .tv-filter{margin-left:.28rem}' +
    '.el-summary-row{display:flex;align-items:center;gap:.6rem;flex-wrap:wrap}' +
    '.el-clearview{font:inherit;font-size:.76rem;padding:.1rem .45rem;border:1px solid var(--c-line-200,#e3ddd2);border-radius:6px;background:var(--c-fill-50,#faf8f4);color:var(--c-ink-600,#5a5249);cursor:pointer}' +
    // the shared filter dropdown (tvBuildFilterPop) is z-index:1000 - lift it above the modal overlay (9000) while this modal is open
    'body.el-export-open .tv-filter-pop{z-index:9600}';
  const st = document.createElement('style'); st.id = 'el-styles'; st.textContent = css;
  document.head.appendChild(st);
}

// Classify a URL for the "Type" column via the SAME strict parser the inline video
// embeds use. type:'video' = a direct media file; the iframe hosts are told apart
// by their rebuilt embedSrc; anything parseVideoEmbed rejects = Other-link.
function classifyExportLink(url) {
  const p = parseVideoEmbed(url);
  if (!p) return 'Other-link';
  if (p.type === 'video') return 'Direct-video';
  const s = p.embedSrc || '';
  if (/youtube|youtu\.be/.test(s)) return 'YouTube';
  if (/drive\.google/.test(s)) return 'Google Drive';
  if (/instagram/.test(s)) return 'Instagram';
  return 'Other-link';
}

// Pull every real web link out of ONE box's markdown, WITH the context (nearest
// heading, or the line text) it sits on. Fence-aware: a ```video, ```video s, or
// ```video l fence's URL line is kept (a video link); mermaid/excalidraw/other code
// fences are skipped entirely (their URLs are config noise). Image markdown
// (![](file)) and <img> tags are stripped so local filenames / image srcs never
// appear. Markdown-table pipe cells ARE scanned (their URLs are real user links).
function extractLinksFromMd(md, chapter) {
  const rows = [];
  const lines = String(md || '').split('\n');
  let fence = null;          // null | 'video' | 'skip'
  let heading = '';
  const add = (url, context) => {
    const u = url.trim().replace(/[.,;:!?)\]|]+$/, '');   // trim trailing punctuation + stray table pipe
    if (u) rows.push({ url: u, type: classifyExportLink(u), chapter: chapter, context: String(context || heading || chapter || '').trim() });
  };
  const hasClose = (from) => { for (let k = from; k < lines.length; k++) { if (lines[k].trim() === '```') return true; } return false; };
  for (let i = 0; i < lines.length; i++) {
    const raw = lines[i];
    const t = raw.trim();
    if (fence) {
      if (t === '```') { fence = null; continue; }
      if (fence === 'video' && /^https?:\/\/\S+$/.test(t)) add(t, heading);   // the video URL line
      continue;                                                               // 'skip' fences: drop everything
    }
    if (t.startsWith('```')) {
      const info = t.slice(3).trim().toLowerCase();
      const recognized = (info === 'video' || info === 'video s' || info === 'video l' || info === 'mermaid' || info === 'excalidraw');
      // Match the renderer: ONLY a recognized AND closed fence is atomic. A generic
      // ```lang or a stray/unterminated ``` is rendered as prose (its lines get
      // linkified), so fall through and scan those lines normally - don't drop links.
      if (recognized && hasClose(i + 1)) {
        fence = info.startsWith('video') ? 'video' : 'skip';   // video -> keep URL line; mermaid/excalidraw -> skip
        continue;
      }
    }
    const hm = raw.match(/^#{1,6}\s+(.+?)\s*$/);
    if (hm) { heading = hm[1].trim(); continue; }
    if (!t) continue;
    if (/^https?:\/\/\S+$/.test(t)) { add(t, heading); continue; }   // whole-line bare/video URL -> the link itself
    // Otherwise: inline URLs in prose or inside md-table cells. Strip image
    // markdown / <img> first so their (local or remote) srcs are excluded.
    const noImg = raw.replace(/!\[[^\]]*\]\([^)]*\)/g, ' ').replace(/<img\b[^>]*>/gi, ' ');
    const m = noImg.match(/https?:\/\/[^\s<>"'`)\]|]+/g);
    if (m) m.forEach(u => add(u, t));
  }
  return rows;
}

// Read one section's notes epics WITHOUT mutating in-memory SECTIONS state
// (loadNotesMeta would clobber sec.notesEpics). Safety-net for the "Everything"
// scope: any section whose notesEpics aren't in memory (a not-yet-opened tab, or
// one added this session). Returns a fresh epics array (legacy boxes synthesized).
async function _readNotesEpicsReadonly(sec) {
  const p = notesPrefix(sec);
  if (!p) return [];
  try {
    const res = await fetch('/load?file=' + p + '__notes_meta.json');
    if (!res.ok) return [];
    const text = await res.text();
    if (!text.trim()) return [];
    const json = JSON.parse(text);
    const epics = Array.isArray(json.epics) ? json.epics : [];
    epics.forEach(ep => { if (ep.type !== 'timeline' && (!Array.isArray(ep.boxes) || !ep.boxes.length)) ep.boxes = [{ id: 'main' }]; });
    return epics;
  } catch (_) { return []; }
}

// Read ONE box's markdown for export: prefer the LIVE editor (captures unsaved
// edits) when this box belongs to the currently-open epic; otherwise load the
// saved .md. Pure read - never writes.
async function _readBoxMdForExport(sec, epicId, boxId, isActiveEpic) {
  if (isActiveEpic) {
    const live = document.querySelector(`.notes-editor[data-box-id="${boxId}"]`);
    if (live) return getEditorContent(live);
  }
  return await loadNotesContent(sec, epicId, boxId);
}

// Bounded-concurrency map (default 8) so "Everything" over many boxes doesn't fire
// hundreds of parallel /load requests; reports progress for the modal's loader.
async function _mapLimited(items, limit, fn, onProgress) {
  const out = new Array(items.length);
  let next = 0, done = 0;
  const workers = new Array(Math.min(limit, items.length || 1)).fill(0).map(async () => {
    while (next < items.length) {
      const i = next++;
      try { out[i] = await fn(items[i], i); } catch (_) { out[i] = null; }
      done++; if (onProgress) onProgress(done, items.length);
    }
  });
  await Promise.all(workers);
  return out;
}

// Gather every link across the chosen scope ('chapter'|'subject'|'class').
// ZERO writes: reads in-memory epics read-only, reads unopened sections' meta
// without mutating SECTIONS, never changes activeSection, never saves.
async function _gatherExportLinks(scope, onProgress) {
  const curSec = SECTIONS[activeSection];
  const curEpicId = curSec ? curSec.activeNotesEpic : null;
  const secList = (scope === 'class')
    ? Object.keys(SECTIONS).map(k => SECTIONS[k]).filter(s => s && notesPrefix(s))
    : (curSec && notesPrefix(curSec) ? [curSec] : []);   // notesPrefix, not sec.file, so category-configured sections (e.g. Personal) aren't dropped
  // Flatten to per-box tasks. Non-current sections (class scope) that aren't
  // loaded get a NON-mutating meta read.
  const tasks = [];
  for (const s of secList) {
    let epics = Array.isArray(s.notesEpics) ? s.notesEpics : null;
    if (!epics) epics = await _readNotesEpicsReadonly(s);
    for (const ep of epics) {
      if (!ep || ep.type === 'timeline') continue;
      if (scope === 'chapter' && !(s === curSec && ep.id === curEpicId)) continue;
      const isActiveEpic = (s === curSec && ep.id === curEpicId);
      const boxes = (Array.isArray(ep.boxes) && ep.boxes.length) ? ep.boxes : [{ id: 'main' }];
      for (const b of boxes) tasks.push({ sec: s, epicId: ep.id, epicName: ep.name, boxId: b.id, boxTitle: b.title, isActiveEpic });
    }
  }
  const perBox = await _mapLimited(tasks, 8, async (t) => {
    const md = await _readBoxMdForExport(t.sec, t.epicId, t.boxId, t.isActiveEpic);
    const title = _firstH1(md) || t.boxTitle || t.epicName || 'Untitled';
    return extractLinksFromMd(md, title);
  }, onProgress);
  const rows = [];
  perBox.forEach(list => { if (list) rows.push(...list); });
  // 1-row-per-occurrence, sorted by URL so duplicates sit adjacent.
  rows.sort((a, b) => a.url.localeCompare(b.url) || String(a.chapter).localeCompare(String(b.chapter)));
  return { rows, boxCount: tasks.length };
}

// Export-format builders. md/CSV both escape per cell; CSV via csvQuote.
function _mdCell(s) { return String(s == null ? '' : s).replace(/\|/g, '\\|').replace(/\r?\n/g, ' ').trim(); }
function _linksToMd(rows) {
  const head = '| Link | Type | Chapter | Context |\n| --- | --- | --- | --- |';
  const body = rows.map(r => `| ${_mdCell(r.url)} | ${_mdCell(r.type)} | ${_mdCell(r.chapter)} | ${_mdCell(r.context)} |`).join('\n');
  return head + (body ? '\n' + body : '');
}
function _linksToCsv(rows) {
  const head = ['Link', 'Type', 'Chapter', 'Context'].map(csvQuote).join(',');
  const body = rows.map(r => [r.url, r.type, r.chapter, r.context].map(csvQuote).join(',')).join('\n');
  return head + (body ? '\n' + body : '');
}
// Copy-all: markdown table to the clipboard, feature-detected with a graceful
// fallback toast (navigator.clipboard is undefined on insecure/HTTP origins).
function _copyExportLinks(rows) {
  if (!rows || !rows.length) return;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(_linksToMd(rows))
      .then(() => showToast('✓ Links copied'))
      .catch(() => showToast('⚠ Could not copy'));
  } else {
    showToast('⚠ Clipboard unavailable - use Export CSV/.md');
  }
}

// The "Export links" modal: pick a scope, gather (read-only), show a table, then
// copy / download. Open to everyone incl. read-only viewers (it's a pure read).
async function openExportLinks() {
  tvCloseFilterPop();   // close any stray shared filter dropdown left open on a table, so el-export-open's z-index can't float it above this modal (its Apply would be a persisted write)
  const curSec = SECTIONS[activeSection];
  if (!curSec) return;
  const epic = (curSec.notesEpics || []).find(n => n.id === curSec.activeNotesEpic);
  const hasChapter = !!(epic && epic.boxes && epic.boxes.length);
  // Mode-aware vocabulary, mirroring the Share modal (labels.js).
  const _isBook = (typeof _ttMode === 'function') ? (_ttMode() === 'book') : false;
  const _ch = (typeof LBL === 'function') ? LBL('chapter') : 'Chapter';
  const _sub = (typeof LBL === 'function') ? LBL('subject') : 'Subject';
  const _subL = _sub.toLowerCase();
  const _whole = _isBook ? 'Whole class' : 'Everything';
  const escH = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  ensureShareStyles();
  ensureExportLinksStyles();
  const ov = document.createElement('div'); ov.className = 'tts-overlay';
  const panel = document.createElement('div'); panel.className = 'tts-panel el-wide';
  panel.innerHTML =
    `<div class="tts-hd"><div><h3>🔗 Export links</h3><div class="sub">Every link in your notes - copy or download to use elsewhere</div></div></div>` +
    `<div class="tts-opts">` +
      `<label class="tts-opt"><input type="radio" name="elScope" value="class"><span class="t">${_whole} <span class="mut">- all ${_subL}s</span></span></label>` +
      `<label class="tts-opt"><input type="radio" name="elScope" value="subject"${hasChapter ? '' : ' checked'}><span class="t">Whole ${_subL} <span class="mut">- ${escH(curSec.title || _subL)}</span></span></label>` +
      (hasChapter ? `<label class="tts-opt"><input type="radio" name="elScope" value="chapter" checked><span class="t">This ${escH(_ch)} <span class="mut">- ${escH(epic.name)}</span></span></label>` : '') +
    `</div>` +
    `<div class="tts-foot tts-foot-r"><button class="tts-btn" id="elClose">Close</button><button class="tts-btn tts-btn-primary" id="elFind">Find links</button></div>` +
    `<div id="elResult"></div>` +
    `<div class="tts-foot tts-foot-r" id="elExports" style="display:none">` +
      `<button class="tts-btn" id="elCopy">Copy all</button>` +
      `<button class="tts-btn" id="elCsv">Export CSV</button>` +
      `<button class="tts-btn" id="elMd">Export .md</button>` +
    `</div>`;
  ov.appendChild(panel);
  document.body.appendChild(ov);
  document.body.classList.add('el-export-open');   // lifts the shared filter dropdown above this overlay

  const close = () => { tvCloseFilterPop(); ov.remove(); document.body.classList.remove('el-export-open'); document.removeEventListener('keydown', onKey, true); };
  // Capture phase (registered before any filter pop exists) + defer to an open
  // dropdown: first Escape closes only the dropdown (its own _tvPopKey), a second
  // Escape closes the modal. Without this both close on one Escape.
  const onKey = (e) => { if (e.key === 'Escape' && !_tvPop) close(); };
  document.addEventListener('keydown', onKey, true);
  ov.addEventListener('mousedown', (e) => { if (e.target === ov) close(); });   // backdrop dismiss (mousedown+target, like Share)

  let lastRows = [];
  let visibleRows = [];   // currently-shown rows (search + Type-filter + sort); copy/export act on THESE
  const resultEl = panel.querySelector('#elResult');
  const exportsEl = panel.querySelector('#elExports');
  const findBtn = panel.querySelector('#elFind');
  panel.querySelector('#elClose').addEventListener('click', close);

  findBtn.addEventListener('click', async () => {
    const picked = panel.querySelector('input[name="elScope"]:checked');
    const scope = picked ? picked.value : 'subject';
    findBtn.disabled = true; exportsEl.style.display = 'none';
    resultEl.innerHTML = `<div class="tts-empty" id="elProg">Gathering links…</div>`;
    const prog = panel.querySelector('#elProg');
    let res;
    try {
      res = await _gatherExportLinks(scope, (done, total) => { if (prog) prog.textContent = `Gathering links… ${done}/${total} boxes`; });
    } catch (_) { res = { rows: [], boxCount: 0 }; }
    findBtn.disabled = false;
    lastRows = res.rows;
    if (!lastRows.length) { visibleRows = []; resultEl.innerHTML = `<div class="tts-empty">No links found in this scope.</div>`; exportsEl.style.display = 'none'; return; }

    // Per-column sort + filter over the gathered rows, matching the grid table:
    // same tv-sort / tv-filter header controls and the SAME tvBuildFilterPop
    // dropdown (search + Starts-with/Contains + Select-all/Clear + value checkboxes
    // + Apply). NO re-gather; lastRows is never mutated (ZERO-writes). Copy/Export
    // act on the currently-visible (filtered + sorted) rows.
    const COLS = [{ key: 'url', label: 'Link' }, { key: 'type', label: 'Type' }, { key: 'chapter', label: _ch }, { key: 'context', label: 'Context' }];
    let sortState = null;             // { key, dir } | null (null = the URL sort from gather)
    const filters = {};               // { key: [chosenValues] } - AND across columns, OR within
    const cellOf = (r, k) => String(r[k] == null ? '' : r[k]);
    const colValues = (k) => {
      const seen = new Set(), vals = [];
      lastRows.forEach(r => { const v = cellOf(r, k); if (!seen.has(v)) { seen.add(v); vals.push(v); } });
      vals.sort((a, b) => tvCompare(a, b, 'asc'));
      return vals;
    };
    const matches = (r) => { for (const k in filters) { if (Array.isArray(filters[k]) && filters[k].indexOf(cellOf(r, k)) === -1) return false; } return true; };
    const compute = () => {
      let v = lastRows.filter(matches);
      if (sortState) v = v.slice().sort((a, b) => tvCompare(cellOf(a, sortState.key), cellOf(b, sortState.key), sortState.dir) || String(a.url).localeCompare(String(b.url)));
      return v;
    };
    resultEl.innerHTML = `<div class="tts-summary el-summary-row" id="elSummary"></div><div class="el-tblwrap" id="elTblWrap"></div>`;
    const summaryEl = resultEl.querySelector('#elSummary');
    const wrap = resultEl.querySelector('#elTblWrap');
    const renderAll = () => {
      visibleRows = compute();
      const head = COLS.map(c => {
        const dir = (sortState && sortState.key === c.key) ? sortState.dir : null;
        const glyph = dir === 'asc' ? '▲' : (dir === 'desc' ? '▼' : '↕');
        const hasF = Array.isArray(filters[c.key]);
        return `<th>${escH(c.label)}` +
          `<span class="tv-sort${dir ? ' tv-on' : ''}" data-key="${c.key}" title="Sort (asc / desc / off)">${glyph}</span>` +
          `<span class="tv-filter${hasF ? ' tv-on' : ''}" data-key="${c.key}" title="Filter values">&#9662;</span></th>`;
      }).join('');
      const body = visibleRows.map(r =>
        `<tr><td><a href="${escH(r.url)}" target="_blank" rel="noopener noreferrer">${escH(r.url)}</a></td>` +
        `<td>${escH(r.type)}</td><td>${escH(r.chapter)}</td><td>${escH(r.context)}</td></tr>`).join('')
        || `<tr><td colspan="4" class="tts-empty">No links match.</td></tr>`;
      wrap.innerHTML = `<table class="tts-tbl"><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>`;
      const anyView = !!sortState || Object.keys(filters).length > 0;
      summaryEl.innerHTML = `<span>Showing ${visibleRows.length} of ${lastRows.length} link${lastRows.length === 1 ? '' : 's'} across ${res.boxCount} ${res.boxCount === 1 ? LBL('boxNoun').toLowerCase() : (LBL('boxNoun') + (/x$/i.test(LBL('boxNoun')) ? 'es' : 's')).toLowerCase()}</span>`
        + (anyView ? ` <button class="el-clearview" type="button" id="elClear">&#10005; Clear sort/filter</button>` : '');
      const clr = summaryEl.querySelector('#elClear');
      if (clr) clr.addEventListener('click', () => { sortState = null; Object.keys(filters).forEach(k => delete filters[k]); renderAll(); });
      wrap.querySelectorAll('.tv-sort').forEach(el => el.addEventListener('click', () => {
        const k = el.dataset.key;
        const cur = (sortState && sortState.key === k) ? sortState.dir : null;
        const next = cur === null ? 'asc' : (cur === 'asc' ? 'desc' : null);   // none -> asc -> desc -> none (like the grid)
        sortState = next ? { key: k, dir: next } : null;
        renderAll();
      }));
      wrap.querySelectorAll('.tv-filter').forEach(el => el.addEventListener('click', (ev) => {
        ev.stopPropagation();
        const k = el.dataset.key;
        const values = colValues(k);
        const selected = new Set(Array.isArray(filters[k]) ? filters[k] : values);   // no filter => all selected
        tvBuildFilterPop(values, selected, el, (chosen) => {
          if (chosen.length === values.length) delete filters[k]; else filters[k] = chosen;   // all => no filter
          renderAll();
        });
      }));
    };
    renderAll();
    exportsEl.style.display = '';
  });

  // Copy/Export operate on the currently-visible (filtered + sorted) rows, so
  // "filter then export" works. visibleRows is refreshed by renderAll above. When
  // the filtered set is empty, all three give the same "Nothing to export" toast
  // and produce no file / no clipboard write (no header-only download, no silent
  // no-op).
  const hasVisible = () => { if (!visibleRows.length) { showToast('Nothing to export'); return false; } return true; };
  panel.querySelector('#elCopy').addEventListener('click', () => { if (hasVisible()) _copyExportLinks(visibleRows); });
  panel.querySelector('#elCsv').addEventListener('click', () => { if (hasVisible()) downloadBlob(new Blob([String.fromCharCode(0xFEFF) + _linksToCsv(visibleRows)], { type: 'text/csv;charset=utf-8' }), 'links.csv'); });
  panel.querySelector('#elMd').addEventListener('click', () => { if (hasVisible()) downloadBlob(new Blob([_linksToMd(visibleRows)], { type: 'text/markdown;charset=utf-8' }), 'links.md'); });
}

;
// ==== FILE: js/notes/notes-connect-ai.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-connect-ai.js
// ==========================================================================

// ── Connect your AI (Bring-Your-Own-AI) ──────────────────────────────────────
// A portal-level button (next to Share) that shows how to connect a person's own
// Claude / ChatGPT to THEIR tracker via the live remote MCP connector (OAuth 2.1,
// one-click Google sign-in). No backend here - the connector + tools are already
// live; this is the in-app onboarding so connecting is discoverable + copy-paste.
const MCP_CONNECTOR_URL = 'https://interactive-books-840108407499.asia-south1.run.app/mcp';
function ensureConnectAiStyles() {
  if (document.getElementById('cai-style')) return;
  const st = document.createElement('style'); st.id = 'cai-style';
  st.textContent =
    '.cai-tabs{display:flex;gap:.4rem;margin-bottom:.85rem}' +
    '.cai-tab{flex:1;font-family:inherit;font-size:.85rem;font-weight:600;padding:.45rem .5rem;border:1px solid var(--c-line-200);border-radius:9px;background:var(--c-white);color:var(--c-ink-500);cursor:pointer;transition:background .12s,border-color .12s}' +
    '.cai-tab:hover{background:var(--c-fill-100)}' +
    '.cai-tab.on{background:var(--c-ink-700);border-color:var(--c-ink-700);color:#fff}' +
    '.cai-steps{display:none}' +
    '.cai-steps.on{display:block}' +
    '.cai-steps ol{list-style:none;counter-reset:cai;margin:0;padding:0;font-size:.85rem;color:var(--c-ink-700);line-height:1.55}' +
    '.cai-steps li{counter-increment:cai;position:relative;padding-left:1.95rem;margin:.55rem 0}' +
    '.cai-steps li:first-child{margin-top:.15rem}' +
    '.cai-steps li::before{content:counter(cai);position:absolute;left:0;top:.02rem;width:1.35rem;height:1.35rem;border-radius:50%;background:var(--c-ink-700);color:#fff;font-size:.7rem;font-weight:700;display:flex;align-items:center;justify-content:center}' +
    '.cai-steps li b{color:var(--c-ink-900);font-weight:600}' +
    '.cai-link{color:var(--c-ink-900);text-decoration:underline;text-underline-offset:2px;text-decoration-thickness:1px}' +
    '.cai-link:hover{color:var(--c-ink-600)}' +
    '.cai-ext{text-decoration:none;font-size:.82em;color:var(--c-ink-450)}' +
    ".cai-steps code{font-family:ui-monospace,'Cascadia Code',Menlo,Consolas,monospace;font-size:.82em;background:var(--c-fill-200);border:1px solid var(--c-line-100);border-radius:5px;padding:.08rem .32rem;color:var(--c-ink-800);word-break:break-all}" +
    '.cai-cli{margin:.55rem 0}' +
    '.cai-cmd{display:flex;align-items:center;gap:.4rem;margin-bottom:.3rem}' +
    '.cai-cmd:last-child{margin-bottom:0}' +
    '.cai-cmd code{flex:1;min-width:0;display:block;white-space:pre-wrap;word-break:break-all;padding:.4rem .55rem}' +
    '.cai-copy{flex:none;font-family:inherit;font-size:.75rem;font-weight:600;padding:.3rem .6rem;border:1px solid var(--c-line-200);border-radius:6px;background:var(--c-white);color:var(--c-ink-600);cursor:pointer;white-space:nowrap;transition:background .12s,border-color .12s}' +
    '.cai-copy:hover{background:var(--c-fill-100);border-color:var(--c-ink-400)}' +
    '.cai-copy-inline{margin-top:.4rem}' +
    '.cai-way-h{font-size:.7rem;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:var(--c-ink-600);margin-bottom:.5rem;display:flex;align-items:baseline;gap:.5rem}' +
    '.cai-way-h span{font-size:.7rem;font-weight:500;letter-spacing:0;text-transform:none;color:var(--c-ink-400)}' +
    /* plan requirement shown as a scannable badge instead of a sentence */
    '.cai-mtabs{display:flex;gap:.4rem;margin:.1rem 0 .85rem}' +
    '.cai-mtab{flex:1;text-align:center;font-family:inherit;font-size:.75rem;font-weight:600;padding:.32rem .8rem;border:1px solid var(--c-line-200);border-radius:7px;background:var(--c-white);color:var(--c-ink-500);cursor:pointer;transition:background .12s,border-color .12s,color .12s}' +
    '.cai-mtab:hover{background:var(--c-fill-100)}' +
    '.cai-mtab.on{background:var(--c-fill-200);border-color:var(--c-ink-400);color:var(--c-ink-900)}' +
    '.cai-mway{display:none}' +
    '.cai-mway.on{display:block}' +
    /* footer: a quiet "what next" line + an amber access callout (split from one gray blob) */
    /* "Get started" prompt list - copyable first actions after connecting */
    '.cai-start{margin-top:.9rem;padding-top:.8rem;border-top:1px solid var(--c-line-100)}' +
    '.cai-start-h{display:flex;align-items:center;gap:.5rem;width:100%;font-family:inherit;font-size:.85rem;font-weight:600;color:var(--c-ink-700);background:var(--c-fill-100);border:1px solid var(--c-line-200);border-radius:9px;padding:.5rem .7rem;cursor:pointer;text-align:left;transition:background .12s,border-color .12s}' +
    '.cai-start-h:hover{background:var(--c-fill-200);border-color:var(--c-ink-400);color:var(--c-ink-900)}' +
    '.cai-start-caret{margin-left:auto;font-size:.75rem;color:var(--c-ink-500);transition:transform .15s}' +
    '.cai-start-h[aria-expanded="true"] .cai-start-caret{transform:rotate(90deg)}' +
    '.cai-start-list{margin-top:.55rem;border:1px solid var(--c-line-150);border-radius:9px;background:var(--c-fill-100);overflow:hidden}' +
    '.cai-start-list[hidden]{display:none}' +
    '.cai-start-row{display:flex;align-items:center;gap:.5rem;padding:.45rem .55rem .45rem .65rem;border-top:1px solid var(--c-line-100)}' +
    '.cai-start-row:first-child{border-top:none}' +
    '.cai-start-row span{flex:1;min-width:0;font-size:.85rem;font-style:italic;color:var(--c-ink-700);line-height:1.4}';
  document.head.appendChild(st);
}
function openConnectAI() {
  ensureShareStyles();          // reuse the shared modal chrome (.tts-overlay/.tts-panel/.tts-btn)
  ensureConnectAiStyles();
  const url = MCP_CONNECTOR_URL;
  // Get-started prompts: the Interactive Books landing's own flow - make the book,
  // draw the graphs, check them and narrate, share, ask (Rishabh 2026-09-27).
  // One list for every container: each prompt names a real connector tool
  // (book create, add_diagram, check_coverage, generate_lesson_video, ev_share,
  // read_notes).
  const startPrompts = [
    'Create an interactive book from this PDF.',
    'Draw a knowledge graph for every section of my book.',
    'Check that each graph covers everything in that section - if it does, turn it into a narrated lesson video.',
    'Share the latest version of my book with my students.',
    'Explain the Light chapter from my book in Hindi.',
  ];
  const promptRows = startPrompts.map(p =>
    `<div class="cai-start-row"><span>"${p}"</span><button class="cai-copy" data-copy="${p}">Copy</button></div>`
  ).join('');
  const ov = document.createElement('div'); ov.className = 'tts-overlay';
  const panel = document.createElement('div'); panel.className = 'tts-panel';
  panel.innerHTML =
    `<div class="tts-hd"><div><h3>Connect any AI</h3><div class="sub">Let your own Claude, ChatGPT or Gemini read, write and manage your docs.</div></div>` +
      `<button id="caiClose" class="tts-icon" title="Close">&times;</button></div>` +
    `<div class="cai-tabs">` +
      `<button class="cai-tab on" data-p="claude">Claude</button>` +
      `<button class="cai-tab" data-p="gpt">ChatGPT</button>` +
      `<button class="cai-tab" data-p="gemini">Gemini</button>` +
    `</div>` +
    `<div class="cai-steps on" data-p="claude">` +
      `<div class="cai-mtabs"><button class="cai-mtab on" data-m="browser">Browser</button><button class="cai-mtab" data-m="terminal">Terminal</button></div>` +
      `<div class="cai-mway on" data-m="browser">` +
        `<div class="cai-way-h">claude.ai <span>no install</span></div><ol>` +
          `<li><a class="cai-link" href="https://claude.ai/settings/connectors" target="_blank" rel="noopener"><b>Go to Customize &rarr; Connectors</b> <span class="cai-ext">&#8599;</span></a></li>` +
          `<li><b>Add &rarr; Add custom connector</b></li>` +
          `<li>Name it, paste the URL as <b>Remote MCP server URL</b>, <b>Add</b> (OAuth blank)<br><button class="cai-copy cai-copy-inline" data-copy="${url}">Copy connector URL</button></li>` +
          `<li><b>Connect &rarr; Sign in with Google</b></li>` +
        `</ol>` +
      `</div>` +
      `<div class="cai-mway" data-m="terminal">` +
        `<div class="cai-way-h">Claude Code <span>terminal</span></div>` +
        `<div class="cai-cli"><div class="cai-cmd"><code>npm i -g @anthropic-ai/claude-code</code><button class="cai-copy" data-copy="npm i -g @anthropic-ai/claude-code">Copy</button></div><div class="cai-cmd"><code>claude mcp add --transport http interactive-books ${url}</code><button class="cai-copy" data-copy="claude mcp add --transport http interactive-books ${url}">Copy</button></div></div>` +
      `</div>` +
    `</div>` +
    `<div class="cai-steps" data-p="gpt">` +
      `<div class="cai-mtabs"><button class="cai-mtab on" data-m="browser">Browser</button><button class="cai-mtab" data-m="terminal">Terminal</button></div>` +
      `<div class="cai-mway on" data-m="browser">` +
        `<div class="cai-way-h">chatgpt.com <span>no install</span></div><ol>` +
          `<li><a class="cai-link" href="https://chatgpt.com/#settings/Connectors" target="_blank" rel="noopener"><b>Go to Settings &rarr; Connectors</b> <span class="cai-ext">&#8599;</span></a>, turn on <b>Developer mode</b></li>` +
          `<li>Add a <b>custom connector</b>, paste the connector URL<br><button class="cai-copy cai-copy-inline" data-copy="${url}">Copy connector URL</button></li>` +
          `<li><b>Sign in with Google</b></li>` +
        `</ol>` +
      `</div>` +
      `<div class="cai-mway" data-m="terminal">` +
        `<div class="cai-way-h">Codex CLI <span>terminal</span></div>` +
        `<div class="cai-cli"><div class="cai-cmd"><code>npm i -g @openai/codex</code><button class="cai-copy" data-copy="npm i -g @openai/codex">Copy</button></div><div class="cai-cmd"><code>codex mcp add interactive-books --url ${url}</code><button class="cai-copy" data-copy="codex mcp add interactive-books --url ${url}">Copy</button></div></div>` +
      `</div>` +
    `</div>` +
    `<div class="cai-steps" data-p="gemini">` +
      `<div class="cai-mtabs"><button class="cai-mtab on" data-m="terminal">Terminal</button></div>` +
      `<div class="cai-mway on" data-m="terminal">` +
        `<div class="cai-way-h">Gemini CLI <span>terminal</span></div>` +
        `<div class="cai-cli"><div class="cai-cmd"><code>npm i -g @google/gemini-cli</code><button class="cai-copy" data-copy="npm i -g @google/gemini-cli">Copy</button></div><div class="cai-cmd"><code>gemini mcp add --transport http interactive-books ${url}</code><button class="cai-copy" data-copy="gemini mcp add --transport http interactive-books ${url}">Copy</button></div></div>` +
      `</div>` +
    `</div>` +
    `<div class="cai-start"><button type="button" class="cai-start-h" id="caiStartToggle" aria-expanded="false">Once connected, start with any of these prompts <span class="cai-start-caret">&#9656;</span></button><div class="cai-start-list" id="caiStartList" hidden>` +
      promptRows +
    `</div></div>` +
    `<div class="tts-foot"><span class="tts-foot-r"><button id="caiDone" class="tts-btn tts-btn-primary">Done</button></span></div>`;
  ov.appendChild(panel); document.body.appendChild(ov);

  const close = () => ov.remove();
  ov.addEventListener('mousedown', e => { if (e.target === ov) close(); });
  panel.querySelector('#caiClose').addEventListener('click', close);
  panel.querySelector('#caiDone').addEventListener('click', close);

  // One delegated copy handler for every .cai-copy button: the connector URL in
  // the browser paste steps, and the full command in the terminal steps. Copies
  // data-copy verbatim and flips the button to "Copied" for 1.5s.
  panel.addEventListener('click', (e) => {
    const b = e.target.closest('.cai-copy');
    if (!b) return;
    const text = b.dataset.copy || '';
    const orig = b.dataset.orig || b.textContent; b.dataset.orig = orig;
    const done = () => { b.textContent = 'Copied'; setTimeout(() => { b.textContent = orig; }, 1500); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, done);
    else {
      const ta = document.createElement('textarea'); ta.value = text;
      ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (_) {}
      ta.remove(); done();
    }
  });

  panel.querySelectorAll('.cai-tab').forEach(t => t.addEventListener('click', () => {
    const p = t.dataset.p;
    panel.querySelectorAll('.cai-tab').forEach(x => x.classList.toggle('on', x === t));
    panel.querySelectorAll('.cai-steps').forEach(s => s.classList.toggle('on', s.dataset.p === p));
  }));
  // Method sub-toggle (Browser / Terminal) WITHIN the active provider — one at a time.
  panel.querySelectorAll('.cai-mtab').forEach(t => t.addEventListener('click', () => {
    const m = t.dataset.m, box = t.closest('.cai-steps');
    box.querySelectorAll('.cai-mtab').forEach(x => x.classList.toggle('on', x === t));
    box.querySelectorAll('.cai-mway').forEach(s => s.classList.toggle('on', s.dataset.m === m));
  }));

  // Collapsible "Get started" prompt list - collapsed by default; header toggles it.
  const startToggle = panel.querySelector('#caiStartToggle');
  const startList = panel.querySelector('#caiStartList');
  if (startToggle && startList) startToggle.addEventListener('click', () => {
    const open = startToggle.getAttribute('aria-expanded') === 'true';
    startToggle.setAttribute('aria-expanded', String(!open));
    startList.hidden = open;
  });
}

;
// ==== FILE: js/notes/notes-modal-chrome.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-modal-chrome.js (was notes-share.js - the legacy chapter-share run / pill / wizard that shared this
// file were deleted 2026-09-29 on Rishabh's word; only the shared modal stylesheet below remains)
// ==========================================================================

// One-time stylesheet for the app's modal chrome (.tts-overlay / .tts-panel / .tts-btn / .tts-tbl / .tts-pill ...) - built from
// the app's own design tokens (warm ink/cream palette, Instrument Sans). Called by the dashboard Share dialog, Invitations,
// Consent, Shared with me, Connect any AI, Export links, the video modal and shared-read - every modal wears these classes.
function ensureShareStyles() {
  if (document.getElementById('tts-style')) return;
  const st = document.createElement('style'); st.id = 'tts-style';
  st.textContent =
    '.tts-overlay{position:fixed;inset:0;z-index:9000;background:rgba(18,16,12,.45);backdrop-filter:blur(3px);display:flex;align-items:center;justify-content:center;padding:1rem}' +
    'body.tts-modal-open .tv-filter-pop{z-index:9600}' +
    ".tts-panel{background:var(--c-white);color:var(--c-ink-800);width:100%;max-width:540px;max-height:86vh;overflow:auto;border:1px solid var(--c-line-150);border-radius:16px;box-shadow:0 24px 64px rgba(18,16,12,.30);font-family:'Instrument Sans','Inter',system-ui,sans-serif;padding:1.2rem 1.35rem}" +
    '.tts-hd{display:flex;align-items:flex-start;justify-content:space-between;gap:.5rem;margin-bottom:.85rem}' +
    '.tts-hd h3{font-size:1.22rem;font-weight:700;color:var(--c-ink-900);letter-spacing:-.01em}' +
    '.tts-hd .sub{font-size:.82rem;color:var(--c-ink-450);margin-top:.15rem}' +
    '.tts-icon{background:none;border:1px solid var(--c-line-200);cursor:pointer;font-size:.95rem;line-height:1;color:var(--c-ink-500);padding:.42rem .5rem;border-radius:9px;flex:none}' +
    '.tts-icon:hover{background:var(--c-fill-100);color:var(--c-ink-700)}' +
    '.tts-label{font-size:.68rem;font-weight:700;letter-spacing:.07em;text-transform:uppercase;color:var(--c-ink-450);margin:0 0 .3rem}' +
    '.tts-num{display:inline-flex;align-items:center;justify-content:center;width:1.15rem;height:1.15rem;border-radius:50%;background:var(--c-ink-700);color:#fff;font-size:.62rem;font-weight:700;margin-right:.45rem;vertical-align:-.2rem;letter-spacing:0}' +
    '.tts-summary{font-size:.82rem;color:var(--c-ink-500);padding-top:.7rem;margin-top:.55rem;border-top:1px solid var(--c-line-100)}' +
    '.tts-summary b{color:var(--c-ink-800);font-weight:600}' +
    '.tts-step{display:none}' +
    '.tts-step.active{display:block}' +
    '.tts-dots{display:flex;gap:.4rem;margin-bottom:1rem}' +
    '.tts-dots span{height:4px;flex:1;border-radius:2px;background:var(--c-line-150);transition:background .15s}' +
    '.tts-dots span.on{background:var(--c-ink-700)}' +
    '.tts-opts{display:flex;flex-direction:column;gap:.35rem;margin-bottom:.8rem}' +
    '.tts-opt{display:flex;gap:.6rem;align-items:flex-start;padding:.48rem .62rem;border:1px solid var(--c-line-200);border-radius:10px;cursor:pointer;transition:border-color .12s,background .12s}' +
    '.tts-opt:hover{background:var(--c-fill-300)}' +
    '.tts-opt.sel{border-color:var(--c-ink-700);background:var(--c-fill-100)}' +
    '.tts-opt input{margin-top:.15rem;accent-color:var(--c-ink-700);width:1rem;height:1rem;flex:none}' +
    '.tts-opt .t{font-size:.92rem;font-weight:600;color:var(--c-ink-800)}' +
    '.tts-opt .t .mut{font-weight:400;color:var(--c-ink-450)}' +
    '.tts-opt .d{display:block;font-size:.8rem;color:var(--c-ink-450);margin-top:.12rem}' +
    '.tts-ver{display:flex;align-items:center;gap:.6rem;font-size:.88rem;font-weight:600;color:var(--c-ink-700);margin-bottom:.8rem}' +
    '.tts-ver input{width:88px;padding:.42rem .55rem;border:1px solid var(--c-line-200);border-radius:8px;color:var(--c-ink-800);font-family:inherit;font-size:.9rem}' +
    '.tts-ver input:focus{outline:none;border-color:var(--c-ink-700)}' +
    '.tts-selall{display:flex;align-items:center;gap:.55rem;font-size:.82rem;font-weight:600;color:var(--c-ink-600);padding-bottom:.55rem;border-bottom:1px solid var(--c-line-100);margin-bottom:.15rem;cursor:pointer}' +
    '.tts-selall input,.tts-member input{accent-color:var(--c-ink-700);width:1rem;height:1rem;flex:none}' +
    '.tts-members{max-height:172px;overflow:auto;margin:0 -.15rem;font-size:.85rem;color:var(--c-ink-450)}' +
    '.tts-member{display:flex;align-items:center;gap:.6rem;padding:.52rem .15rem;border-bottom:1px solid var(--c-line-050);cursor:pointer;font-size:.9rem}' +
    '.tts-member:last-child{border-bottom:none}' +
    '.tts-member:hover{background:var(--c-fill-300)}' +
    '.tts-member .nm{color:var(--c-ink-800);font-weight:500}' +
    '.tts-role{margin-left:auto;font-size:.72rem;color:var(--c-ink-450);background:var(--c-fill-200);border-radius:20px;padding:.15rem .55rem;white-space:nowrap}' +
    '.tts-status{font-size:.82rem;color:var(--c-ink-500);margin-top:.85rem;min-height:1em}' +
    '.tts-st{display:inline-block;font-size:.78rem;font-weight:600;padding:.2rem .55rem;border-radius:7px;margin-right:.4rem}' +
    '.tts-st.ok{color:var(--c-green-700);background:var(--c-green-050)}' +
    '.tts-st.skip{color:var(--c-ink-500);background:var(--c-fill-200)}' +
    '.tts-st.fail{color:var(--c-red);background:var(--c-red-050)}' +
    '.tts-foot{display:flex;align-items:center;gap:.6rem;margin-top:.95rem;padding-top:.8rem;border-top:1px solid var(--c-line-100)}' +
    '.tts-foot-r{margin-left:auto;display:flex;gap:.6rem}' +
    '.tts-btn{font-family:inherit;font-size:.88rem;font-weight:600;padding:.52rem 1rem;border-radius:9px;cursor:pointer;border:1px solid var(--c-line-200);background:var(--c-white);color:var(--c-ink-600);transition:background .12s,border-color .12s}' +
    '.tts-btn:hover{background:var(--c-fill-100);border-color:var(--c-ink-400)}' +
    '.tts-btn-primary{background:var(--c-ink-700);border-color:var(--c-ink-700);color:var(--c-white)}' +
    '.tts-btn-primary:hover{background:var(--c-ink-900);border-color:var(--c-ink-900)}' +
    '.tts-btn-primary:disabled{opacity:.5;cursor:default}' +
    '.tts-back{background:none;border:none;color:var(--c-ink-500);font-family:inherit;font-size:.85rem;font-weight:600;cursor:pointer;padding:.1rem 0;margin-bottom:.7rem}' +
    '.tts-back:hover{color:var(--c-ink-800)}' +
    '.tts-tbl{width:100%;border-collapse:collapse;font-size:.83rem}' +
    '.tts-tbl th{text-align:left;font-weight:700;font-size:.68rem;text-transform:uppercase;letter-spacing:.05em;color:var(--c-ink-450);padding:.3rem .5rem .45rem 0;border-bottom:1px solid var(--c-line-150)}' +
    '.tts-tbl td{padding:.55rem .5rem;border-bottom:1px solid var(--c-line-050);vertical-align:middle;color:var(--c-ink-700)}' +
    '.tts-tbl td:first-child{padding-left:0}' +
    '.tts-tbl .sub{color:var(--c-ink-450);font-size:.72rem}' +
    '.tts-pill{display:inline-block;font-size:.72rem;font-weight:700;padding:.15rem .55rem;border-radius:20px;cursor:default;border:1px solid transparent;letter-spacing:.01em}' +
    '.tts-pill.edit{color:var(--c-green-700);background:var(--c-green-050);border-color:var(--c-green-700)}' +
    '.tts-pill.read{color:var(--c-amber-700);background:var(--c-amber-050);border-color:var(--c-amber-700)}' +
    '.tts-revoke{font-family:inherit;font-size:.74rem;font-weight:600;color:var(--c-red);background:var(--c-red-050);border:1px solid var(--c-red-200);border-radius:7px;padding:.26rem .6rem;cursor:pointer;white-space:nowrap}' +
    '.tts-revoke:hover{background:var(--c-red-075)}' +
    '.tts-own{font-size:.72rem;color:var(--c-ink-400)}' +
    '.tts-empty{color:var(--c-ink-450);padding:.5rem 0}' +
    '.tts-act-tbl .sh{color:var(--c-green-700);font-weight:600;white-space:nowrap}' +
    '.tts-act-tbl .rv{color:var(--c-red);font-weight:600;white-space:nowrap}' +
    '.tts-act-tbl .mt{color:var(--c-ink-450)}' +
    '.tts-seg{display:inline-flex;gap:.25rem;background:var(--c-fill-100,#f1ece3);border-radius:8px;padding:.25rem;margin-bottom:.75rem}' +
    '.tts-seg-btn{border:0;background:transparent;font-family:inherit;font-size:.8rem;font-weight:600;color:var(--c-ink-500);padding:.35rem .85rem;border-radius:6px;cursor:pointer}' +
    '.tts-seg-btn.active{background:#fff;color:var(--c-ink-900);box-shadow:0 1px 2px rgba(18,16,12,.15)}' +
    /* Manage Access — grouped table: member + subject shown once per group */
    '.tts-tbl tr.grp td{border-top:1px solid var(--c-line-200)}' +
    '.tts-tbl td.mem{font-weight:600;color:var(--c-ink-900);vertical-align:top;min-width:5.5rem}' +
    '.tts-tbl td.subj{color:var(--c-ink-500);vertical-align:top}' +
    /* Manage Access needs room: the grouped table + activity log are wide + long */
    '.tts-panel.tts-wide{max-width:820px}' +
    '#shareHistList{max-height:66vh;overflow:auto;margin:0 -.15rem;padding:0 .15rem}' +
    /* sharing progress: a spinner + a fill bar so a many-chapter share never reads as stuck */
    '.tts-spin{display:inline-block;width:.92em;height:.92em;border:2px solid var(--c-line-200);border-top-color:var(--c-ink-700);border-radius:50%;vertical-align:-.16em;animation:tts-spin .6s linear infinite}' +
    '@keyframes tts-spin{to{transform:rotate(360deg)}}' +
    '.tts-prog-txt{display:flex;align-items:center;gap:.5rem;font-size:.86rem;font-weight:600;color:var(--c-ink-700);margin-bottom:.15rem}' +
    '.tts-prog-txt .cur{font-weight:400;color:var(--c-ink-450);min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.tts-prog{height:6px;border-radius:3px;background:var(--c-line-100);overflow:hidden;margin:.5rem 0}' +
    '.tts-prog>i{display:block;height:100%;width:0;background:var(--c-ink-700);border-radius:3px;transition:width .2s ease}' +
    '.tts-confirm-cta{display:block;margin-top:.4rem;font-weight:600;color:var(--c-ink-700)}' +
    // current-chapter row: let the free-text name ellipsis instead of overflowing
    '.tts-prog-txt{min-width:0}' +
    '.tts-prog-txt>.tts-spin,.tts-prog-txt>span:not(.cur){flex:none}' +
    '.tts-prog-txt .cur{flex:1 1 auto}' +
    // ✓/↷/✗ chips: wrap with a real gap instead of flush margins
    '.tts-chips{display:flex;flex-wrap:wrap;gap:.35rem;margin-top:.5rem}' +
    '.tts-chips .tts-st{margin-right:0}' +
    // final bar goes red when any copy failed (so bar + "✗ N failed" chip agree)
    '.tts-prog.fail>i{background:var(--c-red,#c0392b)}' +
    // indeterminate bar during the pre-fetch phase (done===0) - "working", not stuck
    '.tts-prog.indet{position:relative}' +
    '.tts-prog.indet>i{position:absolute;left:0;width:35%;animation:tts-indet 1.1s ease-in-out infinite}' +
    '@keyframes tts-indet{0%{left:-35%}100%{left:100%}}' +
    // floating pill: a running/finished share stays visible after the modal closes
    ".tts-pill-run{position:fixed;right:1.1rem;bottom:1.1rem;z-index:9500;max-width:min(80vw,420px);display:flex;align-items:center;gap:.5rem;background:var(--c-ink-900,#17140f);color:#fff;font-family:'Instrument Sans','Inter',system-ui,sans-serif;font-size:.85rem;font-weight:600;padding:.6rem .95rem;border-radius:999px;box-shadow:0 10px 30px rgba(18,16,12,.35);cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
    '.tts-pill-run.fail{background:var(--c-red,#c0392b)}' +
    '.tts-pill-run .tts-spin{border-color:rgba(255,255,255,.4);border-top-color:#fff}' +
    // While a run is in flight the pill grows to a small card + carries the same "keep the
    // browser open" caution as the popup (the job dies if the tab closes) - muted so it stays tidy.
    '.tts-pill-run.tts-col{flex-direction:column;align-items:flex-start;gap:.28rem;border-radius:14px;white-space:normal}' +
    '.tts-pill-run .tts-pill-line{display:flex;align-items:center;gap:.5rem}' +
    '.tts-pill-run .tts-pill-warn{font-size:.72rem;font-weight:500;opacity:.72;letter-spacing:.01em}' +
    // Manage Access table: keep metadata columns compact + scroll horizontally rather than cram/wrap
    '.tts-wide .tts-tbl{min-width:660px}' +
    '.tts-tbl th:nth-child(n+4),.tts-tbl td:nth-child(n+4){white-space:nowrap}' +
    // live-view hint: closing the modal keeps the share running
    '.tts-hint{font-size:.78rem;color:var(--c-ink-450);margin-top:.7rem;line-height:1.4}' +
    // share-failed message: preserve line breaks + wrap long filenames (no horizontal scroll)
    '.tts-err{white-space:pre-wrap;word-break:break-word;overflow-wrap:anywhere;font-size:.82rem;line-height:1.5;color:var(--c-red);background:var(--c-red-050);border:1px solid var(--c-red-200);border-radius:8px;padding:.6rem .7rem;margin-top:.55rem;max-height:42vh;overflow:auto}';
  document.head.appendChild(st);
}

// ── Share run controller ─────────────────────────────────────────────────────

;
// ==== FILE: js/notes/notes-undo.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-undo.js
// ==========================================================================

// ── Per-box undo / redo for the notes editors ───────────────────────────────
// The editor re-renders itself (setEditorContent round-trips through markdown)
// on blur and on every table op, which WIPES the browser's native
// contenteditable undo — so Ctrl+Z would otherwise do nothing inside a notes
// box (incl. its tables). We keep a small stack of markdown snapshots per box
// and restore them on Ctrl+Z / Ctrl+Shift+Z (Ctrl+Y). Scoped per render — a
// fresh open/refresh of the epic starts a clean history (like reloading an
// editor). The global Ctrl+Z (ui.js) bails on contenteditable, so no conflict.
const _boxUndo = {};        // boxId → [markdown, …] (older states; last = most recent)
const _boxRedo = {};        // boxId → [markdown, …]
const _boxSnap = {};        // boxId → last-captured markdown (the baseline)
const _boxSnapTimers = {};  // boxId → debounce timer for snapshotting
const NOTES_UNDO_MAX = 80;

// ── The chapter's step TIMELINE: which step the page-level Ctrl+Z / Ctrl+Y takes next ──────────────────────────
// A box's content steps live in that box's own stacks above; a box ORDER change (↑ / ↓, a drag in the outline) is a
// step of the CHAPTER, not of a box - it had no undo at all (Rishabh 2026-10-27: "outline mein order change karo toh
// undo nahi hota?"). The timeline is the order the steps happened in, across boxes and order changes, so the hook at
// the bottom takes back the LATEST step whatever its kind. An entry is { box: id } (a content step - its content is in
// _boxUndo / _boxRedo, taken off here by notesUndo / notesRedo themselves, so the in-box Ctrl+Z keeps it in step) or
// { order: { epicId, ids } } (the order to go to). A fresh render of a box drops that box's entries (initBoxUndo, same
// as its stacks); an order entry of a chapter no longer open is dropped when reached.
let _notesTimeline = [];
let _notesTimelineRedo = [];
function _timelineTake(list, match) {
  for (let i = list.length - 1; i >= 0; i--) if (match(list[i])) return list.splice(i, 1)[0];
  return null;
}
// A box move happened (notes-structure.js _afterBoxOrderChange): `ids` is the order it left.
function notesOrderStep(epicId, ids) {
  _notesTimeline.push({ order: { epicId, ids } });
  _notesTimelineRedo = [];   // a fresh step invalidates the redo branch, like a fresh edit does for a box
}
function _notesEditorOf(bid) {
  const ed = document.querySelector(`.notes-editor[data-box-id="${CSS.escape(bid)}"]`);
  return (ed && document.body.contains(ed)) ? ed : null;
}

function initBoxUndo(bid, editor, rawContent) {
  _boxUndo[bid] = [];
  _boxRedo[bid] = [];
  _notesTimeline = _notesTimeline.filter(e => e.box !== bid);
  _notesTimelineRedo = _notesTimelineRedo.filter(e => e.box !== bid);
  // Seed the baseline with the raw on-disk bytes when available, so the first
  // Ctrl+Z restores the original exactly (getEditorContent normalizes, e.g.
  // strips trailing newlines, so a post-render baseline would reformat).
  _boxSnap[bid] = (rawContent != null) ? rawContent : (editor ? getEditorContent(editor) : '');
  if (_boxSnapTimers[bid]) { clearTimeout(_boxSnapTimers[bid]); delete _boxSnapTimers[bid]; }
}
// Image refs reachable via this box's undo/redo history (incl. its current
// baseline). An image present in any snapshot can be brought back by Ctrl+Z/Y,
// so it must NOT be deleted from storage even though the live DOM dropped it —
// otherwise undo/redo would restore markdown pointing at a deleted file. History
// is per-render (reset by initBoxUndo), so genuinely-orphaned files still get
// cleaned once they rotate out / the epic is reopened.
function collectHistoryImageRefs(bid) {
  const refs = new Set();
  const states = [...(_boxUndo[bid] || []), ...(_boxRedo[bid] || []), _boxSnap[bid] || ''];
  for (const md of states) extractImageRefs(md).forEach(r => refs.add(r));
  return refs;
}
// Capture the current content as an undo checkpoint when it differs from the
// baseline. Debounced from oninput so a burst of typing collapses into one step.
function snapshotBoxNow(bid, editor) {
  if (!editor || !document.body.contains(editor)) return;
  const cur = getEditorContent(editor);
  if (cur === (_boxSnap[bid] || '')) return;
  (_boxUndo[bid] || (_boxUndo[bid] = [])).push(_boxSnap[bid] || '');
  if (_boxUndo[bid].length > NOTES_UNDO_MAX) { _boxUndo[bid].shift(); _timelineTake(_notesTimeline, e => e.box === bid); }
  _boxRedo[bid] = [];            // a fresh edit invalidates the redo branch
  _notesTimeline.push({ box: bid });
  _notesTimelineRedo = [];
  _boxSnap[bid] = cur;
}
function scheduleBoxSnapshot(bid, editor) {
  if (_boxSnapTimers[bid]) clearTimeout(_boxSnapTimers[bid]);
  _boxSnapTimers[bid] = setTimeout(() => snapshotBoxNow(bid, editor), 500);
}
// The line an undo / redo step changed: the first markdown line that differs between the state being left and
// the state being restored, located in the re-rendered DOM by its text (markers and inline tags stripped, so a
// "**bold**" line and its <strong> rendering compare equal). Null when nothing matches (a table / block edit).
function _notesChangedLineDiv(editor, fromMd, toMd) {
  const a = String(fromMd || '').split('\n'), b = String(toMd || '').split('\n');
  let i = 0; while (i < a.length && i < b.length && a[i] === b[i]) i++;
  if (i >= b.length) i = b.length - 1;
  const plain = (t) => String(t || '').replace(/<[^>]+>/g, '').replace(/\*\*|`/g, '').replace(/^#{1,6}\s*/, '').replace(/\s+/g, ' ').trim();
  const want = plain(b[i]);
  if (!want) return null;
  const kids = Array.from(editor.children);
  const near = kids[Math.min(i, kids.length - 1)];
  if (near && plain(near.textContent) === want) return near;
  return kids.find((k) => plain(k.textContent) === want) || null;
}
// Where the caret is, in terms that survive a re-render: a table cell (block index + row / column) or a line (child
// index + character offset). Null when the caret is not in this editor.
function _notesCaretPlace(editor) {
  const sel = window.getSelection();
  if (!sel || !sel.rangeCount || !editor.contains(sel.anchorNode)) return null;
  let n = sel.anchorNode; const el = n.nodeType === 3 ? n.parentElement : n;
  const cell = el && el.closest && el.closest('.md-table-block th, .md-table-block td');
  if (cell) {
    const block = cell.closest('.md-table-block');
    const tr = cell.closest('tr');
    const ri = tr.parentElement.tagName === 'THEAD' ? -1 : Array.prototype.indexOf.call(tr.parentElement.children, tr);
    return { kind: 'cell', block: Array.prototype.indexOf.call(editor.querySelectorAll('.md-table-block'), block), ri, ci: cell.cellIndex };
  }
  while (n && n.parentNode !== editor) n = n.parentNode;
  if (!n) return null;
  const probe = document.createRange(); probe.selectNodeContents(n);
  try { probe.setEnd(sel.anchorNode, sel.anchorOffset); } catch (_) { return { kind: 'line', line: Array.prototype.indexOf.call(editor.childNodes, n), offset: 0 }; }
  return { kind: 'line', line: Array.prototype.indexOf.call(editor.childNodes, n), offset: probe.toString().length };
}
// Put the caret back at a place _notesCaretPlace recorded, on the re-rendered content (indices clamped). False when the
// place no longer exists (the undone step removed that block / line).
function _notesCaretRestore(editor, place) {
  if (!place) return false;
  if (place.kind === 'cell') {
    const blocks = editor.querySelectorAll('.md-table-block');
    const block = blocks[Math.min(place.block, blocks.length - 1)];
    if (!block || typeof placeNotesTableCaret !== 'function') return false;
    const bodyRows = block.querySelectorAll('tbody tr').length;
    const cols = block.querySelectorAll('thead th').length;
    placeNotesTableCaret(block, { ri: Math.min(place.ri, bodyRows - 1), ci: Math.min(place.ci, Math.max(0, cols - 1)) });
    return true;
  }
  const kids = editor.childNodes;
  if (!kids.length) return false;
  const line = kids[Math.min(place.line, kids.length - 1)];
  if (line.nodeType === 1 && line.matches && line.matches('.md-table-block, .mermaid-block, .excalidraw-block, .video-embed-block, .video-link-block, .pdf-embed-block, .pdf-link-block, .video-file-block')) return false;
  const w = document.createTreeWalker(line, NodeFilter.SHOW_TEXT); let t, left = place.offset, last = null;
  while ((t = w.nextNode())) { last = t; if (left <= t.nodeValue.length) break; left -= t.nodeValue.length; }
  const r = document.createRange();
  if (last) r.setStart(last, Math.min(left, last.nodeValue.length)); else r.setStart(line, 0);
  r.collapse(true);
  const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
  return true;
}
function restoreBoxState(bid, editor, md, fromMd) {
  const place = _notesCaretPlace(editor);   // where the person was - the step being undone / redone happened there
  setEditorContent(editor, md);
  _boxSnap[bid] = md;            // baseline = restored state (no spurious re-snapshot)
  // Sync the known-image set to the restored content so the post-restore save
  // doesn't see undo/redo as "image removed" and delete its file — that would
  // break a later redo. (An orphaned image file is harmless; a broken one isn't.)
  _boxImages[bid] = extractImageRefs(md);
  // The caret goes back WHERE THE PERSON WAS (the step being undone happened there - a table cell included; Rishabh
  // 2026-10-16: Ctrl+Z after an image pasted into a cell threw the caret to the top of the box), else to the line the
  // step changed, else the end of the box. Focus without scrolling - editor.focus() alone scrolls the TOP of a tall
  // box into view - then bring just the caret's line into view.
  try {
    editor.focus({ preventScroll: true });
    if (!_notesCaretRestore(editor, place)) {
      const at = _notesChangedLineDiv(editor, fromMd, md);
      const r = document.createRange();
      r.selectNodeContents(at && !at.matches('.md-table-block, .mermaid-block, .excalidraw-block, .video-embed-block, .video-link-block, .pdf-embed-block, .pdf-link-block, .video-file-block') ? at : editor);
      r.collapse(false);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
    }
    const s2 = window.getSelection(); const an = s2 && s2.rangeCount ? s2.anchorNode : null; const ael = an && (an.nodeType === 3 ? an.parentElement : an);
    if (ael && ael.scrollIntoView) ael.scrollIntoView({ block: 'nearest' });
  } catch (_) { /* selection APIs unavailable → leave caret as-is */ }
  editor.dispatchEvent(new Event('input'));   // persist + rebuild outline
}
function notesUndo(bid, editor) {
  // Flush any pending debounce so the in-progress edit is itself undoable.
  if (_boxSnapTimers[bid]) { clearTimeout(_boxSnapTimers[bid]); delete _boxSnapTimers[bid]; }
  snapshotBoxNow(bid, editor);
  const stack = _boxUndo[bid] || [];
  if (!stack.length) { showToast('Nothing to undo'); return; }
  const cur = getEditorContent(editor);
  (_boxRedo[bid] || (_boxRedo[bid] = [])).push(cur);
  _notesTimelineRedo.push(_timelineTake(_notesTimeline, e => e.box === bid) || { box: bid });
  restoreBoxState(bid, editor, stack.pop(), cur);
}
function notesRedo(bid, editor) {
  // Symmetric with notesUndo: flush any pending debounce first so an
  // in-progress edit becomes its own undo checkpoint. snapshotBoxNow clears
  // _boxRedo when it commits a real edit, so a redo pressed mid-edit correctly
  // becomes a no-op rather than folding the edit into the wrong stack slot —
  // hence the stack must be re-read AFTER the snapshot.
  if (_boxSnapTimers[bid]) { clearTimeout(_boxSnapTimers[bid]); delete _boxSnapTimers[bid]; }
  snapshotBoxNow(bid, editor);
  const stack = _boxRedo[bid] || [];
  if (!stack.length) { showToast('Nothing to redo'); return; }
  const cur = getEditorContent(editor);
  (_boxUndo[bid] || (_boxUndo[bid] = [])).push(cur);
  _notesTimeline.push(_timelineTake(_notesTimelineRedo, e => e.box === bid) || { box: bid });
  restoreBoxState(bid, editor, stack.pop(), cur);
}

// ONE answer to Ctrl+Z / Ctrl+Y for the notes view, wherever the keys land: the page-level handler (ui.js, through the
// window hook below - a toolbar click, an outline drag or a click on the blank page leaves focus on <body>; Rishabh
// 2026-10-15: rows added from the toolbar, Ctrl+Z did nothing) and a box's own keydown (notes-render.js, the caret in a
// box - which is where an undo that restored a box's text leaves it). The LATEST step on the chapter's timeline is
// taken back (undo) or forward (redo), whatever its kind - a box's content step or a box order step. With no step on
// the timeline the box the person last typed in, still on screen, answers (its own "Nothing to undo"). Returns true
// when it took the key; ui.js then leaves the table view's undo alone.
function notesUndoKey(kind) {
  // Typing still waiting for its debounce becomes its own step first, so the latest step is really the latest.
  for (const bid of Object.keys(_boxSnapTimers)) {
    clearTimeout(_boxSnapTimers[bid]); delete _boxSnapTimers[bid];
    const ed = _notesEditorOf(bid);
    if (ed) snapshotBoxNow(bid, ed);
  }
  const redo = kind === 'redo';
  const sec = (typeof SECTIONS !== 'undefined') ? SECTIONS[activeSection] : null;
  const epicId = sec ? sec.activeNotesEpic : null;
  const list = redo ? _notesTimelineRedo : _notesTimeline;
  while (list.length) {
    const step = list[list.length - 1];
    if (step.order) {
      list.pop();
      if (!epicId || step.order.epicId !== epicId) continue;   // a chapter no longer open: stale
      const left = restoreNotesBoxOrder(epicId, step.order.ids, redo ? 'order redone' : 'order undone');
      if (left) (redo ? _notesTimeline : _notesTimelineRedo).push({ order: { epicId, ids: left } });
      return true;
    }
    const ed = _notesEditorOf(step.box);
    if (!ed || !((redo ? _boxRedo : _boxUndo)[step.box] || []).length) { list.pop(); continue; }   // box gone / nothing left: stale
    if (redo) notesRedo(step.box, ed); else notesUndo(step.box, ed);   // takes the step off the list itself
    return true;
  }
  const ed = (typeof _lastFocusedNotesEditor !== 'undefined') ? _lastFocusedNotesEditor : null;
  if (!ed || !document.body.contains(ed) || !ed.dataset || !ed.dataset.boxId) return false;
  if (redo) notesRedo(ed.dataset.boxId, ed); else notesUndo(ed.dataset.boxId, ed);
  return true;
}
// ui.js knows only this hook, not the editor globals.
window.__ttNotesUndoHook = notesUndoKey;

;
// ==== FILE: js/notes/notes-scene-measure.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, loaded
// BEFORE notes-render.js, ONE shared global scope (function/var -> window). Kept
// DOM-free + dependency-free so it is unit-testable in plain Node
// (test-scene-measure.mjs) and reachable by bare name from notes-render.js.
// Module: notes-scene-measure.js
//
// WHAT: the SYNC, hash-free "how big will this box actually store" measure that
// the per-box size meter + the pre-save cap-guard both consume.
//
// WHY: a notes box is stored as ONE Firestore doc, but cloud-store /save first
// EXTERNALIZES every inline ```excalidraw scene into its OWN sibling scene doc
// (diagram-scene.js externalizeScenes) and leaves a tiny ```excalidraw-ref fence
// in the box. So the box doc that ACTUALLY gets stored is text + refs, NOT the
// raw inline blob. A rich diagram embeds raster images as base64 data-URIs, so
// ONE diagram is ~900KB inline yet ~55 bytes once externalized. Measuring the
// inline blob (what the meter used to do) falsely tripped the RED "too much text"
// warning AND blocked the save for a diagram-only box that was perfectly
// saveable. This measure reports the POST-externalize size instead.
//
// HOW: this MIRRORS externalizeScenes' line-scan EXACTLY - same '```excalidraw'
// opener (matched by trimmed line), same '```' closer, same "an unterminated
// fence stays inline verbatim" rule - but SYNC and WITHOUT hashing (we need only
// the byte SIZE, never the real SHA). The ref fence is
// `\`\`\`excalidraw-ref\n<32 hex>\n\`\`\``; the hash is ALWAYS exactly 32 chars,
// so a 32-char placeholder yields a BYTE-IDENTICAL box-doc size. A Node parity
// test (test-scene-measure.mjs) asserts this measure agrees byte-for-byte with
// the canonical externalizeScenes, so the two can never silently drift - the same
// protection philosophy as diagram-scene.js's own byte-identical drift guard.
// ==========================================================================

const _SM_OPEN_INLINE = '```excalidraw';
const _SM_CLOSE = '```';
// The exact bytes externalizeScenes emits to replace a scene: an opener line, a
// 32-hex hash line, a closer line. A fixed 32-char placeholder measures identical.
const _SM_REF_FENCE = '```excalidraw-ref\n' + '0'.repeat(32) + '\n```';
const _SM_ENC = (typeof TextEncoder !== 'undefined') ? new TextEncoder() : null;
function _smByteLen(s) { return _SM_ENC ? _SM_ENC.encode(s || '').length : (s || '').length; }

// ── Image-externalize MIRROR (of diagram-images.js externalizeSceneImages) ──────
// A scene body's base64 `files` images are pulled out to Storage on save (Agent I's
// diagram-images.js), leaving a tiny `ref` in place - so the STORED scene body (= the
// per-scene-doc size = maxSceneBytes) is POST-image-externalize, not the base64 blob.
// This classic script can't import the ESM diagram-images.js, so it MIRRORS the
// transform (same reason it mirrors externalizeScenes): JSON.parse -> swap each files
// entry's `dataURL` -> `ref` key-position-preserving, value "<32-char placeholder>.<ext>"
// (the real hash is ALWAYS 32 hex -> byte-identical size; no hashing -> stays SYNC) ->
// JSON.stringify. The test-scene-measure parity test asserts this equals the REAL
// externalizeContentImages -> externalizeScenes byte-for-byte. `boxContent` is UNCHANGED
// (the box already stores only scene refs, never base64). MUST match diagram-images.js.
const _SM_IMAGE_MIME_EXT = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/gif': 'gif', 'image/webp': 'webp', 'image/svg+xml': 'svg' };
const _SM_DATA_URI_RE = /^data:([^;,]+)(;[^,]*)?;base64,(.*)$/s;   // mirrors diagram-images dataUrlToBytes
// Rebuild a files entry swapping ONE key at the SAME position (key-position-preserving,
// mirrors diagram-images _swapEntryKey) so the stringified byte size matches the real transform.
function _smSwapKey(entry, fromKey, newKey, newVal) {
  const out = {};
  for (const k of Object.keys(entry)) { if (k === fromKey) out[newKey] = newVal; else out[k] = entry[k]; }
  return out;
}
// The scene body AS STORED after image-externalization (feeds maxSceneBytes). Pure + sync.
function _smExternalizeImages(bodyStr) {
  let scene;
  try { scene = JSON.parse(bodyStr); } catch (_) { return bodyStr; }   // not JSON -> as-is (mirrors externalizeSceneImages)
  const files = scene && scene.files;
  if (!files || typeof files !== 'object') return bodyStr;
  let changed = false;
  for (const fileId of Object.keys(files)) {
    const entry = files[fileId];
    if (!entry || typeof entry !== 'object') continue;
    const m = _SM_DATA_URI_RE.exec(String(entry.dataURL == null ? '' : entry.dataURL));
    if (!m) continue;                                             // already a ref / non-data URL -> leave (mirrors dataUrlToBytes==null)
    const mime = String(entry.mimeType || m[1] || '').trim().toLowerCase();
    const ext = _SM_IMAGE_MIME_EXT[mime];
    // Measure-only pass-through on an UNSUPPORTED mime (the REAL extFromMime throws, which the
    // save surfaces loudly; the meter must never crash). Parity is asserted on supported mimes.
    if (!ext) continue;
    files[fileId] = _smSwapKey(entry, 'dataURL', 'ref', '0'.repeat(32) + '.' + ext);
    changed = true;
  }
  return changed ? JSON.stringify(scene) : bodyStr;
}

// Given a box's INLINE markdown (what the editor holds / what /load re-inlines),
// return what cloud-store will ACTUALLY store, plus the per-scene sizes:
//   boxContent    - the box doc AFTER externalization (text + ref fences). Its
//                   UTF-8 byte length is the value that must fit MAX_BOX_BYTES.
//   maxSceneBytes - the largest single scene BODY's UTF-8 byte length AFTER image
//                   externalization (base64 images -> tiny refs). Each scene body
//                   becomes its own Firestore doc, so this must fit the per-scene-doc
//                   limit; one oversized diagram is its OWN distinct failure (accurate
//                   message), unfixable by splitting text.
//   sceneCount    - number of inline scenes externalized (for diagnostics).
function measureStoredBox(md) {
  const lines = String(md == null ? '' : md).split('\n');
  const out = [];
  let maxSceneBytes = 0;
  let sceneCount = 0;
  let i = 0;
  while (i < lines.length) {
    if (lines[i].trim() === _SM_OPEN_INLINE) {
      let j = i + 1;
      const body = [];
      while (j < lines.length && lines[j].trim() !== _SM_CLOSE) { body.push(lines[j]); j++; }
      if (j >= lines.length) { out.push(lines[i]); i++; continue; }   // unterminated -> stays inline (matches externalizeScenes)
      const bodyBytes = _smByteLen(_smExternalizeImages(body.join('\n')));   // scene doc = POST-image-externalize body
      if (bodyBytes > maxSceneBytes) maxSceneBytes = bodyBytes;
      sceneCount++;
      out.push(_SM_REF_FENCE);
      i = j + 1;
    } else {
      out.push(lines[i]);
      i++;
    }
  }
  return { boxContent: out.join('\n'), maxSceneBytes: maxSceneBytes, sceneCount: sceneCount };
}

;
// ==== FILE: js/notes/notes-render.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files). VERBATIM split from notes.js.
// Module: notes-render.js
// ==========================================================================

const _boxSaveTimers = {};       // per-boxId debounce timers for content save
const _boxFlush = {};            // per-boxId flush closures — force a pending content save NOW (used by flushPendingNotesSaves before a copy reads the cloud)
// Box-height saves are coalesced: ONE debounce for the whole burst, one saveNotesMeta when it settles. A
// per-box timer (the old shape) made a layout switch of an N-box chapter fire N concurrent meta
// transactions on ONE doc - measured 7 optimistic-lock retries (400 + failed-precondition) for 9 boxes,
// final doc correct (SAVE-ERR-1, Rishabh 2026-09-21). box.height is set per box as each resize arrives;
// the timer only decides WHEN the one write goes out.
let _boxHeightsTimer = null;
let _boxHeightsSec = null;       // the section the pending write belongs to
const _boxResizeSeen = {};       // first ResizeObserver fire per box = initial layout, skipped
let _boxResizeObserver = null;   // shared ResizeObserver, recreated each render

// ── MU-1 L7 box lock: one person per box at a time ─────────────────────────
// The lock's two facts live one each side of the classic/module wall, and NEITHER is
// copied across it - a second copy is what goes stale:
//   "which box I hold"        -> HERE (_myBoxKey). presence PULLS it through
//                                window.__ttHeldBox() every time it publishes or
//                                compares. presence keeps no copy of its own.
//   "which boxes others hold" -> presence's. It PUSHES the list here through
//                                window.__ttApplyBoxLocks(locks).
// The four window hooks (classic scripts and ES modules cannot import each other):
//   window.__ttHeldBox()                 set HERE, read by presence.js.
//   window.__ttResetMyBox()              set HERE, called by presence.js's stopPresence:
//       a store/book switch tears the tracker down, so the box I held is gone. Without
//       it the stale key would be published into the NEW store and would make my own
//       re-focus a no-op (claimNotesBox early-returns on an unchanged key).
//   window.__ttPresenceBox()             set by presence.js - "my held box changed,
//       publish it NOW", called from focus/blur below so the lock does not wait for
//       presence's 20 s beat.
//   window.__ttApplyBoxLocks(locks)      set HERE, called by presence.js per snapshot
//       with [{ boxKey, name }] for every OTHER live editor holding a box.
// boxKey is the box's FIRESTORE FILE ID - the active book's prefix plus the box's
// content filename, exactly what bookName() (state.js:69) hands the files transport:
//   <bookPrefix><section>__notes__<epicId>__<boxId>.md
// Nothing shorter identifies a box: a bare box id repeats (every legacy chapter has a
// box called 'main'), and the un-prefixed filename repeats across an owner's books,
// which all share ONE presence collection - so a lock in Book A would have locked the
// same-named box in Book B. It is the real doc name, so the rule can read the book out
// of it. notesBoxKeyFor is the ONE builder: both directions (what I publish, and what I
// match a snapshot against) go through it, so the comparison is exact by construction.
let _boxLocks = [];              // [{ boxKey, name }] boxes OTHER people hold right now
let _myBoxKey = null;            // the box I have focus in (its file id), else null

function notesBoxKeyFor(sec, epicId, boxId) {
  const file = notesContentFilename(sec, epicId, boxId);
  return file ? ((typeof window !== 'undefined' && window.__ttActiveBookPrefix) || '') + file : null;
}
// The presence key for a box of the ACTIVE chapter.
function notesBoxLockKey(boxId) {
  const sec = SECTIONS[activeSection];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  return (sec && epic) ? notesBoxKeyFor(sec, epic.id, boxId) : null;
}
function notesBoxIsLocked(boxKey) {
  return !!(boxKey && _boxLocks.some(l => l.boxKey === boxKey));
}
// THE predicate every write path shares: who else is holding this box right now, by
// name (null = nobody, so a truthy answer IS "locked by someone else"). It takes the
// box by identity, not by key, so notes-persistence can ask it without knowing how a
// key is built - one lock set, one builder, one question.
function boxLockHolder(sec, epicId, boxId) {
  const lock = _boxLocks.find(l => l.boxKey === notesBoxKeyFor(sec, epicId, boxId));
  return lock ? lock.name : null;
}
// The same question asked by FILE NAME - for the one writer that holds a filename rather than a box identity (restore.js
// writes a box back through its own fetch('/save')). The key is built exactly as notesBoxKeyFor builds it.
function boxLockHolderForFile(file) {
  const key = file ? ((typeof window !== 'undefined' && window.__ttActiveBookPrefix) || '') + file : null;
  const lock = key ? _boxLocks.find(l => l.boxKey === key) : null;
  return lock ? lock.name : null;
}
// Ask presence to publish my held box now. Absent in local dev (no cloud store).
function _publishMyBox() {
  if (typeof window !== 'undefined' && typeof window.__ttPresenceBox === 'function') window.__ttPresenceBox();
}
function claimNotesBox(boxKey) {
  if (!boxKey || _myBoxKey === boxKey) return;
  _myBoxKey = boxKey;
  _publishMyBox();
}
// Release only if I still hold THIS box: moving from box A to box B fires B's focus
// before A's deferred blur check, so an unconditional release would drop B's claim.
function releaseNotesBox(boxKey) {
  if (_myBoxKey !== boxKey) return;
  _myBoxKey = null;
  _publishMyBox();
}
if (typeof window !== 'undefined') {
  window.__ttHeldBox = () => _myBoxKey;
  // Presence is tearing down with it, so this only forgets - it must not re-publish.
  window.__ttResetMyBox = () => { _myBoxKey = null; };
}

function applyNotesBoxLocks(locks) {
  _boxLocks = Array.isArray(locks) ? locks : [];
  renderNotesBoxLocks();
}
if (typeof window !== 'undefined') window.__ttApplyBoxLocks = applyNotesBoxLocks;

// Paint the current locks onto the boxes on screen. Runs on every presence snapshot,
// and again at each point a render rebuilds box DOM (fresh nodes come out unlocked).
function renderNotesBoxLocks() {
  document.querySelectorAll('#notesBoxes .notes-box[data-box-id]').forEach(node => {
    const key = notesBoxLockKey(node.dataset.boxId);
    setNotesBoxLocked(node, (key && _boxLocks.find(l => l.boxKey === key)) || null);
  });
}

// One box's locked state.
//
// The refusal is NOT one attribute. A markdown table renders every cell as its own
// contenteditable="true" host (notes-editor-parse.js:279/:305) and an explicit true on
// a descendant OVERRIDES a false ancestor - so clearing the editor alone leaves a box
// with a table fully typeable. Two layers:
//   1. beforeinput on the editor (wired once per box in renderNotesBoxes) - the PRIMARY.
//      It bubbles from the cells, so one listener covers every host inside the box, and
//      it survives every re-render because it sits on the editor, not on the content.
//   2. this sweep of the editor + every contenteditable="true" descendant - what makes
//      the box LOOK and behave locked (no caret, no drag). Content re-renders rebuild
//      those descendants, so the sweep is re-run wherever content is set; layer 1 is
//      what holds in the frame before it does.
// Both are preferred to a blur-and-warn guard, which swallows whatever was typed
// before it ran. flushSave carries the third layer: a locked box never writes.
function setNotesBoxLocked(node, lock) {
  const was = node.classList.contains('is-locked-by-other');
  if (!lock && !was) return;        // never touch a box this lock did not take
  const editor = node.querySelector('.notes-editor');
  node.classList.toggle('is-locked-by-other', !!lock);
  const existing = node.querySelector('.box-lock-label');
  if (!lock) {
    if (editor) editor.setAttribute('contenteditable', 'true');
    // Restore exactly the hosts this lock disabled - marked when it took them, so a
    // block that is contenteditable="false" by design (a diagram, a table wrapper)
    // is never turned editable by an unlock.
    node.querySelectorAll('[data-ttlockedce="1"]').forEach(el => {
      el.setAttribute('contenteditable', 'true');
      el.removeAttribute('data-ttlockedce');
    });
    if (existing) existing.remove();
    return;
  }
  if (editor) {
    editor.setAttribute('contenteditable', 'false');
    if (editor.contains(document.activeElement)) editor.blur();
  }
  node.querySelectorAll('[contenteditable="true"]').forEach(el => {
    el.setAttribute('contenteditable', 'false');
    el.setAttribute('data-ttlockedce', '1');
  });
  const label = existing || node.appendChild(Object.assign(document.createElement('div'), { className: 'box-lock-label' }));
  label.textContent = lock.name + ' is editing';
}

// Persist a box's pixel height to the meta JSON. Debounced so dragging the
// resize handle doesn't write a JSON file 60 times per second.
function persistBoxHeight(boxId, newH) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  if (!epic) return;
  const box = epic.boxes.find(b => b.id === boxId);
  if (!box) return;
  // In fit mode the height is content-driven (auto), not a user-set size — don't
  // persist it, or turning fit off would leave boxes pinned to a content height.
  // EXCEPT a "fixed height" (nofit) box, which keeps its own resizable height in Fit.
  if (notesFitMode(epic) && !box.nofit) return;   // the resolver, not the raw value: an unset fit is Fit=screen by default
  if (box.height === newH) return;
  box.height = newH;
  // A pending write for a DIFFERENT section must not be swept into this one's timer: send it now.
  if (_boxHeightsTimer && _boxHeightsSec !== sec) { clearTimeout(_boxHeightsTimer); saveNotesMeta(_boxHeightsSec); }
  else if (_boxHeightsTimer) clearTimeout(_boxHeightsTimer);
  _boxHeightsSec = sec;
  _boxHeightsTimer = setTimeout(() => {
    _boxHeightsTimer = null; _boxHeightsSec = null;
    saveNotesMeta(sec);
  }, 400);
}

// Renders all boxes for the active epic. Loads each box's content from disk
// and wires per-box autosave + outline-rebuild handlers.
// Fullscreen ONE notes box — handy for reading/editing a wide table that's
// cramped in the normal grid. Toggling the .tt-box-fs class makes the box fill
// the viewport (CSS); the live editor + its listeners are untouched (pure CSS,
// no DOM move), so editing keeps working. Esc or the ⛶ button again exits. This
// is a view-only toggle (no data write), so the read-only guard exempts .box-fs.
function _setFsBtnTitle(box, on) {
  const b = box && box.querySelector('.box-fs');
  if (b) b.title = on ? 'Exit fullscreen (Esc)' : 'Fullscreen this ' + LBL('boxNoun').toLowerCase() + ' (Esc to exit) - useful for wide tables';
}
function toggleNotesBoxFullscreen(bid) {
  const want = String(bid);
  const sel = (typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(want) : want;
  const box = document.querySelector(`.notes-box[data-box-id="${sel}"]`);
  if (!box) return;
  const on = !box.classList.contains('tt-box-fs');
  document.querySelectorAll('.notes-box.tt-box-fs').forEach(b => { b.classList.remove('tt-box-fs'); _setFsBtnTitle(b, false); });
  box.classList.toggle('tt-box-fs', on);
  _setFsBtnTitle(box, on);
  document.body.classList.toggle('tt-box-fs-active', on);
}
function exitNotesBoxFullscreen() {
  const fs = document.querySelector('.notes-box.tt-box-fs');
  if (!fs) return false;
  fs.classList.remove('tt-box-fs');
  _setFsBtnTitle(fs, false);
  document.body.classList.remove('tt-box-fs-active');
  return true;
}
// Esc exits a fullscreen box — but NOT while the Excalidraw modal is open (it
// sits above the fullscreen box and owns Esc); otherwise Esc would yank the box
// out of fullscreen from under the open editor.
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !window.__excalidrawModalOpen) exitNotesBoxFullscreen(); });

// ── Per-box share-size meter ────────────────────────────────────────────────
// A shared box's markdown is stored as ONE Firestore doc (ev_content/.../boxes/<id>),
// so it must stay under Firestore's ~1MB per-doc limit to be shareable. We track UTF-8
// BYTES (not chars) because Devanagari/emoji are 2-4 bytes each - a char count would badly
// under-estimate for Hindi content. MEDIA is NOT counted (it lives as separate files in
// Storage, served via /ev/media). Keep MAX_BOX_BYTES in sync with the server guard (eduvista.js).
const MAX_BOX_BYTES = 900_000;   // ~0.9MB, safe headroom under Firestore's 1,048,576-byte doc limit
// A single diagram's scene is stored as its OWN Firestore doc (`<prefix>__scene__<hash>.json`),
// so ONE scene body must also fit a doc. Firestore rejects a field longer than 1,048,487 bytes;
// this caps the scene body with headroom for the doc's other fields. Over this, splitting text
// cannot help - the diagram itself is too big (usually its embedded images) - so it earns its own
// accurate message instead of the misleading "too much text".
const MAX_SCENE_BYTES = 1_040_000;
function _boxByteLen(s) { try { return new TextEncoder().encode(s || '').length; } catch (_) { return (s || '').length; } }
// Renders the meter from a measure (measureStoredBox), i.e. the size the box will
// ACTUALLY store: text + tiny diagram REFS, never the raw inline scene JSON. Each
// diagram's scene lives in its own doc (like media), so a diagram never counts as
// "text" here. Two distinct hard limits give two accurate messages.
function updateBoxSizeMeter(boxId, m) {
  const box = document.querySelector(`.notes-box[data-box-id="${boxId}"]`);
  if (!box) return;
  const meter = box.querySelector('.box-size-meter');
  if (!meter) return;
  // A SINGLE diagram whose own scene doc exceeds the per-doc limit is a distinct,
  // accurate failure: splitting the box's text cannot shrink one oversized diagram.
  if (m.maxSceneBytes >= MAX_SCENE_BYTES) {
    meter.style.display = '';
    meter.style.background = '#fdeaea'; meter.style.color = '#b42318'; meter.style.border = '1px solid #f3c0bb';
    meter.textContent = '⚠ A diagram is too large to save - simplify it or use smaller images';
    meter.title = "One diagram in this " + LBL('boxNoun').toLowerCase() + " is larger than a single diagram can save (usually its embedded images are too big). Reduce the diagram's images or detail. Splitting the text will not help.";
    return;
  }
  const bytes = _boxByteLen(m.boxContent);   // the box doc as stored: text + diagram refs (scenes live in their own docs)
  const pct = bytes / MAX_BOX_BYTES;
  if (pct < 0.6) { meter.style.display = 'none'; return; }   // only surface as a box gets large
  meter.style.display = '';
  const kb = Math.round(bytes / 1024);
  if (pct >= 1) {
    meter.style.background = '#fdeaea'; meter.style.color = '#b42318'; meter.style.border = '1px solid #f3c0bb';
    meter.textContent = '⚠ Too much text to save - split it with ' + LBL('addBox') + ' (your writing stays on screen)';
    meter.title = 'This ' + LBL('boxNoun').toLowerCase() + ' has more writing than one ' + LBL('boxNoun').toLowerCase() + ' can save. Move some of the text into a new ' + LBL('boxNoun').toLowerCase() + ' (' + LBL('addBox') + '). Media (images / PDF / video) is not counted.';
  } else if (pct >= 0.8) {
    meter.style.background = '#fef6e7'; meter.style.color = '#8a5a00'; meter.style.border = '1px solid #f4dca6';
    meter.textContent = `Text ~${kb} KB - getting large, split with + Add Box`;
    meter.title = 'This ' + LBL('boxNoun').toLowerCase() + ' is getting large. Split long parts into a new ' + LBL('boxNoun').toLowerCase() + ' (' + LBL('addBox') + ') so it keeps saving. Media is not counted.';
  } else {
    meter.style.background = '#f2efe8'; meter.style.color = '#6b6459'; meter.style.border = '1px solid #e5e0d6';
    meter.textContent = `Text ~${kb} KB`;
    meter.title = 'The amount of writing (text) in this ' + LBL('boxNoun').toLowerCase() + '. Media (images / PDF / video) is not counted.';
  }
}

async function renderNotesBoxes() {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  const wrap = document.getElementById('notesBoxes');
  if (!wrap || !epic) return;
  // A VIRTUAL shared (read-access) chapter renders READ-ONLY from the live snapshot
  // (ev_content) via a dedicated path with NO autosave wiring. Branch HERE (not only
  // in openNotesEpic) so EVERY re-render trigger - the Fit toggle, a resize, a
  // refresh - keeps the read-only content. Otherwise the editable loader below reads
  // /load from the RECIPIENT store (where the shared bytes never exist) and blanks the
  // box (the "Fit -> content disappears" bug).
  if (epic._sharedVirtual && typeof renderSharedEpicBoxes === 'function') {
    return renderSharedEpicBoxes(sec, epic);
  }
  wrap.oncontextmenu = null;   // editable chapter: drop any shared-chapter right-click (Hide) handler left on #notesBoxes
  wrap.dataset.sharedEpicId = '';   // and clear the shared-render marker so returning to a shared chapter re-renders
  // A re-render replaces all box nodes, so any fullscreen box is destroyed —
  // clear the page scroll-lock so it can't linger and freeze scrolling.
  document.body.classList.remove('tt-box-fs-active');
  // Set layout on the grid wrapper
  wrap.dataset.layout = epic.layout || 'stack';
  // Fit: 'content' (each box as tall as its content, a row as tall as its tallest box) | '' (off).
  // CSS keys off [data-fit="content"].
  wrap.dataset.fit = notesFitMode(epic);
  // Build DOM first so we can immediately wire handlers; fill content asynchronously.
  // The box itself listens for dragover/drop so dropping ANYWHERE on the box
  // (not just on a 20px handle) places the dragged box. The handle owns
  // `draggable="true"` so dragging starts from there — keeps the editor
  // free to handle normal text selection without the browser starting a drag.
  const _bnl = LBL('boxNoun').toLowerCase();   // UI-A-2: one word per mode in every tooltip below
  wrap.innerHTML = (epic.boxes || []).map(b => {
    const bid = esc(b.id);
    // Apply persisted height as an inline style so the box opens at the size
    // the user last left it. Falls back to layout-specific min-height in CSS.
    const heightStyle = b.height ? ` style="height:${b.height}px"` : '';
    // The SLOT is the grid item; the box sits inside it. In Fit the slot keeps the text's height on the page while
    // the box is a sticky screen-tall card inside it (notes-fit-window.js); otherwise the slot is just the box's size.
    return `
    <div class="notes-slot${b.full ? ' notes-slot--full' : ''}">
    <div class="notes-box${b.full ? ' notes-box--full' : ''}" data-box-id="${bid}"
         ondragover="onBoxDragOver(event)"
         ondragleave="onBoxDragLeave(event)"
         ondrop="onBoxDrop(event,'${bid}')">
      <div class="notes-box-actions">
        <!-- groups: box · layout · text · insert · restore/delete (Rishabh 2026-09-15) -->
        <span class="box-action drag-handle" draggable="true"
              ondragstart="onBoxDragStart(event,'${bid}')"
              ondragend="onBoxDragEnd(event)"
              title="Drag to reorder">⋮⋮</span>
        <button class="box-action" onclick="moveNotesBoxBy('${bid}',-1)" title="Move up / earlier">↑</button>
        <button class="box-action" onclick="moveNotesBoxBy('${bid}',1)" title="Move down / later">↓</button>
        <button class="box-action" onclick="renameNotesBox('${bid}')" title="Rename ${_bnl} (sidebar title)">✏</button>
        <button class="box-action" onclick="allocateBoxToRoadmap('${bid}')" title="Place on the roadmap - set this ${_bnl}'s timeframe (Start date / lane / done)">🗓</button>
        <span class="box-sep" aria-hidden="true"></span>
        <button class="box-action box-fw${b.full ? ' active' : ''}" onclick="toggleNotesBoxFull('${bid}')" title="Full width - span the whole row (mix with 2/3-col: one wide ${_bnl} on top, columns below)" tabindex="-1">⬌</button>
        <button class="box-action box-nofit${b.nofit ? ' active' : ''}" onclick="toggleNotesBoxFit('${bid}')" title="Fixed height - keep this ${_bnl}'s own resizable height even when Fit is on (e.g. a tall diagram ${_bnl})" tabindex="-1">⇕</button>
        <button class="box-action box-fs" onclick="toggleNotesBoxFullscreen('${bid}')" title="Fullscreen this ${_bnl} (Esc to exit) - useful for wide tables">⛶</button>
        <span class="box-sep" aria-hidden="true"></span>
        <button class="box-action box-fmt" onmousedown="formatNotes(event,'bold')" title="Bold the selected text" tabindex="-1"><b>B</b></button>
        <button class="box-action box-fmt" onmousedown="formatNotes(event,'italic')" title="Italicize the selected text" tabindex="-1"><i>I</i></button>
        <button class="box-action box-fmt" onmousedown="formatNotes(event,'underline')" title="Underline the selected text" tabindex="-1"><u>U</u></button>
        <button class="box-action box-fmt box-head" onmousedown="openNotesHeadPop(event)" title="Heading - H1 to H4, or back to text (Ctrl+Alt+1 to 4)" tabindex="-1">H</button>
        <button class="box-action box-color" onmousedown="openNotesColorPop(event)" title="Text color" tabindex="-1"><span class="ncp-a">A</span></button>
        <button class="box-action box-align" onmousedown="alignNotes(event,'left')" title="Align left" tabindex="-1">L</button>
        <button class="box-action box-align" onmousedown="alignNotes(event,'center')" title="Align center" tabindex="-1">C</button>
        <button class="box-action box-align" onmousedown="alignNotes(event,'right')" title="Align right" tabindex="-1">R</button>
        <span class="box-sep" aria-hidden="true"></span>
        <button class="box-action" onmousedown="insertNotesTable(event,'${bid}')" title="Insert a table" tabindex="-1">⊞</button>
        <button class="box-action" onmousedown="event.preventDefault()" onclick="insertExcalidrawBlock('${bid}')" title="Insert a whiteboard" tabindex="-1">▦</button>
        <button class="box-action" onclick="insertNotesVideo('${bid}')" title="Attach a video (YouTube, Google Drive, or a direct link)">▶</button>
        <button class="box-action" onmousedown="openUploadMenu(event,'${bid}')" title="Upload a file (image or PDF) from your device" tabindex="-1">⬆</button>
        <span class="box-sep" aria-hidden="true"></span>
        <button class="box-action" onclick="openRestore('box','${bid}')" title="Restore an earlier version of this ${_bnl} (last 48h)">🕘</button>
        <button class="box-action" onclick="delNotesBox('${bid}')" title="Delete this ${_bnl}">✕</button>
        <span class="box-size-meter" data-box-id="${bid}" style="display:none;margin-left:auto;align-self:center;font-size:.72rem;padding:.12rem .45rem;border-radius:6px;white-space:nowrap"></span>
      </div>
      <div class="notes-editor" data-box-id="${bid}"${heightStyle} contenteditable="true" spellcheck="true"></div>
    </div>
    </div>`;
  }).join('');
  renderNotesBoxLocks();   // L7: the nodes above are fresh + unlocked; re-apply the live locks
  // L7: the box I held may not exist in this render (chapter switch, box deleted). A key
  // nobody can focus again would keep publishing a lock AND make re-focusing a no-op.
  if (_myBoxKey && !(epic.boxes || []).some(b => notesBoxKeyFor(sec, epic.id, b.id) === _myBoxKey)) releaseNotesBox(_myBoxKey);

  // Reset ResizeObserver — each render gets a fresh one watching only the
  // current set of editors. The "seen" map is cleared so the first fire per
  // box (initial layout) is correctly skipped.
  if (_boxResizeObserver) _boxResizeObserver.disconnect();
  Object.keys(_boxResizeSeen).forEach(k => delete _boxResizeSeen[k]);
  _boxResizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const ed = entry.target;
      const bid = ed.dataset.boxId;
      if (!bid) continue;
      if (typeof fitFrozenTableWindows === 'function') fitFrozenTableWindows(ed);   // a frozen table's window follows the editor's new height
      // Don't persist the viewport-sized height a box takes while fullscreen —
      // it'd stick after exiting. Fullscreen is a transient view state.
      if (document.body.classList.contains('tt-box-fs-active')) continue;
      // Skip the first fire per box — that's the initial layout, not a user resize
      if (!_boxResizeSeen[bid]) { _boxResizeSeen[bid] = true; continue; }
      // Persist the BORDER-box height, not contentRect.height (content-box).
      // The editor is box-sizing:border-box, so the saved value is re-applied
      // verbatim as style="height:Npx" — without this, every reload dropped the
      // ~40px padding, throwing off carefully-aligned boxes. Prefer the
      // observer's borderBoxSize (no forced layout); fall back to offsetHeight.
      const bb = (entry.borderBoxSize && entry.borderBoxSize[0] && entry.borderBoxSize[0].blockSize) || ed.offsetHeight;
      persistBoxHeight(bid, Math.round(bb));
    }
  });

  // Load each box's content in parallel, then wire handlers
  await Promise.all((epic.boxes || []).map(async (b) => {
    const editor = wrap.querySelector(`.notes-editor[data-box-id="${b.id}"]`);
    if (!editor) return;
    let content = await loadNotesContent(sec, epic.id, b.id);
    // Single-source title: a box's title IS its first # heading. Migrate a legacy
    // explicit title (box.title with no heading) into a real heading so it shows
    // in the body and becomes the one title. In-memory — persists on next save.
    if (b.title && !_firstH1(content)) content = '# ' + b.title + (content ? '\n\n' + content : '\n');
    setEditorContent(editor, content);
    updateBoxSizeMeter(b.id, measureStoredBox(content));   // post-externalize share-size on load (hidden unless large)
    // If a video upload for THIS box is still in flight (user left mid-upload and came
    // back), re-show its in-box "Uploading..." placeholder so the feedback is consistent.
    restoreUploadPlaceholders(editor, epic.id, b.id);
    // If a prior autosave conflict left a preserved (unsaved) edit for this box that
    // still differs from what's now shown, re-surface the banner (survives a re-render
    // AND a full page refresh - the stash is localStorage-backed). A token-only move
    // (structural change) left no divergence, so this never false-alarms.
    restoreConflictBanner(sec, epic.id, b.id);
    // Seed the known-images set so the FIRST save can diff against what's
    // actually in the file. Without this, deleting an image then saving
    // wouldn't realize the image was ever there.
    _boxImages[b.id] = extractImageRefs(content);
    _boxTitleCache[b.id] = _firstH1(content);
    if (_boxTitleCache[b.id]) b.title = _boxTitleCache[b.id]; else delete b.title;   // cache mirrors the heading
    initBoxUndo(b.id, editor, content);   // baseline = raw bytes (exact first undo)
    const lockKey = notesBoxKeyFor(sec, epic.id, b.id);   // L7: this box's presence key (its Firestore file id)
    // L7 layer 2, re-run: setEditorContent above just built this box's table cells, each
    // its own contenteditable="true" host, so a locked box needs the sweep again.
    if (notesBoxIsLocked(lockKey)) setNotesBoxLocked(editor.closest('.notes-box'), _boxLocks.find(l => l.boxKey === lockKey));
    // L7 layer 1, the PRIMARY refusal: beforeinput bubbles out of every editable host
    // inside the box (a table cell as much as the editor), fires before any character
    // lands, and lives on the editor - so no content re-render can strip it. Nothing
    // typed is lost: the keystroke is refused, never swallowed after the fact.
    editor.addEventListener('beforeinput', (e) => { if (notesBoxIsLocked(lockKey)) e.preventDefault(); });

    // Single saver used by oninput debounce + onblur. Computes the diff of
    // image refs against `_boxImages[b.id]` and removes sidecar files that
    // no other box still references.
    const flushSave = (silent) => {
      if (notesBoxIsLocked(lockKey)) return;        // L7: a box someone else holds never writes - the layer under every input guard
      const heldFile = notesContentFilename(sec, epic.id, b.id);
      if (heldFile && _boxHeld[heldFile]) return;   // conflict pending on this box — don't overwrite until the user reloads it
      const newContent = getEditorContent(editor);
      // Measure what cloud-store will ACTUALLY store: /save externalizes each inline
      // ```excalidraw scene into its own doc, so the box doc holds text + tiny refs and each
      // scene body is its own doc. Measure BOTH, never the raw inline blob (which counts a
      // diagram's base64 images as "text" and falsely blocks a diagram-only box).
      const stored = measureStoredBox(newContent);
      updateBoxSizeMeter(b.id, stored);   // live share-size (debounced with the save)
      // Pre-empt an un-saveable box: two independent Firestore-doc limits. At/over either we do
      // NOT attempt the write - Firestore would reject it with a raw "invalid-argument" toast;
      // the matching RED meter is the clear signal and the user's writing stays on screen.
      //  (1) the whole box doc (text + refs) must fit one doc -> "too much text, split with + Add Box".
      //  (2) each single diagram's scene doc must fit one doc  -> "diagram too large" (splitting text can't help).
      if (_boxByteLen(stored.boxContent) >= MAX_BOX_BYTES) return;
      if (stored.maxSceneBytes >= MAX_SCENE_BYTES) return;
      const newRefs = extractImageRefs(newContent);
      const oldRefs = _boxImages[b.id] || new Set();
      const dropped = [...oldRefs].filter(f => !newRefs.has(f));
      if (dropped.length) {
        // Only delete files no OTHER live box uses AND that no undo/redo state
        // of THIS box still references — else deleting an image now would break
        // a Ctrl+Z that brings it back (the file would 404 on reload).
        const stillReferenced = collectLiveImageRefs(b.id);
        const histReferenced = collectHistoryImageRefs(b.id);
        dropped
          .filter(f => !stillReferenced.has(f) && !histReferenced.has(f))
          .forEach(f => deleteImageFile(f));
      }
      _boxImages[b.id] = newRefs;
      return saveNotesContent(sec, epic.id, b.id, newContent, silent);   // return the promise so a flush can await it
    };
    _boxFlush[b.id] = flushSave;   // expose for flushPendingNotesSaves (copy-before-read)

    editor.addEventListener('focus', () => {
      _lastFocusedNotesEditor = editor;
      outlineReleasePin(b.id);  // UI-A-1: focusing another box releases the outline's click pin (same box keeps it)
      claimNotesBox(lockKey);   // publishes my presence node immediately - others see the lock now
    });
    editor.oninput = () => {
      renumberNotesListsAtCaret(editor);   // a deleted / pasted / moved list item never leaves "1. 3. 4." behind (notes-lists.js)
      if (_boxSaveTimers[b.id]) clearTimeout(_boxSaveTimers[b.id]);
      // The handle means "typing, autosave not fired yet" (notes-refresh.js reads it as unsaved work) - so it is
      // deleted as the debounce fires, exactly as the blur path and flushPendingNotesSaves delete it when they flush.
      _boxSaveTimers[b.id] = setTimeout(() => { delete _boxSaveTimers[b.id]; flushSave(); }, 900);
      // Shared debounced outline rebuild. The box's first # heading is its ONE
      // title, so when THIS box's heading changes: refresh the outline, mirror it
      // into the persisted cache (box.title, for outline/aggregated reads), and
      // refresh the roadmap. Only on an actual heading change — typing body text
      // mustn't churn anything.
      if (_notesOutlineTimer) clearTimeout(_notesOutlineTimer);
      _notesOutlineTimer = setTimeout(() => {
        // The cache FIRST, the outline after: the outline parser reads the heading from the editor itself, but every
        // other reader of box.title (the roadmap, aggregated reads) and the meta write must see the same heading the
        // outline is about to draw - drawing before mirroring left them one edit apart (Rishabh 2026-11-02).
        const t = _firstH1(getEditorContent(editor));
        if (t !== _boxTitleCache[b.id]) {
          _boxTitleCache[b.id] = t;
          if (t) b.title = t; else delete b.title;
          saveNotesMeta(sec);
          if (epic.roadmap && typeof renderNotesRoadmap === 'function') renderNotesRoadmap();
        }
        renderNotesOutline();
      }, 250);
      // Debounced undo checkpoint (collapses a burst of typing into one step)
      scheduleBoxSnapshot(b.id, editor);
    };
    // Ctrl+Z / Ctrl+Shift+Z (Ctrl+Y) — our own undo, since the editor's
    // self-re-render destroys the browser's native contenteditable undo.
    editor.onkeydown = (e) => {
      if (handleNotesEscapeKey(e, editor)) return;    // Esc = done typing: leave the box as a click outside does (notes-keys.js; Rishabh 2026-10-27)
      // Auto numbered lists: Enter continues / exits, Tab/Shift+Tab nest. Runs
      // before the Ctrl-shortcut block since these keys carry no Ctrl/Meta.
      // (handleNotesListKey deliberately bows out inside table cells.)
      if (handleNotesListKey(e, editor)) return;
      if (handleNotesHeadingEnterKey(e, editor)) return;   // Enter on a heading line: the next line is plain text, not a cloned heading (notes-keys.js)
      // PageDown / PageUp inside a table cell: scroll the nearest scroller that has room (table window -> box ->
      // page) and keep the caret where it is (notes-keys.js; Rishabh 2026-09-28).
      if (handleNotesPageKey(e, editor)) return;
      if (handleNotesCellNavKey(e, editor)) return;   // Up / Down / Tab between the cells of a notes table (notes-keys.js)
      if (handleNotesTabKey(e, editor)) return;       // Tab / Shift+Tab in free text = indent / outdent the line, never a focus jump (notes-keys.js)
      // Enter / Shift+Enter inside a markdown-table cell → a line break we
      // insert ourselves. The browser's default here is flaky (the cell is
      // contenteditable=true nested in a contenteditable=false block) and
      // often drops the <br> entirely, so breaks "weren't maintained". A cell
      // can't hold a real paragraph, so plain Enter and Shift+Enter behave the
      // same: both add a <br>, persisted as a literal <br> in the pipe-source.
      if (e.key === 'Enter' && !e.ctrlKey && !e.metaKey && !e.altKey) {
        const sel = window.getSelection();
        let n = sel && sel.anchorNode;
        if (n && n.nodeType === 3) n = n.parentElement;
        const cell = n && n.closest && n.closest('th[contenteditable="true"], td[contenteditable="true"]');
        if (cell && !(document.body && document.body.classList.contains('tt-readonly'))) {
          e.preventDefault();
          e.stopPropagation();
          // A HEADER is one line: Enter there adds nothing. A break at the front of a header pushed its text a
          // line down and the header read as misaligned against its neighbours (Rishabh 2026-10-15, 'Status').
          if (cell.tagName === 'TH') return;
          insertCellLineBreak(cell);
          // bubbling input → cell listener (rebuilds data-source) + editor autosave
          cell.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
      }
      const mod = e.ctrlKey || e.metaKey;
      if (!mod) return;
      // Ctrl+Alt+1..4 -> H1..H4 on the caret's line. Ctrl+1..8 and Ctrl+H are Chrome's own (tab N / history), so the
      // free chord is used (Rishabh 2026-09-24: "jo free hai use that"). e.code, so a non-US layout still maps.
      if (e.altKey && /^Digit[1-4]$/.test(e.code)) {
        e.preventDefault(); e.stopPropagation();
        headNotes(+e.code.slice(5));
        return;
      }
      // Ctrl+Z / Ctrl+Y with the caret in this box: the chapter's latest step, whatever its kind (notes-undo.js
      // notesUndoKey) - a box move taken back / forward counts too, not only this box's own text (2026-10-28: the
      // second Ctrl+Y after an undo that put the caret back in the box found "Nothing to redo" while the move waited).
      if (e.key === 'z' || e.key === 'Z') {
        e.preventDefault(); e.stopPropagation();
        notesUndoKey(e.shiftKey ? 'redo' : 'undo');
      } else if (e.key === 'y' || e.key === 'Y') {
        e.preventDefault(); e.stopPropagation();
        notesUndoKey('redo');
      } else if (e.key === 'a' || e.key === 'A') {
        // Ctrl+A inside a table cell selects only THAT cell's text. Without
        // this the browser selects the whole contenteditable=false block.
        const sel = window.getSelection();
        let n = sel && sel.anchorNode;
        if (n && n.nodeType === 3) n = n.parentElement;
        const cell = n && n.closest && n.closest('th[contenteditable="true"], td[contenteditable="true"]');
        if (cell) {
          e.preventDefault(); e.stopPropagation();
          const r = document.createRange();
          r.selectNodeContents(cell);
          sel.removeAllRanges();
          sel.addRange(r);
        }
      }
    };
    editor.onblur = () => {
      // DURABILITY — runs synchronously on every blur, exactly like the old
      // handler, so a "type → click a cell → close the tab" sequence can't lose
      // the edit (the rAF below would be dropped by an immediate page unload).
      // The save is SILENT: the 900ms typing debounce is what surfaces the
      // "✓ Notes saved" toast, and firing it again on every blur — including
      // clicking from free text into a table cell, or clicking out of a
      // read-only box — was the spurious "saved popup on every click".
      if (_boxSaveTimers[b.id]) { clearTimeout(_boxSaveTimers[b.id]); delete _boxSaveTimers[b.id]; }
      if (_boxSnapTimers[b.id]) { clearTimeout(_boxSnapTimers[b.id]); delete _boxSnapTimers[b.id]; }
      snapshotBoxNow(b.id, editor);   // capture the final edit as an undo checkpoint
      flushSave(true);                // silent save — no toast

      // L7: give the box back only once focus has GENUINELY left it. A blur also fires
      // when focus moves into a table cell INSIDE this same box (cells are their own
      // contenteditable hosts) and when the OS window loses focus - the person is still
      // in the box, so the lock must hold. document.activeElement is authoritative one
      // frame later, the same reason the re-render below defers.
      requestAnimationFrame(() => {
        if (editor.isConnected && editor.contains(document.activeElement)) return;
        releaseNotesBox(lockKey);
      });

      // SCROLL-JUMP FIX — the re-render is the dangerous part: setEditorContent
      // rebuilds every .md-table-scroll and resets its scrollLeft to 0. A `blur`
      // fires not only when the user truly leaves, but ALSO when focus moves to
      // a table cell INSIDE this same editor (cells are independent
      // contenteditable hosts), and when the OS window loses focus (clicking the
      // Windows taskbar). Re-rendering then would snap a right-scrolled wide
      // table back to the left and destroy the just-clicked cell — the real
      // "I can't click a right-side cell" bug. So defer one frame and re-render
      // ONLY once focus has genuinely left the editor (document.activeElement is
      // authoritative next frame; blur's relatedTarget is unreliable for clicks).
      // The re-render only recollapses URL pills — purely cosmetic — so deferring
      // it (and skipping it while focus stays inside) loses nothing.
      requestAnimationFrame(() => {
        if (!editor.isConnected) return;                       // box was torn down
        if (editor.contains(document.activeElement)) return;   // focus still inside (e.g. a table cell)
        // OQ1 (background upload): the uploading placeholder carries NO data-file, so
        // getEditorContent drops it — re-rendering now would wipe it, and the finished
        // upload would then find no placeholder to swap and DELETE the just-uploaded
        // video (looked like "clicking outside cancels the upload"). The re-render is
        // purely cosmetic, so skip it while an upload is in flight; the swap on
        // completion dispatches its own input, and the next blur re-renders cleanly.
        if (editor.querySelector('.vfb-uploading')) return;
        // ITEM 4 (Rishabh 2026-09-18): rebuild ONLY when the content changed since this editor was last
        // rendered. The rebuild exists to recollapse URL pills typed as plain text - when nothing was typed
        // there is nothing to recollapse, and the full setEditorContent tore down every excalidraw / table /
        // video block on every click-out (the "diagram disappears and re-renders" flicker). Same content ->
        // no DOM pass at all. Changed content -> rebuild exactly as before (the pills recollapse with it).
        const liveContent = getEditorContent(editor);
        if (liveContent === _editorRendered.get(editor)) return;
        setEditorContent(editor, liveContent);
        // The rebuild just handed this box fresh contenteditable="true" table cells;
        // if a lock arrived while I was inside it, re-run the sweep (L7 layer 2).
        if (notesBoxIsLocked(lockKey)) setNotesBoxLocked(editor.closest('.notes-box'), _boxLocks.find(l => l.boxKey === lockKey));
      });
    };
    // Paste handling, in priority order:
    //  1) an image → upload + insert <img> at the cursor (existing behavior);
    //  2) tabular data (HTML <table>, markdown pipe-rows, or TSV from Excel/
    //     Sheets) → insert a real markdown table block. A table can't nest in a
    //     cell, so it's appended as a new block at the end of the box;
    //  3) anything else → default paste (plain text).
    // Where the pasted text lands decides its line-break form. A table CELL is one line of the pipe model whose
    // breaks are literal <br> elements (cellToMarkdown); a newline character inserted there is just whitespace
    // and read back as a space (Rishabh 2026-10-14: a multi-line cell pasted into another cell came out as one
    // line). Free text takes the newline as the line divider (setEditorContent's per-line render).
    const caretCell = () => {
      const sel = window.getSelection();
      let n = sel && sel.rangeCount ? sel.anchorNode : null; if (n && n.nodeType === 3) n = n.parentElement;
      return n && n.closest ? n.closest('.md-table-block td, .md-table-block th') : null;
    };
    const insertPastedText = (text) => {
      if (!text) return;
      try {
        if (caretCell()) document.execCommand('insertHTML', false, escapeHtmlForEditor(text).replace(/\r?\n/g, '<br>'));
        else document.execCommand('insertText', false, text);
      } catch (_) {}
    };
    editor.onpaste = (e) => {
      const items = e.clipboardData && e.clipboardData.items;
      if (items) {
        for (const item of items) {
          if (item.type && item.type.startsWith('image/')) {
            e.preventDefault();
            const blob = item.getAsFile();
            if (!blob) return;
            insertImageAtCursor(editor, sec, epic.id, b.id, blob, item.type, 'pasted');
            return;
          }
        }
      }
      // Ctrl+Shift+V → paste as plain text: insert the clipboard text verbatim,
      // bypassing the table auto-conversion (and any HTML injection).
      if (typeof window.consumePlainPaste === 'function' && window.consumePlainPaste()) {
        const plain = (e.clipboardData && e.clipboardData.getData('text/plain')) || '';
        if (plain) { e.preventDefault(); insertPastedText(plain); }
        return;
      }
      // A copied / cut WHITEBOARD (its ```excalidraw fence as text, excalidraw.js copyExcalidrawBlock) lands as a
      // rendered block right below the caret line - same or another box (Rishabh 2026-10-16: Copy / Cut / paste
      // for a whiteboard like the table's).
      const plainText = (e.clipboardData && e.clipboardData.getData('text/plain')) || '';
      if (/^\s*```excalidraw\r?\n[\s\S]*\r?\n```\s*$/.test(plainText)) {
        e.preventDefault();
        insertExcalidrawFenceAtCaret(editor, plainText.trim().replace(/\r/g, ''));
        showToast('✓ Whiteboard pasted');
        return;
      }
      const rows = parseClipboardTable(e);
      if (rows && rows.length && Math.max(...rows.map(r => r.length)) >= 2) {
        e.preventDefault();
        // Capture whether the caret was in an existing table BEFORE the
        // re-render wipes the selection — only affects the toast wording.
        const sel = window.getSelection();
        let n = sel && sel.anchorNode; if (n && n.nodeType === 3) n = n.parentElement;
        const inCell = !!(n && n.closest && n.closest('.md-table-block'));
        const tableMd = tableArrayToMarkdown(rows);
        // The table lands right BELOW the line the caret is on (Rishabh 2026-10-16: "tables always get pasted at the
        // end of the box"): its pipe rows go in as lines after that one, the re-render turns them into the grid, and
        // the new block is the one that follows the blocks already above the caret. From inside a cell (a table
        // cannot nest) or with no caret line: at the end, as before.
        const line = inCell ? null : notesEditorLineDiv(editor);
        let fresh = null;
        if (line && line.parentNode === editor && !(line.matches && line.matches('.md-table-block, .mermaid-block, .excalidraw-block, .video-embed-block, .video-link-block, .pdf-embed-block, .pdf-link-block, .video-file-block'))) {
          let blocksAbove = 0;
          for (let x = line.previousElementSibling; x; x = x.previousElementSibling) if (x.classList && x.classList.contains('md-table-block')) blocksAbove++;
          const frag = document.createDocumentFragment();
          if ((line.textContent || '').trim()) frag.appendChild(document.createElement('div')).appendChild(document.createElement('br'));   // a blank line between the text and the table
          tableMd.split('\n').forEach((row) => { const d = document.createElement('div'); d.textContent = row; frag.appendChild(d); });
          frag.appendChild(document.createElement('div')).appendChild(document.createElement('br'));   // and one below, to type on
          editor.insertBefore(frag, line.nextSibling);
          setEditorContent(editor, getEditorContent(editor));   // pipe rows -> the editable grid
          fresh = editor.querySelectorAll('.md-table-block')[blocksAbove] || null;
        } else {
          const cur = getEditorContent(editor).replace(/\n+$/, '');
          setEditorContent(editor, (cur ? cur + '\n\n' : '') + tableMd + '\n');
          const blocks = editor.querySelectorAll('.md-table-block');
          fresh = blocks[blocks.length - 1] || null;
        }
        // Auto-fit the just-pasted table so a wide paste lands content-fit instead of squeezed - same default as + Col.
        if (fresh) { autoFitNotesTableColumns(fresh, true); if (typeof placeNotesTableCaret === 'function') placeNotesTableCaret(fresh, fresh.querySelector('tbody tr') ? { ri: 0, ci: 0 } : { ri: -1, ci: 0 }); }
        editor.dispatchEvent(new Event('input'));
        showToast(inCell ? '✓ Pasted as a new table below (a table can’t nest in a cell)' : '✓ Pasted as a table');
        return;
      }
      // Plain rich text/HTML (not an image, not Ctrl+Shift+V, not a table):
      // convert to the editor's markdown so list/heading/line structure survives
      // the round-trip (raw <ul>/<li>/<h*> would collapse to a run-on line), and
      // inline color/style is dropped. Insert as text at the caret; the blur
      // re-render then formats the markdown.
      const html = e.clipboardData && e.clipboardData.getData('text/html');
      const plain = (e.clipboardData && e.clipboardData.getData('text/plain')) || '';
      if (html) {
        e.preventDefault();
        insertPastedText(htmlToMarkdown(html) || plain);
        editor.dispatchEvent(new Event('input'));
        return;
      }
      // Plain text only (a terminal, a plain editor): the browser's own paste would put raw newlines into a
      // cell; the same cell rule applies.
      if (plain && caretCell()) {
        e.preventDefault();
        insertPastedText(plain);
        editor.dispatchEvent(new Event('input'));
      }
    };

    // Drag-and-drop image files (from File Explorer / desktop) onto the
    // editor. Skips the drop event if it's the box-reorder drag (which
    // doesn't carry Files in dataTransfer).
    editor.ondragover = (e) => {
      const types = e.dataTransfer && e.dataTransfer.types;
      if (!types || ![...types].includes('Files')) return; // not a file drag
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      editor.classList.add('drag-active');
    };
    editor.ondragleave = () => { editor.classList.remove('drag-active'); };
    editor.ondrop = async (e) => {
      editor.classList.remove('drag-active');
      const files = e.dataTransfer && e.dataTransfer.files;
      if (!files || files.length === 0) return; // let other handlers run (e.g. text-drag)
      e.preventDefault();
      e.stopPropagation(); // don't trigger the box-reorder drop on the parent
      // Position the cursor at the drop point so each insertion lands where
      // the user actually dropped (instead of at the previous cursor spot).
      const range = document.caretRangeFromPoint
        ? document.caretRangeFromPoint(e.clientX, e.clientY)
        : null;
      if (range) {
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
      editor.focus();
      for (const file of Array.from(files)) {
        if (file.type && file.type.startsWith('image/')) {
          await insertImageAtCursor(editor, sec, epic.id, b.id, file, file.type, 'dropped');
        }
      }
    };
    // Start observing this editor for resize-handle drags
    _boxResizeObserver.observe(editor);
  }));
  notesFitWindowSync();   // Fit: each box a sticky screen-tall card over its content-tall slot (notes-fit-window.js)
}



;
// ==== FILE: js/notes/notes-fit-window.js ====
// ── Fit: the box as a sticky window over a content-tall slot (notes-fit-window.js) ─────────────────────────────────
// Rishabh 2026-10-27 19:5x ("C"): a Fit box keeps its CONTENT's height on the page - the page is as long as the text,
// a row as tall as its tallest box - while its CARD is a screen-tall window (styles.css [data-fit="content"]:
// position sticky, max-height the screen, overflow-y auto) that sticks to the top of the screen while the box's
// range passes. Two things make that true, both here:
//   1. the SLOT: each box sits in its own grid item, <div class="notes-slot"> (notes-render.js / shared-read.js);
//      in Fit the slot's min-height = the text's height, so the box occupies its text's height on the page while the
//      card (capped at the screen) travels inside the slot as sticky; kept current as the text, its images or the
//      window change. (A sticky element cannot travel inside its own margin box - RUN 2026-10-27 - hence the slot.)
//   2. the SYNC: the page's scroll, while the card is stuck, moves the text inside the card by the same distance
//      (so scrolling the page through a long box reads it, and at its end the card travels on); the card's own
//      scrollbar / a wheel over it move only the text (the page and the boxes beside it stay put).
// Plus the thumb gate: the card's scrollbar thumb paints only while the pointer is in that box (.notes-box--pointer
// - a class, not :hover, because Chrome never repaints a ::-webkit-scrollbar part when its scroller's :hover changes).
//
// Public (classic global scope):
//   notesFitWindowSync() - after a render of #notesBoxes (editable or shared read view): takes the Fit boxes under
//                          management (or releases them when Fit is off) and sizes their slots.
//   notesFitWindowJump(scroller, innerTop, pageTop) - a JUMP (an outline click, notes-outline.js): the page and the
//                          text inside a card move together to a chosen place, without the sync undoing it.

const NFW_CARD_TOP = 8;   // px - styles.css `top: 8px` on the sticky card; "stuck" = the card's top sits here

const _nfw = { boxes: new Set(), lastY: 0, raf: 0, ro: null, mo: null, pointerBox: null };

function notesFitWindowSync() {
  const wrap = document.getElementById('notesBoxes');
  if (!wrap) return;
  const fit = wrap.dataset.fit === 'content';
  _nfw.boxes.clear();
  for (const box of wrap.querySelectorAll('.notes-box')) {
    const slot = box.closest('.notes-slot');
    if (!slot) throw new Error('notes: a box has no .notes-slot around it (notes-render.js / shared-read.js render one per box)');
    if (!fit || box.classList.contains('notes-box--nofit')) { slot.style.minHeight = ''; continue; }
    _nfw.boxes.add(box);
  }
  _nfwObserve(wrap);
  _nfw.lastY = window.scrollY;
  _nfwKick();
}

// Observers, wired once: the page scroll (the sync), the window / an editor resizing and the text changing (the slot).
function _nfwObserve(wrap) {
  if (!_nfw.ro) {
    _nfw.ro = new ResizeObserver(_nfwKick);
    _nfw.mo = new MutationObserver(_nfwKick);
    window.addEventListener('scroll', _nfwScroll, { passive: true });
    window.addEventListener('resize', _nfwKick);
    document.addEventListener('pointerover', (e) => _nfwPointer(e.target.closest && e.target.closest('.notes-box')));
    document.addEventListener('pointerout', (e) => { if (!e.relatedTarget) _nfwPointer(null); });   // the pointer left the window
  }
  _nfw.ro.disconnect();
  _nfw.mo.disconnect();
  for (const box of _nfw.boxes) for (const ed of box.querySelectorAll('.notes-editor')) _nfw.ro.observe(ed);
  if (_nfw.boxes.size) _nfw.mo.observe(wrap, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['src', 'style', 'class'] });
}

function _nfwKick() {
  if (!_nfw.raf) _nfw.raf = requestAnimationFrame(_nfwSlot);
}

// The slot: its min-height = the text's height (the box's scroll height plus its border), so the box keeps that
// room on the page while the card inside is capped. (A box whose text fits the screen gets a slot its own size.)
function _nfwSlot() {
  _nfw.raf = 0;
  for (const box of _nfw.boxes) {
    if (!box.isConnected) { _nfw.boxes.delete(box); continue; }
    const want = (box.scrollHeight + box.offsetHeight - box.clientHeight) + 'px';
    const slot = box.closest('.notes-slot');
    if (slot.style.minHeight !== want) slot.style.minHeight = want;
  }
}

// The sync: a page scroll while a card is stuck moves the card's text by the same distance. The browser clamps
// scrollTop at the text's ends, where the card then travels with the page (sticky's own doing).
function _nfwScroll() {
  const y = window.scrollY;
  const dy = y - _nfw.lastY;
  _nfw.lastY = y;
  if (!dy) return;
  for (const box of _nfw.boxes) {
    if (box.scrollHeight - box.clientHeight <= 0) continue;
    const top = box.getBoundingClientRect().top;
    if (Math.abs(top - NFW_CARD_TOP) <= 1) box.scrollTop += dy;
  }
}

// A JUMP: the page goes to pageTop and the text inside `scroller` to innerTop - the outline's click (a heading, a box).
// While a card is STUCK, the sync above writes every page-scroll delta into the card's scrollTop, and a scrollTop write
// cancels a scroll the card is in the middle of - so an outline click on a stuck card moved the page a few px and left
// the text where it was (Rishabh 2026-10-28 prod: "Home Applications pe click, navigate nahi hota"; RUN: page 20px,
// text 54 -> 32, heading 2767px down). Here the page moves in ONE step with lastY set to the landing first, so the
// sync sees no delta for it, and only then does the text travel - smoothly, on a card the sync now leaves alone until
// the person scrolls. A scroller the sync does not manage (Fit off: the editor; Fit to height: nothing) keeps the
// smooth page scroll - nothing writes into it mid-way.
function notesFitWindowJump(scroller, innerTop, pageTop) {
  const managed = _nfw.boxes.has(scroller);
  window.scrollTo({ top: pageTop, behavior: managed ? 'auto' : 'smooth' });
  if (managed) _nfw.lastY = window.scrollY;   // the landing (clamped by the page), so the sync's next delta is 0
  scroller.scrollTo({ top: Math.max(0, innerTop), behavior: 'smooth' });
}

function _nfwPointer(box) {
  if (box === _nfw.pointerBox) return;
  if (_nfw.pointerBox) _nfw.pointerBox.classList.remove('notes-box--pointer');
  if (box) box.classList.add('notes-box--pointer');
  _nfw.pointerBox = box;
}

;
// ==== FILE: js/notes/notes-keys.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. <script src> in index.html, fixed
// order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files).
// Module: notes-keys.js - PageDown / PageUp while the caret is in a notes table
// cell. The browser's default moves the caret a screen down inside the nearest
// scrollable ancestor it picks - for a cell nested in a contenteditable=false
// block that is the PAGE, so the whole page jumped while the table stayed
// (Rishabh 2026-09-28: "table, then box, then screen"). Pre-existing: no
// PageDown handling ever existed in public/js.
// ==========================================================================
// PageDown / PageUp scroll the container the caret is IN and stay there, both directions (Rishabh 2026-09-30:
// in a cell the key moved down inside the table but PageUp escaped to the page; in the box's text both keys
// scrolled the page, never the box). The container = the innermost element around the caret that actually
// scrolls in this mode: the table's own window (a frozen header) when the caret is in a cell, else the box's
// scroller (the editor with Fit off, the box - a sticky screen-tall card - with Fit on). AT ITS END the key hands on to the PAGE (Rishabh
// 2026-10-11: the box's bar at its top, the box's top cut off above the viewport, PageUp did nothing - the box was
// already at its top and the page never moved): one more press scrolls the page a screen in the same direction.
// Before the end it stays inside (the 2026-09-30 complaint - keys escaping to the page mid-table - does not return,
// because the hand-on happens only when the inner scroller has nothing left in that direction). A box with no
// scroller of its own (expanded, the page scrolls) is the page from the start. The caret stays where it is - only
// the view moves.
function handleNotesPageKey(e, editor) {
  if (e.key !== 'PageDown' && e.key !== 'PageUp') return false;
  if (e.ctrlKey || e.metaKey || e.altKey) return false;
  if (e.shiftKey) return false;   // Shift+PageUp / Down = extend the selection by a screen - the browser's own, never swallowed (Rishabh 2026-10-16)
  const sel = window.getSelection();
  let n = sel && sel.anchorNode;
  if (n && n.nodeType === 3) n = n.parentElement;
  if (!n || !editor.contains(n)) return false;
  const cell = n.closest && n.closest('.md-table-block th, .md-table-block td');
  // A scroller = an element whose overflow-y actually scrolls AND that has more content than height. Content that
  // merely overflows a visible-overflow editor is NOT one (scrollBy would do nothing and the key would be lost).
  const scrolls = (el) => { if (!el || el.scrollHeight - el.clientHeight <= 0) return false; const o = getComputedStyle(el).overflowY; return o === 'auto' || o === 'scroll'; };
  // Caret in a cell of a FROZEN table (its window scrolls): the table only, both directions, stopping at its ends.
  // Caret in an unfrozen table's cell, or in the box's text: the box's own scroller - the editor (Fit off) or the
  // box card (Fit on) (Rishabh 2026-09-30: "frozen mein table, unfrozen mein box level"). A box without one (its
  // text fits the card): the PAGE - scrolled by us, not the browser, because the browser's PageUp in a nested
  // contenteditable moves the caret to the editor's start and jumps to the top (his find on :5000); we move the view
  // a screen and leave the caret.
  const tableWin = cell ? cell.closest('.md-table-scroll') : null;
  const up = e.key === 'PageUp';
  // Nothing left in this direction = hand on to the next scroller out: table -> editor / box -> page.
  const atEnd = (el) => (up ? el.scrollTop <= 0 : el.scrollTop + el.clientHeight >= el.scrollHeight - 1);
  const chain = [tableWin, editor, editor.closest('.notes-box')].filter(scrolls);
  const scroller = chain.find((el) => !atEnd(el)) || document.scrollingElement;
  e.preventDefault(); e.stopPropagation();
  scroller.scrollBy({ top: (up ? -1 : 1) * Math.round(scroller.clientHeight * 0.9) });
  return true;
}

// ── Arrow / Tab navigation between the CELLS of a notes table ─────────────────
// Each cell is its own contenteditable island inside a contenteditable=false block, so the browser's own
// ArrowDown at a cell's last line walks to the next island in DOM order - the cell to the RIGHT (Rishabh
// 2026-10-15: "cell mein Down arrow dabaya, right wale cell mein chala gaya"). A grid moves like a grid:
//   Down / Up   at the cell's last / first visual line -> the same column, one row down / up (header <-> body);
//               inside a multi-line cell the key still moves within the cell, as text does
//   Shift+Down / Shift+Up -> the browser's own: the selection grows a line inside the cell, never a hop
//   Tab / Shift+Tab -> next / previous cell in reading order (row end wraps to the next row's first cell)
// Landing = placeNotesTableCaret (the caret at the END of the cell, before a header's controls). Nothing happens at
// the grid's edges (first row up / last row down / last cell Tab): the caret stays, the page does not jump.
function handleNotesCellNavKey(e, editor) {
  const nav = e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Tab';
  if (!nav || e.ctrlKey || e.metaKey || e.altKey) return false;
  if (e.shiftKey && e.key !== 'Tab') return false;   // Shift+arrow = the selection grows a line, the browser's own (Rishabh 2026-11-02)
  const sel = window.getSelection();
  let n = sel && sel.rangeCount ? sel.anchorNode : null;
  if (n && n.nodeType === 3) n = n.parentElement;
  if (!n || !editor.contains(n)) return false;
  const cell = n.closest && n.closest('.md-table-block th, .md-table-block td');
  if (!cell) return false;
  const block = cell.closest('.md-table-block');
  const tr = cell.closest('tr');
  const rows = Array.from(block.querySelectorAll('thead tr, tbody tr'));
  const ri = rows.indexOf(tr), ci = cell.cellIndex;
  if (ri < 0) return false;
  let target = null;
  if (e.key === 'Tab') {
    const cells = Array.from(tr.cells);
    target = e.shiftKey
      ? (ci > 0 ? cells[ci - 1] : (ri > 0 ? rows[ri - 1].cells[rows[ri - 1].cells.length - 1] : null))
      : (ci < cells.length - 1 ? cells[ci + 1] : (ri < rows.length - 1 ? rows[ri + 1].cells[0] : null));
  } else {
    // Within a multi-line cell the arrow moves a line first: leave it to the browser unless the caret's line is the
    // cell's last (Down) / first (Up) one - asked of the browser's own line model (_notesCaretAtCellEdge).
    if (!_notesCaretAtCellEdge(sel, cell, e.key === 'ArrowDown' ? 1 : -1)) return false;
    const nr = rows[ri + (e.key === 'ArrowDown' ? 1 : -1)];
    target = nr ? nr.cells[Math.min(ci, nr.cells.length - 1)] : null;
  }
  e.preventDefault(); e.stopPropagation();
  if (!target) return true;   // the grid's edge: stay
  const trow = target.closest('tr');
  const land = { ri: trow.parentElement.tagName === 'THEAD' ? -1 : parseInt(trow.dataset.ri != null ? trow.dataset.ri : Array.from(trow.parentElement.children).indexOf(trow), 10), ci: target.cellIndex };
  placeNotesTableCaret(block, land);
  return true;
}

// Is the caret on the cell's first (dir -1) / last (dir +1) VISUAL line? The browser's own line model answers: the
// selection is moved one line that way and read back - still inside the cell and somewhere else = there was a line
// to go to; then the caret goes back where it was. The rects of a collapsed range cannot answer this: on an EMPTY
// line (the caret after a <br> - the blank line under "1. platform as service") a collapsed range has NO rect, and
// the fall-back to the cell's own rect read that caret as the first AND the last line at once, so Up from a blank
// line in the middle of the text jumped to the cell above (Rishabh 2026-11-02 23:45, prod). A wrapped long line, an
// empty cell, a line ending in a pill: all the browser's, none measured here.
function _notesCaretAtCellEdge(sel, cell, dir) {
  const saved = sel.getRangeAt(0).cloneRange();
  sel.modify('move', dir < 0 ? 'backward' : 'forward', 'line');
  const n = sel.anchorNode;
  const stayed = !!n && cell.contains(n) && !(n === saved.startContainer && sel.anchorOffset === saved.startOffset);
  sel.removeAllRanges(); sel.addRange(saved);
  return !stayed;
}

// ── Tab / Shift+Tab in the box's free text ───────────────────────────────────
// The browser's own Tab moves FOCUS to the next focusable thing - inside a notes box that is the first cell of the
// next table (Rishabh 2026-10-15: caret before "Physical Distribution", Tab, caret in "Year Month"). In a document
// Tab indents the line and Shift+Tab outdents it, by one list level (NOTES_LIST_INDENT), and the caret never leaves
// the box. Numbered-list lines nest through handleNotesListKey (runs first); table cells move through
// handleNotesCellNavKey; a heading line is left as it is (an indented `## x` is no heading) - the key is still
// swallowed so focus stays put.
function handleNotesTabKey(e, editor) {
  if (e.key !== 'Tab' || e.ctrlKey || e.metaKey || e.altKey) return false;
  if (document.body && document.body.classList.contains('tt-readonly')) return false;
  const sel = window.getSelection();
  let n = sel && sel.rangeCount ? sel.anchorNode : null;
  if (n && n.nodeType === 3) n = n.parentElement;
  if (!n || !editor.contains(n)) return false;
  if (n.closest && n.closest('.md-table-block, .mermaid-block, .excalidraw-block, .video-embed-block, .video-link-block, .pdf-embed-block, .pdf-link-block, .video-file-block')) return false;
  const line = notesEditorLineDiv(editor);
  e.preventDefault(); e.stopPropagation();
  if (!line || (line.classList && line.classList.contains('md-head'))) return true;
  let first = line.firstChild;
  if (!(first && first.nodeType === 3)) { if (e.shiftKey) return true; first = line.insertBefore(document.createTextNode(''), first); }
  // Changing a text node's value collapses a caret inside it to its start: read the caret first, put it back after,
  // moved by what was added / removed before it.
  const r0 = sel.getRangeAt(0); const inFirst = r0.collapsed && r0.startContainer === first; const off = inFirst ? r0.startOffset : -1;
  let delta = 0;
  if (!e.shiftKey) { first.nodeValue = NOTES_LIST_INDENT + first.nodeValue; delta = NOTES_LIST_INDENT.length; }
  else {
    const lead = (first.nodeValue.match(/^ {1,3}/) || [''])[0];
    if (!lead) return true;
    first.nodeValue = first.nodeValue.slice(lead.length); delta = -lead.length;
  }
  if (inFirst) { const r = document.createRange(); r.setStart(first, Math.max(0, Math.min(off + delta, first.nodeValue.length))); r.collapse(true); sel.removeAllRanges(); sel.addRange(r); }
  editor.dispatchEvent(new Event('input'));
  return true;
}

// ── Esc = done typing: leave the box, the way a click outside does ─────────────────────────────────────────────
// The box shows its markdown RAW while it has focus and renders it (bold, pills, tables) when focus leaves, so a
// "preview" needed a click somewhere outside (Rishabh 2026-10-27: "abhi preview ke liye bahar click karna padta hai,
// can we also press Esc?"). Esc blurs whatever is focused inside the box - the editor, or a table cell (its own
// contenteditable host) - so the blur path saves silently and re-renders exactly as a click-out does; nothing new.
// An open popover gets the key first: Esc closes the H popover, the table menu or the colour pop (none of them had
// an Escape of its own) and the caret stays; the label menu closes through ui.js; the next Esc leaves. A fullscreen box keeps its own Esc (exit fullscreen, notes-render.js) and the caret.
function handleNotesEscapeKey(e, editor) {
  if (e.key !== 'Escape') return false;
  if (document.body && document.body.classList.contains('tt-box-fs-active')) return false;
  // An open popover of the box goes first: none of them closed on Escape before, so the key closes it and keeps the caret.
  const pop = document.querySelector('#notesHeadPop.open, #notesTableMenu.open, #notesColorPop.open');
  if (pop) {
    e.preventDefault(); e.stopPropagation();
    ({ notesHeadPop: _closeNotesHeadPop, notesTableMenu: _closeNotesTableMenu, notesColorPop: _closeNotesColorPop })[pop.id]();
    return true;
  }
  if (document.querySelector('.label-ctx-menu')) return false;   // ui.js closes it on its own Escape (a capture listener)
  const a = document.activeElement;
  if (!a || !editor.contains(a)) return false;
  e.preventDefault(); e.stopPropagation();
  a.blur();
  return true;
}

// ── Enter on a heading line: the next line is plain text ──────────────────────────────────────────────────────
// The browser's Enter in a contenteditable splits the caret's <div> by CLONING it, class and all, so the line under
// `# Title` was itself a .md-head: the text typed there showed big and bold until a click-out re-rendered the box
// from its markdown (Rishabh 2026-10-27: "header pe click, Enter, type - next line is still with heading format").
// A heading is a LINE that starts `#{n} ` - the text after the caret carries no marker, so the new line is plain
// text, and the line that keeps the marker stays the heading. The split is done here, deterministically, and each
// half's look is set from its OWN text (setNotesLineClassFromText), never from what the browser would have copied.
// A selection is replaced first, as Enter does. Table cells and atomic blocks keep the browser's / their own Enter.
function handleNotesHeadingEnterKey(e, editor) {
  if (e.key !== 'Enter' || e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) return false;
  if (document.body && document.body.classList.contains('tt-readonly')) return false;
  const sel = window.getSelection();
  if (!sel || !sel.rangeCount) return false;
  const r = sel.getRangeAt(0);
  let n = r.startContainer;
  if (n.nodeType === 3) n = n.parentElement;
  if (!n || !editor.contains(n)) return false;
  if (n.closest && n.closest('.md-table-block, .mermaid-block, .excalidraw-block, .video-embed-block, .video-link-block, .pdf-embed-block, .pdf-link-block, .video-file-block')) return false;
  const line = notesEditorLineDiv(editor);
  if (!line || !line.classList.contains('md-head') || !line.contains(r.endContainer)) return false;
  e.preventDefault(); e.stopPropagation();
  if (!r.collapsed) r.deleteContents();
  const tail = document.createRange();
  tail.setStart(r.startContainer, r.startOffset);
  tail.setEnd(line, line.childNodes.length);
  const next = document.createElement('div');
  next.appendChild(tail.extractContents());
  line.after(next);
  [line, next].forEach((d) => {
    if (!d.textContent) { d.textContent = ''; d.appendChild(document.createElement('br')); }   // an empty line is <div><br></div>, one line tall, a place for the caret
    setNotesLineClassFromText(d);
  });
  setNotesCaret(next, 0);
  editor.dispatchEvent(new Event('input'));   // debounced save + undo checkpoint + outline / title refresh
  return true;
}

;
// ==== FILE: js/notes/notes-refresh.js ====
// ==========================================================================
// CLASSIC browser script - NOT an ES module. Bundled by scripts/boot-manifest.json in
// fixed order, ONE shared global scope (function/var -> window; const/let -> global
// lexical env, bare-name reachable across files).
// Module: notes-refresh.js - COMING BACK TO THE TAB, the open chapter re-reads its boxes.
// ==========================================================================
//
// WHY. What another writer did to a box - an AI agent's write_note over MCP, a co-author,
// the same person on another device - reached an already-open tab only when THIS tab tried
// to SAVE that box (the X-Note-Version token 409 -> notes-conflict.js). A person who read a
// box, went to their Claude tab, had the agent change it and came back saw the old text
// until a page refresh (Rishabh 2026-09-18: "agar MCP ke through AI agent box mein data
// change karta hai, anyway to get new data without refresh page?"). The dashboard's shelves
// already answer this on a RETURN (core.js onTabReturn, OBS-1); the notes view now does too.
// The dashboard registrar is an ES-module export and this file is a classic script, so the
// two listeners are wired here directly - the same two events, the same "visible page only".
//
// WHAT IT DOES, in order, on a return to a visible page (throttled: focus + visibilitychange
// fire together):
//   1. Only the chapter ON SCREEN (#notesBoxes laid out, no dashboard overlay over it, an editable chapter with boxes).
//   2. TYPING WINS. Any box of that chapter with unsaved work - a pending autosave debounce,
//      a save still in flight (the per-file save chain is awaited first, so a save that just
//      fired settles and refreshes its own token), or a conflict hold - means NOTHING is
//      re-rendered this time; a re-render rebuilds every box node and would drop the person's
//      unsaved keystrokes. The next return asks again. (Focus alone is NOT "unsaved": the
//      caret usually still sits in a box after an alt-tab, and that is exactly the return
//      this exists for.)
//   3. Every box's /load is fetched in parallel WITH the token this tab holds as If-None-Match:
//      the store answers 304 when that is still the version (budget-planner, Rishabh 2026-10-30:
//      one small read of the box doc, none of the scene / image docs behind it - before, every
//      return re-read every scene of every box to learn nothing had moved). Same token =
//      untouched. Token moved but the CONTENT is byte-equal to what
//      we hold = a structural / token-only move: the new token is adopted silently, exactly
//      as notes-conflict.js treats it. Token moved AND content differs = changed elsewhere.
//   4. Anything changed -> the dirty check runs once more (keystrokes may have landed during
//      the fetches) and then renderNotesBoxes() repaints the chapter through the ONE loader
//      every box already uses (title migration, undo baseline, image refs, size meter, lock
//      sweep - nothing is duplicated here), followed by one toast naming the count.
// A CHAPTER'S SHAPE (a box added or removed elsewhere) lives in notes_meta, not in a box:
// the active chapter's box list is compared too and, when it differs, the section's meta is
// reloaded before the repaint - so a box the agent created appears on the return as well.
//
// THE LISTS TOO (Rishabh 2026-09-18, "round 34 jaisa: tab pe wapas aate hi subject + chapter list bhi
// re-read"): revalidateOnReturn() is what the return now runs. In order: the SUBJECT list (sections.js
// revalidateSectionsList - sections.json re-read, adopted through the merge-response path, its toast), then
// ONE read of the active subject's notes_meta shared by the two steps that need it: the open chapter's
// BOXES (revalidateOpenNotesBoxes above, handed that read) and the subject's CHAPTER list (ids, names,
// order, type) - a chapter another writer added / renamed / removed / reordered is adopted by reloading
// the meta and repainting the chapter strip, with its own toast; the open chapter gone elsewhere routes
// the subject back through switchTab. TYPING WINS here as well: when the box step stood down for unsaved
// work, the chapter list waits for the next return too (a meta reload under a dirty box would leave the
// model ahead of the DOM). One read for both steps is what keeps a box added between two reads from
// falling through the gap.
//
// Future upgrade (Rishabh, recorded): a live Firestore onSnapshot per open box, so a change
// lands while the person is LOOKING, not only on a return.

const NOTES_RETURN_THROTTLE_MS = 1500;
let _notesReturnAt = 0;
let _notesRevalidating = null;   // the in-flight run's promise, so a second return joins it instead of racing it

function _notesBoxIsUnsaved(boxId, file, editor) {
  if (_boxSaveTimers[boxId]) return true;               // typed, autosave not fired yet
  if (file && _boxHeld[file]) return true;              // a conflict banner is up - the person resolves that first
  return false;
}

function _notesOpenChapter() {
  if (typeof SECTIONS === 'undefined' || typeof activeSection === 'undefined') return null;
  const sec = SECTIONS[activeSection];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic);
  const wrap = document.getElementById('notesBoxes');
  if (!sec || !epic || epic._sharedVirtual || epic.type === 'timeline') return null;
  if (!wrap || !wrap.isConnected || !wrap.getClientRects().length) return null;   // not what the page is showing
  if (document.body.classList.contains('tt-evlib-open')) return null;   // the dashboard overlay (#evLibrary, position:fixed) covers the book - laid out underneath, but not what the person sees
  return { sec, epic, wrap };
}

// The shape of the active chapter as notes_meta describes it - ids in order, layout, full-width flags. A shape
// change is what needs the BOXES repainted (a node per box); every other meta change repaints around them.
function _notesChapterShape(epic) {
  return (epic.layout || 'stack') + '|' + (epic.boxes || []).map(b => b.id + (b.full ? '*' : '')).join(',');
}
// EVERYTHING notes_meta holds for a chapter list, as one comparable string: every persisted key of each chapter
// and each box - the roadmap's schedule / tasks / grain / lanes / collapse live here too - keys sorted, `_`-prefixed
// (this tab's own, never persisted) keys out. Before this, a tab coming back compared only the box tokens, the
// chapter shape and the chapter list, so a roadmap card another tab had rewritten stayed stale here and this
// tab's next meta save wrote the old card back (Rishabh's BVP tasks, prod 2026-10-05 21:26 IST).
function _notesMetaSig(epics) { return notesStableJson((epics || []).filter(e => e && !e._sharedVirtual)); }   // notesStableJson: notes-persistence
// The roadmap's "typing wins": a card editor open, an inline rename, a drag, a save still assembling (B's hook).
function _roadmapHasUnsavedEdit() { return typeof nrHasUnsavedEdit === 'function' && !!nrHasUnsavedEdit(); }
// After a section's meta was reloaded from the store, the board repaints through B's hook, which also drops the
// roadmap undo steps that still hold the old copy (a Ctrl+Z would otherwise write the stale data back).
function _roadmapAfterMetaReload(secKey) {
  if (typeof nrOnMetaReloaded === 'function') nrOnMetaReloaded(secKey);
  else if (typeof renderNotesRoadmap === 'function') renderNotesRoadmap();
}

// One read of the subject's chapter list as the store holds it (null when there is none / it is unreadable).
async function _notesFetchMetaEpics(sec) {
  const metaFile = notesMetaFilename(sec);
  if (!metaFile) return null;
  try {
    const r = await fetch('/load?file=' + metaFile);
    if (!r.ok) return null;
    const json = JSON.parse((await r.text()) || '{}');
    return normalizeNotesEpics(Array.isArray(json.epics) ? json.epics : []);   // as memory holds it, so the two compare
  } catch (_) { return null; }
}
// The chapter list as the strip shows it: ids in order, names, kinds.
function _notesChapterListSig(epics) {
  return (epics || []).filter(e => e && !e._sharedVirtual).map(e => e.id + '|' + (e.name || '') + '|' + (e.type || '')).join('\u0000');
}

// `freshEpics` (optional) = the subject's chapter list already read by revalidateOnReturn; without it this reads its own.
async function revalidateOpenNotesBoxes(freshEpics) {
  if (_notesRevalidating) return _notesRevalidating;
  const run = (async () => {
    const open = _notesOpenChapter();
    if (!open) return { skipped: 'off-screen' };
    const { sec, epic, wrap } = open;
    const boxes = (epic.boxes || []).map(b => ({ b, editor: wrap.querySelector(`.notes-editor[data-box-id="${b.id}"]`), file: notesContentFilename(sec, epic.id, b.id) })).filter(x => x.editor && x.file);
    // 2. a save that already fired settles first, so its own token refresh is in place before we compare
    await Promise.all(boxes.map(x => _boxSaveChain[x.file]).filter(Boolean));
    const unsaved = boxes.find(x => _notesBoxIsUnsaved(x.b.id, x.file, x.editor));
    if (unsaved) return { skipped: 'unsaved', boxId: unsaved.b.id };
    // 3. tokens, in parallel
    const changed = [];
    await Promise.all(boxes.map(async ({ b, file }) => {
      let res;
      const heldTok = _boxVersions[file] || null;
      try { res = await fetch('/load?file=' + file, heldTok ? { headers: { 'If-None-Match': heldTok } } : undefined); } catch (_) { return; }
      if (res.status === 304) return;   // the store's version is the one this tab holds: untouched, and nothing behind the box was read
      if (!res.ok) return;
      const tok = res.headers.get('X-Note-Version') || null;
      if (tok === heldTok) return;
      const text = await res.text();
      const held = _boxLoaded[file] == null ? '' : _boxLoaded[file];
      if (text === held) { _boxVersions[file] = tok; return; }   // token-only move: adopt, nothing to show
      changed.push(b.id);
    }));
    // the chapter's meta: its SHAPE (a box added / removed / re-laid-out elsewhere -> the boxes repaint) and
    // EVERYTHING else notes_meta holds for it (a roadmap card's tasks, the grain, a collapse -> reload + repaint around the boxes)
    let shapeChanged = false, metaChanged = false;
    const epicsNow = Array.isArray(freshEpics) ? freshEpics : await _notesFetchMetaEpics(sec);
    if (epicsNow) {
      const fresh = epicsNow.find(e => e.id === epic.id);
      if (fresh) { shapeChanged = _notesChapterShape(fresh) !== _notesChapterShape(epic); metaChanged = _notesMetaSig([fresh]) !== _notesMetaSig([epic]); }
    }
    if (!changed.length && !metaChanged) return { changed: [] };
    // 4. keystrokes during the fetches? then not now. The same question is asked again after EVERY later await
    //    (J measured a keystroke inside loadNotesMeta reaching the repaint), always right before the repaint itself.
    //    The roadmap's own unsaved work (a card editor open, a drag) counts the same way.
    const notNow = () => { const late = boxes.find(x => _notesBoxIsUnsaved(x.b.id, x.file, x.editor)); if (late) return { skipped: 'unsaved', boxId: late.b.id }; if (_roadmapHasUnsavedEdit()) return { skipped: 'unsaved', roadmap: true }; if (_notesOpenChapter() === null) return { skipped: 'off-screen' }; return null; };
    let stop = notNow(); if (stop) return stop;
    if (metaChanged) {
      const hold = notesMetaHold(sec); const keepActive = sec.activeNotesEpic;   // model + its save baseline, as one
      await loadNotesMeta(sec);
      sec.activeNotesEpic = keepActive;
      stop = notNow();
      if (stop) { notesMetaRestore(sec, hold); return stop; }   // model AND baseline back to what the DOM shows (never one without the other); the next return sees the change again
    }
    // The boxes repaint (a node per box) only when a box's content or the shape changed; a meta-only change
    // (a card's tasks, the grain) leaves the editors - and the caret - alone and repaints around them.
    if (changed.length || shapeChanged) await renderNotesBoxes();
    // Everything that reads the box list repaints with it - the same four repaints a LOCAL add does (addNotesBox):
    // the toolbar (box count, the roadmap toggle), the roadmap (one card per box), the outline (titles from the
    // content). Before, only the boxes repainted, so a box added over MCP showed in the body while the outline kept
    // the old list until a reload (Rishabh, prod 2026-10-05). renderNotesRoadmap hides itself for a chapter without a board.
    if (typeof renderNotesToolbar === 'function') renderNotesToolbar();
    if (metaChanged) _roadmapAfterMetaReload(activeSection); else if (typeof renderNotesRoadmap === 'function') renderNotesRoadmap();
    if (typeof renderNotesOutline === 'function') renderNotesOutline();
    if (typeof showToast === 'function') {
      const n = changed.length;
      showToast(metaChanged && !n ? 'This chapter changed elsewhere and was reloaded.' : (n === 1 ? 'A ' + LBL('boxNoun').toLowerCase() + ' was updated elsewhere and reloaded.' : n + ' ' + (LBL('boxNoun') + (/x$/i.test(LBL('boxNoun')) ? 'es' : 's')).toLowerCase() + ' were updated elsewhere and reloaded.'));
    }
    return { changed, shapeChanged, metaChanged };
  })();
  _notesRevalidating = run.finally(() => { _notesRevalidating = null; });
  return _notesRevalidating;
}

// The whole return: subject list -> one meta read -> the open chapter's boxes -> the chapter list.
let _notesReturnRun = null;
async function revalidateOnReturn() {
  if (_notesReturnRun) return _notesReturnRun;
  const run = (async () => {
    const out = {};
    if (typeof revalidateSectionsList === 'function') out.sections = await revalidateSectionsList();
    if (typeof SECTIONS === 'undefined' || typeof activeSection === 'undefined' || !SECTIONS[activeSection]) return out;
    if (document.body.classList.contains('tt-evlib-open') || document.body.classList.contains('tt-readonly')) return out;
    const sec = SECTIONS[activeSection];
    if (sec._sharedVirtual) return out;
    const fresh = await _notesFetchMetaEpics(sec);
    const listBefore = _notesChapterListSig(sec.notesEpics);
    out.boxes = await revalidateOpenNotesBoxes(fresh);
    // The subject's WHOLE meta (every chapter, every box, every roadmap field) against the store's copy - not only
    // the chapter list. The box step may already have reloaded it (then the two are equal now and nothing is left).
    if (!fresh || _notesMetaSig(fresh) === _notesMetaSig(sec.notesEpics)) { out.chapters = { changed: false }; out.others = await _revalidateBoardSections(); return out; }
    if ((out.boxes && out.boxes.skipped === 'unsaved') || _roadmapHasUnsavedEdit()) { out.chapters = { skipped: 'unsaved' }; return out; }   // typing wins; the next return asks again
    const listChanged = _notesChapterListSig(fresh) !== listBefore;
    const keepActive = sec.activeNotesEpic;
    await loadNotesMeta(sec);
    sec.activeNotesEpic = keepActive;
    if (sec.activeNotesEpic && !(sec.notesEpics || []).some(e => e.id === sec.activeNotesEpic)) { sec.activeNotesEpic = null; await switchTab(activeSection); }   // the open chapter went elsewhere
    else if (listChanged && typeof renderSubtabs === 'function') renderSubtabs();
    _roadmapAfterMetaReload(activeSection);   // the board draws every chapter of the subject (and more in All mode)
    if (typeof showToast === 'function') showToast(listChanged ? 'The ' + LBL('epicNoun').toLowerCase() + ' list changed elsewhere and was updated' : 'This ' + LBL('tabNoun').toLowerCase() + ' changed elsewhere and was reloaded.');
    out.chapters = { changed: true, listChanged };
    out.others = await _revalidateBoardSections();
    return out;
  })();
  _notesReturnRun = run.finally(() => { _notesReturnRun = null; });
  return _notesReturnRun;
}

// The Roadmap tab in "All" scope draws every subject's chapters, so a return there re-reads every OTHER subject's
// meta the board shows (the active subject was just done above). Each one that differs is reloaded and the board
// told once per subject. Typing wins the same way; outside All scope there is nothing to do.
async function _revalidateBoardSections() {
  if (typeof _nrIsAllMode !== 'function' || !_nrIsAllMode()) return { skipped: 'not-board' };
  if (typeof _nrAllPrefs !== 'function' || _nrAllPrefs().roadmapScope !== 'all') return { skipped: 'subject-scope' };
  if (_roadmapHasUnsavedEdit()) return { skipped: 'unsaved' };
  const reloaded = [];
  for (const key of Object.keys(SECTIONS)) {
    const other = SECTIONS[key];
    if (key === activeSection || !other || other._sharedVirtual || !Array.isArray(other.notesEpics)) continue;
    const fresh = await _notesFetchMetaEpics(other);
    if (!fresh || _notesMetaSig(fresh) === _notesMetaSig(other.notesEpics)) continue;
    if (_roadmapHasUnsavedEdit()) break;
    await loadNotesMeta(other);
    _roadmapAfterMetaReload(key);
    reloaded.push(key);
  }
  if (reloaded.length && typeof showToast === 'function') showToast('The roadmap changed elsewhere and was reloaded.');
  return { reloaded };
}

function _onNotesTabReturn() {
  if (typeof document === 'undefined' || document.hidden) return;
  const now = Date.now();
  if (now - _notesReturnAt < NOTES_RETURN_THROTTLE_MS) return;   // focus + visibilitychange arrive as a pair
  _notesReturnAt = now;
  revalidateOnReturn();
}
if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
  window.addEventListener('focus', _onNotesTabReturn);
  document.addEventListener('visibilitychange', _onNotesTabReturn);
}

;
// ==== FILE: js/data.js ====

// ── Load CSV from server ──
async function loadCSV(key) {
  const sec = SECTIONS[key];
  // A reload replaces sec.columns from disk; any in-memory index-keyed grid
  // sort/filter view for this section could misalign, so drop it.
  if (typeof _clearGridView === 'function') _clearGridView(key);
  // Delegate to the categories module for sections that opt in. Existing
  // single-file sections fall through to the original logic untouched.
  if (typeof hasCategories === 'function' && hasCategories(sec)) {
    await loadCategorySection(sec);
    return;
  }
  const fallback = sec.defaultCols || DEFAULT_COLS;
  try {
    const res = await fetch('/load?file=' + sec.file);
    if (!res.ok) throw new Error('not found');
    _csvVersions[sec.file] = res.headers.get('X-Note-Version') || null;   // the token the next save sends back
    const text = await res.text();
    const parsed = parseCSV(text);
    if (parsed.length > 0) {
      sec.columns = parsed[0];
      sec.rows = parsed.slice(1);
    } else {
      // Empty file: reset to this section's defaults
      sec.columns = [...fallback];
      sec.rows = [];
    }
  } catch (e) {
    console.warn(`No CSV found for ${key}, starting empty`);
    delete _csvVersions[sec.file];   // no read = no token: an absent file writes as a first create, a present one refuses (409) and reloads
    sec.columns = [...fallback];
    sec.rows = [];
  }
}


// ── Init: load all CSVs then render ──
async function init() {
  // Reconcile the live section-tab list from data/sections.json before loading
  // any CSVs (it decides which sections exist).
  if (typeof loadSectionsConfig === 'function') await loadSectionsConfig();
  // (1) EAGER metadata only: notes-epic sidecars for EVERY section stay eager —
  // the global roadmap ('all' scope) and renderTabs read notesEpics cross-section,
  // and it is small sidecar JSON (not box/CSV content). The heavy per-subject CSV
  // rows + subtabOrder + columnLabels + the formula pass are deferred to the boot
  // section only (switchTab already lazy-loads a subject on its first switch).
  await Promise.all(Object.keys(SECTIONS).map(k => loadNotesMeta(SECTIONS[k])));
  // (2) Resolve the recipient's LIVE read-access shares into VIRTUAL
  // subjects/chapters (native, revocable, no-copy) BEFORE the boot section is
  // picked, so a virtual shared subject can be the boot section. Best-effort —
  // never blocks the journal from loading if the MCP is unreachable.
  if (typeof initSharedRead === 'function') { try { await initSharedRead(); } catch (_) {} }
  // (3) DEFERRED loads for the BOOT section only: just the section we boot into
  // needs its CSV rows + sidecar order/labels + a formula pass up front.
  const bootKey = _bootSectionKey();
  if (bootKey && SECTIONS[bootKey]) {
    activeSection = bootKey;
    const s = SECTIONS[bootKey];
    if (!s._sharedVirtual) {
      await loadCSV(bootKey);
      await loadSubtabOrder(s);
      await loadColumnLabels(s);
      await loadTableViews(s);
      if (typeof computeAllFormulas === 'function' && computeAllFormulas(s)) save();
    }
  }
  // (4) Land on the tab + sub-view we were on before refresh — AFTER the boot CSV
  // so uniqueEpics/category re-point work against the loaded data.
  const restoredPill = applyRestoredNavState();
  // Fresh load with no restored state → applyRestoredNavState leaves activeSubtab
  // unset; resolve the boot section to its remembered sub-tab, else the Roadmap
  // overview (the always-present fallback). Done before renderSubtabs so the right
  // pill paints active. Skipped when a chapter is being reopened (that wins).
  {
    // A received-read book (or any book switch) can carry a STALE activeSection from the prior
    // container's nav state (e.g. the primary journal's "tasks") that does not exist here - fall to
    // the first real subject so the book opens ON CONTENT, not an empty Roadmap (Rishabh 2026-08-11 walk).
    if (!SECTIONS[activeSection]) { const _k0 = Object.keys(SECTIONS)[0]; if (_k0) activeSection = _k0; }
    const _s = SECTIONS[activeSection];
    if (_s) {
      // Prefer the value applyRestoredNavState just restored (NAV_STATE, the freshest
      // boot state); fall back to per-section memory only when there was none.
      const remembered = restoredPill || recallSubtab(activeSection);
      await bornChapterIfBare(_s);   // an older bare domain opens on a born chapter, like a new one (sections.js)
      landOnFirstChapter(_s, remembered);
      if (!_s.activeNotesEpic) _s.activeSubtab = resolveLandingSubtab(_s, remembered);
    }
  }
  renderTabs();
  if (typeof renderCategoryTabs === 'function') renderCategoryTabs();
  renderSubtabs();
  renderGroupOutline();
  // If a notes-Epic was open before refresh (and still exists), reopen it;
  // otherwise show the table view as usual.
  const _bootSec = SECTIONS[activeSection];
  if (_bootSec && _bootSec.activeNotesEpic
      && (_bootSec.notesEpics || []).some(n => n.id === _bootSec.activeNotesEpic)
      && typeof openEpic === 'function') {
    await openEpic(_bootSec.activeNotesEpic);
  } else {
    if (_bootSec) _bootSec.activeNotesEpic = null;
    if (typeof showTableView === 'function') showTableView();
    renderTable();
  }
}

// ── Remember where you were on refresh ──────────────────────────────────────
// Persist the active tab + its sub-view (Category / Epic sub-tab / Parent Task /
// open notes-Epic) to localStorage, keyed by the tracker being viewed (the store
// uid — so an admin viewing an intern restores THAT intern's last view, not the
// admin's own). Written on navigation-ending events; restored in init().
const NAV_STATE_KEY = 'tt_nav_v1';
function _navStoreUid() {
  // Per person AND per document: section keys repeat across documents ('tasks' in every journal), so one
  // document's remembered pill must never land another document's section (reviewer 2026-09-12).
  const who = (typeof window !== 'undefined' && window.__ttStoreUid) || 'self';
  const book = (typeof window !== 'undefined' && window.__ttActiveBookPrefix) || '';
  return who + '|' + book;
}
// Resolve which section init() should eager-load (CSV + sidecars + formulas).
// Prefer the section restored from NAV_STATE (where we were before refresh) so
// the boot CSV is the one applyRestoredNavState will land on; else the current
// activeSection; else the first section. (loadNotesMeta stays eager for ALL.)
function _bootSectionKey() {
  try {
    const all = JSON.parse(localStorage.getItem(NAV_STATE_KEY) || '{}');
    const st = all[_navStoreUid()];
    if (st && st.section && SECTIONS[st.section]) return st.section;
  } catch (_) {}
  if (SECTIONS[activeSection]) return activeSection;
  return Object.keys(SECTIONS)[0] || null;
}

// ── Per-section last-viewed sub-tab ──────────────────────────────────────────
// Remembers, PER SECTION, which sub-tab you were last on, so entering any section
// (boot OR tab-switch) lands you back where you were in THAT section. When nothing
// valid is remembered it falls back to the "Roadmap" overview (the aggregate; no pill of its own since 2026-10-27,
// opened from a chapter pill's right-click menu).
// Keyed by store uid (an admin viewing an intern restores THAT intern's spots).
// This is separate from NAV_STATE (which restores the single last-active section's
// full view on boot); this map covers every section, for tab-switching too.
const SUBTAB_MEM_KEY = 'tt_subtab_v1';
function _subtabMemAll() {
  try { return JSON.parse(localStorage.getItem(SUBTAB_MEM_KEY) || '{}'); } catch (_) { return {}; }
}
function rememberSubtab(secKey, subtab) {
  try {
    const all = _subtabMemAll();
    const uid = _navStoreUid();
    (all[uid] = all[uid] || {})[secKey] = subtab;
    localStorage.setItem(SUBTAB_MEM_KEY, JSON.stringify(all));
  } catch (_) { /* private mode / quota → just don't remember */ }
}
function recallSubtab(secKey) {
  const all = _subtabMemAll();
  const uid = _navStoreUid();
  return (all[uid] && all[uid][secKey]) || null;
}
// Resolve the sub-tab a section should open on, from a remembered/saved value:
//   • a name     → valid only if it is still a real table-Epic
//   • otherwise  → defaultTableSubtab: the table view the subject has ('All' for a flat table, its first table), or
//                  'All' for a subject with no table at all - the table view then paints the empty-subject card
//                  (table.js renderTable). The roadmap aggregate is never a landing (Rishabh 2026-10-27, four looks).
function resolveLandingSubtab(sec, remembered) {
  const epics = (typeof uniqueEpics === 'function') ? uniqueEpics(sec) : [];
  if (remembered && epics.includes(remembered)) return remembered;
  return defaultTableSubtab(sec);
}
// The table pill a section falls to: a flat section's one table ('All'), else its first table, else 'All' (no table:
// the table view shows the empty-subject card).
function defaultTableSubtab(sec) {
  if (sec.flat) return 'All';
  const epics = (typeof uniqueEpics === 'function') ? uniqueEpics(sec).filter(e => e !== 'All' && e !== 'Roadmap') : [];
  return epics.length ? epics[0] : 'All';
}
// Where a section OPENS when the user has left nothing behind for it: its FIRST chapter/topic, so a document
// opens on content (Rishabh 2026-09-12: not on the Roadmap aggregate). Roadmap, All, or a table-Epic land only
// when the user left the section there (`remembered`). A shared-virtual subject (view-only chapters, no table,
// no real roadmap) has nothing else to land on, so it opens on its first chapter whatever was remembered - the
// rule's one built-in instance, formerly a special case at both call sites. A stale open chapter (deleted since)
// counts as none. Runs BEFORE resolveLandingSubtab, which still picks the pill for the no-chapter case.
function landOnFirstChapter(sec, remembered) {
  const epics = (sec && sec.notesEpics) || [];
  if (!epics.length) return;
  if (sec.activeNotesEpic && epics.some(n => n.id === sec.activeNotesEpic)) return;
  // Only a pill that EXISTS in this subject today can be where it was left: a table by name, or 'All' when the subject
  // has a table. 'Roadmap' is no pill any more (subtabs.js, 2026-10-27) and a stale name / an 'All' saved for a
  // subject that has no table (a refresh on the old aggregate wrote 'All', data.js persistNavState) would otherwise
  // fall through resolveLandingSubtab to the aggregate - the "why am I seeing roadmap" of his 14:2x and 17:3x looks.
  // Anything else counts as nothing remembered and the subject opens on its first chapter like any other.
  if (_pillExists(sec, remembered) && !sec._sharedVirtual) return;
  sec.activeNotesEpic = epics[0].id;
}
function _pillExists(sec, name) {
  if (!name || name === 'Roadmap') return false;
  if (name === 'All') return typeof sectionHasTable === 'function' && sectionHasTable(sec);
  return typeof uniqueEpics === 'function' && uniqueEpics(sec).includes(name);
}
function persistNavState() {
  try {
    const sec = SECTIONS[activeSection];
    if (!sec) return;
    const all = JSON.parse(localStorage.getItem(NAV_STATE_KEY) || '{}');
    all[_navStoreUid()] = {
      section: activeSection,
      category: sec.activeCategory || null,
      subtab: sec.activeNotesEpic ? null : (sec.activeSubtab || 'All'),   // a chapter open = the user did NOT leave this section on a pill (landOnFirstChapter reads this)
      notesEpic: sec.activeNotesEpic || null
    };
    localStorage.setItem(NAV_STATE_KEY, JSON.stringify(all));
  } catch (_) { /* private mode / quota → just don't remember */ }
}
// Returns the PILL the user left the active section on (Roadmap / All / a table-Epic name), or null when they
// left it on a chapter (still there or since deleted) or nothing was saved - the landing rule's "remembered".
function applyRestoredNavState() {
  let st = null;
  try {
    const all = JSON.parse(localStorage.getItem(NAV_STATE_KEY) || '{}');
    st = all[_navStoreUid()] || null;
  } catch (_) { st = null; }
  if (!st) return null;
  // Tab — only if it still exists.
  if (st.section && SECTIONS[st.section]) activeSection = st.section;
  const sec = SECTIONS[activeSection];
  if (!sec) return null;
  // Category — validate against the section's list, then re-point the data and
  // recompute its formulas (the active category at load time was categories[0]).
  if (st.category && typeof hasCategories === 'function' && hasCategories(sec)
      && sec.categories.some(c => c.name === st.category)) {
    sec.activeCategory = st.category;
    if (typeof syncSectionToCategory === 'function') syncSectionToCategory(sec);
    if (typeof computeAllFormulas === 'function') computeAllFormulas(sec);  // display-only; no save on boot
  }
  // Sub-tab — restore the saved one if it is still valid, else the Roadmap overview.
  sec.activeSubtab = resolveLandingSubtab(sec, st.subtab);
  // Open notes-Epic — keep only if it still exists (the init branch reopens it).
  if (st.notesEpic && (sec.notesEpics || []).some(n => n.id === st.notesEpic)) {
    sec.activeNotesEpic = st.notesEpic;
  } else {
    sec.activeNotesEpic = null;
  }
  return st.notesEpic ? null : (st.subtab || null);
}
// Save the spot on the way out. beforeunload covers a desktop refresh/close;
// visibilitychange→hidden also catches tab-switch/mobile-background. Both are
// synchronous localStorage writes, so they finish before the page goes away.
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', persistNavState);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') persistNavState();
  });
}


// A section is "shared view-only" when ALL its content is locked shared chapters:
// it has at least one notes-Epic, every notes-Epic is locked, and it carries no
// editable table-Epic. renderTabs marks such a section's tab with a single 🔒
// (left of the name, shown only in the read-only view via CSS) — the ONE
// parent-level lock that replaces the per-chapter badges + "View only" pill.
function _sectionAllViewOnly(s) {
  const notes = (s && s.notesEpics) || [];
  if (!notes.length || !notes.every(n => n.locked)) return false;
  const epicCi = epicColumnIndex(s);
  const tableEpics = epicCi >= 0 ? uniqueEpics(s).filter(e => e !== 'All' && e !== 'Roadmap') : [];
  return tableEpics.length === 0;
}
// #17: the BOOK-level twin of _sectionAllViewOnly, one level up - the whole container is
// view-only when every subject in it is. Two terms, both read live, nothing stored:
//   • it is a BOOK, not the primary journal. The journal (prefix '') is the recipient's OWN
//     editable space that merely HOSTS view-only shares, so even an all-shared journal is a
//     pile of SUBJECT-level restrictions, each of which keeps its own lock.
//   • every subject in it is view-only. A received read book ('srread~') and the author's own
//     per-version viewer ('srview~') are exactly that: loadSectionsConfig leaves them with NO
//     stored sections, so shared-read.js's virtual (locked, table-less) subjects are all there
//     is - the restriction is the BOOK's, not any one subject's.
// Derived from the live container + SECTIONS rather than a new global, so any future read-only
// container kind is covered without touching this.
function _bookAllViewOnly() {
  if (!(typeof window !== 'undefined' && window.__ttActiveBookPrefix)) return false;
  const subjects = Object.keys(SECTIONS).map(k => SECTIONS[k]);
  return subjects.length > 0 && subjects.every(s => _sectionAllViewOnly(s));
}
// #17: THE LOCK BELONGS AT THE LEVEL THE RESTRICTION IS AT (Rishabh). Read-only nests -
// book > subject > chapter - and one restriction must draw exactly ONE 🔒, at its own level.
// This is the single question every lock asks before drawing itself: "is my restriction ALREADY
// expressed ABOVE me?" Yes -> stay silent. Without it a book-level read-only was redrawn on all
// 14 subject tabs, which is not just noise: it destroys the signal a SUBJECT lock carries ("THIS
// subject is view-only, its siblings are not") and makes a reader ask which ones are locked.
function _restrictionAbove(level, s) {
  if (_bookAllViewOnly()) return true;                    // book-level -> subject AND chapter stay silent
  return level === 'chapter' && _sectionAllViewOnly(s);   // subject-level -> its chapters stay silent
}
function renderTabs() {
  // Tabs are user-managed (add / rename / delete) like Epics, so each is a
  // role=button div carrying a ✕, with a trailing "+ Add Tab". Clicking the
  // active tab renames it; clicking another switches (see onTabClick).
  const tabs = Object.entries(SECTIONS).map(([k, s]) => {
    const kAttr = k.replace(/'/g, "\\'");
    const active = k === activeSection ? 'active' : '';
    // ONE parent-level 🔒 (+ "view only" tooltip) on a fully view-only subject's tab. For a
    // SHARED-virtual subject (the recipient's OWN journal) force it visible via inline style -
    // the CSS `.tab-lock{display:none}` only reveals it under tt-view-ro (the teacher-view
    // mode), which a recipient in their own journal never has. This is the SINGLE lock that
    // replaces the per-chapter badges + the "View only" pill (Rishabh).
    // #17: ...and only when the restriction is genuinely THIS subject's. A read-only BOOK (a
    // received read book, or the author opening a completed version's Read view) already says
    // it at the book level, so no subject inside it repeats it.
    const lock = (_sectionAllViewOnly(s) && !_restrictionAbove('subject', s))
      ? '<span class="tab-lock" ' + (s._sharedVirtual ? 'style="display:inline" ' : '') + 'aria-hidden="true" title="Shared to you - view only">🔒</span>'
      : '';
    // A shared (view-only) subject isn't the recipient's to delete/rename — no ✕,
    // and clicking it just opens (renameSection/deleteSection also guard on this).
    const del = s._sharedVirtual ? '' :
      `<span class="del-tab" draggable="false" onclick="event.stopPropagation();deleteSection('${kAttr}')" title="Delete this ${LBL('tabNoun').toLowerCase()} and its data">✕</span>`;
    return `<div class="tab ${active}" role="button" draggable="true" data-section-key="${kAttr}"
      ondragstart="onTabDragStart(event,'${kAttr}')"
      ondragover="onTabDragOver(event)"
      ondragleave="onTabDragLeave(event)"
      ondrop="onTabDrop(event,'${kAttr}')"
      ondragend="onTabDragEnd(event)"
      onclick="onTabClick('${kAttr}')" title="Click to open · drag to reorder · click again to rename">
      ${lock}<span class="tab-name">${esc(s.title)}</span>
      ${del}
    </div>`;
  }).join('');
  const addBtn = (typeof addSection === 'function')
    ? `<div class="strip-actions"><div class="add-tab" role="button" onclick="addSection()" title="${esc(LBL('addTab'))}">${LBL('addTab')}</div></div>`   // sticky at the right edge of the strip (styles.css .strip-actions; Rishabh 2026-09-14)
    : '';
  document.getElementById('tabs').innerHTML = tabs + addBtn;
}


async function switchTab(k) {
  activeSection = k;
  selectedRows.clear(); selectedCols.clear();
  await loadCSV(k); // reload from disk
  await loadNotesMeta(SECTIONS[k]); // reload sidecar notes meta
  // Re-add virtual shared (read-access) chapters — loadNotesMeta just replaced
  // notesEpics with the on-disk set, which never contains them.
  if (typeof injectSharedEpics === 'function') injectSharedEpics(SECTIONS[k]);
  await loadSubtabOrder(SECTIONS[k]); // reload subtab order
  await loadColumnLabels(SECTIONS[k]); // reload per-Epic column labels
  await loadTableViews(SECTIONS[k]); // reload table groups + Group-by chains (table-groupby.js)
  // If the previously-active sub-tab no longer exists in the freshly-loaded
  // section, fall back to "All"
  const sec = SECTIONS[k];
  // Restore this section's last-viewed sub-tab (per-section memory); a section never left anywhere opens on its first chapter.
  const remembered = recallSubtab(k) || sec.activeSubtab;
  await bornChapterIfBare(sec);   // an older bare domain opens on a born chapter, like a new one (sections.js)
  landOnFirstChapter(sec, remembered);
  if (!sec.activeNotesEpic) sec.activeSubtab = resolveLandingSubtab(sec, remembered);   // an open chapter wins, as at boot
  // If the previously-active notes Epic no longer exists, drop it
  if (sec.activeNotesEpic) {
    if (!(sec.notesEpics || []).some(n => n.id === sec.activeNotesEpic)) {
      sec.activeNotesEpic = null;
    }
  }
  renderTabs();
  if (typeof renderCategoryTabs === 'function') renderCategoryTabs();
  renderSubtabs();
  renderGroupOutline();
  // Reopen the active chapter if one is still open; else the table view (a table, or the empty-subject card).
  if (sec.activeNotesEpic) {
    await openEpic(sec.activeNotesEpic);
  } else {
    showTableView();
    renderTable();
  }
}


// ── Whole-file saves = version-checked ──
// A table's CSV (and its column-label / sub-tab-order sidecars) is written WHOLE, so a stale tab's save would
// silently drop what another writer - the same person's other tab, a co-author, an MCP tool - put in since this
// tab last read the file. Every /load stashes the file's version token; every save sends it back and the store
// refuses the write (409) when the file moved. On a 409 the surface reloads from the store and says so; the
// person redoes their last change instead of losing someone else's. Saves are CHAINED so two quick edits never
// race each other into a false conflict (the second waits for the first's new token), and a file under reload
// is HELD (a queued save resolves 409 without writing) so a stale queued write can never land on the fresh
// token. In local dev there is no version header: the token stays null and the plain server ignores the flag.
const _csvVersions = {};
const _csvHeld = {};
let _csvSaveChain = Promise.resolve();
function _versionedSave(file, csv) {
  const run = () => {
    if (_csvHeld[file]) return Promise.resolve(new Response('{"error":"conflict"}', { status: 409, headers: { 'Content-Type': 'application/json' } }));
    return fetch('/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: file, csv, versionCheck: true, expectedUpdatedAt: Object.prototype.hasOwnProperty.call(_csvVersions, file) ? _csvVersions[file] : null })
    }).then((r) => {
      if (r.ok) { const v = r.headers.get('X-Note-Version'); if (v) _csvVersions[file] = v; }
      return r;
    });
  };
  const p = _csvSaveChain.then(run, run);
  _csvSaveChain = p.catch(() => {});
  return p;
}
// Settle a versioned save with TWO sentences, never one. The network sentence covers the fetch alone: a
// rejected fetch or a non-ok status other than 409. Once a response is in, the store has already decided
// (landed, or refused as stale): anything the 409 reload / repaint or the post-ok handler throws is THIS
// TAB'S OWN CODE failing, so it gets its own sentence naming the error (J: a ReferenceError in a fixture
// read as "Server not running" on a save that had succeeded; same rule as saveSectionsConfig / LISTS-1).
// `what` names the surface ("This table"), `netSentence` is the caller's own network wording.
function _settleSave(p, what, netSentence, onOk, onConflict) {
  return p.then((r) => {
    if (r.status === 409) {
      return Promise.resolve().then(onConflict).catch((e) => _afterResponseFailed(
        '⚠ ' + what + ' changed elsewhere, but this tab could not reload it (' + _errText(e) + ') - reload the page', e));
    }
    if (!r.ok) { showToast(netSentence); return; }
    return Promise.resolve().then(onOk).catch((e) => _afterResponseFailed(
      '⚠ Saved, but ' + what.charAt(0).toLowerCase() + what.slice(1) + ' could not refresh (' + _errText(e) + ') - reload to see it', e));
  }, () => { showToast(netSentence); });
}
function _errText(e) { return (e && e.message) || String(e); }
function _afterResponseFailed(sentence, e) { console.error('[save] failed after the response', e); showToast(sentence); }
// A 409 came back: reload that surface once (the file is held meanwhile), repaint, and say so.
async function _onSaveConflict(file, reload, rerender, what) {
  if (_csvHeld[file]) return;
  _csvHeld[file] = true;
  try { await reload(); rerender(); } finally { delete _csvHeld[file]; }
  showToast('⚠ ' + what + ' changed elsewhere and was reloaded - redo your last change');
}

// ── Save: writes CSV to disk via server ──
function save() {
  const key = activeSection;
  const sec = SECTIONS[key];
  // For sections with categories, save to the active category's file.
  // Falls back to sec.file for normal sections.
  const file = (typeof activeCategoryFile === 'function') ? activeCategoryFile(sec) : sec.file;
  _settleSave(_versionedSave(file, buildCSV(sec)), 'This table', '⚠ Server not running',
    () => showToast('✓ Saved to ' + file),
    () => _onSaveConflict(file, () => loadCSV(key), () => { if (!sec.activeNotesEpic) renderTable(); }, 'This table'));
}

;
// ==== FILE: js/table-import.js ====
// ── Import a CSV / Excel file as a NEW TABLE of the open domain (Rishabh 2026-09-29) ──
// "user will expect exact data as per csv including column heading and column number and row number": the file's
// header row becomes the new table's columns, in the file's order (table-columns.js: they join the domain's file as
// needed, this table shows only them); its rows become the table's rows, the first 1,000 of them (the shared cap), filed
// under the table's name (the file's name). Every other table of the domain is untouched.
// The caps (1,000 rows a table, 900 KB a domain), the grid shaping, the sentences and the data change are the SHARED
// module's (mcp-server/shared/table-rules.mjs - an MCP import runs the same code); this file reads the file and speaks.
const IMPORT_SHEETJS = '/vendor/xlsx-0.20.3.mjs';   // SheetJS 0.20.3 ESM (Apache-2.0), VENDORED - served from our host, cached by the SW like the rest, no third-party dependency at runtime; fetched on the FIRST Excel import only (a CSV needs no library)
const IMPORT_ACCEPT = '.csv,.xlsx,.xls,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

// The table-toolbar button (index.html, left of Restore): pick one file, import it.
function importTableFile() {
  const input = document.createElement('input');
  input.type = 'file'; input.accept = IMPORT_ACCEPT; input.style.display = 'none';
  const cleanup = () => { if (input.parentNode) input.remove(); };
  input.addEventListener('cancel', cleanup);                                   // dialog dismissed with no selection
  window.addEventListener('focus', () => setTimeout(cleanup, 300), { once: true });   // browsers without the 'cancel' event
  input.addEventListener('change', () => { const f = input.files && input.files[0]; cleanup(); if (f) _importTableFrom(f); });
  document.body.appendChild(input);
  input.click();
}

// The import speaks through the dashboard toast (js/dashboard/core.js libToast - the PDF export's), not the table's
// "Saved" toast: the save that follows would replace that one within a second (Rishabh 2026-09-29: "toast visible
// nahi, uske baad Saved aa jata hai"). An outcome stays 6 s; a CUT stays 20 s so the person cannot miss it.
async function _importTableFrom(file) {
  const T = await import('/js/dashboard/core.js');
  T.libToast('Importing ' + file.name + '…', 'busy', { owner: 'import' });
  try {
    const sec = SECTIONS[activeSection];
    const grid = await _readImportGrid(file);
    const { headers, rows, total } = _shapeImportGrid(grid);
    if (!headers.length) { T.libToast(TableRules.importMessages.noHeader(file.name).text, 'warn', { owner: 'import', stay: 8000 }); return; }
    // The table's name: the file's, made unique among the domain's tables ("orders", "orders 2", ...).
    const name = TableRules.uniqueTableName(sec, file.name.replace(/\.[^.]+$/, '').trim() || 'Imported table');
    // The file's column names are settled by the rules (blank -> "Column n", "#" / Topic / a repeat -> made unique).
    // Size first, on a copy: one domain is one store document. Nothing is touched when the file will not fit.
    const bytes = new TextEncoder().encode(buildCSV(TableRules.importProbe(sec, name, headers, rows, LBL('epicNoun')))).length;
    if (TableRules.importTooLarge(bytes)) {
      const m = TableRules.importMessages.tooLarge(file.name, bytes, LBL('tabNoun').toLowerCase());
      T.libToast(m.text, 'err', { owner: 'import', stay: 12000, sub: m.sub });
      return;
    }
    _commitFocusedCell();
    pushUndo();
    // Every domain files rows under a Topic column; a flat (older import) or bare domain gets one first (the page's
    // own conversion: it also places the pill and saves the tab list).
    if (sec.flat || epicColumnIndex(sec) < 0) _ungroupedToGrouped(sec);
    TableRules.applyImport(sec, name, headers, rows, LBL('epicNoun'));
    subtabOrderInsertAtEnd(sec, subtabKeyOfTable(name));
    if (typeof _clearGridView === 'function') _clearGridView(activeSection);
    save();
    saveTableViews(sec);
    switchSubtab(name);
    if (total > rows.length) {
      const m = TableRules.importMessages.cut(name, rows.length, total);
      T.libToast(m.text, 'warn', { owner: 'import', stay: 20000, sub: m.sub });
    } else {
      const m = TableRules.importMessages.ok(name, rows.length, headers.length);
      T.libToast(m.text, 'ok', { owner: 'import', stay: 6000, sub: m.sub });
    }
  } catch (e) {
    T.libToast('Could not read ' + file.name, 'err', { owner: 'import', stay: 12000, sub: (e && e.message) || String(e) });
  }
}

// Every row of the file as an array of strings, header row first. A CSV goes through the app's own parser
// (csv.js parseCSV: quotes, embedded commas and newlines); a workbook's FIRST sheet goes through SheetJS
// with formatted text (a date reads as it shows in Excel, a number as typed - never a serial or a float).
async function _readImportGrid(file) {
  if (/\.csv$/i.test(file.name) || file.type === 'text/csv') {
    return parseCSV((await file.text()).replace(/^﻿/, ''));
  }
  const XLSX = await import(IMPORT_SHEETJS);
  const wb = XLSX.read(await file.arrayBuffer(), { type: 'array' });
  const first = wb.SheetNames[0];
  if (!first) throw new Error('the workbook has no sheet');
  return XLSX.utils.sheet_to_json(wb.Sheets[first], { header: 1, raw: false, defval: '', blankrows: false })
    .map(r => r.map(v => (v == null ? '' : String(v))));
}

// Header + rows from the raw grid - the shared rule (leading blank rows go, the header is the first row with
// text, blank rows go, width = the widest row, the first 1,000 rows kept; `total` = the rows the file had).
function _shapeImportGrid(grid) { return TableRules.shapeImportGrid(grid); }

;
// ==== FILE: js/subtabs.js ====

function renderSubtabs() {
  const sec = SECTIONS[activeSection];
  const wrap = document.getElementById('subtabs');
  const epicCi = epicColumnIndex(sec);
  const notesEpics = sec.notesEpics || [];
  const supportsNotes = !!notesPrefix(sec);

  if (epicCi < 0 && notesEpics.length === 0 && !supportsNotes) { wrap.innerHTML = ''; return; }

  const active = sec.activeSubtab || 'All';
  const activeNotes = sec.activeNotesEpic || null;
  // #17: a chapter pill draws its 🔒 only when the restriction is genuinely CHAPTER-level. When
  // the WHOLE subject is shared view-only the subject TAB carries the one lock (data.js
  // renderTabs), and when the WHOLE BOOK is read-only the book carries it - either way repeating
  // it per chapter says nothing new, and a repeated lock reads as "some chapters are locked and
  // others are not", the opposite of the truth. _restrictionAbove (data.js) is the shared
  // predicate, so both levels answer the same question the same way.
  const roAbove = (typeof _restrictionAbove === 'function') && _restrictionAbove('chapter', sec);

  // If the active table Epic isn't represented by any row yet (e.g. just
  // switched from another Category where this Epic was set), make sure it
  // still appears so the user sees their selection. 'All' and 'Roadmap' are
  // pseudo-tabs, not table Epics, so they never get injected here.
  // Drop any table-Epic literally named like a pseudo-tab ('All'/'Roadmap') so it
  // can't render a duplicate, broken pill that routes to the pseudo-tab. Such rows
  // still appear in the "All Tables" aggregate; only the (colliding) per-Epic pill
  // is suppressed. 'All' was always reserved; 'Roadmap' is newly reserved here.
  let tableEpics = epicCi >= 0 ? uniqueEpics(sec).filter(e => e !== 'All' && e !== 'Roadmap') : [];
  if (!activeNotes && active !== 'All' && active !== 'Roadmap' && !tableEpics.includes(active)) tableEpics = [...tableEpics, active];

  // Compose the interleaved pill order from the saved subtab order. New pills
  // (not yet in subtabOrder) are appended at the end in their natural order.
  const notesEpicMap = new Map(notesEpics.map(n => [subtabKeyOfNotes(n.id), n]));
  const tableEpicSet = new Set(tableEpics);
  const orderedKeys = (() => {
    const all = [...tableEpics.map(subtabKeyOfTable), ...notesEpics.map(n => subtabKeyOfNotes(n.id))];
    const order = sec.subtabOrder || [];
    const idx = new Map();
    order.forEach((k, i) => idx.set(k, i));
    return all.slice().sort((a, b) => {
      const ai = idx.has(a) ? idx.get(a) : Infinity;
      const bi = idx.has(b) ? idx.get(b) : Infinity;
      if (ai !== bi) return ai - bi;
      return all.indexOf(a) - all.indexOf(b);
    });
  })();

  // Use <div role="button"> not <button> — <button> fires a native click on
  // Space, which would re-trigger rename mode every time the user typed a
  // space inside the rename input.
  const isAllActive = !activeNotes && active === 'All';
  // The section "Roadmap" (the chapter-less aggregate of every chapter's cards) has NO pill and no menu item (Rishabh
  // 2026-10-27: "roadmap tab mein nahi"; the pill-menu door built first came out: "not needed there"); the chapter-level
  // board is the layout bar's Roadmap button, scope "All". 'Roadmap' stays the internal sub-tab name for the aggregate
  // render (renderAllRoadmap) and the fallback of a chapter-less, table-less subject - but it is never a LANDING: a
  // remembered 'Roadmap' counts as nothing remembered (data.js landOnFirstChapter / _pillExists).
  let html = '';
  // The "All" view (every table's rows in one grid) has NO pill any more (Rishabh 2026-09-29: "All Tables
  // delete kar do") - a table is opened by its own pill. A FLAT section (an imported file) has exactly one
  // table and no Topics, so its one pill carries the domain's own name and opens that view.
  // The pill carries the domain's own name, and behaves like a table pill: a second click renames (the domain -
  // the file's table IS the domain), ✕ deletes it (sections.js deleteSection asks first). Rishabh 2026-09-29.
  if (sec.flat && sectionHasTable(sec)) {
    const kAttr = String(activeSection).replace(/'/g, "\'");
    html += `<div class="subtab ${isAllActive ? 'active' : ''}" role="button" onclick="${isAllActive ? `renameSection('${esc(kAttr)}')` : `onSubtabClick('All')`}" title="${isAllActive ? 'Click to rename' : 'Click to open'}"><span class="subtab-name">${esc(sec.title)}</span><span class="del-sub" onclick="event.stopPropagation();delFlatTable()" title="${esc('Delete this ' + LBL('epicNoun').toLowerCase())}">✕</span></div>`;
  }

  for (const key of orderedKeys) {
    if (isNotesKey(key)) {
      const ne = notesEpicMap.get(key);
      if (!ne) continue;
      const isActive = activeNotes === ne.id;
      const idAttr = ne.id.replace(/'/g, "\\'");
      const keyAttr = key.replace(/'/g, "\\'");
      const lockIco = (ne.locked && !roAbove) ? '<span class="subtab-ico" aria-hidden="true" title="View only - shared to you">🔒</span>' : '';
      if (ne._sharedVirtual) {
        // A VIRTUAL shared (read-access) chapter: resolved live from the sender's
        // snapshot, not the recipient's data — so no drag (order isn't persisted),
        // no ✕ (not theirs to delete; the sender revokes), and click only opens.
        html += `<div class="subtab notes-epic ${isActive ? 'active' : ''}" role="button" data-note-id="${esc(ne.id)}" onclick="onNotesPillClick('${esc(idAttr)}')" title="View only - shared to you">${lockIco}<span class="subtab-name">${esc(ne.name)}</span></div>`;
      } else {
        const titleHint = isActive ? 'Click to rename · drag to reorder' : 'Click to open · drag to reorder';
        html += `<div class="subtab notes-epic ${isActive ? 'active' : ''}" role="button" draggable="true" data-note-id="${esc(ne.id)}" ondragstart="onSubtabDragStart(event,'${esc(keyAttr)}')" ondragover="onSubtabDragOver(event)" ondragleave="onSubtabDragLeave(event)" ondrop="onSubtabDrop(event,'${esc(keyAttr)}')" ondragend="onSubtabDragEnd(event)" onclick="onNotesPillClick('${esc(idAttr)}')" title="${titleHint}">${lockIco}<span class="subtab-name">${esc(ne.name)}</span><span class="del-sub" onclick="event.stopPropagation();delNotesEpic('${esc(idAttr)}')" title="Delete these notes">✕</span></div>`;
      }
    } else {
      if (!tableEpicSet.has(key)) continue;
      const e = key;
      const eAttr = e.replace(/'/g, "\\'");
      const keyAttr = eAttr;
      const isActive = !activeNotes && active === e;
      const titleHint = isActive ? 'Click to rename · drag to reorder' : 'Click to switch · drag to reorder';
      html += `<div class="subtab ${isActive ? 'active' : ''}" role="button" draggable="true" data-epic="${esc(e)}" ondragstart="onSubtabDragStart(event,'${esc(keyAttr)}')" ondragover="onSubtabDragOver(event)" ondragleave="onSubtabDragLeave(event)" ondrop="onSubtabDrop(event,'${esc(keyAttr)}')" ondragend="onSubtabDragEnd(event)" onclick="onSubtabClick('${esc(eAttr)}')" title="${titleHint}"><span class="subtab-name">${esc(e)}</span><span class="del-sub" onclick="event.stopPropagation();delSubtab('${esc(eAttr)}')" title="${esc('Delete this ' + LBL('epicNoun').toLowerCase())}">✕</span></div>`;
    }
  }

  // The add actions sit in ONE sticky wrapper at the right edge of the strip (styles.css .strip-actions; Rishabh 2026-09-14:
  // visible without scrolling) - built up here, appended once, omitted when there is nothing to add.
  let acts = '';
  // "+ Add Table" is ALWAYS offered on an editable section (Rishabh 2026-09-29: "button to hamesha hi rahega") - a
  // grouped one, a FLAT one (an imported file) and a BARE one (only '#', no table yet) alike: addSubtab adds the Topic
  // column first where it is missing. The empty-subject card (table.js) offers the same two actions.
  if (!sec._sharedVirtual) {
    acts += `<div class="add-subtab" role="button" onclick="addSubtab()" title="${esc('Add a table ' + LBL('epicNoun').toLowerCase())}">${LBL('addEpic')}</div>`;
  }
  // "+ Add chapter" is suppressed on a SHARED (view-only) virtual subject - it is the
  // teacher's projection, not the recipient's to add real chapters into (that would write
  // to a synthetic-file location). The recipient adds their own chapters in their OWN
  // subjects, and their own new subjects via "+ Add Tab" - both stay available.
  if (supportsNotes && !sec._sharedVirtual) {
    acts += `<div class="add-subtab add-notes" role="button" onclick="addNotesEpic()" title="${esc('Add a notes ' + LBL('epicNoun').toLowerCase())}">${LBL('addNotes')}</div>`;
  }
  if (acts) html += `<div class="strip-actions">${acts}</div>`;
  wrap.innerHTML = html;
}


// Click router for notes-epic pills: clicking the active one enters rename
// mode; clicking another switches to it.
function onNotesPillClick(id) {
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === id);
  // A shared (view-only) chapter is never renameable — clicking the active one
  // just re-opens it (no rename mode).
  if (sec.activeNotesEpic === id && !(epic && epic._sharedVirtual)) {
    enterNotesRenameMode(id);
  } else {
    if (typeof rememberSubtab === 'function') rememberSubtab(activeSection, null);   // the user left the pills for a chapter - no pill is remembered for this section
    openEpic(id).then(renderSubtabs);
  }
}


function enterNotesRenameMode(id) {
  // Target the pill for THIS id, not whichever pill happens to be .active —
  // they can differ if the active state is ever inconsistent.
  const wrap = document.getElementById('subtabs');
  const btn = wrap && Array.prototype.find.call(
    wrap.querySelectorAll('.subtab.notes-epic'), el => el.dataset && el.dataset.noteId === id);
  if (!btn) return;
  const span = btn.querySelector('.subtab-name');
  if (!span) return;
  const sec = SECTIONS[activeSection];
  const epic = (sec.notesEpics || []).find(n => n.id === id);
  if (!epic) return;
  span.contentEditable = 'true';
  span.dataset.oldName = epic.name;
  span.dataset.id = id;
  span.focus();
  const range = document.createRange();
  range.selectNodeContents(span);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
  span.onblur = () => renameNotesEpic(span.dataset.id, span.textContent);
  span.onkeydown = (e) => {
    e.stopPropagation();
    if (e.key === 'Enter') { e.preventDefault(); span.blur(); }
    if (e.key === 'Escape') {
      e.preventDefault();
      span.textContent = span.dataset.oldName;
      span.blur();
    }
  };
}


// Click router: clicking the active Epic pill enters rename mode; clicking
// anything else switches to it.
function onSubtabClick(name) {
  const sec = SECTIONS[activeSection];
  // Rename only when this table Epic is the genuinely-active pill — i.e. no
  // notes-Epic is open (a notes-Epic takes visual precedence). Otherwise switch
  // to it first; a second click then renames.
  const isAlreadyActive = !sec.activeNotesEpic && (sec.activeSubtab || 'All') === name;
  if (isAlreadyActive && name !== 'All' && name !== 'Roadmap') {
    enterEpicRenameMode(name);
  } else {
    switchSubtab(name);
  }
}


function enterEpicRenameMode(name) {
  // Target the pill for THIS Epic by name, not whichever pill is .active — a
  // notes-Epic can be the active pill while this table Epic is what was clicked.
  const wrap = document.getElementById('subtabs');
  const btn = wrap && Array.prototype.find.call(
    wrap.querySelectorAll('.subtab'), el => el.dataset && el.dataset.epic === name);
  if (!btn) return;
  const span = btn.querySelector('.subtab-name');
  if (!span) return;
  // Disable dragging while editing so text selection on the span works cleanly
  btn.setAttribute('draggable', 'false');
  span.contentEditable = 'true';
  span.dataset.oldName = name;
  span.focus();
  // Select all so typing replaces the current name
  const range = document.createRange();
  range.selectNodeContents(span);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
  span.onblur = () => commitEpicRename(span);
  span.onkeydown = (e) => {
    e.stopPropagation(); // don't let global Ctrl+Z fire while typing
    if (e.key === 'Enter') { e.preventDefault(); span.blur(); }
    if (e.key === 'Escape') {
      e.preventDefault();
      span.textContent = span.dataset.oldName;
      span.blur();
    }
  };
}


function commitEpicRename(span) {
  const oldName = span.dataset.oldName;
  const newName = span.textContent.trim();
  // Validation: empty / unchanged / reserved / duplicate → revert without writing
  const sec = SECTIONS[activeSection];
  if (!newName || newName === oldName) { renderSubtabs(); return; }
  // The shared rule (mcp-server/shared/table-rules.mjs renameTable): the name checked (blank / reserved / taken -
  // its sentence is the toast), every stored Topic cell rewritten (continuation rows follow by fill-down), the
  // table's column set, Group by chain and display labels moved to the new name. Nothing is written when it refuses.
  try { TableRules.validTableName(sec, newName, { current: oldName }); }
  catch (e) { showToast('⚠ ' + e.message); renderSubtabs(); return; }
  pushUndo();
  const renamed = TableRules.renameTable(sec, oldName, newName);
  if (sec.activeSubtab === oldName) {
    sec.activeSubtab = newName;
    // Keep per-section memory in sync, else a stale old name mislands on next boot.
    if (typeof rememberSubtab === 'function') rememberSubtab(activeSection, newName);
  }
  // Keep the unified subtab order pointing at the new name
  subtabOrderRename(sec, subtabKeyOfTable(oldName), subtabKeyOfTable(newName));
  saveTableViews(sec);
  if (renamed.labelsTouched) saveColumnLabels(sec);
  save();
  renderSubtabs();
  renderTable();
  showToast('✓ Renamed to "' + newName + '"');
}


// ── Unified pill ordering: Subtab order file ─────────────────────────────
//
// Table-Epic pills and Notes-Epic pills share ONE rendered strip, and the
// user can drag any pill past any other pill — including table-onto-notes
// and vice versa. The combined display order is persisted in:
//
//   <prefix>__subtab_order.json   →  { "order": ["EpicName", "id:<notesId>", …] }
//
// • A bare string is a table-Epic name.
// • A string prefixed with `id:` is a notes-Epic id.
//
// Pills present in the section but NOT in `order` are appended at the end
// in their natural order (CSV row order for table; meta-array order for
// notes). This means a freshly-added Epic gets a default position at the
// end, and the user can drag it wherever.

function subtabKeyOfTable(name) { return name; }
function subtabKeyOfNotes(id) { return 'id:' + id; }
function isNotesKey(key) { return typeof key === 'string' && key.startsWith('id:'); }
function notesIdFromKey(key) { return key.slice(3); }

function subtabOrderFilename(sec) {
  if (sec.file) return sec.file.replace(/\.csv$/, '') + '__subtab_order.json';
  if (sec.categories && sec.categories[0] && sec.categories[0].file) {
    const prefix = sec.categories[0].file.replace(/__[^_]+\.csv$/, '');
    return prefix + '__subtab_order.json';
  }
  return null;
}

async function loadSubtabOrder(sec) {
  sec.subtabOrder = [];
  const file = subtabOrderFilename(sec);
  if (!file) return;
  try {
    const res = await fetch('/load?file=' + file);
    if (!res.ok) { delete _csvVersions[file]; return; }
    _csvVersions[file] = res.headers.get('X-Note-Version') || null;   // data.js: the token the next save sends back
    const text = await res.text();
    if (!text.trim()) return;
    const json = JSON.parse(text);
    if (Array.isArray(json.order)) sec.subtabOrder = json.order;
  } catch (_) { sec.subtabOrder = []; }
}

function saveSubtabOrder(sec) {
  const file = subtabOrderFilename(sec);
  if (!file) return Promise.resolve();
  const payload = JSON.stringify({ order: sec.subtabOrder || [] }, null, 2);
  // Version-checked + chained (data.js _versionedSave): a stale save is refused, the order reloads, a toast says so.
  // Two sentences (data.js _settleSave): the network one for the fetch, an own one for a throw after the response.
  return _settleSave(_versionedSave(file, payload), 'The sub-tab order', '⚠ Could not save the sub-tab order',
    () => {},
    () => _onSaveConflict(file, () => loadSubtabOrder(sec), () => renderSubtabs(), 'The sub-tab order'));
}

// Compose the interleaved pill order for the active section:
//   1. Build natural lists: table Epics (from CSV) + notes Epics (from meta)
//   2. Sort by index in `sec.subtabOrder`; items not in the order go to the end
function getOrderedSubtabKeys(sec) { return TableRules.orderedKeys(sec.subtabOrder, _presentSubtabKeys(sec)); }

// Keep `sec.subtabOrder` in sync with the live pill set on add/del/rename.
// "At the end" means after every pill the person SEES, not after the stored list: a domain whose pills were
// never dragged has an empty (or partial) stored order, and a bare push would put the new key first, ahead of
// every unlisted pill (J, RUN 2026-09-29: import / + Add Table landed before "Tasks"). So the stored order is
// first made the full order on screen (getOrderedSubtabKeys: listed keys in their order, then the rest in
// natural order), and the new key goes after all of them.
function subtabOrderInsertAtEnd(sec, key) {
  if ((sec.subtabOrder || []).includes(key)) return;
  sec.subtabOrder = TableRules.orderAppend(sec.subtabOrder, _presentSubtabKeys(sec), key);
  saveSubtabOrder(sec);
}
// Every pill the section has right now, in natural order: the tables (from the CSV), then the notes topics.
function _presentSubtabKeys(sec) {
  const tableKeys = (sec.columns && epicColumnIndex(sec) >= 0 ? uniqueEpics(sec) : []).map(subtabKeyOfTable);
  return tableKeys.concat((sec.notesEpics || []).map(n => subtabKeyOfNotes(n.id)));
}
function subtabOrderRemove(sec, key) {
  if (!sec.subtabOrder || !sec.subtabOrder.includes(key)) return;
  sec.subtabOrder = TableRules.orderRemove(sec.subtabOrder, key);
  saveSubtabOrder(sec);
}
function subtabOrderRename(sec, oldKey, newKey) {
  if (!sec.subtabOrder || !sec.subtabOrder.includes(oldKey)) return;
  sec.subtabOrder = TableRules.orderRename(sec.subtabOrder, oldKey, newKey);
  saveSubtabOrder(sec);
}


// ── Unified drag-and-drop reorder ─────────────────────────────────────────
// Every pill (table-Epic OR notes-Epic) is draggable and accepts drops from
// every other pill. Drop logic:
//   • Forward drag (dragged was earlier in order) → drops AFTER target
//   • Backward drag → drops BEFORE target
// Same-type drops additionally keep "natural" data in sync — table-Epic-to-
// table-Epic also reorders CSV rows (so export order matches display);
// notes-Epic-to-notes-Epic also reorders sec.notesEpics (so the meta array
// reflects display). Cross-type drops ONLY update the subtab order file.

let draggedSubtabKey = null;

function onSubtabDragStart(e, key) {
  draggedSubtabKey = key;
  e.dataTransfer.effectAllowed = 'move';
  try { e.dataTransfer.setData('text/plain', key); } catch (_) {}
}

function onSubtabDragOver(e) {
  if (!draggedSubtabKey) return;
  e.preventDefault();
  e.dataTransfer.dropEffect = 'move';
  e.currentTarget.classList.add('drag-over');
}

function onSubtabDragLeave(e) {
  e.currentTarget.classList.remove('drag-over');
}

function onSubtabDragEnd() {
  draggedSubtabKey = null;
  document.querySelectorAll('.subtab.drag-over').forEach(el => el.classList.remove('drag-over'));
}

function onSubtabDrop(e, targetKey) {
  e.preventDefault();
  e.currentTarget.classList.remove('drag-over');
  if (!draggedSubtabKey || draggedSubtabKey === targetKey) { draggedSubtabKey = null; return; }
  const sec = SECTIONS[activeSection];

  // Build the new combined order. Start from the CURRENT displayed order so
  // newly-added pills (not yet in sec.subtabOrder) are positioned consistently.
  const currentOrder = getOrderedSubtabKeys(sec);
  const fromIdx = currentOrder.indexOf(draggedSubtabKey);
  const toIdx = currentOrder.indexOf(targetKey);
  if (fromIdx < 0 || toIdx < 0) { draggedSubtabKey = null; return; }
  const [moved] = currentOrder.splice(fromIdx, 1);
  // Forward drag (fromIdx < toIdx): after splice, target is now at (toIdx-1),
  // and "insert AFTER target" lands the moved item at toIdx. So just insert
  // at `toIdx` for both directions (the index already encodes direction).
  const insertAt = fromIdx < toIdx ? toIdx : toIdx;
  currentOrder.splice(insertAt, 0, moved);
  sec.subtabOrder = currentOrder;
  saveSubtabOrder(sec);

  // Same-type drops also touch the underlying data order so it stays aligned
  const draggedNotes = isNotesKey(draggedSubtabKey);
  const targetNotes = isNotesKey(targetKey);
  if (!draggedNotes && !targetNotes) {
    // Both table-Epics: reorder CSV rows to the new table-Epic sequence
    const orderedTableEpics = currentOrder.filter(k => !isNotesKey(k));
    pushUndo();
    reorderEpicsInRows(orderedTableEpics);
    save();
  } else if (draggedNotes && targetNotes) {
    // Both notes-Epics: re-sort notesEpics array to match
    const orderedIds = currentOrder.filter(isNotesKey).map(notesIdFromKey);
    sec.notesEpics.sort((a, b) => orderedIds.indexOf(a.id) - orderedIds.indexOf(b.id));
    saveNotesMeta(sec);
  }

  draggedSubtabKey = null;
  renderSubtabs();
  renderTable();
  showToast('✓ Reordered');
}


// Rebuilds sec.rows so that rows group together by Epic in the order given.
// Materializes inherited Epic values first so the "blank Epic = inherit from
// row above" pattern doesn't break when rows physically move.
function reorderEpicsInRows(newOrder) {
  const sec = SECTIONS[activeSection];
  const epicCi = epicColumnIndex(sec);
  if (epicCi < 0) return;

  // Fill in blank Epic cells from the row above so each row carries its own Epic
  let lastEpic = '';
  for (const r of sec.rows) {
    const v = (r[epicCi] || '').trim();
    if (v) lastEpic = v;
    else if (lastEpic) r[epicCi] = lastEpic;
  }

  // Group rows by their (now explicit) Epic value
  const groups = new Map();
  const noEpic = [];
  for (const r of sec.rows) {
    const v = (r[epicCi] || '').trim();
    if (!v) noEpic.push(r);
    else {
      if (!groups.has(v)) groups.set(v, []);
      groups.get(v).push(r);
    }
  }

  // Rebuild: any pre-Epic rows stay at top, then Epics in the new order,
  // then any Epics that somehow weren't in newOrder (defensive)
  const rebuilt = [...noEpic];
  for (const e of newOrder) {
    if (groups.has(e)) rebuilt.push(...groups.get(e));
  }
  for (const [e, rows] of groups) {
    if (!newOrder.includes(e)) rebuilt.push(...rows);
  }
  sec.rows = rebuilt;
}


function switchSubtab(name) {
  const sec = SECTIONS[activeSection];
  sec.activeSubtab = name;
  sec.outlineFocus = null;   // a view opens on all of its rows
  // Leaving notes mode if we were in it
  sec.activeNotesEpic = null;
  if (typeof rememberSubtab === 'function') rememberSubtab(activeSection, name);
  showTableView();
  selectedRows.clear(); selectedCols.clear();
  renderSubtabs();
  renderGroupOutline();
  renderTable();
}


function addSubtab() {
  pushUndo();
  const sec = SECTIONS[activeSection];
  if (sec.flat || epicColumnIndex(sec) < 0) _ungroupedToGrouped(sec);   // a flat (imported) table asked for a second table: it gets a Topic column first (the page's conversion: pill + tab list too)
  // The shared rule (mcp-server/shared/table-rules.mjs addTable - an MCP add runs the same code): the name "New Topic",
  // "New Topic 2"... (the mode's word, never "Epic"), the default column set as its own, one blank seed row filed under it.
  const name = TableRules.addTable(sec, TableRules.uniqueTableName(sec, 'New ' + LBL('epicNoun')));
  saveTableViews(sec);
  sec.activeSubtab = name;
  if (typeof rememberSubtab === 'function') rememberSubtab(activeSection, name);
  // Switch to the new Epic (table view). Without clearing activeNotesEpic, a
  // notes-Epic could stay the visually-active pill while activeSubtab points at
  // the new table Epic — an inconsistent dual-active state that made a later
  // rename edit the wrong (notes) pill.
  sec.activeNotesEpic = null;
  if (typeof showTableView === 'function') showTableView();
  // Append to the unified pill order so it lands at the end of the strip
  subtabOrderInsertAtEnd(sec, subtabKeyOfTable(name));
  save();
  renderSubtabs();
  renderTable();
}


// Deleting a FLAT section's one table (its ✕): the rows and the file's columns go, the domain and its notes stay -
// the same reach as deleting a table in a grouped domain. The domain is then table-less (bare # gutter) until the
// next import or "+ Add Table"; Undo brings the table back (state.js snapshots carry columns, rows and flat).
async function delFlatTable() {
  const sec = SECTIONS[activeSection];
  if (!sec.flat) return;
  const n = sec.rows.length;
  if (!(await showConfirmModal({
    title: 'Delete ' + LBL('epicNoun') + '?',
    message: `The table "${sec.title}" - its ${n} row${n === 1 ? '' : 's'} and ${Math.max(0, sec.columns.length - 1)} columns - will be permanently removed. The ${LBL('tabNoun').toLowerCase()} and its notes stay.`,
    okLabel: 'Delete', danger: true
  }))) return;
  pushUndo();
  sec.rows = []; sec.columns = ['#']; sec.defaultCols = ['#'];
  selectedRows.clear(); selectedCols.clear();
  if (typeof _clearGridView === 'function') _clearGridView(activeSection);
  save();
  sec.activeSubtab = defaultTableSubtab(sec);
  if (typeof rememberSubtab === 'function') rememberSubtab(activeSection, sec.activeSubtab);
  renderSubtabs();
  renderGroupOutline(); renderTable();
}

// A FLAT section (an imported file: the file's columns exactly, no grouping column) becomes a GROUPED one the
// moment the person asks for a second table (Rishabh 2026-09-29): the mode's Topic column is inserted right after
// the # gutter, every existing row is filed under the section's own name (the file's name), and `flat` is dropped
// and re-persisted (sections.json) so every tab and reload reads the table as grouped from here on. Until that
// moment the data stays exactly as the file had it.
function _ungroupedToGrouped(sec) {
  const topic = sec.title;
  TableRules.ungroupedToGrouped(sec, topic, LBL('epicNoun'));   // the shared rule: Topic column at 2, every row filed under the domain's title
  subtabOrderInsertAtEnd(sec, subtabKeyOfTable(topic));   // the file's own table keeps the first pill; the new table lands after it
  if (typeof _clearGridView === 'function') _clearGridView(activeSection);   // index-keyed sort/filter no longer lines up
  if (typeof saveSectionsConfig === 'function') saveSectionsConfig();
}


async function delSubtab(name) {
  const sec = SECTIONS[activeSection];
  const epicCi = epicColumnIndex(sec);
  if (epicCi < 0) return;
  // The same confirm a notes topic gets (Rishabh 2026-09-29: "table ke liye hai hi nahi"), with the row count.
  const n = sec.rows.filter((_, i) => effectiveEpic(sec.rows, i, epicCi) === name).length;
  if (!(await showConfirmModal({
    title: 'Delete ' + LBL('epicNoun') + '?',
    message: `"${name}" and its ${n} row${n === 1 ? '' : 's'} will be permanently removed.`,
    okLabel: 'Delete', danger: true
  }))) return;
  pushUndo();
  // The shared rule (mcp-server/shared/table-rules.mjs deleteTable): every row whose EFFECTIVE Topic is the name
  // (what the table showed, continuation rows included), its column set (+ every file column only it listed),
  // its Group by chain and its display labels.
  const gone = TableRules.deleteTable(sec, name);
  if (sec.activeSubtab === name) {
    sec.activeSubtab = null;   // resolved below, once the rows are gone: the next table, else Roadmap
  }
  selectedRows.clear(); selectedCols.clear();
  subtabOrderRemove(sec, subtabKeyOfTable(name));
  saveTableViews(sec);
  if (gone.labelsTouched) saveColumnLabels(sec);
  _syncPtColOverride(sec);
  save();
  if (!sec.activeSubtab) {
    sec.activeSubtab = defaultTableSubtab(sec);
    if (typeof rememberSubtab === 'function') rememberSubtab(activeSection, sec.activeSubtab);
  }
  renderSubtabs();
  renderGroupOutline();
  renderTable();
}

;
// ==== FILE: js/shared-read.js ====
// ── Shared-read: native within-journal VIEW of read-access shares (EV / Share V2) ──
//
// Model (Rishabh, locked): a chapter/subject a teacher shares "into their journal"
// with READ access appears in the recipient's OWN primary journal as a NATIVE,
// read-only, revocable subject/chapter — NOT a separate "Shared with me" shelf, and
// NOT a reader page. Nothing is copied into the recipient's store: the content is
// resolved LIVE from the product's immutable snapshot (ev_content) each render, gated
// by the SAME firestore.rules entitlement the reader uses. Revoke the entitlement ->
// the /ev/library row disappears (nav entry gone) AND the ev_content read denies
// (content gone) -> the shared subject/chapter vanishes on the next render, with
// nothing cached and nothing to chase.
//
// WHY IT CAN NEVER PERSIST (defense-in-depth, mirrors the blessed §5 design):
//   1. VIRTUAL nav (strip-on-save): the shared subject is a SECTIONS entry flagged
//      `_sharedVirtual`, and each shared chapter a notes-epic flagged `_sharedVirtual`.
//      Neither is ever written: saveSectionsConfig strips `_sharedVirtual` subjects,
//      saveNotesMeta strips `_sharedVirtual` epics, and they are never added to the
//      persisted subtab order. (The epic also carries `locked:true`, but see lever 2 -
//      that flag is INERT for the within-journal read; the strip is what protects it.)
//   2. NOT a global lock (deliberate): a `_sharedVirtual` epic REPORTS UN-locked -
//      __ttEpicLocked() is `epic.locked && !epic._sharedVirtual` (notes.js), so it
//      returns false here. This is on purpose: forcing effRO() true would freeze the
//      recipient's OWN primary journal (it hosts these virtual reads), so the read is
//      NOT protected by the store-shim /save swallow. Protection comes from levers 1+3
//      instead. (A MATERIALIZED locked copy - a real epic, NOT `_sharedVirtual` - DOES
//      drive the lock and relies on the shim swallow; that is a different render path.)
//   3. READ-ONLY render (the runtime lever): the shared boxes are rendered by
//      renderSharedEpicBoxes with NO edit toolbar, contenteditable=false, and NO
//      autosave handlers wired at all (a dedicated path, not renderNotesBoxes) - so no
//      /save is ever fired for a shared chapter in the first place. The ONE control a shared
//      box carries is the editable box's ⛶ fullscreen (Rishabh 2026-10-12: a dense diagram at
//      column width in the read view had nothing to click) - a view-only class toggle
//      (toggleNotesBoxFullscreen, notes-render.js), never a write.
//   4. THE ACCESS AUTHORITY = firestore.rules: ev_content is readable only with a LIVE
//      entitlement (evEntitled) / creator gate; revoke -> the read denies + the /ev/library
//      row disappears -> the virtual subject vanishes on the next render. Levers 1-3 keep
//      the recipient's store clean; the rules gate is what actually controls access.
//
// The distinguisher between "within journal" (Mode-1) and "as a book" (Mode-2 link)
// read shares is the product's `sourceBookId`: Mode-1 (ensureReadShareProduct) sets
// it; a plain Mode-2 link does not (null). Only `sourceBookId` reads render here; the
// link reads stay on the library "Shared with me" shelf (as-a-book is a later slice).

// Session state. Rebuilt on each initSharedRead() (boot / library refresh).
const _sharedRead = {
  loaded: false,
  epicsBySectionKey: new Map(),   // virtual SECTIONS key -> [virtualEpic]
  hidden: [],                     // read shares the recipient DISMISSED (for the in-journal "🙈 Hidden" surface)
};
const _sharedBoxCache = new Map();   // productId -> ev_content boxes (per-session read cache)
// R15-1 (Rishabh 2026-09-14): the DELIVERY each cached product was read under. A re-share after a reopen recreates the
// product under the SAME deterministic id with new boxes (R14-7), and the reader's re-accept mints a new grant - so a
// cached product whose stamp changed is stale by definition and is dropped at the next open (initSharedRead). The
// same grant re-opened still reads from the cache; only "the same id, a different delivery" refetches.
const _sharedBoxStamp = new Map();   // productId -> the stamp (grantedAt / publishedAt) its boxes were cached under

// A shared READ box renders through the tracker's own diagram/video block renderers, which add
// their MUTATION controls (edit / edit-source / delete a diagram; remove a video) unconditionally.
// Those are write affordances that must never appear on read-only shared content (the store is
// read-only anyway - the shim swallows the write - but showing them is misleading). Hide them with
// one idempotent stylesheet scoped to `.notes-box--shared`; the read-only PNG DOWNLOAD stays (a
// reader may legitimately save the diagram). CSS beats a DOM sweep because the diagram block renders
// ASYNC (its controls appear after setEditorContent returns) - a rule always applies once they do.
function _ensureSharedReadStyles() {
  if (typeof document === 'undefined' || document.getElementById('sharedReadStyles')) return;
  const st = document.createElement('style');
  st.id = 'sharedReadStyles';
  st.textContent =
    '.notes-box--shared .excalidraw-edit-btn,' +
    '.notes-box--shared .excalidraw-edit-src,' +
    '.notes-box--shared .excalidraw-del-btn,' +
    '.notes-box--shared .vfb-remove{display:none !important;}' +
    // the editable strip appears on focus-within; a read-only box is never focused, so its one ⛶ is always there
    '.notes-box--shared .notes-box-actions{opacity:1;pointer-events:auto;}';
  document.head.appendChild(st);
}

// A read-only shared chapter CANNOT save VIEW prefs (layout / fit) to its meta - the virtual epic is
// stripped on save. So each viewer's OWN choice is remembered in localStorage, keyed by productId +
// chapter index, and re-applied when the virtual epic is rebuilt - so a refresh keeps the chosen layout
// (Rishabh 2026-08-11: "losing my selected layout on refresh must not happen in ANY sharing case").
function _srSavedView(productId, ci, prop) {
  try { return localStorage.getItem('evReadView:' + String(productId) + ':' + (ci || 0) + ':' + prop) || null; } catch (_) { return null; }
}

// A stable virtual SECTIONS key for one SOURCE subject of one sender+book. Same
// source subject -> same key across renders, so re-opening lands on the same tab.
function _sharedSubjectKey(p, sectionFile) {
  return 'shared~' + String(p.creatorUid || 'x') + '~' + String(p.sourceBookId || 'default') + '~' + String(sectionFile || 'sec');
}

async function _sharedFetchJson(path) {
  const cloud = (typeof window !== 'undefined') && window.__ttCloud;
  if (!cloud || typeof cloud.idToken !== 'function') throw new Error('cloud not ready');
  const base = cloud.mcpBase || '';
  const token = await cloud.idToken();
  const res = await fetch(base + path, { headers: { authorization: 'Bearer ' + token } });
  if (!res.ok) throw new Error('ev fetch ' + res.status);
  return res.json();
}
async function _sharedPostJson(path, body) {
  const cloud = (typeof window !== 'undefined') && window.__ttCloud;
  if (!cloud || typeof cloud.idToken !== 'function') throw new Error('cloud not ready');
  const base = cloud.mcpBase || '';
  const token = await cloud.idToken();
  const res = await fetch(base + path, {
    method: 'POST',
    headers: { authorization: 'Bearer ' + token, 'content-type': 'application/json' },
    body: JSON.stringify(body || {}),
  });
  let data = null; try { data = await res.json(); } catch (_) { /* non-JSON error */ }
  if (!res.ok) throw new Error((data && data.error) || ('ev post ' + res.status));
  return data || {};
}

// Build the virtual subjects/epics from the recipient's LIVE read-entitlements.
// Called on boot (data.js init) after sections + notes-meta load. Best-effort: if
// the MCP is unreachable the journal simply shows no shared subjects (same tolerance
// as the library shelf) — this never blocks the journal from loading.
async function initSharedRead() {
  _sharedRead.epicsBySectionKey = new Map();
  _sharedRead.loaded = false;

  // BOOK-AWARE (Rishabh 2026-08-11): which book is active decides WHICH reads render here.
  //  - primary journal (empty prefix): within-journal reads (destination 'journal' / carry sourceBookId)
  //  - a received-read book ('srread~<productId>~'): ONLY that product's read, as its own subjects
  //  - any other book (a materialized edit copy, a normal book): NONE - a read never leaks across books
  const activePrefix = (typeof window !== 'undefined' && window.__ttActiveBookPrefix) || '';
  const srMatch = /^srread~(.+)~$/.exec(activePrefix);
  //  - the AUTHOR's per-version viewer ('srview~<productId>~'): the author's OWN snapshot,
  //    read directly from the product (creator-gated), NOT from /ev/library.
  const svMatch = /^srview~(.+)~$/.exec(activePrefix);
  if (activePrefix !== '' && !srMatch && !svMatch) { _sharedRead.hidden = []; _sharedRead.loaded = true; refreshHiddenSharedBtn(); return; }

  // Read set + the subject-key SCOPE for the active book. A within-journal read is scoped by its source
  // book; a received-read/viewer book is scoped by its productId so two book-reads never merge into one subject.
  let reads, scope, withinJournal = false, sourceOrders = {};   // sourceOrders: /ev/library's per-version source orders (R14-5c) - function scope, the sort below reads it
  if (svMatch) {
    // AUTHOR's per-version read-only VIEWER: source = the author's OWN snapshot product (read
    // directly, firestore.rules evCreator), NOT /ev/library purchases (the author holds no
    // entitlement to their own product). One product = its own subjects, exactly like a received read.
    const pid = svMatch[1];
    const _cloud = (typeof window !== 'undefined') && window.__ttCloud;
    let prod = null, loadErr = null;
    try { prod = (_cloud && typeof _cloud.readEvProduct === 'function') ? await _cloud.readEvProduct(pid) : null; }
    catch (e) { loadErr = e; }
    if (loadErr) {
      // A GENUINE read error (permission/network) is NOT "empty" - surface it, never render a
      // misleading empty book for the author's OWN content (no defensive swallow, per project rule).
      console.error('[shared-read] snapshot could not be loaded:', (loadErr && loadErr.message) || loadErr);
      if (typeof showToast === 'function') showToast('⚠ This shared version could not be loaded - try again.');
      _sharedRead.hidden = []; _sharedRead.loaded = true; refreshHiddenSharedBtn(); return;
    }
    // prod === null here = the product is CONFIRMED missing (deleted): an empty viewer is correct.
    if (!prod) { _sharedRead.hidden = []; _sharedRead.loaded = true; refreshHiddenSharedBtn(); return; }
    reads = [{ productId: pid, creatorUid: prod.creatorUid || null, items: Array.isArray(prod.items) ? prod.items : [], sourceBookTitle: prod.title || 'Shared', productVersion: prod.version, _contentStamp: prod.frozenAt || prod.publishedAt || null }];   // R15-1: the author's snapshot has no grant - its stamp is the shell's freeze time (a checkpoint carries frozenAt, versions.js; a read product publishedAt, read-share.js)
    scope = () => pid;
    _sharedRead.hidden = [];
  } else {
    let purchases = [];
    try { ({ purchases, sourceOrders = {} } = await _sharedFetchJson('/ev/library')); }   // sourceOrders: each held version's source order ONCE, keyed; rows carry sourceOrderKey (R14-5c)
    catch (e) { console.warn('[shared-read] /ev/library unavailable:', (e && e.message) || e); return; }
    if (srMatch) {
      // The card's products (books-store.js joins them into the id, 'srread~a+b'): their union renders as ONE book (G1) -
      // one subject per source subject across all of them, an overlapping chapter once (the _srcSeen dedupe below).
      const pids = new Set(srMatch[1].split('+'));
      reads = (purchases || []).filter(p => p && (p.level || 'read') === 'read' && pids.has(String(p.productId)));
      // H21: the access ended while this view was open (the owner revoked it, or it was deleted from another tab) - the
      // fresh set holds none of the card's products. Drop what the session cached of it and leave for the dashboard with
      // one notice; an empty book is never the answer.
      if (!reads.length) { pids.forEach((pid) => _sharedBoxCache.delete(pid)); _sharedRead.hidden = []; _sharedRead.loaded = true; refreshHiddenSharedBtn(); _leaveGoneShare(); return; }
      scope = () => srMatch[1];   // one scope for the whole card, so its products' subjects merge
      _sharedRead.hidden = [];   // "hide" is a within-journal control; a received book is dropped whole (Remove), not hidden
    } else {
      withinJournal = true;   // F-37: ONLY this inline path re-adds a compact "- vN" marker on coexisting-version subject tabs (no header/card carries it here)
      // Within-journal READ = a read-level entitlement in the journal lane (destination 'journal', or a
      // legacy product carrying sourceBookId). Exclude any the recipient DISMISSED (hiddenByRecipient).
      const allJournalReads = (purchases || []).filter(p => p && (p.level || 'read') === 'read' && (p.destination === 'journal' || p.sourceBookId));
      reads = allJournalReads.filter(p => !p.hiddenByRecipient);
      scope = (p) => (p.sourceBookId || 'default');
      // The DISMISSED ones drive the in-journal "🙈 Hidden" surface (managed from WITHIN the journal).
      _sharedRead.hidden = allJournalReads.filter(p => p.hiddenByRecipient);
    }
  }

  // R15-1: a product delivered again under a NEW grant is read again - the boxes cached under the old grant may be
  // another content (reopen -> edit -> re-freeze -> re-share lands on the same product id). Same stamp = same boxes.
  for (const p of reads) {
    if (!p || !p.productId) continue;
    const pid = String(p.productId), stamp = String(p._contentStamp != null ? p._contentStamp : (p.grantedAt || ''));
    if (_sharedBoxStamp.get(pid) !== stamp) { _sharedBoxCache.delete(pid); _sharedBoxStamp.set(pid, stamp); }
  }

  // Group by SOURCE subject (sectionFile). Each source subject becomes one virtual subject in the active
  // container; its shared chapters become locked pills. Content resolves LIVE from the product each render.
  for (const p of reads) {
    // v2+ read shares co-exist with v1 (no auto-revoke). A version bump versions the SUBJECT: each source
    // subject gets its own "Subject (v2)" tab holding that version's chapters bare (no chapter suffixing).
    const ver = p.productVersion;
    const isBumped = !!(ver && !['shared', 'v1'].includes(String(ver)));
    // F-37: the version is shown on the CARD badge + the open-book HEADER, NOT appended to subject/tab
    // names. `ver`/`isBumped`/`versionOnSubject` stay (the subject KEY still versions its tab so v1 and v2
    // never merge), but the "(vN)" suffix is no longer concatenated onto the visible title/epic name.
    const versionOnSubject = isBumped;
    (p.items || []).forEach((it, ci) => {
      if (!it) return;
      const key = 'shared~' + String(p.creatorUid || 'x') + '~' + scope(p) + '~' + String(it.sectionFile || 'sec') + (versionOnSubject ? '~' + String(ver) : '');
      if (!_sharedRead.epicsBySectionKey.has(key)) {
        const baseTitle = it.sectionTitle || p.sourceBookTitle || 'Shared';
        // F-37 exception: the WITHIN-JOURNAL inline path re-adds a compact "- vN" version marker on the
        // subject tab, because here co-existing versions (v1 + v2+) render as SIBLING tabs with no other
        // per-version indicator (no srread/srview open-book header, no per-version card). srread/srview keep
        // clean titles (their header carries "- vN"). v1 (isBumped=false) stays unmarked as the base.
        const _titleVer = (withinJournal && versionOnSubject) ? (' - v' + ((String(ver).match(/\d+/) || [ver])[0])) : '';
        _sharedRead.epicsBySectionKey.set(key, { title: baseTitle + _titleVer, epics: [], _file: String(it.sectionFile || '') });   // _file: the source section, for the source-order sort below
      }
      const group = _sharedRead.epicsBySectionKey.get(key);
      const epicId = 'shared~' + String(p.productId) + '~' + ci;
      if (group.epics.some(e => e.id === epicId)) return;   // idempotent (same product re-added this render)
      // F7 (Rishabh 2026-08-28): dedup an OVERLAPPING source chapter to ONCE per (subject, version). Two
      // products (e.g. a {ch1,ch2} share + a {ch2,ch3} share of the SAME version) each carry ch2; without
      // this it renders twice. Key by the SOURCE chapter identity (sectionFile::epicId), scoped to this
      // group - the group key already versions the tab, so a different-version overlap stays a separate tab.
      const _f7src = String(it.sectionFile || '') + '::' + String(it.epicId != null ? it.epicId : ('name:' + (it.epicName || '')));
      if (!group._srcSeen) group._srcSeen = new Set();
      if (group._srcSeen.has(_f7src)) return;
      group._srcSeen.add(_f7src);
      // View-pref precedence: viewer-saved -> author-frozen (it.layout/it.fit) -> stack. The Fit
      // ternary uses a NULL check: '0' = viewer explicitly turned Fit off (stays off); null = the
      // viewer never chose -> fall back to the author's frozen fit.
      const _svLayout = _srSavedView(p.productId, ci, 'layout');
      const _svFit = _srSavedView(p.productId, ci, 'fit');
      group.epics.push({
        id: epicId,
        name: (it.epicName || 'Shared'),
        locked: true,
        _sharedVirtual: true,
        _sharedProductId: String(p.productId),
        _sharedVersion: ver || null,
        _sharedCi: ci,
        _srcKey: String(it.sectionFile || '') + '|' + String(it.epicName || ''),   // the checkpoint's chapter key ('file|name'), for the source-order sort below
        layout: _svLayout || (it && it.layout) || 'stack',
        // fit: the viewer's saved choice ('0' = off, anything else saved = on; the old 'screen' / '1' read as on) else the
        // author's frozen one (false = off, anything else stored = on; nothing stored = the default, notesFitMode).
        ...((() => { const v = _svFit != null ? (_svFit === '0' ? false : 'content') : (it && it.fit === false ? false : (it && it.fit ? 'content' : undefined)); return v !== undefined ? { fit: v } : {}; })()),
        boxes: [],
      });
    });
  }

  // R14-5 (Rishabh 2026-09-14): the union card's tabs and pills follow the SOURCE's order, not the order its shares arrived
  // in - the rule G1 gave the editable copy. The order comes with /ev/library (sourceOrders, ONE entry per held version:
  // sections by file, chapters by 'file|name', from the version's checkpoint; a row names its key). One card = one version,
  // so any row's key is the card's. A legacy product carries none -> the map keeps arrival order, as before. Stable sorts:
  // a section or chapter the order does not know keeps its place after the known ones.
  if (srMatch) {
    const order = reads.map((p) => p && p.sourceOrderKey && sourceOrders[p.sourceOrderKey]).find((o) => o && Array.isArray(o.sections));
    if (order) {
      const pos = (list, k) => { const i = (list || []).indexOf(k); return i < 0 ? Infinity : i; };
      const secs = [..._sharedRead.epicsBySectionKey.entries()].map(([k, g], i) => ({ k, g, i }))
        .sort((a, b) => (pos(order.sections, a.g._file) - pos(order.sections, b.g._file)) || (a.i - b.i));   // Infinity - Infinity is NaN (falsy) -> arrival tiebreak
      for (const { g } of secs) g.epics = g.epics.map((e, i) => ({ e, i })).sort((a, b) => (pos(order.chapters, a.e._srcKey) - pos(order.chapters, b.e._srcKey)) || (a.i - b.i)).map(({ e }) => e);
      _sharedRead.epicsBySectionKey = new Map(secs.map(({ k, g }) => [k, g]));
    }
  }

  // PRUNE (A2): initSharedRead is the ONE authority - the recipient's live read
  // entitlements. A revoked or superseded grant is simply absent from the fresh set, so
  // its virtual epic (and an emptied virtual subject) is REMOVED here - never left as a
  // broken locked shell. Only runs on a SUCCESSFUL fetch above (a transient MCP outage
  // returns early and leaves the prior view intact, not wiped).
  const _validEpicIds = new Set();
  for (const g of _sharedRead.epicsBySectionKey.values()) for (const e of g.epics) _validEpicIds.add(e.id);
  for (const k of Object.keys(SECTIONS)) {
    const s = SECTIONS[k];
    if (!s || !s._sharedVirtual) continue;
    if (Array.isArray(s.notesEpics)) s.notesEpics = s.notesEpics.filter((e) => !e._sharedVirtual || _validEpicIds.has(e.id));
    // A synthetic ("shared~...") subject with no shared chapters left, and no longer in the
    // fresh set, is dropped entirely (the subject tab disappears too).
    if (!_sharedRead.epicsBySectionKey.has(k) && (!s.notesEpics || !s.notesEpics.some((e) => e._sharedVirtual))) delete SECTIONS[k];
  }

  // Materialize a VIRTUAL SECTIONS entry per source subject (never persisted).
  for (const [key, group] of _sharedRead.epicsBySectionKey) {
    if (!SECTIONS[key]) {
      SECTIONS[key] = {
        title: group.title,
        file: key,                 // synthetic; stripped from sections.json on save
        columns: [], rows: [],
        // NO defaultCols: a shared subject is VIEW-ONLY notes chapters, not a table. Giving it
        // NEW_TAB_COLS made epicColumnIndex fall back to them (epicCi>=0), which surfaced a
        // "+ Add Table" pill + table affordances on the teacher's projection. Empty => notes-only.
        defaultCols: [],
        notesEpics: [],
        _sharedVirtual: true,
        _sharedSubjKey: key,
      };
    } else {
      SECTIONS[key]._sharedVirtual = true;
      SECTIONS[key]._sharedSubjKey = key;
      SECTIONS[key].title = group.title;
    }
  }

  // R14-5: the tab order is SECTIONS' key order. Re-insert the card's virtual subjects in the map's (source) order, so a
  // re-render after a later share lands the new subject where the source has it, not at the end.
  if (srMatch) for (const key of _sharedRead.epicsBySectionKey.keys()) { const s = SECTIONS[key]; delete SECTIONS[key]; SECTIONS[key] = s; }

  _sharedRead.loaded = true;
  // Inject into every (virtual) subject now that the map is ready.
  for (const key of _sharedRead.epicsBySectionKey.keys()) injectSharedEpics(SECTIONS[key]);
  // Reflect the current hidden count on the header button (appears only when >0).
  refreshHiddenSharedBtn();
}

// H21: the open read view lost its access. Back to the dashboard with one notice - never an empty page. The #/book hash
// is cleared WITHOUT a hashchange (a hashchange would route() into a second enter()), then the dashboard is entered through
// its own path (enter() -> leaveActive resets the read-only book state) and its own toast says why.
function _leaveGoneShare() {
  const lib = (typeof window !== 'undefined') && window.__ttLibrary;
  if (!lib || typeof lib.enter !== 'function') return;
  history.replaceState(null, '', location.pathname + location.search);
  // R14-4 (Rishabh 2026-09-14, prod RUN): force the rebuild - a plain enter() re-shows the shelf from its cached /ev/library,
  // so the revoked card stayed on My books until a reload. Delete's path already forces; the two exits now agree.
  lib.enter(true);
  if (typeof lib.toast === 'function') lib.toast('This share is no longer available.');
}

// H21: a deleted (dropped) or revoked read leaves nothing behind - the per-session box cache of its products goes with it,
// so opening another share can never serve a chapter of the gone one from memory. The dashboard's Delete paths call this
// (book-actions.js deleteReceivedRead, shared-with-me.js doDrop) right after the /ev/drop lands.
function forgetSharedRead(productIds) { for (const pid of (productIds || [])) _sharedBoxCache.delete(String(pid)); }

// Append this section's virtual shared epics (idempotent). Called at the end of a
// section (re)load — switchTab reloads notes-meta from disk (which would wipe the
// virtual epics), so this re-adds them each time. No-op for non-virtual sections.
function injectSharedEpics(sec) {
  if (!_sharedRead.loaded || !sec) return;
  const key = sec._sharedSubjKey || Object.keys(SECTIONS).find(k => SECTIONS[k] === sec);
  if (!key) return;
  const group = _sharedRead.epicsBySectionKey.get(key);
  if (!group) return;
  sec.notesEpics = sec.notesEpics || [];
  const have = new Set(sec.notesEpics.map(e => e.id));
  for (const e of group.epics) if (!have.has(e.id)) sec.notesEpics.push(e);
}

// Read the product's ev_content boxes ONCE per session (cached). Gated client-side by
// firestore.rules evEntitled (the same gate the reader uses) — a revoked entitlement
// throws/denies here, which renders the "no longer available" state. Returns null on
// deny/failure so the caller can show the revoked state (not a stale render).
async function _sharedReadBoxes(productId) {
  if (_sharedBoxCache.has(productId)) return _sharedBoxCache.get(productId);
  const cloud = (typeof window !== 'undefined') && window.__ttCloud;
  if (!cloud || typeof cloud.readEvBoxes !== 'function') return null;
  let boxes = null;
  try { boxes = await cloud.readEvBoxes(productId); }
  catch (_) { boxes = null; }
  // /ev/scenes was not OK: the boxes carry UNRESOLVED diagram refs (readEvBoxes flags this). Do NOT
  // cache them - a transient blip must not stick raw ```excalidraw-ref text for the whole session; a
  // later open re-fetches. Surface it to the reader (a toast), not just a console warning.
  if (boxes && boxes._scenesFailed) {
    if (typeof window !== 'undefined' && typeof window.showToast === 'function') {
      window.showToast('A diagram could not load - refresh to try again.');
    }
    return boxes;
  }
  if (boxes) _sharedBoxCache.set(productId, boxes);
  return boxes;
}

// A tiny right-click menu for shared read content (items: [{label, onClick}]). Positioned at
// the cursor, clamped to the viewport, dismissed on the next outside click / Escape.
function _evHideContextMenu() { const m = document.getElementById('evCtxMenu'); if (m) m.remove(); }
function _evShowContextMenu(x, y, items) {
  _evHideContextMenu();
  const m = document.createElement('div');
  m.id = 'evCtxMenu';
  m.style.cssText = "position:fixed;z-index:100000;background:var(--ev-white);border:1px solid var(--ev-btn-line);border-radius:8px;box-shadow:0 8px 28px rgba(0,0,0,.18);padding:.3rem;min-width:190px;font-family:'Instrument Sans','Inter',system-ui,sans-serif;font-size:.88rem";
  items.forEach((it) => {
    const b = document.createElement('div');
    b.textContent = it.label;
    b.style.cssText = 'padding:.5rem .7rem;border-radius:6px;cursor:pointer;color:var(--ev-ink)';
    b.addEventListener('mouseenter', () => { b.style.background = 'var(--ev-menu-hover)'; });
    b.addEventListener('mouseleave', () => { b.style.background = ''; });
    b.addEventListener('click', () => { _evHideContextMenu(); it.onClick(); });
    m.appendChild(b);
  });
  document.body.appendChild(m);
  const r = m.getBoundingClientRect();
  m.style.left = Math.max(6, Math.min(x, window.innerWidth - r.width - 8)) + 'px';
  m.style.top = Math.max(6, Math.min(y, window.innerHeight - r.height - 8)) + 'px';
  const onDoc = (ev) => { if (!m.contains(ev.target)) { _evHideContextMenu(); cleanup(); } };
  const onKey = (ev) => { if (ev.key === 'Escape') { _evHideContextMenu(); cleanup(); } };
  const cleanup = () => { document.removeEventListener('mousedown', onDoc, true); document.removeEventListener('keydown', onKey, true); };
  setTimeout(() => { document.addEventListener('mousedown', onDoc, true); document.addEventListener('keydown', onKey, true); }, 0);
}

// After a hide/un-hide removes the currently-open shared chapter (or its whole subject), LAND on
// a valid view through the app's OWN render path - NEVER a hand-injected placeholder, which left
// the gone chapter's editor chrome (outline + toolbar) on screen over a raw sentence with a
// dangling activeNotesEpic (the "in-between" broken state). Call AFTER initSharedRead() re-derived
// + renderTabs painted:
//   - active subject removed (its last shared chapter hidden) -> switch to another subject tab;
//   - active chapter removed but siblings remain              -> open the first remaining chapter;
//   - active chapter still present (hid a non-open one)       -> just repaint the pills.
function _landAfterSharedChange() {
  const keys = Object.keys(SECTIONS);
  if (!keys.length) return;
  if (!SECTIONS[activeSection]) { if (typeof switchTab === 'function') switchTab(keys[0]); return; }
  const sec = SECTIONS[activeSection];
  const stillHasActive = sec.activeNotesEpic && (sec.notesEpics || []).some((n) => n.id === sec.activeNotesEpic);
  if (stillHasActive) { if (typeof renderSubtabs === 'function') renderSubtabs(); return; }
  const firstEpic = (sec.notesEpics || [])[0];
  if (firstEpic && typeof openEpic === 'function') {
    openEpic(firstEpic.id).then(() => { if (typeof renderSubtabs === 'function') renderSubtabs(); });
    return;
  }
  // No chapters left but the subject still exists (has a table view) -> its resolved landing.
  sec.activeNotesEpic = null;
  if (typeof switchTab === 'function') switchTab(activeSection);
}

// The recipient HIDES a read-only shared chapter from their own journal (the control that
// was missing - a student could not remove read content). Read is no-copy, so this is a
// per-recipient DISMISS (server /ev/dismiss sets hiddenByRecipient), NOT a delete: the
// teacher keeps sharing it, and a re-share brings it back. Reconciles the view by dropping
// the epic from nav then RE-DERIVING from the live entitlements (the ONE authority) - the
// same no-broken-shell path as a revoke.
// A read grant is ONE product covering the whole selection the sender sent, and /ev/dismiss
// flips the flag on that product - so hiding is per-GRANT, never per-chapter. Both callers below
// therefore have to state the REAL scope up front: whatever else arrived in the same share goes
// with it. Scans every section, because one grant can span subjects.
function _sharedScopeOf(productIds) {
  const want = new Set(productIds);
  const out = [];
  const secs = (typeof SECTIONS !== 'undefined' && SECTIONS) ? SECTIONS : {};
  for (const k of Object.keys(secs)) {
    for (const e of ((secs[k] && secs[k].notesEpics) || [])) {
      if (e && e._sharedVirtual && want.has(e._sharedProductId)) out.push(e);
    }
  }
  return out;
}

async function _hideSharedChapter(sec, epic) {
  if (!epic || !epic._sharedProductId) return;
  const chL = (typeof LBL === 'function' ? LBL('epicNoun') : 'chapter');
  const productId = epic._sharedProductId;
  const alsoGoes = _sharedScopeOf([productId]).filter((e) => e !== epic).map((e) => e.name || '');
  const ok = await showConfirmModal(alsoGoes.length ? {
    title: 'Hide all ' + (alsoGoes.length + 1) + ' ' + chL.toLowerCase() + 's from this share?',
    message: '"' + epic.name + '" arrived in the same share as ' + alsoGoes.map((n) => '"' + n + '"').join(', ') + ', so they hide together. Hidden only for you - the teacher keeps sharing them, and they come back if they share them again.',
    okLabel: 'Hide all',
  } : {
    title: 'Hide this read-only ' + chL + ' from your space?',
    message: 'It is hidden only for you - the teacher keeps sharing it, and it comes back if they share it again.',
    okLabel: 'Hide',
  });
  if (!ok) return;
  try { await _sharedPostJson('/ev/dismiss', { productId }); }
  catch (e) { if (typeof window.showToast === 'function') window.showToast('Could not hide it - ' + ((e && e.message) || e)); return; }
  _sharedBoxCache.delete(productId);
  // Re-derive from the live entitlements (the ONE authority - initSharedRead's PRUNE drops the
  // now-hidden chapter from SECTIONS), repaint the tabs, then LAND cleanly via the app's own
  // render path. (The old code hand-injected a "Hidden..." sentence into #notesBoxes and left
  // the gone chapter's editor chrome + a dangling activeNotesEpic on screen - the broken state.)
  await initSharedRead();
  if (typeof renderTabs === 'function') renderTabs();
  _landAfterSharedChange();
  if (typeof window.showToast === 'function') window.showToast('Hidden from your space.');
}

// Hide a WHOLE shared subject (all its read chapters) from the recipient's journal - the
// subject-tab right-click action. Dismisses each distinct product, then re-derives.
async function _hideSharedSubject(sec) {
  if (!sec) return;
  const chL = (typeof LBL === 'function' ? LBL('epicNoun') : 'chapter');
  const eps = (sec.notesEpics || []).filter((e) => e._sharedVirtual && e._sharedProductId);
  if (!eps.length) return;
  const pids = Array.from(new Set(eps.map((e) => e._sharedProductId)));
  const extra = _sharedScopeOf(pids).length - eps.length;   // same grants, chapters sitting in OTHER subjects
  const ok = await showConfirmModal({
    title: 'Hide this whole shared subject (' + eps.length + ' ' + chL + (eps.length === 1 ? '' : 's') + ') from your space?',
    message: (extra > 0
      ? 'These arrived as whole shares, so ' + extra + ' more ' + chL.toLowerCase() + (extra === 1 ? '' : 's') + ' in other subjects hide too. '
      : '') + 'Hidden only for you - the teacher keeps sharing it, and it comes back if they share it again.',
    okLabel: 'Hide',
  });
  if (!ok) return;
  for (const pid of pids) {
    try { await _sharedPostJson('/ev/dismiss', { productId: pid }); _sharedBoxCache.delete(pid); }
    catch (e) { if (typeof window.showToast === 'function') window.showToast('Could not hide one item - ' + ((e && e.message) || e)); }
  }
  await initSharedRead();
  if (typeof renderTabs === 'function') renderTabs();
  _landAfterSharedChange();   // the hidden subject's tab is gone -> switch to a valid tab (no orphaned view)
  if (typeof window.showToast === 'function') window.showToast('Subject hidden from your space.');
}

// ── In-journal "🙈 Hidden by you" surface (manage-hidden lives WITHIN the journal) ──
// Rishabh's altitude correction (2026-08-08): hidden read content belongs to THIS journal,
// so the un-hide surface must live inside it - a header button next to "Export links" - NOT
// the Library dashboard (the outside book-list level). The button carries a live count and
// only appears when the recipient has hidden something; clicking it opens the panel below.
function refreshHiddenSharedBtn() {
  const b = (typeof document !== 'undefined') && document.getElementById('hiddenSharedBtnTop');
  if (!b) return;
  const n = (_sharedRead.hidden || []).length;
  if (n > 0) { b.style.display = ''; b.textContent = '🙈 Hidden (' + n + ')'; }
  else { b.style.display = 'none'; }
}

// Un-hide ONE dismissed share (bring it back into the journal). `hidden:false` clears the
// server flag; then RE-DERIVE from the live entitlements (the ONE authority) so the subject/
// chapter reappears natively, and refresh the button + count. Throws on failure (the caller
// re-enables its button + toasts) - no swallow.
async function _showHiddenShared(productId) {
  await _sharedPostJson('/ev/dismiss', { productId, hidden: false });
  _sharedBoxCache.delete(productId);
  await initSharedRead();
  if (typeof renderTabs === 'function') renderTabs();
  if (typeof renderSubtabs === 'function') renderSubtabs();
  refreshHiddenSharedBtn();
}

// The panel: everything the recipient hid, each row = one dismissed share (subject + its
// chapters) with a "Show" to bring it back. Reuses the deployed share-modal look (tts-* via
// ensureShareStyles). Rows come from _sharedRead.hidden (already fetched by initSharedRead -
// no extra round-trip). Re-renders after each un-hide; closes itself when nothing is left.
function openHiddenShared() {
  if (typeof ensureShareStyles === 'function') ensureShareStyles();
  const chL = (typeof LBL === 'function' ? LBL('epicNoun') : 'chapter');
  const ov = document.createElement('div'); ov.className = 'tts-overlay';
  const panel = document.createElement('div'); panel.className = 'tts-panel';
  panel.innerHTML =
    `<div class="tts-hd"><div><h3>🙈 Hidden by you</h3>` +
    `<div class="sub">Read-only shared content you hid from this space. Show one to bring it back - the teacher is still sharing it.</div></div></div>` +
    `<div id="hsList"></div>` +
    `<div class="tts-foot tts-foot-r"><button class="tts-btn" id="hsClose">Close</button></div>`;
  ov.appendChild(panel);
  document.body.appendChild(ov);
  const close = () => { ov.remove(); document.removeEventListener('keydown', onKey, true); };
  const onKey = (e) => { if (e.key === 'Escape') close(); };
  document.addEventListener('keydown', onKey, true);
  ov.addEventListener('mousedown', (e) => { if (e.target === ov) close(); });   // backdrop dismiss
  panel.querySelector('#hsClose').addEventListener('click', close);

  const listEl = panel.querySelector('#hsList');
  const renderList = () => {
    const hidden = _sharedRead.hidden || [];
    if (!hidden.length) { close(); if (typeof window.showToast === 'function') window.showToast('Nothing hidden - all back in your space.'); return; }
    listEl.innerHTML = hidden.map((p) => {
      const subj = (p.items && p.items[0] && p.items[0].sectionTitle) || p.sourceBookTitle || 'Shared';
      const chapters = (p.items || []).map((i) => i && i.epicName).filter(Boolean).join(', ') || chL;
      const ver = (p.productVersion && !['shared', 'v1'].includes(String(p.productVersion))) ? ' - v' + ((String(p.productVersion).match(/\d+/) || [p.productVersion])[0]) : '';   // F-37: "- vN", not "(vN)"
      return `<div class="hs-row" style="display:flex;align-items:center;justify-content:space-between;gap:.75rem;padding:.6rem .2rem;border-bottom:1px solid var(--ev-line)">` +
        `<div style="min-width:0"><div style="font-weight:600;color:var(--ev-ink)">${esc(subj)}</div>` +
        `<div style="color:var(--ev-muted);font-size:.85rem;overflow:hidden;text-overflow:ellipsis">${esc(chapters + ver)} · view-only</div></div>` +
        `<button class="tts-btn tts-btn-primary hs-show" data-pid="${esc(String(p.productId))}">Show</button></div>`;
    }).join('');
    listEl.querySelectorAll('.hs-show').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const pid = btn.getAttribute('data-pid');
        btn.disabled = true; btn.textContent = 'Showing…';
        try { await _showHiddenShared(pid); }
        catch (e) { btn.disabled = false; btn.textContent = 'Show'; if (typeof window.showToast === 'function') window.showToast('Could not show it - ' + ((e && e.message) || e)); return; }
        renderList();   // _sharedRead.hidden refreshed by initSharedRead; re-render (auto-closes if empty)
      });
    });
  };
  renderList();
}

// Render ONE shared chapter (a virtual, locked notes-epic) into #notesBoxes: fully
// native look (setEditorContent, the tracker's own markdown renderer + .notes-box CSS)
// but READ-ONLY — no per-box toolbar, contenteditable=false, no autosave handlers.
// Called from openNotesEpic when epic._sharedVirtual. Media (images) served gated via
// /ev/media. Text + images only in this slice; PDF/video inline is a later slice.
async function renderSharedEpicBoxes(sec, epic) {
  const wrap = document.getElementById('notesBoxes');
  if (!wrap) return;
  _ensureSharedReadStyles();   // hide diagram/video MUTATION controls on read-only shared content
  document.body.classList.remove('tt-box-fs-active');
  wrap.dataset.layout = epic.layout || 'stack';
  wrap.dataset.fit = notesFitMode(epic);
  // Fit / resize / refresh re-call this for the SAME chapter. Rebuilding innerHTML would
  // re-create every <img>/<video>/<iframe> and RE-FETCH all media (Rishabh: "Fit reloads all
  // media" - deployed doesn't do this). If this chapter is already rendered, just re-apply the
  // view attrs above (Fit/layout are CSS toggles) and return - no rebuild, no refetch.
  // R15-1: ... and only while it is the SAME DELIVERY. The same card re-opened on one page after a re-share renders
  // into the same element under the same epic id - the box cache was already dropped on the new grant (initSharedRead),
  // but this return served the old DOM. The stamp the boxes were cached under must match too.
  const productId = epic._sharedProductId;
  const _stamp = String(_sharedBoxStamp.get(String(productId)) || '');
  if (wrap.dataset.sharedEpicId === epic.id && wrap.dataset.sharedStamp === _stamp && wrap.querySelector('.notes-box--shared')) { notesFitWindowSync(); return; }   // Fit may have just toggled: the cards follow

  const boxes = await _sharedReadBoxes(productId);
  if (!boxes) {
    // A2: the entitlement was revoked or SUPERSEDED -> this shared chapter DISAPPEARS,
    // never a broken locked shell. Drop it from nav NOW (the pill vanishes), show a
    // one-line neutral notice (not an editable box), then RE-DERIVE from the live
    // entitlements (the ONE authority) so a superseded v1 is replaced by v2 in the
    // recipient's subjects. The /ev/media gate stays the access authority - this only
    // reconciles the view to it.
    _sharedBoxCache.delete(productId);
    const key = (sec && sec._sharedSubjKey) || Object.keys(SECTIONS).find((k) => SECTIONS[k] === sec);
    if (sec && Array.isArray(sec.notesEpics)) sec.notesEpics = sec.notesEpics.filter((e) => e.id !== epic.id);
    const grp = key && _sharedRead.epicsBySectionKey.get(key);
    if (grp) grp.epics = grp.epics.filter((e) => e.id !== epic.id);
    epic.boxes = [];
    wrap.innerHTML = '<div class="notes-editor" style="padding:1rem;color:var(--ev-muted)">This shared ' +
      (typeof LBL === 'function' ? LBL('epicNoun') : 'chapter') + ' is no longer shared with you.</div>';
    if (typeof renderSubtabs === 'function') renderSubtabs();
    initSharedRead().then(() => { if (typeof renderTabs === 'function') renderTabs(); if (typeof renderSubtabs === 'function') renderSubtabs(); });
    return;
  }
  // A product may bundle several chapters; each box id is namespaced "<ci>__<boxId>".
  const mine = boxes.filter(b => String(b.boxId).startsWith(epic._sharedCi + '__'))
                    .sort((a, b) => (a.order || 0) - (b.order || 0));
  // Carry each box's markdown on the box itself. It is the single source of truth
  // (from ev_content) and lets the outline parser read `#`/`##`/`###` headings
  // WITHOUT a DOM round-trip - the shared editors are contenteditable=false and the
  // outline otherwise fell back to "Box N". Never persisted (a _sharedVirtual epic is
  // stripped on save).
  // title = first # heading (the roadmap card + outline cache read box.title for a chapter that is
  // not the live-open one; a shared read box carried no title, so the roadmap fell back to "Box N").
  epic.boxes = mine.map(b => ({ id: b.boxId, md: b.md, title: (typeof _firstH1 === 'function' ? _firstH1(b.md) : '') }));

  // NO banner: the ONE parent 🔒 (subject tab) + tooltip already conveys "view only", so a
  // "Read-only... nothing is copied" bar is redundant clutter (Rishabh). The recipient's HIDE
  // control lives in a RIGHT-CLICK menu on the content - read-only, so: Copy the selection (a
  // reader can copy TEXT; no book is materialized) + Hide this chapter from their own journal.
  wrap.innerHTML = mine.map(b =>
    // the SLOT around each box, as the editable render has (notes-render.js): the grid item that keeps a Fit box's
    // room on the page while the box is a sticky card (notes-fit-window.js)
    '<div class="notes-slot">' +
    `<div class="notes-box notes-box--shared" data-box-id="${esc(b.boxId)}">` +
    // the editable box's ⛶ (same classes: .notes-box-actions / .box-action.box-fs, so the fullscreen CSS and the
    // "only ⛶ while fullscreen" rule apply unchanged); Esc exits through notes-render's global handler
    `<div class="notes-box-actions"><button class="box-action box-fs" onclick="toggleNotesBoxFullscreen('${esc(b.boxId)}')" title="Fullscreen this box (Esc to exit) - useful for wide tables">⛶</button></div>` +
    // data-box-id on the editor too (matches the editable render) so the outline's
    // scroll-to-heading (scrollNotesToLine) can locate this box. No autosave is ever
    // wired here - contenteditable=false + the shared path returns before flushSave.
    `<div class="notes-editor" data-box-id="${esc(b.boxId)}" contenteditable="false" spellcheck="false"></div></div>` +
    '</div>'
  ).join('');
  wrap.dataset.sharedEpicId = epic.id;   // mark rendered so a Fit/resize re-call skips the rebuild (above)
  wrap.dataset.sharedStamp = _stamp;     // R15-1: ... for this delivery only
  wrap.oncontextmenu = (e) => {
    e.preventDefault();
    const items = [];
    const sel = (typeof window.getSelection === 'function') ? String(window.getSelection() || '').trim() : '';
    if (sel) items.push({ label: 'Copy', onClick: () => { try { navigator.clipboard.writeText(sel); } catch (_) {} } });
    if (!items.length) return;   // "Hide from my space" is not offered for now (Rishabh 2026-10-13); with no selection there is nothing to show
    _evShowContextMenu(e.clientX, e.clientY, items);
  };

  const editors = wrap.querySelectorAll('.notes-editor');
  mine.forEach((b, i) => {
    const editor = editors[i];
    if (!editor) return;
    // Stamp the active shared product so notes.js's PDF fetchers (via _evProductOf/closest)
    // resolve bytes through the gated /ev/media relay instead of the own-store /load shim,
    // which 404s for a recipient. Covers the initial embed, the Preview toggle, and open-in-tab.
    editor.dataset.evProduct = productId;
    if (typeof setEditorContent === 'function') setEditorContent(editor, b.md || '');
  });

  // openNotesEpic builds the toolbar (Layout controls, box-count gated) BEFORE this async box
  // fetch resolves, and the outline before the editors carry content - so on a shared chapter's
  // FIRST open both saw epic.boxes empty: no Layout bar (n=0) and no headings. Now that epic.boxes
  // + the editors are populated, rebuild both so they match the loaded content (idempotent; the
  // early-return above skips this on a Fit/resize re-call, where they are already correct).
  if (typeof renderNotesToolbar === 'function') renderNotesToolbar();
  if (typeof renderNotesOutline === 'function') renderNotesOutline();

  await hydrateSharedMedia(wrap, productId);
  await hydrateSharedVideo(wrap, productId);
  notesFitWindowSync();   // Fit: each box a sticky screen-tall card over its content-tall slot (notes-fit-window.js)
  // PDF needs NO separate resolver here: the editor is stamped with data-ev-product (above),
  // so notes.js's setEditorContent -> hydratePdfFrame (and the Preview toggle + open-in-tab)
  // fetch the bytes through the gated /ev/media relay via _evProductOf. Same for srview~bv_.
}

// Point each shared video's <video> at same-origin /ev-load so it streams PROGRESSIVELY
// via HTTP Range (starts playing after the first window; no whole-file wait). A shared
// clip's bytes live in the CREATOR's store, so /load (own-store) misses. The Service
// Worker (sw.js serveEvVideo) intercepts /ev-load and forwards the <video>'s Range to the
// entitlement-gated MCP /ev/media with the buyer's Bearer token (act-as-creator). We then
// REMOVE data-file so the tracker's own SW re-hydration (hydrateVideoFile) can't re-point
// this at the failing /load. Revocable gate intact: the SW re-hits /ev/media for EVERY
// range window, so a revoked entitlement -> 403 -> playback stops. Full-blob fetch (the
// old lag) is gone. Prime the SW with the buyer's auth ctx so the first play needs no
// cold-start round-trip (the SW also asks on demand as a fallback).
async function hydrateSharedVideo(container, productId) {
  const cloud = (typeof window !== 'undefined') && window.__ttCloud;
  if (!cloud || !container) return;
  const blocks = [...container.querySelectorAll('.video-file-block[data-file]')];
  if (!blocks.length) return;
  try { if (typeof cloud.pushEvCtx === 'function') cloud.pushEvCtx(); } catch (_) {}
  for (const block of blocks) {
    const file = block.getAttribute('data-file');
    const video = block.querySelector('video');
    if (!file || !video) continue;
    const src = '/ev-load?productId=' + encodeURIComponent(productId) + '&file=' + encodeURIComponent(file);
    if (video.getAttribute('src') === src) continue;   // already pointed
    video.src = src;
    video.addEventListener('loadedmetadata', () => { try { if (video.paused && !video.currentTime) video.currentTime = 0.05; } catch (_) {} }, { once: true });   // poster: show the first frame at rest instead of a black box
    block.removeAttribute('data-file');   // stop the tracker's SW re-hydration re-pointing this at /load
    try { video.load(); } catch (_) {}
  }
}

// Swap image refs (product-namespaced filenames left by publishProduct) for real
// bytes fetched through /ev/media (entitlement + exact file-scope, served
// act-as-creator). An <img> cannot carry an auth header -> fetch -> blob -> objectURL.
// Best-effort: a denied/missing file leaves a marked alt, never throws.
async function hydrateSharedMedia(container, productId) {
  const cloud = (typeof window !== 'undefined') && window.__ttCloud;
  if (!cloud || !container) return;
  const targets = [];
  container.querySelectorAll('img').forEach((img) => {
    let f = img.getAttribute('data-ev-file');
    if (!f) {
      const src = img.getAttribute('src') || '';
      if (!src || /^(https?:|data:|blob:)/i.test(src)) return;   // external / already-inline
      f = src.replace(/^\/load\?file=/, '').replace(/^.*\//, '');
      try { f = decodeURIComponent(f); } catch (_) {}
    }
    if (f) targets.push([img, f]);
  });
  if (!targets.length) return;
  let token; try { token = await cloud.idToken(); } catch (_) { return; }
  const base = cloud.mcpBase || '';
  // Each image is its own authed round trip - MEASURED at 400-650 ms cold against real files in
  // this store - and an `await` inside a for-loop made a chapter cost the SUM of them. Six images
  // measured 2,947 ms sequential against 799 ms with six in flight: 3.7x, and the per-image fetch
  // never got faster. The wait was that nothing overlapped.
  //
  // Bounded at six rather than an unbounded Promise.all: a hundred-image chapter would otherwise
  // open a hundred simultaneous authed requests. Per-image behaviour is unchanged - a failure still
  // strips the src and marks the image unavailable, and only that one image is affected.
  const hydrateOne = async ([img, f]) => {
    try {
      const res = await fetch(base + '/ev/media?productId=' + encodeURIComponent(productId) + '&file=' + encodeURIComponent(f),
        { headers: { authorization: 'Bearer ' + token } });
      if (!res.ok) { img.removeAttribute('src'); img.alt = (img.alt || 'Image') + ' (unavailable)'; return; }
      img.src = URL.createObjectURL(await res.blob());
      img.removeAttribute('data-ev-file');
    } catch (_) { /* leave placeholder + alt */ }
  };
  let next = 0;
  await Promise.all(Array.from({ length: Math.min(6, targets.length) }, async () => {
    while (next < targets.length) await hydrateOne(targets[next++]);
  }));
}

if (typeof window !== 'undefined') {
  window.initSharedRead = initSharedRead;
  window.injectSharedEpics = injectSharedEpics;
  window.renderSharedEpicBoxes = renderSharedEpicBoxes;
  window.openHiddenShared = openHiddenShared;
  window.refreshHiddenSharedBtn = refreshHiddenSharedBtn;
  window.forgetSharedRead = forgetSharedRead;
}

;
// ==== FILE: js/timeline.js ====
// ── Roadmap date / bucket helpers (shared) ──────────────────────────────────
//
// The standalone "timeline" epic type (its own swimlane board, created by the
// "+ Add Timeline" sub-tab) has been REMOVED. What remains here are the pure date
// and column-bucket helpers that the notes-roadmap (notes-roadmap.js) reuses to
// build its timeframe axis - the calendar grains (daily / weeks / months /
// quarters) and the user-shaped "horizons" grain. No DOM, no epic CRUD, no
// persistence: pure functions plus a few shared layout constants.

const TL_LANE_W = 170;                          // px, must match .tl-lane-head width in CSS
const TL_MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const TL_WEEKDAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const TL_COL_MIN_W = 0.2;                        // smallest a column's width weight may shrink to
const TL_COL_COLLAPSED_W = 0.05;                 // width weight a collapsed column shrinks to (thin strip; only needs to fit the vertical label)

// ── Date helpers (all at local midnight) ────────────────────────────────────
function _tlToday() { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
function _tlParse(iso) { if (!iso) return null; const p = String(iso).split('-').map(Number); return new Date(p[0], (p[1] || 1) - 1, p[2] || 1); }
function _tlIso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
function _tlAddDays(d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); }
function _tlMonthStart(k) { const t = _tlToday(); return new Date(t.getFullYear(), t.getMonth() + k, 1); }
function _tlQuarterStart(k) { const t = _tlToday(); const q = Math.floor(t.getMonth() / 3); return new Date(t.getFullYear(), q * 3 + 3 * k, 1); }
function _tlMD(d) { return TL_MONTHS[d.getMonth()] + ' ' + d.getDate(); }

// Columns for a grain, as real calendar ranges. Each: { label, sub, kind:
// 'past'|'now'|'future', start:Date|null, end:Date|null } (start inclusive,
// end exclusive; null = open-ended).
function _tlBuckets(grain, epic) {
  const t = _tlToday();
  const D = n => _tlAddDays(t, n);
  switch (grain) {
    case 'daily': {
      const out = [{ label: '◀ Earlier', sub: 'shipped', kind: 'past', start: null, end: t }];
      for (let i = 0; i < 5; i++) {
        const s = D(i);
        const label = i === 0 ? 'Today' : (i === 1 ? 'Tomorrow' : TL_WEEKDAYS[s.getDay()]);
        out.push({ label, sub: _tlMD(s), kind: i === 0 ? 'now' : 'future', start: s, end: D(i + 1) });
      }
      out.push({ label: 'Later ▶', sub: '5+ days', kind: 'future', start: D(5), end: null });
      return out;
    }
    case 'weeks': return [
      { label: '◀ Earlier', sub: 'shipped',  kind: 'past',   start: null,  end: t },
      { label: 'This week', sub: _tlMD(D(0)), kind: 'now',    start: D(0),  end: D(7) },
      { label: 'Next week', sub: _tlMD(D(7)), kind: 'future', start: D(7),  end: D(14) },
      { label: 'Week +2',   sub: _tlMD(D(14)), kind: 'future', start: D(14), end: D(21) },
      { label: 'Week +3',   sub: _tlMD(D(21)), kind: 'future', start: D(21), end: D(28) },
      { label: 'Later ▶',   sub: '4+ weeks', kind: 'future', start: D(28), end: null },
    ];
    case 'months': {
      const ms = _tlMonthStart;
      const nm = d => TL_MONTHS[d.getMonth()], yr = d => String(d.getFullYear());
      return [
        { label: '◀ Earlier',  sub: 'shipped',    kind: 'past',   start: null,  end: ms(0) },
        { label: nm(ms(0)),    sub: 'this month', kind: 'now',    start: ms(0), end: ms(1) },
        { label: nm(ms(1)),    sub: yr(ms(1)),    kind: 'future', start: ms(1), end: ms(2) },
        { label: nm(ms(2)),    sub: yr(ms(2)),    kind: 'future', start: ms(2), end: ms(3) },
        { label: nm(ms(3)),    sub: yr(ms(3)),    kind: 'future', start: ms(3), end: ms(4) },
        { label: 'Later ▶',    sub: '4+ months',  kind: 'future', start: ms(4), end: null },
      ];
    }
    case 'quarters': {
      const qs = _tlQuarterStart;
      const ql = d => 'Q' + (Math.floor(d.getMonth() / 3) + 1), yy = d => "'" + String(d.getFullYear()).slice(2);
      return [
        { label: '◀ Earlier', sub: 'shipped',            kind: 'past',   start: null,  end: qs(0) },
        { label: ql(qs(0)),   sub: yy(qs(0)) + ' · now', kind: 'now',    start: qs(0), end: qs(1) },
        { label: ql(qs(1)),   sub: yy(qs(1)),            kind: 'future', start: qs(1), end: qs(2) },
        { label: ql(qs(2)),   sub: yy(qs(2)),            kind: 'future', start: qs(2), end: qs(3) },
        { label: 'Later ▶',   sub: 'next year',          kind: 'future', start: qs(3), end: null },
      ];
    }
    default: return _tlHorizonBuckets(epic);   // horizons — user-editable telescoping windows
  }
}

// Horizons are the one grain the user shapes by hand (the others are strict
// calendar math). They're stored as a list of relative windows and still move with
// time: each window is anchored to today + a running day cursor, so the TODAY line
// keeps sliding as days pass. Shape:
//   { id, label, sub, kind:'past'|'now'|'future'|'later', span:<days> }
// 'past' = Done (…→today), 'later' = open-ended tail (cursor→∞). 'now'/'future'
// consume `span` days each. Only 'future' windows are add/delete-able; 'past',
// 'now' and 'later' are structural. `w` is the column's on-screen width weight
// (default 1 = equal columns; the user drags column edges to change it).
function _tlDefaultHorizons() {
  return [
    { id: 'h_done',  label: 'Done',       sub: 'shipped · behind you', kind: 'past' },
    { id: 'h_now',   label: 'Now',        sub: 'this week',            kind: 'now',    span: 7 },
    { id: 'h_next',  label: 'Next',       sub: 'next week',            kind: 'future', span: 7 },
    { id: 'h_m1',    label: 'This month', sub: 'weeks 3-4',            kind: 'future', span: 16 },
    { id: 'h_m2',    label: 'Next month', sub: '~30-60 days',          kind: 'future', span: 30 },
    { id: 'h_later', label: 'Later',      sub: 'someday · backlog',    kind: 'later' },
  ];
}
function _tlHorizonBuckets(epic) {
  const t = _tlToday();
  const hs = (epic && epic.horizons && epic.horizons.length) ? epic.horizons : _tlDefaultHorizons();
  const out = [];
  let cursor = t;
  for (const h of hs) {
    const collapsed = !!h.collapsed;
    const w = collapsed ? TL_COL_COLLAPSED_W : (h.w > 0 ? h.w : 1);   // collapsed → thin strip
    if (h.kind === 'past') {
      out.push({ label: h.label, sub: h.sub || '', kind: 'past', start: null, end: t, hid: h.id, hkind: 'past', w, collapsed });
    } else if (h.kind === 'later') {
      out.push({ label: h.label, sub: h.sub || '', kind: 'future', start: cursor, end: null, hid: h.id, hkind: 'later', w, collapsed });
    } else if (h.kind === 'future' && h.unallocated) {
      // Unallocated timeframe: the user added the column but hasn't scheduled it
      // yet (no card dropped in). It occupies ZERO time and does NOT advance the
      // cursor — so it stays inert: nothing auto-buckets into it by date and it
      // never shifts its neighbours. Dropping a card activates it (notes-roadmap
      // nrGridDrop sets a span + clears the flag).
      out.push({ label: h.label, sub: h.sub || '', kind: 'future', start: cursor, end: cursor, hid: h.id, hkind: 'future', w, collapsed, unallocated: true });
    } else {
      const span = Math.max(1, h.span || 7);
      const start = cursor, end = _tlAddDays(cursor, span);
      out.push({ label: h.label, sub: h.sub || '', kind: h.kind === 'now' ? 'now' : 'future', start, end, hid: h.id, hkind: h.kind, w, collapsed });
      cursor = end;
    }
  }
  return out;
}

function _tlPlace(buckets, date) {
  if (!date) return -1;
  return buckets.findIndex(b => !b.parallel && (!b.start || date >= b.start) && (!b.end || date < b.end));   // a Parallel column (roadmap) holds no dates
}
// Date to assign an entry when it's dropped / added into a bucket.
function _tlRepDate(b) {
  const t = _tlToday();
  if (b.kind === 'past') return _tlAddDays(t, -1);
  if (b.kind === 'now') return t;
  return b.start || t;
}

;
// ==== FILE: js/roadmap/state.js ====
// ── notes-roadmap / state ───────────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: shared module state + constants, selection, All-mode view prefs, edit-target resolution.
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

// The grain a chapter opens in before its owner picks one (Rishabh 2026-10-04: Daily, not Custom).
const NR_DEFAULT_GRAIN = 'months';   // Rishabh 2026-10-27 21:0x: "default roadmap monthly selected hona chahiye" (was 'daily'; carried by A on his word, B's file)
function _nrGrainOf(epic) { return (epic && epic.roadmapGrain) || NR_DEFAULT_GRAIN; }
// Column widths in the calendar grains: epic.roadmapColW[grain] = { <slot index>: <weight> } (a per-chapter
// view pref, per-section in All mode - the same carrier as roadmapCollapsed). The Custom grain keeps its
// weights on the shared column list (h.w). READ never creates; the writer creates and the reset deletes.
function _nrColWRead(epic, grain) { return (epic && epic.roadmapColW && epic.roadmapColW[grain]) || {}; }
function _nrColWSet(epic, grain, idx, w) { epic.roadmapColW = epic.roadmapColW || {}; (epic.roadmapColW[grain] = epic.roadmapColW[grain] || {})[idx] = w; }
function _nrColWReset(epic, grain) { if (!epic.roadmapColW || !epic.roadmapColW[grain]) return false; delete epic.roadmapColW[grain]; if (!Object.keys(epic.roadmapColW).length) delete epic.roadmapColW; return true; }
// Parallel columns (Rishabh 2026-10-05: "things the user will do in parallel with all the others"): dateless
// columns drawn in EVERY grain, just before Later. A card dropped there is pinned by entry.parallelId and keeps
// its dates; dragging it out unpins it; removing the column unpins every card it held (the modal's promise).
// ONE owner: the chapter (epic.roadmapParallel: [{ id, label, sub, collapsed, w }], ids 'p1', 'p2' ... = the
// lowest free). The Roadmap tab owns no list of its own: it DERIVES the union of its sections' chapters' columns
// by id (the first chapter's label wins), so a pin made in a chapter shows there and the tab can add, rename or
// remove nothing (there is no second copy to drift). READ never creates.
function _nrParallelRead(epic) {
  if (!epic) return [];
  if (epic.id) return Array.isArray(epic.roadmapParallel) ? epic.roadmapParallel : [];
  const seen = new Map();                                 // the All-mode pref carrier: derive
  Object.keys(SECTIONS).forEach(k => ((SECTIONS[k] || {}).notesEpics || []).forEach(e => (Array.isArray(e.roadmapParallel) ? e.roadmapParallel : []).forEach(p => { if (!seen.has(p.id)) seen.set(p.id, p); })));
  return [...seen.values()];
}
// Take every pin to column `id` off the chapter's cards (a removal keeps its promise; a later column with the
// same id starts empty).
function _nrUnpinParallel(epic, id) {
  (epic.boxes || []).forEach(b => (Array.isArray(b.roadmapSchedule) ? b.roadmapSchedule : []).forEach(e => { if (e.parallelId === id) delete e.parallelId; }));
}
function _nrParallelOf(epic, hid) { const id = String(hid || '').replace(/^p:/, ''); return _nrParallelRead(epic).find(p => p.id === id) || null; }
function _nrIsParallelHid(hid) { return /^p:/.test(String(hid || '')); }
const NR_ROW_WORD = 'Row';   // a roadmap row group (lane) - NOT the notes topic / chapter (LBL('chapter')); Rishabh 2026-10-05
const NR_GRAINS = [['daily', 'Daily'], ['weeks', 'Weeks'], ['months', 'Months'], ['quarters', 'Quarters'], ['horizons', 'Custom']];   // Rishabh 2026-09-14: the grain reads "Custom" (the columns are the user's own)
const NR_NEW_SPAN = 14;      // days a freshly-added timeframe spans once a card activates it
const NR_COL_COLLAPSED_PX = 24;   // fixed px width of a collapsed timeframe column's strip (its vertical label always fits, never spills into a neighbour)
let _nrEdit = null;          // { boxId, idx } — the schedule entry being edited inline, or null
let _nrEditHzId = null;      // horizon (timeframe) whose label is being renamed inline
let _nrEditHzSubId = null;   // horizon whose subtitle is being edited inline
let _nrHzDrag = null;        // id of the timeframe column being drag-reordered (null otherwise)
let _nrEditLaneId = null;    // lane whose name is being renamed inline
let _nrEditLaneSubId = null; // lane whose subtitle is being edited inline
let _nrEditEpicId = null;    // aggregated Initiative (notes-epic) whose name is being renamed inline
let _nrColDrag = null;       // { hid, nextHid, startX, startW, startNextW, pxPerWeight } while resizing a column
let _nrSel = new Set();      // selected aggregated cards ("secKey|epicId|boxId|eidx") for bulk move
let _nrUndoStation = null;   // { secKey, epicId, box, idx } of the last soft-deleted station, for Undo
let _nrUndoTimer = null;     // dismiss timer for the undo toast
let _nrDeleteBusy = false;   // true while a station delete's meta save is in flight (blocks reentry so two deletes never race the meta file)
let _nrPromptCancel = null;  // the open prompt-modal's canceller, or null when none is open
let _nrMigratedSecs = new Set();  // sections whose entries have had their sticky horizonId back-filled this session
// The timeframe (horizon) columns are GLOBAL — one shared list across every subject
// and chapter, because the roadmap divides ONE timeline. They persist per-user in a
// single section-agnostic file and are cached here after the first load; null until
// then. (docs/ROADMAP_MODEL.md §7)
const ROADMAP_HORIZONS_FILE = 'roadmap_horizons.json';
let _nrGlobalHorizons = null;   // the shared column list; null until first load
let _nrHzLoading = false;       // true while the one-time async load is in flight
let _nrHzFailed = false;        // true after a hard load failure (500 / network) — the gate parks in an error+Retry state instead of retrying on every render
let _nrHeadH = 0;               // last-measured axis (header) height in px; the sticky header (z-index 6, opaque) overlays this much of every full-height collapsed strip, so labels must stay below it
function _nrClearEdits() { _nrEdit = null; _nrEditHzId = null; _nrEditHzSubId = null; _nrEditLaneId = null; _nrEditLaneSubId = null; _nrEditEpicId = null; _nrSel.clear(); }
function _nrSelKey(secKey, epicId, boxId, eidx) { return secKey + '|' + epicId + '|' + boxId + '|' + eidx; }
function _nrParseSelKey(k) { const p = String(k).split('|'); return { secKey: p[0], epicId: p[1], boxId: p[2], eidx: +p[3] }; }
// Toggle a card into / out of the multi-select set (aggregated views). The card's own
// click (edit) is suppressed so the checkbox is a pure selector.
function nrToggleSelect(e, secKey, epicId, boxId, eidx) {
  if (e) { e.stopPropagation(); e.preventDefault(); }
  const k = _nrSelKey(secKey, epicId, boxId, eidx);
  if (_nrSel.has(k)) _nrSel.delete(k); else _nrSel.add(k);
  renderNotesRoadmap();
}
function nrClearSel() { if (_nrSel.size) { _nrSel.clear(); renderNotesRoadmap(); } }

// The active NOTES epic (never a timeline epic — that has its own renderer).
function _nrEpic() {
  const sec = SECTIONS[activeSection];
  if (!sec) return null;
  return (sec.notesEpics || []).find(n => n.id === sec.activeNotesEpic && n.type !== 'timeline') || null;
}

// ── The section "Roadmap" sub-tab: chapter-less aggregate ("All mode") ───────
// The always-visible Roadmap sub-tab renders the section-wide aggregated roadmap
// with NO chapter open, so its view prefs can't hang off an epic. All mode is
// DERIVED from nav state (activeSubtab === 'Roadmap' + no active notes-epic), so
// nothing has to be cleared when a chapter later opens. Prefs persist per-section
// in localStorage — client-only view state, not board data.
function _nrIsAllMode() {
  const sec = SECTIONS[activeSection];
  return !!(sec && sec.activeSubtab === 'Roadmap' && !sec.activeNotesEpic);
}
let _nrAllPrefsCache = null;                    // { secKey, prefs } — last section's loaded prefs
function _nrAllPrefsKey(secKey) { return '__ttRoadmapPrefs__' + secKey; }
function _nrAllPrefs() {
  const secKey = activeSection;
  if (_nrAllPrefsCache && _nrAllPrefsCache.secKey === secKey) return _nrAllPrefsCache.prefs;
  let prefs;
  try { const raw = localStorage.getItem(_nrAllPrefsKey(secKey)); prefs = raw ? JSON.parse(raw) : {}; }
  catch (_) { prefs = {}; }
  // Valid JSON that is not a plain object (null / number / string / array) parses
  // without throwing, so guard it explicitly - localStorage is user-writable, and
  // setting fields on a non-object below would throw outside the try and brick the tab.
  if (!prefs || typeof prefs !== 'object' || Array.isArray(prefs)) prefs = {};
  // Invariants for the Roadmap tab: always "on", section-wide by default, and NEVER
  // chapter-scoped (there is no active chapter here). Grain defaults to horizons.
  prefs.roadmap = true;
  if (prefs.roadmapScope !== 'all') prefs.roadmapScope = 'subject';
  if (!prefs.roadmapGrain) prefs.roadmapGrain = NR_DEFAULT_GRAIN;
  _nrAllPrefsCache = { secKey, prefs };
  return prefs;
}
// May the viewer WRITE what this roadmap is drawn from? Every control that changes the
// board asks this ONE question instead of each one guessing - which is how the roadmap came
// to be the only editing surface in the app that never asked at all.
//
// Two INDEPENDENT read-only shapes exist and both must answer true:
//   - a received book opened as-a-book -> the whole app is read-only, so the body carries
//     tt-readonly (effRO). All mode has no chapter, so this is the only signal there.
//   - a read share sitting INSIDE the viewer's own journal -> the body is deliberately NOT
//     read-only (it would freeze their own journal - see __ttEpicLocked), so the chapter's
//     own `locked` is the only signal.
// It keys on `locked`, never on `_sharedVirtual`: a MATERIALIZED view-only copy is locked
// without being virtual, and it can arrive already carrying a roadmap.
// Pass the epic when you already hold it (the notes toolbar does); otherwise the active one.
function _nrReadOnly(epic) {
  if (typeof document !== 'undefined' && document.body && document.body.classList.contains('tt-readonly')) return true;
  const e = (epic === undefined) ? _nrEpic() : epic;
  return !!(e && e.locked);
}

// The pref carrier the render + toolbar handlers read/write: in All mode a
// localStorage-backed object; otherwise the active chapter epic (unchanged).
function _nrPrefEpic() { return _nrIsAllMode() ? _nrAllPrefs() : _nrEpic(); }
// Persist a pref change: All mode → localStorage (view state); chapter → the epic's
// notes-meta (unchanged path). Called by the toolbar handlers in place of saveNotesMeta.
function _nrSavePrefs() {
  if (_nrIsAllMode()) {
    _nrAllPrefsCache = { secKey: activeSection, prefs: _nrAllPrefs() };
    try { localStorage.setItem(_nrAllPrefsKey(activeSection), JSON.stringify(_nrAllPrefs())); } catch (_) {}
  } else {
    _nrSaveMeta(SECTIONS[activeSection]);
  }
}

// The section / epic / box a card edit currently targets. _nrEdit carries the OWNING
// section + epic (not just boxId), so an aggregated card edits + saves into its own Area
// (subject), not the active one. Returns null if the target no longer exists.
function _nrEditTarget() {
  if (!_nrEdit) return null;
  const sec = SECTIONS[_nrEdit.secKey];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === _nrEdit.epicId);
  const box = epic && (epic.boxes || []).find(b => b.id === _nrEdit.boxId);
  return box ? { sec, epic, box } : null;
}

// R4 freeze, driven by the ↕ Fit toggle (epic.fit → .tl-scroll gets .nr-fit / .nr-compact):
//
// FIT ON (.nr-fit): the board stays FULL height and the PAGE scrolls (all lanes
// reachable); the header is CSS position:sticky to the WINDOW - .tl-scroll is no scroll
// container in this mode (overflow visible, styles.css), so sticky reaches the window.
// (Until 2026-10-28 it floated by a transform written on every scroll event, a frame
// behind the page - Rishabh: "frozen header bahut lag karta hai". Removed.)
//
// FIT OFF (.nr-compact): the box is bounded to the viewport (_nrFitScroll sets its
// max-height) and scrolls INTERNALLY, with a plain CSS position:sticky header. Compact.
//
// The header lives inside .tl-scroll, so horizontal alignment with the columns is
// automatic (it moves with scrollLeft); only the vertical behavior differs by mode.
let _nrFcols = null; // { gNow, labelW } from the last render, so a resize can recompute --tl-fcols

let _nrScrollHooked = false;

// Drag an initiative row (by its ⋮⋮ grip) onto another row to reposition it.
let _nrLaneDrag = null;

// ── Card interactions ──────────────────────────────────────────────────────
// Single-click opens the inline editor for that entry; double-click jumps to the
// box's notes. Opening the editor is deferred so a double-click can cancel it
// (else the first click would flip the card to inputs and the browser would never
// see the double-click).
let _nrClickTimer = null;

;
// ==== FILE: js/roadmap/buckets.js ====
// ── notes-roadmap / buckets ─────────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: the timeframe axis (buckets), horizon-list load/save, schedule model, entry->column placement, sticky migration.
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

function _nrBuckets(epic) {
  const grain = _nrGrainOf(epic);
  const buckets = _tlBuckets(grain, { horizons: _nrGlobalHorizons });
  // Horizons carry their own collapse state (applied by _tlHorizonBuckets from the
  // shared _nrGlobalHorizons list). The calendar grains are fixed columns with no ids, so
  // give each a stable per-slot id ("grain:index") and apply collapse from a
  // per-grain index list on the epic — slots are stable (Today / +3 days / This
  // week …) even as the real dates slide, so a collapse sticks to its slot.
  if (grain !== 'horizons') {
    const collapsed = (epic.roadmapCollapsed && epic.roadmapCollapsed[grain]) || [];
    const widths = _nrColWRead(epic, grain);   // per-slot width weights the owner dragged (Rishabh 2026-10-04: resize in EVERY grain)
    buckets.forEach((b, i) => {
      b.hid = grain + ':' + i;
      if (collapsed.indexOf(i) !== -1) { b.collapsed = true; b.w = TL_COL_COLLAPSED_W; }
      else b.w = widths[i] > 0 ? widths[i] : 1;
    });
  }
  // Parallel columns sit just before Later (which stays the LAST bucket - the backlog slot every
  // writer counts on), in every grain; each carries its own collapse / width (state.js).
  const par = _nrParallelRead(epic);
  par.forEach((p, k) => buckets.splice(buckets.length - 1, 0, { label: p.label || 'Parallel', sub: p.sub || 'alongside everything', kind: 'future', parallel: true, hid: 'p:' + p.id, start: null, end: null, collapsed: !!p.collapsed, w: p.collapsed ? TL_COL_COLLAPSED_W : (p.w > 0 ? p.w : 1) }));
  return buckets;
}

// The shared horizon list (global across all subjects). The `epic` argument is kept
// for call-site compatibility but is no longer used — columns are not per-chapter.
// The render gate guarantees the list is loaded before any handler can run.
function _nrEnsureHorizons() {
  return _nrGlobalHorizons;
}

// The timeframe axis built from the shared horizon list, independent of any epic /
// grain. Used by _nrReflowHorizons to snapshot card positions across every subject.
function _nrHzAxis() {
  return _tlBuckets('horizons', { horizons: _nrGlobalHorizons });
}

// Load the shared horizon list once. If nothing is saved yet, SEED it by adopting
// the most-customized existing per-chapter list (the user's richest set) and persist
// it, so from then on every subject reads the same columns. Cached in _nrGlobalHorizons.
async function loadRoadmapHorizons() {
  const res = await fetch('/load?file=' + ROADMAP_HORIZONS_FILE);
  if (res.ok) {
    const json = JSON.parse(await res.text());
    _nrGlobalHorizons = (Array.isArray(json.horizons) && json.horizons.length) ? json.horizons : _nrSeedHorizons();
  } else if (res.status === 404) {
    _nrGlobalHorizons = _nrSeedHorizons();
    await saveRoadmapHorizons();       // persist the seed so the shared list is stable
  } else {
    throw new Error('roadmap horizons load failed: HTTP ' + res.status);
  }
  _nrGlobalHorizons.forEach(h => { if (!(h.w > 0)) h.w = 1; });   // default width weight = equal columns
  return _nrGlobalHorizons;
}

// Auto-adopt seed: scan every chapter in every subject and take the horizon list with
// the most entries (the user's richest custom set); fall back to the defaults. Deep-
// cloned so the shared list is independent of any one chapter's stored array.
function _nrSeedHorizons() {
  let best = null;
  Object.keys(SECTIONS).forEach(k => {
    (SECTIONS[k].notesEpics || []).forEach(ep => {
      const hs = ep.roadmapHorizons;
      if (Array.isArray(hs) && hs.length && (!best || hs.length > best.length)) best = hs;
    });
  });
  return JSON.parse(JSON.stringify(best || _tlDefaultHorizons()));
}

// Persist the shared horizon list to its section-agnostic file. Surfaces a failure as
// a toast (never a silent swallow, never an unhandled rejection). Writes are no-ops in
// read-only mode (the /save shim gates them), same as every other writer.
function saveRoadmapHorizons() {
  return fetch('/save', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename: ROADMAP_HORIZONS_FILE, csv: JSON.stringify({ horizons: _nrGlobalHorizons || [] }, null, 2) })
  }).then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); })
    .catch(() => showToast('⚠ Could not save timeframe columns'));
}

// Re-attempt the shared-horizon load after a hard failure. The render gate parks in
// an error state (does not auto-retry), so this explicit action is the only re-kick —
// a down server never gets hammered. Clearing the flag lets the gate load again.
function nrRetryHorizons() {
  _nrHzFailed = false;
  renderNotesRoadmap();
}

// ── Schedule (per-box list of column appearances) ────────────────────────────
// Read-only view of a box's schedule entries. Always returns ≥1 entry: converts
// the legacy single date+tasks+owner shape, and falls back to one empty Later
// entry for an untouched box (so every box still shows as a station).
function _nrEntries(box) {
  if (Array.isArray(box.roadmapSchedule) && box.roadmapSchedule.length) return box.roadmapSchedule;
  if (box.roadmapDate || (box.roadmapTasks && box.roadmapTasks.length) || box.roadmapOwner) {
    return [{ date: box.roadmapDate || null, tasks: (box.roadmapTasks || []).slice(), owner: box.roadmapOwner || '' }];
  }
  return [{ date: null, tasks: [], owner: '' }];
}

// Mutating: materialize box.roadmapSchedule (migrating the legacy fields once),
// then drop the legacy fields. Call before any write to a schedule entry.
function _nrEnsureSchedule(box) {
  if (!Array.isArray(box.roadmapSchedule) || !box.roadmapSchedule.length) {
    box.roadmapSchedule = _nrEntries(box).map(e => ({ date: e.date || null, tasks: (e.tasks || []).slice(), owner: e.owner || '' }));
  }
  delete box.roadmapDate; delete box.roadmapTasks; delete box.roadmapOwner;
  return box.roadmapSchedule;
}

// Which column an entry sits in. The date is a START date and the source of truth
// (all grains are just views of it):
//   • done            → the Done column
//   • no date         → Later (backlog)
//   • future start    → its future column (planned; slides into Now on its own)
//   • started + !done → pinned to Now (ongoing — it does NOT drift into Done as
//                       the calendar moves forward)
function _nrEntryBucket(entry, buckets) {
  if (entry.done) {
    const di = buckets.findIndex(b => b.kind === 'past');
    return di >= 0 ? di : 0;
  }
  // Pinned to a Parallel column (state.js): shown there in every grain, its dates untouched. A pin to a
  // column this board does not have (the Roadmap tab's list differs) falls through to the date placement.
  if (entry.parallelId) {
    const pi = buckets.findIndex(b => b.parallel && b.hid === 'p:' + entry.parallelId);
    if (pi >= 0) return pi;
  }
  // Sticky column (pull-based): a card pinned to a horizon stays there regardless of the calendar -
  // ONLY a user drag moves it. Matches only in the horizons grain (calendar grains use 'grain:index'
  // hids that never match a horizon id, so this falls through to date placement).
  if (entry.horizonId) {
    const hi = buckets.findIndex(b => b.hid === entry.horizonId && b.kind !== 'past');
    if (hi >= 0) return hi;
  }
  if (!entry.date) return buckets.length - 1;
  const i = _tlPlace(buckets, _tlParse(entry.date));
  if (i < 0) return buckets.length - 1;
  // Date-based fallback (calendar grains / pre-migration only - a migrated horizons card takes the
  // sticky path above and never reaches here). A started-past card is clamped up to Now so it does
  // not fall into the Done/past bucket by date. This clamp is NOT the horizons auto-drift Rishabh hit
  // (that was the whole axis sliding under fixed dates, now fixed by the sticky horizonId above).
  const nowIdx = buckets.findIndex(b => b.kind === 'now');
  if (nowIdx >= 0 && i < nowIdx) return nowIdx;
  return i;
}

// True when a bucket is a real horizon (its hid is in the shared horizon list) - i.e. the board is in
// the horizons grain. Calendar grains ('daily:2' etc.) return false, so placement stays date-based.
function _nrIsHorizonBucket(b) {
  return !!(b && (_nrGlobalHorizons || []).some(h => h.id === b.hid));
}

// One-time (per session, per section) sticky-column back-fill. Existing entries have no horizonId, so
// in the horizons grain they'd keep date-drifting. Stamp each DATED, non-done entry's horizonId from
// the horizon bucket it CURRENTLY shows in - freezing every card exactly where it sits (zero visible
// jump) - then persist once. Idempotent (next load finds horizonId set -> no-op). GUARDED by the edit
// lock: a read-only / locked-out tab must NOT write, or two tabs race the meta file. Date-less entries
// (permanent Later) are skipped (they never drift; also avoids materializing empty boxes).
function _nrMigrateStickyColumns(secKey) {
  if (_nrMigratedSecs.has(secKey)) return;
  if (!window.__ttCloud) return;             // cloud bridge not ready yet → skip WITHOUT marking (retry next render); parity with restore.js
  if (window.__ttCloud.readOnly()) return;   // lock guard: a read-only / locked-out tab must not write (retry once we're the editor; do NOT mark migrated)
  _nrMigratedSecs.add(secKey);
  const sec = SECTIONS[secKey];
  if (!sec || !Array.isArray(sec.notesEpics)) return;
  const hz = _nrHzAxis();
  if (!hz.length) return;
  let changed = false;
  for (const epic of sec.notesEpics) {
    if (_nrReadOnly(epic)) continue;           // a read share / locked copy is not this viewer's to stamp - a READ never writes it (the store lock above is store-wide, this is per chapter)
    for (const box of (epic.boxes || [])) {
      if (!_nrEntries(box).some(e => !e.done && !e.horizonId && e.date)) continue;   // nothing driftable here
      _nrEnsureSchedule(box).forEach(e => {
        if (e.done || e.horizonId || !e.date) return;
        const b = hz[_nrEntryBucket(e, hz)];
        if (b && b.kind !== 'past') { e.horizonId = b.hid; changed = true; }
      });
    }
  }
  if (changed) saveNotesMeta(sec);
}

// Deferred pass over every section (called off the render frame). Each section migrates at most once,
// idempotent + lock-guarded. Covers ALL sections so the aggregated ("All") view - which shows many
// sections at once - is consistent, not just the active one.
function _nrMigrateVisibleColumns() {
  for (const k of Object.keys(SECTIONS)) _nrMigrateStickyColumns(k);
}

;
// ==== FILE: js/roadmap/model.js ====
// ── notes-roadmap / model ───────────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: the read-model pivot - lanes, scope/group-by, gather, and per-card facts (title / status / date lifecycle).
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

// ── Lanes (category bands grouping initiatives) ──────────────────────────────
// An initiative (box) belongs to one lane; the roadmap draws one row per lane.
function _nrLanes(epic) {
  if (Array.isArray(epic.roadmapLanes) && epic.roadmapLanes.length) return epic.roadmapLanes;
  return [{ id: 'l_all', name: '' }];
}
// The implicit lane ('l_all') is persisted with NO name: its label is derived at render time (the chapter's own name,
// _nrLaneDisplayName), and a derived fact is not stored - storing the pack's word of the day orphaned every lane on the
// next rename (J, 2026-09-11). Lanes written before this rule carry the word that was current when they were written;
// these three are the only ones that ever were, so the set is closed and a future rename needs no entry here.
const NR_LEGACY_DEFAULT_LANE_NAMES = new Set(['Initiatives', 'Topics', 'Chapters']);
function _nrEnsureLanes(epic) {
  if (!Array.isArray(epic.roadmapLanes) || !epic.roadmapLanes.length) epic.roadmapLanes = [{ id: 'l_all', name: '' }];
  return epic.roadmapLanes;
}
// The box's lane; unassigned (or an unknown id) falls back to the first lane.
function _nrBoxLane(box, lanes) {
  if (box.roadmapLane && lanes.some(l => l.id === box.roadmapLane)) return box.roadmapLane;
  return lanes[0].id;
}
// Row label for a lane. The implicit default lane ('l_all' / "Initiatives") is
// shown as the chapter's own name (e.g. "DPDP"), so a chapter with no custom
// grouping reads as the Chapter it is, not a placeholder word.
function _nrLaneDisplayName(lane, epic) {
  if (lane.id === 'l_all' && (!lane.name || NR_LEGACY_DEFAULT_LANE_NAMES.has(lane.name))) return (epic && epic.name) || LBL('chapter');   // a user's own rename of l_all keeps its name (falls through)
  return lane.name;
}
// Lanes the layer-filter currently hides are stored by id on epic.roadmapHiddenLanes.
function _nrVisibleLanes(epic) {
  const hidden = new Set(epic.roadmapHiddenLanes || []);
  return _nrLanes(epic).filter(l => !hidden.has(l.id));
}

// Distinct owner names across every schedule entry (trimmed; '' = no owner,
// sunk to the bottom). Feeds the owner filter dropdown.
function _nrAllOwners(epic) {
  const seen = new Set(), owners = [];
  (epic.boxes || []).forEach(box => _nrEntries(box).forEach(e => {
    const o = (e.owner || '').trim();
    if (!seen.has(o)) { seen.add(o); owners.push(o); }
  }));
  return owners.sort((a, b) => (a === '' ? 1 : b === '' ? -1 : a.localeCompare(b)));
}

// True when this entry's owner is currently hidden by the owner filter. Hidden
// owner names (trimmed; '' = no owner) live on epic.roadmapHiddenOwners.
function _nrOwnerHidden(entry, epic) {
  const hidden = epic.roadmapHiddenOwners;
  return !!(hidden && hidden.length && hidden.includes((entry.owner || '').trim()));
}

// ── Scope + group-by (the pivot: one base table, different views) ────────────
// See docs/ROADMAP_MODEL.md. Scope = which sections (cards) to include; group-by
// = the row axis for aggregated (wider-than-chapter) scopes. Both are view prefs
// stored on the active chapter's epic. 'chapter' scope = today's editable board.
function _nrScope(epic) {
  const s = epic && epic.roadmapScope;
  return (s === 'subject' || s === 'all') ? s : 'chapter';
}
function _nrGroupBy(epic) {
  return (epic && epic.roadmapGroupBy === 'subject') ? 'subject' : 'chapter';
}

// Flat list of every section (box) in scope: [{ secKey, sec, epic, box, boxIdx }].
// 'chapter' = the active chapter only; 'subject' = every notes-chapter in the
// active subject; 'all' = every notes-chapter in every subject. Pure read.
function _nrGatherBoxes(scope) {
  const out = [];
  const keys = scope === 'all' ? Object.keys(SECTIONS) : [activeSection];
  const activeEp = _nrEpic();
  keys.forEach(k => {
    const sec = SECTIONS[k];
    (sec.notesEpics || []).forEach(ep => {
      if (ep.type === 'timeline') return;                 // timelines have their own renderer
      if (scope === 'chapter' && ep !== activeEp) return; // only the active chapter
      (ep.boxes || []).forEach((box, boxIdx) => out.push({ secKey: k, sec, epic: ep, box, boxIdx }));
    });
  });
  return out;
}

// True only when this box's live editor is the one actually mounted on screen —
// i.e. the box belongs to the ACTIVE section's ACTIVE notes-epic. Box ids are NOT
// globally unique (legacy epics all use the id "main"), so a bare
// querySelector('[data-box-id=...]') can match a DIFFERENT epic's editor; gate every
// live-DOM title read/write on this so an off-screen box never touches the mounted one.
function _nrBoxMounted(secKey, epicId) {
  const sec = SECTIONS[secKey];
  return !!sec && secKey === activeSection && sec.activeNotesEpic === epicId;
}

// Safe card title across scopes. _nrRealTitle reads the live DOM editor, which
// only exists for the ACTIVE chapter — for other chapters fall back to box.title
// then "Box N". (docs/ROADMAP_MODEL.md §8)
// The ONE "Box N" / "Section N" fallback (UI-A-2: the noun is per mode, from labels.js boxNoun). Every
// untitled-box label on the roadmap comes through here - _nrCardTitle, nrBoxTitle, cards-html - so a
// vocabulary change is one line, never three re-inlined copies (Agent B's constraint, 2026-09-18).
function nrBoxFallbackTitle(idx) { return LBL('boxNoun') + ' ' + (idx + 1); }
function _nrCardTitle(box, epic, boxIdx, secKey) {
  return _nrRealTitle(box, secKey, epic && epic.id) || nrBoxFallbackTitle(boxIdx);
}

// The box's title = its first top-level (#) heading, the single source of truth.
// Read it LIVE from the editor ONLY when the box is the mounted one (active section +
// active epic) — authoritative, may be ''. Otherwise fall back to box.title, the
// persisted cache for DOM-less reads (other chapters / aggregated scopes). Passing no
// scope forces the cache path. No "Box N" fallback here.
function _nrRealTitle(box, secKey, epicId) {
  if (_nrBoxMounted(secKey, epicId)) {
    const editor = document.querySelector(`.notes-editor[data-box-id="${box.id}"]`);
    if (editor && typeof getEditorContent === 'function' && typeof _firstH1 === 'function') {
      // A read-only SHARED editor (contenteditable=false) can yield no parseable heading from the
      // live DOM - fall back to the cached box.title rather than dropping to "Box N".
      const t = _firstH1(getEditorContent(editor));
      if (t) return t;
    }
  }
  return box.title || '';
}
// Station label = the box's sidebar title, with a "Box N" fallback.
function nrBoxTitle(box, idx) { return _nrRealTitle(box) || nrBoxFallbackTitle(idx); }

// ── Date lifecycle & time-gap tracking ─────────────────────────────────────
// Today as an ISO date (day granularity — every roadmap date is day-level).
function _nrTodayIso() { return _tlIso(_tlToday()); }
// Done status (entry.done) drives the board; the actual-finish DATE (entry.endDate) is a
// recorded fact. _nrMarkDone marks Done and stamps a finish (today) if none exists.
// _nrMarkNotDone (used by reschedule / re-open) un-marks Done but PRESERVES endDate, so a
// re-opened card keeps its historical finish. The finish date is deleted ONLY when the user
// explicitly clears the Actual-finish field in the editor (see _nrReadCardInputsInto).
function _nrMarkDone(entry) {
  if (!entry) return;
  entry.done = true;
  if (!entry.endDate) entry.endDate = _nrTodayIso();
}
function _nrMarkNotDone(entry) {
  if (!entry) return;
  entry.done = false;   // keep entry.endDate - the recorded finish survives a re-open
}
// Whole-day difference b - a (both ISO). null if either is missing / unparseable.
function _nrDayDiff(a, b) {
  const da = _tlParse(a), db = _tlParse(b);
  if (!da || !db) return null;
  return Math.round((db - da) / 86400000);
}
// May the viewer WRITE this one card? Asks _nrReadOnly (state.js) of the chapter the card
// BELONGS to - never the active one. The aggregated board (This area / All) draws cards
// from many chapters onto one axis, and All mode has no active chapter at all, so a card
// from a read-only share must answer true even while the active chapter is writable. Every
// station control and writer that holds a card's (secKey, epicId) asks this; one that
// already holds the card's epic object passes it to _nrReadOnly directly. A missing chapter
// resolves to null, never undefined: _nrReadOnly(undefined) means "use the active chapter",
// which is the wrong answer for a card.
function _nrCardReadOnly(secKey, epicId) {
  const sec = SECTIONS[secKey];
  return _nrReadOnly((sec && (sec.notesEpics || []).find(n => n.id === epicId)) || null);
}
// Is this section a live READ SHARE - someone else's work projected into the viewer's
// journal? Then nothing may be added into it: the rule the app's own addNotesEpic already
// applies (`_sharedVirtual`). The + Initiative guards ask this BESIDE the existing
// _nrReadOnly() check, never instead of it: All mode has no active chapter, so a read share
// sitting on the board among the viewer's own sections was otherwise offered + Initiative.
// It asks the SECTION, never "are its chapters locked": a materialized locked copy in the
// viewer's OWN section does not stop them adding their own chapters there.
function _nrSectionIsReadShare(secKey) {
  const sec = SECTIONS[secKey];
  return !!(sec && sec._sharedVirtual);
}

// Tell the store's box-level merge that this tab DELETED a box, rather than never saw it.
// saveNotesMeta sends `deletedBoxIds`; fetch-shim mergeEpicLists adopts every stored box the
// payload lacks UNLESS its "<epicId> <boxId>" key is listed (so an MCP-created box survives a
// browser save). A station delete or a cross-chapter move that splices a box without saying so
// gets it merged straight back - and the undo-window expiry then deletes its notes, leaving a
// station with no .md. The set is notes-persistence.js's `_deletedBoxIds`; the key shape is the
// one notes-structure.js delNotesBox builds. Undo takes the key back out.
function _nrMarkBoxDeleted(epicId, boxId) { _deletedBoxIds.add(String(epicId) + ' ' + String(boxId)); }
function _nrUnmarkBoxDeleted(epicId, boxId) { _deletedBoxIds.delete(String(epicId) + ' ' + String(boxId)); }

// ── Row model (Rishabh 2026-10-05: one board row = the cards of ONE box; the order is purely vertical) ──
// One board ROW = ONE box: all of its cards (one per schedule entry) in the timeframe columns they
// fall in; several cards of the box in one column sit side by side in entry order. The rows of a
// GROUP (one lane on the chapter board, one chapter on the aggregated board) read in epic.boxes ORDER:
// the box order IS the row order, there is no second copy of it, so the notes view and the board can
// never disagree (a notes-view move is a board move; a board move reorders epic.boxes). Across lanes the
// order is free - each lane shows its own boxes in that order. SPACER rows ("gaps") sit between them:
// epic.roadmapGaps[laneId] (chapter board) / epic.roadmapGapsAgg (aggregated), row indexes. A box whose
// cards are all in collapsed columns (or that has none) has no row. Everything a drop touches sits in
// ONE chapter meta, so one drop = one save.
// READ the spacer rows (never creates - the render asks this for every lane on every paint, and a
// created-but-empty list would be saved as noise into the chapter meta).
function _nrGapsRead(epic, laneId) {
  if (laneId) return (epic.roadmapGaps && epic.roadmapGaps[laneId]) || [];
  return epic.roadmapGapsAgg || [];
}
function _nrGapsTidy(epic, laneId) {
  if (laneId) { if (epic.roadmapGaps && epic.roadmapGaps[laneId] && !epic.roadmapGaps[laneId].length) delete epic.roadmapGaps[laneId]; if (epic.roadmapGaps && !Object.keys(epic.roadmapGaps).length) delete epic.roadmapGaps; }
  else if (epic.roadmapGapsAgg && !epic.roadmapGapsAgg.length) delete epic.roadmapGapsAgg;
}
// The aggregated board renders every card regardless of the chapter's owner filter (chapter-scope
// only), so its row resolution must ignore that filter too - or a writer and the render would
// disagree about which row a card is on.
function _nrRowFilterEpic(epic, laneId) { return laneId ? epic : {}; }
function _nrRowGroupBoxes(epic, laneId) {
  const boxes = epic.boxes || [];
  if (!laneId) return boxes;
  const lanes = _nrLanes(epic);
  return boxes.filter(b => _nrBoxLane(b, lanes) === laneId);
}
// The rows of a group: its boxes in order, each on the next row that is not a spacer.
// Returns { rowOf: { boxId: row }, rowCount, colsOf(box) = the visible columns it has cards in }.
function _nrResolveRows(groupBoxes, buckets, epic, gaps) {
  const colsMemo = {};
  const colsOf = box => {
    if (colsMemo[box.id]) return colsMemo[box.id];
    const cs = [];
    _nrEntries(box).forEach(e => {
      if (_nrOwnerHidden(e, epic)) return;
      const c = _nrEntryBucket(e, buckets);
      if (buckets[c] && !buckets[c].collapsed && cs.indexOf(c) === -1) cs.push(c);
    });
    return colsMemo[box.id] = cs;
  };
  const spacer = new Set(gaps || []);
  const rowOf = {};
  let r = 0;
  groupBoxes.forEach(box => {
    if (!colsOf(box).length) return;
    while (spacer.has(r)) r++;
    rowOf[box.id] = r++;
  });
  const rows = Object.keys(rowOf).map(k => rowOf[k]).concat(gaps || []);
  return { rowOf, rowCount: rows.length ? Math.max.apply(null, rows) + 1 : 1, colsOf };
}
// The group as a LIST, top row first: { box } for a box's row, { gap: true } for a spacer row.
// `without` = a box joining the group: left out, so the rows are the ones the person saw.
function _nrRowItems(epic, laneId, buckets, without) {
  const group = _nrRowGroupBoxes(epic, laneId).filter(b => b !== without);
  const gaps = _nrGapsRead(epic, laneId);
  const { rowOf, rowCount } = _nrResolveRows(group, buckets, _nrRowFilterEpic(epic, laneId), gaps);
  const items = new Array(rowCount).fill(null);
  group.forEach(b => { if (rowOf[b.id] != null) items[rowOf[b.id]] = { box: b }; });
  gaps.forEach(g => { if (g < rowCount) items[g] = { gap: true }; });
  return items.filter(Boolean);
}
// Write a list back. The spacer rows become its gap items' indexes; the listed boxes take, in list
// order, the places in epic.boxes that those same boxes held - every other box (another lane's, one
// with no row) keeps its place. Returns true when epic.boxes changed order.
function _nrApplyRowItems(epic, laneId, items) {
  const gaps = [];
  items.forEach((it, i) => { if (it.gap) gaps.push(i); });
  if (laneId) { if (gaps.length) { epic.roadmapGaps = epic.roadmapGaps || {}; epic.roadmapGaps[laneId] = gaps; } else if (epic.roadmapGaps) delete epic.roadmapGaps[laneId]; }
  else if (gaps.length) epic.roadmapGapsAgg = gaps; else delete epic.roadmapGapsAgg;
  _nrGapsTidy(epic, laneId);
  const boxes = epic.boxes || [];
  const listed = items.filter(it => it.box).map(it => it.box);
  const inList = new Set(listed);
  const places = [];
  boxes.forEach((b, i) => { if (inList.has(b)) places.push(i); });
  const before = boxes.map(b => b.id).join();
  places.forEach((p, k) => { boxes[p] = listed[k]; });
  return before !== boxes.map(b => b.id).join();
}
// Put `box` in its group's list where a drop (or "+ add here") points, then write the list back.
// `row` = the grid row of the drop; `zone` (card-dnd.js _nrDropZone) = a drop ON another box's card:
// above = its row's place, below = right after it. Without a zone: a spacer row is filled, another
// box's row is taken (that box and the ones under it move down), its own row = stays, past the end =
// appended. `joining` = the box is new to the group (added, or moved in from another lane / chapter):
// the rows are read without it, as the person saw them. Pure mutation; returns true when epic.boxes
// changed order (the caller moves the notes DOM and saves once).
function _nrMoveBoxInRows(epic, laneId, box, row, zone, buckets, joining) {
  const all = _nrRowItems(epic, laneId, buckets, joining ? box : null);
  const self = all.find(it => it.box === box) || null;
  let at = null;
  if (zone && zone.boxId) {
    const t = all.find(it => it.box && it.box.id === zone.boxId);
    if (t && t !== self) at = { item: t, after: zone.kind !== 'above' };
    else if (t) return _nrApplyRowItems(epic, laneId, all);       // on its own card: no row move
  }
  if (!at) {
    const it = all[row];
    if (self && it === self) return _nrApplyRowItems(epic, laneId, all);
    at = it ? { item: it, after: false, fill: !!it.gap } : { end: true };
  }
  const list = all.filter(it => it !== self);
  const me = self || { box };
  if (at.end) list.push(me);
  else {
    const i = list.indexOf(at.item);
    if (at.fill) list.splice(i, 1, me); else list.splice(at.after ? i + 1 : i, 0, me);
  }
  return _nrApplyRowItems(epic, laneId, list);
}
// Take `box` OUT of its group's rows (it moves to another lane / chapter): its row closes up.
function _nrLeaveRow(epic, laneId, box, buckets) {
  _nrApplyRowItems(epic, laneId, _nrRowItems(epic, laneId, buckets).filter(it => it.box !== box));
}
// Open a spacer row at `row` (everything on and below shifts down) / close the spacer at `row`.
function _nrAddGap(epic, laneId, row, buckets) {
  const all = _nrRowItems(epic, laneId, buckets);
  if (!Number.isInteger(row) || row < 0 || row > all.length) return false;
  all.splice(row, 0, { gap: true });
  _nrApplyRowItems(epic, laneId, all);
  return true;
}
function _nrRemoveGap(epic, laneId, row, buckets) {
  const all = _nrRowItems(epic, laneId, buckets);
  if (!all[row] || !all[row].gap) return false;
  all.splice(row, 1);
  _nrApplyRowItems(epic, laneId, all);
  return true;
}
// Several cards of ONE box in one cell sit side by side in entry order: a drop on the left / right
// quarter of one of them moves the dragged entry just before / after it (Rishabh 2026-10-05: their
// horizontal order must be draggable). Pure mutation of box.roadmapSchedule.
function _nrReorderEntry(box, fromIdx, toIdx, after) {
  const sched = _nrEnsureSchedule(box);
  if (fromIdx === toIdx || !sched[fromIdx] || !sched[toIdx]) return false;
  const target = sched[toIdx];
  const [moved] = sched.splice(fromIdx, 1);
  const t = sched.indexOf(target);
  sched.splice(after ? t + 1 : t, 0, moved);
  return true;
}
// The notes view's box elements take epic.boxes order. notes-structure.js owns that DOM move
// (syncNotesBoxesDom: nodes move, nothing re-renders, open editors keep their state), and the outline
// lists the boxes, so it follows. Only the chapter whose boxes are on screen has a notes DOM.
function _nrSyncBoxesDom(epic) {
  const sec = SECTIONS[activeSection];
  if (!sec || sec.activeNotesEpic !== epic.id) return;
  syncNotesBoxesDom(epic);
  renderNotesOutline();
}
// The notes view moved `boxId` in epic.boxes (its drag or ↑ / ↓). The board's rows ARE that order,
// so there is nothing to move: the caller's repaint shows it. Kept as the notes view's one hook.
function nrOnBoxOrderChanged(epic, boxId) {
  return !!epic && !_nrReadOnly(epic) && (epic.boxes || []).some(b => b.id === boxId);
}

// Capture "work began": when a card is OPENED while it is Active and has no actual start
// yet, stamp today (once). Deliberately a single USER-triggered save (from nrCardClick) -
// NOT a render-time write, which would race the cross-tab cloud sync and flicker the open
// editor. Only real schedule entries (roadmapSchedule) are stamped.
function _nrAutoStampActualStartOnOpen(secKey, epicId, boxId, eidx) {
  if (_nrCardReadOnly(secKey, epicId)) return;   // a READ never writes: opening a read-only card stamps nothing
  const sec = SECTIONS[secKey];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === epicId);
  const box = epic && (epic.boxes || []).find(b => b.id === boxId);
  const sched = box && box.roadmapSchedule;
  const entry = Array.isArray(sched) ? sched[eidx] : null;
  if (!entry || entry.actualStart || _nrEntryStatus(entry) !== 'Active') return;
  entry.actualStart = _nrTodayIso();
  saveNotesMeta(sec);
}

// Status is a pure view over the entry's dates — nothing extra is stored. Done (an
// actual finish is set) wins, then start-vs-today decides Active / Planned, and no
// planned start at all is Backlog. (Blocked is retired - the editor no longer sets it.)
function _nrEntryStatus(entry) {
  if (entry.done) return 'Done';
  if (!entry.date) return 'Backlog';
  const d = _tlParse(entry.date);
  return (d && d <= _tlToday()) ? 'Active' : 'Planned';
}
// Card status CSS class (s-*) for an entry — mirrors the status word.
function _nrCardStatusClass(entry) {
  const s = _nrEntryStatus(entry);
  return s === 'Done' ? 'done' : s === 'Blocked' ? 'blocked' : s === 'Active' ? 'active' : 'planned';
}

;
// ==== FILE: js/roadmap/cards-html.js ====
// ── notes-roadmap / cards-html ──────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: HTML builders for the axis head, cards, lane rows, aggregated lanes, the data table, and the lifecycle bar.
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

// Column header. Every column (all grains) carries a « collapse affordance and a
// width weight; the calendar grains additionally show a colour chip. Collapsed →
// an empty thin head; a full-height strip (built in renderNotesRoadmap) draws its
// label + expand. Rename / resize / add-horizon remain a fast-follow.
function _nrAxisHeadHtml(b, grain, showHandle) {
  const hid = esc(b.hid || '');
  const grow = ` style="flex-grow:${b.w || 1}"`;
  if (b.collapsed) {
    return `<div class="tl-zhead ${b.kind} tl-collapsed" data-hid="${hid}" style="flex:0 0 ${NR_COL_COLLAPSED_PX}px"></div>`;
  }
  const isHz = grain === 'horizons' || !!b.parallel;   // a Parallel column edits like a Custom one, in every grain
  const isNow = b.kind === 'now';
  const ro = _nrReadOnly() || (!!b.parallel && _nrIsAllMode());   // every column tool below writes roadmap_horizons.json (or the chapter's Parallel list) - none is offered read-only; the Roadmap tab does not own a Parallel column
  const hzEdit = isHz && !ro;               // click-to-rename / subtitle only when the viewer may write
  const collapse = b.hid
    ? `<span class="tl-col-collapse" onclick="nrToggleCollapse('${hid}')" title="Collapse this timeframe (keeps it, just hides its cards)">&laquo;</span>`
    : '';
  // Label: inline-editable in the Horizons grain; the current-period column is the
  // black "today" pill (also click-to-rename in Horizons). Calendar grains are
  // read-only (strict date math) and show a colour chip.
  let label;
  if (isHz && _nrEditHzId === b.hid) label = `<input class="tl-hz-input" id="nrHzInput" type="text" spellcheck="true" value="${esc(b.label)}" />`;
  else if (isNow) label = `<span class="nr-today-pill"${hzEdit ? ` onclick="nrEditHorizon('${hid}')" style="cursor:text" title="Click to rename"` : ''}>${esc(b.label)}</span>`;
  else if (hzEdit) label = `<span class="tl-hz-name" onclick="nrEditHorizon('${hid}')" title="Click to rename">${esc(b.label)}</span>`;
  else label = esc(b.label);
  const chip = (isHz || isNow) ? '' : '<span class="chip"></span>';
  const isFutureHz = isHz && !b.parallel && b.hkind === 'future' && !ro;   // grip / nudge / delete / drop: writers (a Parallel column has a fixed place)
  // Future columns get a drag grip + left/right nudge arrows + delete, grouped on
  // the right and revealed on hover (like the lane row controls). Done / Now / Later
  // are pinned and carry none of these.
  const grip = isFutureHz
    ? `<span class="tl-hz-grip" draggable="true" ondragstart="nrHzDragStart(event,'${hid}')" ondragend="nrHzDragEnd(event)" title="Drag to reorder this timeframe">&#8942;&#8942;</span>`
    : '';
  const moves = isFutureHz
    ? `<span class="tl-hz-mv" onclick="nrMoveHorizon('${hid}',-1)" title="Move left">&#8249;</span><span class="tl-hz-mv" onclick="nrMoveHorizon('${hid}',1)" title="Move right">&#8250;</span>`
    : '';
  const del = isFutureHz ? `<span class="tl-hz-del" onclick="nrDeleteHorizon('${hid}')" title="Remove this timeframe">&times;</span>`
    : (b.parallel && !ro) ? `<span class="tl-hz-del" onclick="nrDeleteParallel('${hid}')" title="Remove this column (its cards go back to their dates)">&times;</span>` : '';
  const tools = (moves || del) ? `<span class="tl-hz-tools">${moves}${del}</span>` : '';
  let sub;
  if (isHz && _nrEditHzSubId === b.hid) sub = `<input class="tl-hz-subinput" id="nrHzSubInput" type="text" spellcheck="true" value="${esc(b.sub || '')}" placeholder="subtitle" />`;
  else if (hzEdit) { const ph = b.unallocated ? 'drop a card to schedule' : '+ subtitle'; sub = `<span class="tl-hz-sub" onclick="nrEditHorizonSub('${hid}')" title="Click to edit subtitle">${b.sub ? esc(b.sub) : `<span class="tl-sub-add">${ph}</span>`}</span>`; }
  else sub = esc(b.sub || '');
  const handle = (showHandle && !ro)
    ? `<span class="tl-col-resize${_nrColDrag && _nrColDrag.hid === b.hid ? ' is-live' : ''}" onmousedown="nrColResizeStart(event,'${hid}')" title="Drag to resize this timeframe"></span>`
    : '';
  const dataHid = b.hid ? ` data-hid="${hid}"` : '';
  const drop = isFutureHz ? ` ondragover="nrHzDragOver(event)" ondragleave="nrHzDragLeave(event)" ondrop="nrHzDrop(event,'${hid}')"` : '';
  const uncls = ((isHz && b.unallocated) ? ' tl-hz-unalloc' : '') + (b.parallel ? ' tl-parallel' : '');
  return `<div class="tl-zhead ${b.kind}${uncls}"${dataHid}${drop}${grow}><div class="h">${collapse}${grip}${chip}${label}${tools}</div><div class="sub">${sub}</div>${handle}</div>`;
}

// Render a card's sub-task bullets. Blank lines the user typed are KEPT as small
// gaps (they group tasks visually) - only leading/trailing blanks are trimmed.
// Returns '' when there is no real task. Shared by the editable + read-only cards.
// A URL in a task becomes the same pill the notes boxes draw (ui.js linkifyUrls - the ONE
// linkifier; Rishabh 2026-10-04: "url preview, as we have in boxes"): its domain as the label,
// mousedown opens it (ui.js), so a click on a pill must not also open the card's editor.
function _nrTaskListHtml(entry) {
  const t = (entry.tasks || []).slice();
  const blank = s => !(s && s.trim());
  while (t.length && blank(t[0])) t.shift();
  while (t.length && blank(t[t.length - 1])) t.pop();
  if (!t.some(x => !blank(x))) return '';
  return `<ul class="nr-card-tasks" onclick="if (event.target.closest('a.url-pill')) { event.preventDefault(); event.stopPropagation(); }">${t.map(x => blank(x) ? '<li class="nr-task-gap"></li>' : `<li>${linkifyUrls(esc(x))}</li>`).join('')}</ul>`;
}

// One card = one schedule ENTRY of a box. Status colour derives from its column
// (past → done, now → active, otherwise planned). Single-click opens the inline
// editor for THIS entry; double-click jumps to the box's notes; drag moves this
// entry to another column.
// The 5 date placeholders (Allocation / Planned start / Actual start / Planned finish /
// Actual finish) - shared by the chapter-scope editor (_nrCardHtml) and the aggregated
// editor (_nrCardHtmlRO). Rendered BELOW the lifecycle bar. Fixed input IDs, so
// _nrWireCardEdit / _nrReadCardInputsInto drive both editors the same way.
function _nrDatesHtml(entry, box, ro) {
  const r = ro ? ' readonly' : '';   // a read-only card shows its dates; it cannot change them
  return `<div class="nr-ms">
          <div class="nr-ms-row"><span class="nr-ms-lab">Allocation date</span><input class="tl-card-date-input" id="nrCardAllocDate" type="date"${r} value="${esc((box && box.createdAt) || '')}" title="Allocation date - when the station was created (auto-set on new stations; editable to back-fill older ones)" /></div>
          <div class="nr-ms-row"><span class="nr-ms-lab">Planned start</span><input class="tl-card-date-input" id="nrCardDate" type="date"${r} value="${esc(entry.date || '')}" title="Planned start date (also places the card in its timeframe column)" /></div>
          <div class="nr-ms-row"><span class="nr-ms-lab">Actual start</span><input class="tl-card-date-input" id="nrCardActualStart" type="date"${r} value="${esc(entry.actualStart || '')}" title="Actual start - auto-set to today when it first becomes Active; editable" /></div>
          <div class="nr-ms-row"><span class="nr-ms-lab">Planned finish</span><input class="tl-card-date-input" id="nrCardPlannedEnd" type="date"${r} value="${esc(entry.plannedEnd || '')}" title="Planned finish / target date" /></div>
          <div class="nr-ms-row"><span class="nr-ms-lab">Actual finish</span><input class="tl-card-date-input" id="nrCardEndDate" type="date"${r} value="${esc(entry.endDate || '')}" title="Actual finish date - setting it marks the station Done" /></div>
        </div>`;
}
// Sub-tasks for this entry (this column).
function _nrTasksHtml(entry, ro) {
  const tasksText = (entry.tasks || []).join('\n');
  return `<textarea class="tl-card-tasks-input" id="nrCardTasks" rows="3" spellcheck="true"${ro ? ' readonly' : ''} placeholder="Sub-tasks in this column (one per line)">${esc(tasksText)}</textarea>`;
}

// The stage-duration bar shown inside an OPENED station's editor (below the action
// buttons): a real-calendar mini-gantt of THIS entry's lifecycle — waiting (created →
// actual start) then in-progress (actual start → actual end / today), with planned-start
// + target as dashed markers and slippage drawn red. Allocation latency (created →
// planned-start-set) is a line below (it isn't a calendar span). Pure view over stored
// dates — nothing is computed-and-saved here. (docs/ROADMAP_MODEL.md)
const NR_LIFE_NEAR = 16;   // % of the bar below which two axis labels would touch (a label is ~45 px on a ~300 px bar)
// A caption centred within NR_LIFE_EDGE % of either end would run past the bar and be clipped by the card
// (Rishabh 2026-10-17: "start on time" read as "n time"), so it is anchored to that end instead - the same
// rule the axis row already applies to its first and last label (styles.css .nr-life-axis span:first/last-child).
const NR_LIFE_EDGE = 12;   // % - a caption is ~70 px on a ~300 px bar, so half of it is ~12 %
const _nrLifeEdgeCls = (x) => (x <= NR_LIFE_EDGE ? 'edge-l' : x >= 100 - NR_LIFE_EDGE ? 'edge-r' : '');
const _nrLifeSpan = (x, cls, text) => `<span class="${[cls, _nrLifeEdgeCls(x)].filter(Boolean).join(' ')}" style="left:${x}%">${text}</span>`;
function _nrLifecycleBarHtml(box, entry) {
  const created = box.createdAt || null;                    // allocation date
  const pStart  = entry.date || null;                       // planned start
  const aStart  = entry.actualStart || null;
  const target  = entry.plannedEnd || null;                 // planned finish
  const done    = !!entry.done;
  const aEnd    = (done && entry.endDate) ? entry.endDate : null;   // actual finish = Done + a recorded end date
  const running = !!aStart && !done;                               // a Done entry is never "running" (even if its end date is unset)
  // A Done card may have no actual start (drag-to-past / past-add never record one); fall
  // back to its planned start (else allocation) so its work segment + duration aren't empty -
  // but never LATER than the finish, else a card completed BEFORE its planned start would draw
  // as a full-width "waiting" span mislabelling a finished card as still waiting.
  let workStart = aStart;
  if (workStart == null && done) {
    const cand = pStart || created;
    workStart = (cand && aEnd && _tlParse(cand) > _tlParse(aEnd)) ? aEnd : (cand || null);
  }
  const workEnd = aEnd || (running ? _nrTodayIso() : null);
  // While still waiting to start (not started, not done), the waiting stage runs to TODAY so its
  // duration grows each day (the "how long has this been sitting" signal). Once work starts it ends
  // at the actual start; a Done card with no recorded start ends at its fallback work-start.
  const pending = !aStart && !done;
  const waitEnd = aStart || (done ? workStart : _nrTodayIso());

  const alloc        = _nrDayDiff(created, pStart);         // allocation date -> planned start
  const startSlip    = _nrDayDiff(pStart, aStart);
  const duration     = _nrDayDiff(workStart, workEnd);
  const deliverySlip = _nrDayDiff(target, aEnd);

  // Axis = the real timeline points that exist.
  const axis = [['Alloc', created], ['P.start', pStart], ['A.start', aStart], ['Target', target], ['A.end', aEnd]];
  const times = axis.map(([, v]) => v).filter(Boolean).map(v => +_tlParse(v)).filter(t => t);
  if (running || pending) times.push(+_tlParse(_nrTodayIso()));   // extend the axis to today so a live waiting / in-progress bar can draw
  const uniq = [...new Set(times)];
  if (uniq.length < 2) {
    return `<div class="nr-life nr-life-empty">Set Planned start / Actual start / Planned finish to draw the timeline.</div>`;
  }
  const min = Math.min.apply(null, uniq), max = Math.max.apply(null, uniq), span = max - min;
  const P = iso => { const d = _tlParse(iso); return d ? ((+d - min) / span) * 100 : null; };
  const slipTxt = v => (v > 0 ? '+' + v + 'd' : v < 0 ? v + 'd' : 'on time');
  const slipCls = v => (v > 0 ? 'late' : v < 0 ? 'ok' : 'neu');

  const cCreated = P(created), cAStart = P(aStart), cWorkStart = P(workStart), cWorkEnd = P(workEnd), cPStart = P(pStart), cTarget = P(target), cAEnd = P(aEnd), cWaitEnd = P(waitEnd);

  let segs = '';
  if (cCreated != null && cWaitEnd != null && cWaitEnd > cCreated) segs += `<div class="nr-life-seg wait" style="left:${cCreated}%;width:${cWaitEnd - cCreated}%"></div>`;
  if (cWorkStart != null && cWorkEnd != null && cWorkEnd > cWorkStart)  segs += `<div class="nr-life-seg work" style="left:${cWorkStart}%;width:${cWorkEnd - cWorkStart}%"></div>`;
  let ov = '';
  if (cPStart != null && cAStart != null && startSlip != null && startSlip > 0)    ov += `<div class="nr-life-ov" style="left:${cPStart}%;width:${cAStart - cPStart}%" title="Started ${startSlip}d late"></div>`;
  if (cTarget != null && cAEnd != null && deliverySlip != null && deliverySlip > 0) ov += `<div class="nr-life-ov" style="left:${cTarget}%;width:${cAEnd - cTarget}%" title="Delivered ${deliverySlip}d late"></div>`;
  let marks = '';
  if (cPStart != null) marks += `<div class="nr-life-mark plan" style="left:${cPStart}%"></div>`;
  if (cTarget != null) marks += `<div class="nr-life-mark target" style="left:${cTarget}%"></div>`;

  let caps = '';
  const waitDays = _nrDayDiff(created, waitEnd);   // created -> today while pending (grows daily), else -> work start
  if (cCreated != null && cWaitEnd != null && cWaitEnd > cCreated && waitDays != null) caps += _nrLifeSpan((cCreated + cWaitEnd) / 2, '', `waiting ${waitDays}d`);
  if (cWorkStart != null && cWorkEnd != null && cWorkEnd > cWorkStart && duration != null)  caps += _nrLifeSpan((cWorkStart + cWorkEnd) / 2, '', `${aEnd ? 'done' : 'in progress'} ${duration}d`);

  let slips = '';
  if (startSlip != null && cPStart != null && cAStart != null)   slips += _nrLifeSpan((cPStart + cAStart) / 2, slipCls(startSlip), `start ${slipTxt(startSlip)}`);
  if (deliverySlip != null && cTarget != null && cAEnd != null)  slips += _nrLifeSpan((cTarget + cAEnd) / 2, slipCls(deliverySlip), `delivery ${slipTxt(deliverySlip)}`);

  // Axis labels: points on the SAME day share one label ("P.start + A.start" over one date) and
  // two labels closer than NR_LIFE_NEAR % of the bar alternate between an upper and a lower line,
  // so no label is ever drawn over another (Rishabh 2026-10-04: "overlapping text").
  const pts = axis.filter(([, v]) => v).map(([k, v]) => ({ k, v, x: P(v) })).sort((a, b) => a.x - b.x);
  const merged = [];
  pts.forEach(p => { const last = merged[merged.length - 1]; if (last && Math.abs(last.x - p.x) < 0.01) last.k += ' + ' + p.k; else merged.push({ k: p.k, v: p.v, x: p.x }); });
  let staggered = false;
  merged.forEach((p, i) => { p.lo = i > 0 && merged[i - 1].x > p.x - NR_LIFE_NEAR && !merged[i - 1].lo; if (p.lo) staggered = true; });
  // An axis label at either end is anchored to that end by the SAME edge rule as the captions (it used to rely on
  // :first-child / :last-child, which put a lone label - every point on one day - entirely outside the bar).
  const nodes = merged.map(p => `<span class="${[p.lo ? 'lo' : '', _nrLifeEdgeCls(p.x)].filter(Boolean).join(' ')}" style="left:${p.x}%"><i>${p.k}</i><b>${esc(_tlMD(_tlParse(p.v)))}</b></span>`).join('');
  const note = alloc != null
    ? `<div class="nr-life-note"><span class="nr-life-dot"></span>Allocation to planned start: <b>${alloc}d</b> (created to planned).</div>`
    : `<div class="nr-life-note muted"><span class="nr-life-dot muted"></span>Allocation date not set - gap N/A.</div>`;

  return `<div class="nr-life">
      <div class="nr-life-caps">${caps}</div>
      <div class="nr-life-track">${segs}${ov}${marks}</div>
      <div class="nr-life-slips">${slips}</div>
      <div class="nr-life-axis${staggered ? ' nr-life-axis--2' : ''}">${nodes}</div>
      ${note}
    </div>`;
}

function _nrCardHtml(box, boxIdx, entry, eidx, bucket, laneName) {
  const bid = esc(box.id);
  const status = _nrCardStatusClass(entry);
  const ec = _nrEpic();
  const ecId = ec ? ec.id : '';
  const ro = _nrReadOnly(ec);   // chapter scope: every card on this board belongs to the active chapter

  if (_nrEdit && _nrEdit.epicId === ecId && _nrEdit.boxId === box.id && _nrEdit.idx === eidx) {
    const ownEpic = ec || { roadmapLanes: [] };
    const lanes = _nrLanes(ownEpic);
    const laneSel = lanes.length > 1
      ? `<select class="tl-card-lane-input" id="nrCardLane"${ro ? ' disabled' : ''} title="${NR_ROW_WORD} (group)">${lanes.map(l => `<option value="${esc(l.id)}"${l.id === _nrBoxLane(box, lanes) ? ' selected' : ''}>${esc(_nrLaneDisplayName(l, ownEpic))}</option>`).join('')}</select>`
      : '';
    return `<div class="tl-card s-${status} editing" data-box-id="${bid}" data-eidx="${eidx}">
      <span class="node ${status}"></span>
      <div class="tl-card-edit">
        <input class="tl-card-input" id="nrCardTitle" type="text" spellcheck="true"${ro ? ' readonly' : ''} value="${esc(_nrRealTitle(box, activeSection, ecId))}" placeholder="Title" />
        <input class="tl-card-owner-input" id="nrCardOwner" type="text" spellcheck="true"${ro ? ' readonly' : ''} value="${esc(entry.owner || '')}" placeholder="Owner (optional)" />
        ${laneSel}
        ${_nrTasksHtml(entry, ro)}
        ${ro ? '' : `<div class="nr-card-editbtns">
          <button class="nr-mini" onmousedown="event.preventDefault(); nrAddEntry()" title="Show this ${LBL('boxNoun').toLowerCase()} in another timeframe">+ Timeframe</button>
          <button class="nr-mini nr-mini-danger" onmousedown="event.preventDefault(); nrRemoveEntry()" title="Remove only THIS card from the roadmap. The ${LBL('boxNoun').toLowerCase()} and its other cards stay; if this was its last card the ${LBL('boxNoun').toLowerCase()} shows as one card in Later. To delete the whole ${LBL('boxNoun').toLowerCase()}, use its menu below.">Remove this card</button>
        </div>`}
        ${_nrLifecycleBarHtml(box, entry)}
        ${_nrDatesHtml(entry, box, ro)}
      </div>
    </div>`;
  }

  const owner = (entry.owner || '').trim();
  const who = owner
    ? `<span class="tl-who"><span class="tl-ava">${esc(owner.charAt(0).toUpperCase() || '·')}</span>${esc(owner)}</span>`
    : '<span class="tl-who"></span>';
  const d = _tlParse(entry.date);
  const pe = _tlParse(entry.plannedEnd);
  const dateStr = d && pe ? `<span class="tl-card-date" title="Start - Target">${esc(_tlMD(d))} - ${esc(_tlMD(pe))}</span>`
    : d ? `<span class="tl-card-date">${esc(_tlMD(d))}</span>`
    : pe ? `<span class="tl-card-date" title="Target date">by ${esc(_tlMD(pe))}</span>` : '';
  const meta = (owner || d || pe) ? `<div class="tl-card-meta">${who}${dateStr}</div>` : '';
  const taskList = _nrTaskListHtml(entry);
  // Hide the title when it just repeats the row (initiative) name, so multiple
  // cards in a row read as owner + tasks. Keep it if the card has a distinct
  // title, or if it would otherwise be empty (no owner + no tasks).
  const real = _nrRealTitle(box, activeSection, ecId);
  const hasBody = !!owner || !!taskList;
  const showTitle = (real && real !== laneName) || !hasBody;
  const titleHtml = showTitle ? `<span class="tl-card-t">${esc(real || nrBoxFallbackTitle(boxIdx))}</span>` : '';
  return `<div class="tl-card s-${status}" data-box-id="${bid}" data-eidx="${eidx}" draggable="${ro ? 'false' : 'true'}"
      ${ro ? '' : `ondragstart="nrDragStart(event,'${bid}',${eidx})"`}
      onclick="nrCardClick('${esc(activeSection)}','${esc(ecId)}','${bid}',${eidx})"
      ondblclick="nrCardDblClick('${bid}')"
      title="${ro ? `View only - click to see details, double-click to open the ${LBL('boxNoun').toLowerCase()}` : `Click to edit - double-click to open the ${LBL('boxNoun').toLowerCase()} - drag to move or align across timeframes`}">
      <span class="node ${status}"></span>
      ${titleHtml}
      ${taskList}
      ${meta}
    </div>`;
}

// One cell's cards - all of ONE box (one row = one box, model.js). One card draws as before; several
// cards of the box in this column sit side by side in entry order, a grid of that many equal tracks.
function _nrCellSlotsHtml(list) {
  if (!list || !list.length) return { cards: '', multi: '', slotStyle: '' };
  if (list.length === 1) return { cards: list[0], multi: '', slotStyle: '' };
  return { cards: list.map((h, i) => `<div class="tl-slot" style="grid-column:${i + 1}">${h}</div>`).join(''), multi: ' tl-cell--multi', slotStyle: `;--nr-slots:${list.length}` };
}
// The row resolver lives in model.js (_nrResolveRows) so the writers use the same one the render
// reads. `laneId` null = the aggregated board (roadmapGapsAgg).
function _nrRowsForLane(laneBoxes, buckets, epic, laneId, gapEpic) {
  return _nrResolveRows(laneBoxes, buckets, epic, _nrGapsRead(gapEpic || epic, laneId));
}

// One row per lane. Each box contributes one card per schedule entry, placed in
// (its box's row, that entry's timeframe column) via a CSS grid so same-row cards
// align across columns.
function _nrLanesHtml(epic, buckets) {
  const ro = _nrReadOnly(epic);           // read-only chapter: no "+", and its cells stop being drop targets
  const lanes = _nrLanes(epic);           // full set (for box→lane resolution)
  const boxes = epic.boxes || [];
  const N = buckets.length;
  const multi = lanes.length > 1;
  // When an owner filter is active, also drop initiative rows that have no card
  // left for the selected owner(s) — so filtering by owner collapses the board
  // to just that owner's initiatives, not empty rows.
  let visLanes = _nrVisibleLanes(epic);
  if (epic.roadmapHiddenOwners && epic.roadmapHiddenOwners.length) {
    visLanes = visLanes.filter(lane => boxes.some(box =>
      _nrBoxLane(box, lanes) === lane.id &&
      _nrEntries(box).some(e => !_nrOwnerHidden(e, epic))));
  }
  return visLanes.map(lane => {
    // Grid layout: columns = timeframe buckets (same fr weights as the overlay so
    // dividers stay aligned), rows = box rows from _nrRowsForLane. Each (row,col)
    // is a drop cell (nrGridDrop) that also holds the card(s) there; empty cells
    // carry the + add. One spare row at the bottom lets a card be dropped onto a
    // fresh row.
    const lgid = esc(lane.id);
    const laneBoxes = boxes.filter(box => _nrBoxLane(box, lanes) === lane.id);
    const { rowOf, rowCount } = _nrRowsForLane(laneBoxes, buckets, epic, lane.id);
    const gaps = _nrGapsRead(epic, lane.id);
    const totalRows = rowCount + 1;
    const gridCols = buckets.map(b => b.collapsed ? `${NR_COL_COLLAPSED_PX}px` : `${b.w > 0 ? b.w : 1}fr`).join(' ');
    const rowTmpl = `repeat(${rowCount},minmax(56px,auto)) minmax(30px,auto)`;
    const cellCards = {};
    laneBoxes.forEach((box, boxIdx) => {
      const r = rowOf[box.id];
      if (r == null) return;
      _nrEntries(box).forEach((entry, eidx) => {
        if (_nrOwnerHidden(entry, epic)) return;
        const c = _nrEntryBucket(entry, buckets);
        if (!buckets[c] || buckets[c].collapsed) return;
        (cellCards[r + ',' + c] = cellCards[r + ',' + c] || []).push(_nrCardHtml(box, boxIdx, entry, eidx, buckets[c], lane.name));
      });
    });
    let cellsHtml = '';
    for (let r = 0; r < totalRows; r++) {
      for (let i = 0; i < N; i++) {
        const pos = `grid-row:${r + 1};grid-column:${i + 1}`;
        if (buckets[i].collapsed) { cellsHtml += `<div class="tl-cell tl-cell--collapsed" style="${pos}"></div>`; continue; }
        const { cards, multi, slotStyle } = _nrCellSlotsHtml(cellCards[r + ',' + i]);
        const spare = r >= rowCount ? ' tl-cell--spare' : '';
        const isGap = gaps.indexOf(r) !== -1;
        const drop = ro ? '' : ` ondragover="nrDragOver(event)" ondragleave="nrDragLeave(event)" ondrop="nrGridDrop(event,'${lgid}',${r},${i})"`;
        // A SPACER row: an empty band across every column (a drop fills it); its first visible
        // cell carries the "close this space" control.
        if (isGap) {
          const close = (ro || cellsHtml.indexOf(`nrRemoveRowGap('${esc(activeSection)}','${esc(epic.id)}','${lgid}',${r})`) !== -1) ? '' : `<button class="tl-gap-close" title="Remove this row of space" onclick="nrRemoveRowGap('${esc(activeSection)}','${esc(epic.id)}','${lgid}',${r})">&times;</button>`;
          cellsHtml += `<div class="tl-cell tl-cell--gap" style="${pos}"${drop}>${close}</div>`;
          continue;
        }
        // Offer the add affordance on every cell (hover-revealed via CSS), so a cell that
        // already has a station can still get another - unless the chapter is read-only,
        // where a cell neither offers "+" nor accepts a drop. A card row also offers
        // "+ space below" - a whole spacer row, so the owner can open space between two cards.
        const add = ro ? '' : `<button class="tl-cell-add" title="Add ${cards ? 'another' : 'a'} ${LBL('boxNoun').toLowerCase()} here" onclick="nrAddInCol('${lgid}',${i},${r})">+</button>`;
        const space = (ro || spare) ? '' : `<button class="tl-cell-gap" title="Add a row of space below" onclick="nrAddRowGap('${esc(activeSection)}','${esc(epic.id)}','${lgid}',${r + 1})">&#8597;</button>`;
        cellsHtml += `<div class="tl-cell tl-cell--${buckets[i].kind}${spare}${multi}" style="${pos}${slotStyle}"${drop}>${cards}${add}${space}</div>`;
      }
    }
    const cells = `<div class="tl-track tl-grid" style="grid-template-columns:${gridCols};grid-template-rows:${rowTmpl}">${cellsHtml}</div>`;
    const lid = esc(lane.id);
    const dispName = _nrLaneDisplayName(lane, epic);
    // Read-only chapter: the row is a label, not a writer - no rename, no subtitle, no reorder / delete
    // controls, and the head is not a lane drop target.
    const nameHtml = ro
      ? `<div class="n">${esc(dispName)}</div>`
      : _nrEditLaneId === lane.id
        ? `<input class="tl-lane-input" id="nrLaneInput" type="text" spellcheck="true" value="${esc(dispName)}" />`
        : `<div class="n" onclick="nrEditLane('${lid}')" title="Click to rename this ${NR_ROW_WORD.toLowerCase()}">${esc(dispName)}</div>`;
    const subHtml = ro
      ? (lane.sub ? `<div class="s">${esc(lane.sub)}</div>` : '')
      : _nrEditLaneSubId === lane.id
        ? `<input class="tl-lane-subinput" id="nrLaneSubInput" type="text" spellcheck="true" value="${esc(lane.sub || '')}" placeholder="subtitle" />`
        : `<div class="s" onclick="nrEditLaneSub('${lid}')" title="Click to edit subtitle">${lane.sub ? esc(lane.sub) : '<span class="tl-sub-add">+ subtitle</span>'}</div>`;
    const ctrls = (multi && !ro) ? `<div class="nr-lane-ctrls">
        <span class="nr-lane-grip" draggable="true" ondragstart="nrLaneDragStart(event,'${lid}')" ondragend="nrLaneDragEnd(event)" title="Drag to reorder this ${NR_ROW_WORD.toLowerCase()}">&#8942;&#8942;</span>
        <span onclick="nrMoveLane('${lid}',-1)" title="Move up">&#8593;</span>
        <span onclick="nrMoveLane('${lid}',1)" title="Move down">&#8595;</span>
        <span class="nr-lane-x" onclick="nrDeleteLane('${lid}')" title="Delete this ${NR_ROW_WORD.toLowerCase()}">&times;</span>
      </div>` : '';
    const laneDrop = ro ? '' : ` ondragover="nrLaneDragOver(event)" ondragleave="nrLaneDragLeave(event)" ondrop="nrLaneDrop(event,'${lid}')"`;
    // One implicit lane: no Topic column (render.js laneColHidden) - the head would only repeat the chapter's name.
    const head = multi ? `<div class="tl-lane-head"${laneDrop}>
        ${nameHtml}
        ${subHtml}
        ${ctrls}
      </div>` : '';
    return `<div class="tl-lane-row">
      ${head}
      ${cells}
    </div>`;
  }).join('');
}

// A read-only card for aggregated (subject / all) scopes — a pure view, no
// drag / click-to-edit handlers (editing stays in 'chapter' scope). Title shows
// the section name (rows here are chapters/subjects, so the section is useful).
function _nrCardHtmlRO(box, epic, boxIdx, entry, secKey, eidx) {
  const status = _nrCardStatusClass(entry);
  const bid = esc(box.id);
  const ro = _nrReadOnly(epic);   // this card's OWN chapter - the board mixes chapters, so never the active one
  // Editing this aggregated card: inline editor for the ENTRY fields (owner / start /
  // target / blocked / done / tasks), committed back to THIS card's own Area. The title
  // edits the box's # heading in its own chapter/subject (via _nrApplyBoxTitle, which
  // works even when the box's editor is off-screen); lane move and add / remove
  // timeframes are chapter-scope only.
  if (_nrEdit && _nrEdit.epicId === epic.id && _nrEdit.boxId === box.id && _nrEdit.idx === eidx) {
    return `<div class="tl-card s-${status} editing nr-card-ro" data-box-id="${bid}" data-eidx="${eidx}">
      <span class="node ${status}"></span>
      <div class="tl-card-edit">
        <input class="tl-card-input" id="nrCardTitle" type="text" spellcheck="true"${ro ? ' readonly' : ''} value="${esc(_nrRealTitle(box, secKey, epic.id))}" placeholder="Title" />
        <input class="tl-card-owner-input" id="nrCardOwner" type="text" spellcheck="true"${ro ? ' readonly' : ''} value="${esc(entry.owner || '')}" placeholder="Owner (optional)" />
        ${_nrTasksHtml(entry, ro)}
        ${ro ? '' : `<div class="nr-card-editbtns">
          <button class="nr-mini" onmousedown="event.preventDefault(); nrAddEntry()" title="Show this card in another timeframe">+ Timeframe</button>
          <button class="nr-mini nr-mini-danger" onmousedown="event.preventDefault(); nrRemoveEntry()" title="Remove only THIS card from the roadmap. The ${LBL('boxNoun').toLowerCase()} and its other cards stay; if this was its last card the ${LBL('boxNoun').toLowerCase()} shows as one card in Later.">Remove this card</button>
          <button class="nr-mini nr-mini-danger" onmousedown="event.preventDefault(); nrAggDeleteBox('${esc(secKey)}','${esc(epic.id)}','${bid}')" title="Delete this station and its notes (.md file) entirely">Delete</button>
        </div>`}
        ${_nrLifecycleBarHtml(box, entry)}
        ${_nrDatesHtml(entry, box, ro)}
      </div>
    </div>`;
  }
  const owner = (entry.owner || '').trim();
  const who = owner
    ? `<span class="tl-who"><span class="tl-ava">${esc(owner.charAt(0).toUpperCase() || '·')}</span>${esc(owner)}</span>`
    : '<span class="tl-who"></span>';
  const d = _tlParse(entry.date);
  const pe = _tlParse(entry.plannedEnd);
  const dateStr = d && pe ? `<span class="tl-card-date" title="Start - Target">${esc(_tlMD(d))} - ${esc(_tlMD(pe))}</span>`
    : d ? `<span class="tl-card-date">${esc(_tlMD(d))}</span>`
    : pe ? `<span class="tl-card-date" title="Target date">by ${esc(_tlMD(pe))}</span>` : '';
  const meta = (owner || d || pe) ? `<div class="tl-card-meta">${who}${dateStr}</div>` : '';
  const taskList = _nrTaskListHtml(entry);
  const title = _nrCardTitle(box, epic, boxIdx, secKey);
  const isSel = _nrSel.has(_nrSelKey(secKey, epic.id, box.id, eidx));
  return `<div class="tl-card s-${status} nr-card-ro${isSel ? ' nr-card-sel' : ''}" data-box-id="${bid}" data-eidx="${eidx}" draggable="${ro ? 'false' : 'true'}"
      ${ro ? '' : `ondragstart="nrAggDragStart(event,'${esc(secKey)}','${esc(epic.id)}','${bid}',${eidx})"`}
      onclick="nrCardClick('${esc(secKey)}','${esc(epic.id)}','${bid}',${eidx})"
      ondblclick="nrCardGoto('${esc(secKey)}','${esc(epic.id)}','${bid}')"
      title="${ro ? 'View only - click to see details, double-click to open its section' : `Click to edit - double-click to open its section - drag to move - checkbox to multi-select (saves to ${esc(epic.name || 'its ' + LBL('subject').toLowerCase())})`}">
      ${ro ? '' : `<span class="nr-card-check${isSel ? ' on' : ''}" onclick="nrToggleSelect(event,'${esc(secKey)}','${esc(epic.id)}','${bid}',${eidx})" title="Select for bulk move"></span>`}
      <span class="node ${status}"></span>
      <span class="tl-card-t">${esc(title)}</span>
      ${taskList}
      ${meta}
    </div>`;
}

// Aggregated rows for subject / all scope. Rows are ALWAYS chapters (cards are
// Sections, so Chapter is the finest row level). Group-by only changes how the
// left label reads:
//   • 'chapter' → one "Chapter" column (subject shown as a subtitle in All scope)
//   • 'subject' → two columns "Subject | Chapter" (nested): chapters grouped
//                 under their subject, the subject label shown once per group.
// The subject column just labels/groups on the left; chapters stay in separate
// rows so their cards never overlap. Read-only. (docs/ROADMAP_MODEL.md)
function _nrAggLanesHtml(items, buckets, scope, groupBy, hiddenGroups, cols) {
  const N = buckets.length;
  const hidden = hiddenGroups || new Set();
  const nested = groupBy === 'subject';       // Subject + Chapter (two separate columns)
  const { subjW, chapW, subjCollapsed, chapCollapsed } = cols;
  const order = [];
  const byKey = new Map();
  items.forEach(it => {
    // Two independent row filters (both live in epic.roadmapHiddenGroups): the Area
    // filter hides 's:'+subject keys, the Initiative filter hides 'c:'+chapter keys. The
    // Area filter UI only exists in nested (group-by-Area) mode, so 's:' keys are applied
    // ONLY there - else a stale Area-hide from a previous nested session would silently
    // drop rows in flat mode with no way to un-hide them.
    if ((nested && hidden.has('s:' + it.secKey)) || hidden.has('c:' + it.epic.id)) return;
    const key = 'c:' + it.epic.id;            // a row is always a chapter
    if (!byKey.has(key)) {
      byKey.set(key, []);
      order.push({
        key, secKey: it.secKey, epicId: it.epic.id,
        chapter: it.epic.name || '',
        subject: it.sec.title || it.secKey,
        subFlat: (!nested && scope === 'all') ? (it.sec.title || '') : '',   // subtitle in flat All
      });
    }
    byKey.get(key).push(it);
  });
  // Mark the first chapter row of each subject group so its Subject cell shows
  // the label once (a visual span); later rows in the group leave it blank.
  let prevSubj = null;
  order.forEach(row => { row.firstOfSubj = nested && row.secKey !== prevSubj; prevSubj = row.secKey; });
  // Grid column template (shared by every Initiative): collapsed columns fixed px,
  // expanded ones share the rest by weight - matches the chapter board + the overlays.
  const gridColsAgg = buckets.map(b => b.collapsed ? `${NR_COL_COLLAPSED_PX}px` : `${b.w > 0 ? b.w : 1}fr`).join(' ');

  const rowsHtml = order.map((row, ri) => {
    const rowItems = byKey.get(row.key) || [];
    const rowRo = _nrCardReadOnly(row.secKey, row.epicId);   // a row is one chapter: ask ITS lock, not the active chapter's
    // Grid with one row per box (mirrors the chapter board): a box's cards sit on its row, in the
    // entry's timeframe column; the rows read in the chapter's box order. rowItems all belong to this
    // one epic; owner filter is chapter-scope only, so pass {} (no filtering here).
    const aggBoxes = rowItems.map(it => it.box);
    const rowEpic = (SECTIONS[row.secKey].notesEpics || []).find(n => n.id === row.epicId);
    const { rowOf, rowCount } = _nrRowsForLane(aggBoxes, buckets, {}, null, rowEpic);
    const aggGaps = _nrGapsRead(rowEpic, null);
    const totalRows = rowCount + 1;
    const rowTmpl = `repeat(${rowCount},minmax(56px,auto)) minmax(30px,auto)`;
    const cellCards = {};
    rowItems.forEach(it => {
      const r = rowOf[it.box.id];
      if (r == null) return;
      _nrEntries(it.box).forEach((entry, eidx) => {
        const c = _nrEntryBucket(entry, buckets);
        if (!buckets[c] || buckets[c].collapsed) return;
        (cellCards[r + ',' + c] = cellCards[r + ',' + c] || []).push(_nrCardHtmlRO(it.box, it.epic, it.boxIdx, entry, it.secKey, eidx));
      });
    });
    let cells = '';
    for (let r = 0; r < totalRows; r++) {
      for (let i = 0; i < N; i++) {
        const pos = `grid-row:${r + 1};grid-column:${i + 1}`;
        if (buckets[i].collapsed) { cells += `<div class="tl-cell tl-cell--collapsed" style="${pos}"></div>`; continue; }
        const { cards: cd, multi, slotStyle } = _nrCellSlotsHtml(cellCards[r + ',' + i]);
        const spare = r >= rowCount ? ' tl-cell--spare' : '';
        const drop = rowRo ? '' : ` ondragover="nrDragOver(event)" ondragleave="nrDragLeave(event)" ondrop="nrAggGridDrop(event,'${esc(row.secKey)}','${esc(row.epicId)}',${r},${i})"`;
        if (aggGaps.indexOf(r) !== -1) {   // spacer row (see the chapter board)
          const close = (rowRo || cells.indexOf(`nrRemoveRowGap('${esc(row.secKey)}','${esc(row.epicId)}','',${r})`) !== -1) ? '' : `<button class="tl-gap-close" title="Remove this row of space" onclick="nrRemoveRowGap('${esc(row.secKey)}','${esc(row.epicId)}','',${r})">&times;</button>`;
          cells += `<div class="tl-cell tl-cell--gap" style="${pos}"${drop}>${close}</div>`;
          continue;
        }
        const add = rowRo ? '' : `<button class="tl-cell-add" title="Add ${cd ? 'another' : 'a'} card here" onclick="nrAggAddInCol('${esc(row.secKey)}','${esc(row.epicId)}',${i},${r})">+</button>`;
        const space = (rowRo || spare) ? '' : `<button class="tl-cell-gap" title="Add a row of space below" onclick="nrAddRowGap('${esc(row.secKey)}','${esc(row.epicId)}','',${r + 1})">&#8597;</button>`;
        cells += `<div class="tl-cell tl-cell--${buckets[i].kind}${spare}${multi}" style="${pos}${slotStyle}"${drop}>${cd}${add}${space}</div>`;
      }
    }
    // Chapter cell (thin when its column is collapsed).
    const chapCell = chapCollapsed
      ? `<div class="tl-lane-head nr-col-collapsed" style="width:${chapW}px" onclick="nrToggleLabelCol('chapter')" title="Expand Chapter column"></div>`
      : `<div class="tl-lane-head" style="width:${chapW}px">${
          rowRo
            ? `<div class="n">${esc(row.chapter)}</div>`
            : _nrEditEpicId === row.epicId
              ? `<input class="tl-lane-input" id="nrEpicInput" type="text" spellcheck="true" value="${esc(row.chapter)}" />`
              : `<div class="n" onclick="nrEditEpicName('${esc(row.epicId)}')" title="Click to rename this ${LBL('chapter').toLowerCase()}">${esc(row.chapter)}</div>`
        }${(!nested && row.subFlat) ? `<div class="s">${esc(row.subFlat)}</div>` : ''}</div>`;
    let head;
    if (nested) {
      // Subject column is a MERGED cell per group: the label shows once (on the
      // group's first chapter), blank below, and the CSS keeps that column
      // continuous (no divider). Chapters still get a divider, since chapters differ.
      const subjCell = subjCollapsed
        ? `<div class="nr-subj-col nr-col-collapsed" style="width:${subjW}px" onclick="nrToggleLabelCol('subject')" title="Expand Subject column"></div>`
        : `<div class="nr-subj-col${row.firstOfSubj ? ' nr-subj-first' : ''}" style="width:${subjW}px">${row.firstOfSubj ? `<span class="n" title="${esc(row.subject)}">${esc(row.subject)}</span>` : ''}</div>`;
      head = subjCell + chapCell;
    } else {
      head = chapCell;
    }
    // nested rows: same-subject chapters contiguous; a new subject = fresh block.
    const rowCls = nested ? (row.firstOfSubj ? ' nr-grp-start' : ' nr-grp-cont') : '';
    let html = `<div class="tl-lane-row${rowCls}">${head}<div class="tl-track tl-grid" style="grid-template-columns:${gridColsAgg};grid-template-rows:${rowTmpl}">${cells}</div></div>`;
    // Nested (group-by-Area): after each Area group's last Initiative, offer "+ Initiative"
    // for that Area; a single "+ Area" follows all groups (see the outer return).
    if (nested) {
      const lastOfGroup = ri === order.length - 1 || order[ri + 1].secKey !== row.secKey;
      if (lastOfGroup) html += _nrAddInitiativeRowHtml(row.secKey, cols);
    }
    return html;
  }).join('');
  // "+ Area" only in the All view: 'This area' (subject) scope gathers just the active
  // section, so a newly created Area would never appear there (looks like a no-op). The
  // per-Area "+ Initiative" rows above stay (a new Initiative lands in the active Area).
  return rowsHtml + ((nested && scope === 'all') ? _nrAddAreaRowHtml(cols) : '');
}

// Read-only "raw data" view — the flat table the board is rendered from. One row
// per schedule entry (= one card). Shows ALL entries, unaffected by the owner /
// initiative filters, so it reflects the underlying Firestore document.
function _nrTableHtml(epic, buckets, scope) {
  const items = _nrGatherBoxes(scope || 'chapter');
  const rows = [];
  items.forEach(it => {
    _nrEntries(it.box).forEach(entry => {
      const bi = _nrEntryBucket(entry, buckets);
      const bucket = buckets[bi];
      rows.push({
        subject: it.sec.title || it.secKey,
        chapter: it.epic.name || '',
        card: _nrCardTitle(it.box, it.epic, it.boxIdx, it.secKey),
        bi, timeframe: bucket ? bucket.label : '',
        start: entry.date || '', target: entry.plannedEnd || '', end: entry.endDate || '',
        owner: (entry.owner || '').trim(),
        status: _nrEntryStatus(entry),
        tasks: (entry.tasks || []).filter(Boolean),
      });
    });
  });
  const cmp = (a, b) => (a < b ? -1 : a > b ? 1 : 0);
  // Clean ordering: subject, then chapter, then timeframe, then start date.
  rows.sort((a, b) => cmp(a.subject, b.subject) || cmp(a.chapter, b.chapter) || a.bi - b.bi || cmp(a.start, b.start));
  if (!rows.length) return '';
  const em = '<span class="nr-dt-empty">-</span>';
  const fmtDate = ds => { const d = _tlParse(ds); return d ? esc(_tlMD(d)) : em; };
  const body = rows.map(r => `<tr>
      <td>${esc(r.subject)}</td>
      <td>${esc(r.chapter)}</td>
      <td>${esc(r.card)}</td>
      <td>${esc(r.timeframe)}</td>
      <td class="nr-dt-date">${fmtDate(r.start)}</td>
      <td class="nr-dt-date">${fmtDate(r.target)}</td>
      <td class="nr-dt-date">${fmtDate(r.end)}</td>
      <td>${r.owner ? esc(r.owner) : em}</td>
      <td><span class="nr-dt-status nr-dt-status--${r.status.toLowerCase()}">${r.status}</span></td>
      <td>${r.tasks.length ? `<ul class="nr-dt-tasks">${r.tasks.map(t => `<li>${esc(t)}</li>`).join('')}</ul>` : em}</td>
    </tr>`).join('');
  const scopeLabel = scope === 'all' ? 'all subjects' : scope === 'subject' ? 'this subject' : 'this chapter';
  return `<div class="nr-data">
      <div class="nr-data-head">Raw data <span class="nr-data-sub">${rows.length} card${rows.length === 1 ? '' : 's'} &middot; ${scopeLabel} &middot; the flat base table the roadmap is a view of (read-only)</span></div>
      <div class="nr-data-scroll">
        <table class="nr-data-table">
          <thead><tr><th>Subject</th><th>Chapter</th><th>Section</th><th>Timeframe</th><th>Start</th><th>Target</th><th>End</th><th>Owner</th><th>Status</th><th>Sub-tasks</th></tr></thead>
          <tbody>${body}</tbody>
        </table>
      </div>
    </div>`;
}

;
// ==== FILE: js/roadmap/render.js ====
// ── notes-roadmap / render ──────────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: render orchestration (showRoadmapView / renderAllRoadmap / renderNotesRoadmap), the 3-width-engine glue (grid fr / flex-grow / absolute calc() overlays), and post-render geometry / positioning / scroll.
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

// Show ONLY the roadmap band — the always-visible section "Roadmap" sub-tab. Reuses
// the notes-view container but hides the notes chrome (toolbar + boxes, via the
// tt-roadmap-tab body class + CSS) so the roadmap paints standalone. Mirrors the way
// the notes/table views toggle their sibling containers. The routing (subtabs.js /
// data.js) sets activeSubtab='Roadmap' + clears activeNotesEpic first, so
// _nrIsAllMode() is already true by the time renderNotesRoadmap paints.
function showRoadmapView() {
  document.body.classList.remove('tt-box-fs-active');
  document.body.classList.add('tt-roadmap-tab');
  const tv = document.getElementById('tableView');
  const nv = document.getElementById('notesView');
  const tl = document.getElementById('timelineView');
  if (tv) tv.style.display = 'none';
  if (tl) tl.style.display = 'none';
  if (nv) nv.style.display = '';
  const pt = document.getElementById('parentTaskTabs');
  if (pt) { pt.style.display = 'none'; pt.innerHTML = ''; }
}
// Full entry for the Roadmap sub-tab: show the view, then paint the aggregate.
function renderAllRoadmap() { showRoadmapView(); renderNotesRoadmap(); }

function renderNotesRoadmap() {
  // Keep the notes chrome hidden only while the Roadmap tab is the active view. The
  // toggle is authoritative (state-derived), so leaving the tab — e.g. openNotesEpic,
  // which always calls this — reveals the chapter's toolbar + boxes again.
  document.body.classList.toggle('tt-roadmap-tab', _nrIsAllMode());
  const epic = _nrPrefEpic();
  const host = document.getElementById('notesRoadmap');
  if (!host) return;
  if (!epic || !epic.roadmap) { host.style.display = 'none'; host.innerHTML = ''; return; }
  host.style.display = '';
  // The timeframe columns are shared (one file for all subjects), so they must be in
  // memory before the axis can be built. On the first roadmap open, kick off the load
  // and re-render when it lands.
  if (_nrGlobalHorizons === null) {
    // A prior hard failure (500 / network) parks here: show an explicit error + Retry
    // instead of a stuck "Loading…". We do NOT auto-retry on every render, so a down
    // server isn't spammed — the user re-kicks it via Retry (nrRetryHorizons).
    if (_nrHzFailed) {
      host.innerHTML = '<div class="nr-loading">Could not load timeframe columns. <button class="btn-small" onclick="nrRetryHorizons()">Retry</button></div>';
      return;
    }
    if (!_nrHzLoading) {
      _nrHzLoading = true;
      loadRoadmapHorizons()
        .then(() => renderNotesRoadmap())
        .catch(err => {
          // Reset the in-flight flag and flip to the error state so the board never
          // stays stuck on "Loading…". (404 -> seed and 200 -> data never reach here.)
          console.error('roadmap horizons load failed', err);
          _nrHzLoading = false;
          _nrHzFailed = true;
          showToast('⚠ Could not load timeframe columns');
          renderNotesRoadmap();
        });
    }
    host.innerHTML = '<div class="nr-loading">Loading timeframe…</div>';
    return;
  }
  // Sticky-column back-fill: stamp existing entries' horizonId so they stop date-drifting. Deferred
  // OFF this render frame (avoids the cross-tab save race), lock-guarded, one save per section, and
  // only scheduled while something is still unmigrated.
  if (Object.keys(SECTIONS).some(k => !_nrMigratedSecs.has(k))) setTimeout(_nrMigrateVisibleColumns, 0);
  // The show/hide toggle lives in the notes toolbar (above this band); this band's
  // header carries only the roadmap's own controls (Grain / Fit / + Custom / + Initiative).
  // Drop a stale edit carried over from another epic / a deleted box / removed entry.
  if (_nrEdit) {
    const t = _nrEditTarget();
    if (!t || _nrEdit.idx >= _nrEntries(t.box).length) _nrEdit = null;
  }

  _nrHistBaseline();                      // the undo history's before-state = what is on screen now
  const grain = _nrGrainOf(epic);
  const scope = _nrScope(epic);
  const groupBy = _nrGroupBy(epic);
  const agg = scope !== 'chapter';        // wider than one chapter → aggregated, read-only view
  const nested = agg && groupBy === 'subject';   // Subject + Chapter = two left columns
  const NR_SUBJ_W = 130, NR_COL_THIN = 26;       // full / collapsed label-column widths
  // Subject / Chapter label columns can be collapsed to a thin strip (like a
  // collapsed timeframe column) — aggregated views only.
  const subjCollapsed = nested && _nrLabelColCollapsed(epic, 'subject');
  const chapCollapsed = agg && _nrLabelColCollapsed(epic, 'chapter');
  const subjW = subjCollapsed ? NR_COL_THIN : NR_SUBJ_W;
  const chapW = chapCollapsed ? NR_COL_THIN : TL_LANE_W;
  const cols = { subjW, chapW, subjCollapsed, chapCollapsed };
  // A chapter with a single (implicit) lane has nothing to say in a Topic column - the lane would
  // only repeat the chapter's name - so the column is not drawn and the board gets the width.
  const laneColHidden = !agg && _nrLanes(epic).length === 1;
  const labelW = agg ? ((nested ? subjW : 0) + chapW) : (laneColHidden ? 0 : TL_LANE_W);   // total left-label width → overlay offset
  const buckets = _nrBuckets(epic);       // the active chapter's axis is the shared axis
  const N = buckets.length;
  const nowIdx = buckets.findIndex(b => b.kind === 'now');
  // Column widths → THREE engines in sync. Expanded columns share the track by weight;
  // a COLLAPSED column takes a FIXED NR_COL_COLLAPSED_PX strip, so it never shrinks with
  // column count and its vertical label always fits (never spills into a neighbour). The
  // grid/flex tracks reserve the same fixed px (px + fr / px + flex-grow), and the
  // absolute overlays below use the matching per-column geometry, so header cells, body
  // cells, dividers, the now-band, the TODAY line and collapsed strips all line up.
  const COL_PX = NR_COL_COLLAPSED_PX;
  const totalCollapsedPx = buckets.reduce((s, b) => s + (b.collapsed ? COL_PX : 0), 0);
  const sumExpW = buckets.reduce((s, b) => s + (b.collapsed ? 0 : (b.w > 0 ? b.w : 1)), 0) || 1;
  // grid-template-columns for the chapter-scope grid tracks (header axis + lane bodies):
  // a collapsed column is a fixed px track, an expanded one an fr track by weight.
  const gridCols = buckets.map(b => b.collapsed ? `${COL_PX}px` : `${b.w > 0 ? b.w : 1}fr`).join(' ');
  // Per-column geometry: left edge + width as calc(<px>px + <pct>%) over the timeline
  // width. The label column(s) are the px offset; each collapsed strip reserves COL_PX
  // before the weighted share, so expanded columns split (100% - labelW - totalCollapsedPx).
  const geo = [];
  let accPx = labelW, accPct = 0;
  for (let i = 0; i < N; i++) {
    let wPx, wPct;
    if (buckets[i].collapsed) { wPx = COL_PX; wPct = 0; }
    else { const f = (buckets[i].w > 0 ? buckets[i].w : 1) / sumExpW; wPct = f * 100; wPx = -f * (labelW + totalCollapsedPx); }
    geo.push({ leftPx: accPx, leftPct: accPct, wPx, wPct });
    accPx += wPx; accPct += wPct;
  }
  const calcXY = (px, pct) => `calc(${px.toFixed(2)}px + ${pct.toFixed(3)}%)`;
  const leftOf = i => calcXY(geo[i].leftPx, geo[i].leftPct);
  const widthOf = i => calcXY(geo[i].wPx, geo[i].wPct);
  const gNow = geo[nowIdx] || { leftPx: labelW, leftPct: 0, wPx: 0, wPct: 0 };
  const lineLeft = calcXY(gNow.leftPx, gNow.leftPct);   // the today line = the Earlier | Now boundary in every grain (Rishabh 2026-09-14)
  const bandLeft = lineLeft;
  const bandW = calcXY(gNow.wPx, gNow.wPct);
  _nrFcols = { gNow, labelW };   // cached so a resize can recompute --tl-fcols (see _nrSyncFcols)
  // Initial --tl-fcols = today as a fraction of the track (the .tl-track rail's solid
  // length in aggregated scope). Exact when nothing is collapsed; refined post-render
  // (measures the live track width) once fixed-px strips are in play.
  let expBeforeNow = 0;
  for (let i = 0; i < nowIdx; i++) if (!buckets[i].collapsed) expBeforeNow += (buckets[i].w > 0 ? buckets[i].w : 1);
  const fColsInit = expBeforeNow / sumExpW;

  let dividers = '';
  for (let k = 1; k < N; k++) {
    if (k === nowIdx) continue;
    dividers += `<div class="tl-coldiv" style="left:${leftOf(k)}"></div>`;
  }

  // Collapsed columns: a full-height fixed-width strip carrying the vertical label +
  // expand click, drawn over the thin placeholder cells.
  let collapsedStrips = '';
  buckets.forEach((b, i) => {
    if (!b.collapsed) return;
    collapsedStrips += `<button class="tl-collapsed-strip" style="left:${leftOf(i)};width:${widthOf(i)}" onclick="nrToggleCollapse('${esc(b.hid)}')" title="Expand ${esc(b.label)}"><span class="tl-col-sticky"><span class="tl-col-chev">&raquo;</span><span class="tl-col-vlabel">${esc(b.label)}</span></span></button>`;
  });

  // Show a resize handle on EVERY expanded column, as long as there's another expanded
  // column to trade width with. The drag trades with the next expanded column (skipping
  // collapsed thin/fixed ones between); the LAST expanded column trades with the PREVIOUS
  // expanded one instead - so every column stays resizable even with collapsed columns
  // beside it (grab any column's right edge to make it bigger). Previously the handle only
  // appeared between two adjacent expanded columns, so it vanished around collapsed ones.
  const axisHeads = buckets.map((b, i) =>
    _nrAxisHeadHtml(b, grain, !b.collapsed && buckets.some((x, j) => j !== i && !x.collapsed))).join('');   // every grain (Rishabh 2026-10-04)
  const grainBtns = NR_GRAINS.map(([k, l]) =>
    `<button class="layout-btn${k === grain ? ' active' : ''}" onclick="setNotesRoadmapGrain('${k}')">${l}</button>`).join('');
  // Both of these WRITE the section - nrAddHorizon appends a timeframe column, nrFitColumns
  // rewrites every column width - so they are offered only to someone who can write it. This
  // is the All-mode door: the Roadmap sub-tab renders for a received book too, and these two
  // were reachable there without any chapter being opened.
  const hzTools = _nrReadOnly() ? ''
    : '<button class="btn-small" onclick="nrFitColumns()" title="Reset all timeframe widths to equal">&#10530; Fit</button>' + (grain === 'horizons' ? '<button class="btn-small" onclick="nrAddHorizon()" title="Add a custom column">+ Custom</button>' : '')
      + (_nrIsAllMode() ? '' : '<button class="btn-small" onclick="nrAddParallel()" title="Add a Parallel column - a dateless column, before Later, shown in every grain, for what runs alongside everything else">+ Parallel</button>');
  const laneFilterOn = (epic.roadmapHiddenLanes && epic.roadmapHiddenLanes.length) ? ' tl-on' : '';
  const ownerFilterOn = (epic.roadmapHiddenOwners && epic.roadmapHiddenOwners.length) ? ' nr-filter-on' : '';
  const tableOn = epic.roadmapShowTable ? ' active' : '';
  // Scope = which sections to show; group-by = the row axis for wider scopes.
  // The Roadmap sub-tab (All mode) has no active chapter, so it offers only the
  // section-wide + all-sections scopes; a chapter open offers all three.
  const scopeDefs = _nrIsAllMode()
    ? [['subject', LBL('scopeSubject')], ['all', 'All']]
    : [['chapter', LBL('scopeChapter')], ['subject', LBL('scopeSubject')], ['all', 'All']];
  const scopeBtns = scopeDefs
    .map(([k, l]) => `<button class="layout-btn${k === scope ? ' active' : ''}" onclick="setNotesRoadmapScope('${k}')" title="Show sections from ${l.toLowerCase()}">${l}</button>`).join('');
  const groupByTools = agg
    ? `<span class="toolbar-label">Group:</span><div class="layout-group">${
        [['chapter', LBL('chapter')], ['subject', LBL('subject')]].map(([k, l]) =>
          `<button class="layout-btn${k === groupBy ? ' active' : ''}" onclick="setNotesRoadmapGroupBy('${k}')" title="Group rows by ${l.toLowerCase()}">${l}</button>`).join('')
      }</div>` : '';
  // Chapter-only tools (owner filter + add chapter row) are hidden in aggregated scopes,
  // and now also when the viewer cannot write the chapter - nrAddLane creates one.
  const chapterTools = (agg || _nrReadOnly()) ? '' :
    `<button class="btn-small nr-owner-filter${ownerFilterOn}" onclick="nrOpenOwnerFilter(this)" title="Filter cards by owner">Owner &#9662;</button>
        <button class="btn-small" onclick="nrAddLane()" title="Add a ${NR_ROW_WORD.toLowerCase()} to this roadmap to group cards under (not a new ${LBL('chapter').toLowerCase()} - that is + Add Notes above)">+ ${NR_ROW_WORD}</button>`;
  // Row filter is available in every scope: chapter scope filters the chapter's
  // rows (lanes); aggregated scopes get TWO independent filters - Initiatives
  // (chapters) always, plus Areas (subjects) when nested - one per label column.
  const hiddenGroupsArr = epic.roadmapHiddenGroups || [];
  const dimFilterSpan = (dim, word) => {
    const on = agg ? (hiddenGroupsArr.some(k => k.startsWith(dim === 'subject' ? 's:' : 'c:')) ? ' tl-on' : '') : laneFilterOn;
    return `<span class="tl-layer-filter${on}" onclick="nrOpenRowFilter(this,'${dim}')" title="Show / hide ${word}">&#9662;</span>`;
  };
  const subjFilter = dimFilterSpan('subject', `${LBL('subject').toLowerCase()}s`);
  const chapFilter = dimFilterSpan('chapter', `${LBL('chapter').toLowerCase()}s`);
  // Corner cells, with collapse (« → thin strip) / expand (» ) controls in aggregated
  // views. Nested scope shows a SEPARATE Subject column (its own filter) before the
  // Chapter column (its own filter); flat / chapter scopes show only the Chapter corner.
  const subjCorner = !nested ? '' : (subjCollapsed
    ? `<div class="nr-subj-col nr-col-collapsed" style="width:${subjW}px" onclick="nrToggleLabelCol('subject')" title="Expand ${LBL('subject')} column"><span class="nr-col-sticky"><span class="tl-col-chev">&raquo;</span><span class="nr-col-vlabel">${LBL('subject')}</span></span></div>`
    : `<div class="nr-subj-col nr-subj-head" style="width:${subjW}px"><span class="nr-col-collapse" onclick="nrToggleLabelCol('subject')" title="Collapse ${LBL('subject')} column">&laquo;</span>${LBL('subject')}${subjFilter}</div>`);
  const chapCorner = laneColHidden ? '' : chapCollapsed
    ? `<div class="tl-lane-head tl-axis-corner nr-col-collapsed" style="width:${chapW}px" onclick="nrToggleLabelCol('chapter')" title="Expand ${LBL('chapter')} column"><span class="nr-col-sticky"><span class="tl-col-chev">&raquo;</span><span class="nr-col-vlabel">${LBL('chapter')}</span></span></div>`
    : `<div class="tl-lane-head tl-axis-corner${agg ? ' nr-chap-head' : ''}" style="width:${chapW}px">${agg ? `<span class="nr-col-collapse" onclick="nrToggleLabelCol('chapter')" title="Collapse ${LBL('chapter')} column">&laquo;</span>` : ''}${LBL('chapter')}${chapFilter}</div>`;
  const cornerHtml = subjCorner + chapCorner;
  const hiddenGroups = new Set(epic.roadmapHiddenGroups || []);
  const aggItems = agg ? _nrGatherBoxes(scope) : null;
  const nrEmpty = agg && !aggItems.length;   // aggregate with no cards → show the hint, drop the timeline chrome
  const lanesHtml = agg
    ? (aggItems.length
        ? _nrAggLanesHtml(aggItems, buckets, scope, groupBy, hiddenGroups, cols)
        : `<div class="nr-empty">No cards here yet. Add boxes to a ${LBL('chapter').toLowerCase()} to see them on this roadmap.</div>`)
    : _nrLanesHtml(epic, buckets);
  const selBar = (agg && _nrSel.size)
    ? `<div class="nr-selbar">${_nrSel.size} selected - drag to a new timeframe to reschedule, or to another ${LBL('chapter')}/${LBL('subject')} (dragging to a different ${LBL('chapter')}/${LBL('subject')} also moves its content). <button class="nr-selbar-clear" onclick="nrClearSel()">Clear</button></div>`
    : '';

  host.innerHTML = `
    <div class="nr-head">
      <div class="nr-tools">
        <span class="toolbar-label">Scope:</span>
        <div class="layout-group">${scopeBtns}</div>
        ${groupByTools}
        <span class="toolbar-label">Grain:</span>
        <div class="layout-group">${grainBtns}</div>
        ${hzTools}
        ${chapterTools}
        ${_nrIsAllMode() ? `<button class="layout-btn${epic.fit ? ' active' : ''}" onclick="nrToggleRoadmapFit()" title="${epic.fit ? 'Roadmap fits the page - click for a compact scrolling ' + LBL('boxNoun').toLowerCase() : 'Fit the whole roadmap on the page - all lanes visible, the page scrolls'}">↕ Fit</button>` : ''}
        ${(_nrIsAllMode() || _nrReadOnly()) ? '' : `<button class="layout-btn active" onclick="toggleNotesRoadmap()" title="${LBL('roadmapHideTip')}">✓ ${LBL('roadmap')}</button>`}
        <button class="layout-btn nr-fs-btn${nrRoadmapFullscreen() ? ' active' : ''}" onclick="nrToggleRoadmapFullscreen()" title="${nrRoadmapFullscreen() ? 'Exit fullscreen (Esc)' : 'Fullscreen roadmap (Esc to exit)'}">&#x26F6;</button>
      </div>
    </div>
    ${selBar}
    <div class="tl-scroll ${(_nrIsAllMode() ? epic.fit : notesFitMode(epic)) ? 'nr-fit' : 'nr-compact'}">
      <div class="tl-timeline${agg ? ' nr-agg' : ''}" id="nrTimeline" style="--tl-fcols:${fColsInit.toFixed(4)}">
        <div class="tl-axis-row">
          ${cornerHtml}
          <div class="tl-axis-track"${agg ? '' : ` style="display:grid;grid-template-columns:${gridCols}"`}>${axisHeads}</div>
          <span class="tl-axis-arrow" title="Time moves forward" aria-hidden="true"></span>
        </div>
        <div class="tl-lanes">${lanesHtml}</div>
        ${nrEmpty ? '' : dividers}
        ${nrEmpty ? '' : collapsedStrips}
        ${nrEmpty ? '' : `<div class="tl-now-band" style="left:${bandLeft};width:${bandW}"></div>`}
        ${nrEmpty ? '' : `<div class="tl-today-line" style="left:${lineLeft}"></div>`}
      </div>
    </div>
    ${epic.roadmapShowTable ? _nrTableHtml(epic, buckets, scope) : ''}`;

  // Playhead + now-band start at the BOTTOM of the header row; header height
  // varies by grain, so measure it live and expose it as --tl-head-h.
  const tlEl = document.getElementById('nrTimeline');
  const axis = tlEl && tlEl.querySelector('.tl-axis-row');
  if (axis) { _nrHeadH = axis.offsetHeight; tlEl.style.setProperty('--tl-head-h', _nrHeadH + 'px'); }
  _nrSyncFcols();
  _nrFitScroll();
  _nrHookScroll();
  _nrFitCollapsedBoard();
  _nrPositionCollapsedLabels();
  _nrPositionSubjectLabels();
  _nrPositionCollapsedColLabels();
  _nrWireCardEdit();
  _nrWireInlineInputs();
}

// Vertical centre (viewport coords) of an element's ON-SCREEN portion, given its
// getBoundingClientRect top/bottom. When the element is fully in view this is
// just its own centre, so a container that fits the screen behaves EXACTLY as a
// static centre would — no motion, no jank. Once the element is taller than the
// viewport, this is the centre of the *visible* slice, so the label follows the
// screen and never scrolls off (the tall aggregated "All" view). Fully off
// screen -> element centre (position then doesn't matter).
function _nrVisBand(top, bottom) {
  // Compact mode (Fit off) scrolls inside the box, so clamp the on-screen band to the
  // box; Fit mode scrolls the window, so clamp to the window.
  let vtop = 0, vbot = window.innerHeight;
  const sc = document.querySelector('#notesRoadmap .tl-scroll');
  if (sc && sc.classList.contains('nr-compact')) { const r = sc.getBoundingClientRect(); vtop = Math.max(vtop, r.top); vbot = Math.min(vbot, r.bottom); }
  const vt = Math.max(top, vtop);
  const vb = Math.min(bottom, vbot);
  return vb > vt ? (vt + vb) / 2 : (top + bottom) / 2;
}

// Centre each collapsed timeframe column's label in the visible part of its
// (full-height) strip. Degrades to strip-centre when the strip fits on screen
// (scroll-invariant, smooth); tracks the viewport only once the strip is taller
// than the screen. Cheap no-op when nothing is collapsed.
function _nrPositionCollapsedLabels() {
  const strips = document.querySelectorAll('#notesRoadmap .tl-collapsed-strip');
  strips.forEach(strip => {
    const label = strip.querySelector('.tl-col-sticky');
    if (!label) return;
    const r = strip.getBoundingClientRect();
    const within = _nrVisBand(r.top, r.bottom) - r.top - label.offsetHeight / 2;
    // Clamp the TOP to _nrHeadH: the sticky header (opaque, z-index 6) overlays the
    // strip's top _nrHeadH px, so the label must sit below it or it clips (the "DONE"
    // shows as "ONE" on a short board). Bottom clamp keeps it inside the strip.
    const clamped = Math.max(_nrHeadH, Math.min(within, strip.offsetHeight - label.offsetHeight));
    label.style.transform = `translateY(${(clamped - label.offsetTop).toFixed(1)}px)`;
  });
}

// A collapsed strip is the full board height, and its label sits BELOW the sticky
// header (_nrHeadH px). On a SHORT board (few rows) there isn't room for header +
// label, so the label clips. Give the board a min-height that fits the tallest
// collapsed label PLUS the header (measured live, so any label length works). Label
// height is font/text-driven, not scroll- or width-driven, so this runs ONCE per
// render — the per-scroll centering (_nrPositionCollapsedLabels) stays cheap.
function _nrFitCollapsedBoard() {
  const tl = document.getElementById('nrTimeline');
  if (!tl) return;
  let maxLabelH = 0;
  tl.querySelectorAll('.tl-collapsed-strip .tl-col-sticky').forEach(l => { maxLabelH = Math.max(maxLabelH, l.offsetHeight); });
  tl.style.minHeight = maxLabelH ? (maxLabelH + _nrHeadH + 20) + 'px' : '';
}

// Centre each subject's label in the visible part of its group (all its chapter
// rows). Group-centre when the group fits on screen; follows the viewport when
// the group is taller. Clamped to the group so it never leaves its own band.
function _nrPositionSubjectLabels() {
  const host = document.getElementById('notesRoadmap');
  if (!host) return;
  const rows = Array.from(host.querySelectorAll('.tl-lanes .tl-lane-row'));
  for (let i = 0; i < rows.length; i++) {
    if (!rows[i].classList.contains('nr-grp-start')) continue;
    const label = rows[i].querySelector('.nr-subj-col .n');
    if (!label) continue;
    const top = rows[i].getBoundingClientRect().top;
    let bottom = rows[i].getBoundingClientRect().bottom;   // extend over continuation rows
    for (let j = i + 1; j < rows.length && rows[j].classList.contains('nr-grp-cont'); j++) {
      bottom = rows[j].getBoundingClientRect().bottom;
    }
    const y = _nrVisBand(top, bottom) - top - label.offsetHeight / 2;
    const clamped = Math.max(0, Math.min(y, (bottom - top) - label.offsetHeight));
    label.style.transform = `translateY(${clamped.toFixed(1)}px)`;   // transform (GPU) not top (reflow) — smooth
  }
}

// Centre a collapsed LABEL column's (Subject / Chapter) vertical label in the
// visible part of the full timeline height — matching a collapsed timeframe
// strip. Timeline-centre when it fits; follows the viewport when it's taller.
function _nrPositionCollapsedColLabels() {
  const tl = document.getElementById('nrTimeline');
  if (!tl) return;
  const tlRect = tl.getBoundingClientRect();
  const centerVp = _nrVisBand(tlRect.top, tlRect.bottom);
  tl.querySelectorAll('.tl-axis-row .nr-col-collapsed .nr-col-sticky').forEach(lbl => {
    const cellTop = lbl.parentElement.getBoundingClientRect().top;
    const raw = centerVp - lbl.offsetHeight / 2 - cellTop;
    const minTop = tlRect.top - cellTop;
    const maxTop = tlRect.bottom - lbl.offsetHeight - cellTop;
    lbl.style.transform = `translateY(${Math.max(minTop, Math.min(raw, maxTop)).toFixed(1)}px)`;   // transform (GPU) not top (reflow) — smooth
  });
}
// --tl-fcols = today's fraction of the TRACK width. The .tl-track rail (aggregated scope)
// draws solid up to it; with fixed-px collapsed strips that fraction depends on the live
// pixel width, so measure it after render and on resize (the calc-based overlays self-adjust).
function _nrSyncFcols() {
  const tlEl = document.getElementById('nrTimeline');
  if (!tlEl || !_nrFcols) return;
  const { gNow, labelW } = _nrFcols;
  const W = tlEl.getBoundingClientRect().width;
  const trackW = W - labelW;
  if (trackW <= 0) return;
  const todayX = gNow.leftPx + (gNow.leftPct / 100) * W;
  tlEl.style.setProperty('--tl-fcols', Math.max(0, Math.min(1, (todayX - labelW) / trackW)).toFixed(4));
}

// Compact mode (Fit off): cap the box to the viewport so it scrolls internally.
// Fit mode (Fit on): clear the cap so the board is full height (page scrolls).
function _nrFitScroll() {
  const sc = document.querySelector('#notesRoadmap .tl-scroll');
  if (!sc) return;
  // Fullscreen: the overlay is the viewport; the board scrolls inside it under the tool band, whatever
  // the Fit flag says (the page behind cannot scroll, so "page scrolls" has no meaning here).
  if (nrRoadmapFullscreen()) { const top = sc.getBoundingClientRect().top; sc.style.maxHeight = Math.max(240, Math.round(window.innerHeight - top - 8)) + 'px'; return; }
  if (sc.classList.contains('nr-fit')) { sc.style.maxHeight = ''; return; }
  const top = sc.getBoundingClientRect().top;
  sc.style.maxHeight = Math.max(360, Math.round(window.innerHeight - top - 16)) + 'px';
}
function _nrHookScroll() {
  if (_nrScrollHooked) return;
  _nrScrollHooked = true;
  let raf = 0;
  const tick = () => { raf = 0; _nrPositionCollapsedLabels(); _nrPositionSubjectLabels(); _nrPositionCollapsedColLabels(); };
  // The frozen header is CSS position:sticky in every mode (styles.css .tl-axis-row rules) - nothing to do per scroll.
  const onScroll = () => {
    if (!raf) raf = requestAnimationFrame(tick);   // label repositioning stays rAF-throttled
  };
  // Capture phase catches scroll from the window (Fit-on vertical scroller) AND from the
  // .tl-scroll box (Fit-off internal + horizontal scroll); scroll doesn't bubble but does capture.
  document.addEventListener('scroll', onScroll, true);
  window.addEventListener('resize', () => { _nrFitScroll(); _nrSyncFcols(); onScroll(); });
  // Escape clears a multi-select (only when not typing in an input - the card editor
  // stops Escape from bubbling here, so this fires only on the board itself).
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && _nrSel.size) { _nrSel.clear(); renderNotesRoadmap(); } });
}

;
// ==== FILE: js/roadmap/card-editor.js ====
// ── notes-roadmap / card-editor ─────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: the inline card editor (title / owner / date / sub-tasks per entry) + allocate-to-roadmap.
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

// ── Inline card editor (title / owner / date / sub-tasks, per entry) ─────────
// Single-click flips a card to inputs (see _nrCardHtml's editing branch); this
// focuses the title and commits the entry on Enter / blur (Escape cancels).
// Tabbing between fields doesn't commit. Title is box-level (shared); owner /
// date / sub-tasks are per entry (this column).
function _nrReadCardInputsInto(box, idx) {
  const sched = _nrEnsureSchedule(box);
  const entry = sched[idx];
  if (!entry) return;
  const ownerEl = document.getElementById('nrCardOwner');
  const dateEl = document.getElementById('nrCardDate');
  const tasksEl = document.getElementById('nrCardTasks');
  // Title is NOT read here — it edits the box's # heading, handled in
  // _nrCommitCardEdit via renameBoxHeading (the single title source).
  if (ownerEl) entry.owner = ownerEl.value.trim();
  const laneEl = document.getElementById('nrCardLane');
  if (laneEl) box.roadmapLane = laneEl.value;                          // lane is per-initiative (whole box)
  if (dateEl) entry.date = dateEl.value || null;                        // planned start = a recorded fact; the column is the sticky horizonId (horizons grain). Only calendar grains place by this date.
  // Allocation date = when the station was created (box-level). Auto-set on new
  // stations; editable here so older stations can be back-filled.
  const allocEl = document.getElementById('nrCardAllocDate');
  if (allocEl) { if (allocEl.value) box.createdAt = allocEl.value; else delete box.createdAt; }
  // Actual start: auto-stamped when the card first goes Active, but editable here.
  const actualStartEl = document.getElementById('nrCardActualStart');
  if (actualStartEl) { if (actualStartEl.value) entry.actualStart = actualStartEl.value; else delete entry.actualStart; }
  // Planned finish (target): optional.
  const plannedEndEl = document.getElementById('nrCardPlannedEnd');
  if (plannedEndEl) { if (plannedEndEl.value) entry.plannedEnd = plannedEndEl.value; else delete entry.plannedEnd; }
  // Actual finish: a plain date - setting it marks the station Done (and moves it to its
  // Earlier/Done column); clearing it re-opens the station. Blocked is retired, so any
  // legacy blocked flag is dropped on save.
  const endDateEl = document.getElementById('nrCardEndDate');
  // Only touch the Done state when the Actual-finish field ACTUALLY changed - so a no-op
  // commit (open a Done card + click away without editing) never un-Dones it. Critical for
  // legacy Done cards (done=true, no recorded endDate): their field renders empty, and the
  // old unconditional-else path silently un-Done'd them on inspection.
  if (endDateEl) {
    const fv = endDateEl.value, cur = entry.endDate || '';
    if (fv !== cur) {
      if (fv) { entry.endDate = fv; entry.done = true; }   // set / changed a finish -> Done
      else { delete entry.endDate; entry.done = false; }   // cleared a set finish -> not Done
    }
  }
  delete entry.blocked; delete entry.blockedDate;
  if (tasksEl) {
    const t = tasksEl.value.split('\n').map(x => x.trim());   // keep internal blank rows (user grouping)
    while (t.length && !t[0]) t.shift();                       // drop only leading blanks
    while (t.length && !t[t.length - 1]) t.pop();              // and trailing blanks
    entry.tasks = t;
  }
}

function _nrWireCardEdit() {
  if (!_nrEdit) return;
  const cap = _nrEdit;
  const titleEl = document.getElementById('nrCardTitle');   // absent in the aggregated editor (title is read-only there)
  const ownerEl = document.getElementById('nrCardOwner');
  const allocEl = document.getElementById('nrCardAllocDate');
  const dateEl = document.getElementById('nrCardDate');
  const actualStartEl = document.getElementById('nrCardActualStart');
  const plannedEndEl = document.getElementById('nrCardPlannedEnd');
  const endDateEl = document.getElementById('nrCardEndDate');
  const tasksEl = document.getElementById('nrCardTasks');
  // EVERY editable field must be in fields[] (the blur handler commits when focus leaves
  // to a non-field element); the 5 date placeholders sit in tab order between owner and
  // sub-tasks, so all must be listed or tabbing through would commit/close the editor.
  const fields = [titleEl, ownerEl, allocEl, dateEl, actualStartEl, plannedEndEl, endDateEl, tasksEl].filter(Boolean);
  if (!fields.length) return;
  // The sub-tasks box grows with its text (Rishabh 2026-10-04: a fixed 3 rows hid the rest).
  if (tasksEl) { const grow = () => { tasksEl.style.height = 'auto'; tasksEl.style.height = tasksEl.scrollHeight + 'px'; }; grow(); tasksEl.addEventListener('input', grow); }
  const focusEl = titleEl || fields[0];
  focusEl.focus(); if (focusEl.select) focusEl.select();
  const commit = () => { if (_nrEdit === cap) _nrCommitCardEdit(); };
  const cancel = () => { if (_nrEdit === cap) { _nrEdit = null; _nrCloseEditorInPlace(); } };
  fields.forEach(el => {
    el.addEventListener('keydown', e => {
      e.stopPropagation();
      // Enter commits — except inside the sub-tasks textarea, where Enter starts a
      // new line (Ctrl/Cmd+Enter commits it). Escape always cancels.
      if (e.key === 'Enter' && (el !== tasksEl || e.ctrlKey || e.metaKey)) { e.preventDefault(); commit(); }
      else if (e.key === 'Escape') { e.preventDefault(); cancel(); }
    });
    el.addEventListener('blur', e => {
      if (e.relatedTarget && fields.indexOf(e.relatedTarget) !== -1) return;   // moving between the fields
      commit();
    });
  });
}

// Resolves when the meta save has LANDED (or at once when nothing was saved), so a writer that
// follows an open edit - nrAggDeleteBox - can serialize behind it: two meta saves of one section in
// flight together race at the store, and the later-landing one (here the commit, carrying the box)
// wins over the delete.
function _nrCommitCardEdit() {
  if (!_nrEdit) return Promise.resolve();
  // A read-only card only CLOSES: nothing is read back from its inputs, nothing is saved,
  // and no "Saved" toast claims otherwise. Enter / blur land here exactly as an edit does.
  if (_nrCardReadOnly(_nrEdit.secKey, _nrEdit.epicId)) { _nrEdit = null; _nrCloseEditorInPlace(); return Promise.resolve(); }
  const t = _nrEditTarget();
  const idx = _nrEdit.idx;
  const secKey = _nrEdit.secKey;                            // capture before we null _nrEdit
  const titleEl = document.getElementById('nrCardTitle');
  const newTitle = titleEl ? titleEl.value.trim() : null;
  _nrEdit = null;
  let saved = Promise.resolve();
  if (t) {
    _nrReadCardInputsInto(t.box, idx);
    saved = _nrSaveMeta(t.sec);                           // save into the card's OWN Area
    if (typeof renderNotesOutline === 'function') renderNotesOutline();   // title feeds the sidebar
    showToast('✓ Saved');
    // The title field edits the box's # heading (the one title source) in BOTH the
    // chapter and aggregated editors. _nrApplyBoxTitle also handles a box whose editor
    // is off-screen (another chapter / subject) by rewriting its .md directly.
    if (newTitle !== null && newTitle !== _nrRealTitle(t.box, secKey, t.epic.id)) {
      _nrApplyBoxTitle(t.sec, t.epic, t.box, newTitle, secKey);
    }
  }
  _nrCloseEditorInPlace();
  return saved;
}

// Closing the editor takes ~450px out of the board (the open card's fields). The scroller - the page in Fit mode, the
// .tl-scroll box in compact - is then shorter than its scroll position allows, the browser clamps the position upward,
// and the card the person was on leaves the screen; on a short board that reads as "the page jumped to the top"
// (Rishabh 2026-10-28, prod RUN: last card at the page's bottom, close -> card out of view). The card is the anchor:
// remember where it sat on screen, re-render, put it back there (the scroller clamps what it must), and at the least
// keep it in view. A re-render with no open card (nothing to anchor) is the plain render.
function _nrCloseEditorInPlace() {
  const open = document.querySelector('#notesRoadmap .tl-card.editing');
  const anchor = open ? { boxId: open.dataset.boxId, eidx: open.dataset.eidx, top: open.getBoundingClientRect().top } : null;
  renderNotesRoadmap();
  if (!anchor) return;
  const el = document.querySelector(`#notesRoadmap .tl-card[data-box-id="${CSS.escape(anchor.boxId)}"][data-eidx="${CSS.escape(anchor.eidx)}"]`);
  if (!el) return;
  const sc = document.querySelector('#notesRoadmap .tl-scroll');
  const scroller = (sc && !sc.classList.contains('nr-fit') && sc.scrollHeight > sc.clientHeight) ? sc : window;
  // The sticky axis row covers the top of the scroller: "on screen" starts below it, not at 0.
  const axis = document.querySelector('#notesRoadmap .tl-axis-row');
  const headTop = axis ? axis.getBoundingClientRect().bottom : 0;
  const viewBottom = scroller === window ? window.innerHeight : sc.getBoundingClientRect().bottom;
  const wasOnScreen = anchor.top >= headTop && anchor.top < viewBottom;
  if (wasOnScreen) { const delta = el.getBoundingClientRect().top - anchor.top; if (delta) scroller.scrollBy(0, delta); }
  // Whatever the clamp left: the card's top sits below the header and its bottom inside the view (its top wins when
  // the card is taller than the view).
  const r = el.getBoundingClientRect();
  if (r.bottom > viewBottom) scroller.scrollBy(0, r.bottom - viewBottom + 12);
  const r2 = el.getBoundingClientRect();
  if (r2.top < headTop + 8) scroller.scrollBy(0, r2.top - headTop - 8);
}

// Rename a box's # (H1) heading - the single title source - from any scope. If the box
// is on screen (active chapter), edit its live content so the change persists exactly
// as typing would. Otherwise (aggregated card in another chapter / subject, no editor)
// load its .md, replace the H1 via _setFirstH1, and save - aborting (no clobber) if the
// read or write fails. Also updates box.title, the cache the roadmap card reads.
async function _nrApplyBoxTitle(sec, epic, box, newTitle, secKey) {
  if (_nrReadOnly(epic)) return;                        // the real writer refuses itself, not only via _nrCommitCardEdit
  const t = (newTitle || '').trim();
  // On-screen box (the ACTIVE section's ACTIVE epic): edit its live editor so the change
  // persists exactly as typing would. Box ids are not unique across epics (legacy boxes
  // are all "main"), so ONLY take this path when the box is truly the mounted one -
  // otherwise an off-screen rename would clobber the active epic's .md.
  if (_nrBoxMounted(secKey, epic.id)) {
    const editor = document.querySelector(`.notes-editor[data-box-id="${box.id}"]`);
    if (editor && typeof getEditorContent === 'function' && typeof setEditorContent === 'function' && typeof _setFirstH1 === 'function') {
      setEditorContent(editor, _setFirstH1(getEditorContent(editor), t));
      editor.dispatchEvent(new Event('input', { bubbles: true }));   // persists .md + refreshes cache / outline / roadmap
      return;
    }
  }
  // Off-screen box: rewrite its .md directly, scoped by sec + epic + box (never the DOM).
  const content = await _nrLoadContentStrict(sec, epic.id, box.id);
  if (content === null) { showToast('⚠ Could not open the station to rename it'); return; }
  const ok = await _nrSaveContentStrict(sec, epic.id, box.id, _setFirstH1(content, t));
  if (!ok) { showToast('⚠ Could not save the new title'); return; }
  if (t) box.title = t; else delete box.title;         // cache the roadmap / outline read
  await _nrSaveMeta(sec);
  renderNotesRoadmap();
  if (typeof renderNotesOutline === 'function') renderNotesOutline();
}

// "+ column": save the current entry, then add a new appearance (in Later,
// inheriting this entry's owner) and open it for editing.
function nrAddEntry() {
  if (!_nrEdit) return;
  if (_nrCardReadOnly(_nrEdit.secKey, _nrEdit.epicId)) return;   // read-only: the button is not drawn; this is the writer's own refusal
  const t = _nrEditTarget();
  if (!t) return;
  _nrReadCardInputsInto(t.box, _nrEdit.idx);
  const sched = _nrEnsureSchedule(t.box);
  const cur = sched[_nrEdit.idx] || {};
  sched.push({ date: null, tasks: [], owner: cur.owner || '' });
  _nrEdit = { secKey: _nrEdit.secKey, epicId: _nrEdit.epicId, boxId: t.box.id, idx: sched.length - 1 };
  _nrSaveMeta(t.sec);
  renderNotesRoadmap();
  showToast('✓ Added another timeframe — set its date + tasks');
}

// "Remove": drop this entry (this column's appearance). If it was the only one,
// the box falls back to a single Later card.
function nrRemoveEntry() {
  if (!_nrEdit) return;
  if (_nrCardReadOnly(_nrEdit.secKey, _nrEdit.epicId)) return;   // read-only: the button is not drawn; this is the writer's own refusal
  const t = _nrEditTarget();
  if (t) {
    const sched = _nrEnsureSchedule(t.box);
    sched.splice(_nrEdit.idx, 1);
    _nrSaveMeta(t.sec);
  }
  _nrEdit = null;
  renderNotesRoadmap();
  showToast('✓ Card removed');
}

// From a box (notes area): jump to its roadmap card and open the editor so you
// can set its timeframe (Start date / lane / Done). Every box already appears on
// the roadmap (unscheduled = a Later card); this turns the roadmap on if needed,
// switches to the editable per-chapter scope, and opens this box's card.
function allocateBoxToRoadmap(boxId) {
  const sec = SECTIONS[activeSection];
  const epic = _nrEpic();
  if (!epic) return;
  if (_nrReadOnly(epic)) return;                        // it turns the roadmap on + saves - never for a read-only chapter
  const box = (epic.boxes || []).find(b => b.id === boxId);
  if (!box) return;
  if (!epic.roadmap) { epic.roadmap = true; if (!epic.roadmapGrain) epic.roadmapGrain = NR_DEFAULT_GRAIN; }
  epic.roadmapScope = 'chapter';          // aggregated scopes are read-only — need the editable view
  _nrEnsureSchedule(box);
  _nrSaveMeta(sec);
  _nrClearEdits();
  _nrEdit = { secKey: activeSection, epicId: epic.id, boxId, idx: 0 };
  if (typeof renderNotesToolbar === 'function') renderNotesToolbar();
  renderNotesRoadmap();
  const host = document.getElementById('notesRoadmap');
  if (host) host.scrollIntoView({ behavior: 'smooth', block: 'start' });
  showToast('Set this ' + LBL('boxNoun').toLowerCase() + "'s timeframe on the roadmap");
}

;
// ==== FILE: js/roadmap/controls.js ====
// ── notes-roadmap / controls ────────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: option-band control handlers - grain / scope / group / label-col / table / Fit toggles and the row / lane / owner / group filters.
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

// ── Toolbar + grain ──────────────────────────────────────────────────────────
function toggleNotesRoadmap() {
  const sec = SECTIONS[activeSection];
  const epic = _nrEpic();
  if (!epic) return;
  // Hiding the button is presentation; this is the actual rule. An inline onclick is a bare
  // global reachable from a stale DOM node left behind by a previous document, so the write
  // has to refuse on its own. Silent, like every other read-only guard in the app - the
  // control is not offered, so arriving here at all means something went around the UI.
  if (_nrReadOnly(epic)) return;
  epic.roadmap = !epic.roadmap;
  if (epic.roadmap && !epic.roadmapGrain) epic.roadmapGrain = NR_DEFAULT_GRAIN;
  _nrSaveMeta(sec);
  renderNotesToolbar();      // reflect the button's active state
  renderNotesRoadmap();
  showToast(epic.roadmap ? LBL('roadmapAddedToast') : LBL('roadmapHiddenToast'));
}

function setNotesRoadmapGrain(g) {
  const epic = _nrPrefEpic();
  if (!epic || epic.roadmapGrain === g) return;
  epic.roadmapGrain = g;
  _nrClearEdits();
  _nrSavePrefs();
  renderNotesRoadmap();
}

// Scope = how wide the roadmap looks: this chapter (editable board), this
// subject, or all subjects (both aggregated + read-only). Stored on the epic.
function setNotesRoadmapScope(s) {
  const epic = _nrPrefEpic();
  if (!epic) return;
  const next = (s === 'subject' || s === 'all') ? s : 'chapter';
  if (_nrIsAllMode() && next === 'chapter') return;   // no chapter scope without an open chapter
  if (_nrScope(epic) === next) return;
  if (next === 'chapter') delete epic.roadmapScope; else epic.roadmapScope = next;
  _nrClearEdits();
  _nrSavePrefs();
  renderNotesRoadmap();
}

// Group-by = the row axis for aggregated scopes: Chapter or Subject.
function setNotesRoadmapGroupBy(g) {
  const epic = _nrPrefEpic();
  if (!epic) return;
  if (g === 'subject') epic.roadmapGroupBy = 'subject'; else delete epic.roadmapGroupBy;
  _nrSavePrefs();
  renderNotesRoadmap();
}

// Collapse the Subject / Chapter LABEL columns to a thin strip (like a collapsed
// timeframe column). Collapsed columns are stored on epic.roadmapLabelCollapsed
// (an array of 'subject' | 'chapter').
function _nrLabelColCollapsed(epic, which) {
  return !!(epic.roadmapLabelCollapsed && epic.roadmapLabelCollapsed.indexOf(which) !== -1);
}
function nrToggleLabelCol(which) {
  const epic = _nrPrefEpic();
  if (!epic) return;
  const list = Array.isArray(epic.roadmapLabelCollapsed) ? epic.roadmapLabelCollapsed.slice() : [];
  const at = list.indexOf(which);
  if (at === -1) list.push(which); else list.splice(at, 1);
  if (list.length) epic.roadmapLabelCollapsed = list; else delete epic.roadmapLabelCollapsed;
  _nrSavePrefs();
  renderNotesRoadmap();
}

// Show / hide the read-only raw-data table below the board.
function nrToggleTable() {
  const epic = _nrPrefEpic();
  if (!epic) return;
  if (epic.roadmapShowTable) delete epic.roadmapShowTable; else epic.roadmapShowTable = true;
  _nrSavePrefs();
  renderNotesRoadmap();
}

// Collapse / expand a column to a thin strip. Keeps the column and all its cards
// — just hides them until expanded. Works in every grain: Horizons persists on
// the epic's materialized horizons list; calendar grains persist a per-grain list
// of collapsed slot indices (hid = "grain:index").
function nrToggleCollapse(hid) {
  const epic = _nrPrefEpic();
  if (!epic) return;
  const grain = _nrGrainOf(epic);
  let nowCollapsed;
  const par = _nrIsParallelHid(hid) ? _nrParallelOf(epic, hid) : null;
  if (par) {
    if (_nrIsAllMode()) return;                            // the tab derives the column from its chapter; collapse it there
    par.collapsed = !par.collapsed; if (!par.collapsed) delete par.collapsed;
    nowCollapsed = !!par.collapsed;
    _nrSavePrefs();
  } else if (grain === 'horizons') {
    const h = _nrEnsureHorizons().find(x => x.id === hid);
    if (!h) return;
    h.collapsed = !h.collapsed;
    nowCollapsed = h.collapsed;
    _nrSaveHorizons();                 // collapse state is part of the shared column
  } else {
    const idx = parseInt(String(hid).split(':')[1], 10);
    if (!(idx >= 0)) return;
    epic.roadmapCollapsed = epic.roadmapCollapsed || {};
    const list = epic.roadmapCollapsed[grain] = epic.roadmapCollapsed[grain] || [];
    const at = list.indexOf(idx);
    if (at === -1) { list.push(idx); nowCollapsed = true; } else { list.splice(at, 1); nowCollapsed = false; }
    _nrSavePrefs();                        // calendar-grain collapse stays per-chapter (or per-section in All mode)
  }
  renderNotesRoadmap();
  showToast(nowCollapsed ? '✓ Timeframe collapsed' : '✓ Timeframe expanded');
}

// Row filter dispatcher — chapter scope filters the chapter rows (lanes);
// aggregated scopes filter the chapter / subject rows.
function nrOpenRowFilter(anchorEl, dim) {
  const epic = _nrPrefEpic();
  if (!epic) return;
  return _nrScope(epic) === 'chapter' ? nrOpenLaneFilter(anchorEl) : nrOpenGroupFilter(anchorEl, dim);
}

// Chapter-scope filter — show / hide the chapter's rows (lanes). Reuses the
// shared data-grid filter dropdown (search + checkboxes), persists HIDDEN lane
// ids so renames don't change what's hidden. Uses display names (default lane
// shows the chapter's own name).
function nrOpenLaneFilter(anchorEl) {
  const epic = _nrEpic();
  if (!epic || typeof tvBuildFilterPop !== 'function') return;
  const lanes = _nrLanes(epic);
  const disp = l => _nrLaneDisplayName(l, epic);
  const names = [], seen = new Set();
  lanes.forEach(l => { const nm = disp(l); if (!seen.has(nm)) { seen.add(nm); names.push(nm); } });
  const hidden = new Set(epic.roadmapHiddenLanes || []);
  const selected = new Set(names.filter(nm => lanes.some(l => disp(l) === nm && !hidden.has(l.id))));
  tvBuildFilterPop(names, selected, anchorEl, (chosen) => {
    const keep = new Set(chosen);
    const nowHidden = lanes.filter(l => !keep.has(disp(l))).map(l => l.id);
    if (nowHidden.length) epic.roadmapHiddenLanes = nowHidden; else delete epic.roadmapHiddenLanes;
    _nrSaveMeta(SECTIONS[activeSection]);
    renderNotesRoadmap();
    const shown = lanes.length - nowHidden.length;
    showToast(nowHidden.length ? `Showing ${shown} of ${lanes.length} ${NR_ROW_WORD.toLowerCase()}s` : '✓ Showing all ' + LBL('chapter').toLowerCase() + 's');
  });
}

// Aggregated-scope filter — show / hide Initiative (chapter) or Area (subject) rows.
// `dim` picks which: 'subject' filters Areas ('s:'+subjectKey keys), 'chapter' filters
// Initiatives ('c:'+chapterId keys). Both persist on epic.roadmapHiddenGroups and are
// independent - each write only replaces its own key prefix, leaving the other's intact.
function nrOpenGroupFilter(anchorEl, dim) {
  const epic = _nrPrefEpic();
  if (!epic || typeof tvBuildFilterPop !== 'function') return;
  const scope = _nrScope(epic);
  const prefix = dim === 'subject' ? 's:' : 'c:';
  const hidden = new Set(epic.roadmapHiddenGroups || []);
  const rows = [], seenKey = new Set();
  _nrGatherBoxes(scope).forEach(it => {
    // The Initiative (chapter) filter lists only chapters from Areas that are
    // currently VISIBLE. A chapter under an Area-filtered-out (hidden) Area isn't on
    // the board, so it must not appear as an Initiative option - otherwise the filter
    // shows every chapter regardless of the Area filter (it reads as "on" yet is hidden).
    if (dim === 'chapter' && hidden.has('s:' + it.secKey)) return;
    const key = prefix + (dim === 'subject' ? it.secKey : it.epic.id);
    if (seenKey.has(key)) return;
    seenKey.add(key);
    rows.push({ key, name: dim === 'subject' ? (it.sec.title || it.secKey) : (it.epic.name || ''), area: it.sec.title || it.secKey });
  });
  if (!rows.length) return;
  // Drive the popup by a UNIQUE label mapped back to the row's key, NOT by raw name -
  // else two rows with the same name (e.g. an "Overview" chapter in two Areas) would
  // hide / show together. Initiatives are prefixed with their Area; any remaining
  // duplicate gets a " (n)" suffix so every label is distinct.
  // Prefix a chapter label with its Area only when the list spans MORE THAN ONE Area
  // (needed to tell apart same-named chapters across Areas). With a single Area in view
  // the "Area / " prefix is just noise, so show the bare chapter name. Same-name
  // duplicates still get a " (n)" suffix regardless.
  const multiArea = new Set(rows.map(r => r.area)).size > 1;
  const labelKey = new Map(), used = new Map(), labels = [];
  rows.forEach(r => {
    let lab = (dim === 'subject' || !multiArea) ? r.name : `${r.area} / ${r.name}`;
    if (used.has(lab)) { const c = used.get(lab) + 1; used.set(lab, c); lab = `${lab} (${c})`; } else used.set(lab, 1);
    labels.push(lab); labelKey.set(lab, r.key);
  });
  const selected = new Set(labels.filter(lab => !hidden.has(labelKey.get(lab))));
  tvBuildFilterPop(labels, selected, anchorEl, (chosen) => {
    const keep = new Set(chosen.map(lab => labelKey.get(lab)));
    const nowHidden = rows.filter(r => !keep.has(r.key)).map(r => r.key);
    // Replace only the keys we actually LISTED this time; keep the other dimension's
    // keys AND preserve this dimension's keys for rows we excluded (e.g. Initiatives
    // under a hidden Area keep their own hidden state, restored when the Area returns).
    const listedKeys = new Set(rows.map(r => r.key));
    const merged = (epic.roadmapHiddenGroups || []).filter(k => !listedKeys.has(k)).concat(nowHidden);
    if (merged.length) epic.roadmapHiddenGroups = merged; else delete epic.roadmapHiddenGroups;
    _nrSavePrefs();
    renderNotesRoadmap();
    const label = `${(dim === 'subject' ? LBL('subject') : LBL('chapter')).toLowerCase()}s`;
    showToast(nowHidden.length ? `Showing ${rows.length - nowHidden.length} of ${rows.length} ${label}` : `✓ Showing all ${label}`);
  });
}

// Owner filter — show / hide cards by their owner. Same shared dropdown as the
// initiative filter; persists the HIDDEN owner names (trimmed; '' = no owner).
function nrOpenOwnerFilter(anchorEl) {
  const epic = _nrEpic();
  if (!epic || typeof tvBuildFilterPop !== 'function') return;
  const owners = _nrAllOwners(epic);
  if (!owners.length) { showToast('No owners to filter'); return; }
  const hidden = new Set(epic.roadmapHiddenOwners || []);
  const selected = new Set(owners.filter(o => !hidden.has(o)));
  tvBuildFilterPop(owners, selected, anchorEl, (chosen) => {
    const keep = new Set(chosen);
    const nowHidden = owners.filter(o => !keep.has(o));
    if (nowHidden.length) epic.roadmapHiddenOwners = nowHidden; else delete epic.roadmapHiddenOwners;
    _nrSaveMeta(SECTIONS[activeSection]);
    renderNotesRoadmap();
    const shown = owners.length - nowHidden.length;
    showToast(nowHidden.length ? `Showing ${shown} of ${owners.length} owners` : '✓ Showing all owners');
  });
}


// ── Roadmap undo / redo (Rishabh 2026-10-04: "roadmap mein undo kaam nahi karta") ─────────────
// Ctrl+Z / Ctrl+Shift+Z (Ctrl+Y) undo ROADMAP actions while the roadmap is on screen - keyboard only, no
// buttons (Rishabh 2026-10-05: "yeh undo and redo ke button nahi chahiye"); the band stays uncluttered. Still on
// screen; the table's own history (state.js undo()) is never touched from here (RUN 2026-10-05:
// Ctrl+Z on the roadmap used to run the TABLE undo). A step = everything ONE action saved: the
// notes meta of each chapter it wrote (its notesEpics, as JSON before and after) and the shared
// column list. BEFORE is the snapshot the render keeps per section (_nrHistBase), so no writer
// needs code of its own: every roadmap layout / schedule save goes through _nrSaveMeta or
// _nrSaveHorizons, which record the step. Station add / delete / cross-chapter move keep the raw
// savers (they also move or delete the box's .md, which a meta restore cannot bring back - the
// 7 s Undo toast covers a delete). Undo restores the before-state INTO the live objects (same
// epic / box identity - the notes view holds references), saves through the raw savers (not
// recorded) and re-renders the roadmap + the notes boxes.
const NR_HIST_MAX = 40;
let _nrHist = [];            // steps: { secs: { secKey: { before, after } }, hz: { before, after } | null }
let _nrHistAt = 0;           // steps[0 .. _nrHistAt) are applied; steps[_nrHistAt ..] are redo
let _nrHistBase = {};        // secKey -> JSON of its notesEpics as last rendered / saved
let _nrHzBase = null;        // JSON of the shared column list as last rendered / saved
let _nrHistStep = null;      // the step the current action is assembling (its saves land in one tick)
function _nrSecKeyOf(sec) { return Object.keys(SECTIONS).find(k => SECTIONS[k] === sec) || null; }
function _nrSnapSec(sec) { return JSON.stringify(sec.notesEpics || []); }
function _nrSnapHz() { return JSON.stringify(_nrGlobalHorizons || []); }
// The render's pre-mutation snapshot: the active section (chapter board) or every section (the
// aggregated board draws them all). Skipped while a column is being dragged (a render per move).
function _nrHistBaseline() {
  if (_nrColDrag) return;
  const keys = _nrIsAllMode() || _nrScope(_nrPrefEpic() || {}) !== 'chapter' ? Object.keys(SECTIONS) : [activeSection];
  keys.forEach(k => { if (SECTIONS[k] && !(_nrHistStep && _nrHistStep.secs[k])) _nrHistBase[k] = _nrSnapSec(SECTIONS[k]); });
  if (_nrGlobalHorizons && !(_nrHistStep && _nrHistStep.hz)) _nrHzBase = _nrSnapHz();
}
function _nrHistRecord(secKey, hz) {
  if (!_nrHistStep) { _nrHistStep = { secs: {}, hz: null }; Promise.resolve().then(_nrHistCommit); }
  if (secKey && SECTIONS[secKey]) {
    const after = _nrSnapSec(SECTIONS[secKey]);
    const cur = _nrHistStep.secs[secKey];
    if (cur) cur.after = after; else _nrHistStep.secs[secKey] = { before: _nrHistBase[secKey] != null ? _nrHistBase[secKey] : after, after };
    _nrHistBase[secKey] = after;
  }
  if (hz) {
    const after = _nrSnapHz();
    if (_nrHistStep.hz) _nrHistStep.hz.after = after; else _nrHistStep.hz = { before: _nrHzBase != null ? _nrHzBase : after, after };
    _nrHzBase = after;
  }
}
function _nrHistCommit() {
  const st = _nrHistStep; _nrHistStep = null;
  if (!st) return;
  const changed = Object.keys(st.secs).some(k => st.secs[k].before !== st.secs[k].after) || (st.hz && st.hz.before !== st.hz.after);
  if (!changed) return;                                   // a save that moved nothing is no step
  _nrHist.length = _nrHistAt; _nrHist.push(st);
  if (_nrHist.length > NR_HIST_MAX) _nrHist.shift();
  _nrHistAt = _nrHist.length;
  _nrHistButtons();
}
// The recorded savers - every roadmap layout / schedule writer calls these.
function _nrSaveMeta(sec) { _nrHistRecord(_nrSecKeyOf(sec), false); return saveNotesMeta(sec); }
function _nrSaveHorizons() { _nrHistRecord(null, true); return saveRoadmapHorizons(); }
// Put a snapshot back into the live objects, keeping every epic's and box's identity.
function _nrReplaceEpics(sec, list) {
  const oldE = new Map((sec.notesEpics || []).map(e => [e.id, e]));
  sec.notesEpics = list.map(se => {
    const e = oldE.get(se.id) || {};
    const oldB = new Map((e.boxes || []).map(b => [b.id, b]));
    Object.keys(e).forEach(k => delete e[k]); Object.assign(e, se);
    if (se.boxes) e.boxes = se.boxes.map(sb => { const b = oldB.get(sb.id) || {}; Object.keys(b).forEach(k => delete b[k]); Object.assign(b, sb); return b; });
    return e;
  });
}
function _nrHistApply(step, dir) {
  Object.keys(step.secs).forEach(k => {
    const sec = SECTIONS[k]; if (!sec) return;
    _nrReplaceEpics(sec, JSON.parse(step.secs[k][dir]));
    _nrHistBase[k] = step.secs[k][dir];
    saveNotesMeta(sec);                                   // raw: a restore is not a new step
  });
  if (step.hz) {
    const list = JSON.parse(step.hz[dir]);
    _nrGlobalHorizons.length = 0; list.forEach(h => _nrGlobalHorizons.push(h));
    _nrHzBase = step.hz[dir];
    saveRoadmapHorizons();
  }
  _nrClearEdits();
  renderNotesRoadmap();
  if (!_nrIsAllMode() && typeof renderNotesBoxes === 'function') { renderNotesBoxes(); if (typeof renderNotesOutline === 'function') renderNotesOutline(); }   // lanes / order / schedules shown in the notes view follow
  _nrHistButtons();
}
function nrUndo() {
  if (_nrHistAt <= 0) { showToast('Nothing to undo on the roadmap'); return; }
  if (_nrReadOnly()) return;
  _nrHistAt--; _nrHistApply(_nrHist[_nrHistAt], 'before'); showToast('↶ Roadmap change undone');
}
function nrRedo() {
  if (_nrHistAt >= _nrHist.length) { showToast('Nothing to redo on the roadmap'); return; }
  if (_nrReadOnly()) return;
  _nrHistApply(_nrHist[_nrHistAt], 'after'); _nrHistAt++; showToast('↷ Roadmap change redone');
}
function _nrHistButtons() {}   // keyboard only - nothing in the band to refresh (kept as the one hook a later surface could use)
// ── The notes view's return-refresh (notes-refresh.js) asks the roadmap two things ───────────────
// Is a roadmap edit in progress in this tab? Then a reload now would drop it (typing wins).
function nrHasUnsavedEdit() {
  return !!(_nrEdit || _nrEditHzId || _nrEditHzSubId || _nrEditLaneId || _nrEditLaneSubId || _nrEditEpicId
    || window._nrDrag || _nrLaneDrag || _nrHzDrag || _nrColDrag || _nrDeleteBusy || _nrHistStep || _nrPromptCancel);
}
// A section's meta was just reloaded from the store (another tab / an agent changed it). Its undo steps
// hold snapshots of the OLD data - a Ctrl+Z would write that back - so they go; the baseline is taken
// again by the repaint, and the Roadmap tab's prefs carrier is read again.
function nrOnMetaReloaded(secKey) {
  const keep = [];
  let at = 0;
  _nrHist.forEach((st, i) => { if (st.secs[secKey]) return; keep.push(st); if (i < _nrHistAt) at++; });
  _nrHist = keep; _nrHistAt = at;
  delete _nrHistBase[secKey];
  _nrAllPrefsCache = null;
  renderNotesRoadmap();
}
// Is the roadmap the thing on screen? Then Ctrl+Z is its undo - the TABLE undo (ui.js) must not run.
function _nrRoadmapOnScreen() {
  if (typeof document === 'undefined' || !document.getElementById) return false;
  const h = document.getElementById('notesRoadmap');
  return !!(h && h.style.display !== 'none' && h.getClientRects().length && h.querySelector('.tl-timeline'));   // getClientRects, not offsetParent: offsetParent is null for a FIXED element, i.e. the fullscreen band (J, 2026-10-05)
}
document.addEventListener('keydown', e => {
  if (!(e.ctrlKey || e.metaKey) || window.__excalidrawModalOpen) return;
  const k = (e.key || '').toLowerCase();
  if (k !== 'z' && k !== 'y') return;
  if (!_nrRoadmapOnScreen()) return;
  const t = e.target;
  if (t && (t.isContentEditable || t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT')) { e.stopPropagation(); return; }   // typing: ONLY the field's own undo - no preventDefault (native undo runs), and the table undo in ui.js (bubble) never sees it (J, 2026-10-05)
  e.preventDefault(); e.stopPropagation();                // capture phase: ui.js's table undo (bubble) never sees it
  if (k === 'y' || e.shiftKey) nrRedo(); else nrUndo();
}, true);

// Fullscreen (Rishabh 2026-10-04: "option for fullscreen of roadmap, button for that"): the roadmap
// band takes the whole window (a fixed overlay over the page, like a notes box's ⛶), the page behind
// stops scrolling, Esc or the button again leaves. Pure view state - nothing is saved, so a read-only
// viewer has it too. The class sits on the HOST element, which a re-render keeps (only its innerHTML is
// rewritten), so a drop inside fullscreen does not drop out of it.
function nrRoadmapFullscreen() { const h = document.getElementById('notesRoadmap'); return !!(h && h.classList.contains('nr-fs')); }
function nrToggleRoadmapFullscreen() {
  const host = document.getElementById('notesRoadmap');
  if (!host) return;
  const on = !host.classList.contains('nr-fs');
  host.classList.toggle('nr-fs', on);
  document.body.classList.toggle('tt-roadmap-fs', on);
  renderNotesRoadmap();            // the button's state + the compact scroll cap (_nrFitScroll) follow the class
}
function nrExitRoadmapFullscreen() {
  if (!nrRoadmapFullscreen()) return false;
  nrToggleRoadmapFullscreen();
  return true;
}
// Esc leaves fullscreen - unless the whiteboard modal (which owns Esc) is open, or an inline editor
// is typing (its own Esc handling closes it; a card editor stops Escape from bubbling here anyway).
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape' || window.__excalidrawModalOpen) return;
  const t = e.target;
  if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
  if (nrExitRoadmapFullscreen()) e.stopPropagation();
});

// Vertical "↕ Fit" for the section Roadmap tab (All mode). Chapter tabs get this from the
// notes toolbar (setNotesFit -> epic.fit); the Roadmap tab is chapter-less, so its Fit
// state lives on the All-mode pref carrier - in All mode _nrPrefEpic() IS _nrAllPrefs(),
// and _nrSavePrefs() persists it per-section in localStorage (same as the tab's other
// prefs). Fit ON = board stays full height and the PAGE scrolls (all lanes visible);
// OFF = a compact box that scrolls internally. The render (.tl-scroll gets .nr-fit /
// .nr-compact from epic.fit) and the freeze/scroll logic are already DOM-class-driven,
// so this just flips the flag + re-renders. Chapter mode keeps setNotesFit unchanged.
function nrToggleRoadmapFit() {
  const epic = _nrPrefEpic();
  if (!epic) return;
  epic.fit = !epic.fit;
  _nrSavePrefs();
  renderNotesRoadmap();
}

;
// ==== FILE: js/roadmap/lanes.js ====
// ── notes-roadmap / lanes ───────────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: lane CRUD, Initiative (notes-epic) + Area (section) add/rename/delete from the board, lane drag-reorder, and the prompt modal.
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

// ── Lane CRUD ────────────────────────────────────────────────────────────────
// Every write handler below asks the ONE predicate before it mutates. Hiding the control is
// presentation; this is the rule. These are bare globals on inline onclick=, so a stale DOM
// node left by a previous document can still reach them - and a read-only /save is SWALLOWED
// with { ok: true } (cloud-store/fetch-shim.js), so an unguarded handler paints a change,
// toasts success, and persists nothing. Silent refusal, because the control is not offered:
// arriving here at all means something went around the UI.
function nrAddLane() {
  const sec = SECTIONS[activeSection];
  const epic = _nrEpic();
  if (!epic) return;
  if (_nrReadOnly(epic)) return;
  const lanes = _nrEnsureLanes(epic);
  const id = 'l_' + Math.random().toString(36).slice(2, 7);
  lanes.push({ id, name: 'New ' + NR_ROW_WORD.toLowerCase(), sub: '' });   // the pack's word: "New topic" in a personal doc, "New chapter" in a book
  _nrClearEdits();
  _nrEditLaneId = id;      // drop straight into naming it inline
  _nrSaveMeta(sec);
  renderNotesRoadmap();
}
function nrEditLane(laneId) { if (_nrReadOnly()) return; _nrClearEdits(); _nrEditLaneId = laneId; renderNotesRoadmap(); }
function nrCommitLane(laneId, val) {
  _nrEditLaneId = null;
  const epic = _nrEpic();
  if (_nrReadOnly(epic)) { renderNotesRoadmap(); return; }   // a stale input (or a lock that landed mid-edit) only closes
  const lane = epic && _nrLanes(epic).find(l => l.id === laneId);
  const t = (val || '').trim();
  if (lane && t && t !== lane.name) { lane.name = t; _nrSaveMeta(SECTIONS[activeSection]); showToast('✓ ' + LBL('chapter') + ' renamed'); }
  renderNotesRoadmap();
}
// Reorder the initiative rows (moves within the full lane list, so a hidden lane
// in between is stepped over on screen but order stays consistent).
function nrMoveLane(laneId, delta) {
  const sec = SECTIONS[activeSection];
  const epic = _nrEpic();
  if (!epic) return;
  if (_nrReadOnly(epic)) return;
  const lanes = _nrEnsureLanes(epic);
  const i = lanes.findIndex(l => l.id === laneId);
  const j = i + delta;
  if (i < 0 || j < 0 || j >= lanes.length) return;
  const [m] = lanes.splice(i, 1);
  lanes.splice(j, 0, m);
  _nrSaveMeta(sec);
  renderNotesRoadmap();
}
function nrLaneDragStart(e, laneId) {
  _nrLaneDrag = laneId;
  try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', laneId); } catch (_) {}
  e.stopPropagation();
}
function nrLaneDragEnd() {
  _nrLaneDrag = null;
  const host = document.getElementById('notesRoadmap');
  if (host) host.querySelectorAll('.tl-lane-head.nr-lane-drop').forEach(el => el.classList.remove('nr-lane-drop'));
}
function nrLaneDragOver(e) {
  if (!_nrLaneDrag) return;                     // only react to a row drag, not a card drag
  e.preventDefault(); e.stopPropagation();
  try { e.dataTransfer.dropEffect = 'move'; } catch (_) {}
  e.currentTarget.classList.add('nr-lane-drop');
}
function nrLaneDragLeave(e) { e.currentTarget.classList.remove('nr-lane-drop'); }
function nrLaneDrop(e, targetLaneId) {
  if (!_nrLaneDrag) return;
  e.preventDefault(); e.stopPropagation();
  e.currentTarget.classList.remove('nr-lane-drop');
  const dragged = _nrLaneDrag;
  _nrLaneDrag = null;
  if (dragged === targetLaneId) return;
  const sec = SECTIONS[activeSection];
  const epic = _nrEpic();
  if (!epic) return;
  if (_nrReadOnly(epic)) return;
  const lanes = _nrEnsureLanes(epic);
  const from = lanes.findIndex(l => l.id === dragged);
  const to = lanes.findIndex(l => l.id === targetLaneId);
  if (from < 0 || to < 0) return;
  const [m] = lanes.splice(from, 1);
  lanes.splice(to, 0, m);                       // forward → after target, backward → before (like box reorder)
  _nrSaveMeta(sec);
  renderNotesRoadmap();
  showToast('✓ Reordered');
}
function nrEditLaneSub(laneId) { if (_nrReadOnly()) return; _nrClearEdits(); _nrEditLaneSubId = laneId; renderNotesRoadmap(); }
function nrCommitLaneSub(laneId, val) {
  _nrEditLaneSubId = null;
  const epic = _nrEpic();
  if (_nrReadOnly(epic)) { renderNotesRoadmap(); return; }
  const lane = epic && _nrLanes(epic).find(l => l.id === laneId);
  if (lane) { const t = (val || '').trim(); if (t) lane.sub = t; else delete lane.sub; _nrSaveMeta(SECTIONS[activeSection]); }
  renderNotesRoadmap();
}

// ── Add / rename Initiative (notes-epic) + Area (section) from the aggregated board ──

// Professional replacement for the native prompt(): a styled modal (reuses the timeline's
// .tl-modal look) that resolves to the entered text, or null if cancelled (Cancel / Esc /
// overlay click). Used to name a new Subject / Chapter from the roadmap "+".
function _nrPromptModal(opts) {
  opts = opts || {};
  return new Promise(resolve => {
    if (_nrPromptCancel) _nrPromptCancel();          // a prior modal is still open -> cancel it (resolves null, unbinds its listener) before opening this one
    const overlay = document.createElement('div');
    overlay.id = 'nrPromptModal';
    overlay.className = 'tl-modal-overlay';
    overlay.innerHTML =
      `<div class="tl-modal" role="dialog" aria-modal="true">
         <div class="tl-modal-head">${esc(opts.title || 'Name')}</div>
         <label class="tl-field">${esc(opts.label || '')}
           <input class="nr-prompt-input" type="text" spellcheck="true" placeholder="${esc(opts.placeholder || '')}" value="${esc(opts.value || '')}" />
         </label>
         <div class="tl-modal-actions">
           <button class="btn-small nr-prompt-cancel" type="button">Cancel</button>
           <button class="btn-small cm-ok nr-prompt-ok" type="button">${esc(opts.okLabel || 'Create')}</button>
         </div>
       </div>`;
    document.body.appendChild(overlay);
    const inp = overlay.querySelector('.nr-prompt-input');
    let done = false;
    const close = val => {
      if (done) return;                          // resolve exactly once
      done = true;
      if (_nrPromptCancel === cancel) _nrPromptCancel = null;
      document.removeEventListener('keydown', onKey, true);
      overlay.remove();
      resolve(val);
    };
    const cancel = () => close(null);
    _nrPromptCancel = cancel;                     // let a re-entry / another modal tear this one down cleanly
    const onKey = e => {
      // Stop Enter/Esc from reaching the board (e.g. the Escape handler that clears a multi-select) -
      // dismissing this naming dialog must not touch the board, just like the native prompt() didn't.
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); close(inp.value); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); cancel(); }
    };
    overlay.querySelector('.nr-prompt-ok').onclick = () => close(inp.value);
    overlay.querySelector('.nr-prompt-cancel').onclick = cancel;
    overlay.addEventListener('mousedown', e => { if (e.target === overlay) cancel(); });
    document.addEventListener('keydown', onKey, true);
    setTimeout(() => { inp.focus(); inp.select(); }, 0);
  });
}

// The "+" for a new Chapter: name it in the professional modal, then create it.
async function nrPromptAddInitiative(secKey) {
  if (!SECTIONS[secKey]) return;
  // Refuse BEFORE the modal opens. The dialog's OK button is not the place to enforce this:
  // a cancel-only dialog is a broken dialog, not a guard.
  if (_nrReadOnly()) return;
  if (_nrSectionIsReadShare(secKey)) return;     // All mode has no active chapter - so also ask THIS row's section
  const name = await _nrPromptModal({
    title: 'New ' + LBL('chapter'),                 // a REAL chapter / notes topic (a tab), not a roadmap row - Rishabh 2026-10-05
    label: 'Name this ' + LBL('chapter').toLowerCase(),
    placeholder: LBL('chapter') + ' name',
    okLabel: 'Create',
  });
  if (name === null) return;                      // cancelled
  await nrAddInitiative(secKey, name);
}

// A new Initiative is a real notes-epic with one empty box, added to the chosen Area
// (subject) - shown as a fresh row in the aggregated board (its empty box lands in
// Later). Named from the modal when the user adds one; auto-named + dropped into inline
// rename when seeded internally (e.g. by nrAddArea). Stays in the roadmap.
async function nrAddInitiative(secKey, wantName) {
  const sec = SECTIONS[secKey];
  if (!sec || typeof notesPrefix !== 'function' || !notesPrefix(sec)) { showToast('⚠ Cannot add here'); return; }
  if (_nrReadOnly()) return;                     // the real writer - guarded itself, not only via its two callers
  if (_nrSectionIsReadShare(secKey)) return;     // ...and never into a read share (All mode shows one beside the viewer's own sections)
  sec.notesEpics = sec.notesEpics || [];
  const existing = new Set(sec.notesEpics.map(n => n.name));
  const named = (wantName || '').trim();           // a name from the modal, or '' to auto-name + inline-rename
  const base = named || ('New ' + LBL('chapter').toLowerCase());
  let name = base, n = 1;
  while (existing.has(name)) { n++; name = base + ' ' + n; }
  const id = String(Date.now()) + '_' + Math.random().toString(36).slice(2, 6);
  const boxId = 'box_' + Math.random().toString(36).slice(2, 7);
  sec.notesEpics.push({ id, name, layout: 'stack', boxes: [{ id: boxId, createdAt: _nrTodayIso() }] });
  await _nrSaveMeta(sec);
  await saveNotesContent(sec, id, boxId, '');   // empty file for the first box
  _nrClearEdits();
  if (!named) _nrEditEpicId = id;                // auto-named -> inline rename; modal-named -> keep the name
  if (secKey === activeSection) renderSubtabs();   // the new chapter is a TAB too - the strip must show it at once (Rishabh 2026-10-05: added via the roadmap, no tab)
  renderNotesRoadmap();
  showToast('✓ ' + LBL('chapter') + ' added');
}
// The chapter cell of the aggregated board renames THAT chapter - so it is that chapter's own
// lock that decides (a read share sits beside the viewer's own rows; the active chapter says nothing).
function _nrEpicById(epicId) {
  for (const k of Object.keys(SECTIONS)) {
    const ep = (SECTIONS[k].notesEpics || []).find(n => n.id === epicId);
    if (ep) return ep;
  }
  return null;
}
function nrEditEpicName(epicId) { if (_nrReadOnly(_nrEpicById(epicId))) return; _nrClearEdits(); _nrEditEpicId = epicId; renderNotesRoadmap(); }
function nrCommitEpicName(epicId, val) {
  _nrEditEpicId = null;
  if (_nrReadOnly(_nrEpicById(epicId))) { renderNotesRoadmap(); return; }
  const t = (val || '').trim();
  for (const k of Object.keys(SECTIONS)) {
    const sec = SECTIONS[k];
    const ep = (sec.notesEpics || []).find(n => n.id === epicId);
    if (ep) {
      if (t && t !== ep.name) {
        // A-3 root fix (Rishabh 2026-08-15): block a DUPLICATE chapter name within the same subject -
        // the same guard renameNotesEpic already enforces, so two chapters can never share a name (which
        // rendered as two visually-identical share/table rows). Deterministic exact match, no fuzzy.
        if ((sec.notesEpics || []).some(n => n.id !== epicId && n.name === t)) showToast('⚠ "' + t + '" already exists');
        else { ep.name = t; _nrSaveMeta(sec); showToast('✓ Renamed'); }
      }
      break;
    }
  }
  renderNotesRoadmap();
}
// A new Area = a new top-level tab. Created INLINE (mirrors addSection's core) so the
// user stays in the roadmap - no navigation. Makes a unique key + CSV file, writes a
// header-only CSV (rolling back the in-memory tab if that write fails), refreshes the
// tab bar, then seeds a starter Initiative so the Area shows as a row + opens to rename.
async function nrAddArea() {
  // Same rule as nrPromptAddInitiative, and this is the path that held a deploy: a read-only
  // viewer reached Create, /save answered { ok: true, readOnly: true }, so `ok` was TRUE, the
  // rollback below never ran, a new subject TAB was painted, and a success toast fired for a
  // write that never happened.
  if (_nrReadOnly()) return;
  const input = await _nrPromptModal({
    title: 'New ' + LBL('subject'),
    label: 'Name this ' + LBL('subject'),
    placeholder: LBL('subject') + ' name',
    okLabel: 'Create',
  });
  if (input === null) return;                     // cancelled
  const title = (input || '').trim() || ('New ' + LBL('subject'));
  const base = title.toLowerCase().replace(/[^a-z0-9]+/g, '') || 'tab';
  let key = base, n = 1;
  while (SECTIONS[key]) { n++; key = base + n; }
  const safeName = (title.replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_+|_+$/g, '')) || 'Tab';
  const files = new Set(Object.keys(SECTIONS).map(k => SECTIONS[k].file).filter(Boolean));
  let prefix = Object.keys(SECTIONS).length + 1, file = prefix + '__' + safeName + '.csv';
  while (files.has(file)) { prefix++; file = prefix + '__' + safeName + '.csv'; }
  const cols = (typeof NEW_TAB_COLS !== 'undefined') ? NEW_TAB_COLS.slice() : [];
  SECTIONS[key] = { title, file, columns: [], rows: [], defaultCols: cols };
  const header = (typeof csvQuote === 'function' ? cols.map(csvQuote) : cols).join(',') + '\n';
  let ok = false;
  try { const res = await fetch('/save', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ filename: file, csv: header }) }); ok = !!(res && res.ok); } catch (_) {}
  if (!ok) { delete SECTIONS[key]; showToast('⚠ Server not running - ' + LBL('subject') + ' not created'); return; }
  if (typeof saveSectionsConfig === 'function') saveSectionsConfig();
  if (typeof renderTabs === 'function') renderTabs();          // show the new tab, no navigation
  await nrAddInitiative(key);                                  // seed an Initiative so the Area shows + inline-rename
}
// Affordance rows appended in the aggregated (group-by-Area / nested) board.
function _nrAddInitiativeRowHtml(secKey, cols) {
  if (_nrReadOnly()) return '';                  // never offer an affordance the viewer may not use
  if (_nrSectionIsReadShare(secKey)) return '';  // ...including this row's own section being a read share
  return `<div class="tl-lane-row nr-grp-cont nr-add-row">`
    + `<div class="nr-subj-col" style="width:${cols.subjW}px"></div>`
    + `<div class="tl-lane-head" style="width:${cols.chapW}px"><button class="nr-add-lane nr-add-init" onclick="nrPromptAddInitiative('${esc(secKey)}')" title="Add a new ${LBL('chapter').toLowerCase()} to this ${LBL('subject').toLowerCase()}">+</button></div>`
    + `<div class="tl-track"></div></div>`;
}
function _nrAddAreaRowHtml(cols) {
  if (_nrReadOnly()) return '';
  return `<div class="tl-lane-row nr-add-row nr-add-area-row">`
    + `<div class="tl-lane-head" style="width:${cols.subjW + cols.chapW}px"><button class="nr-add-lane" onclick="nrAddArea()" title="Add a new ${LBL('subject').toLowerCase()} (tab)">+</button></div>`
    + `<div class="tl-track"></div></div>`;
}
async function nrDeleteLane(laneId) {
  const sec = SECTIONS[activeSection];
  const epic = _nrEpic();
  if (!epic) return;
  if (_nrReadOnly(epic)) return;                 // refuse BEFORE the confirm dialog
  const lanes = _nrEnsureLanes(epic);
  if (lanes.length <= 1) { showToast('⚠ Keep at least one ' + NR_ROW_WORD.toLowerCase()); return; }
  const lane = lanes.find(l => l.id === laneId);
  if (!lane) return;
  const fallback = lanes.find(l => l.id !== laneId);
  const moving = (epic.boxes || []).filter(b => _nrBoxLane(b, lanes) === laneId);
  if (!(await showConfirmModal({ title: 'Delete this ' + NR_ROW_WORD.toLowerCase() + '?', message: `"${_nrLaneDisplayName(lane, epic)}" and its ${moving.length} card${moving.length === 1 ? '' : 's'} will move to "${_nrLaneDisplayName(fallback, epic)}".`, okLabel: 'Delete', danger: true }))) return;
  moving.forEach(b => { b.roadmapLane = fallback.id; });          // reassign before removing the row
  epic.roadmapLanes = lanes.filter(l => l.id !== laneId);
  _nrSaveMeta(sec);
  renderNotesRoadmap();
  showToast('✓ ' + NR_ROW_WORD + ' removed');
}

;
// ==== FILE: js/roadmap/columns.js ====
// ── notes-roadmap / columns ─────────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: timeframe (horizon) column CRUD, width-resize, reflow (date-shift on structural change), column drag-reorder, inline-input wiring.
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

// ── Timeframe (horizon) columns — Horizons grain only ────────────────────────
// A new timeframe drops in just before the open-ended "Later" tail and starts
// UNALLOCATED: no date window yet, so it takes up no time and shifts nobody. The
// user drags it to the position they want, then drops a card into it to schedule
// it (nrGridDrop activates it, giving it NR_NEW_SPAN days at its position).
function nrAddHorizon() {
  const epic = _nrPrefEpic();
  if (!epic || _nrGrainOf(epic) !== 'horizons') return;
  // The same predicate render.js uses to hide this button, so the control and the rule can
  // never disagree. _nrSaveHorizons() below writes the section.
  if (_nrReadOnly()) return;
  const hs = _nrEnsureHorizons();
  const id = 'h_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 5);
  const li = hs.findIndex(h => h.kind === 'later');
  hs.splice(li < 0 ? hs.length : li, 0, { id, label: 'New', sub: '', kind: 'future', w: 1, unallocated: true });
  _nrClearEdits();
  _nrEditHzId = id;        // drop straight into naming it inline
  _nrSaveHorizons();
  renderNotesRoadmap();
}
// Every timeframe-column writer below saves roadmap_horizons.json (and a reorder re-dates cards),
// so each asks the same predicate nrAddHorizon / nrFitColumns already ask, at its own entry.
// The Parallel columns' own writers (state.js): every grain, saved with the chapter meta (or the
// Roadmap tab's browser prefs). The inline inputs are the timeframe ones (same ids), routed by the 'p:' hid.
function _nrSaveParallel() { _nrSavePrefs(); }
function nrAddParallel() {
  const epic = _nrPrefEpic();
  if (!epic || _nrReadOnly() || _nrIsAllMode()) return;   // a chapter owns its columns; the Roadmap tab derives (state.js)
  const list = epic.roadmapParallel = _nrParallelRead(epic).slice();
  let n = 1; while (list.some(p => p.id === 'p' + n)) n++;   // the lowest FREE positional id - unique after a middle remove, and a removed id comes back (J, 2026-10-05: length + 1 duplicated p2 after removing p1)
  const id = 'p' + n;
  list.push({ id, label: 'Parallel', sub: '' });
  _nrClearEdits();
  _nrEditHzId = 'p:' + id;        // name it inline at once
  _nrSaveParallel();
  renderNotesRoadmap();
}
async function nrDeleteParallel(hid) {
  const epic = _nrPrefEpic();
  if (!epic || _nrReadOnly()) return;
  const p = _nrParallelOf(epic, hid);
  if (!p || _nrIsAllMode()) return;
  if (!(await showConfirmModal({ title: 'Remove this column?', message: `Cards in "${p.label}" go back to their dates (or Later).`, okLabel: 'Remove', danger: true }))) return;
  _nrUnpinParallel(epic, p.id);                           // the promise above: no card keeps a pin to a column that is gone
  epic.roadmapParallel = _nrParallelRead(epic).filter(x => x !== p);
  if (!epic.roadmapParallel.length) delete epic.roadmapParallel;
  _nrClearEdits();
  _nrSaveParallel();
  renderNotesRoadmap();
  showToast('✓ Column removed');
}
function nrEditHorizon(hid) { if (_nrReadOnly()) return; _nrClearEdits(); _nrEditHzId = hid; renderNotesRoadmap(); }
function nrCommitHorizon(hid, val) {
  _nrEditHzId = null;
  if (_nrReadOnly()) { renderNotesRoadmap(); return; }
  const t = (val || '').trim();
  const p = _nrIsParallelHid(hid) ? _nrParallelOf(_nrPrefEpic(), hid) : null;
  if (p) { if (t && t !== p.label && !_nrIsAllMode()) { p.label = t; _nrSaveParallel(); showToast('✓ Column renamed'); } renderNotesRoadmap(); return; }
  const h = _nrEnsureHorizons().find(x => x.id === hid);
  if (h && t && t !== h.label) { h.label = t; _nrSaveHorizons(); showToast('✓ Timeframe renamed'); }
  renderNotesRoadmap();
}
function nrEditHorizonSub(hid) { if (_nrReadOnly()) return; _nrClearEdits(); _nrEditHzSubId = hid; renderNotesRoadmap(); }
function nrCommitHorizonSub(hid, val) {
  _nrEditHzSubId = null;
  if (_nrReadOnly()) { renderNotesRoadmap(); return; }
  const p = _nrIsParallelHid(hid) ? _nrParallelOf(_nrPrefEpic(), hid) : null;
  if (p) { if (!_nrIsAllMode()) { p.sub = (val || '').trim(); _nrSaveParallel(); } renderNotesRoadmap(); return; }
  const h = _nrEnsureHorizons().find(x => x.id === hid);
  if (h) { h.sub = (val || '').trim(); _nrSaveHorizons(); }
  renderNotesRoadmap();
}
async function nrDeleteHorizon(hid) {
  if (_nrReadOnly()) return;                     // refuse BEFORE the confirm dialog
  const hs = _nrEnsureHorizons();
  const idx = hs.findIndex(h => h.id === hid);
  if (idx < 0) return;
  const h = hs[idx];
  if (h.kind !== 'future') { showToast("⚠ Done / Now / Later can't be removed"); return; }
  if (!(await showConfirmModal({ title: 'Remove timeframe?', message: `Any cards in the "${h.label}" timeframe fall into the next one.`, okLabel: 'Remove', danger: true }))) return;
  hs.splice(idx, 1);
  _nrClearEdits();
  _nrSaveHorizons();
  renderNotesRoadmap();
  showToast('✓ Timeframe removed');
}
// Drag a column's right edge to resize it; the column and its neighbour trade width so the
// board never overflows or leaves gaps. Works in EVERY grain (Rishabh 2026-10-04): the Custom
// grain writes the shared column list (h.w, roadmap_horizons.json), a calendar grain writes the
// chapter's per-grain slot weights (epic.roadmapColW - _nrColWSet, saved with the view prefs).
function _nrColWWrite(epic, grain, b, w) {
  if (b.parallel) { if (_nrIsAllMode()) return; const p = _nrParallelOf(epic, b.hid); if (p) p.w = w; return; }   // the tab does not own the column
  if (grain === 'horizons') { const h = _nrEnsureHorizons().find(x => x.id === b.hid); if (h) h.w = w; }
  else _nrColWSet(epic, grain, parseInt(String(b.hid).split(':')[1], 10), w);
}
function nrColResizeStart(e, hid) {
  e.preventDefault(); e.stopPropagation();
  if (_nrReadOnly()) return;                     // the release saves every width
  const epic = _nrPrefEpic();
  if (!epic) return;
  const bk = _nrBuckets(epic);
  const idx = bk.findIndex(b => b.hid === hid);
  if (idx < 0) return;
  // Trade width with the next EXPANDED column (skip collapsed thin/fixed ones between);
  // if this is the LAST expanded column, fall back to the PREVIOUS expanded one so it is
  // still resizable (dragging its right edge grows it, shrinking that neighbour).
  let tIdx = idx + 1;
  while (tIdx < bk.length && bk[tIdx].collapsed) tIdx++;
  if (tIdx >= bk.length) {
    tIdx = idx - 1;
    while (tIdx >= 0 && bk[tIdx].collapsed) tIdx--;
    if (tIdx < 0) return;   // the only expanded column - nothing to trade with
  }
  const h = bk[idx], next = bk[tIdx];
  const headEl = e.target.closest('.tl-zhead');
  const wpx = headEl ? headEl.offsetWidth : 120;
  const startW = Math.max(TL_COL_MIN_W, h.w > 0 ? h.w : 1);
  _nrColDrag = {
    hid, nextHid: next.hid, grain: _nrGrainOf(epic), parallel: !!(h.parallel || next.parallel), startX: e.clientX, startW,
    startNextW: Math.max(TL_COL_MIN_W, next.w > 0 ? next.w : 1),
    pxPerWeight: Math.max(1, wpx / startW),
  };
  _nrClearEdits();
  document.body.classList.add('tl-colresizing');
  document.addEventListener('mousemove', _nrColResizeMove);
  document.addEventListener('mouseup', _nrColResizeEnd);
  renderNotesRoadmap();
}
function _nrColResizeMove(e) {
  if (!_nrColDrag) return;
  const epic = _nrPrefEpic();
  if (!epic) return;
  const bk = _nrBuckets(epic);
  const h = bk.find(x => x.hid === _nrColDrag.hid);
  const next = bk.find(x => x.hid === _nrColDrag.nextHid);
  if (!h || !next) return;
  const sum = _nrColDrag.startW + _nrColDrag.startNextW;
  const dW = (e.clientX - _nrColDrag.startX) / _nrColDrag.pxPerWeight;
  const nw = Math.max(TL_COL_MIN_W, Math.min(sum - TL_COL_MIN_W, _nrColDrag.startW + dW));
  const nn = sum - nw;
  if (h.w !== nw || next.w !== nn) { _nrColWWrite(epic, _nrColDrag.grain, h, nw); _nrColWWrite(epic, _nrColDrag.grain, next, nn); renderNotesRoadmap(); }
}
function _nrColResizeEnd() {
  document.removeEventListener('mousemove', _nrColResizeMove);
  document.removeEventListener('mouseup', _nrColResizeEnd);
  document.body.classList.remove('tl-colresizing');
  const was = _nrColDrag;
  _nrColDrag = null;
  if (!was) return;
  if (was.grain === 'horizons') _nrSaveHorizons();
  if (was.grain !== 'horizons' || was.parallel) _nrSavePrefs();   // a Parallel column's width lives on the pref carrier in every grain
  renderNotesRoadmap();
}
// "Fit": every column back to equal width - in the current grain.
function nrFitColumns() {
  const epic = _nrPrefEpic();
  if (!epic) return;
  if (_nrReadOnly()) return;                     // rewrites every column width - see nrAddHorizon
  const grain = _nrGrainOf(epic);
  let changed = false;
  if (grain === 'horizons') { _nrEnsureHorizons().forEach(h => { if (h.w !== 1) { h.w = 1; changed = true; } }); }
  else changed = _nrColWReset(epic, grain);
  let parChanged = false;
  _nrParallelRead(epic).forEach(p => { if (p.w !== undefined && p.w !== 1) { delete p.w; parChanged = true; } });
  if (!changed && !parChanged) { showToast('Timeframes already fit evenly'); return; }
  _nrClearEdits();
  if (grain === 'horizons' && changed) _nrSaveHorizons();
  if (grain !== 'horizons' || parChanged) _nrSavePrefs();
  renderNotesRoadmap();
  showToast('✓ Timeframes reset to equal width');
}

// A structural change to the timeframe columns (reorder / activate) shifts the
// sequential date windows, which would otherwise re-bucket cards by date. To keep
// every card visually in the SAME column, snapshot each card's column + window
// start before the change, run mutate(), then shift each card's date (and target)
// by however far its column's start moved. skipEntry (a card being explicitly
// placed by the caller) is left alone; Done / Later cards are date-agnostic and stay.
// The columns are SHARED, so every horizons-grain card across ALL subjects rides this
// axis — snapshot them all. Returns the Set of secKeys whose dates shifted so the
// caller can persist each affected subject.
function _nrReflowHorizons(mutate, skipEntry) {
  const before = _nrHzAxis();
  const snaps = [];
  _nrGatherBoxes('all').forEach(({ secKey, epic, box }) => {
    if (_nrGrainOf(epic) !== 'horizons') return;   // calendar-grain views don't use this axis
    if (_nrReadOnly(epic)) return;             // a read share / locked copy on the board: its dates are not ours to shift (and its save would be refused anyway)
    _nrEntries(box).forEach((entry, eidx) => {
      if (entry === skipEntry || entry.done || !entry.date) return;
      const bk = before[_nrEntryBucket(entry, before)];
      if (entry.horizonId && bk && bk.hid === entry.horizonId) return;   // sticky-pinned → the pin holds the column; its dates must NOT shift (a stale horizonId won't match bk.hid → still date-placed, still shifts)
      if (!bk || !bk.start || bk.hkind === 'later') return;
      snaps.push({ secKey, box, eidx, hid: bk.hid, start0: bk.start });
    });
  });
  mutate();
  const byHid = {};
  _nrHzAxis().forEach(b => { if (b.hid) byHid[b.hid] = b; });
  const DAY = 86400000;
  const touched = new Set();
  snaps.forEach(s => {
    const nb = byHid[s.hid];
    if (!nb || !nb.start) return;
    const delta = Math.round((nb.start - s.start0) / DAY);
    if (!delta) return;
    const entry = _nrEnsureSchedule(s.box)[s.eidx];
    if (!entry) return;
    const d = _tlParse(entry.date);
    if (d) entry.date = _tlIso(_tlAddDays(d, delta));
    const pe = _tlParse(entry.plannedEnd);
    if (pe) entry.plannedEnd = _tlIso(_tlAddDays(pe, delta));
    touched.add(s.secKey);
  });
  return touched;
}

// Reorder a future timeframe column — two affordances (mirroring the lane row): a
// drag grip and left/right nudge arrows. Done / Now stay pinned on the left, Later
// on the right, so a future column only ever lands between them. Cards move WITH
// their column (dates reflow) so nothing jumps except the column that moved.
function nrHzDragStart(e, hid) {
  _nrHzDrag = hid;
  try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', hid); } catch (_) {}
  e.stopPropagation();
}
function nrHzDragEnd() {
  _nrHzDrag = null;
  const host = document.getElementById('notesRoadmap');
  if (host) host.querySelectorAll('.tl-zhead.nr-hz-drop').forEach(el => el.classList.remove('nr-hz-drop'));
}
function nrHzDragOver(e) {
  if (!_nrHzDrag) return;                        // only react to a column-grip drag, not a card
  e.preventDefault(); e.stopPropagation();
  try { e.dataTransfer.dropEffect = 'move'; } catch (_) {}
  e.currentTarget.classList.add('nr-hz-drop');
}
function nrHzDragLeave(e) { e.currentTarget.classList.remove('nr-hz-drop'); }
function nrHzDrop(e, targetHid) {
  if (!_nrHzDrag) return;
  e.preventDefault(); e.stopPropagation();
  e.currentTarget.classList.remove('nr-hz-drop');
  const dragged = _nrHzDrag; _nrHzDrag = null;
  if (_nrReadOnly()) return;
  if (dragged === targetHid) return;
  const hs = _nrEnsureHorizons();
  const from = hs.findIndex(h => h.id === dragged);
  const to = hs.findIndex(h => h.id === targetHid);
  if (from < 0 || to < 0 || hs[from].kind !== 'future' || hs[to].kind !== 'future') return;
  const touched = _nrReflowHorizons(() => { const [m] = hs.splice(from, 1); hs.splice(to, 0, m); });
  _nrClearEdits();
  _nrSaveHorizons();
  touched.forEach(k => _nrSaveMeta(SECTIONS[k]));
  renderNotesRoadmap();
  showToast('✓ Reordered');
}
// Nudge a future column one slot left/right — a keyboard-free fallback for the grip.
function nrMoveHorizon(hid, delta) {
  if (_nrReadOnly()) return;
  const hs = _nrEnsureHorizons();
  const i = hs.findIndex(h => h.id === hid);
  if (i < 0 || hs[i].kind !== 'future') return;
  const j = i + delta;
  if (j < 0 || j >= hs.length || hs[j].kind !== 'future') return;   // stay within the future band
  const touched = _nrReflowHorizons(() => { const [m] = hs.splice(i, 1); hs.splice(j, 0, m); });
  _nrClearEdits();
  _nrSaveHorizons();
  touched.forEach(k => _nrSaveMeta(SECTIONS[k]));
  renderNotesRoadmap();
}

// Focus + commit whichever inline header/lane input is active (label / subtitle
// / lane name / lane subtitle).
function _nrWireInlineInputs() {
  const bind = (elId, isActive, commit, cancel) => {
    if (!isActive()) return;
    const inp = document.getElementById(elId);
    if (!inp) return;
    inp.focus(); if (inp.select) inp.select();
    inp.addEventListener('keydown', e => {
      e.stopPropagation();
      if (e.key === 'Enter') { e.preventDefault(); commit(inp.value); }
      else if (e.key === 'Escape') { e.preventDefault(); cancel(); }
    });
    inp.addEventListener('blur', () => { if (isActive()) commit(inp.value); });
  };
  const hz = _nrEditHzId, hzSub = _nrEditHzSubId, lane = _nrEditLaneId, laneSub = _nrEditLaneSubId, epicE = _nrEditEpicId;
  bind('nrEpicInput', () => _nrEditEpicId === epicE, v => nrCommitEpicName(epicE, v), () => { if (_nrEditEpicId === epicE) { _nrEditEpicId = null; renderNotesRoadmap(); } });
  bind('nrHzInput', () => _nrEditHzId === hz, v => nrCommitHorizon(hz, v), () => { if (_nrEditHzId === hz) { _nrEditHzId = null; renderNotesRoadmap(); } });
  bind('nrHzSubInput', () => _nrEditHzSubId === hzSub, v => nrCommitHorizonSub(hzSub, v), () => { if (_nrEditHzSubId === hzSub) { _nrEditHzSubId = null; renderNotesRoadmap(); } });
  bind('nrLaneInput', () => _nrEditLaneId === lane, v => nrCommitLane(lane, v), () => { if (_nrEditLaneId === lane) { _nrEditLaneId = null; renderNotesRoadmap(); } });
  bind('nrLaneSubInput', () => _nrEditLaneSubId === laneSub, v => nrCommitLaneSub(laneSub, v), () => { if (_nrEditLaneSubId === laneSub) { _nrEditLaneSubId = null; renderNotesRoadmap(); } });
}

;
// ==== FILE: js/roadmap/card-dnd.js ====
// ── notes-roadmap / card-dnd ────────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: card interaction event handlers - click / dblclick / goto and the drag / dragover / drop plumbing on cards and grid cells.
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

function nrCardClick(secKey, epicId, boxId, eidx) {
  if (_nrEdit) return;   // a click while already editing (outside the inputs) is ignored
  if (_nrClickTimer) clearTimeout(_nrClickTimer);
  _nrClickTimer = setTimeout(() => {
    _nrClickTimer = null;
    _nrEdit = { secKey, epicId, boxId, idx: eidx };
    _nrAutoStampActualStartOnOpen(secKey, epicId, boxId, eidx);   // capture "work began" on first open while Active
    renderNotesRoadmap();
  }, 240);
}
function nrCardDblClick(boxId) {
  if (_nrClickTimer) { clearTimeout(_nrClickTimer); _nrClickTimer = null; }
  if (typeof scrollNotesToBox === 'function') scrollNotesToBox(boxId);
}
// Double-click an AGGREGATED card: jump to its box's content. The card can belong to
// another chapter or subject (read from its own secKey/epicId), so switch there first,
// then scroll once the boxes have rendered. Cancels the pending single-click edit.
async function nrCardGoto(secKey, epicId, boxId) {
  if (_nrClickTimer) { clearTimeout(_nrClickTimer); _nrClickTimer = null; }
  const sec = SECTIONS[secKey];
  if (!sec) return;                                    // card's subject no longer exists
  const alreadyThere = secKey === activeSection && sec.activeNotesEpic === epicId;
  if (!alreadyThere) {
    if (secKey !== activeSection) await switchTab(secKey);
    await openNotesEpic(epicId);
    // openNotesEpic sets activeNotesEpic + activeSubtab but does NOT repaint the pill
    // strip, so the sub-tab bar would keep the old highlight (e.g. staying on the
    // "Roadmap" pill after jumping into a chapter). Repaint so the opened chapter's
    // pill becomes active - matching the normal pill-click path (openEpic->renderSubtabs).
    if (typeof renderSubtabs === 'function') renderSubtabs();
  }
  // Let the freshly-rendered boxes lay out before measuring the scroll target.
  requestAnimationFrame(() => scrollNotesToBox(boxId));
}

function nrDragStart(e, boxId, eidx) {
  window._nrDrag = { boxId, eidx };
  try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', boxId); } catch (_) {}
}

// Aggregated (read-only-rows) drag: carries the card's OWN section + epic so the drop
// reschedules + saves into its own Area.
function nrAggDragStart(e, secKey, epicId, boxId, eidx) {
  // Dragging a SELECTED card moves the whole selection; an unselected one moves alone.
  const bulk = _nrSel.size > 0 && _nrSel.has(_nrSelKey(secKey, epicId, boxId, eidx));
  window._nrDrag = { secKey, epicId, boxId, eidx, bulk };
  try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', boxId); } catch (_) {}
  e.stopPropagation();
}
// Drop into an aggregated GRID cell (row, column). Mirrors nrGridDrop for the chapter board: the
// row moves the box in its chapter's box order (one row = one box, model.js), and the column
// reschedules its start date (only when it actually changes). Bulk selections and
// cross-Initiative drops are routed on.
function nrAggGridDrop(e, targetSecKey, targetEpicId, row, bucketIdx) {
  e.preventDefault();
  e.currentTarget.classList.remove('tl-drop'); e.currentTarget.classList.remove('tl-drop-after');
  const zone = _nrDropZone(e, bucketIdx); _nrShowZone(null);
  row = _nrDropRow(e, row);
  const drag = window._nrDrag;
  window._nrDrag = null;
  if (!drag || !drag.secKey) return;                    // only aggregated card drags carry a secKey
  if (_nrCardReadOnly(targetSecKey, targetEpicId) || _nrCardReadOnly(drag.secKey, drag.epicId)) return;   // read-only on either end: nothing moves (the writers below refuse too)
  if (drag.bulk && _nrSel.size) { nrAggBulkMove([..._nrSel].map(_nrParseSelKey), bucketIdx, targetSecKey, targetEpicId); return; }
  if (targetEpicId && targetEpicId !== drag.epicId) { nrAggMoveBox(drag, bucketIdx, targetSecKey, targetEpicId, row); return; }
  // Same Initiative → set the alignment row, and reschedule the timeframe if the column changed.
  const sec = SECTIONS[drag.secKey];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === drag.epicId);
  const box = epic && (epic.boxes || []).find(b => b.id === drag.boxId);
  if (!box) return;
  const buckets = _nrBuckets(_nrPrefEpic());
  const b = buckets[bucketIdx];
  const entry = _nrEnsureSchedule(box)[drag.eidx];
  if (b && entry && _nrEntryBucket(entry, buckets) !== bucketIdx) _nrRescheduleEntry(entry, b, bucketIdx, buckets.length - 1);   // column changed → re-place (sticky horizonId in horizons grain, date in calendar grain)
  _nrDropRows(epic, null, box, drag.eidx, row, zone, buckets);
  _nrSaveMeta(sec);
  renderNotesRoadmap();
  showToast('✓ Aligned');
}
// Drop into another timeframe column in an aggregated view: reschedule the dragged
// card's start date to that column, saved into its OWN Area. The row (its Area /
// Initiative) is unchanged - moving a card across rows is a separate step.
function nrAggDrop(e, bucketIdx, targetSecKey, targetEpicId) {
  e.preventDefault();
  e.currentTarget.classList.remove('tl-drop');
  const drag = window._nrDrag;
  window._nrDrag = null;
  if (!drag || !drag.secKey) return;                    // only aggregated card drags carry a secKey
  if (_nrCardReadOnly(targetSecKey, targetEpicId) || _nrCardReadOnly(drag.secKey, drag.epicId)) return;   // read-only on either end: nothing moves (the writers below refuse too)
  // BULK: dragging a selected card moves the WHOLE selection to the dropped cell.
  if (drag.bulk && _nrSel.size) { nrAggBulkMove([..._nrSel].map(_nrParseSelKey), bucketIdx, targetSecKey, targetEpicId); return; }
  // Dropped on a DIFFERENT Initiative row → physically relocate the box to that
  // Initiative's Area (moving its notes too) and reschedule to the dropped column.
  if (targetEpicId && targetEpicId !== drag.epicId) { nrAggMoveBox(drag, bucketIdx, targetSecKey, targetEpicId); return; }
  // Same row → reschedule the timeframe only (the row / Area is unchanged).
  const sec = SECTIONS[drag.secKey];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === drag.epicId);
  const box = epic && (epic.boxes || []).find(b => b.id === drag.boxId);
  if (!box) return;
  const buckets = _nrBuckets(_nrPrefEpic());                // aggregated views share the active chapter's axis
  const b = buckets[bucketIdx];
  if (!b) return;
  const entry = _nrEnsureSchedule(box)[drag.eidx];
  if (!entry) return;
  if (_nrEntryBucket(entry, buckets) === bucketIdx) return;   // same column → nothing to reschedule
  _nrRescheduleEntry(entry, b, bucketIdx, buckets.length - 1);
  _nrSaveMeta(sec);
  renderNotesRoadmap();
  showToast('✓ Moved to ' + b.label.replace(/[◀▶]/g, '').trim());
}
// Where on a CARD a drag is. Another box's card: the upper / lower half = the row above / below it
// (one row = one box, so nothing goes beside it). A card of the DRAGGED box (several of its cards in one
// cell sit side by side): the left / right quarter = just before / after that card in the cell, else
// nothing (same row). Null when the pointer is not over a card (an empty cell, or the empty part of a
// cell with cards). `col` = the cell's timeframe column.
function _nrDropZone(e, col) {
  const cell = e.currentTarget;
  const card = e.target && e.target.closest ? e.target.closest('.tl-card') : null;
  if (!card || !cell || !cell.contains || !cell.contains(card)) return null;
  const r = card.getBoundingClientRect();
  if (!(r.width > 0) || !Number.isFinite(e.clientX)) return null;
  const x = (e.clientX - r.left) / r.width, y = r.height > 0 ? (e.clientY - r.top) / r.height : 0;
  const boxId = card.getAttribute('data-box-id');
  const drag = window._nrDrag;
  const own = !!(drag && drag.boxId === boxId);
  const kind = own ? (x < 0.25 ? 'left' : x > 0.75 ? 'right' : null) : (y < 0.5 ? 'above' : 'below');
  if (!kind) return null;
  return { kind, boxId, eidx: Number(card.getAttribute('data-eidx')), col, card };
}
// After the column change of a drop: the row (another box's card = above / below it, else the cell's
// row - model.js _nrMoveBoxInRows) or, on a card of the same box, the order of its cards in the cell.
// The notes boxes follow a changed order on screen.
function _nrDropRows(epic, laneId, box, eidx, row, zone, buckets, joining) {
  if (zone && zone.boxId === box.id) { _nrReorderEntry(box, eidx, zone.eidx, zone.kind === 'right'); return; }
  if (_nrMoveBoxInRows(epic, laneId, box, row, zone, buckets, joining)) _nrSyncBoxesDom(epic);
}
// The empty part of a cell that already holds cards = the row BELOW those cards; an empty cell =
// this row (fill a spacer / take that box's row / append).
function _nrDropRow(e, row) {
  const cell = e.currentTarget;
  return (cell && cell.querySelector && cell.querySelector('.tl-card')) ? row + 1 : row;
}
const NR_DZ = ['nr-dz-above', 'nr-dz-below', 'nr-dz-left', 'nr-dz-right'];
let _nrDzCard = null;        // the card currently showing a drop-zone line
function _nrShowZone(zone) {
  if (_nrDzCard && (!zone || _nrDzCard !== zone.card)) { NR_DZ.forEach(c => _nrDzCard.classList.remove(c)); _nrDzCard = null; }
  if (zone) { NR_DZ.forEach(c => zone.card.classList.toggle(c, c === 'nr-dz-' + zone.kind)); _nrDzCard = zone.card; }
}
function nrDragOver(e) {
  if (_nrLaneDrag || _nrHzDrag) return;          // a row or a column is being dragged, not a card
  e.preventDefault();
  try { e.dataTransfer.dropEffect = 'move'; } catch (_) {}
  const zone = _nrDropZone(e);
  e.currentTarget.classList.toggle('tl-drop', !zone);
  e.currentTarget.classList.toggle('tl-drop-after', !zone && !!e.currentTarget.querySelector('.tl-card'));   // the empty part of a cell with cards = the row below them
  _nrShowZone(zone);
}
function nrDragLeave(e) { e.currentTarget.classList.remove('tl-drop'); e.currentTarget.classList.remove('tl-drop-after'); _nrShowZone(null); }

// Drop a card into a grid CELL (row, column). The row moves the box in the chapter's box order (one
// row = one box, model.js); the column reschedules the start date - but ONLY when the column actually
// changes, so a pure vertical move keeps the card's exact date.
function nrGridDrop(e, laneId, row, bucketIdx) {
  e.preventDefault();
  e.currentTarget.classList.remove('tl-drop'); e.currentTarget.classList.remove('tl-drop-after');
  const zone = _nrDropZone(e, bucketIdx); _nrShowZone(null);
  row = _nrDropRow(e, row);
  const drag = window._nrDrag;
  window._nrDrag = null;
  const sec = SECTIONS[activeSection];
  const epic = _nrEpic();
  if (!epic || !drag) return;
  if (_nrReadOnly(epic)) return;                        // read-only chapter: its cells take no drop (see _nrLanesHtml)
  const box = (epic.boxes || []).find(b => b.id === drag.boxId);
  if (!box) return;
  const buckets = _nrBuckets(epic);
  const b = buckets[bucketIdx];
  if (!b) return;
  const sched = _nrEnsureSchedule(box);
  const entry = sched[drag.eidx];
  if (!entry) return;
  // Rows are the box order (model.js row model): the drop puts the box at that row - the boxes on and
  // below move down, the row it left closes, a spacer row is filled. A drop into another lane first
  // takes the box out of its old lane's rows.
  const oldLane = _nrBoxLane(box, _nrLanes(epic));
  if (laneId && laneId !== oldLane) { _nrLeaveRow(epic, oldLane, box, buckets); box.roadmapLane = laneId; }
  // Dropping the first card into an unallocated column SCHEDULES it: give it a
  // window at its current position (keeping every other card in place), then place
  // this card in it. This is how a new timeframe gets its dates (position = time order).
  const hz = b.hid ? (_nrGlobalHorizons || []).find(h => h.id === b.hid) : null;
  if (hz && hz.unallocated) {
    const touched = _nrReflowHorizons(() => { hz.span = NR_NEW_SPAN; delete hz.unallocated; }, entry);
    const nbk = _nrBuckets(epic);
    const nb = nbk.find(x => x.hid === hz.id);
    if (nb) _nrRescheduleEntry(entry, nb, nbk.indexOf(nb), nbk.length - 1);   // pins horizonId = the just-activated column
    else _nrMarkNotDone(entry);
    _nrDropRows(epic, laneId || oldLane, box, drag.eidx, row, zone, nbk, !!(laneId && laneId !== oldLane));
    _nrSaveHorizons();
    touched.add(activeSection);           // the dropped card's own subject also changed
    touched.forEach(k => _nrSaveMeta(SECTIONS[k]));
    renderNotesRoadmap();
    showToast('✓ Timeframe scheduled');
    return;
  }
  const curBucket = _nrEntryBucket(entry, buckets);
  if (curBucket !== bucketIdx) _nrRescheduleEntry(entry, b, bucketIdx, buckets.length - 1);   // column changed → re-place; same column → keep everything (pure align)
  _nrDropRows(epic, laneId || oldLane, box, drag.eidx, row, zone, _nrBuckets(epic), !!(laneId && laneId !== oldLane));
  _nrSaveMeta(sec);
  renderNotesRoadmap();
  showToast(curBucket === bucketIdx ? '✓ Aligned' : '✓ Moved to ' + b.label.replace(/[◀▶]/g, '').trim());
}

;
// ==== FILE: js/roadmap/card-ops.js ====
// ── notes-roadmap / card-ops ────────────────────────────────────────────────────
//
// CLASSIC script - NOT an ES module. Loaded as a plain <script src> from index.html,
// sharing ONE global scope with the other roadmap/*.js modules and timeline.js. Every
// symbol here is a bare top-level global (functions + module state); do NOT wrap in an
// IIFE and do NOT add import/export - inline onclick= handlers and other classic scripts
// resolve these names globally. Shared mutable state + constants live in roadmap/state.js.
//
// Responsibility: card mutation operations - physical box+notes relocation, reschedule, bulk move, add-in-column, soft-delete/undo, strict content I/O.
// Split out of the former monolithic notes-roadmap.js (behavior-preserving). See
// docs/ROADMAP_MODEL.md for the model.

// Strict content READ. The shared loadNotesContent swallows every error into '', which
// would let a transient load-failure wipe the source on a move. This distinguishes:
// 200 -> the text (may be a genuine ''); 404 -> no content doc = empty box ('' after the
// legacy-'main' fallback); 500 / network -> null = FAILED (caller must abort, not wipe).
async function _nrLoadContentStrict(sec, epicId, boxId) {
  const file = (typeof notesContentFilename === 'function') ? notesContentFilename(sec, epicId, boxId) : null;
  if (!file) return null;
  try {
    const res = await fetch('/load?file=' + file);
    if (res.ok) return await res.text();
    if (res.status === 404) {
      if (boxId === 'main' && typeof notesContentFilenameLegacy === 'function') {
        const legacy = notesContentFilenameLegacy(sec, epicId);
        if (legacy) { const r2 = await fetch('/load?file=' + legacy); if (r2.ok) return await r2.text(); }
      }
      return '';                                  // no doc anywhere = genuinely empty box
    }
    return null;                                  // 500 etc = failed read
  } catch (_) { return null; }                    // network error = failed read
}
// Strict content WRITE - returns whether the target write actually succeeded (the shared
// saveNotesContent swallows failures). A move deletes the source only after this confirms.
async function _nrSaveContentStrict(sec, epicId, boxId, content) {
  const file = (typeof notesContentFilename === 'function') ? notesContentFilename(sec, epicId, boxId) : null;
  if (!file) return false;
  try {
    const res = await fetch('/save', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ filename: file, csv: content }) });
    return !!(res && res.ok);
  } catch (_) { return false; }
}

// Safely relocate a box + its notes .md from srcEpic (srcSec) to tgtEpic (tgtSec):
//   1. read the source content STRICT - abort (no change) if the read failed;
//   2. pick a COLLISION-SAFE target id - a fresh 'box_...' id when the target already has
//      this id or it is a legacy 'main' (never overwrite an existing target box's file);
//   3. write to the target and CONFIRM the write before touching the source;
//   4. move the box in meta + adopt the (possibly new) id.
// Returns { srcSec, srcEpicId, oldId } so the caller deletes the source content ONLY
// after the metas are saved, or null on abort. Does NOT save meta or render.
async function _nrPhysicalMoveBox(srcSec, srcEpic, box, tgtSec, tgtEpic) {
  if (_nrReadOnly(srcEpic) || _nrReadOnly(tgtEpic)) return null;   // the real writer refuses itself; null = abort (callers restore the view)
  const oldId = box.id;
  const content = await _nrLoadContentStrict(srcSec, srcEpic.id, oldId);
  if (content === null) { showToast('⚠ Could not read the card - move cancelled (nothing changed)'); return null; }
  const collide = oldId === 'main' || (tgtEpic.boxes || []).some(b => b.id === oldId);
  const newId = collide ? ('box_' + Math.random().toString(36).slice(2, 7)) : oldId;
  const ok = await _nrSaveContentStrict(tgtSec, tgtEpic.id, newId, content);
  if (!ok) { showToast('⚠ Could not save to the target - move cancelled (nothing changed)'); return null; }
  _nrLeaveRow(srcEpic, null, box, _nrBuckets(_nrPrefEpic()));   // its aggregated row closes up behind it
  const idx = (srcEpic.boxes || []).findIndex(b => b.id === oldId);
  if (idx >= 0) srcEpic.boxes.splice(idx, 1);
  _nrMarkBoxDeleted(srcEpic.id, oldId);         // or the source chapter's meta save merges the box straight back (a copy pointing at the .md deleted below)
  delete box.roadmapLane;   // the lane belongs to the old chapter
  box.id = newId;
  tgtEpic.boxes = tgtEpic.boxes || [];
  tgtEpic.boxes.push(box);
  return { srcSec, srcEpicId: srcEpic.id, oldId };
}

// Place one entry into a target bucket (in place). Horizons grain -> STICKY: store the horizon id and
// leave the user's planned-start date untouched, so the card stays put until the user drags it again.
// Calendar grain -> date-based: set the start date (null for the last/backlog slot), drop any stale
// sticky pin. Past/Done column -> the Done flag. Pure mutation. (docs/ROADMAP_MODEL.md)
function _nrRescheduleEntry(entry, b, bucketIdx, lastIdx) {
  if (!entry || !b) return;
  if (b.parallel) { entry.parallelId = b.hid.slice(2); delete entry.horizonId; _nrMarkNotDone(entry); return; }   // pinned to the Parallel column, dates kept
  delete entry.parallelId;                                                                                        // any other column unpins it
  if (b.kind === 'past') { _nrMarkDone(entry); delete entry.horizonId; return; }
  if (_nrIsHorizonBucket(b)) { entry.horizonId = b.hid; _nrMarkNotDone(entry); }               // sticky; date left as-is
  else { entry.date = (bucketIdx === lastIdx) ? null : _tlIso(_tlRepDate(b)); delete entry.horizonId; _nrMarkNotDone(entry); }
}

async function nrAggMoveBox(drag, bucketIdx, targetSecKey, targetEpicId, row) {
  const srcSec = SECTIONS[drag.secKey];
  const srcEpic = srcSec && (srcSec.notesEpics || []).find(n => n.id === drag.epicId);
  const tgtSec = SECTIONS[targetSecKey];
  const tgtEpic = tgtSec && (tgtSec.notesEpics || []).find(n => n.id === targetEpicId);
  if (!srcEpic || !tgtEpic) return;
  if (_nrReadOnly(srcEpic) || _nrReadOnly(tgtEpic)) return;   // a move writes BOTH chapters - either read-only refuses
  const box = (srcEpic.boxes || []).find(b => b.id === drag.boxId);
  if (!box) return;
  const buckets = _nrBuckets(_nrPrefEpic());
  const res = await _nrPhysicalMoveBox(srcSec, srcEpic, box, tgtSec, tgtEpic);
  if (!res) { renderNotesRoadmap(); return; }        // aborted - nothing persisted, restore view
  if (Number.isInteger(row) && row >= 0) _nrMoveBoxInRows(tgtEpic, null, box, row, null, buckets, true);   // at the dropped row of the new chapter (its old chapter's row already closed in _nrPhysicalMoveBox)
  _nrRescheduleEntry(_nrEnsureSchedule(box)[drag.eidx], buckets[bucketIdx], bucketIdx, buckets.length - 1);
  await saveNotesMeta(srcSec);
  if (tgtSec !== srcSec) await saveNotesMeta(tgtSec);
  if (typeof deleteNotesContent === 'function') deleteNotesContent(res.srcSec, res.srcEpicId, res.oldId);   // source removed AFTER metas saved
  _nrEdit = null;
  if (srcSec === SECTIONS[activeSection] || tgtSec === SECTIONS[activeSection]) {
    if (typeof renderNotesBoxes === 'function') await renderNotesBoxes();
    if (typeof renderNotesToolbar === 'function') renderNotesToolbar();
    if (typeof renderNotesOutline === 'function') renderNotesOutline();
  }
  renderNotesRoadmap();
  showToast('✓ Moved to ' + (tgtEpic.name || LBL('chapter')));
}

// Move every selected card to the dropped cell (target Initiative + timeframe). Cards not
// already in the target Initiative are physically relocated (box + notes, once per box,
// via the collision-safe / abort-on-failure _nrPhysicalMoveBox); every selected entry is
// rescheduled to the column. Boxes are tracked by REFERENCE (their id may change on the
// move), each touched Area is saved once, and each source file is deleted only AFTER the
// metas are saved.
async function nrAggBulkMove(cards, bucketIdx, targetSecKey, targetEpicId) {
  const tgtSec = SECTIONS[targetSecKey];
  const tgtEpic = tgtSec && (tgtSec.notesEpics || []).find(n => n.id === targetEpicId);
  if (!tgtEpic) return;
  if (_nrReadOnly(tgtEpic)) return;                           // nothing may land in a read-only chapter
  cards = cards.filter(c => !_nrCardReadOnly(c.secKey, c.epicId));   // and a read-only card never leaves its own
  if (!cards.length) return;
  const buckets = _nrBuckets(_nrPrefEpic());
  const b = buckets[bucketIdx];
  const touched = new Set();
  const boxOf = new Map();     // "epicId|boxId" (original) -> the box object (moved, current id)
  const delSrc = [];           // { srcSec, srcEpicId, oldId } to delete after the metas save
  const n = cards.length;
  for (const c of cards) {
    const srcSec = SECTIONS[c.secKey];
    const srcEpic = srcSec && (srcSec.notesEpics || []).find(x => x.id === c.epicId);
    if (!srcEpic) continue;
    const origKey = c.epicId + '|' + c.boxId;
    let box, homeSec;
    if (c.epicId !== targetEpicId) {
      if (!boxOf.has(origKey)) {
        const b0 = (srcEpic.boxes || []).find(x => x.id === c.boxId);
        if (b0) {
          const res = await _nrPhysicalMoveBox(srcSec, srcEpic, b0, tgtSec, tgtEpic);
          if (res) { boxOf.set(origKey, b0); delSrc.push(res); touched.add(srcSec); touched.add(tgtSec); }
        }
      }
      box = boxOf.get(origKey); homeSec = tgtSec;      // moved box now lives in tgtEpic (same ref, current id)
    } else {
      box = (srcEpic.boxes || []).find(x => x.id === c.boxId); homeSec = srcSec;
    }
    if (box && b) { _nrRescheduleEntry(_nrEnsureSchedule(box)[c.eidx], b, bucketIdx, buckets.length - 1); touched.add(homeSec); }
  }
  for (const s of touched) await saveNotesMeta(s);
  for (const d of delSrc) { if (typeof deleteNotesContent === 'function') deleteNotesContent(d.srcSec, d.srcEpicId, d.oldId); }
  _nrSel.clear(); _nrEdit = null;
  if (touched.has(SECTIONS[activeSection])) {
    if (typeof renderNotesBoxes === 'function') await renderNotesBoxes();
    if (typeof renderNotesToolbar === 'function') renderNotesToolbar();
    if (typeof renderNotesOutline === 'function') renderNotesOutline();
  }
  renderNotesRoadmap();
  showToast('✓ Moved ' + n + ' card' + (n === 1 ? '' : 's') + (b ? ' to ' + b.label.replace(/[◀▶]/g, '').trim() : ''));
}

// Add a new station (box) into a specific Initiative row at a timeframe column, from an
// aggregated view. The box is created in that Initiative's OWN Area (section) and opened
// for editing. Its title (the box's # heading) is set in its own chapter.
async function nrAggAddInCol(secKey, epicId, bucketIdx, row) {
  const sec = SECTIONS[secKey];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === epicId);
  if (!epic) return;
  if (_nrReadOnly(epic)) return;                              // read-only chapter: no station is added
  const buckets = _nrBuckets(_nrPrefEpic());              // aggregated shares the active chapter's axis
  const b = buckets[bucketIdx];
  const boxId = 'box_' + Math.random().toString(36).slice(2, 7);
  let entry;
  if (b && b.kind === 'past') {
    entry = { date: _tlIso(_tlToday()), done: true, endDate: _tlIso(_tlToday()), tasks: [], owner: '' };
  } else {
    entry = { done: false, tasks: [], owner: '' };
    if (b) _nrRescheduleEntry(entry, b, bucketIdx, buckets.length - 1);   // sticky horizonId (horizons) or date (calendar)
  }
  epic.boxes = epic.boxes || [];
  const newBox = { id: boxId, roadmapSchedule: [entry], createdAt: _nrTodayIso() };
  epic.boxes.push(newBox);
  if (Number.isInteger(row) && row >= 0) _nrMoveBoxInRows(epic, null, newBox, row, null, buckets, true);   // at the clicked row (the box already there moves down)
  _nrEdit = { secKey, epicId, boxId, idx: 0 };
  await saveNotesMeta(sec);
  await saveNotesContent(sec, epicId, boxId, '');
  if (secKey === activeSection) {
    if (typeof renderNotesBoxes === 'function') await renderNotesBoxes();
    if (typeof renderNotesToolbar === 'function') renderNotesToolbar();
    if (typeof renderNotesOutline === 'function') renderNotesOutline();
  }
  renderNotesRoadmap();
  showToast('✓ Card added' + (b ? ' in ' + b.label.replace(/[◀▶]/g, '').trim() : ''));
}

// Delete a station (box) from an aggregated view, in its OWN Area. SOFT-delete: the box meta is
// removed now and an Undo toast is shown; the notes .md is hard-deleted only when the undo window
// expires (or a new delete supersedes this one). Undo re-inserts the meta - the .md is untouched,
// so nothing is lost even if the disk write failed. No content is captured or rewritten.
async function nrAggDeleteBox(secKey, epicId, boxId) {
  if (_nrDeleteBusy) return;                                // a delete's meta save is in flight -> ignore reentry so two deletes never race the same meta file (and can't zero out the first's undo window)
  const sec = SECTIONS[secKey];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === epicId);
  if (!epic) return;
  if (_nrReadOnly(epic)) return;                            // read-only chapter: refuse before even asking to confirm
  const idx = (epic.boxes || []).findIndex(b => b.id === boxId);
  if (idx < 0) return;
  if (epic.boxes.length <= 1) { showToast("⚠ Cannot delete " + aan(LBL('chapter')) + "'s only card"); return; }
  // The Delete button sits in an OPEN editor. The confirm dialog takes focus, the title input
  // blurs, and the blur-commit fires a meta save that still carries this box - racing the delete's
  // save below at the store, where the later-landing one wins (RUN: the deleted station came back,
  // and an Undo then held it twice). Commit first and wait for that save to land, so the two
  // writes are serialized; an edit the user typed is kept either way.
  await _nrCommitCardEdit();
  if (!(await showConfirmModal({ title: 'Delete station?', message: 'This station and its notes will be deleted. You can undo right after.', okLabel: 'Delete', danger: true }))) return;
  if (_nrUndoStation) { clearTimeout(_nrUndoTimer); _nrFinalizeDelete(); }   // a prior soft-delete is still pending -> hard-delete it first so this one can't clobber its undo
  const box = epic.boxes[idx];
  epic.boxes.splice(idx, 1);
  _nrMarkBoxDeleted(epicId, boxId);            // the meta save below would otherwise merge the box back from the store, and the expiry then delete its notes
  _nrEdit = null;
  _nrUndoStation = { secKey, epicId, box, idx };            // meta gone now; .md deleted only on undo-window expiry
  _nrDeleteBusy = true;
  try {
    await saveNotesMeta(sec);
    if (secKey === activeSection) {
      if (typeof renderNotesBoxes === 'function') await renderNotesBoxes();
      if (typeof renderNotesToolbar === 'function') renderNotesToolbar();
      if (typeof renderNotesOutline === 'function') renderNotesOutline();
    }
    renderNotesRoadmap();
    _nrUndoToast('Station deleted', _nrUndoDeleteStation, _nrFinalizeDelete);
  } finally {
    _nrDeleteBusy = false;                                  // release the in-flight lock even if the save/render throws
  }
}

// Restore the soft-deleted station: put the box meta back at its original slot. Its notes .md was
// never removed (hard-delete only runs on undo-window expiry), so it is auto re-referenced - no
// content rewrite needed.
async function _nrUndoDeleteStation() {
  const u = _nrUndoStation;
  _nrUndoStation = null;
  if (!u) return;
  const sec = SECTIONS[u.secKey];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === u.epicId);
  if (!epic) { showToast('⚠ Cannot restore - ' + LBL('chapter').toLowerCase() + ' removed'); return; }
  const boxes = epic.boxes || (epic.boxes = []);
  boxes.splice(Math.min(u.idx, boxes.length), 0, u.box);
  _nrUnmarkBoxDeleted(u.epicId, u.box.id);     // it is a live box again - the delete record must not outlive the undo
  await saveNotesMeta(sec);
  if (u.secKey === activeSection) {
    if (typeof renderNotesBoxes === 'function') await renderNotesBoxes();
    if (typeof renderNotesToolbar === 'function') renderNotesToolbar();
    if (typeof renderNotesOutline === 'function') renderNotesOutline();
  }
  renderNotesRoadmap();
  showToast('✓ Station restored');
}

// Hard-delete the notes .md of the still-pending soft-deleted station - the moment its undo window
// expires, or a new delete supersedes it. The box meta is already gone; on Undo this never runs.
function _nrFinalizeDelete() {
  const u = _nrUndoStation;
  _nrUndoStation = null;
  if (!u) return;
  const sec = SECTIONS[u.secKey];
  if (sec) deleteNotesContent(sec, u.epicId, u.box.id);
}

// A toast with an Undo action (the shared showToast is text-only). Clicking Undo runs undoFn;
// otherwise it auto-dismisses and runs expireFn (which finalizes the soft-delete).
function _nrUndoToast(msg, undoFn, expireFn) {
  let el = document.getElementById('nrUndoToast');
  if (!el) {
    el = document.createElement('div');
    el.id = 'nrUndoToast';
    el.className = 'nr-undo-toast';
    document.body.appendChild(el);
  }
  el.innerHTML = '<span class="nr-undo-msg"></span><button class="nr-undo-btn" type="button">Undo</button>';
  el.querySelector('.nr-undo-msg').textContent = msg;
  const hide = () => el.classList.remove('show');
  el.querySelector('.nr-undo-btn').onclick = () => { clearTimeout(_nrUndoTimer); hide(); undoFn(); };
  el.classList.add('show');
  clearTimeout(_nrUndoTimer);
  _nrUndoTimer = setTimeout(() => { hide(); if (expireFn) expireFn(); }, 7000);
}

// ── Add a box straight into a column ───────────────────────────────────────
// Creates a new box whose single schedule entry sits in the clicked column
// (backlog column = unscheduled), then opens it in inline edit (title focused).
async function nrAddInCol(laneId, bucketIdx, row) {
  const sec = SECTIONS[activeSection];
  const epic = _nrEpic();
  if (!epic) return;
  if (_nrReadOnly(epic)) return;                        // read-only chapter: no station is added
  const buckets = _nrBuckets(epic);
  const b = buckets[bucketIdx];
  // Adding straight into an unallocated column schedules it too (same as a drop).
  const hz = b && b.hid ? (_nrGlobalHorizons || []).find(h => h.id === b.hid) : null;
  let touched = null;
  if (hz && hz.unallocated) { touched = _nrReflowHorizons(() => { hz.span = NR_NEW_SPAN; delete hz.unallocated; }); _nrSaveHorizons(); }
  const bb = _nrBuckets(epic)[bucketIdx];   // re-read after a possible activation
  const boxId = 'box_' + Math.random().toString(36).slice(2, 7);
  let entry;
  if (bb && bb.kind === 'past') entry = { date: _tlIso(_tlToday()), done: true, endDate: _tlIso(_tlToday()), tasks: [], owner: '' };
  else { entry = { done: false, tasks: [], owner: '' }; if (bb) _nrRescheduleEntry(entry, bb, bucketIdx, buckets.length - 1); }   // sticky horizonId (horizons) or date (calendar)
  const box = { id: boxId, roadmapLane: laneId, roadmapSchedule: [entry], createdAt: _nrTodayIso() };
  epic.boxes.push(box);
  if (Number.isInteger(row) && row >= 0) _nrMoveBoxInRows(epic, laneId, box, row, null, _nrBuckets(epic), true);   // at the clicked row (the box already there moves down); the notes view re-renders below
  _nrEdit = { secKey: activeSection, epicId: epic.id, boxId, idx: 0 };
  await saveNotesMeta(sec);
  if (touched) touched.forEach(k => { if (k !== activeSection) saveNotesMeta(SECTIONS[k]); });   // cards shifted in other subjects by the activation
  await saveNotesContent(sec, epic.id, boxId, '');
  await renderNotesBoxes();
  renderNotesToolbar();
  renderNotesRoadmap();
  renderNotesOutline();
  showToast('✓ ' + LBL('boxNoun') + ' added' + (b ? ' in ' + b.label.replace(/[◀▶]/g, '').trim() : ''));
}

// ── Spacer rows ("space" between two cards, the whole row across every column) ────────────
// laneId '' = the aggregated board (one chapter's rows). Both ask the chapter's own lock,
// shift the rows through the model.js row model, and save that chapter's meta ONCE.
function nrAddRowGap(secKey, epicId, laneId, row) {
  const sec = SECTIONS[secKey];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === epicId);
  if (!epic || _nrReadOnly(epic)) return;
  if (!_nrAddGap(epic, laneId || null, row, _nrBuckets(laneId ? epic : _nrPrefEpic()))) return;
  _nrSaveMeta(sec);
  renderNotesRoadmap();
}
function nrRemoveRowGap(secKey, epicId, laneId, row) {
  const sec = SECTIONS[secKey];
  const epic = sec && (sec.notesEpics || []).find(n => n.id === epicId);
  if (!epic || _nrReadOnly(epic)) return;
  if (!_nrRemoveGap(epic, laneId || null, row, _nrBuckets(laneId ? epic : _nrPrefEpic()))) return;
  _nrSaveMeta(sec);
  renderNotesRoadmap();
}

;
// ==== FILE: js/table.js ====

// Default column width (px) by NAME, so a header like "Status" or "Task /
// Summary" always gets a sensible width and never wraps into stacked letters.
// localStorage (user-resized) takes precedence over this. # is always narrow.
// The FLOOR of a column's width: its header text at the header's font, plus the cell padding (14px each side) and the
// room the hover controls take at the right edge. A column is never narrower than this - not by the stored drag width,
// not by the pane: a narrow window makes the TABLE wider than its pane (the table carries min-width = the sum of its
// columns, .table-scroll scrolls sideways) instead of the browser squeezing every column in proportion and breaking
// "Resources" / "Status" / "Date" into one letter per line (Rishabh 2026-10-12, his screenshot; his option A).
// MEASURED from the rendered header, never guessed from the stylesheet: the chrome = th width minus the label box
// (the label is flex:1, so that difference is exactly the th padding + gap + the + / ✕ buttons (opacity 0 but laid out)
// + the sort / filter glyphs + the handle); the label's natural width = its box when it is let go of flex:1 for one
// read (its own font, letter-spacing and padding included).
function colHeaderMinWidth(name, ci) {
  const cell = document.querySelector(`#tableHead th .cell[data-ci="${ci}"]`);
  const th = cell && cell.closest('th');
  if (!th) return 0;
  const chrome = th.getBoundingClientRect().width - cell.getBoundingClientRect().width;
  const prevFlex = cell.style.flex;
  cell.style.flex = '0 0 auto';
  const natural = cell.getBoundingClientRect().width;
  cell.style.flex = prevFlex;
  return Math.ceil(natural + chrome) + 2;
}
// After the header is rendered: a column narrower than its label + chrome is widened to exactly that (the stored drag
// width and the by-name default both bow to it), then the table's min-width follows.
function applyHeaderFloors() {
  document.querySelectorAll('#colGroup col[data-ci]').forEach((col) => {
    const ci = Number(col.dataset.ci);
    if (ci === 0) return;
    const cell = document.querySelector(`#tableHead th .cell[data-ci="${ci}"]`);
    if (!cell) return;
    const need = colHeaderMinWidth(cell.textContent, ci);
    if ((parseFloat(col.style.width) || 0) < need) col.style.width = need + 'px';
  });
  syncTableMinWidth();
}
// The table's min-width follows its columns (render + a live drag): the sum of the <col> widths + the action column.
function syncTableMinWidth() {
  let sum = 44;
  document.querySelectorAll('#colGroup col[data-ci]').forEach((c) => { sum += parseFloat(c.style.width) || 0; });
  document.getElementById('taskTable').style.minWidth = sum + 'px';
}
function colDefaultWidth(name, i) {
  if (i === 0) return 44;
  switch ((name || '').trim().toLowerCase()) {
    case 'theme': return 130;
    case 'epic': return 150;
    case 'parent task': return 150;
    case 'task / summary': case 'task/summary': case 'task': case 'summary': return 240;
    case 'sub task': case 'subtask': return 200;
    case 'resources': case 'resource': return 120;
    case 'status': return 110;
    case 'notes': return 220;
    case 'date': return 120;
    default: return 160;
  }
}

// Per-cell text-styling class by column NAME (mirrors colDefaultWidth), so
// Status/Notes/etc. get the right size/color whatever the column order. The old
// positional TD_CLASSES mis-styled cells once the default column order changed.
function tdClass(name, i) {
  if (i === 0) return 'col-num';
  switch ((name || '').trim().toLowerCase()) {
    case 'theme': return 'col-theme';
    case 'epic': return 'col-epic';
    case 'parent task': return 'col-parent';
    case 'task / summary': case 'task/summary': case 'task': case 'summary': return 'col-task';
    case 'sub task': case 'subtask': return 'col-sub';
    case 'resources': case 'resource': return 'col-owner';
    case 'status': return 'col-status';
    case 'notes': return 'col-notes';
    default: return '';
  }
}

// ── Epic data-grid sort & filter (display-only) ──────────────────────────────
// A per-column sort + value filter for the main task grid, mirroring the
// notes-table controls. It only changes how rows are DISPLAYED — sec.rows is
// never reordered (each rendered <tr> keeps its real data-ri, so edits/deletes
// hit the right row). State is per-section and in-memory (resets on reload),
// applied on TOP of the Epic / Parent-Task sub-tab filtering. Reuses the notes
// engine's comparator (tvCompare/tvCellText) and the shared filter dropdown
// (tvBuildFilterPop) — both loaded from notes.js before this file.
const _gridViews = {};       // { [sectionKey]: { sort:{ci,dir}|null, filters:{ci:[values]} } }
let _gridVisible = [];       // sub-tab-filtered [{row, ri}] of the last render — the filter dropdown reads its value list from here

function getGridView() {
  const v = _gridViews[activeSection];
  return { sort: (v && v.sort) || null, filters: (v && v.filters) || {} };
}
function setGridView(view) {
  const has = view && (view.sort || (view.filters && Object.keys(view.filters).length));
  if (has) _gridViews[activeSection] = { sort: view.sort || null, filters: view.filters || {} };
  else delete _gridViews[activeSection];
}
// Drop the index-keyed sort/filter view for a section (defaults to the active
// one). Called from EVERY path that can change a section's column layout/meaning
// — undo/redo (restoreFrom), category switch, and CSV reload — so a stale view
// can never misapply to a now-different column.
function _clearGridView(key) { delete _gridViews[key || activeSection]; }

// Flatten a cell that holds a pasted Markdown table to a short readable label
// (its header cells), so the filter list / sort key never show raw pipe markdown.
function gridFlattenMd(v) {
  const lines = String(v).trim().split('\n').filter(l => l.trim() !== '');
  if (lines.length < 2) return v;
  const cells = l => l.replace(/^\s*\|/, '').replace(/\|\s*$/, '').split(/(?<!\\)\|/).map(c => c.replace(/\\\|/g, '|').trim());
  return '▦ ' + cells(lines[0]).filter(Boolean).join(' / ');
}
// The comparable / filterable text for a cell. Grouping columns (Epic, Parent
// Task) use the FILLED-DOWN value (effectiveEpic/effectiveParentTask) — in the
// grouped views their continuation rows are blank, so the raw cell would make a
// filter on those columns match only each group's header row. Markdown-table
// cells are flattened so the token matches what's displayed, not raw pipes.
// epicCi/ptCi are passed in (not recomputed per cell) — parentTaskColumnIndex
// reads localStorage, so resolving it once per render keeps this cheap.
function gridCellValue(sec, ri, ci, epicCi, ptCi) {
  let raw;
  if (ci === epicCi && epicCi >= 0) raw = effectiveEpic(sec.rows, ri, epicCi);
  else if (ci === ptCi && ptCi >= 0) raw = effectiveParentTask(sec.rows, ri, ptCi, epicCi);
  else raw = sec.rows[ri][ci];
  raw = raw != null ? raw : '';
  if (isMdTable(raw)) raw = gridFlattenMd(raw);
  return tvCellText(raw);
}
// True if a row passes every active column filter (AND across columns, OR within
// a column). Stale keys (column removed) are ignored.
function gridRowMatches(sec, ri, filters, epicCi, ptCi) {
  const colCount = sec.columns.length;
  for (const k in filters) {
    const ci = +k;
    if (ci < 0 || ci >= colCount) continue;
    if (!Array.isArray(filters[k])) continue;
    if (filters[k].indexOf(gridCellValue(sec, ri, ci, epicCi, ptCi)) === -1) return false;
  }
  return true;
}
// Distinct displayed values of column ci across the sub-tab-visible rows (sorted).
function gridColumnValues(sec, ci) {
  const epicCi = epicColumnIndex(sec), ptCi = parentTaskColumnIndex(sec);
  const seen = new Set(), vals = [];
  for (const x of _gridVisible) {
    const v = gridCellValue(sec, x.ri, ci, epicCi, ptCi);
    if (!seen.has(v)) { seen.add(v); vals.push(v); }
  }
  vals.sort((a, b) => tvCompare(a, b, 'asc'));
  return vals;
}
// Group-preserving sort. The grid is a grouped table (Epic ▸ Parent Task ▸
// rows, via fill-down), so sorting works "at the group level": groups stay
// intact and only the level being sorted is reordered.
//   • sort the Epic column      → reorder whole Epic blocks by Epic name
//   • sort the Parent Task col   → reorder Parent-Task blocks within each Epic
//   • sort any other (leaf) col  → reorder rows within their smallest group
// Higher levels keep their natural (first-appearance) order; ties fall back to
// the original row order (stable). Because blocks never break, the first row of
// each block still carries the group name — fill-down display + group borders
// keep working and the cells stay normally editable. sec.rows is untouched.
function gridSortRows(shown, sortCol, dir, sec, epicCi, ptCi) {
  const meta = shown.map((x, idx) => ({
    x, idx,
    epic: epicCi >= 0 ? effectiveEpic(sec.rows, x.ri, epicCi) : '',
    pt: ptCi >= 0 ? effectiveParentTask(sec.rows, x.ri, ptCi, epicCi) : '',
  }));
  const epicFirst = new Map(), ptFirst = new Map();
  meta.forEach(m => {
    m.pk = JSON.stringify([m.epic, m.pt]);   // collision-proof composite (Epic, Parent Task) key
    if (!epicFirst.has(m.epic)) epicFirst.set(m.epic, m.idx);
    if (!ptFirst.has(m.pk)) ptFirst.set(m.pk, m.idx);
  });
  const sortingEpic = sortCol === epicCi && epicCi >= 0;
  const sortingPt = sortCol === ptCi && ptCi >= 0;
  meta.sort((A, B) => {
    let c;
    if (sortingEpic) {
      c = tvCompare(A.epic, B.epic, dir); if (c) return c;
      return A.idx - B.idx;
    }
    c = epicFirst.get(A.epic) - epicFirst.get(B.epic); if (c) return c;   // keep Epic blocks in order
    if (sortingPt) {
      c = tvCompare(A.pt, B.pt, dir); if (c) return c;
      return A.idx - B.idx;
    }
    c = ptFirst.get(A.pk) - ptFirst.get(B.pk); if (c) return c;   // keep PT blocks in order
    c = tvCompare(gridCellValue(sec, A.x.ri, sortCol, epicCi, ptCi), gridCellValue(sec, B.x.ri, sortCol, epicCi, ptCi), dir); if (c) return c;
    return A.idx - B.idx;
  });
  return meta.map(m => m.x);
}
// Cycle a column's sort: none → asc → desc → none.
function gridCycleSort(ci) {
  const view = getGridView();
  const cur = (view.sort && view.sort.ci === ci) ? view.sort.dir : null;
  const next = cur === null ? 'asc' : (cur === 'asc' ? 'desc' : null);
  view.sort = next ? { ci, dir: next } : null;
  setGridView(view);
  renderTable();
}
// Open the filter dropdown for column ci, anchored under its header glyph.
function gridOpenFilter(e, ci, anchorEl) {
  if (e && e.stopPropagation) e.stopPropagation();
  const sec = SECTIONS[activeSection];
  const view = getGridView();
  const values = gridColumnValues(sec, ci);
  const active = view.filters && view.filters['' + ci];
  const selected = new Set(active ? active : values);   // no filter ⇒ all selected
  tvBuildFilterPop(values, selected, anchorEl, (chosen) => {
    if (!view.filters) view.filters = {};
    if (chosen.length === values.length) delete view.filters['' + ci];   // all ⇒ no filter
    else view.filters['' + ci] = chosen;
    setGridView(view);
    renderTable();
  });
}
// Clear all sort + filters for the active section (wired to the toolbar pill).
function gridResetView() {
  setGridView({ sort: null, filters: {} });
  renderTable();
}

function renderTable() {
  const sec = SECTIONS[activeSection];

  // A subject with NO chapter and NO table (a domain is BORN with a chapter - sections.js; this is one whose last
  // chapter was deleted) is a plain blank: no grid, no table toolbar, nothing in their place - the strip's
  // "+ Add Notes" / "+ Add Table" are the way in, and never the roadmap aggregate (Rishabh 2026-10-27: "existing
  // platform hai, kuch subtle sa blank"; the card with two buttons was rejected on his look). [hidden] is honoured by
  // a styles.css rule that beats the toolbar's display:flex - the attribute alone lost to it (v212).
  const bare = !sectionHasTable(sec) && !(sec.notesEpics || []).length;
  document.querySelector('#tableView .toolbar').hidden = bare;
  document.querySelector('#tableView .table-wrapper').hidden = bare;
  if (bare) return;

  // The VIEW (table-groupby.js): one table (its Topic column is implied, so hidden, as is a "Theme" column),
  // or "All", where the Topic column shows which table a row belongs to.
  // The view's Group-by chain nests the rows under headings; an outline focus narrows them to one branch.
  const epicCi = epicColumnIndex(sec);
  const ptCi = parentTaskColumnIndex(sec);
  const table = activeTableName(sec);
  const gIdxs = groupByIndices(sec);
  // The columns this view shows, in order (table-columns.js viewColumnIndices): # then the open table's own set;
  // All / a flat table: every column. A "Theme" column is implied inside a table. A grouping column reads on its
  // heading, so it leaves the grid (Rishabh 2026-09-29: "two times the same value ka kya point").
  const viewCols = viewColumnIndices(sec).filter(i => i === 0 || (!gIdxs.includes(i) && !(table !== null && (sec.columns[i] || '').trim().toLowerCase() === 'theme')));
  const hiddenCols = new Set(sec.columns.map((c, i) => i).filter(i => !viewCols.includes(i)));

  // Build visible-row list. Keep the original index (ri) so data-ri still
  // points into sec.rows correctly — edits/deletes operate on real positions,
  // not filtered positions. Computed before the header so the sort/filter
  // controls know whether there's enough data to bother showing.
  const focus = (gIdxs.length && sec.outlineFocus) ? sec.outlineFocus : null;
  const visible = sec.rows
    .map((row, ri) => ({ row, ri }))
    .filter(x => {
      if (!rowInView(sec, x.ri, epicCi)) return false;
      if (focus) { const p = groupPathOf(sec, x.ri, gIdxs, epicCi); if (!focus.every((v, i) => p[i] === v)) return false; }
      return true;
    });
  _gridVisible = visible;                 // the filter dropdown reads its value list from here

  const view = getGridView();
  const showCtrls = visible.length >= 1;  // show as soon as there's data (discoverable even on 1 row)

  // Colgroup — width by column NAME (not position) so headers always fit and
  // never cram, whatever the column set/order. A localStorage value (the user
  // dragged the resize handle) overrides it. data-ci on each <col> lets the
  // resize handler find the right element even when sub-tab filtering hides some.
  // (the trailing c-act is the narrow 44px action-button column)
  document.getElementById('colGroup').innerHTML =
    viewCols.map((i) => {
      const c = sec.columns[i];
      const w = getStoredColWidth(activeSection, c) || colDefaultWidth(c, i);
      return `<col data-ci="${i}" style="width:${w}px">`;
    }).join('') + '<col class="c-act">';
  // (the header floors + the table's min-width are applied right after the header renders - applyHeaderFloors)

  // Head — headers are editable, hover shows ✕, right edge has a resize handle.
  // When there are ≥2 rows, each header also carries display-only sort/filter
  // controls (the .cell stays clean — controls are siblings, so onHeaderEdit's
  // textContent read never picks them up).
  document.getElementById('tableHead').innerHTML = `<tr>
    ${viewCols.map((i) => {
      const c = sec.columns[i];
      if (i === 0) return `<th class="center">${esc(c)}</th>`;
      const label = columnLabel(sec, i);
      const sortDir = (view.sort && view.sort.ci === i) ? view.sort.dir : null;
      const sortGlyph = sortDir === 'asc' ? '▲' : (sortDir === 'desc' ? '▼' : '↕');
      const hasFilter = !!(view.filters && view.filters['' + i] && view.filters['' + i].length);
      // Sort is offered on every column. On the Epic / Parent-Task grouping
      // columns it reorders whole groups (see gridSortRows) rather than tearing
      // them apart, so the fill-down layout stays intact.
      const sortCtrl = showCtrls
        ? `<span class="tv-sort${sortDir ? ' tv-on' : ''}" onclick="gridCycleSort(${i})" title="Sort (asc / desc / off)">${sortGlyph}</span>`
        : '';
      const filterCtrl = showCtrls
        ? `<span class="tv-filter${hasFilter ? ' tv-on' : ''}" onclick="gridOpenFilter(event, ${i}, this)" title="Filter values">▾</span>`
        : '';
      const ctrls = (sortCtrl || filterCtrl)
        ? `<span class="grid-th-ctrls" contenteditable="false">${sortCtrl}${filterCtrl}</span>`
        : '';
      return `<th><div class="th-wrap">
           <button class="ins-col-btn" onclick="insertColumn(${i})" title="Insert column before this">+</button>
           <div class="cell" contenteditable="true" data-ci="${i}" title="${esc(label)}" onblur="onHeaderEdit(this)" onkeydown="onKey(event,this)">${esc(label)}</div>
           ${ctrls}
           <span class="col-sel" onclick="toggleColSel(${i}, event)" title="Select column · Shift+click to select a range">▢</span>
           <button class="del-col-btn" onclick="delColumn(${i})" title="Delete column">✕</button>
         </div><div class="col-resize" onmousedown="startColResize(event, ${i})" title="Drag to resize"></div></th>`;
    }).join('')}
    <th class="center"></th>
  </tr>`;
  // A column is never narrower than its header label + the header's chrome; past the pane the table scrolls sideways
  // (.table-scroll) instead of the browser crushing every column (Rishabh 2026-10-12, option A).
  applyHeaderFloors();

  const visibleColCount = viewCols.length;

  // Toolbar clear-all pill — shown only when a sort/filter is active.
  const viewActive = !!(view.sort || (view.filters && Object.keys(view.filters).length));
  const clearEl = document.getElementById('gridClearView');
  if (clearEl) clearEl.hidden = !viewActive;

  const body = document.getElementById('tableBody');
  if (!visible.length) {
    body.innerHTML = `<tr><td colspan="${visibleColCount + 1}" class="empty">No rows yet. Click "+ Add Row" to start.</td></tr>`;
    renderGroupByControl(); renderGroupOutline();
    return;
  }

  // Display-only value filter + sort (applied on top of the sub-tab filter).
  // sec.rows is never reordered — each <tr> below keeps its real data-ri.
  let shown = visible;
  if (view.filters && Object.keys(view.filters).length) {
    shown = shown.filter(x => gridRowMatches(sec, x.ri, view.filters, epicCi, ptCi));
  }
  // Sort is honoured only if its column is in range and not currently hidden by
  // the sub-tab. The sort is GROUP-PRESERVING (gridSortRows): groups stay intact
  // and fill-down/borders keep working, so cells can stay normally editable.
  const sci = view.sort ? view.sort.ci : null;
  const sortCol = (sci != null && sci >= 0 && sci < sec.columns.length && !hiddenCols.has(sci)) ? sci : -1;
  if (sortCol >= 0) {
    shown = gridSortRows(shown, sortCol, view.sort.dir, sec, epicCi, ptCi);
  }

  if (!shown.length) {
    body.innerHTML = `<tr><td colspan="${visibleColCount + 1}" class="empty">No rows match the current filter. <button class="grid-clear-inline" type="button" onclick="gridResetView()">Clear sort/filter</button></td></tr>`;
    renderGroupByControl(); renderGroupOutline();
    return;
  }

  // While a sort/filter view is active, the fill-down "name on the first row of
  // a group" convention no longer holds (a reorder can move the named row, a
  // filter can hide it). So render the grouping columns (Epic / Parent Task)
  // with their filled-down value on EVERY visible row, and drop the group-start
  // borders. The cells stay editable (data-eff lets onEdit ignore a no-op blur
  // so the inherited value isn't silently written into a blank continuation row).
  const groupFill = sortCol >= 0 || !!(view.filters && Object.keys(view.filters).length);
  let displayIdx = 0;
  const rowHtml = ({ row, ri }) => {
    displayIdx++;
    const isGroupStart = !groupFill && !gIdxs.length && epicCi >= 0 && row[epicCi] && row[epicCi].trim() !== '';   // no grouping column (a flat table) or a Group-by view = no group borders
    const cls = [selectedRows.has(ri) ? 'selected' : '', isGroupStart ? 'group-start' : ''].filter(Boolean).join(' ');
    return `<tr class="${cls}" data-ri="${ri}">
      <td class="col-num" onclick="toggleSel(${ri}, event)" onmousedown="if(event.shiftKey)event.preventDefault()" style="cursor:pointer" title="Click to select · Shift+click to select a range"><button class="ins-row-btn" onclick="event.stopPropagation();insertRow(${ri})" title="Insert row before this">+</button>${displayIdx}</td>
      ${viewCols.slice(1).map((actualCi) => {
        const v = row[actualCi] == null ? '' : row[actualCi];
        const isFormula = isFormulaColumn(sec, actualCi);
        const tdc = tdClass(sec.columns[actualCi], actualCi);
        if (isFormula) {
          return `<td class="${tdc}"><div class="cell formula-cell" data-ri="${ri}" data-ci="${actualCi}" title="Computed — derived from other columns">${cellHtml(v)}</div></td>`;
        }
        if (groupFill && (actualCi === epicCi || actualCi === ptCi)) {
          const dv = (actualCi === epicCi) ? effectiveEpic(sec.rows, ri, epicCi) : effectiveParentTask(sec.rows, ri, ptCi, epicCi);
          return `<td class="${tdc}"><div class="cell" contenteditable="true" data-ri="${ri}" data-ci="${actualCi}" data-eff="1" onblur="onEdit(this)" onkeydown="onKey(event,this)" onpaste="onCellPaste(event,this)">${cellHtml(dv)}</div></td>`;
        }
        return `<td class="${tdc}"><div class="cell" contenteditable="true" data-ri="${ri}" data-ci="${actualCi}" onblur="onEdit(this)" onkeydown="onKey(event,this)" onpaste="onCellPaste(event,this)">${cellHtml(v)}</div></td>`;
      }).join('')}
      <td class="center"><button class="del-btn" onclick="delRow(${ri})" title="Delete">✕</button></td>
    </tr>`;
  };
  // A Group-by view nests the rows under collapsible headings (table-groupby.js); a plain view lists them.
  body.innerHTML = gIdxs.length
    ? groupedBodyHtml(sec, groupRows(sec, shown, gIdxs, epicCi), rowHtml, visibleColCount + 1, hiddenCols)
    : shown.map(rowHtml).join('');
  renderGroupByControl();
  renderGroupOutline();
  _paintColSel();
}


// ── Markdown-table cells ─────────────────────────────────────────────────
// A cell can hold a Markdown table (pasted from a spreadsheet or web page).
// It's stored as Markdown TEXT (CSV-safe — buildCSV quotes any field carrying a
// comma, a quote, or ANY of the three line breaks parseCSV honours: \n, \r\n and a
// lone \r) and shown as a real grid when the cell isn't being edited. On focus,
// ui.js's focusin handler swaps the grid back to raw Markdown so the user edits
// the source and innerText round-trips on save.
function isMdTable(v) {
  if (!v) return false;
  const lines = String(v).trim().split('\n');
  if (lines.length < 2 || !lines[0].includes('|')) return false;
  const sep = lines[1].trim();                       // separator row, e.g. | --- | --- |
  return /-/.test(sep) && /^[\s|:-]+$/.test(sep);
}

function mdTableToHtml(v) {
  const lines = String(v).trim().split('\n').filter(l => l.trim() !== '');
  const cells = l => l.replace(/^\s*\|/, '').replace(/\|\s*$/, '').split(/(?<!\\)\|/).map(c => c.replace(/\\\|/g, '|').trim());
  const head = cells(lines[0]);
  const body = lines.slice(2).map(cells);
  const th = head.map(h => `<th>${linkifyUrls(esc(h))}</th>`).join('');
  const trs = body.map(r => `<tr>${r.map(c => `<td>${linkifyUrls(esc(c))}</td>`).join('')}</tr>`).join('');
  return `<table class="cell-md-table"><thead><tr>${th}</tr></thead><tbody>${trs}</tbody></table>`;
}

// What an editable cell's HTML should be: a grid for a Markdown table, else the
// normal URL-pill'd escaped text.
function cellHtml(v) {
  return isMdTable(v) ? mdTableToHtml(v) : linkifyUrls(esc(v));
}

// Build a GitHub-flavoured Markdown table from a 2-D array of cells.
function rowsToMd(rows) {
  rows = (rows || []).filter(r => r.length && r.some(c => String(c).trim() !== ''));
  if (!rows.length) return '';
  const w = Math.max(...rows.map(r => r.length));
  const cell = s => String(s == null ? '' : s).replace(/\r?\n/g, ' ').replace(/\|/g, '\\|').trim();
  const fix = r => { const c = r.map(cell); while (c.length < w) c.push(''); return c; };
  const line = c => '| ' + c.join(' | ') + ' |';
  const all = rows.map(fix);
  return [line(all[0]), line(all[0].map(() => '---')), ...all.slice(1).map(line)].join('\n');
}

// Parse a pasted HTML <table> into a 2-D array of trimmed cell strings.
function htmlTableToRows(html) {
  try {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const table = doc.querySelector('table');
    if (!table) return null;
    const rows = Array.from(table.querySelectorAll('tr'))
      .map(tr => Array.from(tr.querySelectorAll('th,td'))
        .map(td => (td.innerText || td.textContent || '').replace(/\s+/g, ' ').trim()));
    return rows.length ? rows : null;
  } catch (_) { return null; }
}

// Parse tab-separated clipboard text (spreadsheet copy) into rows. Returns null
// if there are no tabs (not a table → let the default paste run).
function tsvToRows(text) {
  const lines = String(text || '').replace(/\r\n?/g, '\n').split('\n');
  while (lines.length && lines[lines.length - 1] === '') lines.pop();
  if (!lines.length || !lines.some(l => l.includes('\t'))) return null;
  return lines.map(l => l.split('\t'));
}

// Cell paste handler: if a table (HTML or TSV) is on the clipboard, convert it
// to a Markdown table and make it the cell's content; otherwise fall through to
// the browser's normal text paste (unchanged behaviour for non-table pastes).
function onCellPaste(e, el) {
  const cd = e.clipboardData || window.clipboardData;
  if (!cd || !cd.getData) return;
  // Ctrl+Shift+V → paste as plain text (skip the Markdown-table conversion).
  if (typeof window.consumePlainPaste === 'function' && window.consumePlainPaste()) {
    const plain = cd.getData('text/plain') || '';
    if (plain) { e.preventDefault(); document.execCommand('insertText', false, plain); }
    return;
  }
  const html = cd.getData('text/html');
  let rows = (html && /<table[\s>]/i.test(html)) ? htmlTableToRows(html) : null;
  if (!rows) rows = tsvToRows(cd.getData('text/plain'));
  if (!rows) return;                       // not a table → default paste
  const md = rowsToMd(rows);
  if (!md) return;
  e.preventDefault();
  el.textContent = md;                     // the pasted table IS the cell now
}


async function onEdit(el) {
  const ri = +el.dataset.ri, ci = +el.dataset.ci;
  const sec = SECTIONS[activeSection];
  // innerText (not textContent) — innerText includes the line breaks the
  // browser inserts for Shift+Enter (as <br> or wrapping <div>s). textContent
  // would silently strip them. URL pills are already expanded to raw URL text
  // by the focusin handler in ui.js, so innerText captures the real URL.
  const newVal = el.innerText.trim();
  // A grouping cell (Epic / Parent Task) shown with its filled-down (effective)
  // value while a sort/filter view is active (data-eff): if the user didn't
  // actually change it, don't materialise the inherited value into a blank
  // continuation cell — restore the display and bail. A real edit (newVal differs
  // from the inherited value) falls through and is written normally.
  if (el.dataset.eff) {
    const epicCi = epicColumnIndex(sec), ptCi = parentTaskColumnIndex(sec);
    const eff = ci === epicCi ? effectiveEpic(sec.rows, ri, epicCi)
              : ci === ptCi ? effectiveParentTask(sec.rows, ri, ptCi, epicCi) : null;
    if (eff !== null && newVal === eff && (sec.rows[ri][ci] || '') === '') {
      el.innerHTML = cellHtml(eff);
      return;
    }
  }
  const changed = sec.rows[ri][ci] !== newVal;
  if (changed) {
    pushUndo();
    sec.rows[ri][ci] = newVal;
    // Recompute any formula columns on this row — if a source value changed,
    // derived columns (e.g. Stamp Duty = 7% of Price) update automatically.
    const formulasChanged = computeRowFormulas(sec, ri);
    save();
    // Resource Management only: if a "Resources" cell was edited, either
    // clone the row into a matching Resource Epic (one-way overview→detail
    // sync) or offer to spawn a brand new Epic for it. Returns true if the
    // table was re-rendered, so we skip the rest of onEdit.
    if (await maybeAutoCreateResourceEpic(ri, ci, newVal)) return;
    // If the Epic column was edited, sub-tabs need to be re-derived. If the row
    // also moved out of the currently-active sub-tab, re-filter the table too.
    if (ci === epicColumnIndex(sec)) {
      renderSubtabs();
      renderTable();
      return; // renderTable already re-rendered this cell with pills collapsed
    } else if (groupByIndices(sec).includes(ci)) {
      renderTable();   // a grouping value changed: the row moves to its new heading, the outline recounts
      return;
    } else if (formulasChanged) {
      renderTable();
      return;
    }
  }
  // No full re-render happened above — recollapse URL pills (or re-render a
  // Markdown-table cell as a grid) so the user sees the rendered form after blur.
  el.innerHTML = cellHtml(sec.rows[ri][ci]);
}


// Resource Management uses a two-level pattern: Skill Wise is the overview
// (one row per skill+task with an assigned Resource in col 6), and each
// assigned Resource has their OWN Epic showing detailed tasks (Sahanoor →
// Badlaav Website breakdown). This hook keeps the second level in sync —
// one-way, overview→detail:
//   • Resources cell matches an EXISTING Resource Epic → silently clone
//     the source row into that Epic (so the assignee's view always shows
//     every task they own).
//   • Resources cell is a NEW name → offer (via confirm) to create their
//     Epic, seeded with every existing row already assigned to them.
//   • Edits/additions inside a Resource Epic never propagate back to
//     Skill Wise — that's intentional, those are detail expansions.
//
// Returns true if the table was re-rendered (clone happened or Epic was
// created); false otherwise — caller skips further re-render steps.
async function maybeAutoCreateResourceEpic(ri, ci, newVal) {
  if (activeSection !== 'resources') return false;
  const sec = SECTIONS[activeSection];
  const colName = sec.columns[ci];
  // Match the assignee column ("Resources", col 6) — NOT col 1 which is the
  // Epic itself, also confusingly named "Resource" (singular).
  if (!colName || colName.toLowerCase() !== 'resources') return false;
  // Use the raw typed value as the candidate Epic name. The user prefers to
  // see literal text reflected, not have the system pre-strip prefixes like
  // "Planned - " — phrases they don't want as Epics get a Cancel click.
  const cleaned = (newVal || '').trim();
  if (!cleaned) return false;
  const epicCi = epicColumnIndex(sec);
  if (epicCi < 0) return false;
  // Build lowercase→canonical-case map of existing Epic names so case-only
  // differences ("sahanoor" vs "Sahanoor") don't cause a duplicate Epic.
  const existingMap = new Map();
  sec.rows.forEach(r => {
    const v = (r[epicCi] || '').trim();
    if (v && !existingMap.has(v.toLowerCase())) existingMap.set(v.toLowerCase(), v);
  });
  // ── Existing Epic → clone the source row into it (silent, no confirm) ──
  if (existingMap.has(cleaned.toLowerCase())) {
    const matchedName = existingMap.get(cleaned.toLowerCase());
    pushUndo();
    // Clone the just-edited row verbatim, override only the Epic column with
    // the canonical-case name. This is overview→detail sync; the Skill Wise
    // source row stays where it is, the clone lives under the Resource Epic.
    const clone = sec.rows[ri].slice();
    clone[epicCi] = matchedName;
    clone[0] = String(sec.rows.length + 1);
    sec.rows.push(clone);
    save();
    renderSubtabs();
    renderTable();
    showToast(`✓ Synced to "${matchedName}" ${LBL('epicNoun')}`);
    return true;
  }
  // ── No matching Epic → confirm to create a new one, then seed it ──
  // Descriptive phrases like "Self + CA" or "DXB RE Consultant +
  // Social Media Consultant" shouldn't get their own Epic; user clicks Cancel.
  if (!(await showConfirmModal({ title: 'Create ' + LBL('epicNoun') + '?', message: `A new ${LBL('epicNoun')} "${cleaned}" will be created.`, okLabel: 'Create' }))) return false;
  pushUndo();
  // Find every existing row whose Resources cell already references this name —
  // these get cloned VERBATIM into the new Epic so the user sees the same
  // tasks already assigned to them, ready to expand with detailed sub-rows.
  const sourceRows = sec.rows.filter(rw =>
    (rw[ci] || '').trim().toLowerCase() === cleaned.toLowerCase()
  );
  const newRows = sourceRows.length > 0
    ? sourceRows.map(src => {
        // Clone the entire source row, then override ONLY the Epic column so
        // the clone belongs to the new Resource's Epic. Same Parent Task /
        // Task / Sub Task / Status / Notes / dates / Resources at the same
        // column positions — same level, same value, no shifting.
        const r = src.slice();
        r[epicCi] = cleaned;
        return r;
      })
    : [(() => {
        // No matches — single blank row carrying just the Epic name so the
        // pill is non-empty and the user can start adding tasks immediately.
        const r = sec.columns.map(() => '');
        r[epicCi] = cleaned;
        return r;
      })()];
  newRows.forEach((r, idx) => { r[0] = String(sec.rows.length + idx + 1); });
  sec.rows.push(...newRows);
  // Append to the unified subtab order so the new pill lands at the strip's end
  if (typeof subtabOrderInsertAtEnd === 'function' && typeof subtabKeyOfTable === 'function') {
    subtabOrderInsertAtEnd(sec, subtabKeyOfTable(cleaned));
  }
  save();
  renderSubtabs();
  renderTable();
  showToast(sourceRows.length > 0
    ? `✓ ${LBL('epicNoun')} "${cleaned}" created with ${sourceRows.length} starter row${sourceRows.length === 1 ? '' : 's'}`
    : `✓ ${LBL('epicNoun')} "${cleaned}" created`);
  return true;
}


function onKey(e, el) {
  if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); el.blur(); }
  // Excel-style row selection from a cell (Rishabh 2026-09-29): Shift+Down / Shift+Up starts on this row and
  // grows the selection one row per press; Esc clears it. Left / Right stay text selection inside the cell.
  const tr = el.closest && el.closest('#tableBody tr[data-ri]');
  if (tr && e.shiftKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
    e.preventDefault();
    extendSelByKey(Number(tr.dataset.ri), e.key === 'ArrowDown' ? 1 : -1, el.dataset.ci);
    return;
  }
  if (tr && e.shiftKey && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
    e.preventDefault();
    extendColSelByKey(Number(el.dataset.ci), e.key === 'ArrowRight' ? 1 : -1, Number(tr.dataset.ri));
    return;
  }
  if (tr && e.key === 'Escape' && (selectedRows.size || selectedCols.size)) { e.preventDefault(); clearSelection(); return; }
  if (e.key === 'Tab') {
    const cells = [...document.querySelectorAll('.cell')];
    const idx = cells.indexOf(el);
    const next = e.shiftKey ? cells[idx - 1] : cells[idx + 1];
    // Only preventDefault if we have somewhere to go — otherwise let the
    // browser's native Tab move focus out of the table.
    if (next) {
      e.preventDefault();
      el.blur();
      next.focus();
    }
  }
}


// Row selection by the # cell: a click toggles one row; Shift+click selects every row SHOWN between the last
// plain click and this one (display order - a sort or filter may reorder or hide rows, so the range is what
// the person sees, not raw indices). Rishabh 2026-09-29: "no way to select multiple rows?" - e.g. the 8
// preamble lines of an imported ledger: click 1, Shift+click 8, Delete Selected.
let _selAnchor = null;   // the row a range grows from (last plain click / the cell the keys started in)
let _selFocus = null;    // the far end of a keyboard range
const _shownRows = () => Array.from(document.querySelectorAll('#tableBody tr[data-ri]')).map(tr => Number(tr.dataset.ri));
// Paint the selection onto the rows already on screen - no re-render, so a focused cell keeps its focus
// while Shift+Arrow grows the range.
function _paintSel() {
  document.querySelectorAll('#tableBody tr[data-ri]').forEach(tr => tr.classList.toggle('selected', selectedRows.has(Number(tr.dataset.ri))));
}
function _selectShownRange(a, b, shown) {
  selectedRows.clear(); selectedCols.clear();
  shown.slice(Math.min(a, b), Math.max(a, b) + 1).forEach(r => selectedRows.add(r));
  _paintSel();
}
function toggleSel(ri, ev) {
  const shown = _shownRows();
  if (ev && ev.shiftKey && _selAnchor != null) {
    const a = shown.indexOf(_selAnchor), b = shown.indexOf(ri);
    if (a >= 0 && b >= 0) { shown.slice(Math.min(a, b), Math.max(a, b) + 1).forEach(r => selectedRows.add(r)); _selFocus = ri; _paintSel(); return; }
  }
  selectedRows.has(ri) ? selectedRows.delete(ri) : selectedRows.add(ri);
  _selAnchor = ri; _selFocus = ri;
  _paintSel();
}
// Shift+Down / Shift+Up from a cell: the first press selects this row and the next one (as Excel does from a
// cell), each further press moves the far end one row in display order; the range is anchor..focus. The
// caret follows into the same column of the new far row, so the next press keeps working.
function extendSelByKey(ri, dir, ci) {
  const shown = _shownRows();
  if (_selAnchor == null || !selectedRows.has(_selAnchor) || !shown.includes(_selAnchor)) { _selAnchor = ri; _selFocus = ri; }
  const from = (_selFocus != null && shown.includes(_selFocus)) ? _selFocus : ri;
  const ni = Math.max(0, Math.min(shown.length - 1, shown.indexOf(from) + dir));
  _selFocus = shown[ni];
  _selectShownRange(shown.indexOf(_selAnchor), ni, shown);
  const cell = document.querySelector('#tableBody tr[data-ri="' + _selFocus + '"] .cell[data-ci="' + ci + '"]');
  if (cell) { cell.focus(); cell.scrollIntoView({ block: 'nearest' }); }
}


// Internal: insert a blank row at the given index, focus its first editable
// cell. Shared by addRow (append) and insertRow (insert at a specific position
// via the row's "+" button).
// A cell still holding the caret commits BEFORE the rows move: its blur would otherwise fire after the splice and
// write its text into whatever row now sits at its old index (seen with a keyboard-selected range + the row "+").
function _commitFocusedCell() {
  const a = document.activeElement;
  if (a && a.classList && a.classList.contains('cell')) a.blur();
}
function _insertRowAt(beforeRi, count) {
  _commitFocusedCell();
  pushUndo();
  const sec = SECTIONS[activeSection];
  const r = sec.columns.map(() => '');
  r[0] = String(beforeRi + 1); // renumbered on save; just for consistency in memory
  // If one table is open, pre-fill its Topic on the new row so it actually shows up in that table; if the
  // outline has narrowed the view to a branch, pre-fill that branch's grouping values the same way.
  const epicCi = epicColumnIndex(sec);
  const table = activeTableName(sec);
  if (epicCi >= 0 && table) r[epicCi] = table;
  if (sec.outlineFocus) groupByIndices(sec).forEach((ci, i) => { const v = sec.outlineFocus[i]; if (v && v !== TableRules.GROUP_BLANK_LABEL) r[ci] = v; });
  const fresh = []; for (let i = 0; i < (count || 1); i++) fresh.push(r.slice());
  sec.rows.splice(beforeRi, 0, ...fresh);
  selectedRows.clear(); selectedCols.clear();
  // Add the row into the PLAIN view: a sort would scatter it to a computed spot
  // and an active filter would hide its blank cells, so drop the whole sort/
  // filter view. The new row then appears right where it was inserted, blank and
  // editable — no inherited/phantom value to fight.
  _clearGridView();
  save(); renderTable();
  setTimeout(() => {
    const c = document.querySelector(`.cell[data-ri="${beforeRi}"][data-ci="1"]`);
    if (c) c.focus();
  }, 50);
}


function addRow() {
  // Append at the end
  _insertRowAt(SECTIONS[activeSection].rows.length);
}


function insertRow(beforeRi) {
  // Insert before the row at index `beforeRi` (pushes that row down). The + of a SELECTED row inserts as many
  // blank rows as are selected, above the topmost selected row - Excel's "select 3 rows, Insert" (Rishabh 2026-09-29).
  if (selectedRows.has(beforeRi)) { _insertRowAt(Math.min(...selectedRows), selectedRows.size); return; }
  _insertRowAt(beforeRi);
}


// Internal: insert a column at the given index, then focus its header so the
// user can type the real name. Shared by addColumn (append) and insertColumn
// (insert at a specific position via the header "+" button).
// Inside a table the new column joins THAT table's set (table-columns.js), before the column at `beforeCi` of its
// order, or at its end; the file gains the column only if it is new to it. In the All / flat view the column is
// inserted into the file at `beforeCi`, as it always was.
function _insertColumnAt(beforeCi, count) {
  _commitFocusedCell();
  pushUndo();
  const sec = SECTIONS[activeSection];
  const table = activeTableName(sec);
  let focusCi = beforeCi;
  for (let k = 0; k < (count || 1); k++) {
    if (table !== null) {
      const name = uniqueColumnName(sec, 'New Column');
      const set = tableColsOf(sec, table);
      const pos = beforeCi < sec.columns.length ? set.indexOf(sec.columns[beforeCi]) : -1;
      tableAddColumn(sec, table, name, pos < 0 ? set.length : pos + k);
      if (k === 0) focusCi = sec.columns.indexOf(name);
    } else {
      if (TableRules.insertUnionColumnAt(sec, beforeCi, uniqueColumnName(sec, 'New Column'))) saveColumnLabels(sec);   // per-table label indices follow
    }
  }
  selectedCols.clear();
  _clearGridView();                      // column indices shifted → drop the sort/filter view
  save(); if (table !== null) saveTableViews(sec); renderTable();
  setTimeout(() => {
    const h = document.querySelector(`thead .cell[data-ci="${focusCi}"]`);
    if (h) {
      h.focus();
      const range = document.createRange();
      range.selectNodeContents(h);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }, 50);
}


function addColumn() {
  // Append at the end
  _insertColumnAt(SECTIONS[activeSection].columns.length);
}


function insertColumn(beforeCi) {
  // The + of a SELECTED column inserts as many new columns as are selected, before the leftmost one (the rows' rule).
  if (selectedCols.has(beforeCi)) { _insertColumnAt(Math.min(...selectedCols), selectedCols.size); return; }
  // Insert before the column at index `beforeCi` (pushes that column right)
  _insertColumnAt(beforeCi);
}


function onHeaderEdit(el) {
  const ci = +el.dataset.ci;
  const sec = SECTIONS[activeSection];
  const newVal = el.textContent.trim();
  const epic = activeTableName(sec);   // one table open: a label of its own; All / a table group: the shared name

  // ── Per-Epic rename ──
  // When a specific Epic is active, a header rename is a DISPLAY-LABEL override
  // for THAT Epic only. The section's canonical column name (sec.columns) — and
  // therefore every other Epic, plus formulas / CSV export which key off it —
  // is left untouched. With no override an Epic shows the shared canonical name,
  // so by default every Epic shares the same column names.
  if (epic) {
    const canonical = sec.columns[ci];
    sec.columnLabels = sec.columnLabels || {};
    const current = (sec.columnLabels[epic] && sec.columnLabels[epic][ci]) || canonical;
    if (current === newVal) return; // no change
    pushUndo();   // a label change is an Undo step too (the snapshot carries the labels, state.js)
    if (!newVal || newVal === canonical) {
      // Renamed back to the shared/default name → drop the override so this Epic
      // tracks the canonical name again (and the labels file stays tidy).
      if (sec.columnLabels[epic]) {
        delete sec.columnLabels[epic][ci];
        if (!Object.keys(sec.columnLabels[epic]).length) delete sec.columnLabels[epic];
      }
    } else {
      sec.columnLabels[epic] = sec.columnLabels[epic] || {};
      sec.columnLabels[epic][ci] = newVal;
    }
    saveColumnLabels(sec);
    if (typeof showToast === 'function') showToast('✓ Renamed in "' + epic + '" only');
    return;
  }

  // ── "All" view → rename the section-wide canonical column name ──
  if (sec.columns[ci] === newVal) return; // no change → no undo entry
  pushUndo();
  // Track renames of the Parent Task grouping column so the vertical sidebar
  // keeps working under the new name. (Epic is positional — no tracking
  // needed since col 1 stays col 1 regardless of name.)
  const wasPtCol = ci === parentTaskColumnIndex(sec);
  const oldName = sec.columns[ci];
  sec.columns[ci] = newVal;
  if (wasPtCol) setStoredPtColName(activeSection, newVal);
  renameGroupByColumn(sec, oldName, newVal);   // every view grouping on this column follows the new name
  save();
}


function delColumn(ci) {
  if (selectedCols.has(ci)) { deleteSelectedColumns(); return; }   // the ✕ of a SELECTED column deletes the whole selection (table-select.js)
  pushUndo();
  const sec = SECTIONS[activeSection];
  _removeColumn(sec, sec.columns[ci]);
  _clearGridView();                      // column indices shifted → drop the sort/filter view
  save(); saveTableViews(sec); renderTable();
}
// Take one column (by NAME) out of the open view (no undo entry, no save, no render - the callers do that once):
// inside a table, out of that table's set (table-columns.js - the file keeps it while another table shows it);
// in the All / flat view, out of the file.
function _removeColumn(sec, name) {
  const table = activeTableName(sec);
  if (table !== null) { tableRemoveColumn(sec, table, name); return; }
  const ci = sec.columns.indexOf(name);
  if (ci <= 0) return;
  if (TableRules.removeUnionColumnAt(sec, ci)) saveColumnLabels(sec);   // this column's per-table labels go, the rest shift
  _syncPtColOverride(sec);   // a remembered Parent Task column name that no column carries any more is dropped (table-columns.js)
}


let colResize = null; // { colEl, colName, startX, startWidth }


function startColResize(e, ci) {
  e.preventDefault();
  e.stopPropagation();
  const sec = SECTIONS[activeSection];
  const colName = sec.columns[ci];
  const colEl = document.querySelector(`#colGroup col[data-ci="${ci}"]`);
  if (!colEl) return;
  const startWidth = colEl.getBoundingClientRect().width;
  colResize = { colEl, colName, ci, startX: e.clientX, startWidth };
  document.body.classList.add('col-resizing');
  document.addEventListener('mousemove', onColResizeMove);
  document.addEventListener('mouseup', onColResizeEnd);
}


function onColResizeMove(e) {
  if (!colResize) return;
  const delta = e.clientX - colResize.startX;
  const newWidth = Math.max(colHeaderMinWidth(colResize.colName, colResize.ci), colResize.startWidth + delta);   // the floor = the header label + its chrome
  colResize.colEl.style.width = newWidth + 'px';
  syncTableMinWidth();
}


function onColResizeEnd() {
  if (!colResize) return;
  const finalWidth = Math.round(parseFloat(colResize.colEl.style.width));
  if (finalWidth && finalWidth >= colHeaderMinWidth(colResize.colName, colResize.ci)) setStoredColWidth(activeSection, colResize.colName, finalWidth);
  colResize = null;
  document.body.classList.remove('col-resizing');
  document.removeEventListener('mousemove', onColResizeMove);
  document.removeEventListener('mouseup', onColResizeEnd);
}


function delRow(ri) {
  if (selectedRows.has(ri)) { deleteSelected(); return; }   // the ✕ of a SELECTED row deletes the whole selection (Rishabh 2026-09-29)
  pushUndo();
  SECTIONS[activeSection].rows.splice(ri, 1);
  selectedRows.clear(); selectedCols.clear(); save(); renderTable();
}


async function deleteSelected() {
  if (selectedCols.size && !(await deleteSelectedColumns())) return;   // the columns first (confirmed); a Cancel keeps the rows too
  if (!selectedRows.size) return;
  _commitFocusedCell();
  pushUndo();
  [...selectedRows].sort((a, b) => b - a).forEach(i => SECTIONS[activeSection].rows.splice(i, 1));
  selectedRows.clear(); selectedCols.clear(); save(); renderTable();
}


// ── Per-Epic column labels ─────────────────────────────────────────────────
// Every Epic in a section shares ONE physical table (one CSV, one header row in
// sec.columns). To let a column display a DIFFERENT name under a specific Epic
// without affecting the others, per-Epic display-label overrides live in a
// sidecar file next to the CSV:
//
//   <prefix>__column_labels.json
//     → { "labels": { "<EpicName>": { "<colIndex>": "<label>" } } }
//
// Overrides are keyed by column INDEX (stable across renames; shifted on column
// insert/delete) and by Epic NAME (migrated on Epic rename, dropped on delete).
// A column with no override falls back to the canonical sec.columns name — so by
// default all Epics share the same column names. The canonical name is what the
// CSV header, formulas, and Export use; per-Epic labels are display-only.

function columnLabelsFilename(sec) {
  if (sec.file) return sec.file.replace(/\.csv$/, '') + '__column_labels.json';
  if (sec.categories && sec.categories[0] && sec.categories[0].file) {
    return sec.categories[0].file.replace(/__[^_]+\.csv$/, '') + '__column_labels.json';
  }
  return null;
}

async function loadColumnLabels(sec) {
  sec.columnLabels = {};
  const file = columnLabelsFilename(sec);
  if (!file) return;
  try {
    const res = await fetch('/load?file=' + file);
    if (!res.ok) { delete _csvVersions[file]; return; }
    _csvVersions[file] = res.headers.get('X-Note-Version') || null;   // data.js: the token the next save sends back
    const text = await res.text();
    if (!text.trim()) return;
    const json = JSON.parse(text);
    if (json && json.labels && typeof json.labels === 'object') sec.columnLabels = json.labels;
  } catch (_) { sec.columnLabels = {}; }
}

function saveColumnLabels(sec) {
  const file = columnLabelsFilename(sec);
  if (!file) return Promise.resolve();
  const payload = JSON.stringify({ labels: sec.columnLabels || {} }, null, 2);
  // Version-checked + chained (data.js _versionedSave): a stale save is refused, the labels reload, a toast says so.
  // Two sentences (data.js _settleSave): the network one for the fetch, an own one for a throw after the response.
  return _settleSave(_versionedSave(file, payload), 'The column labels', '⚠ Could not save the column labels',
    () => {},
    () => _onSaveConflict(file, () => loadColumnLabels(sec), () => renderTable(), 'The column labels'));
}

// Display name for column `ci` under the active Epic: the per-Epic override if
// one exists, otherwise the shared canonical column name.
function columnLabel(sec, ci) {
  const epic = activeTableName(sec);
  if (epic && sec.columnLabels && sec.columnLabels[epic]) {
    const ov = sec.columnLabels[epic][ci];
    if (typeof ov === 'string' && ov.length) return ov;
  }
  return sec.columns[ci];
}


;
// ==== FILE: js/table-columns.js ====
// ── Per-table columns: the web's thin callers of the SHARED rules (mcp-server/shared/table-rules.mjs, bundled as
// `TableRules` ahead of every classic script by scripts/build-bundles.mjs). The rules - one domain is ONE file
// whose header is the UNION of every table's columns, each table shows its own SET in its own order
// (sec.tableCols[table]), a column leaves the file only when no table lists it - live THERE, once, and the MCP
// server runs the same code (Rishabh 2026-09-29: "har table independent" + "MCP shares the web's code").
// This file keeps only what needs the page: the open view, localStorage, the label save. Add / rename / delete
// of a whole table (its set included) are TableRules.addTable / renameTable / deleteTable, called from subtabs.js.

// The names of the columns a table shows, in its order (never # or the Topic column).
function tableColsOf(sec, table) { return TableRules.tableColsOf(sec, table); }

// The column indices the open view shows: # first, then the table's own columns in its order; All / flat: everything.
function viewColumnIndices(sec) {
  const table = activeTableName(sec);
  if (table === null) return sec.columns.map((c, i) => i);
  const idx = tableColsOf(sec, table).map(n => sec.columns.indexOf(n)).filter(i => i > 0);
  return [0].concat(idx);
}

function uniqueColumnName(sec, base) { return TableRules.uniqueColumnName(sec, base); }
function tableAddColumn(sec, table, name, pos) { TableRules.tableAddColumn(sec, table, name, pos); }
function tableRemoveColumn(sec, table, name) { _afterUnionChange(sec, TableRules.tableRemoveColumn(sec, table, name).labelsTouched); }

// After the file's header changed: the per-table display labels are saved when the rules moved them, and a
// remembered Parent Task column name (localStorage, epics.js parentTaskColumnIndex) is dropped once no column
// carries it any more - by NAME, so it holds for one removed column or many.
function _afterUnionChange(sec, labelsTouched) {
  if (labelsTouched) saveColumnLabels(sec);
  _syncPtColOverride(sec);
}
function _syncPtColOverride(sec) {
  const n = getStoredPtColName(activeSection);
  if (n && !sec.columns.some(c => (c || '').trim().toLowerCase() === n.toLowerCase())) setStoredPtColName(activeSection, null);
}

;
// ==== FILE: js/table-select.js ====
// ── Column selection (Rishabh 2026-09-29: "multiple column we can't select?") ──
// The rows' model, turned sideways: the ▢ beside a header's sort / filter toggles that column, Shift+click
// selects the shown range, Shift+Right / Shift+Left from a cell grows the selection one column per press, Esc
// clears. A selected column's ✕ deletes every selected column (after a confirm with the count); its + inserts
// as many new columns; "Delete Selected" takes the selected columns along with the selected rows.
// The selection lives in state.js `selectedCols` (indices into sec.columns) and is painted onto the cells on
// screen (td.col-selected / th.col-selected), never re-rendered, so a focused cell keeps its caret.

let _colAnchor = null;   // the column a range grows from
let _colFocus = null;    // the far end of a keyboard range
const _shownCols = () => Array.from(document.querySelectorAll('#tableHead .cell[data-ci]')).map(c => Number(c.dataset.ci));

function _paintColSel() {
  document.querySelectorAll('#tableHead .cell[data-ci]').forEach(c => {
    const on = selectedCols.has(Number(c.dataset.ci));
    const th = c.closest('th'); if (th) th.classList.toggle('col-selected', on);
    const box = th && th.querySelector('.col-sel'); if (box) { box.classList.toggle('on', on); box.textContent = on ? '▣' : '▢'; }
  });
  document.querySelectorAll('#tableBody .cell[data-ci]').forEach(c => {
    const td = c.closest('td'); if (td) td.classList.toggle('col-selected', selectedCols.has(Number(c.dataset.ci)));
  });
}
function _selectShownColRange(a, b, shown) {
  selectedCols.clear();
  shown.slice(Math.min(a, b), Math.max(a, b) + 1).forEach(ci => selectedCols.add(ci));
  _paintColSel();
}
function toggleColSel(ci, ev) {
  if (ev) ev.stopPropagation();
  const shown = _shownCols();
  if (ev && ev.shiftKey && _colAnchor != null) {
    const a = shown.indexOf(_colAnchor), b = shown.indexOf(ci);
    if (a >= 0 && b >= 0) { shown.slice(Math.min(a, b), Math.max(a, b) + 1).forEach(c => selectedCols.add(c)); _colFocus = ci; _paintColSel(); return; }
  }
  selectedCols.has(ci) ? selectedCols.delete(ci) : selectedCols.add(ci);
  _colAnchor = ci; _colFocus = ci;
  _paintColSel();
}
// Shift+Right / Shift+Left from a cell: the first press selects this column and the next one, each further
// press moves the far end one column in display order; the caret follows into the same row of the far column.
function extendColSelByKey(ci, dir, ri) {
  const shown = _shownCols();
  if (_colAnchor == null || !selectedCols.has(_colAnchor) || !shown.includes(_colAnchor)) { _colAnchor = ci; _colFocus = ci; }
  const from = (_colFocus != null && shown.includes(_colFocus)) ? _colFocus : ci;
  const ni = Math.max(0, Math.min(shown.length - 1, shown.indexOf(from) + dir));
  _colFocus = shown[ni];
  _selectShownColRange(shown.indexOf(_colAnchor), ni, shown);
  const cell = document.querySelector('#tableBody tr[data-ri="' + ri + '"] .cell[data-ci="' + _colFocus + '"]');
  if (cell) { cell.focus(); cell.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
}
function clearSelection() {
  selectedRows.clear(); selectedCols.clear();
  _paintSel(); _paintColSel();
}

// Every selected column goes, after the person confirms the count. Resolves true when it happened.
async function deleteSelectedColumns() {
  const sec = SECTIONS[activeSection];
  const cols = [...selectedCols].filter(ci => ci > 0 && ci < sec.columns.length).sort((a, b) => b - a);
  if (!cols.length) return false;
  const names = cols.slice().reverse().map(ci => sec.columns[ci] || '(unnamed)');
  if (!(await showConfirmModal({
    title: 'Delete ' + cols.length + ' column' + (cols.length === 1 ? '' : 's') + '?',
    message: names.map(n => '"' + n + '"').join(', ') + ' and every value in ' + (cols.length === 1 ? 'it' : 'them') + ' will be permanently removed.',
    okLabel: 'Delete', danger: true
  }))) return false;
  _commitFocusedCell();
  pushUndo();
  names.forEach(n => _removeColumn(sec, n));   // by name: a removal may shift the file's indices
  selectedCols.clear();
  _clearGridView();
  save(); saveTableViews(sec); renderTable();
  return true;
}

// The Delete key on a selection = "Delete Selected" (Rishabh 2026-09-29: "select karne ke baad delete key kaam
// nahi karti?"). Only while the table view is on screen and no dialog is open; Backspace stays a text key, so
// typing in a cell is untouched, and with nothing selected Delete is the ordinary text key too.
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Delete' || e.altKey || e.ctrlKey || e.metaKey) return;
  if (!(selectedRows.size || selectedCols.size)) return;
  const tv = document.getElementById('tableView');
  if (!tv || tv.style.display === 'none' || !tv.offsetParent) return;
  if (document.querySelector('.tl-modal-overlay, .evlib-modal-ov')) return;
  if (document.body.classList.contains('tt-readonly')) return;
  e.preventDefault();
  deleteSelected();
});

;
// ==== FILE: js/table-groupby.js ====
// ── Group by: a multi-level, view-only grouping of a table's rows (Rishabh 2026-09-29) ──
// A VIEW is what the sub-tab strip has open: one table (a Topic) or "All" (every table of the domain - the
// Topic is a column there, so grouping across tables is just grouping by it). Each view remembers its own chain of grouping columns,
// e.g. ["Parent Task", "Status"]; the rows are then shown under nested, collapsible headings with a count
// and the totals of the number columns, and the left rail carries the same tree as an outline whose node
// click narrows the table to that branch. Nothing here touches the data: the CSV is what it was, a cell
// keeps its data-ri, sort and filter (the header controls) run first and grouping sits on top.
//
// Persisted per section in <prefix>__table_views.json: { groupBy: { <viewKey>: [column names] }, tableCols: { <table>: [names] } }.
// Columns are named, not indexed, so a column moved or inserted keeps its grouping. Collapsed headings and
// the outline focus live in memory only (a reload opens everything, focused on All).
//
// The old rule - a column NAMED "Parent Task" drives a vertical sidebar - is gone: a "Parent Task" column is a
// column like any other, grouped only when the person picks it here.

const TABLE_VIEWS_SUFFIX = '__table_views.json';

function tableViewsFilename(sec) {
  if (sec.file) return sec.file.replace(/\.csv$/, '') + TABLE_VIEWS_SUFFIX;
  if (sec.categories && sec.categories[0] && sec.categories[0].file) return sec.categories[0].file.replace(/__[^_]+\.csv$/, '') + TABLE_VIEWS_SUFFIX;
  return null;
}

async function loadTableViews(sec) {
  sec.groupBy = {}; sec.tableCols = {};
  const file = tableViewsFilename(sec);
  if (!file) return;
  try {
    const res = await fetch('/load?file=' + file);
    if (!res.ok) { delete _csvVersions[file]; return; }
    _csvVersions[file] = res.headers.get('X-Note-Version') || null;   // data.js: the token the next save sends back
    const text = await res.text();
    if (!text.trim()) return;
    const json = JSON.parse(text);
    if (json.groupBy && typeof json.groupBy === 'object') sec.groupBy = json.groupBy;
    if (json.tableCols && typeof json.tableCols === 'object') sec.tableCols = json.tableCols;
  } catch (_) { sec.groupBy = {}; sec.tableCols = {}; }
}

function saveTableViews(sec) {
  const file = tableViewsFilename(sec);
  if (!file) return Promise.resolve();
  const payload = JSON.stringify({ groupBy: sec.groupBy || {}, tableCols: sec.tableCols || {} }, null, 2);
  return _settleSave(_versionedSave(file, payload), 'The table views', '⚠ Could not save the table view',
    () => {},
    () => _onSaveConflict(file, () => loadTableViews(sec), () => { renderSubtabs(); renderTable(); }, 'The table views'));
}

// ── the active view ──
function viewKeyOf(sec) { return sec.activeSubtab || 'All'; }
// The ONE table the view shows, or null for "All" and "Roadmap" (the places that used to test
// `activeSubtab !== 'All'` and meant "a single table").
function activeTableName(sec) {
  const k = viewKeyOf(sec);
  return (k === 'All' || k === 'Roadmap') ? null : k;
}
// Is row `ri` inside the active view? One table: its Topic; All: every row.
function rowInView(sec, ri, epicCi) {
  const table = activeTableName(sec);
  if (table === null || epicCi < 0) return true;
  return effectiveEpic(sec.rows, ri, epicCi) === table;
}

// The chain of grouping COLUMN NAMES for the active view: what the person set on THIS table, nothing
// inherited (Rishabh 2026-09-29: "grouping per table, inherit kuch nahi") - a table with no chain is a plain grid.
// The rules (read, validate + store, rename) are the SHARED module's (mcp-server/shared/table-rules.mjs) - the
// MCP server sets a chain through the same code; this file adds the open view, the save and the repaint.
function groupByChain(sec) { return TableRules.groupByChain(sec, viewKeyOf(sec)); }
function groupByIndices(sec) { return TableRules.groupByIndices(sec, viewKeyOf(sec)); }
function setGroupByChain(sec, chain) {
  pushUndo();   // a view change is an Undo step like a data change (Rishabh 2026-09-30: "first undo = undo grouping, second = the cell edit")
  TableRules.setGroupByChain(sec, viewKeyOf(sec), chain);
  sec.outlineFocus = null; sec.groupCollapsed = new Set();
  saveTableViews(sec);
  renderGroupOutline();
  renderTable();
}

// A renamed column keeps its place in every view's chain (chains are by name).
function renameGroupByColumn(sec, oldName, newName) {
  if (TableRules.renameGroupByColumn(sec, oldName, newName)) saveTableViews(sec);
}

// A grouping cell inherits from the row above within the same Topic (the fill-down the table has always used
// for its grouping columns: the name on the first row of a run, blank continuation rows below it).
function effectiveCell(rows, idx, ci, epicCi) { return TableRules.effectiveCell(rows, idx, ci, epicCi); }
function groupPathOf(sec, ri, idxs, epicCi) { return TableRules.groupPathOf(sec, ri, idxs, epicCi); }

// The tree: { key, path, rows: [{row, ri}], children: [node] } - children in first-appearance order, so the
// person's own row order is the group order; leaves keep the rows.
function groupRows(sec, shown, idxs, epicCi) { return TableRules.groupRows(sec, shown, idxs, epicCi); }
function pathId(path) { return path.join('\u001f'); }

// Totals of the number columns for a group heading: a column counts when every non-blank cell in the group
// parses as a number (commas and spaces allowed) and at least one is present.
function groupTotals(sec, rows, hiddenCols) { return TableRules.groupTotals(sec, rows, hiddenCols); }
function fmtTotal(v) { return Number.isInteger(v) ? v.toLocaleString() : v.toLocaleString(undefined, { maximumFractionDigits: 2 }); }

// The tbody of a grouped view: heading rows (one per node, colspan across the table) with the rows under
// them; a collapsed heading hides everything beneath it. `rowHtml(x)` is the table's own row renderer, so
// cells look and edit exactly as ungrouped.
function groupedBodyHtml(sec, tree, rowHtml, colspan, hiddenCols) {
  const collapsed = sec.groupCollapsed || (sec.groupCollapsed = new Set());
  const focus = sec.outlineFocus || [];
  const inFocus = (node) => focus.every((v, i) => node.path[i] === undefined || node.path[i] === v);
  let html = '';
  const walk = (node, depth) => {
    for (const child of node.children) {
      if (!inFocus(child)) continue;
      const id = pathId(child.path), isOpen = !collapsed.has(id);
      const totals = groupTotals(sec, child.rows, hiddenCols).map(t => `<span class="grp-total"><span class="grp-total-k">${esc(t.name)}</span> ${esc(fmtTotal(t.sum))}</span>`).join('');
      html += `<tr class="grp-row lvl-${depth}" data-path="${esc(id)}" onclick="toggleGroupRow(this.dataset.path)" title="${isOpen ? 'Collapse' : 'Expand'}">`
        + `<td colspan="${colspan}"><span class="grp-chevron">${isOpen ? '▾' : '▸'}</span><span class="grp-name">${esc(child.key)}</span><span class="grp-count">${child.rows.length} row${child.rows.length === 1 ? '' : 's'}</span>${totals}</td></tr>`;
      if (!isOpen) continue;
      if (child.children.length) walk(child, depth + 1);
      else html += child.rows.map(rowHtml).join('');
    }
  };
  walk(tree, 1);
  return html;
}
function toggleGroupRow(id) {
  const sec = SECTIONS[activeSection];
  sec.groupCollapsed = sec.groupCollapsed || new Set();
  sec.groupCollapsed.has(id) ? sec.groupCollapsed.delete(id) : sec.groupCollapsed.add(id);
  renderTable();
}

// ── the outline (left rail, the slot the notes outline also uses) ──
// Root "All (n)", then the tree; a node click narrows the table to that branch (view-only), the chevron
// folds it. Empty when the view has no grouping, when the Roadmap is open, or when a notes topic is open
// (the notes outline owns the slot then).
function renderGroupOutline() {
  const wrap = document.getElementById('parentTaskTabs');
  if (!wrap) return;
  const sec = SECTIONS[activeSection];
  if (!sec || sec.activeNotesEpic || viewKeyOf(sec) === 'Roadmap') { wrap.innerHTML = ''; wrap.classList.remove('outline-collapsed'); return; }
  wrap.classList.remove('outline-collapsed');   // collapse is a notes-only affordance
  const idxs = groupByIndices(sec);
  if (!idxs.length) { wrap.innerHTML = ''; return; }
  const epicCi = epicColumnIndex(sec);
  // the view's rows, computed here (not read from the table's last render - it may be another section's)
  const shown = sec.rows.map((row, ri) => ({ row, ri })).filter(x => rowInView(sec, x.ri, epicCi));
  const tree = groupRows(sec, shown, idxs, epicCi);
  const focus = sec.outlineFocus || [];
  const focusId = pathId(focus);
  // the notes outline's shell (styles.css .outline-all / .outline-item): the same head, rows and current surface
  let html = `<div class="parent-task-tab outline-all" title="The groups of this view"><span class="outline-all-label">Outline</span></div>`
    + `<div class="parent-task-tab outline-item grp-node lvl-1 ${!focus.length ? 'is-current' : ''}" role="button" onclick="focusGroupNode('')"><span class="grp-node-chev none"></span><span class="outline-item-label">All</span><span class="grp-node-count">${shown.length}</span></div>`;
  const walk = (node, depth) => {
    for (const child of node.children) {
      const id = pathId(child.path), isOpen = child.children.length > 0 && outlineNodeOpen(sec, id, depth);
      const chev = child.children.length ? `<span class="grp-node-chev" data-path="${esc(id)}" data-depth="${depth}" onclick="event.stopPropagation();toggleOutlineNode(this.dataset.path, +this.dataset.depth)">${isOpen ? '▾' : '▸'}</span>` : '<span class="grp-node-chev none"></span>';
      html += `<div class="parent-task-tab outline-item outline-l${Math.min(depth, 3)} grp-node lvl-${depth} ${focusId === id ? 'is-current' : ''}" role="button" data-path="${esc(id)}" onclick="focusGroupNode(this.dataset.path)" title="${esc(child.path.join(' › '))}">${chev}<span class="outline-item-label">${esc(child.key)}</span><span class="grp-node-count">${child.rows.length}</span></div>`;
      if (isOpen) walk(child, depth + 1);
    }
  };
  walk(tree, 1);
  wrap.innerHTML = html;
}
function focusGroupNode(id) {
  const sec = SECTIONS[activeSection];
  const current = pathId(sec.outlineFocus || []);
  sec.outlineFocus = (!id || id === current) ? null : id.split('\u001f');
  selectedRows.clear(); selectedCols.clear();
  renderGroupOutline();
  renderTable();
}
// A level-1 node starts open, deeper ones closed; a click on the chevron flips that node and the choice is
// kept for the session (sec.outlineState, id -> open).
function outlineNodeOpen(sec, id, depth) {
  const st = sec.outlineState || {};
  return Object.prototype.hasOwnProperty.call(st, id) ? !!st[id] : depth === 1;
}
function toggleOutlineNode(id, depth) {
  const sec = SECTIONS[activeSection];
  sec.outlineState = sec.outlineState || {};
  sec.outlineState[id] = !outlineNodeOpen(sec, id, depth);
  renderGroupOutline();
}

// ── the toolbar control ──
// "Group by ▾" shows the chain as chips (each with ✕) and a "then by…" list of the remaining columns; Clear
// drops the chain for this view. Rendered by renderTable into #groupByCtl.
function renderGroupByControl() {
  const el = document.getElementById('groupByCtl');
  if (!el) return;
  const sec = SECTIONS[activeSection];
  if (!sec || viewKeyOf(sec) === 'Roadmap') { el.innerHTML = ''; return; }
  const chain = groupByChain(sec);
  const label = chain.length ? 'Group by: ' + chain.map(esc).join(' › ') : 'Group by';
  el.innerHTML = `<button class="layout-btn${chain.length ? ' active' : ''}" type="button" onclick="openGroupByMenu(this)" title="Group the rows under headings - one column, then another">☰ ${label} ▾</button>`;
}
function openGroupByMenu(btn) {
  const old = document.getElementById('groupByMenu'); if (old) { old.remove(); return; }
  const sec = SECTIONS[activeSection];
  const chain = groupByChain(sec);
  const rest = TableRules.groupableColumns(sec, viewKeyOf(sec)).filter(c => !chain.includes(c));   // this table's own columns, not the file's
  const menu = document.createElement('div'); menu.id = 'groupByMenu'; menu.className = 'grp-menu';
  const chips = chain.map((c, i) => `<span class="grp-chip">${i ? '<span class="grp-chip-then">then</span>' : ''}${esc(c)}<button type="button" class="grp-chip-x" data-i="${i}" title="Remove this level">✕</button></span>`).join('');
  menu.innerHTML = `<div class="grp-menu-head">${chain.length ? chips : '<span class="grp-menu-empty">No grouping - pick a column</span>'}</div>`
    + `<select class="grp-menu-select"><option value="">${chain.length ? 'then by…' : 'Group by…'}</option>${rest.map(c => `<option>${esc(c)}</option>`).join('')}</select>`
    + (chain.length ? `<button type="button" class="btn grp-menu-clear">Clear grouping</button>` : '');
  menu.querySelector('.grp-menu-select').onchange = (e) => { if (e.target.value) { setGroupByChain(sec, chain.concat([e.target.value])); menu.remove(); } };
  menu.querySelectorAll('.grp-chip-x').forEach(b => { b.onclick = () => { const c = chain.slice(); c.splice(+b.dataset.i, 1); setGroupByChain(sec, c); menu.remove(); }; });
  const clr = menu.querySelector('.grp-menu-clear'); if (clr) clr.onclick = () => { setGroupByChain(sec, []); menu.remove(); };
  const r = btn.getBoundingClientRect();
  menu.style.top = (r.bottom + window.scrollY + 4) + 'px'; menu.style.left = (r.left + window.scrollX) + 'px';
  document.body.appendChild(menu);
  setTimeout(() => document.addEventListener('mousedown', function off(e) { if (!menu.contains(e.target) && e.target !== btn) { menu.remove(); document.removeEventListener('mousedown', off); } }), 0);
}

;
// ==== FILE: js/ui.js ====

function esc(s) { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; }


// Wrap any http(s) URLs in already-HTML-escaped text with a compact "pill"
// <a class="url-pill"> tag. The visible label is the URL's domain (e.g.
// "webshare.io") so long URLs don't clutter the cell. The full URL lives in
// `href`, `data-url`, and `title` so:
//   • hover → browser tooltip shows the actual URL
//   • Ctrl/Cmd+click → opens in new tab (target="_blank")
//   • right-click → "Copy link address" gives the real URL
//   • focusing the cell expands the pill back to the full URL so the user
//     can edit it (see the focusin handler below)
function linkifyUrls(escapedHtml) {
  if (!escapedHtml) return escapedHtml;
  return escapedHtml.replace(
    /https?:\/\/[^\s<>"'`]*[^\s<>"'`.,;:!?)\]]/g,
    (m) => {
      const label = urlLabel(m);
      return `<a class="url-pill" href="${m}" data-url="${m}" target="_blank" rel="noopener noreferrer" tabindex="-1" title="${m}\nClick to open · right-click to copy">${label}</a>`;
    }
  );
}

// Compact label for a URL: prefer the hostname (sans leading "www."). Falls
// back to "link" if the URL is unparseable (rare for an http(s) match).
function urlLabel(url) {
  try {
    const host = new URL(url).hostname.replace(/^www\./, '');
    return host || 'link';
  } catch (_) { return 'link'; }
}

// Expand all <a class="url-pill"> inside a container back to their raw URL
// text. Called when an editable container (cell or notes editor) is focused,
// so the user can read / edit the actual URL — not the shortened label.
function expandUrlPills(container) {
  if (!container) return;
  container.querySelectorAll('a.url-pill').forEach(a => {
    const url = a.dataset.url || a.getAttribute('href') || a.textContent;
    a.replaceWith(document.createTextNode(url));
  });
}


// Global focus router: when an editable cell or notes-box gets focus from
// anywhere (click on text, Tab from another cell, click on the link itself),
// expand any URL pills inside it so editing reveals the full URL string. On
// blur the cell's own re-render (see onEdit / notes onblur) collapses them.
document.addEventListener('focusin', (e) => {
  const tgt = e.target;
  if (!tgt || !tgt.closest) return;

  // (A) A cell inside a NOTES markdown table → expand the pills in just THAT
  // table block while it's being edited. Leaving the table re-collapses them
  // (focusout handler below), so the compact URL preview returns the moment you
  // click out of the table — even while still inside the same notes box. Scoping
  // to the block (not the whole editor) is what keeps table pills as previews
  // while you edit free text around them.
  const notesCell = tgt.closest(
    '.md-table-block th[contenteditable="true"], .md-table-block td[contenteditable="true"]'
  );
  if (notesCell) {
    // Expand URL pills in ONLY the focused cell — NOT the whole block. Expanding
    // the whole block also widens off-screen LEFT columns, which shifts content
    // rightward and yanks a right-scrolled wide table back to the left (so you
    // couldn't even click a right-side cell). Per-cell keeps every other column's
    // width unchanged, so the clicked cell stays exactly where it is.
    expandUrlPills(notesCell);
    // Safety net for the browser's native focus-scroll on a contenteditable cell:
    // re-assert the table's horizontal scroll for a couple of frames so clicking a
    // right-side cell stays put rather than snapping to the left.
    const scroller = notesCell.closest('.md-table-scroll');
    if (scroller) {
      const sl = scroller.scrollLeft, st = scroller.scrollTop;
      // Re-assert the scroll across the next few frames (~80ms) to outlast the
      // browser's focus/caret scroll, then stop so genuine scrolling still works.
      let n = 0;
      const pin = () => {
        if (scroller.scrollLeft !== sl) scroller.scrollLeft = sl;
        if (scroller.scrollTop !== st) scroller.scrollTop = st;
        if (++n < 5) requestAnimationFrame(pin);
      };
      pin();
    }
    return;
  }

  const t = tgt.closest('.cell[contenteditable="true"], .notes-editor[contenteditable="true"]');
  if (!t) return;

  // (B) Free text in a notes box → expand its pills, but NOT the ones inside
  // table blocks (those are managed per-table by (A)/focusout, so they keep
  // showing the preview while you type around them).
  if (t.matches('.notes-editor[contenteditable="true"]')) {
    t.querySelectorAll('a.url-pill').forEach(a => {
      if (a.closest('.md-table-block')) return;
      const url = a.dataset.url || a.getAttribute('href') || a.textContent;
      a.replaceWith(document.createTextNode(url));
    });
    return;
  }

  // (C) A data-table cell (the main grid) — unchanged: expand pills, and swap a
  // rendered Markdown grid back to its raw source so the user edits the source;
  // innerText round-trips on blur/save. The stored raw Markdown is the value.
  expandUrlPills(t);
  if (t.matches('.cell[contenteditable="true"]') && t.querySelector('table.cell-md-table')) {
    const sec = (typeof SECTIONS !== 'undefined') && SECTIONS[activeSection];
    const ri = +t.dataset.ri, ci = +t.dataset.ci;
    if (sec && sec.rows[ri] != null && sec.rows[ri][ci] != null) t.textContent = sec.rows[ri][ci];
  }
  // Mermaid blocks and markdown tables in NOTES intentionally NOT auto-expanded
  // on focusin — clicking the scrollbar or padding shouldn't collapse a
  // rendered diagram. Those block types have a per-block "⋮ source" button
  // as the explicit way to drop into raw-source editing.
});

// Collapse a NOTES table's URL pills back to the compact preview as soon as
// focus leaves the table — to free text in the same box, another box, or out of
// the page entirely. This is what makes the preview return when you click OUTSIDE
// the table without needing a full notes-box blur. If focus merely moved to
// another cell of the SAME table, leave it expanded (you're still editing it).
// Cosmetic only: the table's data-source (not the live cells) is what gets saved.
document.addEventListener('focusout', (e) => {
  const block = e.target && e.target.closest && e.target.closest('.md-table-block');
  if (!block) return;
  // Resolve the destination AFTER focus settles, not from e.relatedTarget — that
  // field is unreliable on click-driven focus moves (null in some browsers /
  // focus sequences), which would wrongly collapse a cell you just left while
  // still editing the same table. On the next frame document.activeElement is
  // authoritative: only collapse if focus has genuinely left this table block.
  requestAnimationFrame(() => {
    if (block.contains(document.activeElement)) return;   // still inside this table
    if (typeof collapseNotesTablePills === 'function') collapseNotesTablePills(block);
  });
});


// Global click router for inline links inside cells / notes editor.
//   Plain click → cancel navigation; let contenteditable focus for editing.
//   Ctrl/Cmd+click or middle-click → let the browser open in new tab.
document.addEventListener('click', (e) => {
  const a = e.target && e.target.closest && e.target.closest('.cell a[href], .notes-editor a[href]');
  if (!a) return;
  if (e.ctrlKey || e.metaKey || e.button === 1) return; // open
  e.preventDefault(); // edit
});

// URL-pill open / copy — handled at MOUSEDOWN (capture), BEFORE focus moves into
// the cell. This matters because focusing a cell/line expands its pills back to
// raw editable URL text (see the focusin handler), which would destroy the <a>
// element a click or right-click needs. A pill only exists while the cell is NOT
// being edited (the compact preview), so intercepting it here means:
//   • left-click  → open the URL in a new tab (don't steal focus / expand)
//   • right-click → copy the URL to the clipboard (+ toast)
// To EDIT a URL instead, click elsewhere in the cell (or Tab in) to focus it —
// that expands the pills to full editable text as before.
function _pillFrom(e) {
  return e && e.target && e.target.closest ? e.target.closest('a.url-pill') : null;
}
document.addEventListener('mousedown', (e) => {
  const pill = _pillFrom(e);
  if (!pill) return;
  if (e.button === 2) {
    // right-click → copy
    e.preventDefault();
    const url = pill.dataset.url || pill.getAttribute('href') || pill.textContent;
    if (url && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url)
        .then(() => { if (typeof showToast === 'function') showToast('✓ Link copied'); })
        .catch(() => { if (typeof showToast === 'function') showToast('⚠ Could not copy'); });
    }
    return;
  }
  if (e.button === 0 && !e.shiftKey) {
    // left-click (incl. Ctrl/Cmd) → open in a new tab
    e.preventDefault();
    const url = pill.dataset.url || pill.getAttribute('href');
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  }
}, true);
// We copy on the right-mousedown above, so suppress the native context menu on a
// pill (it would otherwise show on the expanded plain-text and lack "Copy link").
document.addEventListener('contextmenu', (e) => {
  if (_pillFrom(e)) e.preventDefault();
}, true);


// ── Right-click "Copy name / Rename" menu for labels ─────────────────────────
// One shared menu (showLabelMenu) used from all three label types via a single
// delegated contextmenu listener: subject tabs (.tab), chapter/notes-epic tabs
// (.subtab.notes-epic), and outline box-titles (.outline-part-header). Copy uses
// the clipboard and never claims success on empty (like the notes 409 Copy). Rename
// reuses each level's EXISTING rename path - section=prompt (renameSection), chapter
// =inline pill edit (enterNotesRenameMode), outline=box-content H1 save
// (renameNotesBox) - so persistence + autosave + the version-guard all apply; no
// side path. The labels keep user-select:none; this menu's Copy is the copy path.
let _labelMenuEl = null;
function ensureLabelMenuStyles() {
  if (document.getElementById('label-ctx-styles')) return;
  const css =
    '.label-ctx-menu{position:fixed;z-index:9700;min-width:150px;display:flex;flex-direction:column;padding:4px;background:var(--c-fill-50,#faf8f4);border:1px solid var(--c-line-200,#e3ddd2);border-radius:8px;box-shadow:0 6px 20px rgba(0,0,0,.16);font-size:.85rem}' +
    '.label-ctx-item{font:inherit;font-size:.85rem;text-align:left;white-space:nowrap;padding:.34rem .6rem;border:none;border-radius:6px;background:transparent;color:var(--c-ink-700,#3b3630);cursor:pointer}' +
    '.label-ctx-item:hover,.label-ctx-item:focus{background:var(--c-fill-150,#efe9df);outline:none}';
  const st = document.createElement('style'); st.id = 'label-ctx-styles'; st.textContent = css;
  document.head.appendChild(st);
}
function closeLabelMenu() {
  if (_labelMenuEl) { _labelMenuEl.remove(); _labelMenuEl = null; }
  document.removeEventListener('mousedown', _labelMenuOutside, true);
  document.removeEventListener('keydown', _labelMenuKey, true);
  window.removeEventListener('scroll', closeLabelMenu, true);
  window.removeEventListener('resize', closeLabelMenu);
}
function _labelMenuOutside(e) { if (_labelMenuEl && !(e.target.closest && e.target.closest('.label-ctx-menu'))) closeLabelMenu(); }
function _labelMenuKey(e) {
  if (!_labelMenuEl) return;
  const btns = Array.prototype.slice.call(_labelMenuEl.querySelectorAll('.label-ctx-item'));
  const i = btns.indexOf(document.activeElement);
  if (e.key === 'Escape') { e.preventDefault(); closeLabelMenu(); }
  else if (e.key === 'ArrowDown') { e.preventDefault(); (btns[(i + 1) % btns.length] || btns[0]).focus(); }
  else if (e.key === 'ArrowUp') { e.preventDefault(); (btns[(i - 1 + btns.length) % btns.length] || btns[0]).focus(); }
}
// items: [{ label, action }]. Positioned at the cursor (x,y), clamped to the
// viewport; dismissed on outside-click / Esc / scroll / resize; keyboard-navigable.
function showLabelMenu(x, y, items) {
  closeLabelMenu();
  ensureLabelMenuStyles();
  const menu = document.createElement('div');
  menu.className = 'label-ctx-menu';
  menu.setAttribute('role', 'menu');
  items.forEach(it => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'label-ctx-item'; b.setAttribute('role', 'menuitem');
    b.textContent = it.label;   // label text only - never innerHTML of user data
    b.addEventListener('click', () => { closeLabelMenu(); it.action(); });
    menu.appendChild(b);
  });
  document.body.appendChild(menu);
  _labelMenuEl = menu;
  const r = menu.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
  menu.style.left = Math.max(6, Math.min(x, vw - r.width - 6)) + 'px';
  menu.style.top = Math.max(6, Math.min(y, vh - r.height - 6)) + 'px';
  const first = menu.querySelector('.label-ctx-item'); if (first) first.focus();
  document.addEventListener('mousedown', _labelMenuOutside, true);
  document.addEventListener('keydown', _labelMenuKey, true);
  window.addEventListener('scroll', closeLabelMenu, true);
  window.addEventListener('resize', closeLabelMenu);
}
// Copy a plain label name to the clipboard. Never claims success on empty.
function copyLabelName(text) {
  const t = (text == null ? '' : String(text)).trim();
  if (!t) { if (typeof showToast === 'function') showToast('⚠ Nothing to copy'); return; }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(t)
      .then(() => { if (typeof showToast === 'function') showToast('✓ Name copied'); })
      .catch(() => { if (typeof showToast === 'function') showToast('⚠ Could not copy'); });
  } else if (typeof showToast === 'function') showToast('⚠ Clipboard unavailable');
}
// Small bottom-right "busy" pill shown while a copy/paste (or other slow op) is in
// flight - a big subject can take a moment, and without this it looks like nothing
// happened. Appears only if the op runs past a short threshold, so fast ops don't
// flash a spinner. One pill at a time (copy/paste are never concurrent here).
let _busyEl = null, _busyShowTimer = null;
function showBusy(msg) {
  hideBusy();
  _busyShowTimer = setTimeout(() => {
    _busyShowTimer = null;
    const el = document.createElement('div');
    el.className = 'tt-busy';
    const spin = document.createElement('span'); spin.className = 'tt-busy-spin'; spin.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span'); label.className = 'tt-busy-label'; label.textContent = msg;   // textContent - no user-data injection
    el.appendChild(spin); el.appendChild(label);
    document.body.appendChild(el);
    void el.offsetWidth;          // reflow so the slide-in transition runs
    el.classList.add('show');
    _busyEl = el;
  }, 180);
}
function hideBusy() {
  if (_busyShowTimer) { clearTimeout(_busyShowTimer); _busyShowTimer = null; }
  if (_busyEl) {
    const el = _busyEl; _busyEl = null;
    el.classList.remove('show');
    setTimeout(() => { if (el && el.parentNode) el.parentNode.removeChild(el); }, 220);
  }
}
// ── Copy / Cut / Paste (chapter · box · subject) ──────────────────────────────
// The store half is cloud-store/copy-paste.js (the clipboards, the deep copy, a cut's
// source removal after the paste commits). This half drives it from the right-click
// menus, keeps the in-memory SECTIONS in step, and speaks through the dashboard's one
// toast (libToast - the Export PDF / Import toast), not the table's small one.
function _cpToast(msg, kind, stay) {
  window.__ttLibrary.toast(msg, kind, { owner: 'copy-paste', stay: stay || 4600 });
}
function _cpFail(e, verb) { _cpToast((e && e.message) || (verb + ' failed'), 'err', 8000); }
const _cpSecByFile = (file) => Object.values(SECTIONS).find(s => s && s.file === file) || null;
// A cut's source left the store with the paste; the section that held it (when it is
// one of this book's) drops it in memory too, so a later meta save cannot put it back
// (_deletedBoxIds / _deletedEpicIds are the merge's exclusion lists, notes-persistence.js).
function _cpSyncMovedBox(moved) {
  _deletedBoxIds.add(String(moved.epicId) + ' ' + String(moved.boxId));
  delete _boxImages[moved.boxId];
  const src = _cpSecByFile(moved.sectionFile);
  const epic = src && (src.notesEpics || []).find(n => n.id === moved.epicId);
  if (!epic || !Array.isArray(epic.boxes)) return;
  const i = epic.boxes.findIndex(b => b.id === moved.boxId);
  if (i >= 0) epic.boxes.splice(i, 1);
}
function _cpSyncMovedChapter(moved) {
  _deletedEpicIds.add(String(moved.epicId));
  const src = _cpSecByFile(moved.sectionFile);
  if (!src) return;
  const i = (src.notesEpics || []).findIndex(n => n.id === moved.epicId);
  if (i >= 0) src.notesEpics.splice(i, 1);
  if (Array.isArray(src.subtabOrder)) src.subtabOrder = src.subtabOrder.filter(k => k !== subtabKeyOfNotes(moved.epicId));
  if (src.activeNotesEpic === moved.epicId) {   // the moved chapter was the one open in its section: that section lands on its pill next time
    src.activeNotesEpic = null;
    src.activeSubtab = resolveLandingSubtab(src, src.activeSubtab);
  }
}
// Copy (or cut) a whole chapter into the in-session clipboard (reads via cloud-store).
async function _copyChapterFrom(epicId, cut) {
  const sec = SECTIONS[activeSection];
  const noun = LBL('epicNoun').toLowerCase();
  showBusy((cut ? 'Cutting ' : 'Copying ') + noun + '...');
  try {
    if (typeof flushPendingNotesSaves === 'function') await flushPendingNotesSaves(activeSection);   // persist just-made edits (roadmap move / typing) before the copy reads the cloud
    const r = cut ? await window.__ttCloud.cutNotesChapter(sec.file, epicId) : await window.__ttCloud.copyNotesChapter(sec.file, epicId);
    _cpToast(LBL('epicNoun') + (cut ? ' cut: "' : ' copied: "') + r.name + '"', 'ok', 6000);
  } catch (e) { _cpFail(e, cut ? 'Cut' : 'Copy'); }
  finally { hideBusy(); }
}
// Paste the clipboard chapter as a NEW chapter in the currently-open subject: cloud-
// store duplicates it (fresh ids + own media + scene docs; a cut then removes its
// source), then reload meta + open the copy.
async function _pasteChapterHere() {
  const sec = SECTIONS[activeSection];
  showBusy('Pasting ' + LBL('epicNoun').toLowerCase() + '...');
  try {
    const res = await window.__ttCloud.pasteNotesChapter(sec.file);
    if (res.moved) _cpSyncMovedChapter(res.moved);
    await loadNotesMeta(sec);
    subtabOrderInsertAtEnd(sec, subtabKeyOfNotes(res.id));
    renderSubtabs();
    await openEpic(res.id);
    _cpToast(LBL('epicNoun') + (res.moved ? ' moved: "' : ' pasted: "') + res.name + '"', 'ok');
  } catch (e) { _cpFail(e, 'Paste'); }
  finally { hideBusy(); }
}
// Copy (or cut) one box (its whole content + display attrs) from the currently-open
// chapter into the in-session clipboard (reads via cloud-store).
async function _copyBoxFrom(boxId, cut) {
  const sec = SECTIONS[activeSection];
  const noun = LBL('boxNoun').toLowerCase();
  if (cut && _refuseIfBoxLocked(sec, sec.activeNotesEpic, boxId)) return;   // L7: someone else is in it - not movable from under them
  showBusy((cut ? 'Cutting ' : 'Copying ') + noun + '...');
  try {
    if (typeof flushPendingNotesSaves === 'function') await flushPendingNotesSaves(activeSection);   // persist just-made edits before the copy reads the cloud
    const r = cut ? await window.__ttCloud.cutNotesBox(sec.file, sec.activeNotesEpic, boxId) : await window.__ttCloud.copyNotesBox(sec.file, sec.activeNotesEpic, boxId);
    _cpToast(LBL('boxNoun') + (cut ? ' cut: "' : ' copied: "') + r.title + '"', 'ok', 6000);
  } catch (e) { _cpFail(e, cut ? 'Cut' : 'Copy'); }
  finally { hideBusy(); }
}
// Paste the clipboard box as a NEW box in the CURRENTLY-open chapter (which may differ
// from the source): cloud-store duplicates it (fresh id + own media + scene docs; a cut
// then removes its source), then reload meta + re-render the box grid / toolbar /
// roadmap / outline.
async function _pasteBoxHere() {
  const sec = SECTIONS[activeSection];
  showBusy('Pasting ' + LBL('boxNoun').toLowerCase() + '...');
  try {
    const res = await window.__ttCloud.pasteNotesBox(sec.file, sec.activeNotesEpic);
    if (res.moved) _cpSyncMovedBox(res.moved);
    await loadNotesMeta(sec);
    await renderNotesBoxes();
    renderNotesToolbar();
    renderNotesRoadmap();
    renderNotesOutline();
    _cpToast(LBL('boxNoun') + (res.moved ? ' moved: "' : ' pasted: "') + res.title + '"', 'ok');
  } catch (e) { _cpFail(e, 'Paste'); }
  finally { hideBusy(); }
}
// Copy a whole subject (the CSV table + every chapter) into the in-session clipboard.
async function _copySubjectFrom(key) {
  const sec = SECTIONS[key];
  if (!sec) return;
  showBusy('Copying ' + LBL('tabNoun').toLowerCase() + '...');
  try {
    if (typeof flushPendingNotesSaves === 'function') await flushPendingNotesSaves(key);   // flush ONLY if this is the active section (copying a non-active tab must not write it)
    const r = await window.__ttCloud.copyNotesSubject(sec.file);
    _cpToast(LBL('tabNoun') + ' copied: "' + r.title + '" (' + r.chapters + ' ' + LBL('epicNoun').toLowerCase() + 's)', 'ok', 6000);
  } catch (e) { _cpFail(e, 'Copy'); }
  finally { hideBusy(); }
}
// Paste the copied subject as a NEW tab: cloud-store already persisted the table +
// every chapter (fresh ids + own media) AND the sections.json entry, so mirror
// addSection - register the tab in memory (no full reconcile, which would drop every
// other tab's loaded rows), re-render the strip, and switch (switchTab loads its
// CSV + notes from disk).
async function _pasteSubjectHere() {
  showBusy('Pasting ' + LBL('tabNoun').toLowerCase() + '...');
  try {
    const res = await window.__ttCloud.pasteNotesSubject();
    SECTIONS[res.key] = _plainSection({ key: res.key, title: res.title, file: res.file, flat: res.flat });   // sections.js: the same shape a persisted entry loads as
    renderTabs();
    await switchTab(res.key);
    _cpToast(LBL('tabNoun') + ' pasted: "' + res.title + '"', 'ok');
  } catch (e) { _cpFail(e, 'Paste'); }
  finally { hideBusy(); }
}

// Delegated right-click on the label types -> the shared menu. Native contextmenu is
// suppressed ONLY on these labels. CHAPTER tabs get whole-chapter Copy/Paste (Paste
// only when something is on the clipboard); subject tabs + outline box-titles get
// Rename for now. Edit-only actions are hidden in read-only.
document.addEventListener('contextmenu', (e) => {
  const t = e.target;
  if (!t || !t.closest) return;
  const editable = !(document.body && document.body.classList.contains('tt-readonly'));
  const cloud = (typeof window !== 'undefined') ? window.__ttCloud : null;

  const chapTab = t.closest('.subtab.notes-epic[data-note-id]');
  if (chapTab) {
    const id = chapTab.dataset.noteId;
    // A SHARED (read-only) chapter isn't theirs to Copy / Cut / Paste / Rename: no menu at all. ("Hide from my
    // space" used to be its one action; the feature is not offered for now - Rishabh 2026-10-13 - the
    // _hideSharedChapter function stays, no menu names it.)
    const _sec = (typeof SECTIONS !== 'undefined') ? SECTIONS[activeSection] : null;
    const _ep = _sec && (_sec.notesEpics || []).find(n => n.id === id);
    if (_ep && _ep._sharedVirtual) return;
    const items = [];
    // Copy / Cut only where the view is editable: a read-only view's chapters are virtual (no store doc of
    // their own), so a copy there could only say "Chapter not found" (his srview screenshot, 2026-10-13).
    if (editable && cloud && typeof cloud.copyNotesChapter === 'function') items.push({ label: 'Copy ' + LBL('epicNoun').toLowerCase(), action: () => _copyChapterFrom(id, false) });
    if (editable && cloud && typeof cloud.cutNotesChapter === 'function') items.push({ label: 'Cut ' + LBL('epicNoun').toLowerCase(), action: () => _copyChapterFrom(id, true) });
    if (editable && cloud && typeof cloud.hasChapterClipboard === 'function' && cloud.hasChapterClipboard()) items.push({ label: 'Paste ' + LBL('epicNoun').toLowerCase(), action: () => _pasteChapterHere() });
    if (editable && typeof enterNotesRenameMode === 'function') items.push({ label: 'Rename', action: () => enterNotesRenameMode(id) });
    // No Roadmap entry here: the section's board (every chapter's cards) has no pill and no menu item (Rishabh
    // 2026-10-27: "not needed there"); a chapter's layout-bar Roadmap button with scope "All" shows it.
    e.preventDefault(); showLabelMenu(e.clientX, e.clientY, items); return;
  }
  // Empty area of the chapter (subtabs) strip - the whole row, incl. right of
  // "+ Add Notes" - offers Paste chapter, so you can paste without targeting a pill.
  if (t.closest('#subtabs')) {
    if (editable && cloud && typeof cloud.hasChapterClipboard === 'function' && cloud.hasChapterClipboard()) {
      e.preventDefault(); showLabelMenu(e.clientX, e.clientY, [{ label: 'Paste ' + LBL('epicNoun').toLowerCase(), action: () => _pasteChapterHere() }]); return;
    }
    return;   // nothing on the clipboard -> no menu (leave the native one)
  }
  const secTab = t.closest('.tab[data-section-key]');
  if (secTab) {
    const key = secTab.dataset.sectionKey;
    // A SHARED (read-only) subject: no menu (its "Hide from my space" is not offered for now; _hideSharedSubject stays).
    const _s = (typeof SECTIONS !== 'undefined') ? SECTIONS[key] : null;
    if (_s && _s._sharedVirtual) return;
    const items = [];
    if (editable && cloud && typeof cloud.copyNotesSubject === 'function') items.push({ label: 'Copy ' + LBL('tabNoun').toLowerCase(), action: () => _copySubjectFrom(key) });
    if (editable && cloud && typeof cloud.hasSubjectClipboard === 'function' && cloud.hasSubjectClipboard()) items.push({ label: 'Paste ' + LBL('tabNoun').toLowerCase(), action: () => _pasteSubjectHere() });
    if (editable && typeof renameSection === 'function') items.push({ label: 'Rename', action: () => renameSection(key) });
    if (!items.length) return;
    e.preventDefault(); showLabelMenu(e.clientX, e.clientY, items); return;
  }
  // Empty area of the tab strip (#tabs, incl. right of "+ Add Tab", not on a tab)
  // -> Paste subject, so you can paste without targeting a specific tab.
  if (t.closest('#tabs') && !t.closest('.tab')) {
    if (editable && cloud && typeof cloud.hasSubjectClipboard === 'function' && cloud.hasSubjectClipboard()) {
      e.preventDefault(); showLabelMenu(e.clientX, e.clientY, [{ label: 'Paste ' + LBL('tabNoun').toLowerCase(), action: () => _pasteSubjectHere() }]); return;
    }
    return;   // nothing on the clipboard -> no menu (leave the native one)
  }
  // An outline row names its box: the part header of a multi-box chapter, or any heading row (the only rows a
  // one-box chapter shows). Copy / Cut / Paste act on THAT box; Rename is the part header's own.
  const outItem = t.closest('.outline-part-header[data-box-id], .outline-item[data-box-id]');
  if (outItem) {
    const boxId = outItem.dataset.boxId;
    const items = [];
    if (editable && cloud && typeof cloud.copyNotesBox === 'function') items.push({ label: 'Copy ' + LBL('boxNoun').toLowerCase(), action: () => _copyBoxFrom(boxId, false) });
    if (editable && cloud && typeof cloud.cutNotesBox === 'function') items.push({ label: 'Cut ' + LBL('boxNoun').toLowerCase(), action: () => _copyBoxFrom(boxId, true) });
    if (editable && cloud && typeof cloud.hasBoxClipboard === 'function' && cloud.hasBoxClipboard()) items.push({ label: 'Paste ' + LBL('boxNoun').toLowerCase(), action: () => _pasteBoxHere() });
    if (editable && outItem.classList.contains('outline-part-header') && typeof renameNotesBox === 'function') items.push({ label: 'Rename', action: () => renameNotesBox(boxId) });
    if (!items.length) return;
    e.preventDefault(); showLabelMenu(e.clientX, e.clientY, items); return;
  }
  // Empty area of the outline sidebar (#parentTaskTabs while it shows the outline -
  // i.e. contains .outline-all - but NOT on an outline row) -> Paste box, since the
  // outline IS the current chapter's box list. Same target as the empty box grid.
  const outlineHost = t.closest('#parentTaskTabs');
  if (outlineHost && outlineHost.querySelector('.outline-all')
      && !t.closest('.outline-part-header') && !t.closest('.outline-item')
      && !t.closest('.outline-all') && !t.closest('.outline-rail')) {
    const sec = SECTIONS[activeSection];
    if (editable && cloud && typeof cloud.hasBoxClipboard === 'function' && cloud.hasBoxClipboard() && sec && sec.activeNotesEpic) {
      e.preventDefault(); showLabelMenu(e.clientX, e.clientY, [{ label: 'Paste ' + LBL('boxNoun').toLowerCase(), action: () => _pasteBoxHere() }]); return;
    }
    return;   // nothing on the clipboard -> no menu (leave the native one)
  }
  // Empty area of the notes-box grid (NOT on a box - a box has a contenteditable
  // that keeps its native menu) -> Paste box into the currently-open chapter.
  if (t.closest('#notesBoxes') && !t.closest('.notes-box')) {
    const sec = SECTIONS[activeSection];
    if (editable && cloud && typeof cloud.hasBoxClipboard === 'function' && cloud.hasBoxClipboard() && sec && sec.activeNotesEpic) {
      e.preventDefault(); showLabelMenu(e.clientX, e.clientY, [{ label: 'Paste ' + LBL('boxNoun').toLowerCase(), action: () => _pasteBoxHere() }]); return;
    }
    return;   // nothing on the clipboard -> no menu (leave the native one)
  }
}, true);


function showToast(msg) {
  const t = document.getElementById('toast');
  t.textContent = msg;
  t.classList.add('show');
  if (t._hide) clearTimeout(t._hide);   // a toast still showing restarts its clock
  t._hide = setTimeout(() => t.classList.remove('show'), 1500);
}

// Professional replacement for the native confirm(): a styled modal that reuses the
// app's .tl-modal look (same as _nrPromptModal) and resolves to true (confirmed) or
// false (Cancel / Esc / overlay click). opts: { title, message, okLabel, cancelLabel,
// danger }. Title/message use textContent - never innerHTML of user data (no XSS).
let _confirmModalCancel = null;
function showConfirmModal(opts) {
  opts = opts || {};
  return new Promise(resolve => {
    if (_confirmModalCancel) _confirmModalCancel();   // a prior modal is still open -> cancel it first
    const overlay = document.createElement('div');
    overlay.className = 'tl-modal-overlay';
    const modal = document.createElement('div');
    modal.className = 'tl-modal'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    const head = document.createElement('div'); head.className = 'tl-modal-head'; head.textContent = opts.title || 'Are you sure?';
    const actions = document.createElement('div'); actions.className = 'tl-modal-actions';
    const cancelBtn = document.createElement('button'); cancelBtn.type = 'button'; cancelBtn.className = 'btn-small cm-cancel'; cancelBtn.textContent = opts.cancelLabel || 'Cancel';
    const okBtn = document.createElement('button'); okBtn.type = 'button'; okBtn.className = 'btn-small cm-ok' + (opts.danger ? ' btn-danger-modal' : ''); okBtn.textContent = opts.okLabel || 'OK';
    actions.appendChild(cancelBtn); actions.appendChild(okBtn);
    modal.appendChild(head);
    if (opts.message) { const msg = document.createElement('div'); msg.className = 'tl-modal-msg'; msg.textContent = opts.message; modal.appendChild(msg); }
    modal.appendChild(actions);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    let done = false;
    const close = (val) => {
      if (done) return; done = true;                 // resolve exactly once
      if (_confirmModalCancel === cancel) _confirmModalCancel = null;
      document.removeEventListener('keydown', onKey, true);
      overlay.remove();
      resolve(val);
    };
    const cancel = () => close(false);
    _confirmModalCancel = cancel;
    const onKey = (e) => {
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); close(true); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); cancel(); }
    };
    okBtn.onclick = () => close(true);
    cancelBtn.onclick = cancel;
    overlay.addEventListener('mousedown', (e) => { if (e.target === overlay) cancel(); });   // click outside = cancel
    document.addEventListener('keydown', onKey, true);
    setTimeout(() => okBtn.focus(), 0);
  });
}

// Professional replacement for the native prompt(): a styled modal (same .tl-modal
// look) with a single text field. Resolves to the entered string, or null on Cancel /
// Esc / overlay click. opts: { title, label, value, placeholder, okLabel }. label +
// placeholder are display-only; value pre-fills + selects. All via textContent / value
// (no innerHTML of user data).
let _promptModalCancel = null;
function showPromptModal(opts) {
  opts = opts || {};
  return new Promise(resolve => {
    if (_promptModalCancel) _promptModalCancel();
    const overlay = document.createElement('div');
    overlay.className = 'tl-modal-overlay';
    const modal = document.createElement('div');
    modal.className = 'tl-modal'; modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    const head = document.createElement('div'); head.className = 'tl-modal-head'; head.textContent = opts.title || 'Enter a value';
    const field = document.createElement('label'); field.className = 'tl-field'; if (opts.label) field.textContent = opts.label;
    const input = document.createElement('input'); input.type = 'text'; input.className = 'nr-prompt-input'; input.spellcheck = true;
    input.placeholder = opts.placeholder || ''; input.value = opts.value != null ? String(opts.value) : '';
    field.appendChild(input);
    if (opts.hint) {   // help text under the input (rules, examples); pre-line, so a caller's line breaks stand
      const hint = document.createElement('div'); hint.className = 'prompt-hint'; hint.textContent = opts.hint;
      field.appendChild(hint);
    }
    const actions = document.createElement('div'); actions.className = 'tl-modal-actions';
    const cancelBtn = document.createElement('button'); cancelBtn.type = 'button'; cancelBtn.className = 'btn-small cm-cancel'; cancelBtn.textContent = opts.cancelLabel || 'Cancel';
    const okBtn = document.createElement('button'); okBtn.type = 'button'; okBtn.className = 'btn-small cm-ok'; okBtn.textContent = opts.okLabel || 'OK';
    actions.appendChild(cancelBtn); actions.appendChild(okBtn);
    modal.appendChild(head); modal.appendChild(field); modal.appendChild(actions);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    let done = false;
    const close = (val) => {
      if (done) return; done = true;
      if (_promptModalCancel === cancel) _promptModalCancel = null;
      document.removeEventListener('keydown', onKey, true);
      overlay.remove();
      resolve(val);
    };
    const cancel = () => close(null);
    _promptModalCancel = cancel;
    const onKey = (e) => {
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); close(input.value); }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); cancel(); }
    };
    okBtn.onclick = () => close(input.value);
    cancelBtn.onclick = cancel;
    overlay.addEventListener('mousedown', (e) => { if (e.target === overlay) cancel(); });
    document.addEventListener('keydown', onKey, true);
    setTimeout(() => { input.focus(); input.select(); }, 0);
  });
}


function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  // Release the blob URL after the click has been processed
  setTimeout(() => URL.revokeObjectURL(url), 100);
}


// ── Global keyboard shortcuts: Ctrl+Z = undo, Ctrl+Shift+Z = redo ──
// A TYPING target keeps the browser's own undo: a cell being edited (contenteditable) AND every plain field - an
// <input>, a <textarea>, a <select>. Before 2026-10-05 only contenteditable was excluded, so Ctrl+Z while typing in a
// rename box, a column name or a dialog field did not undo the typing - it silently stepped the TABLE's history back
// and saved (Rishabh via J). One rule here, for every field, not a guard per field.
function isTypingTarget(el) {
  if (!el || el.nodeType !== 1) return false;
  if (el.isContentEditable) return true;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}
document.addEventListener('keydown', (e) => {
  if (isTypingTarget(e.target)) return;
  // While the Excalidraw modal is open, it owns Ctrl+Z / Ctrl+Y (canvas undo).
  // The modal also stopPropagation()s keydown in the capture phase, but this
  // flag is belt-and-suspenders so the app's undo() can never mutate table /
  // notes state behind the modal (an Excalidraw canvas is NOT contentEditable,
  // so the guard above wouldn't catch it).
  if (window.__excalidrawModalOpen) return;
  const mod = e.ctrlKey || e.metaKey;
  if (!mod) return;
  const isZ = e.key === 'z' || e.key === 'Z', isY = e.key === 'y' || e.key === 'Y';
  if (!isZ && !isY) return;
  e.preventDefault();
  // A notes box the person last typed in, still on screen, owns the undo while nothing else has focus (a toolbar
  // click or a click on the page's blank area leaves focus on <body>): its own history, not the table view's
  // (Rishabh 2026-10-15: rows added from the toolbar, Ctrl+Z did nothing). notes-undo.js installs the hook.
  const notesHook = window.__ttNotesUndoHook;
  if (typeof notesHook === 'function' && notesHook((isY || e.shiftKey) ? 'redo' : 'undo')) return;
  if (isY || e.shiftKey) redo(); else undo();
});

// ── Outline keyboard: Ctrl/Cmd + C / X / V on a focused outline row = copy / cut / paste the BOX the row names ──
// The same three actions as the row's right-click menu (Rishabh 2026-10-16: "same for outline, with shortcuts"). A row
// is focused by its click (notes-outline.js) or by Tab; nothing happens while the focus is in a box's text.
document.addEventListener('keydown', (e) => {
  if (!(e.ctrlKey || e.metaKey) || e.altKey || e.shiftKey) return;
  const k = String(e.key || '').toLowerCase();
  if (k !== 'c' && k !== 'x' && k !== 'v') return;
  const a = document.activeElement;
  const row = a && a.closest ? a.closest('.outline-part-header[data-box-id], .outline-item[data-box-id]') : null;
  if (!row) return;
  if (document.body && document.body.classList.contains('tt-readonly')) return;
  const cloud = window.__ttCloud;
  if (!cloud) return;
  e.preventDefault();
  if (k === 'c') { if (typeof cloud.copyNotesBox === 'function') _copyBoxFrom(row.dataset.boxId, false); return; }
  if (k === 'x') { if (typeof cloud.cutNotesBox === 'function') _copyBoxFrom(row.dataset.boxId, true); return; }
  if (typeof cloud.hasBoxClipboard === 'function' && cloud.hasBoxClipboard()) _pasteBoxHere();
  else showToast('Nothing to paste - copy or cut a ' + LBL('boxNoun').toLowerCase() + ' first');
});

// ── Ctrl/Cmd+Shift+V → "paste as plain text" ────────────────────────────────
// The data table (onCellPaste) and notes tables auto-convert pasted tabular
// data into a Markdown table. This arms a one-shot flag so the very next paste
// is inserted as plain text instead — the standard "paste without formatting"
// escape hatch. Capture phase so it's seen regardless of focus; auto-disarms.
let _plainPasteArmed = false;
let _plainPasteTimer = null;
document.addEventListener('keydown', (e) => {
  if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'v' || e.key === 'V')) {
    _plainPasteArmed = true;
    if (_plainPasteTimer) clearTimeout(_plainPasteTimer);
    _plainPasteTimer = setTimeout(() => { _plainPasteArmed = false; }, 2000);
  }
}, true);
// Read-and-clear: a paste handler calls this to learn (once) whether the user
// asked for a plain-text paste.
window.consumePlainPaste = () => { const v = _plainPasteArmed; _plainPasteArmed = false; return v; };

;
// ==== FILE: js/excalidraw.js ====
// ───────────────────────────────────────────────────────────────────────────
// Excalidraw block type — hand-drawn diagrams inside notes-Epic boxes.
//
// Companion to the mermaid block type in notes.js. A diagram is stored as a
// ```excalidraw fenced code block whose body is the scene JSON (single-line,
// minified). notes.js handles the parse/serialize seams; THIS file handles:
//   • renderExcalidrawBlock — async static SVG preview (via exportToSvg) +
//     the ✎ edit / ⬇ png / ⛶ full buttons and the ☰ Copy / Cut / Delete menu.
//   • openExcalidrawModal — full interactive whiteboard canvas in a modal (our own
//     ☰ menu, a direct Laser button, Ctrl+drag pans while the laser is on).
//   • insertExcalidrawFenceAtCaret / insertExcalidrawBlock — put a whiteboard into a
//     box at the caret line (the ▦ button, and a paste of a copied whiteboard).
//
// LOADING MODEL — Excalidraw v0.18+ is ESM-only (no UMD). React/ReactDOM are
// resolved via the <script type="importmap"> in index.html; the library itself is
// SELF-HOSTED at /dist/vendor/excalidraw/ (scripts/build-excalidraw-vendor.mjs
// bundles the version package.json pins) and lazy-imported here on first use, so
// boxes WITHOUT a diagram pay nothing at startup. It must be same-origin: exportToSvg
// subsets the inlined fonts in a Web Worker built from the library's own chunk URL,
// and a Worker script from another origin (the old esm.sh copy) can never start.
// The static preview path (exportToSvg) needs only the Excalidraw library; only
// the interactive modal additionally pulls React + ReactDOM.
//
// SAFETY (see the recon notes that drove this):
//   • The modal mounts at document.body — NEVER inside .notes-editor — so the
//     global focusin/click routers in ui.js can't climb into a .notes-editor
//     ancestor while the canvas is focused.
//   • The modal traps keydown in the CAPTURE phase and sets
//     window.__excalidrawModalOpen so the app's global Ctrl+Z/Y (ui.js) can
//     never fire — Excalidraw owns its own canvas undo/redo while open.
//   • The block element can be replaced by an editor blur re-render the moment
//     the modal grabs focus (setEditorContent rebuilds every block from its
//     data-source). So we capture the scene + block index up front and re-find
//     the target block by index at save time.
// ───────────────────────────────────────────────────────────────────────────

// The library's own laser-pointer icon (its toolbar-laser dropdown item, 0.18.0), inlined so our header Laser button
// shows the same picture the user knows from the tools menu.
const _EXCALI_LASER_SVG = '<svg viewBox="0 0 20 20" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" transform="rotate(90 10 10)"><path clip-rule="evenodd" d="m9.644 13.69 7.774-7.773a2.357 2.357 0 0 0-3.334-3.334l-7.773 7.774L8 12l1.643 1.69Z"/><path d="m13.25 3.417 3.333 3.333M10 10l2-2M5 15l3-3M2.156 17.894l1-1M5.453 19.029l-.144-1.407M2.377 11.887l.866 1.118M8.354 17.273l-1.194-.758M.953 14.652l1.408.13"/></g></svg>';
// Built by scripts/build-excalidraw-vendor.mjs (its VENDOR_URL): the bundled library, its stylesheet and its fonts.
const _EXCALI_VENDOR = '/dist/vendor/excalidraw/';
const _EXCALI_JS = _EXCALI_VENDOR + 'index.js';
const _EXCALI_CSS = _EXCALI_VENDOR + 'index.css';
const _EXCALI_ASSETS = _EXCALI_VENDOR; // fonts/ fetched at runtime (EXCALIDRAW_ASSET_PATH)

let _excaliLibPromise = null;   // cached ExcalidrawLib namespace

// Rendered-SVG cache, keyed by the block's exact data-source (the scene JSON). A box is rebuilt from its
// markdown on every blur, on a tab-return reload and on a conflict reload, and each rebuild used to put every
// diagram back through "⏳ Rendering diagram…" + exportToSvg - Rishabh 2026-09-18: "excalidraw diagram firse
// load hone pe pehle loading aur phir image aate hai, jo flicker ban jaata hai bahot bada". The same source
// always exports to the same SVG, so the second render is a lookup: no library await, no placeholder frame.
// An edited diagram has a new source and renders once more. Bounded: the oldest entry goes past the cap.
const _excaliSvgCache = new Map();
const EXCALI_SVG_CACHE_MAX = 150;
function _excaliSvgRemember(src, html) {
  if (_excaliSvgCache.has(src)) _excaliSvgCache.delete(src);
  _excaliSvgCache.set(src, html);
  if (_excaliSvgCache.size > EXCALI_SVG_CACHE_MAX) _excaliSvgCache.delete(_excaliSvgCache.keys().next().value);
}
// Excalidraw 0.18 exportToSvg wraps every LABELLED line / arrow in a <mask> (a white rect minus the label's rect) with
// no maskUnits, so the mask's region defaults to the element's own bounding box (objectBoundingBox): a straight
// vertical / horizontal line is 0.3-1 px wide there and its 2 px stroke clips to a hairline or to nothing - the line
// shows in the editor (the canvas draws no masks) and vanishes in the read view and the PDF (Rishabh 2026-10-22/23,
// "especially with", the media links). The mask's only job is the label gap, so its region is the WHOLE picture.
function _excaliMaskWholePicture(svg) {
  const w = svg.getAttribute('width'), h = svg.getAttribute('height');
  for (const m of svg.querySelectorAll('mask')) {
    m.setAttribute('maskUnits', 'userSpaceOnUse');
    m.setAttribute('x', '0'); m.setAttribute('y', '0');
    m.setAttribute('width', w); m.setAttribute('height', h);
  }
  return svg;
}
let _excaliReactPromise = null; // cached [React, ReactDOMClient]
let _excaliAssetsInjected = false;

// Inject the Excalidraw CSS + asset-path config exactly once, lazily — so the
// initial page load fetches nothing of Excalidraw until a diagram is touched.
function _excaliInjectAssets() {
  if (_excaliAssetsInjected) return;
  _excaliAssetsInjected = true;
  if (typeof window.EXCALIDRAW_ASSET_PATH === 'undefined') {
    window.EXCALIDRAW_ASSET_PATH = _EXCALI_ASSETS;
  }
  if (!document.querySelector('link[data-excalidraw-css]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = _EXCALI_CSS;
    link.setAttribute('data-excalidraw-css', '');
    document.head.appendChild(link);
  }
}

// Lazy-load the Excalidraw library (Excalidraw component, exportToSvg, …).
// Cached: repeated previews/edits reuse one module instance (and thus one
// React instance once React is also loaded). import() of a URL works from this
// classic script; the path goes through a variable, so the precache walk
// (build-precache.mjs) leaves the 20 MB library out of the app shell.
function loadExcalidrawLib() {
  _excaliInjectAssets();
  if (!_excaliLibPromise) _excaliLibPromise = import(_EXCALI_JS);
  return _excaliLibPromise;
}

// Lazy-load React + ReactDOM client — only needed for the interactive modal,
// not for the static SVG preview. Bare specifiers resolve via the import map.
function loadExcalidrawReact() {
  if (!_excaliReactPromise) {
    _excaliReactPromise = Promise.all([import('react'), import('react-dom/client')]);
  }
  return _excaliReactPromise;
}

// HTML for the corner buttons every rendered block carries. One flex strip (not per-button absolute offsets), so a
// view that hides some of them (the shared read view hides edit / delete) keeps the rest packed together.
// Rishabh 2026-10-16: the strip is ✎ edit · ⬇ png · ⛶ full plus ONE ☰ menu (Copy / Cut / Delete) exactly like the
// table's; the "⋮ source" raw-JSON button is gone (a developer escape hatch nobody used).
function _excaliButtonsHtml() {
  return '<div class="excalidraw-actions">' +
         '<button class="excalidraw-edit-btn" type="button" title="Edit whiteboard" tabindex="-1">✎ edit</button>' +
         '<button class="excalidraw-dl-btn" type="button" title="Download whiteboard as PNG" tabindex="-1">⬇ png</button>' +
         '<button class="excalidraw-fs-btn" type="button" title="Fullscreen this whiteboard (Esc to exit)" tabindex="-1">⛶ full</button>' +
         '<button class="excalidraw-menu-btn" type="button" title="Whiteboard menu - copy, cut, delete" tabindex="-1">☰</button>' +
         '</div>';
}

// The fence this block is stored as - the SAME bytes the box's markdown carries (data-source is the scene JSON,
// single line). Copy puts it on the clipboard as text; a paste into any notes box re-renders it at the caret
// (notes-render.js onpaste -> insertExcalidrawFenceAtCaret). Outside the app it pastes as that text.
function _excaliFenceOf(block) {
  return '```excalidraw\n' + (block.dataset.source || '{"elements":[]}') + '\n```';
}
function copyExcalidrawBlock(block) {
  navigator.clipboard.writeText(_excaliFenceOf(block)).then(
    () => showToast('✓ Whiteboard copied'),
    (err) => showToast('⚠ Could not copy the whiteboard (' + ((err && err.message) || err) + ')'));
}
// Cut = Copy + remove, no confirm: the clipboard holds the whiteboard and the box's Ctrl+Z brings it back (the
// table's rule, Rishabh 2026-10-16).
function cutExcalidrawBlock(block) {
  const editor = block.closest('.notes-editor');
  navigator.clipboard.writeText(_excaliFenceOf(block)).then(
    () => { block.remove(); if (editor) editor.dispatchEvent(new Event('input', { bubbles: true })); showToast('✓ Whiteboard cut'); },
    (err) => showToast('⚠ Could not cut the whiteboard (' + ((err && err.message) || err) + ')'));
}
// The ☰ menu: the table menu's popover (notes-tables-menu.js openNotesPopMenu), the whiteboard's items.
function openExcalidrawMenu(e, block) {
  const readOnly = !!(document.body && document.body.classList.contains('tt-readonly'));
  const items = [{ label: 'Copy', fn: () => copyExcalidrawBlock(block) }];
  if (!readOnly) {
    items.push({ label: 'Cut', fn: () => cutExcalidrawBlock(block) });
    items.push({ label: 'Delete', fn: () => deleteExcalidrawBlock(block) });
  }
  openNotesPopMenu(e, items);
}

// FULLSCREEN one diagram (Rishabh 2026-10-12: "full screen just for the whiteboard", an add-on to the box-level ⛶).
// View only: the block's rendered SVG preview is CLONED into a body-level overlay and fitted to the viewport (the
// SVG carries exportToSvg's viewBox, so width/height 100% letterboxes it); nothing is written, the editor is not
// opened, the inline block is untouched. Esc, the ✕ or a click on the backdrop closes it. Lives at body level with
// a z-index above a fullscreened box (.tt-box-fs = 9000) and below the editor modal (10000), so it works from
// inside a box ⛶ too. Esc is taken in the CAPTURE phase and stopped there, so the box-level Esc (notes-render.js,
// bubble phase on document) does not also drop the box out of its own fullscreen.
function openExcalidrawFullscreen(block) {
  if (document.querySelector('.excalidraw-fs-backdrop')) return;
  const svg = block.querySelector(':scope > svg');
  if (!svg) { if (typeof showToast === 'function') showToast('⚠ Empty diagram — nothing to show'); return; }
  const backdrop = document.createElement('div');
  backdrop.className = 'excalidraw-fs-backdrop';
  backdrop.innerHTML =
    '<button class="excalidraw-fs-close" type="button" title="Exit fullscreen (Esc)">✕</button>' +
    '<div class="excalidraw-fs-stage"></div>';
  backdrop.querySelector('.excalidraw-fs-stage').appendChild(svg.cloneNode(true));
  const close = () => {
    document.removeEventListener('keydown', onKey, true);
    backdrop.remove();
  };
  const onKey = (e) => {
    if (e.key !== 'Escape') return;
    e.stopImmediatePropagation();
    e.preventDefault();
    close();
  };
  backdrop.addEventListener('click', (e) => {
    if (e.target.closest('svg')) return;   // a click on the drawing itself stays
    close();
  });
  document.addEventListener('keydown', onKey, true);
  document.body.appendChild(backdrop);
}

// Wire the corner buttons. mousedown (not click) + preventDefault so the editor
// doesn't focus into the block before we act on it (same reasoning as mermaid).
function _wireExcalidrawButtons(block) {
  const editBtn = block.querySelector('.excalidraw-edit-btn');
  if (editBtn) {
    editBtn.addEventListener('mousedown', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openExcalidrawModal(block);
    });
  }
  const menuBtn = block.querySelector('.excalidraw-menu-btn');
  if (menuBtn) menuBtn.addEventListener('mousedown', (e) => openExcalidrawMenu(e, block));   // mousedown: the caret stays put
  const dlBtn = block.querySelector('.excalidraw-dl-btn');
  if (dlBtn) {
    dlBtn.addEventListener('mousedown', (e) => {
      e.preventDefault();
      e.stopPropagation();
      downloadExcalidrawBlock(block);
    });
  }
  const fsBtn = block.querySelector('.excalidraw-fs-btn');
  if (fsBtn) {
    fsBtn.addEventListener('mousedown', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openExcalidrawFullscreen(block);
    });
  }
}

// Remove a diagram block from its box. An empty diagram deletes silently; one
// that actually has elements asks for confirmation first (notes deletions are
// not covered by the table's undo history). Removing the block element and
// dispatching 'input' lets the box's existing debounced autosave rewrite the
// .md file without the now-deleted ```excalidraw``` fence.
async function deleteExcalidrawBlock(block) {
  const editor = block.closest('.notes-editor');
  const src = block.dataset.source || '';
  let elementCount = 0;
  try {
    const s = src.trim() ? JSON.parse(src) : { elements: [] };
    elementCount = ((s && s.elements) || []).length;
  } catch (_) {
    elementCount = src.trim() ? 1 : 0; // unparseable but non-empty → treat as having content
  }
  if (elementCount > 0 && !(await showConfirmModal({ title: 'Delete diagram?', message: 'This diagram will be removed. This cannot be undone.', okLabel: 'Delete', danger: true }))) return;
  block.remove();
  if (editor) editor.dispatchEvent(new Event('input', { bubbles: true }));
  if (typeof showToast === 'function') showToast('✓ Diagram removed');
}

// Build a download filename for a diagram PNG — tied to the owning box + index.
function _excaliDownloadName(boxId, blockIndex) {
  const id = boxId || 'diagram';
  return 'whiteboard-' + id + (blockIndex >= 0 ? '-' + (blockIndex + 1) : '') + '.png';
}

// Save a Blob to the user's Downloads via a transient object URL.
function _triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}

// Export a block's scene to a PNG and trigger a browser download. Uses
// Excalidraw's exportToBlob; degrades with a toast if the lib / CDN fails.
async function downloadExcalidrawBlock(block) {
  const src = block.dataset.source || '';
  let scene;
  try { scene = src.trim() ? JSON.parse(src) : { elements: [] }; }
  catch (_) { if (typeof showToast === 'function') showToast('⚠ Invalid scene — cannot export'); return; }
  const elements = (scene && scene.elements) || [];
  if (!elements.length) { if (typeof showToast === 'function') showToast('⚠ Empty diagram — nothing to export'); return; }
  const editor = block.closest('.notes-editor');
  const boxId = (editor && editor.dataset.boxId) ? editor.dataset.boxId : 'diagram';
  const blocks = editor ? Array.from(editor.querySelectorAll('.excalidraw-block')) : [];
  const idx = blocks.indexOf(block);
  if (typeof showToast === 'function') showToast('⏳ Exporting PNG…');
  try {
    const Lib = await loadExcalidrawLib();
    if (typeof Lib.exportToBlob !== 'function') throw new Error('exportToBlob unavailable');
    let els = elements;
    try { if (typeof Lib.restoreElements === 'function') els = Lib.restoreElements(elements, null); } catch (_) {}
    const blob = await Lib.exportToBlob({
      elements: els,
      files: scene.files || null,
      mimeType: 'image/png',
      exportPadding: 16,
      appState: {
        exportBackground: true,
        viewBackgroundColor: (scene.appState && scene.appState.viewBackgroundColor) || '#ffffff',
        exportWithDarkMode: false,
        exportEmbedScene: false,
        exportScale: 2
      }
    });
    _triggerBlobDownload(blob, _excaliDownloadName(boxId, idx));
    if (typeof showToast === 'function') showToast('✓ Diagram exported (PNG)');
  } catch (_) {
    if (typeof showToast === 'function') showToast('⚠ PNG export failed (check internet / CDN)');
  }
}

// Render a static, non-interactive SVG preview of the block's scene, then
// attach the ✎ edit / ⋮ source buttons. Mirrors renderMermaidBlock's contract:
// async, replaces the "⏳ Rendering…" placeholder, degrades gracefully if the
// scene JSON is invalid or the CDN fails — the data-source always round-trips.
async function renderExcalidrawBlock(block) {
  const src = block.dataset.source || '';
  let scene = null;
  try {
    scene = src.trim() ? JSON.parse(src) : { elements: [] };
  } catch (_) {
    // Invalid JSON — preserve the raw source so nothing is lost, show an error.
    block.innerHTML =
      `<pre class="excalidraw-fallback">${escapeHtmlForEditor(src)}</pre>` +
      `<div class="excalidraw-error">⚠ Invalid whiteboard scene JSON</div>` +
      _excaliButtonsHtml();
    _wireExcalidrawButtons(block);
    return;
  }

  const elements = (scene && scene.elements) || [];
  let previewHtml;
  if (!elements.length) {
    previewHtml = `<div class="excalidraw-empty">Empty diagram — click ✎ edit to draw</div>`;
  } else if (_excaliSvgCache.has(src)) {
    previewHtml = _excaliSvgCache.get(src);   // rendered earlier this session: shown at once, nothing awaited
  } else {
    try {
      const Lib = await loadExcalidrawLib();
      // Normalize through Excalidraw's own restore so hand-authored / lean
      // scenes (missing seed/version/etc.) get valid defaults before export.
      let renderEls = elements;
      try {
        if (typeof Lib.restoreElements === 'function') {
          renderEls = Lib.restoreElements(elements, null);
        }
      } catch (_) { renderEls = elements; }
      const svg = await Lib.exportToSvg({
        elements: renderEls,
        files: scene.files || null,
        exportPadding: 12,
        appState: {
          exportBackground: true,
          viewBackgroundColor: (scene.appState && scene.appState.viewBackgroundColor) || '#ffffff',
          exportWithDarkMode: false,
          exportEmbedScene: false
        }
      });
      // Keep exportToSvg's natural pixel dimensions; CSS caps the displayed
      // size (max-width) and scales height proportionally. Stretching to 100%
      // made the preview balloon to the full (very wide) box width.
      _excaliMaskWholePicture(svg);   // every label mask covers the whole picture, or a straight labelled line clips away
      previewHtml = svg.outerHTML;
      _excaliSvgRemember(src, previewHtml);
    } catch (_) {
      previewHtml =
        `<pre class="excalidraw-fallback">${escapeHtmlForEditor(src)}</pre>` +
        `<div class="excalidraw-error">⚠ Whiteboard failed to load (check internet / CDN). Reload the page to try again - nothing is lost.</div>`;
    }
  }
  block.innerHTML = previewHtml + _excaliButtonsHtml();
  _wireExcalidrawButtons(block);
  // ADD-ON: if this diagram has a generated lesson, attach the Diagram|Video
  // toggle (no-op otherwise). Guarded so a missing add-on never breaks render.
  if (typeof attachVideoToggle === 'function') { try { attachVideoToggle(block); } catch (_) {} }
}

// Open the full interactive Excalidraw editor in a modal seeded with the
// block's scene. On Save, the edited scene is written back into the block's
// data-source and persisted via the box's existing debounced autosave.
async function openExcalidrawModal(block) {
  // Singleton — only one editor modal at a time. Guards against a second modal
  // opening while one is up (which would let the first's cleanup flip
  // __excalidrawModalOpen back to false and re-enable the app's global undo
  // while a modal is still on screen). The blocking backdrop already prevents
  // this via the UI; this is belt-and-suspenders for programmatic opens.
  if (window.__excalidrawModalOpen) return;
  // Capture NOW — the block may be replaced by a blur re-render once the modal
  // takes focus. data-source is preserved across re-renders, and block order
  // is stable, so we re-find the target by its index at save time. We also
  // capture the owning box id so we can re-find the CORRECT editor (not just
  // "the first .notes-editor") if the editor element itself was replaced.
  const editor = block.closest('.notes-editor');
  const boxId = editor ? editor.dataset.boxId : null;
  const allBlocks = editor ? Array.from(editor.querySelectorAll('.excalidraw-block')) : [];
  const blockIndex = allBlocks.indexOf(block);
  let initialScene = { elements: [] };
  try {
    const s = block.dataset.source;
    if (s && s.trim()) initialScene = JSON.parse(s);
  } catch (_) { /* fall back to empty scene */ }

  const backdrop = document.createElement('div');
  backdrop.className = 'excalidraw-modal-backdrop';
  backdrop.innerHTML =
    '<div class="excalidraw-modal">' +
      '<div class="excalidraw-modal-header">' +
        '<span class="excalidraw-modal-title">✎ Whiteboard · changes auto-save</span>' +
        '<div class="excalidraw-modal-actions">' +
          '<button class="btn excalidraw-modal-laser" type="button" title="Laser pointer (K) - point at things without drawing. While it is on: Ctrl + drag moves the canvas, hold Alt to select / move things">' + _EXCALI_LASER_SVG + ' Laser</button>' +
          '<button class="btn btn-primary excalidraw-modal-save" type="button">Save &amp; close</button>' +
        '</div>' +
      '</div>' +
      '<div class="excalidraw-canvas-host"></div>' +
    '</div>';
  document.body.appendChild(backdrop);
  window.__excalidrawModalOpen = true;

  // Excalidraw owns ALL keyboard while the modal is open (Ctrl+Z/Y undo-redo,
  // Delete, arrow-key nudge, etc.). We deliberately do NOT trap or
  // stopPropagation keydown here. Excalidraw's own handlers live on document /
  // its own container, and the canvas sits INSIDE this backdrop — so a
  // capture-phase stopPropagation on the backdrop would starve Excalidraw of
  // every keystroke (that bug made arrow keys scroll the page and Ctrl+Z /
  // Delete do nothing). Instead, the window.__excalidrawModalOpen flag (checked
  // in ui.js's global keydown handler) neutralizes ONLY our app's Ctrl+Z/Y and
  // leaves every key flowing to Excalidraw untouched.

  const host = backdrop.querySelector('.excalidraw-canvas-host');
  host.textContent = 'Loading whiteboard…';

  let root = null;
  let api = null;
  let cleaned = false;
  let _autoSaveTimer = null;
  let altSel = false;            // Alt is holding the selection tool for the laser (see the ALT block below)
  let altTeardown = null;        // removes the Alt listeners (document / window) when the modal goes
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    if (_autoSaveTimer) clearTimeout(_autoSaveTimer);
    if (altTeardown) altTeardown();
    window.__excalidrawModalOpen = false;
    try { if (root) root.unmount(); } catch (_) {}
    backdrop.remove();
  };

  // NOTHING CHANGED = NOTHING WRITTEN (team feedback #10, 2026-10-12). Excalidraw fires onChange on mount, on every
  // selection, pan and zoom - and this modal's serialization never byte-matches the fence the MCP wrote, so merely
  // OPENING a whiteboard used to rewrite the box, move the diagram's content_hash and fail the AI's next
  // edit_diagram-by-hash until it described the diagram again. The guard is a fingerprint of the DRAWING taken when
  // the drawing is handed to the editor (and again after each write): Excalidraw's own scene version over the elements
  // plus the set of file ids. The reference is computed from the SCENE DATA, not read back from the editor: the editor's
  // API arrives before the scene is applied (RUN: version 0 at that moment, the real version at the first onChange
  // ~300 ms later), and restoreElements keeps each element's version, so the data and the mounted scene agree.
  // The camera (scroll / zoom) is not part of it: a pan alone never writes; the viewport still rides
  // along with a real edit, so a drawing you changed reopens framed as you left it (E, round lead, 2026-10-12: the fence
  // is the drawing, not the camera).
  let _baseline = null;
  const fingerprint = () => ({
    v: Lib.getSceneVersion(api.getSceneElements()),
    f: Object.keys(api.getFiles() || {}).sort().join(',')
  });
  const drawingChanged = () => { const now = fingerprint(); return now.v !== _baseline.v || now.f !== _baseline.f; };
  // THE PREVIEW FOLLOWS THE LAST WRITE (RUN 2026-10-12, a regression of the guard above): the 900 ms autosave writes
  // the drawing and moves the reference; a Close right after then saw "nothing changed" and only closed - the inline
  // preview still showed the picture from BEFORE the session ("Empty diagram" for a new whiteboard) until the box
  // re-rendered. So the session remembers that it wrote, and a Close after a write re-renders the block (and says
  // "saved") even when the drawing is unchanged since that write. An untouched session still closes silently.
  let _wroteThisSession = false;

  // Write the current scene back into the owning box's block and trigger the
  // box's debounced disk autosave. close=true also re-renders the inline block,
  // toasts, and tears down the modal. Shared by the buttons AND the debounced
  // auto-save below — so edits persist even if the modal is merely closed.
  const persist = (close) => {
    if (!api) { if (close) cleanup(); return; }
    if (!drawingChanged()) {
      if (!close) return;                                       // an idle onChange: nothing to write
      if (!_wroteThisSession) { cleanup(); return; }            // untouched session: no write, no "saved" toast, just close
      const liveEd = (editor && editor.isConnected) ? editor : (boxId ? document.querySelector(`.notes-editor[data-box-id="${(typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(boxId) : boxId}"]`) : null);
      const blks = liveEd ? Array.from(liveEd.querySelectorAll('.excalidraw-block')) : [];
      const blk = (blockIndex >= 0 && blks[blockIndex]) ? blks[blockIndex] : blks[blks.length - 1];
      if (blk) renderExcalidrawBlock(blk).catch(() => {});      // the autosave already wrote this drawing: show it
      if (typeof showToast === 'function') showToast('✓ Diagram saved');
      cleanup();
      return;
    }
    _baseline = fingerprint();                                  // what the box now holds; a later idle onChange compares against it
    _wroteThisSession = true;
    const a = api.getAppState();
    const scene = {
      elements: api.getSceneElements(),
      appState: {
        viewBackgroundColor: a.viewBackgroundColor || '#ffffff',
        scrollX: a.scrollX, scrollY: a.scrollY, zoom: a.zoom
      },
      files: api.getFiles() || {}
    };
    const json = JSON.stringify(scene);
    let liveEditor = (editor && editor.isConnected) ? editor : null;
    if (!liveEditor && boxId) {
      const sel = (typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(boxId) : boxId;
      liveEditor = document.querySelector(`.notes-editor[data-box-id="${sel}"]`);
    }
    if (!liveEditor) {
      if (close) { if (typeof showToast === 'function') showToast('⚠ Diagram target lost — not saved'); cleanup(); }
      return;
    }
    const blocks = Array.from(liveEditor.querySelectorAll('.excalidraw-block'));
    const target = (blockIndex >= 0 && blocks[blockIndex]) ? blocks[blockIndex] : blocks[blocks.length - 1];
    if (target) {
      // data-source MUST be set before dispatching 'input' (the box's flushSave
      // reads it synchronously). Only re-render the inline block on close.
      target.dataset.source = json;
      if (close) renderExcalidrawBlock(target).catch(() => {});
      liveEditor.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (close) {
      if (typeof showToast === 'function') showToast('✓ Diagram saved');
      cleanup();
    }
  };

  // Debounced background auto-save. Excalidraw fires onChange very frequently
  // (every pointer move while drawing), hence the debounce.
  const scheduleAutoSave = () => {
    if (_autoSaveTimer) clearTimeout(_autoSaveTimer);
    _autoSaveTimer = setTimeout(() => persist(false), 900);
  };

  // Both the button and a backdrop click flush a final save and close. There is
  // no "discard" — changes auto-save; use Excalidraw's Ctrl+Z to undo instead.
  backdrop.addEventListener('mousedown', (e) => { if (e.target === backdrop) persist(true); });

  let Lib, React, ReactDOMClient;
  try {
    const [lib, reactPair] = await Promise.all([loadExcalidrawLib(), loadExcalidrawReact()]);
    Lib = lib;
    React = reactPair[0];
    ReactDOMClient = reactPair[1];
  } catch (_) {
    host.textContent = 'Failed to load the whiteboard (check internet / CDN). Close this and try again - your drawing is safe in the box.';
    return; // modal stays open showing the error; Cancel / backdrop closes it
  }

  _baseline = {   // the drawing as handed to the editor (see the guard above)
    v: Lib.getSceneVersion(Lib.restoreElements(initialScene.elements || [], null)),
    f: Object.keys(initialScene.files || {}).sort().join(',')
  };
  host.textContent = '';
  root = ReactDOMClient.createRoot(host);
  // If the saved scene carries a viewport (scrollX/scrollY/zoom), restore it so
  // the diagram reopens framed exactly as the user left it. Only auto-fit when
  // there is NO saved viewport (first open / legacy scenes) — otherwise the fit
  // would override the user's saved pan/zoom.
  const sa = initialScene.appState || {};
  const savedView = (typeof sa.scrollX === 'number' && typeof sa.scrollY === 'number' && sa.zoom)
    ? { scrollX: sa.scrollX, scrollY: sa.scrollY, zoom: sa.zoom }
    : null;
  const initAppState = { viewBackgroundColor: sa.viewBackgroundColor || '#ffffff' };
  if (savedView) Object.assign(initAppState, savedView);
  // The ☰ menu is OURS, not the library's (Rishabh 2026-10-16: "we don't want the word excalidraw on our app"):
  // only Find on canvas / Reset the canvas / Dark mode / Canvas background. Dropped: Open + Save to (.excalidraw
  // FILES - the box saves itself), Export image (our ⬇ PNG), Help (the library's shortcut sheet + its links) and
  // the library's socials. aiEnabled:false drops the "Wireframe to code" AI entry from the tools dropdown; the
  // Library button, the ? help icon and the "Generate > Mermaid" entry are hidden by CSS (styles.css, the
  // .excalidraw-canvas-host rules) - the library draws them unconditionally.
  const MM = Lib.MainMenu;
  const ourMenu = React.createElement(MM, null,
    React.createElement(MM.DefaultItems.SearchMenu),
    React.createElement(MM.DefaultItems.ClearCanvas),
    React.createElement(MM.DefaultItems.ToggleTheme),
    React.createElement(MM.DefaultItems.ChangeCanvasBackground));
  const laserBtn = backdrop.querySelector('.excalidraw-modal-laser');
  const syncLaser = (st) => { if (laserBtn) laserBtn.classList.toggle('is-on', altSel || !!(st && st.activeTool && st.activeTool.type === 'laser')); };
  root.render(
    React.createElement(Lib.Excalidraw, {
      initialData: {
        elements: initialScene.elements || [],
        appState: initAppState,
        files: initialScene.files || null,
        scrollToContent: !savedView
      },
      aiEnabled: false,
      excalidrawAPI: (a) => {
        api = a;
        backdrop.excalidrawApi = a;   // the live editor API on the modal element (a DOM handle for the headless e2e / persist-guard checks; no global)
        // Excalidraw is an infinite, scrollbar-less canvas. On FIRST open (no
        // saved viewport) zoom-to-fit so nothing sits off-screen / behind the
        // toolbar. If a viewport was saved, leave it exactly as restored.
        if (!savedView) {
          setTimeout(() => {
            try { a.scrollToContent(a.getSceneElements(), { fitToContent: true, animate: false }); } catch (_) {}
          }, 60);
        }
      },
      onChange: (_els, st) => { syncLaser(st); scheduleAutoSave(); }
    }, ourMenu)
  );

  // LASER (Rishabh 2026-10-16): a direct button beside Save & close (the library's own dropdown item is hidden in
  // styles.css; K still works). Click toggles laser <-> selection; the button lights while the laser is on - and while
  // Alt is holding the selection tool for it (below), since that is still the laser session.
  laserBtn.addEventListener('click', () => {
    if (!api) return;
    const on = api.getAppState().activeTool.type === 'laser';
    api.setActiveTool({ type: on ? 'selection' : 'laser' });
  });
  // Ctrl + left-drag MOVES THE CANVAS while the laser is on (his ask: "left click laser, canvas move with Ctrl").
  // The library gives the laser no pan of its own (wheel / middle button / Space+drag stay as they are). Capture
  // phase on the host, so the library never sees the press as a laser stroke; the scroll is applied through the
  // API in scene units (screen px / zoom), exactly what the hand tool does.
  host.addEventListener('pointerdown', (e) => {
    if (!api || e.button !== 0 || !e.ctrlKey) return;
    if (api.getAppState().activeTool.type !== 'laser') return;
    e.preventDefault(); e.stopPropagation();
    let lx = e.clientX, ly = e.clientY;
    const move = (ev) => {
      const s = api.getAppState(); const z = (s.zoom && s.zoom.value) || 1;
      api.updateScene({ appState: { scrollX: s.scrollX + (ev.clientX - lx) / z, scrollY: s.scrollY + (ev.clientY - ly) / z } });
      lx = ev.clientX; ly = ev.clientY;
    };
    const up = () => { window.removeEventListener('pointermove', move, true); window.removeEventListener('pointerup', up, true); };
    window.addEventListener('pointermove', move, true);
    window.addEventListener('pointerup', up, true);
  }, true);

  // ALT = SELECT WHILE THE LASER IS ON (Rishabh 2026-10-17: "laser on, Alt + drag moves the object - what the arrow
  // tool does"). Holding Alt switches the laser to the selection tool (move, click-select, box-select, resize - all of
  // it, natively); releasing Alt brings the laser back, after the drag in flight if there is one. Window blur (Alt+Tab)
  // ends it too. The library's own Alt + drag DUPLICATES the dragged elements (RUN: pointerDownState.hit.hasBeenDuplicated),
  // so while this mode is on every trusted pointer event that carries Alt is swallowed in the capture phase and
  // re-dispatched on the same target with altKey off - the library sees a plain drag. Alt without the laser is untouched.
  // The KEY itself is swallowed too, first press and the auto-repeats a held key sends (~30/s): the library re-runs an
  // in-flight resize / box-select on every keydown with THAT event's altKey (= from the centre), so a repeat reaching it
  // between two stripped moves made the shape alternate (Rishabh 2026-10-17: "resizing flickers", "can't multi-select").
  let altDragging = false, altOffPending = false;
  const altOn = () => {
    if (altSel || !api || api.getAppState().activeTool.type !== 'laser') return false;
    altSel = true; altOffPending = false;
    api.setActiveTool({ type: 'selection' });
    syncLaser(api.getAppState());
    return true;
  };
  const altOff = () => {
    if (!altSel) return;
    if (altDragging) { altOffPending = true; return; }   // finish the drag first; the pointerup below completes it
    altSel = false; altOffPending = false;
    if (api) api.setActiveTool({ type: 'laser' });
  };
  const ALT_COPY = ['pointerId', 'width', 'height', 'pressure', 'tangentialPressure', 'tiltX', 'tiltY', 'twist', 'pointerType', 'isPrimary',
    'clientX', 'clientY', 'screenX', 'screenY', 'button', 'buttons', 'ctrlKey', 'shiftKey', 'metaKey', 'bubbles', 'cancelable', 'composed', 'detail'];
  const stripAlt = (ev) => {
    if (ev.type === 'pointerdown' && altSel && ev.isTrusted && ev.button === 0 && !ev.ctrlKey) altDragging = true;
    const endsDrag = (ev.type === 'pointerup' || ev.type === 'pointercancel') && altDragging;
    if (altSel && ev.isTrusted && ev.altKey) {
      ev.stopImmediatePropagation();
      const init = { view: window };
      for (const k of ALT_COPY) init[k] = ev[k];
      init.altKey = false;
      const clone = new PointerEvent(ev.type, init);
      ev.target.dispatchEvent(clone);
      if (clone.defaultPrevented) ev.preventDefault();
    }
    if (endsDrag) { altDragging = false; if (altOffPending) altOff(); }
  };
  const onAltKeyDown = (e) => { if (e.key !== 'Alt') return; if (altOn() || altSel) { e.preventDefault(); e.stopImmediatePropagation(); } };
  const onAltKeyUp = (e) => { if (e.key !== 'Alt') return; if (altSel) e.preventDefault(); altOff(); };
  const onAltBlur = () => { altDragging = false; altOff(); };
  document.addEventListener('keydown', onAltKeyDown, true);
  document.addEventListener('keyup', onAltKeyUp, true);
  window.addEventListener('blur', onAltBlur);
  ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'].forEach((t) => window.addEventListener(t, stripAlt, true));
  altTeardown = () => {
    document.removeEventListener('keydown', onAltKeyDown, true);
    document.removeEventListener('keyup', onAltKeyUp, true);
    window.removeEventListener('blur', onAltBlur);
    ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'].forEach((t) => window.removeEventListener(t, stripAlt, true));
  };

  backdrop.querySelector('.excalidraw-modal-save').addEventListener('click', () => persist(true));

}

// Put a ```excalidraw fence into a box AT THE CARET LINE - right below the line the caret is on, a blank line on
// each side (the table's rule, insertNotesTable) - or at the end when the caret is not in this box's prose (no
// caret, another box, or inside an atomic block). The pasted / spliced lines go in as plain <div>s and the
// re-render turns them into the rendered block; the box's autosave persists it. Returns the fresh block.
// Shared by the ▦ button (an empty whiteboard) and by a paste of a copied / cut whiteboard (notes-render.js).
// Rishabh 2026-10-16: "I can't enter a whiteboard in between, it always gets added at the end."
function insertExcalidrawFenceAtCaret(editor, fenceText) {
  const winSel = window.getSelection();
  let lineDiv = null;
  if (winSel && winSel.rangeCount) {
    const a = winSel.anchorNode;
    const ael = a && (a.nodeType === 1 ? a : a.parentElement);
    const inThis = ael && ael.closest && ael.closest('.notes-editor') === editor;
    const inAtomic = ael && ael.closest && ael.closest('.md-table-block, .mermaid-block, .excalidraw-block, .video-embed-block, .video-link-block, .pdf-embed-block, .pdf-link-block, .video-file-block');
    if (inThis && !inAtomic) lineDiv = notesEditorLineDiv(editor);
  }
  let fresh = null;
  if (lineDiv && lineDiv.parentNode === editor) {
    let blocksAbove = 0;
    for (let x = lineDiv.previousElementSibling; x; x = x.previousElementSibling) if (x.classList && x.classList.contains('excalidraw-block')) blocksAbove++;
    if (lineDiv.classList && lineDiv.classList.contains('excalidraw-block')) blocksAbove++;   // the caret line itself is a whiteboard: the new one goes below it
    const frag = document.createDocumentFragment();
    const blank = () => { const d = document.createElement('div'); d.appendChild(document.createElement('br')); return d; };
    frag.appendChild(blank());
    fenceText.split('\n').forEach((l) => { const d = document.createElement('div'); d.textContent = l; frag.appendChild(d); });
    frag.appendChild(blank());
    editor.insertBefore(frag, lineDiv.nextSibling);   // appends if nextSibling is null
    setEditorContent(editor, getEditorContent(editor));
    fresh = editor.querySelectorAll('.excalidraw-block')[blocksAbove] || null;
  } else {
    const current = getEditorContent(editor);
    setEditorContent(editor, current.trim() ? current.replace(/\n+$/, '') + '\n\n' + fenceText : fenceText);
    const blocks = editor.querySelectorAll('.excalidraw-block');
    fresh = blocks[blocks.length - 1] || null;
  }
  editor.dispatchEvent(new Event('input', { bubbles: true }));   // the box's debounced autosave persists it
  return fresh;
}

// Create a new, empty whiteboard in the given box at the caret and open the editor on it immediately. Wired to
// the ▦ button in each box's actions (mousedown there keeps the caret where it is).
function insertExcalidrawBlock(boxId) {
  const sel = (typeof CSS !== 'undefined' && CSS.escape) ? CSS.escape(boxId) : boxId;
  const editor = document.querySelector(`.notes-editor[data-box-id="${sel}"]`);
  if (!editor) return;
  const fresh = insertExcalidrawFenceAtCaret(editor, '```excalidraw\n{"elements":[]}\n```');
  if (fresh) openExcalidrawModal(fresh);
}

;
// ==== FILE: js/laser.js ====
// ── Laser pointer (portal level) ─────────────────────────────────────────────
// A presenter's laser over the whole book / document page - the same trail the
// Laser tool inside the whiteboard draws (Rishabh 2026-10-27: "Excalidraw ki tarah,
// professional"). The stroke maths IS Excalidraw's: @excalidraw/laser-pointer, the
// engine its own Laser tool runs on, bundled by scripts/build-excalidraw-vendor.mjs
// to /dist/vendor/laser-pointer/index.js and imported on the first switch-on; the
// trail options below are the ones Excalidraw's LaserTrails uses (streamline .4, a
// 1 s fade per point, a 50-point tail), drawn as filled outlines on a canvas.
//
// While ON, a full-viewport transparent canvas sits above the page:
//   - exactly the whiteboard's gesture: press starts a trail, moving while pressed
//     feeds it, release ends it and it fades out; a move with nothing pressed draws
//     nothing (Rishabh 2026-10-27: "Excalidraw mein bina click kiye nahi aata");
//   - a press lands on the canvas, so it does nothing on the page;
//   - holding Ctrl (Cmd on Mac) makes the canvas pass-through, so Ctrl + click
//     reaches whatever is underneath (no event is re-dispatched); so does the
//     pointer being over the header menu (its grid button, its open popup), so the
//     menu opens and its Laser tile is clickable while the laser is on;
//   - the mouse wheel scrolls the page: the canvas has no overflow of its own, so
//     the wheel chains to the document scroller.
// It turns OFF on: the tile again; Esc (unless an input / editor holds focus - its own Esc wins).
//
// The button is the #laserBtnTop tile in the header menu's popup (index.html #hdrPop): the laser is PAGE-WIDE - it
// stays on across chapters and views (Rishabh 2026-10-27: "move that laser within pop up only"). This file paints the
// tile's icon (the whiteboard's own, excalidraw.js _EXCALI_LASER_SVG, as the tile's background image in the ink and
// in the laser red for the ON state), its label and its tip at load.
//
// Public (classic global scope; the tile's inline onclick calls toggleLaser):
//   toggleLaser(), laserOff()

const LASER_VENDOR_URL = '/dist/vendor/laser-pointer/index.js';   // scripts/build-excalidraw-vendor.mjs LASER_VENDOR_URL
const LASER_POINT_LIFE_MS = 1000;   // Excalidraw LaserTrails: a point is full-size at birth and gone after this
const LASER_TAIL_POINTS = 50;       // Excalidraw LaserTrails: the trail thins over its last 50 points
const _laserEaseOut = (t) => Math.sin((t * Math.PI) / 2);   // Excalidraw's easeOut

const _laser = { on: false, canvas: null, ctx: null, ro: null, color: '', Lib: null, current: null, past: [], raf: 0, pass: false };

// The menu tile's icon, label + tip (the markup sits in index.html; the icon lives in ONE place, excalidraw.js). The
// tile icons are CSS background images (styles.css .hdr-actions .btn::before), so the SVG goes in as a data URL in
// the tile's own colour tokens: currentColor does not resolve inside an image.
{
  const b = document.getElementById('laserBtnTop');
  if (!b) throw new Error('laser: #laserBtnTop is missing from index.html');
  const tokens = getComputedStyle(document.documentElement);
  const dataUrl = (colour) => {
    const svg = _EXCALI_LASER_SVG.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ').replace(/currentColor/g, colour.trim());
    return 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
  };
  b.style.setProperty('--laser-tile-icon', dataUrl(tokens.getPropertyValue('--c-ink-700')));
  b.style.setProperty('--laser-tile-icon-on', dataUrl(tokens.getPropertyValue('--tt-laser')));
  b.textContent = LBL('laser');
  b.title = LBL('laserTip');
}

function toggleLaser() {
  if (_laser.on) laserOff(); else _laserOn();
}

// The stroke engine, loaded once from our origin (the vendor build). A missing build is an error, not a plainer laser.
async function _laserLib() {
  if (!_laser.Lib) _laser.Lib = (await import(LASER_VENDOR_URL)).LaserPointer;
  if (typeof _laser.Lib !== 'function') throw new Error('laser: ' + LASER_VENDOR_URL + ' exports no LaserPointer - run npm run build (build:vendor)');
  return _laser.Lib;
}

// Excalidraw's LaserTrails.getTrailOptions: each point carries its birth time as "pressure"; a point's size falls to 0
// over LASER_POINT_LIFE_MS, and the last LASER_TAIL_POINTS of the trail taper; the smaller of the two wins.
function _laserTrailOptions() {
  return {
    simplify: 0,
    streamline: 0.4,
    keepHead: true,
    sizeMapping: (d) => {
      const age = Math.max(0, 1 - (performance.now() - d.pressure) / LASER_POINT_LIFE_MS);
      const tail = (LASER_TAIL_POINTS - Math.min(LASER_TAIL_POINTS, d.totalLength - d.currentIndex)) / LASER_TAIL_POINTS;
      return Math.min(_laserEaseOut(tail), _laserEaseOut(age));
    },
  };
}

async function _laserOn() {
  const color = getComputedStyle(document.documentElement).getPropertyValue('--tt-laser').trim();
  if (!color) throw new Error('laser: the --tt-laser colour token is not defined (styles.css, LASER POINTER block)');
  const Lib = await _laserLib();
  if (_laser.on) return;   // a second click while the engine loaded
  const c = document.createElement('canvas');
  c.className = 'tt-laser-canvas';
  c.setAttribute('aria-hidden', 'true');
  document.body.appendChild(c);
  Object.assign(_laser, { on: true, canvas: c, ctx: c.getContext('2d'), color, Lib, current: null, past: [], pass: false });
  // The canvas's CSS box is the viewport minus the scrollbar; its backing store follows that box (and the
  // pixel ratio, which a browser zoom changes along with the box), so strokes stay crisp at any size.
  // Sized now, so the very first move after the click draws on the full-size store; the observer keeps it so.
  _laserResize();
  _laser.ro = new ResizeObserver(_laserResize);
  _laser.ro.observe(c);
  c.addEventListener('pointerdown', _laserPress);
  window.addEventListener('pointermove', _laserMove, true);
  window.addEventListener('pointerup', _laserRelease, true);
  window.addEventListener('pointercancel', _laserRelease, true);
  window.addEventListener('pointerout', _laserOut, true);
  window.addEventListener('keydown', _laserKeyDown, true);
  window.addEventListener('keyup', _laserKeyUp, true);
  window.addEventListener('blur', _laserBlur);
  _laserSyncButtons();
}

function laserOff() {
  if (!_laser.on) return;
  window.removeEventListener('pointermove', _laserMove, true);
  window.removeEventListener('pointerup', _laserRelease, true);
  window.removeEventListener('pointercancel', _laserRelease, true);
  window.removeEventListener('pointerout', _laserOut, true);
  window.removeEventListener('keydown', _laserKeyDown, true);
  window.removeEventListener('keyup', _laserKeyUp, true);
  window.removeEventListener('blur', _laserBlur);
  _laser.ro.disconnect();
  if (_laser.raf) cancelAnimationFrame(_laser.raf);
  _laser.canvas.remove();
  Object.assign(_laser, { on: false, canvas: null, ctx: null, ro: null, current: null, past: [], raf: 0, pass: false });
  _laserSyncButtons();
}

// Every rendered Laser button shows the current state (no toolbar re-render needed).
function _laserSyncButtons() {
  document.querySelectorAll('[data-laser-btn]').forEach((b) => {
    b.classList.toggle('active', _laser.on);
    b.setAttribute('aria-pressed', String(_laser.on));
  });
}

// The header menu (its grid button and, when open, its popup) stays reachable under the laser: over it the canvas is
// pass-through, so the menu opens and the Laser tile turns the laser off. Hit-tested by rect on every move.
function _laserOverMenu(x, y) {
  return ['#hdrMenuBtn', '#hdrPop'].some((sel) => {
    const el = document.querySelector(sel);
    if (!el || el.hidden) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  });
}

function _laserResize() {
  const { canvas: c, ctx } = _laser;
  const dpr = window.devicePixelRatio;
  c.width = Math.round(c.clientWidth * dpr);
  c.height = Math.round(c.clientHeight * dpr);
  // A resize resets the context state, so the fill is (re)applied here, once per size.
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  ctx.fillStyle = _laser.color;
  _laserKick();
}

// Ctrl / Cmd held = the page underneath takes the pointer; released = the laser takes it back.
function _laserSetPass(pass) {
  if (_laser.pass === pass) return;
  _laser.pass = pass;
  _laser.canvas.style.pointerEvents = pass ? 'none' : '';
}

// A move feeds the trail only while one is open (pressed); unpressed it only tracks Ctrl and the menu hover.
function _laserMove(e) {
  _laserSetPass(e.ctrlKey || e.metaKey || _laserOverMenu(e.clientX, e.clientY));
  if (!_laser.current) return;
  _laser.current.addPoint([e.clientX, e.clientY, performance.now()]);
  _laserKick();
}

// The trail is over (released, or the pointer left the window): it loses its head and fades out whole, as
// Excalidraw's does on pointer-up; the next press starts a fresh one.
function _laserEndPath() {
  const t = _laser.current;
  if (!t) return;
  t.close();
  t.options.keepHead = false;
  _laser.past.push(t);
  _laser.current = null;
  _laserKick();
}

function _laserOut(e) {
  if (!e.relatedTarget) _laserEndPath();   // the pointer left the window
}

// Excalidraw's startPath: the press opens a trail at the pointer; the moves that follow feed it (_laserMove).
function _laserPress(e) {
  e.preventDefault();   // the canvas takes the press: no focus change, no text selection, nothing underneath clicked
  if (e.button !== 0) return;
  _laser.current = new _laser.Lib(_laserTrailOptions());
  _laser.current.addPoint([e.clientX, e.clientY, performance.now()]);
  _laserKick();
}

// Excalidraw's endPath on pointer-up (and on a cancelled pointer).
function _laserRelease() {
  _laserEndPath();
}

function _laserIsTypingTarget(t) {
  return t instanceof Element && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName));
}

function _laserKeyDown(e) {
  if (e.key === 'Control' || e.key === 'Meta') { _laserSetPass(true); return; }
  // Esc: the laser is the topmost layer, so it closes first - but a focused input / editor keeps its own Esc.
  if (e.key !== 'Escape' || _laserIsTypingTarget(e.target)) return;
  e.preventDefault();
  e.stopPropagation();
  laserOff();
}

function _laserKeyUp(e) {
  if (e.key === 'Control' || e.key === 'Meta') _laserSetPass(false);
}

function _laserBlur() {
  _laserSetPass(false);
}

function _laserKick() {
  if (!_laser.raf) _laser.raf = requestAnimationFrame(_laserFrame);
}

// One frame, as Excalidraw's AnimatedTrail.onFrame: every trail's outline (its size shrinks per point through
// sizeMapping as time passes), past trails dropped once their outline is empty; the loop stops when nothing is left.
function _laserFrame() {
  const { ctx, canvas: c } = _laser;
  ctx.clearRect(0, 0, c.clientWidth, c.clientHeight);
  const trails = _laser.current ? [..._laser.past, _laser.current] : _laser.past;
  for (const t of trails) _laserFillOutline(ctx, t.getStrokeOutline());
  _laser.past = _laser.past.filter((t) => t.getStrokeOutline().length !== 0);
  _laser.raf = (_laser.past.length || _laser.current) ? requestAnimationFrame(_laserFrame) : 0;
}

// The outline is a closed polygon around the stroke; the midpoint-quadratic join is the one perfect-freehand's
// getSvgPathFromStroke draws, so the edge is as smooth as the whiteboard's.
function _laserFillOutline(ctx, pts) {
  const n = pts.length;
  if (n < 2) return;
  ctx.beginPath();
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < n; i++) {
    const a = pts[i], b = pts[(i + 1) % n];
    ctx.quadraticCurveTo(a[0], a[1], (a[0] + b[0]) / 2, (a[1] + b[1]) / 2);
  }
  ctx.closePath();
  ctx.fill();
}

;
// ==== FILE: js/restore.js ====
// ───────────────────────────────────────────────────────────────────────────
// Self-serve "restore to an earlier time" (PITR-backed, last 48 hours).
//
// FLOW:  🕘  ->  pick a time  ->  Preview  ->  Restore this version
//   • Preview = a privileged point-in-time READ via the MCP server (the browser
//     can't do PITR reads itself). Cross-origin, so it bypasses the /save shim.
//   • Restore = WRITE-back through the tracker's OWN /save path (same writer as
//     autosave, so the single-editor lock + read-only rules apply), then reload
//     the affected surface from the cloud.
//
// SCOPE (v1): the CONTENT of an existing table (its CSV) or an existing notes
// box (its .md). NOT covered: a deleted box / epic / tab, or pasted images. The
// panel states this plainly.
// ───────────────────────────────────────────────────────────────────────────

// The MCP/API base is config-driven (MCP_BASE, baked by build-config.mjs) and shared
// through the cloud-store bridge. restore.js is a classic script (no imports), so it
// reads window.__ttCloud.mcpBase at call time - the SAME bridge it already uses for
// idToken/storeUid/readOnly. ONE source of truth (no hostname/URL hardcode here), so a
// localhost "live mode" run reaches the deployed API just like /ev/*.
const RESTORE_MAX_HOURS = 48;
const RESTORE_MAX_MS = RESTORE_MAX_HOURS * 60 * 60 * 1000;
// Slack matching the server so a preset that lands exactly on the 48h edge isn't
// rejected by the time the request arrives (request latency / clock skew).
const RESTORE_GRACE_MS = 10 * 60 * 1000;

// Preset label -> "this many ms ago". All within the 48h window.
const RESTORE_PRESETS = [
  ['5 min ago', 5 * 60 * 1000],
  ['1 hour ago', 60 * 60 * 1000],
  ['3 hours ago', 3 * 60 * 60 * 1000],
  ['Yesterday', 24 * 60 * 60 * 1000],
  ['2 days ago', RESTORE_MAX_MS],
];

// Live panel state: { kind, boxId, file, title, atMs, last:{exists,content} }
let _restore = null;

// Resolve which single file backs the thing being restored, + a human title.
function _restoreTarget(kind, boxId) {
  const sec = SECTIONS[activeSection];
  if (kind === 'box') {
    const file = notesContentFilename(sec, sec.activeNotesEpic, boxId);
    return { kind, boxId, file, noun: 'note box' };
  }
  const file = (typeof activeCategoryFile === 'function') ? activeCategoryFile(sec) : sec.file;
  return { kind, boxId: null, file, noun: 'table' };
}

function _localInputValue(ms) {
  const d = new Date(ms - new Date(ms).getTimezoneOffset() * 60000);
  return d.toISOString().slice(0, 16);   // 'YYYY-MM-DDTHH:mm' in local time
}
function _csvRowCount(text) {
  const t = String(text || '').replace(/\n+$/, '');
  return t ? Math.max(0, t.split('\n').length - 1) : 0;   // minus the header row
}

// Entry point — wired on the box header (🕘) and the table toolbar.
function openRestore(kind, boxId) {
  if (!window.__ttCloud) return;
  if (window.__ttCloud.readOnly()) {
    if (typeof showToast === 'function') showToast('This view is read-only — switch to edit mode to restore.');
    return;
  }
  const sec = SECTIONS[activeSection];
  if (!sec) return;
  if (kind === 'box' && !sec.activeNotesEpic) return;
  const t = _restoreTarget(kind, boxId);
  if (!t.file) { if (typeof showToast === 'function') showToast('Nothing to restore here.'); return; }
  _restore = { ...t, atMs: null, last: null };
  _buildRestorePanel();
}

function _buildRestorePanel() {
  closeRestorePanel();
  const noun = _restore.noun;
  const back = document.createElement('div');
  back.id = 'ttRestoreBackdrop';
  back.className = 'tt-restore-backdrop';

  const card = document.createElement('div');
  card.className = 'tt-restore-card';
  card.innerHTML =
    '<div class="tt-restore-head">'
      + `<strong>🕘 Restore an earlier version</strong>`
      + '<button class="tt-restore-x" id="ttRestoreClose" title="Close">✕</button>'
    + '</div>'
    + '<div class="tt-restore-body">'
      + '<div class="tt-restore-note">'
        + `Brings the saved content of <strong>this ${noun}</strong> back to how it was, up to <strong>${RESTORE_MAX_HOURS} hours</strong> ago.`
        + '<div class="tt-restore-can"><span class="ok">✓ Recoverable:</span> the text, tables and diagrams inside this ' + noun + '.</div>'
        + '<div class="tt-restore-can"><span class="no">✗ Not yet:</span> a <em>deleted</em> ' + LBL('boxNoun').toLowerCase() + ', tab or epic, and pasted images. (Coming in a later phase.)</div>'
      + '</div>'
      + '<div class="tt-restore-pickrow">'
        + '<span class="tt-restore-lbl">Go back to:</span>'
        + '<span id="ttRestorePresets" class="tt-restore-presets"></span>'
      + '</div>'
      + '<div class="tt-restore-pickrow">'
        + '<span class="tt-restore-lbl">or pick a time:</span>'
        + `<input type="datetime-local" id="ttRestoreWhen" class="tt-restore-when">`
        + '<button class="btn" id="ttRestorePreview">Preview</button>'
      + '</div>'
      + '<div id="ttRestoreMsg" class="tt-restore-msg"></div>'
      + '<div id="ttRestorePreviewWrap" class="tt-restore-preview" hidden>'
        + '<div id="ttRestoreSummary" class="tt-restore-summary"></div>'
        + '<pre id="ttRestoreContent" class="tt-restore-content"></pre>'
      + '</div>'
    + '</div>'
    + '<div class="tt-restore-foot">'
      + '<button class="btn" id="ttRestoreCancel">Cancel</button>'
      + '<button class="btn btn-primary" id="ttRestoreDo" disabled>Restore this version</button>'
    + '</div>';
  back.appendChild(card);
  document.body.appendChild(back);

  // Presets
  const presetWrap = card.querySelector('#ttRestorePresets');
  RESTORE_PRESETS.forEach(([label, ms]) => {
    const b = document.createElement('button');
    b.className = 'btn tt-restore-preset';
    b.textContent = label;
    b.addEventListener('click', () => {
      const at = Date.now() - ms;
      card.querySelector('#ttRestoreWhen').value = _localInputValue(at);
      _previewRestore(at);
    });
    presetWrap.appendChild(b);
  });

  // Custom time bounds
  const when = card.querySelector('#ttRestoreWhen');
  when.min = _localInputValue(Date.now() - RESTORE_MAX_MS);
  when.max = _localInputValue(Date.now());

  card.querySelector('#ttRestorePreview').addEventListener('click', () => {
    const v = when.value;
    const at = v ? new Date(v).getTime() : NaN;
    if (!Number.isFinite(at)) { _restoreMsg('Pick a time first (a preset above, or the time field).', true); return; }
    _previewRestore(at);
  });
  card.querySelector('#ttRestoreClose').addEventListener('click', closeRestorePanel);
  card.querySelector('#ttRestoreCancel').addEventListener('click', closeRestorePanel);
  card.querySelector('#ttRestoreDo').addEventListener('click', _commitRestore);
  back.addEventListener('mousedown', (e) => { if (e.target === back) closeRestorePanel(); });
  document.addEventListener('keydown', _restoreKey, true);
}

function _restoreKey(e) {
  if (e.key === 'Escape') { e.stopPropagation(); e.preventDefault(); closeRestorePanel(); }
}

function closeRestorePanel() {
  document.removeEventListener('keydown', _restoreKey, true);
  const b = document.getElementById('ttRestoreBackdrop');
  if (b) b.remove();
}

function _restoreMsg(text, isErr) {
  const el = document.getElementById('ttRestoreMsg');
  if (!el) return;
  el.textContent = text || '';
  el.className = 'tt-restore-msg' + (isErr ? ' err' : '');
}

async function _previewRestore(atMs) {
  if (!_restore) return;
  const now = Date.now();
  if (atMs > now) atMs = now;
  if (atMs < now - RESTORE_MAX_MS - RESTORE_GRACE_MS) { _restoreMsg(`Restore only reaches back ${RESTORE_MAX_HOURS} hours.`, true); return; }
  _restore.atMs = atMs;
  _restore.last = null;
  const doBtn = document.getElementById('ttRestoreDo');
  if (doBtn) doBtn.disabled = true;
  document.getElementById('ttRestorePreviewWrap').hidden = true;
  _restoreMsg('Reading the saved version…');

  let res;
  try {
    res = await _restoreReadRequest(_restore.file, atMs);
  } catch (e) {
    _restoreMsg(String(e.message || e), true);
    return;
  }
  _restore.last = res;
  const when = new Date(atMs).toLocaleString();

  if (!res.exists) {
    _restoreMsg('', false);
    const wrap = document.getElementById('ttRestorePreviewWrap');
    wrap.hidden = false;
    document.getElementById('ttRestoreSummary').textContent = `This ${_restore.noun} did not exist at ${when} — nothing to restore.`;
    document.getElementById('ttRestoreContent').textContent = '';
    if (doBtn) doBtn.disabled = true;
    return;
  }

  const content = res.content || '';
  const isCsv = /\.csv$/.test(_restore.file);
  const sizePart = isCsv ? `${_csvRowCount(content)} rows` : `${content.length} characters`;
  const emptyNote = content.trim() === '' ? '  (it was blank then)' : '';
  _restoreMsg('', false);
  const wrap = document.getElementById('ttRestorePreviewWrap');
  wrap.hidden = false;
  document.getElementById('ttRestoreSummary').textContent = `As of ${when}: ${sizePart}.${emptyNote}`;
  document.getElementById('ttRestoreContent').textContent = isCsv ? content : _stripExcalidrawForPreview(content);
  if (doBtn) doBtn.disabled = false;
}

// Excalidraw scenes are a huge single-line JSON fence — useless and noisy in a
// text preview. Replace each with a one-line marker (the real content is still
// restored verbatim; this only affects what's SHOWN).
function _stripExcalidrawForPreview(md) {
  return String(md).replace(/```excalidraw[\s\S]*?```/g, '⟦ Whiteboard - kept, restored in full (collapsed in this preview) ⟧');
}

async function _restoreReadRequest(file, atMs) {
  const token = await window.__ttCloud.idToken();
  const storeUid = window.__ttCloud.storeUid();
  const r = await fetch(window.__ttCloud.mcpBase + '/restore-read', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
    body: JSON.stringify({ storeUid, file, at: atMs }),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || `Couldn't read that version (${r.status}).`);
  return j;   // { exists, content, readTime, file }
}

async function _commitRestore() {
  if (!_restore || !_restore.last || !_restore.last.exists) return;
  // MU-1 L7: a box someone else is editing right now is not restored over them - this is the one box writer outside
  // saveNotesContent (it writes through its own fetch below), so it asks the same lock predicate itself, by file name.
  if (typeof boxLockHolderForFile === 'function') {
    const holder = boxLockHolderForFile(_restore.file);
    if (holder) { if (typeof showToast === 'function') showToast('⚠ ' + holder + ' is editing this ' + LBL('boxNoun').toLowerCase()); return; }
  }
  const when = new Date(_restore.atMs).toLocaleString();
  if (!(await showConfirmModal({ title: 'Restore?', message: `This ${_restore.noun} will be replaced with how it was at ${when}. You can restore again to undo.`, okLabel: 'Restore' }))) return;

  const doBtn = document.getElementById('ttRestoreDo');
  if (doBtn) { doBtn.disabled = true; doBtn.textContent = 'Restoring…'; }

  try {
    // WRITE-back through the tracker's own /save path (same writer as autosave).
    const r = await fetch('/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: _restore.file, csv: _restore.last.content }),
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok || j.error) throw new Error(j.error || 'Save failed.');
    if (j.readOnly) throw new Error('This view is read-only — switch to edit mode to restore.');

    // Reload the affected surface from the cloud so the in-memory state matches
    // (otherwise the next autosave would re-write the stale in-memory copy).
    // Table: switchTab is the app's own full section reload (CSV + subtabs +
    // parent-task tabs), so a restore that changed which rows/parent-tasks exist
    // re-renders correctly — renderTable() alone would leave those strips stale.
    if (_restore.kind === 'box') {
      await renderNotesBoxes();
    } else {
      await switchTab(activeSection);
    }
    closeRestorePanel();
    if (typeof showToast === 'function') showToast(`✓ Restored to ${when}`);
  } catch (e) {
    if (doBtn) { doBtn.disabled = false; doBtn.textContent = 'Restore this version'; }
    _restoreMsg(String(e.message || e), true);
  }
}
